(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9495,1530,5842],{

/***/ 63781:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[path]",
      function () {
        return __webpack_require__(91403);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86889);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function index(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), " ").concat(props.parent == "botStore" ? "botStoreLoader" : null),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().loader), " ").concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().loader3))
        })
    });
}


/***/ }),

/***/ 39775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(99849);
/* harmony import */ var _styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _public_assets_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18023);
/* harmony import */ var _basicForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35842);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16330);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _redux_global_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39471);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14416);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(14890);
/* harmony import */ var _uploadFileemptwin__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50543);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49530);
/* harmony import */ var _azure_storage_blob__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(60998);





















var ModalExample = function(props) {
    var useOutsideAlerter = // method to close the modal if clicked outside
    function useOutsideAlerter(ref) {
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                //props.closeModal();
                }
            }
            // Bind the event listener
            document.addEventListener("click", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var validateEmail = function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(String(email).toLowerCase())) {
            var emailAr = email.split("@");
            if (emailAr.length == 2) {
                if (emailAr[1] == "unilever.com") {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    // return re.test(String(email).toLowerCase());
    };
    //console.log("Props cart ---", props);
    var sucessFailure = props.data[1].component.content.field_message_type_value_pair;
    var modalRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    useOutsideAlerter(modalRef);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var goTo = function(link) {
        router.push(link);
    };
    var initialState = {
        "employeeTwinID": props.empid,
        "softSkillID": "",
        "skillName": "",
        "skillDescription": "",
        "status": "",
        "Profile": "",
        "engagementLeadEmail": "",
        "businessRequestorEmail": "",
        "uploadDocument": "anshudoclink"
    };
    var rawErrorData = {
        skillName: false,
        status: false,
        Profile: false,
        engagementLeadEmail: false,
        businessRequestorEmail: false,
        uploadDocument: false
    };
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(initialState), 2), state = ref[0], setState = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(rawErrorData), stateError = ref1[0], setStateError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), items = ref2[0], setItems = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(""), 2), sskillid = ref3[0], setSskillid = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), submitForm = ref4[0], setSubmitForm = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), getFormValues = ref5[0], setGetFormValues = ref5[1];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), emptyFormValues = ref6[0], setEmptyFormValues = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), Loading = ref7[0], setLoading = ref7[1];
    /*Upload file code */ var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), file = ref8[0], setFile = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), fileName = ref9[0], setFileName = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showFileName = ref10[0], setShowFileName = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), fileError = ref11[0], setError = ref11[1];
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("", 2), docfolder = ref12[0], setDocfolder = ref12[1];
    /*Dropdown Added by Anshu*/ var requestDemoInfo = props.data[0].component.content;
    var field_title = requestDemoInfo.field_title, field_message_input = requestDemoInfo.field_message_input, field_options = requestDemoInfo.field_options, field_request_demo_form_componen = requestDemoInfo.field_request_demo_form_componen;
    var formComponents = field_request_demo_form_componen.filter(function(item) {
        return item.field_label != "Remarks";
    });
    var remarkComponent = props.data[0].component.content.field_request_demo_form_componen[0];
    var requesttype = props.data[0].component.content.field_request_demo_form_componen[1];
    var softskillid = props.data[0].component.content.field_request_demo_form_componen[2];
    var softskillname = props.data[0].component.content.field_request_demo_form_componen[3];
    var status = props.data[0].component.content.field_request_demo_form_componen[4];
    var profile = props.data[0].component.content.field_request_demo_form_componen[5];
    var engagementlead = props.data[0].component.content.field_request_demo_form_componen[6];
    var businessrequestor = props.data[0].component.content.field_request_demo_form_componen[7];
    var uploadDocument = props.data[0].component.content.field_request_demo_form_componen[8];
    var softskillForm = function() {
        setGetFormValues(true);
    };
    var onValueChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(e) {
            var value;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                value = e.target.value;
                if (e.target.id == "engagementLeadEmail" && !validateEmail(e.target.value)) {} else if (e.target.id == "businessRequestorEmail" && !validateEmail(e.target.value)) {} else {
                    setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, e.target.id, value)));
                }
                if (e.target.value) {
                    setStateError((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, stateError), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, e.target.id, "valid")));
                } else {
                    setStateError((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, stateError), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, e.target.id, true)));
                }
                return [
                    2
                ];
            });
        });
        return function onValueChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    // localStorage.setItem("item" , JSON.stringify(soft_skill_arr))
    // localStorage.setItem("abc" , JSON.stringify(items))
    var soft_skill_arr = [];
    var onFromSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                return [
                    2
                ];
            });
        });
        return function onFromSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handledemo = function() {
        props.closeModal();
        document.body.style.overflow = "unset";
    };
    //console.log("iteam_check------>" , items)
    // document upload code by Anshu
    var blobSasUrlNew = _utility_endpoints__WEBPACK_IMPORTED_MODULE_11__/* ["default"].blobSasUrlNew */ .ZP.blobSasUrlNew;
    var blobServiceClient = new _azure_storage_blob__WEBPACK_IMPORTED_MODULE_18__/* .BlobServiceClient */ .N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("employeetwin");
    //console.log(endpoints.blobsoftskillSasUrl, "fetchBlobemp");
    var uploadFile = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(file, name) {
            var fileNameOriginal, fileNameWithSpaces, fileName, ar, extension, fileSize, blockBlobClient, options, resp, url, ar1, another, toSend, auth, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        //console.log(file);
                        setShowFileName(true);
                        fileNameOriginal = file.name;
                        fileNameWithSpaces = fileNameOriginal + Date.now();
                        fileName = fileNameWithSpaces.replace(/ /g, "");
                        ar = fileNameOriginal.split(".");
                        extension = ar[ar.length - 1];
                        fileSize = file.size;
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        url = resp._response.request.url;
                        ar1 = url.split("?");
                        another = ar1[0].split("/");
                        toSend = another[another.length - 1];
                        setFile(toSend);
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error, "erro");
                        alert("Could not upload");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadFile(file, name) {
            return _ref.apply(this, arguments);
        };
    }();
    var uploadButtonClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
            var formData, authCheck, expiryStatus;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        formData = new FormData();
                        if (file == null) {
                            setError(true);
                            return [
                                2
                            ];
                        } else {
                            setError(false);
                        }
                        formData.append("empFile", file);
                        setLoading(true);
                        setloader(true);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().editModalWrapper),
        children: Loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader__WEBPACK_IMPORTED_MODULE_6__["default"], {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().modalBox),
            ref: modalRef,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat((_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().formContainer)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                class: "col-md-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().rowBtn),
                                    onClick: function() {
                                        handledemo();
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().icon),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/close.png",
                                            className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().iconimg)
                                        })
                                    })
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().modalBody),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().row)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().row),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-lg-12 col-md-12 col-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().formGroup),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().formheading),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/cart.png",
                                                className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().carticonimg)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().head),
                                                children: [
                                                    " Your ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: "1 item"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    " added to the cart!"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().modalFooter),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().combinedBtn),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().rowBtn),
                                onClick: function() {
                                    return goTo(props.pageRoutes.Emptwincart);
                                },
                                children: "View Cart"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_components_cart_module_scss__WEBPACK_IMPORTED_MODULE_19___default().exportListBtn),
                                onClick: function() {
                                    return goTo(props.pageRoutes.Emptwincart);
                                },
                                children: "Place an Order"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux__WEBPACK_IMPORTED_MODULE_20__/* .bindActionCreators */ .DE)(_redux_global_actions__WEBPACK_IMPORTED_MODULE_8__/* .sessionTimeOutCheck */ .Iy, dispatch),
        checkExpiry: (0,redux__WEBPACK_IMPORTED_MODULE_20__/* .bindActionCreators */ .DE)(_redux_global_actions__WEBPACK_IMPORTED_MODULE_8__/* .checkExpiry */ .Wr, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(ModalExample));


/***/ }),

/***/ 50355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SoftSkill; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/components/softskill.module.scss
var softskill_module = __webpack_require__(33346);
var softskill_module_default = /*#__PURE__*/__webpack_require__.n(softskill_module);
// EXTERNAL MODULE: ./public/assets/svg/index.jsx + 68 modules
var svg = __webpack_require__(18023);
// EXTERNAL MODULE: ./components/basicForm/index.js
var basicForm = __webpack_require__(35842);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/Loader/index.jsx
var Loader = __webpack_require__(16330);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./redux/global/actions.js
var actions = __webpack_require__(39471);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./components/uploadFileemptwin/index.jsx
var uploadFileemptwin = __webpack_require__(50543);
// EXTERNAL MODULE: ./utility/endpoints.js
var endpoints = __webpack_require__(49530);
// EXTERNAL MODULE: ./pages/successModal/index.jsx
var pages_successModal = __webpack_require__(99696);
// EXTERNAL MODULE: ./node_modules/@azure/storage-blob/dist-esm/storage-blob/src/BlobServiceClient.js + 206 modules
var BlobServiceClient = __webpack_require__(60998);
// EXTERNAL MODULE: ./styles/components/documentUploader.module.scss
var documentUploader_module = __webpack_require__(38710);
var documentUploader_module_default = /*#__PURE__*/__webpack_require__.n(documentUploader_module);
// EXTERNAL MODULE: ./components/uploadFile/index.jsx
var components_uploadFile = __webpack_require__(67954);
// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.esm.js
var fuse_esm = __webpack_require__(74221);
;// CONCATENATED MODULE: ./components/DocumentsoftskillUploader/index.jsx














var ModalExample = function(props) {
    var ref = (0,react.useState)({}), uploaded = ref[0], setUploaded = ref[1];
    var ref1 = (0,react.useState)({}), couldNotUpload = ref1[0], setCouldNotUpload = ref1[1];
    var ref2 = (0,react.useState)(null), totalItems = ref2[0], setTotalItems = ref2[1];
    var ref3 = (0,react.useState)(0), uploadedItems = ref3[0], setUploadedItems = ref3[1];
    var ref4 = (0,react.useState)({}), originalFileNames = ref4[0], setOriginalFileNames = ref4[1];
    var ref5 = (0,react.useState)({}), azureFileNames = ref5[0], setAzureFileNames = ref5[1];
    var blobSasUrl = "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin";
    var blobSasUrlNew = endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    //   "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
    var blobSasUrl1 = endpoints/* default.blobSasUrl */.ZP.blobSasUrl;
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/".concat(props.documentFolderName));
    // const createContainer = async () => {
    //   try {
    //     // reportStatus(`Creating container "${containerName}"...`);
    //     await containerClient.create();
    //     console.log("done");
    //     // reportStatus(`Done.`);
    //   } catch (error) {
    //     console.log(error);
    //     // reportStatus(error.message);
    //   }
    // };
    // createContainer()
    /**
 *

   
 */ react.useEffect(function() {
        if (props.uploadedDocumentsState != null) {
            console.log("consoling em down ", props.uploadedDocumentsState, "dsada", props.uploadedDocumentsState.uploaded, props.uploadedDocumentsState.totalItems, props.uploadedDocumentsState.uploadedItems, props.uploadedDocumentsState.originalFileNames);
            setUploaded(props.uploadedDocumentsState.uploaded);
            setTotalItems(props.uploadedDocumentsState.totalItems);
            setUploadedItems(props.uploadedDocumentsState.uploadedItems);
            setOriginalFileNames(props.uploadedDocumentsState.originalFileNames);
            setAzureFileNames(props.uploadedDocumentsState.azureFileNames);
        }
    }, []);
    var documentAr = [
        {
            title: "SOP",
            value: "sopDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx",
                ".msg",
                ".png",
                ".jpeg",
                ".jpg",
                ".xls",
                ".xlsx",
                ".ppt",
                ".pptx"
            ]
        },
        {
            title: "PDD",
            value: "pddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "PDD Approval",
            value: "pddApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "SDD",
            value: "sddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "QSG",
            value: "qsgDocument",
            type: [
                ".doc",
                ".docx"
            ]
        },
        {
            title: "ODI",
            value: "odiDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "BRD",
            value: "brdDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Cost Apporval",
            value: "costApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Landscape Approval",
            value: "explicitLandscapeApplicationOwnerApprovalDocument",
            type: ".msg"
        },
        {
            title: "GPM Approval",
            value: "explicitGPMApprovalSupplyChainFinanceDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "GFCF Approval",
            value: "explicitGFCFApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Dev Quality Crendentails Available",
            value: "devQualityCredentialsAvailableDocument",
            type: ".msg"
        },
        {
            title: "Infosec Approval",
            value: "infosecApprovalDocument",
            type: ".msg"
        },
        {
            title: "DA Review Sign Off",
            value: "dAReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "Test Data Development",
            value: "testDataAvailableForDevelopmentDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Request Raised Product Credentials",
            value: "requestRaisedForProductionCredentialsDocument",
            type: ".msg"
        },
        {
            title: "Internal Testing Completed",
            value: "internalTestingCompletedDocument",
            type: ".msg"
        },
        {
            title: "Peer Review Sign Off",
            value: "peerReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "DA Review Second Sign Off",
            value: "daReviewSecondSignOffDocument",
            type: ".msg"
        },
        {
            title: "BP Release Sign Off",
            value: "bpReleaseSignOffFromDaDocument",
            type: ".msg"
        },
        {
            title: "UAT Scripts With Results",
            value: "uatScriptsWithResultsDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Gate Form",
            value: "gateFormDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Peer Review Checklist",
            value: "peerReviewchecklistDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "QA Sign Off",
            value: "qaSignOffDocument",
            type: ".msg"
        },
        {
            title: "Walk Through Video",
            value: "walkthroughVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        },
        {
            title: "KT Video",
            value: "ktVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        }, 
    ];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(documentAr), 2), filteredDocumentAr = ref6[0], setFilteredDocumentAr = ref6[1];
    react.useEffect(function() {
        setTotalItems(documentAr.length);
    }, []);
    // to upload a file
    var ref7 = (0,react.useState)(false), fileUplaodState = ref7[0], setfileUplaodState = ref7[1];
    var ref8 = (0,react.useState)(false), currentlyUploading = ref8[0], setCurrentlyUploading = ref8[1];
    var ref9 = (0,react.useState)({}), presentState = ref9[0], setPresentState = ref9[1];
    var uploadFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file, name, title, originalFileName, extension) {
            var counter, i, fileName, blockBlobClient, options, resp, ar, another, finalUrl, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("thisConsole", file, "file", name, "name", title, "title", originalFileName, "orginalFileName");
                        counter = 0;
                        console.log(originalFileName, "originalFileNamesfirst", originalFileNames);
                        for(var i in originalFileNames){
                            if (originalFileNames[i].split(".")[0].split("~")[0] + "." + originalFileNames[i].split(".")[originalFileNames[i].split(".").length - 1] == originalFileName) {
                                counter = counter + 1;
                            }
                        }
                        console.log(counter, "originalFileNameCounter");
                        if (counter > 0) {
                            originalFileName = originalFileName.split(".")[0] + "~" + counter + "." + originalFileName.split(".")[1];
                        }
                        fileName = originalFileName;
                        console.log(originalFileNames, "originalFileNames");
                        setCurrentlyUploading(true);
                        setAzureFileNames((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, azureFileNames), (0,_define_property/* default */.Z)({}, name, fileName)));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            },
                            concurrency: 25
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        console.log("blob upload response----", resp);
                        setUploaded((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploaded), (0,_define_property/* default */.Z)({}, name, true)));
                        setUploadedItems(uploadedItems + 1);
                        setOriginalFileNames((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, originalFileNames), (0,_define_property/* default */.Z)({}, name, originalFileName)));
                        //props.setUploadedFileToShowOutside(title)
                        console.log(extension, "url idhar hai");
                        ar = resp._response.request.url.split("?");
                        another = ar[0].split("/");
                        finalUrl = another[another.length - 1];
                        // props.sendDocInfo(
                        //   name,
                        //   resp._response.request.url,
                        //   title,
                        //   uploadedItems + 1,
                        //   extension
                        // );
                        setPresentState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, presentState), (0,_define_property/* default */.Z)({}, name, finalUrl)));
                        setCurrentlyUploading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setCurrentlyUploading(false);
                        setCouldNotUpload((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, couldNotUpload), (0,_define_property/* default */.Z)({}, name, true)));
                        setUploaded((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploaded), (0,_define_property/* default */.Z)({}, name, false)));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadFile(file, name, title, originalFileName, extension) {
            return _ref.apply(this, arguments);
        };
    }();
    console.log("Anshu file code", originalFileNames);
    // to delete a file
    var ref10 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), deleteDocumentsLater = ref10[0], setDeleteDocumentsLater = ref10[1];
    var deleteThis = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(name) {
            var fileName, azureFileNamesVar, previousFileTitle, i, toDelete, azureFileNamesVar1, previousFileTitle1, i1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                console.log(azureFileNames);
                fileName = "1" + name;
                console.log(name, "azureFileName", azureFileNames);
                setPresentState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, presentState), (0,_define_property/* default */.Z)({}, name, "")));
                // if (azureFileNames[name]) {
                if (props.formType == "editBot") {
                    // setDeleteDocumentsLater([
                    //   ...deleteDocumentsLater,
                    //   azureFileNames[name],
                    // ]);
                    console.log(uploaded, "uploadedBeforeDeleting");
                    setUploaded((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploaded), (0,_define_property/* default */.Z)({}, name, false)));
                    setUploadedItems(uploadedItems - 1);
                    azureFileNamesVar = (0,_object_spread/* default */.Z)({}, azureFileNames);
                    delete azureFileNamesVar[name];
                    setAzureFileNames((0,_object_spread/* default */.Z)({}, azureFileNamesVar));
                    previousFileTitle = null;
                    // console.log(uploaded, "xadsda", name)
                    for(var i in uploaded){
                        if (uploaded[i] == true && i != name) {
                            previousFileTitle = i;
                            break;
                        }
                    }
                //  props.sendDocInfo(name, "", previousFileTitle, uploadedItems - 1);
                } else {
                    toDelete = azureFileNames[name];
                    setUploaded((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploaded), (0,_define_property/* default */.Z)({}, name, false)));
                    setUploadedItems(uploadedItems - 1);
                    azureFileNamesVar1 = (0,_object_spread/* default */.Z)({}, azureFileNames);
                    delete azureFileNamesVar1[name];
                    setAzureFileNames((0,_object_spread/* default */.Z)({}, azureFileNamesVar1));
                    previousFileTitle1 = null;
                    // console.log(uploaded, "xadsda", name)
                    for(var i1 in uploaded){
                        if (uploaded[i1] == true && i1 != name) {
                            previousFileTitle1 = i1;
                            break;
                        }
                    }
                //   props.sendDocInfo(name, "", previousFileTitle, uploadedItems - 1);
                //   try {
                //  await containerClient.deleteBlob(toDelete);
                // }
                // catch(err) {
                //   console.log(err)
                // }
                }
                return [
                    2
                ];
            });
        // alert("there");
        // }
        });
        return function deleteThis(name) {
            return _ref.apply(this, arguments);
        };
    }();
    var searchDocuments = function(e) {
        if (e.target.value.length == 0) {
            setFilteredDocumentAr(documentAr);
        } else {
            var options = {
                shouldSort: true,
                keys: [
                    "title",
                    "value",
                    "type"
                ]
            };
            var fuse = new fuse_esm/* default */.Z(documentAr, options);
            // Change the pattern
            var pattern = e.target.value;
            console.log("pattern  -----", pattern);
            var fuseResult = fuse.search("".concat(pattern));
            var filteredResult = [];
            console.log("fusee result  ----", fuseResult);
            for(var i in fuseResult){
                filteredResult.push(fuseResult[i].item);
            }
            setFilteredDocumentAr(filteredResult);
        }
    };
    // const allDone = () => {
    //   const docURL=blobSasUrl1+"/"+props.documentFolderName;
    //   console.log("line number 329",docURL);
    //   localStorage.setItem("docURL", JSON.stringify(docURL));
    //   if (!currentlyUploading) {
    //   props.sendAllInfoAboutUploadModal(
    //     uploaded,
    //     totalItems,
    //     uploadedItems,
    //     originalFileNames,
    //     azureFileNames,
    //     deleteDocumentsLater,
    //     presentState
    //   );
    //   props.closeModal();
    //   }
    // };
    var allDone = function() {
        var docURL = blobSasUrl1 + "/" + props.documentFolderName;
        console.log("line number 329", docURL);
        localStorage.setItem("docURL", JSON.stringify(originalFileNames));
        if (!currentlyUploading) {
            {}
            props.sendAllInfoAboutUploadModal(uploaded, totalItems, uploadedItems, originalFileNames, azureFileNames, deleteDocumentsLater, presentState);
            props.closeModal();
        }
    };
    // to download a file
    // const downloadThis = async (e) => {
    //   let fileName = "1" + e.target.name;
    //   const blockBlobClient = containerClient.getBlobClient(fileName);
    //   const downloadBlockBlobResponse = await blockBlobClient.download(0);
    //   console.log(downloadBlockBlobResponse);
    // };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (documentUploader_module_default()).editModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (documentUploader_module_default()).modalBox,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (documentUploader_module_default()).modalHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (documentUploader_module_default()).content,
                            children: "Document Uploader"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (documentUploader_module_default()).search,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                    name: "searchGrayIcon",
                                    className: (documentUploader_module_default()).searchIcon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    placeholder: "Search",
                                    onChange: searchDocuments
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (documentUploader_module_default()).modalBody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (documentUploader_module_default()).formatType,
                            children: "Upload files in the format of .pdf, .doc, .docx, .msg, .png, .jpeg, .jpg, .xls, .xlsx, .ppt, .pptx"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: filteredDocumentAr.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    style: {
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (documentUploader_module_default()).left,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    item.title,
                                                    item.title == "SOP" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        children: "*"
                                                    }) : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (documentUploader_module_default()).right,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_uploadFile/* default */.Z, {
                                                    data: true,
                                                    title: item.title,
                                                    value: item.value,
                                                    fileType: item.value == "walkthroughVideo" || item.value == "ktVideo" ? item.type : [
                                                        ".pdf",
                                                        ".doc",
                                                        ".docx",
                                                        ".msg",
                                                        ".png",
                                                        ".jpeg",
                                                        ".jpg",
                                                        ".xls",
                                                        ".xlsx",
                                                        ".ppt",
                                                        ".pptx"
                                                    ],
                                                    uploadFile: uploadFile,
                                                    uploaded: uploaded[item.value],
                                                    couldNotUpload: couldNotUpload[item.value],
                                                    originalFileName: originalFileNames[item.value],
                                                    type: "createBot",
                                                    specialCase: item.value == "walkthroughVideo" || item.value == "ktVideo" ? true : false,
                                                    currentlyUploading: currentlyUploading
                                                }),
                                                uploaded[item.value] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: function() {
                                                        return deleteThis(item.value);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                        name: "deleteicon",
                                                        className: (documentUploader_module_default()).icon
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (documentUploader_module_default()).modalFooter,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (documentUploader_module_default()).left,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (documentUploader_module_default()).countFilesSelected,
                                children: "".concat(uploadedItems, "/").concat(totalItems, " files selected")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (documentUploader_module_default()).right,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (documentUploader_module_default()).combinedBtn,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (documentUploader_module_default()).rowBtn,
                                        onClick: function() {
                                            return props.closeModal();
                                        },
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (documentUploader_module_default()).exportListBtn,
                                        onClick: function() {
                                            return allDone();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                name: "uploadicon"
                                            }),
                                            "Upload files"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var DocumentsoftskillUploader = (ModalExample);

;// CONCATENATED MODULE: ./components/Pages/SoftSkill/index.jsx
























var SoftSkill_ModalExample = function(props) {
    var useOutsideAlerter = // method to close the modal if clicked outside
    function useOutsideAlerter(ref) {
        (0,react.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                //props.closeModal();
                }
            }
            // Bind the event listener
            document.addEventListener("click", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var validateEmail = function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(String(email).toLowerCase())) {
            var emailAr = email.split("@");
            if (emailAr.length == 2) {
                if (emailAr[1] == "unilever.com") {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    // return re.test(String(email).toLowerCase());
    };
    // console.log("Props soft skill ---", props);
    // console.log(props.softidfrommodal);
    var sucessFailure = props.data[1].component.content.field_message_type_value_pair;
    var modalRef = react.useRef(null);
    useOutsideAlerter(modalRef);
    var router = (0,next_router.useRouter)();
    var initialState = {
        "employeeTwinID": props.empid,
        "softSkillID": "",
        "skillName": "",
        "skillDescription": "",
        "status": "",
        "Profile": "",
        "engagementLeadEmail": "",
        "businessRequestorEmail": "",
        "sopDocument": "",
        "pddDocument": "",
        "pddApprovalDocument": "",
        "sddDocument": "",
        "qsgDocument": "",
        "odiDocument": "",
        "brdDocument": "",
        "costApprovalDocument": "",
        "explicitLandscapeApplicationOwnerApprovalDocument": "",
        "explicitGPMApprovalSupplyChainFinanceDocument": "",
        "explicitGFCFApprovalDocument": "",
        "devQualityCredentialsAvailableDocument": "",
        "infosecApprovalDocument": "",
        "dAReviewSignOffDocument": "",
        "testDataAvailableForDevelopmentDocument": "",
        "requestRaisedForProductionCredentialsDocument": "",
        "internalTestingCompletedDocument": "",
        "peerReviewSignOffDocument": "",
        "daReviewSecondSignOffDocument": "",
        "bpReleaseSignOffFromDaDocument": "",
        "uatScriptsWithResultsDocument": "",
        "uatSignOffDocument": "",
        "releaseManagerSignOffDocument": "",
        "gateFormDocument": "",
        "peerReviewchecklistDocument": "",
        "qaSignOffDocument": "",
        "walkthroughVideo": "",
        "ktVideo": ""
    };
    var rawErrorData = {
        skillName: false,
        status: false,
        Profile: false,
        engagementLeadEmail: false,
        businessRequestorEmail: false,
        uploadDocument: false,
        sopDocument: false,
        pddDocument: false,
        pddApprovalDocument: false,
        sddDocument: false,
        qsgDocument: false,
        odiDocument: false,
        brdDocument: false,
        costApprovalDocument: false,
        explicitLandscapeApplicationOwnerApprovalDocument: false,
        explicitGPMApprovalSupplyChainFinanceDocument: false,
        explicitGFCFApprovalDocument: false,
        devQualityCredentialsAvailableDocument: false,
        infosecApprovalDocument: false,
        dAReviewSignOffDocument: false,
        testDataAvailableForDevelopmentDocument: false,
        requestRaisedForProductionCredentialsDocument: false,
        internalTestingCompletedDocument: false,
        peerReviewSignOffDocument: false,
        daReviewSecondSignOffDocument: false,
        bpReleaseSignOffFromDaDocument: false,
        uatScriptsWithResultsDocument: false,
        uatSignOffDocument: false,
        releaseManagerSignOffDocument: false,
        gateFormDocument: false,
        peerReviewchecklistDocument: false,
        qaSignOffDocument: false,
        walkthroughVideo: false,
        ktVideo: false
    };
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), modalShow = ref[0], setModalShow = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(initialState), 2), state = ref1[0], setState = ref1[1];
    var ref2 = (0,react.useState)(rawErrorData), stateError = ref2[0], setStateError = ref2[1];
    var ref3 = (0,react.useState)([]), items = ref3[0], setItems = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), sskillid = ref4[0], setSskillid = ref4[1];
    var ref5 = (0,react.useState)(false), successModal = ref5[0], setSuccessModal = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref6[0], setSubmitForm = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref7[0], setGetFormValues = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref8[0], setEmptyFormValues = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), Loading = ref9[0], setLoading = ref9[1];
    /*Upload file code */ var ref10 = (0,react.useState)(false), fileError = ref10[0], setError = ref10[1];
    var ref11 = (0,react.useState)(null), file = ref11[0], setFile = ref11[1];
    var ref12 = (0,react.useState)(null), fileNameOriginal = ref12[0], setFileName = ref12[1];
    var ref13 = (0,react.useState)(false), showFileName = ref13[0], setShowFileName = ref13[1];
    var ref14 = (0,react.useState)([]), automationPdfs = ref14[0], setAutomationPdfs = ref14[1];
    var ref15 = (0,react.useState)([]), confidentialPdfs = ref15[0], setConfidentialPdfs = ref15[1];
    var ref16 = (0,react.useState)({}), auth = ref16[0], setAuth = ref16[1];
    var ref17 = (0,react.useState)(false), filenameError = ref17[0], setFileNameError = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), uploadedDocumentsState = ref18[0], setUploadedDocumentsState = ref18[1];
    var ref19 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), totalUploadedItems = ref19[0], setTotalUploadedItems = ref19[1];
    var ref20 = (0,react.useState)([
        "pdf",
        "docx",
        "doc",
        "xlsx",
        "msg",
        "jpg",
        "jpeg",
        "png",
        "ppt",
        "pptx", 
    ]), fileTypes = ref20[0], setfileTypes = ref20[1];
    var ref21 = (0,_sliced_to_array/* default */.Z)("", 2), docfolder = ref21[0], setDocfolder = ref21[1];
    /*Dropdown Added by Anshu*/ var requestDemoInfo = props.data[0].component.content;
    var field_title = requestDemoInfo.field_title, field_message_input = requestDemoInfo.field_message_input, field_options = requestDemoInfo.field_options, field_request_demo_form_componen = requestDemoInfo.field_request_demo_form_componen;
    var formComponents = field_request_demo_form_componen.filter(function(item) {
        return item.field_label != "Remarks";
    });
    var remarkComponent = props.data[0].component.content.field_request_demo_form_componen[0];
    var requesttype = props.data[0].component.content.field_request_demo_form_componen[1];
    var softskillid = props.data[0].component.content.field_request_demo_form_componen[2];
    var softskillname = props.data[0].component.content.field_request_demo_form_componen[3];
    var status = props.data[0].component.content.field_request_demo_form_componen[4];
    var profile = props.data[0].component.content.field_request_demo_form_componen[5];
    var engagementlead = props.data[0].component.content.field_request_demo_form_componen[6];
    var businessrequestor = props.data[0].component.content.field_request_demo_form_componen[7];
    var uploadDocument = props.data[0].component.content.field_request_demo_form_componen[8];
    var category = props.data[0].component.content.field_request_demo_form_componen[9];
    var softskillForm = function() {
        setGetFormValues(true);
    };
    var gotDocInfo = function(name, url, title, uploadedItems, extension) {
        var ar = url.split("?");
        var another = ar[0].split("/");
        var toSend = another[another.length - 1];
        // console.log(title, uploadedItems, "uploaded data of data");	
        // console.log(name, "nameat uploaderrr", title)	
        console.log(extension, "extension at 56");
        //  setUploadedFileToShow(title);	
        setTotalUploadedItems(uploadedItems);
        sendDocInfo(name, toSend, extension);
    };
    var ref22 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), sopInvalid = ref22[0], setSopInvalid = ref22[1];
    var sendAllInfoAboutUploadModal = function(uploaded, totalItems, uploadedItems, originalFileNames, azureFileNames, deleteDocumentsLater, presentState) {
        if (uploaded.sopDocument) {
            setSopInvalid(false);
        } else {
            setSopInvalid(true);
        }
        console.log("sab console kara lo", uploaded, "1", totalItems, "22", uploadedItems, "33", originalFileNames, "44", azureFileNames, "555", deleteDocumentsLater, "6666", presentState);
        //setUploadedFileToShow(documentAr.filter((item) => item.value === Object.keys(presentState)[Object.keys(presentState).length-1])[0].title)	
        console.log(azureFileNames, "azurefiles234latest");
        console.log(uploadedDocumentsState, "azurefiles234previous");
        var deleteDocumentsLaterToSet = [];
        if (uploadedDocumentsState && uploadedDocumentsState.deleteDocumentsLater && uploadedDocumentsState.deleteDocumentsLater.length > 0) {
            deleteDocumentsLaterToSet = (0,_to_consumable_array/* default */.Z)(uploadedDocumentsState.deleteDocumentsLater);
            for(var i in uploadedDocumentsState.azureFileNames){
                if (!(i in azureFileNames)) {
                    deleteDocumentsLaterToSet.push(uploadedDocumentsState.azureFileNames[i]);
                }
            }
        }
        setUploadedDocumentsState({
            uploaded: uploaded,
            totalItems: totalItems,
            uploadedItems: uploadedItems,
            originalFileNames: originalFileNames,
            azureFileNames: (0,_object_spread/* default */.Z)({}, azureFileNames),
            deleteDocumentsLater: (0,_to_consumable_array/* default */.Z)(deleteDocumentsLaterToSet)
        });
        setTotalUploadedItems(uploadedItems);
        {}
    };
    var openDocumentModal = function() {
        var modal = !modalShow;
        setModalShow(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var closeDocumentModal = function() {
        var modal = !modalShow;
        setModalShow(false);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var azurefilepath;
    var blobSasUrl = "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
    var blobSasUrlNew = endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    // "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin");
    var uploadFile = function(file, name) {
        //console.log(file.name, "pdfsauto");
        azurefilepath = "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/" + file.name;
        //console.log("azure file path",azurefilepath)
        //console.log(automationPdfs, "pdfsauto");
        if (automationPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0 || confidentialPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0) {
            setFileNameError(true);
            setSuccessModal(true);
            return;
        }
        setFile(file);
        setShowFileName(true);
        setFileName(file.name);
    };
    var uploadButtonClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var fileNameWithSpaces, fileName, ar, extension, fileSize, blockBlobClient, options, resp, url, ar1, another, toSend, authCheck, expiryStatus, auth, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fileNameWithSpaces = fileNameOriginal;
                        fileName = fileNameWithSpaces.replace(/ /g, " ");
                        ar = fileNameOriginal.split(".");
                        extension = ar[ar.length - 1];
                        fileSize = file.size;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        url = resp._response.request.url;
                        ar1 = url.split("?");
                        another = ar1[0].split("/");
                        toSend = another[another.length - 1];
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 3:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            axios_default()({
                                method: "post",
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/framework/createFramework"),
                                data: {
                                    docType: extension,
                                    docName: fileNameOriginal,
                                    docCategory: "png",
                                    docUrl: toSend,
                                    docSize: fileSize
                                },
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(resp) {
                                if (resp.data.code == 200) {
                                    //  console.log(resp);
                                    window.scrollTo(0, 0);
                                    setSuccessModal(true);
                                    //setShowFileName(false);
                                    //setLoader(false);
                                    // setFile(null);
                                    setError(false);
                                //setFileName(null);
                                //getAllPdfs();
                                } else if (resp.data.code == 403) {
                                    //setLoader(false);
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            //setLoader(false)
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error, "erro");
                        alert("Could not upload");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var onValueChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = e.target.value;
                if (e.target.id == "engagementLeadEmail" && !validateEmail(e.target.value)) {} else if (e.target.id == "businessRequestorEmail" && !validateEmail(e.target.value)) {} else {
                    setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, e.target.id, value)));
                }
                if (e.target.value) {
                    setStateError((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stateError), (0,_define_property/* default */.Z)({}, e.target.id, "valid")));
                } else {
                    setStateError((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stateError), (0,_define_property/* default */.Z)({}, e.target.id, true)));
                }
                return [
                    2
                ];
            });
        });
        return function onValueChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    // localStorage.setItem("item" , JSON.stringify(soft_skill_arr))
    // localStorage.setItem("abc" , JSON.stringify(items))
    var soft_skill_arr = [];
    var ref23 = (0,react.useState)(false), softdocument = ref23[0], setSoftdocument = ref23[1];
    var onFromSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var authCheck, expiryStatus, moveAhead, softdocs, sopDocument, pddDocument, pddApprovalDocument, sddDocument, qsgDocument, odiDocument, brdDocument, costApprovalDocument, explicitLandscapeApplicationOwnerApprovalDocument, explicitGPMApprovalSupplyChainFinanceDocument, explicitGFCFApprovalDocument, devQualityCredentialsAvailableDocument, infosecApprovalDocument, dAReviewSignOffDocument, testDataAvailableForDevelopmentDocument, requestRaisedForProductionCredentialsDocument, internalTestingCompletedDocument, peerReviewSignOffDocument, daReviewSecondSignOffDocument, bpReleaseSignOffFromDaDocument, uatScriptsWithResultsDocument, uatSignOffDocument, releaseManagerSignOffDocument, gateFormDocument, peerReviewchecklistDocument, qaSignOffDocument, walkthroughVideo, ktVideo, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSubmitForm(true);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        moveAhead = true;
                        softdocs = JSON.parse(localStorage.getItem("docURL"));
                        {}
                        if (localStorage.getItem("docURL")) {
                            setSoftdocument(false);
                        }
                        if (!(softdocs === null || softdocs === void 0 ? void 0 : softdocs.sopDocument)) {
                            setSoftdocument(true);
                        }
                        sopDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.sopDocument) || "";
                        pddDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.pddDocument) || "";
                        pddApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.pddApprovalDocument) || "";
                        sddDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.sddDocument) || "";
                        qsgDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.qsgDocument) || "";
                        odiDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.odiDocument) || "";
                        brdDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.brdDocument) || "";
                        costApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.costApprovalDocument) || "";
                        explicitLandscapeApplicationOwnerApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.explicitLandscapeApplicationOwnerApprovalDocument) || "";
                        explicitGPMApprovalSupplyChainFinanceDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.explicitGPMApprovalSupplyChainFinanceDocument) || "";
                        explicitGFCFApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.explicitGFCFApprovalDocument) || "";
                        devQualityCredentialsAvailableDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.devQualityCredentialsAvailableDocument) || "";
                        infosecApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.infosecApprovalDocument) || "";
                        dAReviewSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.dAReviewSignOffDocument) || "";
                        testDataAvailableForDevelopmentDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.testDataAvailableForDevelopmentDocument) || "";
                        requestRaisedForProductionCredentialsDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.requestRaisedForProductionCredentialsDocument) || "";
                        internalTestingCompletedDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.internalTestingCompletedDocument) || "";
                        peerReviewSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.peerReviewSignOffDocument) || "";
                        daReviewSecondSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.daReviewSecondSignOffDocument) || "";
                        bpReleaseSignOffFromDaDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.bpReleaseSignOffFromDaDocument) || "";
                        uatScriptsWithResultsDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.uatScriptsWithResultsDocument) || "";
                        uatSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.uatSignOffDocument) || "";
                        releaseManagerSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.releaseManagerSignOffDocument) || "";
                        gateFormDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.gateFormDocument) || "";
                        peerReviewchecklistDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.peerReviewchecklistDocument) || "";
                        qaSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.qaSignOffDocument) || "";
                        walkthroughVideo = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.walkthroughVideo) || "";
                        ktVideo = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.ktVideo) || "";
                        if (!(state.skillName == "" || state.status == "" || state.Profile == "" || state.engagementLeadEmail == "" || state.businessRequestorEmail == "" || softdocument)) return [
                            3,
                            2
                        ];
                        return [
                            3,
                            5
                        ];
                    case 2:
                        if (!expiryStatus) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 3:
                        auth = _state.sent();
                        axios_default()({
                            method: "post",
                            url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/softSkill/add"),
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            },
                            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                sopDocument: sopDocument,
                                pddDocument: pddDocument,
                                pddApprovalDocument: pddApprovalDocument,
                                sddDocument: sddDocument,
                                qsgDocument: qsgDocument,
                                odiDocument: odiDocument,
                                brdDocument: brdDocument,
                                costApprovalDocument: costApprovalDocument,
                                explicitLandscapeApplicationOwnerApprovalDocument: explicitLandscapeApplicationOwnerApprovalDocument,
                                explicitGPMApprovalSupplyChainFinanceDocument: explicitGPMApprovalSupplyChainFinanceDocument,
                                explicitGFCFApprovalDocument: explicitGFCFApprovalDocument,
                                devQualityCredentialsAvailableDocument: devQualityCredentialsAvailableDocument,
                                infosecApprovalDocument: infosecApprovalDocument,
                                dAReviewSignOffDocument: dAReviewSignOffDocument,
                                testDataAvailableForDevelopmentDocument: testDataAvailableForDevelopmentDocument,
                                requestRaisedForProductionCredentialsDocument: requestRaisedForProductionCredentialsDocument,
                                internalTestingCompletedDocument: internalTestingCompletedDocument,
                                peerReviewSignOffDocument: peerReviewSignOffDocument,
                                daReviewSecondSignOffDocument: daReviewSecondSignOffDocument,
                                bpReleaseSignOffFromDaDocument: bpReleaseSignOffFromDaDocument,
                                uatScriptsWithResultsDocument: uatScriptsWithResultsDocument,
                                uatSignOffDocument: uatSignOffDocument,
                                releaseManagerSignOffDocument: releaseManagerSignOffDocument,
                                gateFormDocument: gateFormDocument,
                                peerReviewchecklistDocument: peerReviewchecklistDocument,
                                qaSignOffDocument: qaSignOffDocument,
                                walkthroughVideo: walkthroughVideo,
                                ktVideo: ktVideo,
                                uploadDocument: "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/" + fileNameOriginal
                            })
                        }).then(function(resp) {
                            if (resp.data.code == 403) {
                                setLoading(false);
                                localStorage.removeItem("auth");
                                props.sessionTimeOutCheck(true);
                                setEmptyFormValues(!emptyFormValues);
                                setState(initialState);
                                setGetFormValues(false);
                            } else if (resp.status == 200) {
                                setEmptyFormValues(!emptyFormValues);
                                // console.log(resp.data);
                                // console.log("data from api---->",resp.data.data.softSkillID)
                                setItems(resp.data.data.softSkillID);
                                if (JSON.parse(localStorage.getItem("myData"))) {
                                    var storedData = JSON.parse(localStorage.getItem("myData"));
                                    // console.log(storedData);
                                    storedData.push(resp.data.data.softSkillID);
                                    localStorage.setItem("myData", JSON.stringify(storedData));
                                } else {
                                    localStorage.setItem("myData", JSON.stringify([
                                        resp.data.data.softSkillID
                                    ]));
                                }
                                setState(initialState);
                                setGetFormValues(false);
                                props.closeModal();
                                props.setSuccessModal(true);
                                props.setMessage(sucessFailure[0].field_message + " and the soft skill id is ".concat(resp.data.data.softSkillID));
                                setLoading(true);
                                if (props.name == "empskillpage") {
                                    props.softidfrommodal(resp.data.data.softSkillID);
                                }
                                props.setSuccessModal(true);
                            } else if (resp.data.code == 400) {
                                setEmptyFormValues(!emptyFormValues);
                                setLoading(false);
                                setState(initialState);
                                setGetFormValues(false);
                                // props.setMessage(sucessFailure[1].field_message[0]);
                                props.setsucessOrFailure(true);
                                props.closeModal();
                                props.setSuccessModal(true);
                            }
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        props.sessionTimeOutCheck(true);
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFromSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handledemo = function() {
        props.closeModal();
        document.body.style.overflow = "unset";
    };
    // console.log("iteam_check------>" , items)
    // document upload code by Anshu
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (softskill_module_default()).editModalWrapper,
        children: [
            Loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader["default"], {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (softskill_module_default()).modalBox,
                ref: modalRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((softskill_module_default()).formContainer),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        class: "col-md-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (softskill_module_default()).rowBtn,
                                            onClick: function() {
                                                handledemo();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (softskill_module_default()).icon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/close.png",
                                                    className: (softskill_module_default()).iconimg
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            className: (softskill_module_default()).head,
                                            children: [
                                                field_title,
                                                " "
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (softskill_module_default()).text,
                                            children: field_message_input
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (softskill_module_default()).modalBody,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (softskill_module_default()).row
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (softskill_module_default()).row,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-12 col-md-12 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (softskill_module_default()).formGroup,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (softskill_module_default()).formheading,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/softskillvector.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Soft Skill Form"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 col-md-6 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (softskill_module_default()).formGroup,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (softskill_module_default()).combine,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (softskill_module_default()).mainLabel,
                                                        children: [
                                                            get_default()(softskillname, "field_form_field_title", ""),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                className: (softskill_module_default()).mandatoryField,
                                                                children: "*"
                                                            }),
                                                            submitForm ? state.skillName == "" && state.skillName.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (softskill_module_default()).errorMessage,
                                                                children: get_default()(softskillname, "field_message_ip_error_message", "")
                                                            }) : null : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    className: (softskill_module_default()).inputtext,
                                                    id: "skillName",
                                                    name: "skillName",
                                                    onChange: onValueChange
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-12 col-md-12 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (softskill_module_default()).formGroup,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (softskill_module_default()).labelstyle,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        children: get_default()(remarkComponent, "field_form_field_title", "")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    // className={`${invalidFlag ? styles.errorBorder : null}`}
                                                    placeholder: remarkComponent.field_title,
                                                    id: "skillDescription",
                                                    name: "skillDescription",
                                                    onChange: onValueChange
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 col-md-6 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (softskill_module_default()).formGroup,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (softskill_module_default()).combine,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (softskill_module_default()).mainLabel,
                                                        children: [
                                                            get_default()(status, "field_form_field_title", ""),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                className: (softskill_module_default()).mandatoryField,
                                                                children: "*"
                                                            }),
                                                            submitForm ? state.status == "" && state.status.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (softskill_module_default()).errorMessage,
                                                                children: get_default()(status, "field_message_ip_error_message", "")
                                                            }) : null : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                    className: (softskill_module_default()).select,
                                                    onChange: onValueChange,
                                                    name: "status",
                                                    id: "status",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                            defaultValue: true,
                                                            children: [
                                                                " ",
                                                                get_default()(status, "field_form_field_title", "")
                                                            ]
                                                        }),
                                                        get_default()(status, "field_options", []).map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: item,
                                                                children: item
                                                            }, index);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 col-md-6 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (softskill_module_default()).formGroup,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (softskill_module_default()).combine,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (softskill_module_default()).mainLabel,
                                                        children: [
                                                            get_default()(category, "field_form_field_title", ""),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                className: (softskill_module_default()).mandatoryField,
                                                                children: "*"
                                                            }),
                                                            submitForm ? state.category == "" && state.category.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (softskill_module_default()).errorMessage,
                                                                children: get_default()(category, "field_message_ip_error_message", "")
                                                            }) : null : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                    className: (softskill_module_default()).select,
                                                    onChange: onValueChange,
                                                    name: "category",
                                                    id: "category",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                            defaultValue: true,
                                                            children: [
                                                                " ",
                                                                get_default()(category, "field_form_field_title", "")
                                                            ]
                                                        }),
                                                        get_default()(category, "field_options", []).map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: item,
                                                                children: item
                                                            }, index);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 col-md-6 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (softskill_module_default()).formGroup,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (softskill_module_default()).combine,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (softskill_module_default()).mainLabel,
                                                        children: [
                                                            get_default()(profile, "field_form_field_title", ""),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                className: (softskill_module_default()).mandatoryField,
                                                                children: "*"
                                                            }),
                                                            submitForm ? state.Profile == "" && state.Profile.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (softskill_module_default()).errorMessage,
                                                                children: get_default()(profile, "field_message_ip_error_message", "")
                                                            }) : null : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    className: (softskill_module_default()).inputtext,
                                                    id: "Profile",
                                                    name: "Profile",
                                                    onChange: onValueChange
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 col-md-6 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (softskill_module_default()).formGroup,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (softskill_module_default()).combine,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (softskill_module_default()).mainLabel,
                                                        children: [
                                                            get_default()(engagementlead, "field_form_field_title", ""),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                className: (softskill_module_default()).mandatoryField,
                                                                children: "*"
                                                            }),
                                                            submitForm ? state.engagementLeadEmail == "" && state.engagementLeadEmail.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (softskill_module_default()).errorMessage,
                                                                children: get_default()(engagementlead, "field_message_ip_error_message", "")
                                                            }) : null : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                    className: (softskill_module_default()).select,
                                                    onChange: onValueChange,
                                                    name: "engagementLeadEmail",
                                                    id: "engagementLeadEmail",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                            defaultValue: true,
                                                            children: [
                                                                " ",
                                                                get_default()(engagementlead, "field_form_field_title", "")
                                                            ]
                                                        }),
                                                        get_default()(engagementlead, "field_options", []).map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: item,
                                                                children: item
                                                            }, index);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 col-md-6 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (softskill_module_default()).formGroup,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (softskill_module_default()).combine,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (softskill_module_default()).mainLabel,
                                                        children: [
                                                            get_default()(businessrequestor, "field_form_field_title", ""),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                className: (softskill_module_default()).mandatoryField,
                                                                children: "*"
                                                            }),
                                                            submitForm ? state.businessRequestorEmail == "" && state.businessRequestorEmail.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (softskill_module_default()).errorMessage,
                                                                children: get_default()(businessrequestor, "field_message_ip_error_message", "")
                                                            }) : null : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    className: (softskill_module_default()).inputtext,
                                                    id: "businessRequestorEmail",
                                                    name: "businessRequestorEmail",
                                                    onChange: onValueChange
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 col-md-6 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (softskill_module_default()).formGroup,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((softskill_module_default()).uploadBtnWrapper),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (softskill_module_default()).uploadFileContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (softskill_module_default()).mainLabel,
                                                            children: [
                                                                get_default()(uploadDocument, "field_title", "") + "s",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                    className: (softskill_module_default()).mandatoryField,
                                                                    children: "*"
                                                                }),
                                                                submitForm ? softdocument ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (softskill_module_default()).errorMessage,
                                                                    children: "Please upload SOP Document"
                                                                }) : null : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (softskill_module_default()).uploadControl,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (softskill_module_default()).multiDocsWrapper,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (softskill_module_default()).skillMultiDocs,
                                                                        onClick: openDocumentModal,
                                                                        children: "Open Document Uploader"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (softskill_module_default()).text
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (softskill_module_default()).modalFooter,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (softskill_module_default()).combinedBtn,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (softskill_module_default()).exportListBtn,
                                onClick: onFromSubmit,
                                children: field_options[0]
                            })
                        })
                    })
                ]
            }),
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: function() {
                    setSuccessModal(false);
                    setFileNameError(false);
                },
                title: "Framework",
                message: filenameError ? "Document with this name already exists." : "uploaded",
                fail: filenameError ? true : false
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (softskill_module_default()).uploadContainer,
                children: modalShow == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentsoftskillUploader, {
                    closeModal: closeDocumentModal,
                    sendDocInfo: gotDocInfo,
                    sendAllInfoAboutUploadModal: sendAllInfoAboutUploadModal,
                    uploadedDocumentsState: uploadedDocumentsState,
                    formType: fileTypes,
                    documentFolderName: "employeetwin",
                    softSkillDoc: "softSkillDocState"
                }) : null
            })
        ]
    });
};
var mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var SoftSkill = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(SoftSkill_ModalExample));


/***/ }),

/***/ 35842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58059);
/* harmony import */ var _styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _public_assets_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18023);
/* harmony import */ var react_datetime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8660);
/* harmony import */ var react_datetime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_datetime__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86060);
/* harmony import */ var react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _listWithoutcheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45336);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);











//import Router from "next/router";



// import { useDispatch } from "react-redux";
// import { isNull } from "lodash";
function index(props) {
    var formatDate = function formatDate() {
        var d = new Date(), month = "" + (d.getMonth() + 1), day = "" + d.getDate(), year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [
            day,
            month,
            year
        ].join("-");
    };
    var camelize = function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    //console.log("basic form-----" , props)
    var notRequired = [
        "Area",
        "Sub Area",
        "MCO",
        "Lead Platform"
    ];
    //const dispatch = useDispatch();
    // let initialStates = {};
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({}), 2), state = ref[0], setState = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(""), 2), value = ref1[0], setValue = ref1[1];
    // React.useEffect(() => {
    //   try {
    //     if (props.userType != undefined) {
    //       console.log("1")
    //       if (props.userType == "gCad") {
    //         console.log("1")
    //         setState({
    //           ...state,
    //           cluster: "Global",
    //           mco: "Global"
    //         });
    //       }
    //     }
    //   } catch (e) {
    //     console.log(e);
    //   }
    // }, []);
    var inputprops = {
        placeholder: "DD-MM-YYYY",
        readOnly: true
    };
    props.data.map(function(item) {
        if (item.field_label == "Comments From Stakeholders") {
            item.value = "commentsFromStakeHolder";
        } else if (item.field_label == "EL") {
            item.value = "el";
        } else if (item.field_label == "MCO") {
            item.value = "mco";
        } else if (item.field_label == "SPOC") {
            item.value = "spoc";
        } else {
            item.value = camelize(item.field_label);
        }
    });
    var dropDownsInitialStates = {};
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState([]), 2), requiredFields = ref2[0], setRequiredFields = ref2[1];
    // nested dropdown
    props.data.map(function(item) {
        if (item.field_input_type == "Related Dropdown" && item.field_related_dropdown.length > 0) {
            var fieldOptions = [];
            item.field_dropdown_option_component.map(function(item) {
                fieldOptions = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(fieldOptions).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(item.field_options));
            });
        }
    });
    // intial states setup
    // states
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(null), 2), relatedDropdowns = ref3[0], setRelatedDropdowns = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(dropDownsInitialStates), 2), dropDownState = ref4[0], setDropdownState = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), invalidFlag = ref5[0], setInvalidFlag = ref5[1];
    // related dropdowns initial setup
    var initialStates = {};
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var requiredFieldsAr = [];
        props.data.map(function(item) {
            if (item.field_input_type == "Date") {
            // initialStates[item.value] = formatDate();
            } else if (item.field_input_type == "Radio") {
                if (item.field_label == "Target Pitch") {
                    initialStates[item.value] = item.field_options[0];
                }
            } else {
                initialStates[item.value] = "";
            }
            if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
                dropDownsInitialStates[item.value] = false;
            }
            if (item.field_required == "1") {
                // if(!props.notRequired.includes(item.field_form_field_title))
                requiredFieldsAr.push(item.value);
            }
        });
        setRequiredFields((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(requiredFieldsAr));
        var relatedDropdownToSet = {};
        props.data.map(function(item) {
            if (item.field_input_type == "Related Dropdown") {
                relatedDropdownToSet[item.value] = item.field_dropdown_option_component;
            }
        });
        setRelatedDropdowns(relatedDropdownToSet);
        setDropdownState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, dropDownsInitialStates));
        if (props.formType == "demand" || props.formType == "getBot" || props.formType == "userAccessEdit" || props.formType == "userCreateData" || props.formType == "approval") {
            //
            //console.log(props.demandEditData, "demandEditData")
            if (props.demandEditData != null) {
                if (props.demandEditData.cluster && props.formType == "userAccessEdit") {
                    // console.log(relatedDropdownToSet, "relatedSsupYo", props.data)
                    relatedDropdownToSet["mco"].nowValues = relatedDropdownToSet["mco"].filter(function(itemmco) {
                        return itemmco.field_title == props.demandEditData.cluster;
                    })[0].field_options;
                }
                setState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props.demandEditData));
            } else {
                setState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, initialStates));
            }
        }
    }, []);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (!lodash__WEBPACK_IMPORTED_MODULE_7___default().isEmpty(props.approvalEditData)) [
            setState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props.approvalEditData))
        ];
    }, [
        props.approvalEditData
    ]);
    // React.useEffect(() => {
    //   if (props.editData) {
    //     setState({...props.editData})
    //   }
    // }, [])
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (props.reset) {
            //alert("hii")
            setDropdownState(dropDownsInitialStates);
            setState(initialStates);
            props.setreset(false);
            var reall = relatedDropdowns;
            for(var i in reall){
                delete reall[i]["nowValues"];
            }
            setRelatedDropdowns((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, reall));
        }
    }, [
        props.reset
    ]);
    // handling input values
    // text input changes
    var inputChange = function(e) {
        //console.log(e.target.name, "scsd", e.target.value, "allfsds", state);
        setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, e.target.name, e.target.value)));
    };
    // dropdown open close
    var handleDropDown = function(item) {
        setDropdownState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, dropDownsInitialStates), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, item, !dropDownState[item])));
        //console.log(item,"itemsss");
        props.data.map(function(item) {
            //console.log(item,"itemsss");
            if (props.formType == "userCreateData" || props.formType == "userAccessEdit") {
                if (value == "") {
                    if (item.field_related_dropdown != "") {
                        var reall = relatedDropdowns;
                        for(var i in reall){
                            delete reall[i].nowValues;
                        }
                        setRelatedDropdowns((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, reall));
                    }
                }
            }
        });
    };
    // dropdown value selected
    var gotDropDownValue = function(value, dropdownParent, haveRelated) {
        setValue(value);
        //console.log(haveRelated,"itemsss");
        //console.log(value,"itemsss");
        if (value == "None") {
            if (dropdownParent == "country") {
                setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, dropdownParent, [])));
            } else {
                var newState = state;
                delete newState[dropdownParent];
                setState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, newState));
            }
            setDropdownState(dropDownsInitialStates);
        } else {
            var newState1 = state;
            if (haveRelated) {
                delete newState1[haveRelated];
                var relatedDropdownsToChange = relatedDropdowns;
                props.data.map(function(item, index) {
                    if (item.value == haveRelated) {
                        if (camelize(item.field_related_dropdown) != null && camelize(item.field_related_dropdown).length > 0) {
                            delete newState1[camelize(item.field_related_dropdown)];
                            delete relatedDropdownsToChange[camelize(item.field_related_dropdown)].nowValues;
                        }
                    }
                });
                // setState({...newState});
                var selectedRelatedDropdown = relatedDropdownsToChange[haveRelated];
                selectedRelatedDropdown.nowValues = selectedRelatedDropdown.filter(function(item) {
                    return item.field_title == value;
                })[0].field_options;
                setRelatedDropdowns((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, relatedDropdownsToChange), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, haveRelated, selectedRelatedDropdown)));
            }
            setDropdownState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, dropDownsInitialStates));
            setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, newState1), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, dropdownParent, value)));
            if (props.params == "approval") {
                props.sendFormValues((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, newState1), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, dropdownParent, value)));
            }
            if (props.formType == "approval") {
                if (dropdownParent == "1.PleaseSelectTheProcessArea") {
                    props.sendDataToApproval({
                        subProcess: state["1.PleaseSelectTheSub-ProcessArea"],
                        process: value
                    }, null, false);
                } else {
                    props.sendDataToApproval({
                        process: state["1.PleaseSelectTheProcessArea"],
                        subProcess: value
                    }, null, false);
                }
            }
        }
    };
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
    // console.log(state, "state is")
    }, [
        state
    ]);
    // date selected
    var handleDate = function(date, parent) {
        if (typeof date == "object") {
            var bigDate = date._d;
            var thisDate = bigDate.getDate();
            var thisMonth = bigDate.getMonth() + 1;
            if (thisMonth.toString().length == 1) {
                thisMonth = "0" + thisMonth.toString();
            }
            if (thisDate.toString().length == 1) {
                thisDate = "0" + thisDate.toString();
            }
            var thisYear = bigDate.getFullYear();
            //console.log(thisMonth, "thisMonth")
            // var dd = String(bigDate.getDate()).padStart(2, "0");
            // var mm = String(bigDate.getMonth() + 1).padStart(2, "0"); //January is 0!
            // var yyyy = bigDate.getFullYear();
            var myDate = thisDate + "-" + thisMonth + "-" + thisYear;
            // console.log(myDate, "myDate")
            setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, parent, myDate)));
        } else {
            setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, parent, date._d)));
        }
    };
    // send state to parent
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        //console.log("state get form value basic form-----", state);
        //console.log(props.getFormValues, "getFormValues")
        if (props.getFormValues) {
            var moveAhead = true;
            //console.log("required Fields", requiredFields);
            for(var i in requiredFields){
                if (state[requiredFields[i]] == "" || state[requiredFields[i]] == false || state[requiredFields[i]] === undefined || state[requiredFields[i]] == undefined || state[requiredFields[i]] == "undefined" || state[requiredFields[i]] == null) {
                    // console.log(state[requiredFields[i]], "let's see")
                    moveAhead = false;
                    break;
                }
            }
            if (moveAhead == true) {
                // console.log("sendfrom ----" ,state)
                props.sendFormValues(state);
                setInvalidFlag(false);
            } else {
                setInvalidFlag(true);
            }
            if (props.setGetFormValues) {
                props.setGetFormValues(false);
            }
        }
    }, [
        props.getFormValues
    ]);
    // empty states after submit
    // React.useEffect(() => {
    //   if (props.emptyFormValues== true){
    //   setState(initialStates);
    //   setDropdownState(dropDownsInitialStates);
    //   }
    // }, [props.emptyFormValues]);
    // React.useEffect(() => {
    //   if (props.formType == "demand" || props.formType == "getBot"|| props.formType == "userAccessEdit" || props.formType=="userCreateData" ||props.formType=="approval") {
    //     if (props.demandEditData != null) {
    //       setState(props.demandEditData);
    //     }
    //   }
    // }, [props.demandEditData]);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
    // console.log(state, "stateChange")
    }, [
        state
    ]);
    return props.data.map(function(item, index) {
        if (item.field_input_type == "Radio") {
            //console.log("radioo", item);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().colFirst),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().row),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().formGroup), " ").concat(item.field_column_size == "Large" ? (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().fullWidth) : null),
                        onChange: inputChange,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mainLabel),
                                children: [
                                    item.field_label,
                                    " ",
                                    item.field_required == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                        className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mandatoryField),
                                        children: "*"
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().inputGroupWrapper),
                                children: item.field_options.map(function(radioItem, index) {
                                    var a = item.value;
                                    // console.log(state.a, "whpppppp")
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radioWrapper),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().subLabel),
                                                children: radioItem
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "radio",
                                                className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radioBox),
                                                value: radioItem,
                                                name: item.value,
                                                // defaultChecked={
                                                //   item.value == "targetPitch"
                                                //     ? radioItem == "3A"
                                                //       ? true
                                                //       : false
                                                //     : false
                                                // }
                                                checked: state[item.value] == radioItem ? true : false
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radioCheckmark)
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                })
            });
        } else if (item.field_input_type == "Plain Text") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().colFirst),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().row),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().inputGroup), " ").concat(item.field_column_size == "Large" ? (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().fullWidth) : null),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            item.field_form_field_title,
                                            notRequired.includes(item.field_form_field_title) ? null : item.field_required == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                children: "*"
                                            }) : null
                                        ]
                                    }),
                                    invalidFlag ? !props.notRequired.includes(item.field_form_field_title) && (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().errorMessage),
                                        children: item.field_message_ip_error_message
                                    }) : null : null
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().input), "  ").concat(invalidFlag ? !props.notRequired.includes(item.field_form_field_title) && (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().errorBorder) : null : null),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "text",
                                    placeholder: item.field_title,
                                    name: item.value,
                                    onChange: inputChange,
                                    defaultValue: state[item.value]
                                })
                            })
                        ]
                    })
                })
            });
        } else if (item.field_input_type == "Large Plain Text") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().colFirst),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().row),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().inputGroup), " ").concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().fullWidth)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            " ",
                                            item.field_form_field_title,
                                            item.field_required == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                children: "*"
                                            }) : null
                                        ]
                                    }),
                                    invalidFlag ? !props.notRequired.includes(item.field_form_field_title) && (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().errorMessage),
                                        children: item.field_message_ip_error_message
                                    }) : null : null
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().input), "  ").concat(invalidFlag ? !props.notRequired.includes(item.field_form_field_title) && (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().errorBorder) : null : null),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "text",
                                    placeholder: item.field_title,
                                    name: item.value,
                                    onChange: inputChange,
                                    defaultValue: state[item.value]
                                })
                            })
                        ]
                    })
                })
            });
        } else if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
            var ref, ref1;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: props.type === "form" ? (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().coluser) : (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().colFirst),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().row),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: props.params === "approval" ? "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().approvalgroup)) : props.type === "form" ? "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().approvalgroup)) : props.type === "user" ? "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().userGroup)) : "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().inputGroup)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            item.field_form_field_title,
                                            item.field_required == "1" && props.params != "approval" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                children: "*"
                                            }) : null
                                        ]
                                    }),
                                    props.invalidFlag && (!((ref = props.state["dropData"]) === null || ref === void 0 ? void 0 : ref.process) || !((ref1 = props.state["dropData"]) === null || ref1 === void 0 ? void 0 : ref1.subProcess)) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().errorMessage),
                                        children: item.field_message_ip_error_message
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().input), " ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().errorBorder) : null : null),
                                onClick: function() {
                                    handleDropDown(item.value);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().left),
                                        children: state[item.value] == "" || state[item.value] == null || state[item.value] == "undefined" || item.field_label == "Country" ? item.field_input : state[item.value]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().right),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_svg__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            name: "chevron",
                                            className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().chevron)
                                        })
                                    })
                                ]
                            }),
                            dropDownState[item.value] == true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dropdown),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_listWithoutcheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    formType: props.formType,
                                    dropdownParent: item.value,
                                    params: props.params,
                                    values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? //  "None",
                                    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(relatedDropdowns[item.value].nowValues) : [
                                        "No parent Selected"
                                    ] : [
                                        , 
                                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(item.field_options)),
                                    getDropdownValue: gotDropDownValue,
                                    haveRelated: camelize(item.field_related_dropdown),
                                    closeAllDropdowns: function() {
                                        setDropdownState(dropDownsInitialStates);
                                    }
                                })
                            }) : null,
                            item.field_label == "Country" ? state[item.value].map(function(multipleItem, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().multipleItems),
                                    children: multipleItem
                                }, index);
                            }) : null
                        ]
                    })
                })
            });
        } else if (item.field_input_type == "Date") {
            // console.log(state[item.value], "statevalue");
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().colFirst),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().row),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().inputGroup), " "),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            " ",
                                            item.field_label,
                                            " ",
                                            item.field_required == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                children: "*"
                                            }) : null
                                        ]
                                    }),
                                    invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().errorMessage),
                                        children: "Incorrect Format"
                                    }) : null : null
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_datetime__WEBPACK_IMPORTED_MODULE_3___default()), {
                                closeOnSelect: true,
                                // initialValue={_.get(state, "dateLogged", [
                                //   "2020-11-12",
                                // ])}
                                value: lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(state, item.value),
                                timeFormat: false,
                                dateFormat: "DD-MM-YYYY",
                                className: "".concat((_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calender), "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (_styles_components_basicForm_module_scss__WEBPACK_IMPORTED_MODULE_13___default().errorBorder) : null : null),
                                inputProps: inputprops,
                                onChange: function(date) {
                                    return handleDate(date, item.value);
                                }
                            })
                        ]
                    })
                })
            });
        }
    });
}
/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ 40632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_components_footer_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30345);
/* harmony import */ var _styles_components_footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_components_footer_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





function Footer(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isExcluded = ref[0], setisExcluded = ref[1];
    var contactUsHidePath = [
        "/product",
        "/product_details",
        "/product_details_chatbot",
        "/product_details_cupa",
        "/product_details_sap",
        "/product_details_suite"
    ];
    //  const contactUsHidePath=['/product','/product_details','/product_details_chatbot','/product_details_cupa','/product_details_sap','/product_details_suite']
    //console.log("footer props",router.asPath,router.asPath=="/login")
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var ref;
        if (contactUsHidePath.includes((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0])) {
            setisExcluded(true);
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        className: "".concat((_styles_components_footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footer), " ").concat(props.title == "Demand" ? "".concat((_styles_components_footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().modFooter)) : null, " "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_styles_components_footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footWrapper), " container"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-12 col-md-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat((_styles_components_footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().left), " pr-lg-5"),
                            dangerouslySetInnerHTML: {
                                __html: props.footerProps.field_footer_text
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-12 col-md-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_components_footer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().right),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(props, "footerProps.field_contact_us", "")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    children: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(props, "footerProps.field_email_id", []).filter(function(v) {
                                        return isExcluded ? v !== "ML_IND_ETSC_RPA_Support@unilever.com" : v;
                                    }).map(function(item, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: index == 0 ? {
                                                borderRight: isExcluded ? "none" : "2px solid"
                                            } : undefined,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "mailto:".concat(item),
                                                children: item
                                            })
                                        }, index);
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 58566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header_Filter; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/shared/utils/Figure.js
var Figure = __webpack_require__(16223);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/hallOfFame/assets/filter.svg
/* harmony default export */ var filter = ({"src":"/_next/static/media/filter.8011ea8c.svg","height":18,"width":18});
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(15437);
// EXTERNAL MODULE: ./node_modules/react-icons/rx/index.esm.js
var index_esm = __webpack_require__(55788);
// EXTERNAL MODULE: ./components/hallOfFame/lib/hall_of_fame_store.js
var hall_of_fame_store = __webpack_require__(2617);
;// CONCATENATED MODULE: ./components/hallOfFame/header/Filter.jsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  background-color: #005eef;\n  color: #fff;\n  &::-webkit-calendar-picker-indicator {\n    background-image: url("/hof_date.svg");\n    cursor: pointer;\n    scale: 1.5;\n    position: relative;\n    left: 6px;\n  }\n  outline: none;\n  border: none;\n  text-transform: uppercase;\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Filter = function() {
    var ref = (0,react.useState)(false), isHover = ref[0], setIsHover = ref[1];
    var ref1 = (0,react.useState)(false), clearFilter = ref1[0], setClearFilter = ref1[1];
    console.log("clearFilter", clearFilter);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex relative items-center gap-2 bg-[rgba(255,255,255,0.15)] rounded-[3rem] p-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-[#005EEF] rounded-full w-8 h-8 flex justify-center items-center",
                children: isHover ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* RxCross2 */.$iT, {
                    onClick: function() {
                        return setIsHover(false);
                    },
                    className: "text-white w-4 h-4 cursor-pointer",
                    title: "Close"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Figure/* Figure */.B, {
                    onClick: function() {
                        return setIsHover(true);
                    },
                    className: "w-4 h-4 object-contain cursor-pointer",
                    title: "Filter",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: filter,
                        alt: "Filter Icon"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-unilever-shilling-medium text-white mr-2 text-xs",
                children: "FILTER"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HOFFilter, {
                isHover: isHover,
                clearFilter: clearFilter,
                setClearFilter: setClearFilter
            }),
            isHover && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: function() {
                    return setClearFilter(true);
                },
                className: "font-unilever-shilling-normal whitespace-nowrap cursor-pointer text-white mr-2 text-xs",
                children: "Clear Filter"
            })
        ]
    });
};
var HOFFilter = function(param) {
    var isHover = param.isHover, clearFilter = param.clearFilter, setClearFilter = param.setClearFilter;
    var ref = (0,react.useState)({
        minDate: "",
        maxDate: ""
    }), dateLimit = ref[0], setDateLimit = ref[1];
    var ref1 = (0,react.useState)({
        startDate: "",
        endDate: ""
    }), date = ref1[0], setDate = ref1[1];
    var setFilterDate = (0,hall_of_fame_store/* default */.Z)().setFilterDate;
    var minDate = dateLimit.minDate, maxDate = dateLimit.maxDate;
    var startDate = date.startDate, endDate = date.endDate;
    var handleDateChane = function(e) {
        setDate((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, date), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    (0,react.useEffect)(function() {
        var today = new Date().toISOString().split("T")[0];
        setDateLimit(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                maxDate: today
            });
        });
    }, []);
    (0,react.useEffect)(function() {
        if (startDate && endDate) {
            setFilterDate({
                startDate: startDate,
                endDate: endDate
            });
            setClearFilter(false);
        }
    //eslint-disable-next-line
    }, [
        startDate,
        endDate
    ]);
    (0,react.useEffect)(function() {
        if (clearFilter && startDate && endDate) {
            setDate({
                startDate: "",
                endDate: ""
            });
            setFilterDate({
                startDate: "",
                endDate: ""
            });
        }
    //eslint-disable-next-line
    }, [
        clearFilter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-[#005EEF] ".concat(isHover ? "px-3 mr-2" : "px-0", " text-white rounded-[3rem] text-sm flex items-center font-unilever-shilling-normal"),
        style: {
            visibility: isHover ? "visible" : "hidden",
            width: isHover ? "390px" : "0px",
            transition: "all linear 300ms"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-2 !border-r-2 pr-3 py-1 !border-[#2676f1]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "",
                        children: "From"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDate, {
                        type: "date",
                        name: "startDate",
                        max: endDate ? endDate : maxDate,
                        value: startDate,
                        onChange: handleDateChane
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-2 pl-3 py-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "To"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDate, {
                        type: "date",
                        name: "endDate",
                        min: startDate,
                        max: maxDate,
                        value: endDate,
                        onChange: handleDateChane
                    })
                ]
            })
        ]
    });
};
var InputDate = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-c3f2194e-0"
})(_templateObject());
/* harmony default export */ var header_Filter = (Filter);


/***/ }),

/***/ 2617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);



var useFilterStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)(function(set) {
    return {
        filterDate: {
            startDate: "",
            endDate: ""
        },
        setFilterDate: function(payload) {
            return set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    filterDate: payload
                });
            });
        },
        tractionData: [],
        setTractionData: function(payload) {
            return set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    tractionData: payload
                });
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useFilterStore);


/***/ }),

/***/ 30223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./styles/components/header.module.scss
var header_module = __webpack_require__(4440);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/msal/lib-es6/UserAgentApplication.js + 41 modules
var UserAgentApplication = __webpack_require__(8115);
// EXTERNAL MODULE: ./utility/endpoints.js
var endpoints = __webpack_require__(49530);
// EXTERNAL MODULE: ./redux/globalSearch/actionTypes.js
var globalSearch_actionTypes = __webpack_require__(96713);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./redux/global/actions.js
var actions = __webpack_require__(39471);
;// CONCATENATED MODULE: ./redux/globalSearch/actions.js







var fetchGlobalSearchResult = function() {
    return {
        type: actionTypes.FETCH_GLOBAL_SEARCH_RESULT
    };
};
var fetchGlobalSearchResultSuccess = function(data) {
    return {
        type: globalSearch_actionTypes/* FETCH_GLOBAL_SEARCH_RESULT_SUCCESS */.$l,
        payload: data
    };
};
var fetchGlobalSearchResultFailed = function(data) {
    return {
        type: globalSearch_actionTypes/* FETCH_GLOBAL_SEARCH_RESULT_FAILED */.Ke
    };
};
var globalSearchResult = function(payload) {
    return function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(dispatch) {
            var authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            (0,actions/* checkExpiry */.Wr)(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            return [
                                2,
                                axios_default()({
                                    method: "get",
                                    url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/").concat(endpoints/* default.globalSearch */.ZP.globalSearch, "?k=").concat(payload),
                                    // data: payload,
                                    headers: {
                                        Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                    }
                                }).then(function(resp) {
                                    console.log(resp.data.code);
                                    if (resp.data.code == 200) {
                                        var keyword = payload;
                                        resp.data.data;
                                        dispatch(fetchGlobalSearchResultSuccess({
                                            data: resp.data.data,
                                            keyword: keyword
                                        }));
                                        router_default().push("/globalSearch");
                                    } else if (resp.data.code == 403) {
                                        dispatch(fetchGlobalSearchResultFailed());
                                        dispatch((0,actions/* sessionTimeOutCheck */.Iy)(true));
                                    } else {
                                        dispatch(fetchGlobalSearchResultFailed());
                                    }
                                })
                            ];
                        } else {
                            dispatch((0,actions/* sessionTimeOutCheck */.Iy)(true));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};

// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js + 4 modules
var useWindowSize = __webpack_require__(66018);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Loader/index.jsx
var Loader = __webpack_require__(16330);
;// CONCATENATED MODULE: ./components/header/index.jsx







//import BurgerMenu from "../burgerMenu/index";
var BurgerMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8763).then(__webpack_require__.bind(__webpack_require__, 28763));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28763)
            ];
        }
    }
});
//import Icons from "../../public/assets/svg/index";
var Icons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18023));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18023)
            ];
        }
    }
});


//import RequestDemoModal from "../Pages/RequestDemo";
var RequestDemoModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(4885), __webpack_require__.e(7747), __webpack_require__.e(5842), __webpack_require__.e(439)]).then(__webpack_require__.bind(__webpack_require__, 80756));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80756)
            ];
        }
    }
});
//import SubmitAnIdea from "../Pages/submitAnIdea";
var SubmitAnIdea = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8487), __webpack_require__.e(3662), __webpack_require__.e(4885), __webpack_require__.e(8764), __webpack_require__.e(998), __webpack_require__.e(7747), __webpack_require__.e(5842), __webpack_require__.e(532)]).then(__webpack_require__.bind(__webpack_require__, 34638));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34638)
            ];
        }
    }
});
//import SuccessModal from "../../pages/successModal";
var SuccessModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 99696));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99696)
            ];
        }
    }
});








function index(props) {
    var useOutsideAlerter = // useEffect(()=> {
    //    var iframe = document.getElementById('chatBot');
    //       iframe.addEventListener('load', () => {
    //         alert("heyyy")
    //       console.log( iframe.contentWindow,"iframe infOOOOOOO" );
    //      })
    // })
    function useOutsideAlerter(ref) {
        react.useEffect(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setadminButton(false);
                }
            }
            // Bind the event listener
            document.addEventListener("click", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    console.log(" props of header ------", props);
    //console.log(props.headerProps.header_component[0].field_header_logo[0].file_url)
    //const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' })
    var dispatch = (0,es/* useDispatch */.I0)();
    var chatBotRef = react.useRef(null);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([
        "admin",
        "internalUser",
        "gCad",
        "firstLevelGPMApprover",
        "GPMapprover",
        "firstGfcf",
        "gfcf"
    ]), 2), nonrestrictedUser = ref[0], setnonRestrictedUser = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState([
        "admin",
        "internalUser",
        "supportStatus"
    ]), 2), demandAccessUsers = ref1[0], setDemandAccessUsers = ref1[1];
    var isTabletOrMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 500px)"
    });
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), burgerMenuClick = ref2[0], setburgerMenuClick = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), adminButton = ref3[0], setadminButton = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), requestDemoModal = ref4[0], setRequestDemoModal = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), submitAnIdea = ref5[0], setSubmitAnIdea = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref6[0], setSuccessModal = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), authData = ref7[0], setAuthData = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState("We received your request for demo. Please wait while team will try to get to you!"), 2), message = ref8[0], setMessage = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), sucessOrFailure = ref9[0], setsucessOrFailure = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), keyword = ref10[0], setKeyword = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), mobileSearchActive = ref11[0], setMobileSearchActive = ref11[1];
    var profileDropdownRef = react.useRef(null);
    useOutsideAlerter(profileDropdownRef);
    // const [lastScroll, setLastScroll] = useState(0)
    var ref12 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), sticky = ref12[0], setSticky = ref12[1];
    var width = (0,useWindowSize/* default */.Z)().width;
    var stickyStyle = {
        transform: "translateY(".concat(sticky ? "-100%" : "0", ")")
    };
    var lastScroll = 0;
    // React.useEffect(() => {
    //   if (width > 992) {
    //     document.addEventListener("scroll", trackScroll);
    //   }
    //   return () => {
    //     document.removeEventListener("scroll", trackScroll);
    //   };
    // }, []);
    var trackScroll = function() {
        if (window.scrollY >= lastScroll) {
            setSticky(true);
        } else {
            setSticky(false);
        }
        lastScroll = window.scrollY;
    };
    react.useEffect(function() {
        try {
            var auth = JSON.parse(localStorage.getItem("auth")).data;
            //console.log('auth ----header', auth);
            setAuthData(auth);
        // window.addEventListener('message', function (e) {
        //   alert('heyy')
        //   var iframe = $("#atomFrame");
        //   var eventName = e.data[0];
        //   var data = e.data[1];
        //   switch (eventName) {
        //     case 'setHeight':
        //       iframe.height(data);
        //       break;
        //   }
        // }, false);
        } catch (e) {
            console.log("eroor", e);
        }
    }, []);
    react.useEffect(function() {
        if (props.videoClicked) {
            setSubmitAnIdea(true);
            props.setVideoClicked(false);
        }
    }, [
        props.videoClicked
    ]);
    var burgerFunc = function() {
        var burger = !burgerMenuClick;
        setburgerMenuClick(!burgerMenuClick);
        if (burger === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var ref13 = (0,react.useState)(false), loader = ref13[0], setloader = ref13[1];
    var goTo = function(link) {
        setloader(true);
        router_default().push(link);
        setTimeout(function() {
            setloader(false);
        }, 3000);
        setadminButton(false);
    };
    var userLogout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var msalConfig, msalInstance, account;
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    msalConfig = {
                        auth: {
                            clientId: "e9eab7ce-f3e5-4b3b-9ecb-8dcbcc3f0bde",
                            authority: "https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e",
                            redirectUri: endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin,
                            postLogoutRedirectUri: "".concat(endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "logout")
                        }
                    };
                    msalInstance = new UserAgentApplication/* UserAgentApplication */.x(msalConfig);
                    account = msalInstance.getAccount();
                    msalInstance.logout();
                } catch (e) {
                // console.log("logout errpr", e);
                }
                return [
                    2
                ];
            });
        });
        return function userLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    var handlerequestmodal = function() {
        var modal = !requestDemoModal;
        setRequestDemoModal(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var handlesubmitIdea = function() {
        var ideamodal = !submitAnIdea;
        setSubmitAnIdea(true);
        if (!submitAnIdea === true) {
            document.body.style.overflow = "hidden";
        } else {
            //  alert("heyy")
            document.body.style.overflow = "unset";
        }
    };
    var handlelogo = function() {
        router_default().push("/");
    };
    var textInput = function(e) {
        setKeyword(e.target.value);
    };
    var submitSearch = function(e) {
        if (e.key === "Enter" && keyword != "") {
            dispatch(globalSearchResult(keyword));
        }
    };
    var searchClicked = function() {
        if (keyword != "") {
            dispatch(globalSearchResult(keyword));
        }
    };
    react.useEffect(function() {
        window.addEventListener("scroll", scrollToTop);
        window.addEventListener("message", function(e) {
            if (e.data.setHeight == 620 && isTabletOrMobile) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "unset";
            }
        });
        return function() {
            return window.removeEventListener("scroll", scrollToTop);
        };
    }, []);
    var scrollToTop = function() {
        //console.log("scroll value", sc);
        try {
            var sc = window.pageYOffset;
            if (sc > 100) {
                document.getElementById("scrollToTop").style.display = "flex";
            } else {
                document.getElementById("scrollToTop").style.display = "none";
            }
        } catch (e) {
        //console.log(e)
        }
    };
    // useEffect(() => {
    //   window.addEventListener('message', function (e) {
    //     var iframe = document.getElementById("atomFrame");
    //     console.log(e.data, "e.data")
    //     console.log(iframe)
    //     var eventName = e.data[0];
    //     var data = e.data[1];
    //     switch (eventName) {
    //       case 'setHeight':
    //         if (data == 610){
    //        iframe.style.height = "600px"
    //        iframe.style.bottom = "-5rem" 
    //        iframe.style.overflow = "hidden"
    //       }
    //         else {
    //          iframe.style.height= "120px"
    //          iframe.style.zIndex = "9999"
    //          iframe.style.bottom = "-1rem" 
    //         }
    //         break;
    //     }
    //   }, false);
    //   return () => {
    //     window.removeEventListener("message", () => {return;})
    //   }
    // }, [])
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    src: "https://atombot.azurewebsites.net/public/scripts/frame-support.js"
                })
            }),
            burgerMenuClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerMenu, {
                data: props,
                authData: authData,
                userLogout: userLogout,
                setburgerMenuClick: setburgerMenuClick,
                handlesubmitIdea: handlesubmitIdea,
                handlerequestmodal: handlerequestmodal
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: (header_module_default()).header,
                id: "mainHeader",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (header_module_default()).headWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (header_module_default()).logoMain,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (header_module_default()).logowrapper,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "/",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "https://automation.unilever.com/sites/default/files/2021-05/Unilever%20logo_header%20tab_1.svg",
                                                                    //  src= {endpoints.drupalIp+_get(props, "headerProps.header_component[0].field_header_logo[0].file_url", "")}
                                                                    onClick: function() {
                                                                        handlelogo();
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (header_module_default()).sublogowrapper,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "/",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "https://automation.unilever.com/sites/default/files/2023-04/HAP_Logo_White_Transparent_BG_Horizontal_SVG.png"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-8 d-flex justify-content-end",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (header_module_default()).searchProfileWrapper,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (header_module_default()).search,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (header_module_default()).searchIcon,
                                                                    onClick: searchClicked,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons, {
                                                                        name: "searchDesktop"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (header_module_default()).profile,
                                                                onClick: function() {
                                                                    setadminButton(!adminButton);
                                                                },
                                                                ref: profileDropdownRef,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons, {
                                                                    name: "userDesktop",
                                                                    className: (header_module_default()).userIcon
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (header_module_default()).searchMenuWrapper,
                                                        children: mobileSearchActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (header_module_default()).search,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    onClick: searchClicked,
                                                                    className: (header_module_default()).searchIcon,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons, {
                                                                        name: "searchDesktop"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    name: "keyword",
                                                                    type: "text",
                                                                    placeholder: "Search",
                                                                    value: keyword,
                                                                    onChange: function(e) {
                                                                        textInput(e);
                                                                    },
                                                                    onKeyPress: function(e) {
                                                                        submitSearch(e);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (header_module_default()).crossIcon,
                                                                    onClick: function() {
                                                                        return setMobileSearchActive(false);
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons, {
                                                                        name: "CrossIcon"
                                                                    })
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (header_module_default()).searchContain,
                                                                    onClick: function() {
                                                                        return setMobileSearchActive(true);
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons, {
                                                                        name: "searchMobile",
                                                                        className: (header_module_default()).searchMobileIcon
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (header_module_default()).burgerMenu,
                                                                    onClick: burgerFunc,
                                                                    children: burgerMenuClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons, {
                                                                        name: "closewhite",
                                                                        className: (header_module_default()).burgerMenuIcon
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons, {
                                                                        name: "burgerMenu",
                                                                        className: (header_module_default()).burgerMenuIcon
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            adminButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((header_module_default()).adminLoginWrapper, " row"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((header_module_default()).adminLogin),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        goTo("userProfile");
                                                    },
                                                    children: authData.name
                                                }),
                                                authData.userType == "admin" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        goTo("userAccessMapping");
                                                    },
                                                    children: "Admin Access Zone"
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        goTo("Orderlisting");
                                                    },
                                                    children: "Order Listing"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    onClick: userLogout,
                                                    className: (header_module_default()).logouticon,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons, {
                                                            name: "logout",
                                                            className: (header_module_default()).logi
                                                        }),
                                                        "Logout"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "".concat((header_module_default()).navbar, " shadow-md"),
                        style: stickyStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container h-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row h-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).left,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        return goTo("/");
                                                    },
                                                    className: props.title == "Home" ? (header_module_default()).active : null,
                                                    children: "Home"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        return goTo("/cez");
                                                    },
                                                    className: props.title == "Cognitive Experience Zone" ? (header_module_default()).active : null,
                                                    children: "Experience Zone"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        return goTo("/BotStore");
                                                    },
                                                    className: props.title == "Bot Store" ? (header_module_default()).active : null,
                                                    children: "Bot Store"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        return goTo("/Offerings");
                                                    },
                                                    className: props.title == "Offerings" ? (header_module_default()).active : null,
                                                    children: "Offerings"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        return goTo("https://automation.unilever.com/NewEmployeetwin");
                                                    },
                                                    className: props.title == "New Employeetwin" ? (header_module_default()).active : null,
                                                    children: "Employee Twin"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        return goTo("https://automation.unilever.com/products");
                                                    },
                                                    className: props.title == "Product" ? (header_module_default()).active : null,
                                                    children: "Product"
                                                }),
                                                props.userRole != "endUser" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        return goTo("/Approvals");
                                                    },
                                                    className: props.title == "Approvals" ? (header_module_default()).active : null,
                                                    children: "Approvals"
                                                }) : null,
                                                props.userRole === "admin" || props.userRole === "internalUser" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        return goTo("/hall-of-fame");
                                                    },
                                                    className: props.title == "H.O.F" ? (header_module_default()).active : null,
                                                    children: "H.O.F"
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        return goTo("/ContactUs");
                                                    },
                                                    className: props.title == "Contact Us" ? (header_module_default()).active : null,
                                                    children: "Contact Us"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader["default"], {}) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (header_module_default()).scrollToTop,
                href: "#headTop",
                id: "scrollToTop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons, {
                    name: "chevron",
                    className: (header_module_default()).chevron
                })
            }),
            requestDemoModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestDemoModal, {
                data: props.requestDemoData.data.field_component,
                closeModal: function() {
                    setRequestDemoModal(false);
                },
                setSuccessModal: setSuccessModal,
                setMessage: setMessage,
                setsucessOrFailure: setsucessOrFailure
            }) : null,
            submitAnIdea ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitAnIdea, {
                closeModal: function() {
                    setSubmitAnIdea(false);
                    document.body.style.overflow = "unset";
                },
                getFormData: props.headerProps
            }) : null,
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessModal, {
                setSuccessModal: setSuccessModal,
                title: "Request a demo",
                message: message,
                fail: sucessOrFailure
            }) : null
        ]
    });
}
/* harmony default export */ var header = (index);


/***/ }),

/***/ 96326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Figure; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15437);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 0;\n  & > span {\n    height: 100% !important;\n    width: 100% !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Figure = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].figure.withConfig */ .ZP.figure.withConfig({
    componentId: "sc-d9199119-0"
})(_templateObject());


/***/ }),

/***/ 50543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60242);
/* harmony import */ var _styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_assets_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18023);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49530);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _listWithoutcheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45336);














function index(props) {
    //console.log(props,"upload props");
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), invalidFile = ref[0], setInvalidFile = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), uploading = ref1[0], setUploading = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), disabled = ref2[0], setDisabled = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(null), 2), originalFileName = ref3[0], setOriginalFileName = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState("No file chosen"), 2), originalFileName1 = ref4[0], setOriginalFileName1 = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        docType: ""
    }), 2), state = ref5[0], setState = ref5[1];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        docType: false
    }), 2), dropDownState = ref6[0], setDropdownState = ref6[1];
    var handleDropDown = function(item) {
        setDropdownState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, dropDownState), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, item, !dropDownState[item])));
    };
    // dropdown value selected
    var handleFileChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(e, title) {
            var fileNameExtension, fileNameExtension1, extensionFlag, i;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                //console.log(props.fileType)
                if (props.chooseFile == "onlySubmitAnIdea") {
                    props.onUploadBtnClicked(); //For Error Msg when no file selected in submitAnIdea form
                }
                if (props.type == "demand") {
                    fileNameExtension = e.target.files[0].name.split(".");
                    fileNameExtension = fileNameExtension[fileNameExtension.length - 1];
                    if (props.fileType.includes(fileNameExtension)) {
                        props.uploadFile(e.target.files[0], e.target.name, title, fileNameExtension);
                        setOriginalFileName(e.target.files[0].name);
                        setOriginalFileName1(e.target.files[0].name);
                        setInvalidFile(false);
                    } else {
                        setInvalidFile(true);
                    }
                } else {
                    fileNameExtension1 = e.target.files[0].name.split(".");
                    fileNameExtension1 = fileNameExtension1[fileNameExtension1.length - 1];
                    extensionFlag = false;
                    if (typeof props.fileType == "string") {
                        if (props.fileType.includes(fileNameExtension1)) {
                            extensionFlag = true;
                        }
                    } else {
                        for(var i in props.fileType){
                            if (props.fileType[i].includes(fileNameExtension1)) {
                                extensionFlag = true;
                            }
                        }
                    }
                    if (extensionFlag == true) {
                        setOriginalFileName(e.target.files[0].name);
                        setOriginalFileName1(e.target.files[0].name);
                        console.log(e.target.files[0], "sd", e.target.name);
                        props.uploadFile(e.target.files[0], e.target.name, title, e.target.files[0].name, fileNameExtension1);
                        if (props.type !== "framework") {}
                        setInvalidFile(false);
                    } else {
                        setInvalidFile(true);
                    }
                }
                e.target.value = "";
                return [
                    2
                ];
            });
        });
        return function handleFileChange(e, title) {
            return _ref.apply(this, arguments);
        };
    }();
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        //console.log(props.uploaded, "uploadedddddddd")
        if (props.uploaded == true) {
            if (props.type == "createBot") {
                setDisabled(true);
            }
        } else {
            setDisabled(false);
        }
    }, [
        props.uploaded
    ]);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (props.originalFileName != null && props.originalFileName.length > 0) {
            console.log(props.originalFileName, "originalestFileNames");
            setOriginalFileName(props.originalFileName);
            setOriginalFileName1(props.originalFileName);
        }
    }, [
        props.originalFileName
    ]);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (props.currentlyUploading) {
            setDisabled(true);
        } else {
            if (!props.uploaded) {
                setDisabled(false);
            }
        }
    }, [
        props.currentlyUploading
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().wrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: disabled == true ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().disabledInputGroup) : (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().inputGroup),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uploadButton),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                            for: props.value,
                            children: "Select from device"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "file",
                        style: {
                            display: "none"
                        },
                        id: props.value,
                        onChange: function(e) {
                            handleFileChange(e, props.title);
                        },
                        name: props.value,
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "".concat((_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().fileName), " ").concat(props.uploaded == true ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uploaded) : props.couldNotUpload == true ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().errorUploading) : uploading == true ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uploading) : null),
                        children: props.name == "editemployeetwin" ? props.uploaded == true ? decodeURI(originalFileName) : props.couldNotUpload == true ? "Error while uploading" : uploading == true ? "Uploading..." : "Selected........" : props.uploaded == true ? props.chooseFile == "onlySubmitAnIdea" ? decodeURI(originalFileName1) : decodeURI(originalFileName) : props.couldNotUpload == true ? "Error while uploading" : uploading == true ? "Uploading..." : " No file chosen"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: props.type == "createBot" && props.value !== "botDemoVideo" && !props.specialCase ? invalidFile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: props.specialCase ? !invalidFile ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().validFormatMsgSpecial) : (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().invalidFormatMsgSpecial) : !invalidFile ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().validFormatMsg) : (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().invalidFormatMsg),
                    style: {
                        position: "absolute",
                        left: "10px",
                        bottom: "6px"
                    },
                    children: "Incorrect format"
                }) : null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: props.specialCase ? !invalidFile ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().validFormatMsgSpecial) : (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().invalidFormatMsgSpecial) : !invalidFile ? (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().validFormatMsg) : (_styles_components_uploadFile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().invalidFormatMsg),
                    children: "Upload files in the format of ".concat(typeof props.fileType == "string" || typeof props.fileType == "object" ? props.fileType : ".mov, .avi, .mp4", ".")
                })
            })
        ]
    });
}


/***/ }),

/***/ 91403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _path_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./styles/components/frameworkBanner.module.scss
var frameworkBanner_module = __webpack_require__(40070);
var frameworkBanner_module_default = /*#__PURE__*/__webpack_require__.n(frameworkBanner_module);
// EXTERNAL MODULE: ./utility/endpoints.js
var utility_endpoints = __webpack_require__(49530);
;// CONCATENATED MODULE: ./components/frameworkBanner/index.jsx




function index(props) {
    //console.log(props, "framaework page image")
    var _data = props.data, field_background_image = _data.field_background_image, field_background_image_mobile = _data.field_background_image_mobile, field_hedaing = _data.field_hedaing, field_details = _data.field_details;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((frameworkBanner_module_default()).frameworkbannerWrapper, " container-fluid"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((frameworkBanner_module_default()).row, " row"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (frameworkBanner_module_default()).imaging,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (frameworkBanner_module_default()).image,
                                src: utility_endpoints/* default.drupalIp */.ZP.drupalIp + field_background_image[0].file_url,
                                alt: field_background_image[0].image_alt
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (frameworkBanner_module_default()).imageMobile,
                                src: utility_endpoints/* default.drupalIp */.ZP.drupalIp + field_background_image_mobile[0].file_url,
                                alt: "abc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((frameworkBanner_module_default()).container, " container py-4"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (frameworkBanner_module_default()).frameworkbannerHead,
                                children: field_hedaing
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (frameworkBanner_module_default()).frameworkbannerText,
                                dangerouslySetInnerHTML: {
                                    __html: field_details
                                }
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./public/assets/svg/index.jsx + 68 modules
var svg = __webpack_require__(18023);
;// CONCATENATED MODULE: ./components/frameworkStepper/index.jsx





function frameworkStepper(props) {
    //     console.log(props, "stepper")
    //    let detailAr = props.data[0].field_details.split("<p>")
    //    for ( let i in detailAr) {
    //        detailAr[i] = "<p styles.dataLine>" + detailAr[i];
    //    }
    //    const aa = detailAr.shift()
    //    const aaa = detailAr.join()
    //    console.log(aaa)
    return /*#__PURE__*/ _jsx("div", {
        className: styles.stepperContainer,
        children: props.data.map(function(item, index) {
            return /*#__PURE__*/ _jsxs("div", {
                className: "".concat(styles.stepperCardWrapper, " ").concat(index == 0 ? styles.discover : index == 1 ? styles.designProcess : index == 2 ? styles.deploySustain : index == 3 ? styles.developSolution : null),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "".concat(styles.head, " ").concat(index == 0 ? styles.discover : index == 1 ? styles.designProcess : index == 2 ? styles.deploySustain : index == 3 ? styles.developSolution : null),
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "".concat(styles.icon, " ").concat(index == 0 ? styles.discover : index == 1 ? styles.designProcess : index == 2 ? styles.deploySustain : index == 3 ? styles.developSolution : null),
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "".concat(endpoints.drupalIp).concat(item.field_background_image[0].file_url)
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "".concat(styles.title, " ").concat(index == 0 ? styles.discover : index == 1 ? styles.designProcess : index == 2 ? styles.deploySustain : index == 3 ? styles.developSolution : null),
                                children: /*#__PURE__*/ _jsx("p", {
                                    children: item.field_title
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "".concat(styles.body, " ").concat(index == 0 ? styles.discover : index == 1 ? styles.designProcess : index == 2 ? styles.deploySustain : index == 3 ? styles.developSolution : null),
                        dangerouslySetInnerHTML: {
                            __html: item.field_details
                        }
                    })
                ]
            }, index);
        })
    });
}

// EXTERNAL MODULE: ./components/uploadFile/index.jsx
var components_uploadFile = __webpack_require__(67954);
// EXTERNAL MODULE: ./styles/pages/frameworkPage.module.scss
var frameworkPage_module = __webpack_require__(3519);
var frameworkPage_module_default = /*#__PURE__*/__webpack_require__.n(frameworkPage_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./styles/components/frameworkPdfComponent.module.scss
var frameworkPdfComponent_module = __webpack_require__(75503);
var frameworkPdfComponent_module_default = /*#__PURE__*/__webpack_require__.n(frameworkPdfComponent_module);
// EXTERNAL MODULE: ./node_modules/jszip/dist/jszip.min.js
var jszip_min = __webpack_require__(55733);
var jszip_min_default = /*#__PURE__*/__webpack_require__.n(jszip_min);
// EXTERNAL MODULE: ./node_modules/jszip-utils/lib/index.js
var lib = __webpack_require__(80925);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./pages/successModal/index.jsx
var pages_successModal = __webpack_require__(99696);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
// EXTERNAL MODULE: ./redux/global/actions.js
var actions = __webpack_require__(39471);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
;// CONCATENATED MODULE: ./components/frameWorkPdfComponent/index.jsx






















function frameWorkPdfComponent_index(props) {
    //console.log("props framewrokcomponent-----", props);
    var ref = (0,react.useState)([]), transformedDocuments = ref[0], setTransformedDocuments = ref[1];
    var ref1 = (0,react.useState)(true), isButtonDisabled = ref1[0], setIsButtonDisabled = ref1[1];
    var ref2 = (0,react.useState)(false), areYouSure = ref2[0], setAreYouSure = ref2[1];
    //console.log(props, "frameworkprops");
    var pdfObj = {};
    for(var i in props.docsData){
        pdfObj[i] = "".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(props.docsData[i].docUrl);
    }
    //console.log(pdfObj, "pdfobj");
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), automationCheckedState = ref3[0], setAutomationCheckedState = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(pdfObj), 2), pdfLink = ref4[0], setPdfLink = ref4[1];
    var selectDocumentsHandler = function(event, index) {
        var isChecked = event.target.checked;
        //console.log(transformedDocuments, "transformedDocs");
        var newTransformedDocuments = (0,src_to_consumable_array/* default */.Z)(transformedDocuments);
        if (isChecked) {
            newTransformedDocuments[index].isSelected = true;
        } else {
            newTransformedDocuments[index].isSelected = false;
        }
        if (checkIfAnyDocumentSelected(newTransformedDocuments)) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
        setTransformedDocuments(newTransformedDocuments);
    };
    var selectAllDocuments = function(e) {
        var newTransformedDocuments = (0,src_to_consumable_array/* default */.Z)(transformedDocuments);
        if (e.target.checked) {
            for(var i in newTransformedDocuments){
                newTransformedDocuments[i].isSelected = true;
            }
        } else {
            for(var i1 in newTransformedDocuments){
                newTransformedDocuments[i1].isSelected = false;
            }
        }
        if (checkIfAnyDocumentSelected(newTransformedDocuments)) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
        setTransformedDocuments(newTransformedDocuments);
    };
    var checkIfAnyDocumentSelected = function(documents) {
        return documents.some(function(document) {
            return document.isSelected === true;
        });
    };
    var downloadSelectedDocuments = function() {
        if (!checkIfAnyDocumentSelected(transformedDocuments)) {
            return;
        }
        var selectedDocuments = transformedDocuments.filter(function(document) {
            return document.isSelected === true;
        });
        //console.log("Selected Documents", selectedDocuments);
        if (selectedDocuments.length === 1) {
            window.open("".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(selectedDocuments[0].docUrl));
        } else {
            downloadZipForDocuments(selectedDocuments);
        }
    };
    var downloadAllDocuments = function() {
        //  console.log("docsdata", props.docsData);
        downloadZipForDocuments(props.docsData);
    };
    var downloadZipForDocuments = function(documents) {
        props.setLoader(true);
        var zip = new (jszip_min_default())();
        var zipFolderName = "Documents.zip";
        var count = 0;
        documents.forEach(function(document) {
            var fileName = document.docName;
            var filePath = "".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(document.docUrl);
            lib_default().getBinaryContent(filePath, function(err, data) {
                if (err) {
                    throw err;
                }
                zip.file(fileName, data, {
                    binary: true
                });
                count++;
                if (count === documents.length) {
                    zip.generateAsync({
                        type: "blob"
                    }).then(function(content) {
                        (0,FileSaver_min.saveAs)(content, zipFolderName);
                        props.setLoader(false);
                    });
                }
            });
        });
    };
    var downloadPdf = function(pdfLink) {
        window.open(pdfLink);
    };
    var formatDocumentSize = function(sizeInBytes) {
        var megaBytes = sizeInBytes / 1e6;
        var kiloBytes = sizeInBytes / 1e3;
        if (megaBytes >= 1) {
            return "".concat(megaBytes.toFixed(1), " mb");
        } else {
            return "".concat(Math.trunc(kiloBytes), " kb");
        }
    };
    var transformDocumentsData = function() {
        var transformedDocuments = props.docsData.map(function(doc) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, doc), {
                isSelected: false
            });
        });
        //console.log("tranformed doc ----", transformedDocuments);
        setTransformedDocuments(transformedDocuments);
    };
    (0,react.useEffect)(function() {
        if (props.docsData) {
            transformDocumentsData();
        }
    }, [
        props.docsData
    ]);
    var ref5 = (0,react.useState)(null), frameworkIdToDelete = ref5[0], setFrameworkIdToDelete = ref5[1];
    var deleteDocument = function(frameworkId) {
        setFrameworkIdToDelete(frameworkId);
        setAreYouSure(true);
    };
    var responseFromAreYouSure = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(bool) {
            var authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!bool) return [
                            3,
                            5
                        ];
                        props.setLoader(true);
                        window.scrollTo(0, 0);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 2:
                        auth = _state.sent();
                        axios_default()({
                            method: "delete",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/framework/deleteFrameworkDocument"),
                            params: {
                                id: frameworkIdToDelete
                            },
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            }
                        }).then(function(res) {
                            if (res.data.code == 403) {
                                props.sessionTimeOutCheck(true);
                                props.setLoader(false);
                            }
                            //console.log(res);
                            props.getAllPdfs();
                            setAreYouSure(false);
                            props.setLoader(false);
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        props.sessionTimeOutCheck(true);
                        props.setLoader(false);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setAreYouSure(false);
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function responseFromAreYouSure(bool) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((frameworkPdfComponent_module_default()).automationFactoryContainer, " container"),
        children: [
            areYouSure ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                title: "Framework",
                message: "Are you sure?",
                fail: true,
                setSuccessModal: responseFromAreYouSure,
                areYouSure: true
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (frameworkPdfComponent_module_default()).factoryHead,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (frameworkPdfComponent_module_default()).left,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: get_default()(props, "data", "")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (frameworkPdfComponent_module_default()).right,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "".concat((frameworkPdfComponent_module_default()).downloadSelected),
                                disabled: isButtonDisabled,
                                onClick: downloadSelectedDocuments,
                                children: get_default()(props, "download[0]", "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (frameworkPdfComponent_module_default()).downloadAll,
                                onClick: downloadAllDocuments,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                        name: "downloadWhite",
                                        className: (frameworkPdfComponent_module_default()).downloadWhite
                                    }),
                                    get_default()(props, "download[1]", "")
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (frameworkPdfComponent_module_default()).assetsWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (frameworkPdfComponent_module_default()).selectAllCheck,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: (frameworkPdfComponent_module_default()).list_Checkbox_container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (frameworkPdfComponent_module_default()).lableHead,
                                    children: "Select all"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    onChange: function(e) {
                                        return selectAllDocuments(e);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (frameworkPdfComponent_module_default()).list_checkmark
                                })
                            ]
                        })
                    }),
                    transformedDocuments.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: item.isSelected ? "".concat((frameworkPdfComponent_module_default()).pdfCard, " ").concat((frameworkPdfComponent_module_default()).active) : (frameworkPdfComponent_module_default()).pdfCard,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (frameworkPdfComponent_module_default()).head,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "  ".concat(item.isSelected ? (frameworkPdfComponent_module_default()).iconview : (frameworkPdfComponent_module_default()).iconWrap),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (frameworkPdfComponent_module_default()).check,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (frameworkPdfComponent_module_default()).list_Checkbox_container,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                onChange: function(e) {
                                                                    return selectDocumentsHandler(e, index);
                                                                },
                                                                checked: item.isSelected ? true : false
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (frameworkPdfComponent_module_default()).list_checkmark
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                    name: item.docType,
                                                    className: (frameworkPdfComponent_module_default()).icon
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            class: (frameworkPdfComponent_module_default()).pdfTitle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: item.docName.length > 15 ? "".concat(item.docName.slice(0, 16), "...") : item.docName
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                    children: formatDocumentSize(item.docSize)
                                                })
                                            ]
                                        }),
                                        props.auth.userType == "admin" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (frameworkPdfComponent_module_default()).deleteIcon,
                                            onClick: function() {
                                                deleteDocument(item.frameworkId);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                name: "deleteicon",
                                                className: (frameworkPdfComponent_module_default()).icon
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: function() {
                                                downloadPdf("".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(item.docUrl));
                                            },
                                            className: (frameworkPdfComponent_module_default()).mobileDownloadIcon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                name: "downloadBlue"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: function() {
                                                downloadPdf("".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(item.docUrl));
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (frameworkPdfComponent_module_default()).body,
                                    onClick: function() {
                                        downloadPdf("".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(item.docUrl));
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (frameworkPdfComponent_module_default()).downloadOverlay,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (frameworkPdfComponent_module_default()).downloadBtn,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                        name: "downloadWhite",
                                                        className: (frameworkPdfComponent_module_default()).download
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Download"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (frameworkPdfComponent_module_default()).objWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                style: {
                                                    width: "100%"
                                                },
                                                src: item.docType == "xlsx" || item.docType == "doc" || item.docType == "docx" ? "https://docs.google.com/viewerng/viewer?embedded=true&url=".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(item.docUrl) : item.docType == "ppt" || item.docType == "pptx" || item.docType == "msg" ? "https://view.officeapps.live.com/op/embed.aspx?src=".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(item.docUrl) : "".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(item.docUrl),
                                                type: "application/".concat(item.docType),
                                                width: "220",
                                                height: "100"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (frameworkPdfComponent_module_default()).mobileDownloadAll,
                onClick: downloadSelectedDocuments,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (frameworkPdfComponent_module_default()).btn,
                    children: get_default()(props, "download[0]", "")
                })
            })
        ]
    });
}
var mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var frameWorkPdfComponent = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(frameWorkPdfComponent_index));

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
;// CONCATENATED MODULE: ./utility/userTypes.js
/* harmony default export */ var userTypes = ({
    Admin: "admin",
    GFCF: "GFCF Approver",
    GPM: "GPM Approver",
    GCAD: "GCAD Approver",
    BusinnessOwner: "Business Owner",
    EnagaementLead: "Engagement Lead",
    BusinessAnalyst: "Business Analyst"
});

// EXTERNAL MODULE: ./node_modules/@azure/storage-blob/dist-esm/storage-blob/src/BlobServiceClient.js + 206 modules
var BlobServiceClient = __webpack_require__(60998);
// EXTERNAL MODULE: ./components/Loader/index.jsx
var components_Loader = __webpack_require__(16330);
// EXTERNAL MODULE: ./node_modules/lodash.includes/index.js
var lodash_includes = __webpack_require__(28922);
;// CONCATENATED MODULE: ./components/Pages/Frameworks/index.js
























function Frameworks_index(props) {
    //console.log("props  drupal----", props);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)([
        "endUser",
        "businessUserRegionWise",
        "businessOwner",
        "firstGfcf",
        "gfcf",
        "firstLevelGPMApprover",
        "GPMapprover",
        "gCad",
        "supportStatus"
    ]), restrictedUsers = ref[0], setRestrictedUser = ref[1];
    var ref1 = (0,react.useState)([
        "internalUser",
        "qrManager",
        "releaseManager",
        "editAccess",
        "admin", 
    ]), nonRestrictedUser = ref1[0], setNonRestrictedUser = ref1[1];
    //  console.log(props.routes, "routessss")
    var ref2 = (0,react.useState)(false), loader = ref2[0], setLoader = ref2[1];
    var ref3 = (0,react.useState)(false), fileError = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)([
        "pdf",
        "docx",
        "doc",
        "xlsx",
        "msg",
        "jpg",
        "jpeg",
        "png",
        "ppt",
        "pptx", 
    ]), fileTypes = ref4[0], setfileTypes = ref4[1];
    var ref5 = props.data[0], content = ref5.component.content;
    var stepperImage = props.data[1].component.content.field_content_image[0].file_url;
    var stepperImageMobile = props.data[1].component.content.field_content_image_mobile[0].file_url;
    var pdfData = get_default()(props, "data[1].component.content.field_options", []);
    var ref6 = (0,react.useState)(false), successModal = ref6[0], setSuccessModal = ref6[1];
    var ref7 = (0,react.useState)("Document Added!"), message = ref7[0], setMessage = ref7[1];
    var ref8 = (0,react.useState)(null), file = ref8[0], setFile = ref8[1];
    var ref9 = (0,react.useState)(null), fileNameOriginal = ref9[0], setFileName = ref9[1];
    var ref10 = (0,react.useState)(false), showFileName = ref10[0], setShowFileName = ref10[1];
    var ref11 = (0,react.useState)([]), automationPdfs = ref11[0], setAutomationPdfs = ref11[1];
    var ref12 = (0,react.useState)([]), confidentialPdfs = ref12[0], setConfidentialPdfs = ref12[1];
    var ref13 = (0,react.useState)({}), auth = ref13[0], setAuth = ref13[1];
    var ref14 = (0,react.useState)(false), filenameError = ref14[0], setFileNameError = ref14[1];
    (0,react.useEffect)(function() {
        try {
            if (localStorage.getItem("auth") != undefined) {
                setAuth(JSON.parse(localStorage.getItem("auth")).data);
            }
        } catch (e) {
            console.log("error", e);
        }
    }, []);
    var blobSasUrl = "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
    var blobSasUrlNew = utility_endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    // "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/FrameworkDocuments");
    var uploadFile = function(file, name) {
        //console.log(file, "pdfsauto");
        //console.log(automationPdfs, "pdfsauto");
        if (automationPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0 || confidentialPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0) {
            setFileNameError(true);
            setSuccessModal(true);
            return;
        }
        setFile(file);
        setShowFileName(true);
        setFileName(file.name);
    };
    var uploadButtonClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var fileNameWithSpaces, fileName, ar, extension, fileSize, blockBlobClient, options, resp, url, ar1, another, toSend, authCheck, expiryStatus, auth, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        //console.log(fileNameOriginal, "fileName", file);
                        if (fileNameOriginal == null || docType == null) {
                            setError(true);
                            return [
                                2
                            ];
                        } else {
                            setError(false);
                        }
                        setLoader(true);
                        fileNameWithSpaces = fileNameOriginal;
                        fileName = fileNameWithSpaces.replace(/ /g, "");
                        ar = fileNameOriginal.split(".");
                        extension = ar[ar.length - 1];
                        fileSize = file.size;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        url = resp._response.request.url;
                        ar1 = url.split("?");
                        another = ar1[0].split("/");
                        toSend = another[another.length - 1];
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 3:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            axios_default()({
                                method: "post",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/framework/createFramework"),
                                data: {
                                    docType: extension,
                                    docName: fileNameOriginal,
                                    docCategory: docType,
                                    docUrl: toSend,
                                    docSize: fileSize
                                },
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(resp) {
                                if (resp.data.code == 200) {
                                    //  console.log(resp);
                                    window.scrollTo(0, 0);
                                    setSuccessModal(true);
                                    setShowFileName(false);
                                    setLoader(false);
                                    setFile(null);
                                    setError(false);
                                    setFileName(null);
                                    getAllPdfs();
                                } else if (resp.data.code == 403) {
                                    setLoader(false);
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            setLoader(false);
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error, "erro");
                        alert("Could not upload");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var getAllPdfs = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            // setLoader(true);
                            axios_default()({
                                method: "get",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/framework/getFramework"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(res) {
                                if (res.data.code == 200) {
                                    //    setLoader(false);
                                    //console.log(res.data, "framework Response  ---");
                                    var automationPdfs = res.data.data.filter(function(item) {
                                        return item.docCategory == "automation";
                                    });
                                    var confidentialPdfs = res.data.data.filter(function(item) {
                                        return item.docCategory == "confidential";
                                    });
                                    setAutomationPdfs(automationPdfs);
                                    setConfidentialPdfs(confidentialPdfs);
                                } else if (res.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            setLoader(false);
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getAllPdfs() {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        getAllPdfs();
    }, []);
    react.useEffect(function() {
    //console.log(automationPdfs, "automation");
    }, [
        automationPdfs
    ]);
    var ref15 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), docType = ref15[0], setDoctype = ref15[1];
    var gotDocTypeFromChild = function(docTypeState) {
        if (docTypeState.docType == "Automation factory templates") {
            setDoctype("automation");
        } else {
            setDoctype("confidential");
        }
    };
    return loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            height: "800px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {})
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (frameworkPage_module_default()).frameworkContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index, {
                    data: content
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            class: "col-12 py-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(stepperImage),
                                    className: "d-none d-lg-block hw-100"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(stepperImageMobile),
                                    className: "d-lg-none d-block m-auto hw-100"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        auth.userType == "admin" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (frameworkPage_module_default()).uploadControl,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (frameworkPage_module_default()).uploadFileContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_uploadFile/* default */.Z, {
                                            type: "framework",
                                            fileType: fileTypes,
                                            data: pdfData,
                                            uploadFile: uploadFile,
                                            uploaded: showFileName,
                                            value: "frameworkDocument",
                                            sendDocTypeToParent: gotDocTypeFromChild
                                        }),
                                        fileError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                color: "red",
                                                fontSize: "10px"
                                            },
                                            children: "Select Some File and doctype"
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (frameworkPage_module_default()).actionBtn,
                                    onClick: uploadButtonClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                name: "uploadicon",
                                                className: (frameworkPage_module_default()).uploadIcon
                                            }),
                                            get_default()(props, "data[1].component.content.field_upload_file_button_text[0]", ""),
                                            " "
                                        ]
                                    })
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (frameworkPage_module_default()).pdfViewCardContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(frameWorkPdfComponent, {
                                    auth: auth,
                                    data: pdfData[0],
                                    download: get_default()(props, "data[1].component.content.field_upload_document_component[0].field_document_download_buttons", []),
                                    docsData: automationPdfs,
                                    setLoader: setLoader,
                                    getAllPdfs: getAllPdfs
                                }),
                                !restrictedUsers.includes(auth.userType) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(frameWorkPdfComponent, {
                                    auth: auth,
                                    data: pdfData[1],
                                    download: get_default()(props, "data[1].component.content.field_upload_document_component[0].field_document_download_buttons", []),
                                    docsData: confidentialPdfs,
                                    setLoader: setLoader,
                                    getAllPdfs: getAllPdfs
                                }) : null
                            ]
                        })
                    ]
                }),
                successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                    setSuccessModal: function() {
                        setSuccessModal(false);
                        setFileNameError(false);
                    },
                    title: "Framework",
                    message: filenameError ? "Document with this name already exists." : message,
                    fail: filenameError ? true : false
                }) : null
            ]
        })
    });
}
var Frameworks_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function Frameworks_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var Frameworks = ((0,es/* connect */.$j)(Frameworks_mapStateToProps, Frameworks_mapDispatchToProps)(Frameworks_index));

// EXTERNAL MODULE: ./styles/pages/demand.module.scss
var demand_module = __webpack_require__(79924);
var demand_module_default = /*#__PURE__*/__webpack_require__.n(demand_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./styles/components/demandData.module.scss
var demandData_module = __webpack_require__(25615);
var demandData_module_default = /*#__PURE__*/__webpack_require__.n(demandData_module);
// EXTERNAL MODULE: ./styles/components/demandEdit.module.scss
var demandEdit_module = __webpack_require__(87619);
var demandEdit_module_default = /*#__PURE__*/__webpack_require__.n(demandEdit_module);
// EXTERNAL MODULE: ./components/listWithoutcheck/index.jsx
var listWithoutcheck = __webpack_require__(45336);
// EXTERNAL MODULE: ./components/basicForm/index.js
var basicForm = __webpack_require__(35842);
;// CONCATENATED MODULE: ./components/demandEditModal/index.jsx















var baseUrl = utility_endpoints/* default.baseUrl */.ZP.baseUrl;




var ModalExample = function(props) {
    var useOutsideAlerter = function useOutsideAlerter(ref) {
        (0,react.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                //console.log(ref.current, "lllllll");
                //console.log(event.target, "eeeeeee");
                if (ref.current && !ref.current.contains(event.target)) {
                //props.closeModal();
                }
            }
            // Bind the event listener
            document.addEventListener("click", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var camelize = // field_demand_edit_new_row_detail.map((item, index) => {
    //   if (
    //     item.field_input_type == "Radio" ||
    //     item.field_input_type == "Plain Text"
    //   ) {
    //     arrangedArray.push(item);
    //   } else if (item.field_input_type == "Dropdown1") {
    //     let dropDownAr = [];
    //     dropDownAr.push(item);
    //     dropDownAr.push(field_demand_edit_new_row_detail[index + 1]);
    //     arrangedArray.push(dropDownAr);
    //   }
    // });
    // to convert labels into camelcase
    function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    //console.log();
    //console.log("Demaand data  ---", props.demandEditData);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(true), lodaing = ref[0], setLoading = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), newDemand = ref1[0], setNewDemand = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref2[0], setSuccessModal = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState("Demand Updated Successfully!"), 2), message = ref3[0], setMessage = ref3[1];
    var _demandFormData = props.demandFormData, field_demand_edit_new_row_detail = _demandFormData.field_demand_edit_new_row_detail, field_title = _demandFormData.field_title;
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), state = ref4[0], setState = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref5[0], setSubmitForm = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref6[0], setGetFormValues = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref7[0], setEmptyFormValues = ref7[1];
    var modalRef = react.useRef(null);
    useOutsideAlerter(modalRef);
    var submitDemandForm = function() {
        setGetFormValues(true);
        props.setState((0,src_object_spread/* default */.Z)({}, props.initialState));
        props.setSearchState("");
        props.setFilterOn(false);
    //props.setPaginationNum(1);
    };
    var recievedFormValues = function(formState) {
        //console.log(formState, "formState is here");
        setState((0,src_object_spread/* default */.Z)({}, state, formState));
        sendData((0,src_object_spread/* default */.Z)({}, state, formState));
    };
    //   React.useEffect(() => {
    //     if (submitForm == true){
    // console.log("submitform")
    //     }
    //   }, [submitForm]);
    var convertToDDMMYYYY = function(date, Z) {
        //console.log(date, "this is what I'm getting", Z);
        var year = date.slice(0, 4);
        var month = date.slice(5, 7);
        var day = date.slice(8, 10);
        var newDate = day + "-" + month + "-" + year;
        return newDate;
    };
    var convertToYYYYMMDD = function(date) {
        //console.log(date, "dateiswhat");
        var day = date.slice(0, 2);
        var month = date.slice(3, 5);
        var year = date.slice(6, 10);
        var newDate = year + "-" + month + "-" + day;
        return newDate;
    };
    react.useEffect(function() {
        if (props.demandEditData != null) {
            {}
            // props.demandEditData.sessionDate = convertToYYYYMMDD(props.demandEditData.sessionDate)
            setState(props.demandEditData);
        } else if (props.demandEditData == null) {
            //console.log("else new demand");
            setNewDemand(true);
        }
    }, []);
    var arrangedArray = [];
    var sendData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(statess) {
            var auth, authCheck, expiryStatus, auth1, authCheck1, expiryStatus1, auth2, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        statess.sessionDate = convertToYYYYMMDD(statess.sessionDate);
                        if (!(newDemand == true)) return [
                            3,
                            2
                        ];
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth1 = JSON.parse(localStorage.getItem("auth")).data;
                            props.setmodalactive(false);
                            props.setLoading(true);
                            axios_default()({
                                method: "post",
                                url: "".concat(baseUrl, "/demands/createDemand"),
                                headers: {
                                    Authorization: "".concat(auth1.accessToken, "|").concat(auth1.email)
                                },
                                data: statess
                            }).then(function(resp) {
                                //console.log("resp", resp);
                                if (resp.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                    setLoading(false);
                                    props.setLoading(false);
                                } else if (resp.data.code == 200) {
                                    props.closeModal("create");
                                }
                                setState({});
                            });
                        } else {
                            props.sessionTimeOutCheck(true);
                            setLoading(false);
                            props.setLoading(false);
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        authCheck1 = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck1)
                        ];
                    case 3:
                        expiryStatus1 = _state.sent();
                        if (expiryStatus1) {
                            auth2 = JSON.parse(localStorage.getItem("auth")).data;
                            props.setmodalactive(false);
                            props.setLoading(true);
                            axios_default()({
                                method: "put",
                                url: "".concat(baseUrl, "/demands/updateDemand"),
                                headers: {
                                    Authorization: "".concat(auth2.accessToken, "|").concat(auth2.email)
                                },
                                data: {
                                    emailAndSerialNumber: {
                                        UserEmail: auth2.email,
                                        rowKey: state.rowKey
                                    },
                                    demandUpdateFields: (0,src_object_spread/* default */.Z)({}, statess)
                                }
                            }).then(function(resp) {
                                if (resp.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                    setLoading(false);
                                    props.setLoading(false);
                                } else if (resp.data.code == 200) {
                                    props.closeModal("update");
                                }
                                setState({});
                            //  props.closeModal();
                            });
                        } else {
                            props.sessionTimeOutCheck(true);
                            setLoading(false);
                            props.setLoading(false);
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function sendData(statess) {
            return _ref.apply(this, arguments);
        };
    }();
    var editmodal = function() {
        props.closeModal();
        document.body.style.overflow = "unset";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (demandEdit_module_default()).editModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (demandEdit_module_default()).modalBox,
            ref: modalRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (demandEdit_module_default()).modalHeader,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (demandEdit_module_default()).content,
                        children: field_title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (demandEdit_module_default()).modalBody,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(basicForm["default"], {
                        data: field_demand_edit_new_row_detail,
                        sendFormValues: recievedFormValues,
                        getFormValues: getFormValues,
                        emptyFormValues: emptyFormValues,
                        formType: "demand",
                        params: "demandModal",
                        editState: state,
                        demandEditData: props.demandEditData,
                        setGetFormValues: setGetFormValues
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (demandEdit_module_default()).ModalFooter,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (demandEdit_module_default()).combinedBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (demandEdit_module_default()).rowBtn,
                                onClick: function() {
                                    editmodal();
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (demandEdit_module_default()).exportListBtn,
                                onClick: submitDemandForm,
                                children: "Save Details"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var demandEditModal_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function demandEditModal_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var demandEditModal = ((0,es/* connect */.$j)(demandEditModal_mapStateToProps, demandEditModal_mapDispatchToProps)(ModalExample));

;// CONCATENATED MODULE: ./components/demandFilters/index.jsx







function demandFilters_index(props) {
    var camelize = function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    var initialFilterButtonState = {
        0: false,
        1: false,
        2: false,
        3: false
    };
    var ref = _sliced_to_array(React.useState(_object_spread_props(_object_spread({}, initialFilterButtonState), {
        0: true
    })), 2), filterButtonsState = ref[0], setFilterButtonState = ref[1];
    var ref1 = _sliced_to_array(React.useState({}), 2), filterState = ref1[0], setFilterState = ref1[1];
    var radioChange = function(e) {
        //console.log(filterState, "filterState")
        setFilterState(_object_spread_props(_object_spread({}, filterState), _define_property({}, e.target.name, e.target.value)));
    };
    var filterButtonClicked = function(index) {
        setFilterButtonState(_object_spread_props(_object_spread({}, initialFilterButtonState), _define_property({}, index, true)));
    };
    var applyFilter = function() {
        props.setState(filterState);
        props.setfilterActive(false);
    };
    //console.log(props.filterMobileData);  
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.mobileFiltersWrapper,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.head,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.title,
                        children: "Filters"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.clearFilters,
                        onClick: function() {
                            setFilterState({});
                        },
                        children: "Clear All Filters"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.body,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.left,
                        children: /*#__PURE__*/ _jsx("ul", {
                            children: props.filterMobileData.map(function(item, index) {
                                return /*#__PURE__*/ _jsx("li", {
                                    className: filterButtonsState[index] ? styles.active : null,
                                    onClick: function() {
                                        return filterButtonClicked(index);
                                    },
                                    children: item.field_label
                                });
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.right,
                        children: /*#__PURE__*/ _jsx("ul", {
                            children: props.filterMobileData.map(function(item, index) {
                                return filterButtonsState[index] ? /*#__PURE__*/ _jsx("ul", {
                                    onChange: radioChange,
                                    children: item.field_options.map(function(optionItem, optionIndex) {
                                        return /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsxs("label", {
                                                className: styles.radioWrapper,
                                                children: [
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "radio",
                                                        className: styles.radioBox,
                                                        value: optionItem,
                                                        name: camelize(item.field_label),
                                                        checked: optionItem == filterState[camelize(item.field_label)] ? true : false
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: styles.radioCheckmark
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: styles.subLabel,
                                                        children: optionItem
                                                    })
                                                ]
                                            })
                                        });
                                    })
                                }) : null;
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.foot,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.cancelBtn,
                        onClick: function() {
                            props.setFilterActive(false);
                        },
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.applyBtn,
                        onClick: applyFilter,
                        children: "Apply"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./styles/components/demandFilters.module.scss
var demandFilters_module = __webpack_require__(34910);
var demandFilters_module_default = /*#__PURE__*/__webpack_require__.n(demandFilters_module);
;// CONCATENATED MODULE: ./components/MobileFilters/index.jsx







function MobileFilters_index(props) {
    var camelize = function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    //console.log("filterMobile", props);
    delete props.previousState.offset;
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), relatedValues = ref[0], setRelatedValues = ref[1];
    react.useEffect(function() {
        //console.log(props.setMobileFilterRelatedInfo)
        setRelatedValues(props.mobileFilterRelatedInfo);
        setFilterState(props.previousState);
    }, []);
    react.useEffect(function() {
    //console.log(relatedValues, "RELATEDVALUES")
    }, [
        relatedValues
    ]);
    var initialFilterButtonState = {
        0: false,
        1: false,
        2: false,
        3: false
    };
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialFilterButtonState), {
        0: true
    })), 2), filterButtonsState = ref1[0], setFilterButtonState = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), filterState = ref2[0], setFilterState = ref2[1];
    var radioChange = function(e, haveRelated) {
        //console.log(haveRelated, "HAVErELATED")
        if (e.target.value == "None") {
            var newFilterState = filterState;
            var relatedValuesToChange = relatedValues;
            var extractGrandChildCheck = props.filterMobileData.filter(function(item) {
                return item.field_label == haveRelated;
            });
            // props.setLength(0)
            //console.log(filterState, "filterstate in radio change")
            if (extractGrandChildCheck.length > 0) {
                extractGrandChildCheck = extractGrandChildCheck[0];
                delete newFilterState[camelize(extractGrandChildCheck.field_related_dropdown)];
                delete relatedValuesToChange[extractGrandChildCheck.field_related_dropdown];
            }
            //console.log(filterState, "filterstate in after radio change")
            //console.log(haveRelated, "HAVErELATED")
            delete newFilterState[e.target.name];
            delete newFilterState[camelize(haveRelated)];
            //  delete newFilterState[]
            setFilterState((0,src_object_spread/* default */.Z)({}, newFilterState));
            delete relatedValuesToChange[haveRelated];
            setRelatedValues((0,src_object_spread/* default */.Z)({}, relatedValuesToChange));
        } else {
            if (haveRelated != "") {
                props.filterMobileData.map(function(item, index) {
                    if (item.field_label == haveRelated) {
                        //console.log(item.field_title, "itemsss", e.target.name)
                        //console.log(item.field_dropdown_option_component.filter((item) => item.field_title == e.target.value))
                        var selectedRelatedParent = item.field_dropdown_option_component.filter(function(item) {
                            return item.field_title == e.target.value;
                        });
                        //console.log(selectedRelatedParent, "selectedrelated", haveRelated)
                        setRelatedValues((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, relatedValues), (0,src_define_property/* default */.Z)({}, haveRelated, selectedRelatedParent[0].field_options)));
                    }
                });
            }
            setFilterState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, filterState), (0,src_define_property/* default */.Z)({}, e.target.name, e.target.value)));
        }
    };
    react.useEffect(function() {
    //console.log(filterState, "check123")
    }, [
        filterState
    ]);
    var filterButtonClicked = function(index) {
        //console.log('index--', index);
        setFilterButtonState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialFilterButtonState), (0,src_define_property/* default */.Z)({}, index, true)));
    };
    var applyFilter = function() {
        //console.log(filterState, "filterState")
        props.setState(filterState);
        props.setFilterActive(false);
        props.setMobileFilterRelatedInfo(relatedValues);
        var filterFlag = 0;
        for(var i in filterState){
            //console.log(filterState[i] , "filter state ki i")
            if (filterState[i] !== "" && filterState[i] !== undefined && filterState[i] !== null && i != "kfa") {
                //console.log(props.length, "yaich chaiyee")
                filterFlag = filterFlag + 1;
            //console.log("test");
            }
        // if((filterState[i]) == "None"){
        //   props.setLength(length - 1)
        //   console.log(" no test");
        // }
        }
        props.setLength(filterFlag);
    };
    //console.log(props.filterMobileData);  
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (demandFilters_module_default()).mobileFiltersWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (demandFilters_module_default()).head,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (demandFilters_module_default()).title,
                        children: "Filters"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (demandFilters_module_default()).clearFilters,
                        onClick: function() {
                            setFilterState({});
                            props.setLength(0);
                            setRelatedValues({});
                            props.setFilterOn(false);
                            props.setState(props.initialState);
                            props.setFilterActive(false);
                        },
                        children: "Clear All Filters"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (demandFilters_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (demandFilters_module_default()).left,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: props.filterMobileData.map(function(item, index) {
                                if (item.field_input_type == "Related Dropdown" && relatedValues[item.field_label] == null) {
                                    return null;
                                } else {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: filterButtonsState[index] ? (demandFilters_module_default()).active : null,
                                        onClick: function() {
                                            return filterButtonClicked(index);
                                        },
                                        children: item.field_label
                                    });
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (demandFilters_module_default()).right,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: props.filterMobileData.map(function(item, index) {
                                return filterButtonsState[index] ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    onChange: function(e) {
                                        return radioChange(e, item.field_related_dropdown);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (demandFilters_module_default()).radioWrapper,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "radio",
                                                        className: (demandFilters_module_default()).radioBox,
                                                        value: "None",
                                                        name: camelize(item.field_label),
                                                        checked: filterState[camelize(item.field_label)] == undefined ? true : false
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (demandFilters_module_default()).radioCheckmark
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (demandFilters_module_default()).subLabel,
                                                        children: "None"
                                                    })
                                                ]
                                            })
                                        }),
                                        item.field_input_type == "Related Dropdown" ? relatedValues[item.field_label].map(function(optionItem, optionIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (demandFilters_module_default()).radioWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "radio",
                                                            className: (demandFilters_module_default()).radioBox,
                                                            value: optionItem,
                                                            name: camelize(item.field_label),
                                                            checked: optionItem == filterState[camelize(item.field_label)] ? true : false
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (demandFilters_module_default()).radioCheckmark
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (demandFilters_module_default()).subLabel,
                                                            children: optionItem
                                                        })
                                                    ]
                                                })
                                            });
                                        }) : item.field_options.map(function(optionItem, optionIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (demandFilters_module_default()).radioWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "radio",
                                                            className: (demandFilters_module_default()).radioBox,
                                                            value: optionItem,
                                                            name: camelize(item.field_label),
                                                            checked: optionItem == filterState[camelize(item.field_label)] ? true : false
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (demandFilters_module_default()).radioCheckmark
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (demandFilters_module_default()).subLabel,
                                                            children: optionItem
                                                        })
                                                    ]
                                                })
                                            });
                                        })
                                    ]
                                }) : null;
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (demandFilters_module_default()).foot,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (demandFilters_module_default()).cancelBtn,
                        onClick: function() {
                            props.setFilterActive(false);
                        },
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (demandFilters_module_default()).applyBtn,
                        onClick: applyFilter,
                        children: "Apply"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./styles/components/pagination.module.scss
var pagination_module = __webpack_require__(98286);
var pagination_module_default = /*#__PURE__*/__webpack_require__.n(pagination_module);
;// CONCATENATED MODULE: ./components/PaginationDemand/index.js





var PaginationDemand_index = function(props) {
    var ref = (0,react.useState)([]), allPages = ref[0], setAllPages = ref[1];
    var ref1 = (0,react.useState)(1), first = ref1[0], setFirst = ref1[1];
    var ref2 = (0,react.useState)(2), second = ref2[0], setSecond = ref2[1];
    var ref3 = (0,react.useState)(true), forward = ref3[0], setForward = ref3[1];
    var ref4 = (0,react.useState)(false), backward = ref4[0], setBackward = ref4[1];
    react.useEffect(function() {
        var pages = [];
        //console.log(props.totalLength, "totalLength kitni hai")
        for(var i = 1; i <= Math.ceil(props.totalLength / 5); i++){
            pages.push(i);
        }
        //console.log(pages)
        setAllPages((0,src_to_consumable_array/* default */.Z)(pages));
        if (props.paginationNum == 1) {
            setFirst(1);
            setSecond(2);
            setBackward(false);
            setForward(true);
        }
    }, [
        props.totalLength
    ]);
    var pageNumClicked = function(pageNum) {
        props.setPaginationNum(pageNum);
        if (pageNum == Math.ceil(props.totalLength / 5)) {
            setForward(false);
            setBackward(true);
            setFirst(pageNum - 1);
            setSecond(pageNum);
        } else if (pageNum == 1) {
            setBackward(false);
            setForward(true);
            setFirst(1);
            setSecond(2);
        }
    };
    var nextPage = function() {
        if (props.paginationNum < Math.ceil(props.totalLength / 5)) {
            if (props.paginationNum == 2) {
                setBackward(true);
            }
            if (props.paginationNum >= Math.ceil(props.totalLength / 5) - 2) {
                setForward(false);
            //    setFirst(1)
            //   setSecond(Math.ceil(props.totalLength/5)-1)
            } else {
                setForward(true);
            }
            if (props.paginationNum == second) {
                setFirst(props.paginationNum + 1);
                setSecond(props.paginationNum + 2);
            }
            props.setPaginationNum(props.paginationNum + 1);
        }
    };
    var previousPage = function() {
        if (props.paginationNum > 1) {
            if (props.paginationNum == Math.ceil(props.totalLength / 5) - 1) {
                setForward(true);
            }
            if (props.paginationNum <= 3) {
                setBackward(false);
            } else {
                setBackward(true);
            }
            // if (second ==  Math.ceil(props.totalLength/5)-2){
            //     setForward(false)
            //     setFirst(1)
            //     setSecond(Math.ceil(props.totalLength/5)-1)
            //     props.setPaginationNum(props.paginationNum-1)
            // }
            if (props.paginationNum != 1) {
                if (props.paginationNum == first) {
                    setFirst(props.paginationNum - 2);
                    setSecond(props.paginationNum - 1);
                }
            }
            props.setPaginationNum(props.paginationNum - 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (pagination_module_default()).paginationOuter,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (pagination_module_default()).leftArrow,
                    onClick: previousPage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/svg/paginationarrow.png"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (pagination_module_default()).main,
                    children: allPages.map(function(item, index) {
                        if (item == 1 || item == allPages[allPages.length - 1]) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    forward && item == allPages[allPages.length - 1] && props.totalLength > 10 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "    .    .    ."
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "".concat((pagination_module_default()).number, " ").concat(props.paginationNum == item ? (pagination_module_default()).active : null),
                                        onClick: function() {
                                            return pageNumClicked(item);
                                        },
                                        children: item
                                    }, index),
                                    backward && item == 1 && props.totalLength > 10 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "    .    .    ."
                                    }) : null
                                ]
                            });
                        } else if (item == first || item == second) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((pagination_module_default()).number, " ").concat(props.paginationNum == item ? (pagination_module_default()).active : null),
                                    onClick: function() {
                                        return pageNumClicked(item);
                                    },
                                    children: item
                                }, index)
                            });
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (pagination_module_default()).rightArrow,
                    onClick: nextPage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/svg/paginationarrow.png"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var PaginationDemand = (PaginationDemand_index);

;// CONCATENATED MODULE: ./components/demandData/index.jsx


























function demandData_index(props) {
    var camelize = //  const clusterData = props.globalData.cluster_main_component[0];
    //  const leadPlatformData = props.globalData.lead_platform_main_component[0];
    function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    //console.log("props --- demand data  ----", props);
    var ref = (0,react.useState)(false), noImage = ref[0], setNoImage = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref1[0], setSuccessModal = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState("Demand Updated Successfully!"), 2), message = ref2[0], setMessage = ref2[1];
    var ref3 = (0,react.useState)(false), loader = ref3[0], setloader = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), searchState = ref4[0], setSearchState = ref4[1];
    var router = (0,next_router.useRouter)();
    var ref5 = (0,react.useState)(null), authData = ref5[0], setAuthData = ref5[1];
    var ref6 = (0,react.useState)(0), length = ref6[0], setLength = ref6[1];
    var ref7 = (0,react.useState)(1), paginationNum = ref7[0], setPaginationNum = ref7[1];
    var ref8 = (0,react.useState)(0), botCount = ref8[0], setBotCount = ref8[1];
    var ref9 = (0,react.useState)(0), filterBotCount = ref9[0], setFilterBotCount = ref9[1];
    var ref10 = (0,react.useState)(1), filterPaginationNum = ref10[0], setFilterPaginationNum = ref10[1];
    var ref11 = (0,react.useState)(true), first = ref11[0], setFirst = ref11[1];
    var isTabletOrMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 768px)"
    });
    react.useEffect(function() {
        try {
            var auth = JSON.parse(localStorage.getItem("auth")).data;
            setAuthData(auth);
        } catch (e) {
            console.log(e);
        }
    }, []);
    var data = props.data.content;
    var demandFormData = props.demandFormData.content;
    //console.log(demandFormData, "demandFormData");
    var ref12 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), renderForm = ref12[0], setRenderForm = ref12[1];
    var ref13 = (0,react.useState)(false), loading = ref13[0], setLoading = ref13[1];
    var initialState = {};
    var dropDownsInitialStates = {};
    data.field_demand_table_filters.map(function(item) {
        initialState[camelize(item.field_label)] = "";
        dropDownsInitialStates[camelize(item.field_label)] = false;
    });
    data.field_demand_table_filters.map(function(item) {
        item.value = camelize(item.field_label);
    });
    var ref14 = (0,react.useState)(initialState), state = ref14[0], setState = ref14[1];
    var ref15 = (0,src_sliced_to_array/* default */.Z)(react.useState(dropDownsInitialStates), 2), dropDownState = ref15[0], setDropdownState = ref15[1];
    var handleDropDown = function(item) {
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownsInitialStates), (0,src_define_property/* default */.Z)({}, item, !dropDownState[item])));
    };
    var gotDropDownValue = function(value, dropdownParent) {
        setDropdownState(dropDownsInitialStates);
        setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, dropdownParent, value)));
    };
    var ref16 = (0,react.useState)(false), modalactive = ref16[0], setmodalactive = ref16[1];
    var ref17 = (0,react.useState)(false), filterActive = ref17[0], setFilterActive = ref17[1];
    var ref18 = (0,react.useState)([]), demandData = ref18[0], setDemandData = ref18[1];
    var ref19 = (0,react.useState)([]), filteredDemandData = ref19[0], setFilteredDemandData = ref19[1];
    var ref20 = (0,react.useState)(null), editIndex = ref20[0], setEditIndex = ref20[1];
    var ref21 = (0,react.useState)(false), newDemand = ref21[0], setNewDemand = ref21[1];
    var ref22 = (0,react.useState)({}), mobileFilterRelatedInfo = ref22[0], setMobileFilterRelatedInfo = ref22[1];
    var ref23 = (0,react.useState)(0), offset = ref23[0], setOffset = ref23[1];
    var ref24 = (0,react.useState)(0), filterOffset = ref24[0], setFilterOffset = ref24[1];
    var ref25 = (0,react.useState)(false), filterOn = ref25[0], setFilterOn = ref25[1];
    var editModal = function(editIndex) {
        //console.log("edit modal  ---  index", editIndex);
        //console.log("demand data ---", demandData);
        if (editIndex != -1) {
            setEditIndex(editIndex);
        } else {
            setNewDemand(true);
        }
        var modal = !modalactive;
        setmodalactive(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var closeModal = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(value) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(value == undefined)) return [
                            3,
                            1
                        ];
                        setmodalactive(false);
                        setNewDemand(false);
                        return [
                            2
                        ];
                    case 1:
                        if (!(value == "create")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getAllDemands()
                        ];
                    case 2:
                        _state.sent();
                        setmodalactive(false);
                        setNewDemand(false);
                        setMessage("Demand Created Sucessfully");
                        setSuccessModal(true);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        if (!(value == "update")) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            getAllDemands()
                        ];
                    case 4:
                        _state.sent();
                        setmodalactive(false);
                        setNewDemand(false);
                        setMessage("Demand Updated SucessFully");
                        setSuccessModal(true);
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function closeModal(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var filterClick = function() {
        setFilterActive(true);
    };
    var getAllDemands = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var auth, authCheck, expiryStatus, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        auth = _state.sent();
                        setLoading(true);
                        setloader(true);
                        props.setLoading(true);
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 2:
                        authCheck = _state.sent();
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 3:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            axios_default()({
                                method: "get",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/demands/getDemand"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                params: {
                                    offset: offset
                                }
                            }).then(function(resp) {
                                props.setLoading(false);
                                if (resp.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                    setLoading(false);
                                    setloader(false);
                                    props.setLoading(false);
                                } else if (resp.data.code == 200) {
                                    setFirst(false);
                                    setloader(false);
                                    setBotCount(resp.data.data.count);
                                    resp.data.data.rows.map(function(item, index) {
                                        item.sessionDate = convertToDDMMYYYY(item.sessionDate.split("T")[0]);
                                        return item;
                                    });
                                    //console.log(resp.data.data, "response demand api");
                                    setDemandData(resp.data.data.rows);
                                    setFilteredDemandData(resp.data.data.rows);
                                    if (resp.data.data.rows.length == 0) {
                                        setNoImage(true);
                                    }
                                    setLoading(false);
                                }
                            });
                        } else {
                            props.sessionTimeOutCheck(true);
                            setLoading(false);
                            setloader(false);
                            props.setLoading(false);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function getAllDemands() {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        setLoading(true);
        getAllDemands();
    }, []);
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getAllDemands()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        props.getUpdatedDemands
    ]);
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!first) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getAllDemands()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        offset
    ]);
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!first) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getFilterDemands()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        filterOffset
    ]);
    react.useEffect(function() {
        paginationNum >= 1 && setOffset((paginationNum - 1) * 5);
    }, [
        paginationNum
    ]);
    react.useEffect(function() {
        //console.log(filterPaginationNum, "pagination", filterOffset);
        filterPaginationNum >= 1 && setFilterOffset((filterPaginationNum - 1) * 5);
    }, [
        filterPaginationNum
    ]);
    var getDemandsExcel = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var Filters, i, authCheck, expiryStatus, auth, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        Filters = {};
                        for(var i in state){
                            if (state[i].length > 0) {
                                Filters[i] = state[i];
                            }
                        }
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 2:
                        auth = _state.sent();
                        axios_default()({
                            method: "get",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/demands/getDemandFile"),
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            },
                            params: Filters
                        }).then(function(resp) {
                            if (resp.data.code == 403) {
                                localStorage.removeItem("auth");
                                sessionStorage.clear();
                                props.sessionTimeOutCheck(true);
                                setLoading(false);
                                setloader(false);
                                props.setLoading(false);
                            } else if (resp.data.code == 200) {
                                //console.log(resp.data, "demandexcelresponse");
                                window.open(resp.data.data);
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        props.sessionTimeOutCheck(true);
                        setLoading(false);
                        setloader(false);
                        props.setLoading(false);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function getDemandsExcel() {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            getFilterDemands();
            return [
                2
            ];
        });
    }), [
        state
    ]);
    var getFilterDemands = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var auth, Filters, i, authCheck, expiryStatus, auth1, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        auth = _state.sent();
                        Filters = {};
                        for(var i in state){
                            if (state[i].length > 0) {
                                Filters[i] = state[i];
                            }
                        }
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 3:
                        auth1 = _state.sent();
                        if (!(Filters && Object.keys(Filters).length === 0 && Filters.constructor === Object)) return [
                            3,
                            4
                        ];
                        // console.log("first", "first")
                        // setFilteredDemandData(demandData);
                        getAllDemands();
                        setFilterOn(false);
                        return [
                            3,
                            6
                        ];
                    case 4:
                        //console.log("second", "first")
                        setLoading(true);
                        Filters.offset = filterOffset;
                        setFilterOn(true);
                        //console.log("Filtersss", Filters);
                        return [
                            4,
                            axios_default()({
                                method: "get",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/demands/getDemand"),
                                params: Filters,
                                headers: {
                                    Authorization: "".concat(auth1.accessToken, "|").concat(auth1.email)
                                }
                            }).then(function(resp) {
                                setLoading(false);
                                if (resp.data.code == 200) {
                                    //console.log("fliter data  ---", resp.data);
                                    setFilterBotCount(resp.data.data.count);
                                    resp.data.data.rows.map(function(item, index) {
                                        item.sessionDate = convertToDDMMYYYY(item.sessionDate.split("T")[0]);
                                        return item;
                                    });
                                    //  setDemandData(resp.data.data)
                                    setFilteredDemandData(resp.data.data.rows);
                                    if (resp.data.data.rows.length == 0) {
                                        setNoImage(true);
                                    }
                                } else if (resp.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                    props.setLoading(false);
                                    setLoading(false);
                                    setloader(false);
                                }
                            })
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        props.sessionTimeOutCheck(true);
                        setLoading(false);
                        setloader(false);
                        props.setLoading(false);
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        e = _state.sent();
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function getFilterDemands() {
            return _ref.apply(this, arguments);
        };
    }();
    var searchInTable = function(e) {
        setSearchState(e.target.value);
        //console.log("StateDemandd", state);
        if (e.target.value.length >= 3) {
            var stateFilter = state;
            stateFilter.search = e.target.value;
            setState((0,src_object_spread/* default */.Z)({}, stateFilter));
            setFilterOffset(0);
            setPaginationNum(1);
        } else if (e.target.value.length == 0) {
            var stateFilter1 = state;
            delete stateFilter1.search;
            setState((0,src_object_spread/* default */.Z)({}, stateFilter1));
        }
    // else {
    //   let stateFilter = state;
    //   if (Object.keys(stateFilter).includes('search')) {
    //     delete stateFilter.search;
    //   };
    //   console.log('State Filter', stateFilter);
    //   setState({
    //     ...stateFilter
    //   })
    //   setFilterOffset(0);
    //   setPaginationNum(1);
    // }
    };
    var convertToDDMMYYYY = function(date, Z) {
        //console.log(date, "this is what I'm getting", Z);
        var year = date.slice(0, 4);
        var month = date.slice(5, 7);
        var day = date.slice(8, 10);
        var newDate = day + "-" + month + "-" + year;
        return newDate;
    };
    var arrayToMap = get_default()(props, "data.content.field_table_labels", []).slice(0, get_default()(props, "data.content.field_table_labels", []).length - 1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((demandData_module_default()).demandDataWrapper, " container"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (demandData_module_default()).demandActionHead,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (demandData_module_default()).top,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (demandData_module_default()).left,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (demandData_module_default()).search,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                            name: "searchGrayIcon",
                                            className: (demandData_module_default()).searchIcon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            placeholder: get_default()(props, "data.content.field_search_placeholder", ""),
                                            onChange: searchInTable,
                                            value: searchState != "" ? searchState : ""
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (demandData_module_default()).right,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (demandData_module_default()).combinedBtn,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (demandData_module_default()).rowBtn,
                                            onClick: function() {
                                                return editModal(-1);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                    name: "plusIcon",
                                                    className: (demandData_module_default()).plusIcon
                                                }),
                                                get_default()(data, "field_options[0]", "")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (demandData_module_default()).rowBtn2,
                                            onClick: function() {
                                                setState((0,src_object_spread/* default */.Z)({}, initialState));
                                                setSearchState("");
                                                setFilterOn(false);
                                                setPaginationNum(1);
                                            },
                                            children: get_default()(props, "fieldOptions[2]", "")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (demandData_module_default()).exportListBtn,
                                            onClick: getDemandsExcel,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                    name: "uploadicon",
                                                    className: (demandData_module_default()).uploadIcon
                                                }),
                                                get_default()(data, "field_options[1]", "")
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (demandData_module_default()).bottom,
                        children: data.field_demand_table_filters.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (demandData_module_default()).inputGroup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                " ",
                                                item.field_form_field_title
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "".concat((demandData_module_default()).input),
                                        onClick: function() {
                                            handleDropDown(camelize(item.field_label));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (demandData_module_default()).left,
                                                children: state[camelize(item.field_label)] == "" ? item.field_input : state[camelize(item.field_label)]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (demandData_module_default()).right,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                    name: "chevron",
                                                    className: (demandData_module_default()).chevron
                                                })
                                            })
                                        ]
                                    }),
                                    dropDownState[item.value] == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (demandData_module_default()).dropi,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                            dropdownParent: [
                                                item.value
                                            ],
                                            values: item.field_options,
                                            getDropdownValue: gotDropDownValue,
                                            params: "demandFilters",
                                            closeAllDropdowns: function() {
                                                return setDropdownState(dropDownsInitialStates);
                                            }
                                        })
                                    }) : null
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (demandData_module_default()).demandDataBody,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (demandData_module_default()).scrollableTable,
                        children: filteredDemandData.length != 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                        children: arrayToMap.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: item
                                                })
                                            });
                                        })
                                    })
                                }),
                                props.loading || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (demandData_module_default()).loadContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                    children: filteredDemandData != null ? filteredDemandData.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            id: "tableDesktopRow".concat(index),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: filterOn ? (filterPaginationNum - 1) * 5 + index + 1 : botCount - item.rowKey + 1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: item.cluster
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: item.subArea
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: item.product
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            width: "200px"
                                                        },
                                                        children: item.mcoLeadPlatform
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: item.targetPitch
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: item.sessionDate
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: item.el
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: item.currentStatus
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: item.convertedDemand
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: item.productOwner
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            width: "250px"
                                                        },
                                                        children: [
                                                            " ",
                                                            item.commentsFromStakeHolder
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, index);
                                    }) : null
                                })
                            ]
                        }) : noImage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (demandData_module_default()).noresults,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(_.get(props.noimageUrl, "field_no_result_image[0].file_url", ""))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    className: (demandData_module_default()).head,
                                    children: [
                                        " ",
                                        _.get(props.noimageUrl, "field_title", "")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (demandData_module_default()).content,
                                    dangerouslySetInnerHTML: {
                                        __html: _.get(props.noimageUrl, "field_details", "")
                                    }
                                })
                            ]
                        }) : null
                    }),
                    filteredDemandData.length != 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (demandData_module_default()).fixedTable,
                        children: props.loading || loading ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: get_default()(props, "data.content.field_table_labels[12]", "")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                    children: filteredDemandData != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: filteredDemandData.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                id: "actionDesktopRow".concat(index),
                                                className: (demandData_module_default()).actionDesktop,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    onClick: function() {
                                                        return editModal(item.rowKey);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                            name: "pencilDark",
                                                            className: (demandData_module_default()).editInactive
                                                        })
                                                    })
                                                })
                                            });
                                        })
                                    }) : null
                                })
                            ]
                        })
                    }) : null,
                    modalactive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(demandEditModal, {
                        demandFormData: demandFormData,
                        closeModal: closeModal,
                        demandEditData: newDemand == true ? null : filteredDemandData.filter(function(item) {
                            if (item.rowKey == editIndex) return item;
                        })[0],
                        globalData: props.globalData,
                        setLoading: setLoading,
                        setmodalactive: setmodalactive,
                        setState: setState,
                        initialState: initialState,
                        setSearchState: setSearchState,
                        setFilterOn: setFilterOn,
                        setPaginationNum: setPaginationNum
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (demandData_module_default()).mobileFilterBtn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (demandData_module_default()).btn,
                    onClick: filterClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                            name: "filters",
                            className: (demandData_module_default()).filterIcon
                        }),
                        "Filters",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                            className: (demandData_module_default()).filterCount,
                            children: length > 4 ? 4 : length
                        })
                    ]
                })
            }),
            filteredDemandData.length != 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (demandData_module_default()).pagination,
                children: filterOn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationDemand, {
                    totalLength: filterBotCount,
                    paginationNum: filterPaginationNum,
                    setPaginationNum: setFilterPaginationNum
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationDemand, {
                    totalLength: botCount,
                    paginationNum: paginationNum,
                    setPaginationNum: setPaginationNum
                })
            }) : null,
            filterActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilters_index, {
                filterMobileData: data.field_demand_table_filters,
                setState: setState,
                setFilterActive: setFilterActive,
                previousState: state,
                mobileFilterRelatedInfo: mobileFilterRelatedInfo,
                setMobileFilterRelatedInfo: setMobileFilterRelatedInfo,
                setLength: setLength,
                length: length,
                setFilterOn: setFilterOn,
                initialState: initialState
            }) : null,
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: setSuccessModal,
                title: "Edit Demand",
                message: message
            }) : null
        ]
    });
}
var demandData_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function demandData_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var components_demandData = ((0,es/* connect */.$j)(demandData_mapStateToProps, demandData_mapDispatchToProps)(demandData_index));

;// CONCATENATED MODULE: ./components/Pages/demandPage/index.jsx

















function demandPage_index(props) {
    //props.data.data.field_basic_content_component[2].component.content.field_no_result_image[0].file_url
    // console.log("demand page props no image---", props.data[2].component.content);
    //console.log("no result image  ---", props.data.data.field_basic_content_component[2].component.content.field_no_result_image[0].file_url);
    //console.log("demand data", props.data);
    var ref = (0,react.useState)(props.data[2].component.content), noImageUrl = ref[0], setNoImageUrl = ref[1];
    var ref1 = (0,react.useState)(false), loader = ref1[0], setloader = ref1[1];
    var ref2 = (0,react.useState)(null), authData = ref2[0], setAuthData = ref2[1];
    var ref3 = (0,react.useState)(false), successModal = ref3[0], setSuccessModal = ref3[1];
    var ref4 = (0,react.useState)(false), fail = ref4[0], setFail = ref4[1];
    var ref5 = (0,react.useState)("Demand created successfully!"), message = ref5[0], setMessage = ref5[1];
    react.useEffect(function() {
        try {
            var auth = JSON.parse(localStorage.getItem("auth")).data;
            //console.log("auth ----header", auth);
            setAuthData(auth);
        } catch (e) {
            console.log("eroor", e);
        }
    }, []);
    var demandData = props.data[0].component;
    var demandFormData = props.data[1].component;
    var ref6 = (0,react.useState)(null), file = ref6[0], setFile = ref6[1];
    var ref7 = (0,react.useState)(null), fileName = ref7[0], setFileName = ref7[1];
    var ref8 = (0,react.useState)(false), showFileName = ref8[0], setShowFileName = ref8[1];
    var ref9 = (0,react.useState)(false), getUpdatedDemands = ref9[0], setGetUpdatedDemands = ref9[1];
    var ref10 = (0,react.useState)(false), loading = ref10[0], setLoading = ref10[1];
    var ref11 = (0,react.useState)(false), fileError = ref11[0], setError = ref11[1];
    var uploadFile = function(file, name) {
        setFile(file);
        setError(false);
        setShowFileName(true);
    };
    var uploadButtonClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var formData, authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        formData = new FormData();
                        if (file == null) {
                            setError(true);
                            return [
                                2
                            ];
                        } else {
                            setError(false);
                        }
                        formData.append("demandFile", file);
                        setLoading(true);
                        setloader(true);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            3
                        ];
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        setAuthData(auth);
                        return [
                            4,
                            axios_default()({
                                method: "post",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/demands/createDemandExcel"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: formData
                            }).then(function(resp) {
                                setloader(false);
                                if (resp.data.code == 200) {
                                    setMessage("File Uploaded Sucessfully");
                                    setSuccessModal(true);
                                    //console.log("response", resp);
                                    setShowFileName(false);
                                    setGetUpdatedDemands(!getUpdatedDemands);
                                    setLoading(false);
                                    setFail(false);
                                } else if (resp.data.code == 403) {
                                    setloader(false);
                                    setLoading(false);
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                } else if (resp.data.code == 400) {
                                    setShowFileName(false);
                                    setMessage(resp.data.message);
                                    setSuccessModal(true);
                                    setLoading(false);
                                    setFail(true);
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoading(false);
                        setloader(false);
                        props.sessionTimeOutCheck(true);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    // to dowload sample files
    var downloadSampleFile = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var demandFileResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios_default()({
                                method: "GET",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/demands/demandSampleFile"),
                                headers: {
                                    Authorization: "".concat(authData.accessToken, "|").concat(authData.email)
                                }
                            })
                        ];
                    case 1:
                        demandFileResponse = _state.sent();
                        //console.log("respDemand--", demandFileResponse.data.data);
                        //demandFileResponse.data.data
                        if (demandFileResponse.data.code == 403) {
                            setLoading(false);
                            setloader(false);
                            props.sessionTimeOutCheck(true);
                        } else {
                            window.open(demandFileResponse.data.data);
                        }
                        return [
                            2
                        ];
                }
            });
        //window.open(`${endpoints.fetchBlobUrl}/demandFileSample%20(1).xlsx`);
        });
        return function downloadSampleFile() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (demand_module_default()).demandContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((demand_module_default()).uploadBtnWrapper, " container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (demand_module_default()).uploadFileContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_uploadFile/* default */.Z, {
                                type: "demand",
                                uploadFile: uploadFile,
                                uploaded: showFileName,
                                fileType: ".xlsx",
                                value: "demandDocument"
                            }),
                            fileError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    color: "red",
                                    fontSize: "10px"
                                },
                                children: "Select Some File"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (demand_module_default()).actionBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (demand_module_default()).iconUpload,
                            onClick: uploadButtonClick,
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                    name: "uploadicon",
                                    className: (demand_module_default()).uploadIcon
                                }),
                                get_default()(props, "data[0].component.content.field_upload_file_button_text[0]", "")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (demand_module_default()).downloadBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (demand_module_default()).sampleUpload,
                            onClick: downloadSampleFile,
                            children: [
                                " ",
                                get_default()(props, "data[0].component.content.field_upload_file_button_text[1]", "")
                            ]
                        })
                    })
                ]
            }),
            loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_demandData, {
                data: demandData,
                demandFormData: demandFormData,
                getUpdatedDemands: getUpdatedDemands,
                loading: loading,
                globalData: props.globalData,
                noimageUrl: noImageUrl,
                demandTableDruplData: get_default()(props, "data[0].component.content.field_demand_table_filters", []),
                fieldOptions: get_default()(props, "data[0].component.content.field_options", []),
                fieldRowDetails: get_default()(props, "data[0].component.content.field_table_labels", []),
                setLoading: setLoading
            }),
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: setSuccessModal,
                title: "Create Demand",
                message: message,
                fail: fail,
                setFail: setFail
            }) : null
        ]
    });
}
var demandPage_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function demandPage_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var demandPage = ((0,es/* connect */.$j)(demandPage_mapStateToProps, demandPage_mapDispatchToProps)(demandPage_index));

// EXTERNAL MODULE: ./components/botForm/index.jsx + 2 modules
var botForm = __webpack_require__(77580);
// EXTERNAL MODULE: ./components/createBotStepper/index.jsx + 1 modules
var createBotStepper = __webpack_require__(93034);
// EXTERNAL MODULE: ./styles/pages/createBotFinal.module.scss
var createBotFinal_module = __webpack_require__(5361);
var createBotFinal_module_default = /*#__PURE__*/__webpack_require__.n(createBotFinal_module);
// EXTERNAL MODULE: ./styles/pages/createBot.module.scss
var createBot_module = __webpack_require__(96633);
var createBot_module_default = /*#__PURE__*/__webpack_require__.n(createBot_module);
// EXTERNAL MODULE: ./redux/createBot/actionTypes.js
var createBot_actionTypes = __webpack_require__(34300);
;// CONCATENATED MODULE: ./redux/createBot/actions.js

var firstBotCreateAction = function(data) {
    return {
        type: createBot_actionTypes/* firstBotCreateActionType */.g,
        payload: data
    };
};

;// CONCATENATED MODULE: ./data/createBotForm.js
var allBotStates = {
    leadPlatform: "Supply Chain",
    area: "CD Excellence",
    subArea: "Monthly Reporting",
    cluster: "Europe",
    mco: "Benelux",
    country: "Netherlands",
    primaryApplication: "SAP",
    applications: "SAP, Excel, Outlook, SP",
    toolUsed: "BP",
    deliveryModel: "Model 1",
    status: "Ideas",
    processID: "ULAFLMLMasterData",
    processName: "Master Data Anomaly Detection",
    processCriticality: "Critical Process",
    processDescription: "Bot extracts Promo Guidelines files for UK & Ireland, consolidates in master sheet and remove duplicates along with entering source file reference details and send it to UDL via Blob storage.",
    kfa: false,
    requestType: "New Request",
    requesterEmailID: "Shehara.Gamage@unilever.com",
    engagementLead: "kunal.kakkar@unilever.com",
    initiatedBy: "GEO IT",
    dataClassification: "Internal",
    buildName: "5024-ULBPFINMECU010PPVMonitoring_SQL;5024-ULBPFINMECU010PPVMonitoring_SAP_Master;5024-ULBPFINMECU010PPVMontoring_Email Notification;5024-ULBPFINMECU010PPVMonitoring_SAP_Base_Standard;5024-ULBPFINMECU010PPVMonitoring_SAP_Base_Custom",
    supportStatus: "Support Type",
    technology: "Ai",
    dateLogged: "2021-02-01",
    sopReceivedDate: "2021-02-01",
    tCode: "T97",
    hoursSavedYearly: "10",
    businessOwnerEmailID: "Shehara.Gamage@unilever.com",
    createdBy: "David Raj",
    numberOfRunsInAMonth: 10,
    averageTime: 50,
    sopDocument: "some documnets",
    parentBotID: "457",
    dateOfStatusChanged: "2021-02-01",
    commentsForStatusChanged: "Some Changes",
    kfaTransactional: false,
    kfaInformational: false,
    kfaIuc: false,
    remarks: "Good Remarks",
    pddDocument: "can be empty",
    pddApprovalDocument: "can be empty",
    sddDocument: "can be empty",
    qsgDocument: "can be empty",
    odiDocument: "can be empty",
    brdDocument: "can be empty",
    costApprovalDocument: "can be empty",
    explicitLandscapeApplicationOwnerApprovalDocument: "can be empty",
    explicitGPMApprovalSupplyChainFinanceDocument: "can be empty",
    explicitGFCFApprovalDocument: "can be empty",
    devQualityCredentialsAvailableDocument: "can be empty",
    infosecApprovalDocument: "can be empty",
    dAReviewSignOffDocument: "can be empty",
    testDataAvailableForDevelopmentDocument: "can be empty",
    requestRaisedForProductionCredentialsDocument: "can be empty",
    internalTestingCompletedDocument: "can be empty",
    peerReviewSignOffDocument: "can be empty",
    daReviewSecondSignOffDocument: "can be empty",
    bpReleaseSignOffFromDaDocument: "can be empty",
    uatScriptsWithResultsDocument: "can be empty",
    uatSignOffDocument: "can be empty",
    releaseManagerSignOffDocument: "can be empty",
    gateFormDocument: "can be empty",
    peerReviewchecklistDocument: "can be empty",
    qaSignOffDocument: "can be empty",
    walkthroughVideo: "can be empty",
    ktVideo: "can be empty",
    costApprovalDate: "2021-02-01",
    pddSignOffDate: "2021-02-01",
    testStartDate: "2021-02-01",
    goLiveDate: "2021-02-01",
    bauDate: "2021-02-01",
    lastModifiedDate: "2021-02-01",
    landscapeApprover: "ddddd",
    landscapeApproval: false,
    controlImpacted: "node ",
    nameofControlImpacted: "node",
    iuc: false,
    approvedBy: "node",
    approvalDate: "2021-02-01",
    infosecApprover: "node",
    infosecApproval: false
};
var imageBaseURL = "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/product/";

// EXTERNAL MODULE: ./components/dynamicSuccessModal/index.js
var dynamicSuccessModal = __webpack_require__(24923);
// EXTERNAL MODULE: ./components/botDetailEndUser/index.jsx + 2 modules
var botDetailEndUser = __webpack_require__(21824);
// EXTERNAL MODULE: ./components/Pages/createBotFormss/gdt_data.js
var gdt_data = __webpack_require__(97105);
;// CONCATENATED MODULE: ./components/Pages/createBotFormss/index.js


























var createBotFormss_index = function(props) {
    //console.log("props dekh",props)
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref[0], setSuccessModal = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState("Bot created successfully!"), 2), message = ref1[0], setMessage = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), loading = ref2[0], setloading = ref2[1];
    var firstPage = props.data[0].component.content.field_new_bot_details[0];
    var secondPage = props.data[0].component.content.field_new_bot_details[1];
    var thirdPage = props.data[0].component.content.field_new_bot_details[2];
    var fourthPage = props.data[0].component.content.field_new_bot_details[3];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), renderFirstBot = ref3[0], setRenderFirstBot = ref3[1];
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var isDevEnvironment = utility_endpoints/* default.environment */.ZP.environment === "dev" ? true : false;
    var productData = gdt_data/* product */.O7;
    var familyData = gdt_data/* family */.NK;
    var domainData = gdt_data/* domain */.nw;
    var leadPlatformData = isDevEnvironment ? props.globalData.lead_platform_main_component[3] : props.globalData.lead_platform_main_component[1];
    var areaData = isDevEnvironment ? props.globalData.lead_platform_main_component[4] : props.globalData.lead_platform_main_component[4];
    var subAreaData = isDevEnvironment ? props.globalData.lead_platform_main_component[5] : props.globalData.lead_platform_main_component[3];
    var clusterData = props.globalData.cluster_main_component[0];
    var mcoData = props.globalData.cluster_main_component[1];
    var countryData = props.globalData.cluster_main_component[2];
    react.useEffect(function() {
        firstPage.field_bot_form_steps.splice(1, 0, productData);
        firstPage.field_bot_form_steps.splice(1, 0, familyData);
        firstPage.field_bot_form_steps.splice(1, 0, domainData);
        firstPage.field_bot_form_steps.splice(4, 0, subAreaData);
        firstPage.field_bot_form_steps.splice(4, 0, areaData);
        firstPage.field_bot_form_steps.splice(4, 0, leadPlatformData);
        firstPage.field_bot_form_steps.splice(7, 0, countryData);
        firstPage.field_bot_form_steps.splice(7, 0, mcoData);
        firstPage.field_bot_form_steps.splice(7, 0, clusterData);
        setRenderFirstBot(true);
    }, []);
    var useMe = {
        1: false,
        2: false,
        3: false,
        4: false
    };
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        1: true,
        2: false,
        3: false,
        4: false
    }), 2), botPages = ref4[0], setBotPages = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState(1), 2), pageNumber = ref5[0], setPageNumber = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), done = ref6[0], setDone = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), showPreview = ref7[0], setShowPreview = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), newlyCreatedBotID = ref8[0], setNewlyCreatedBotID = ref8[1];
    var ref9 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), businessOwnerModal = ref9[0], setBusinessOwnerModal = ref9[1];
    var nextBot = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(pageNum) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setBotPages((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, useMe), (0,src_define_property/* default */.Z)({}, pageNum, true)));
                setPageNumber(pageNum);
                window.scrollTo(0, 0);
                return [
                    2
                ];
            });
        });
        return function nextBot(pageNum) {
            return _ref.apply(this, arguments);
        };
    }();
    var saveInfoToRedux = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(state, pageNum) {
            var auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (pageNum == 1) {
                    if (!state.documentFolderName) {
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        state.documentFolderName = Date.now();
                        axios_default()({
                            method: "post",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/addFolderName"),
                            data: {
                                folderName: state.documentFolderName
                            },
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            }
                        }).then(function(res) {
                        //console.log(res)
                        });
                    }
                }
                // need to be removed
                // if(pageNum == 2){
                //   state.sopDocument="8456191154484498-img_1645186514_sopDocument.png"
                // }
                dispatch(firstBotCreateAction(state));
                return [
                    2
                ];
            });
        });
        return function saveInfoToRedux(state, pageNum) {
            return _ref.apply(this, arguments);
        };
    }();
    var allDone = function() {
        setShowPreview(true);
        window.scrollTo(0, 0);
    };
    var backToEdit = function() {
        setShowPreview(false);
        setBotPages((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, useMe), {
            4: true
        }));
    };
    var createTheBot = function() {
        setDone(true);
    };
    react.useEffect(function() {
        function doIt() {
            return _doIt.apply(this, arguments);
        }
        function _doIt() {
            _doIt = (0,src_async_to_generator/* default */.Z)(function() {
                var countryString, i, technologyString, i1, mcoString, i2, auth, createBotDataToSend, authCheck, expiryStatus;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            debugger;
                            if (!(done == true)) return [
                                3,
                                5
                            ];
                            setloading(true);
                            if (props.botFormState.landscapeApproval == "Yes") {
                                props.botFormState.landscapeApproval = true;
                            } else {
                                props.botFormState.landscapeApproval = false;
                            }
                            if (props.botFormState.infosecApproval == "Yes") {
                                props.botFormState.infosecApproval = true;
                            } else {
                                props.botFormState.infosecApproval = false;
                            }
                            if (props.botFormState.requestType == "New Request") {
                                props.botFormState.parentBotID = "";
                            }
                            countryString = "";
                            for(var i in props.botFormState.country){
                                if (i < props.botFormState.country.length - 1 && props.botFormState.country.length > 1) {
                                    countryString = countryString + props.botFormState.country[i] + ",";
                                } else {
                                    countryString = countryString + props.botFormState.country[i];
                                }
                            }
                            props.botFormState.country = countryString;
                            technologyString = "";
                            for(var i1 in props.botFormState.technology){
                                if (i1 < props.botFormState.technology.length - 1 && props.botFormState.technology.length > 1) {
                                    technologyString = technologyString + props.botFormState.technology[i1] + ",";
                                } else {
                                    technologyString = technologyString + props.botFormState.technology[i1];
                                }
                            }
                            props.botFormState.technology = technologyString;
                            mcoString = "";
                            for(var i2 in props.botFormState.mco){
                                if (i2 < props.botFormState.mco.length - 1 && props.botFormState.mco.length > 1) {
                                    mcoString = mcoString + props.botFormState.mco[i2] + ",";
                                } else {
                                    mcoString = mcoString + props.botFormState.mco[i2];
                                }
                            }
                            props.botFormState.mco = mcoString;
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            delete props.botFormState.uploadDocumentsState;
                            createBotDataToSend = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                UserEmail: auth.email
                            }, props.botFormState), {
                                review: {
                                    status: false,
                                    comment: "Review Pending"
                                }
                            });
                            createBotDataToSend.createdBy = auth.name;
                            return [
                                4,
                                JSON.parse(localStorage.getItem("auth")).data
                            ];
                        case 1:
                            authCheck = _state.sent();
                            return [
                                4,
                                props.checkExpiry(authCheck)
                            ];
                        case 2:
                            expiryStatus = _state.sent();
                            if (!expiryStatus) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                axios_default()({
                                    method: "post",
                                    url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/getBotCount"),
                                    data: {
                                        landscapeId: null,
                                        parentBotID: "",
                                        botType: "master"
                                    },
                                    headers: {
                                        Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                    }
                                }).then(function(res) {
                                    //console.log(res)
                                    var landscapeId = "";
                                    var landscape = createBotDataToSend.landscape;
                                    if (landscape == "Global") {
                                        landscapeId = "0";
                                    }
                                    if (landscape == "Fusion") {
                                        landscapeId = "1";
                                    }
                                    if (landscape == "Sirius") {
                                        landscapeId = "2";
                                    }
                                    if (landscape == "Cordillera") {
                                        landscapeId = "3";
                                    }
                                    if (landscape == "U2K2") {
                                        landscapeId = "4";
                                    }
                                    var masterbotId = parseInt(res.data.data.masterBotID) + 1;
                                    createBotDataToSend.masterBotID = masterbotId;
                                    createBotDataToSend.botExternalId = masterbotId;
                                    createBotDataToSend.botType = "master";
                                    createBotDataToSend.landscapeId = landscapeId;
                                })
                            ];
                        case 3:
                            _state.sent();
                            axios_default()({
                                method: "post",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/createBot"),
                                data: createBotDataToSend,
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(resp) {
                                if (resp.data.code == 200) {
                                    //console.log(resp.data.data);
                                    setNewlyCreatedBotID(resp.data.data.botExternalId);
                                    setloading(false);
                                    setSuccessModal(true);
                                } else if (resp.data.code == 403) {
                                    setloading(false);
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                } else if (resp.data.code == 500) {
                                    console.log("Error", resp.data.data);
                                    setloading(false);
                                    setSuccessModal(false);
                                } else {
                                    console.log("Logs", resp.data);
                                    setloading(false);
                                }
                            }).catch(function(err) {
                                console.log("Error", err);
                                setloading(false);
                            });
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setloading(false);
                            props.sessionTimeOutCheck(true);
                            _state.label = 5;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return _doIt.apply(this, arguments);
        }
        doIt();
    }, [
        done
    ]);
    return showPreview ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(botDetailEndUser/* default */.Z, {
                myBot: props.botFormState,
                type: "previewPage",
                backToEdit: backToEdit,
                createTheBot: createTheBot
            }),
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicSuccessModal/* default */.Z, {
                setSuccessModal: setSuccessModal,
                parent: "createBot",
                data: props.data[1].component.content,
                botID: newlyCreatedBotID
            }) : null
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (createBotFinal_module_default()).mainContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (createBotFinal_module_default()).stepperContainer,
                children: [
                    successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicSuccessModal/* default */.Z, {
                        setSuccessModal: setSuccessModal,
                        parent: "createBot",
                        data: props.data[1].component.content,
                        botID: newlyCreatedBotID
                    }) : null,
                    businessOwnerModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                        setSuccessModal: setBusinessOwnerModal,
                        title: "User Access Mapping",
                        message: "Business owner already exist with another user type",
                        // setMessage={setMessage}
                        fail: true
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(createBotStepper/* default */.Z, {
                        pageNumber: pageNumber,
                        editBot: false
                    })
                ]
            }),
            botPages[1] == true && renderFirstBot ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (createBot_module_default()).botContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(botForm/* default */.Z, {
                        nextBot: nextBot,
                        data: firstPage.field_bot_form_steps,
                        pageNum: 1,
                        saveInfoToRedux: saveInfoToRedux,
                        savedState: props.botFormState,
                        globalData: props.globalData,
                        setBusinessOwnerModal: setBusinessOwnerModal
                    })
                })
            }) : null,
            botPages[2] == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(botForm/* default */.Z, {
                nextBot: nextBot,
                data: secondPage.field_bot_form_steps,
                pageNum: 2,
                saveInfoToRedux: saveInfoToRedux,
                savedState: props.botFormState
            }) : null,
            botPages[3] == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(botForm/* default */.Z, {
                nextBot: nextBot,
                data: thirdPage.field_bot_form_steps,
                pageNum: 3,
                saveInfoToRedux: saveInfoToRedux,
                savedState: props.botFormState
            }) : null,
            botPages[4] == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(botForm/* default */.Z, {
                allDone: allDone,
                nextBot: nextBot,
                data: fourthPage.field_bot_form_steps,
                pageNum: 4,
                saveInfoToRedux: saveInfoToRedux,
                savedState: props.botFormState
            }) : null
        ]
    });
};
var createBotFormss_mapStateToProps = function(state) {
    //console.log("state",state)
    return {
        botFormState: state.createBot,
        currentBot: state.storeBot.currentBot,
        session: state.session.session
    };
};
function createBotFormss_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var createBotFormss = ((0,es/* connect */.$j)(createBotFormss_mapStateToProps, createBotFormss_mapDispatchToProps)(createBotFormss_index));

;// CONCATENATED MODULE: ./components/Pages/botDetailPage/index.jsx






function botDetailPage_index(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), currentBot = ref[0], setCurrentBot = ref[1];
    react.useEffect(function() {
        setCurrentBot(props.currentBot);
    }, [
        props.currentBot
    ]);
    react.useEffect(function() {
    //console.log(router.query, "all kinda queries")
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(botDetailEndUser/* default */.Z, {
            globalData: props.globalData,
            data: props
        })
    });
}
var botDetailPage_mapStateToProps = function(state) {
    return {
        currentBot: state.storeBot.currentBot
    };
};
/* harmony default export */ var botDetailPage = ((0,es/* connect */.$j)(botDetailPage_mapStateToProps, null)(botDetailPage_index));

// EXTERNAL MODULE: ./styles/components/banner.module.scss
var banner_module = __webpack_require__(23289);
var banner_module_default = /*#__PURE__*/__webpack_require__.n(banner_module);
// EXTERNAL MODULE: ./components/shared/skeleton.module.css
var skeleton_module = __webpack_require__(43484);
var skeleton_module_default = /*#__PURE__*/__webpack_require__.n(skeleton_module);
// EXTERNAL MODULE: ./components/shared/config.js
var shared_config = __webpack_require__(60344);
;// CONCATENATED MODULE: ./components/botStats/BotStats.jsx







var BotStats = function() {
    var ref = (0,react.useState)([]), stats = ref[0], setStats = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useRef)(false);
    var getBotStats = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var config, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        config = {
                            headers: {
                                Authorization: "Bearer ".concat(shared_config/* config.bearerToken */.v.bearerToken)
                            }
                        };
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default().get("".concat(shared_config/* config.baseUrl */.v.baseUrl, "/bot/stats"), config)
                        ];
                    case 2:
                        res = _state.sent();
                        if (res.data.stats) {
                            setStats(res.data.stats);
                        }
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setLoading(false);
                        console.log("Bot Stats Error:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getBotStats() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!ref2.current) {
            getBotStats();
            ref2.current = true;
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-1 sm:grid-cols-2 gap-4 w-full",
        children: loading ? [
            1,
            2
        ].map(function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-28",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-10 ".concat((skeleton_module_default()).skeleton_box, " mb-1")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-3 gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((skeleton_module_default()).skeleton_box, " h-16")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((skeleton_module_default()).skeleton_box, " h-16")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((skeleton_module_default()).skeleton_box, " h-16")
                            })
                        ]
                    })
                ]
            });
        }) : stats.length ? stats.map(function(stat, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stat, {
                stat: stat,
                isLive: stat.isLive
            }, idx);
        }) : ""
    });
};
var Stat = function(param) {
    var stat = param.stat, isLive = param.isLive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(isLive ? "bg-[rgba(255,255,255,0.5)]" : "bg-[rgba(255,85,84,0.5)] text-white", " shadow-md font-unilever-shilling-medium px-2"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "!border-b-2 !border-[rgba(255,255,255,0.5)] text-center py-2 text-[16px]",
                children: stat.heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-3",
                children: stat.values.map(function(value, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(idx !== stat.values.length - 1 ? "!border-r-2 !border-[rgba(0,0,0,0.08)]" : "", " flex flex-col justify-center items-center p-2"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[14px]",
                                children: value.count
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[10px]",
                                children: value.label
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
};
/* harmony default export */ var botStats_BotStats = (BotStats);

;// CONCATENATED MODULE: ./components/botStats/BotDetailedStats.jsx









var BotDetailedStats = function(param) {
    var openDetailedStat = param.openDetailedStat;
    var ref = useState([]), detailedStats = ref[0], setDetailedStats = ref[1];
    var ref1 = useState(null), count = ref1[0], setCount = ref1[1];
    var ref2 = useState(false), loading = ref2[0], setLoading = ref2[1];
    var botStatus = [
        "Live",
        "Initial Demand",
        "Retired",
        "On hold"
    ];
    var ref3 = useState([
        "Live"
    ]), selectedStatus = ref3[0], setSelectedStatus = ref3[1];
    var getDetailedStats = function() {
        var _ref = _async_to_generator(function(selectedStatus) {
            var config, res, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        config = {
                            headers: {
                                Authorization: "Bearer ".concat(axiosConfig.bearerToken)
                            }
                        };
                        //https://automation.unilever.com/api
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios.post("https://automation.unilever.com/api/bot/detailed-bot-stats", {
                                status: selectedStatus
                            }, config)
                        ];
                    case 2:
                        res = _state.sent();
                        console.log("res.data", res.data);
                        if (res.data.status === "success") {
                            setDetailedStats(res.data.data.technologyBots);
                            setCount(res.data.data.totalCount);
                        }
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log("Error:", error);
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getDetailedStats(selectedStatus) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFilterChange = function(e) {
        var _target = e.target, name = _target.name, checked = _target.checked;
        console.log(name, checked, typeof checked === "undefined" ? "undefined" : _type_of(checked));
        if (checked) {
            setSelectedStatus(_to_consumable_array(selectedStatus).concat([
                name
            ]));
        } else {
            setSelectedStatus(selectedStatus.filter(function(status) {
                return status !== name;
            }));
        }
    };
    useEffect(function() {
        getDetailedStats(selectedStatus);
    }, [
        selectedStatus
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "".concat(openDetailedStat ? "w-[90%]" : "w-0", " transition-all absolute left-[50%] top-12 bg-[#f7f7f7] min-h-[100px] max-h-[70vh] shadow-md z-20 translate-x-[-50%] p-2 flex flex-col gap-3"),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "bg-[#176bf9] flex items-center justify-center gap-10 py-1 text-white text-lg",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: "Detailed Bot Stats"
                    }),
                    " ",
                    /*#__PURE__*/ _jsxs("span", {
                        className: "text-sm",
                        children: [
                            "Total Bot Count: ",
                            count
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "!border !border-[#176bf9] p-1 text-xs text-center",
                children: "Calculated by catering New Request & Roll Out"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-5",
                children: [
                    "Select Bot Status:",
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-center justify-between w-[50%]",
                        children: botStatus.map(function(status, id) {
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ _jsx("input", {
                                        type: "checkbox",
                                        name: status,
                                        onChange: handleFilterChange,
                                        checked: selectedStatus.includes(status),
                                        className: "cursor-pointer"
                                    }),
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "mb-[2px]",
                                        children: status
                                    })
                                ]
                            }, id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "grid grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2 overflow-y-scroll",
                children: loading ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8
                    ].map(function(item, index) {
                        return /*#__PURE__*/ _jsx("div", {
                            className: "".concat(style.skeleton_box, " aspect-square")
                        }, index);
                    })
                }) : detailedStats.map(function(bot, idx) {
                    /*#__PURE__*/ return _jsxs("div", {
                        className: "bg-[#ecf3ff] !aspect-square !border-[#1e52ac31] !border-[1px] shadow-sm flex flex-col justify-center items-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "font-unilever-shilling-medium text-lg",
                                children: bot === null || bot === void 0 ? void 0 : bot.count
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "font-unilever-shilling-normal text-sm text-center px-1",
                                children: bot === null || bot === void 0 ? void 0 : bot.technology
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
};
/* harmony default export */ var botStats_BotDetailedStats = ((/* unused pure expression or super */ null && (BotDetailedStats)));

// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./components/hallOfFame/header/Filter.jsx + 1 modules
var Filter = __webpack_require__(58566);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(15437);
;// CONCATENATED MODULE: ./components/botStats/BotDashboard.jsx






function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  background-color: #ffffff;\n  color: #000;\n  &::-webkit-calendar-picker-indicator {\n    background-image: url("/hof_date.svg");\n    cursor: pointer;\n    scale: 1.5;\n    position: relative;\n    left: -8px;\n  }\n  padding: 5px 0;\n  border-radius: 20px;\n  padding-left: 5px;\n  outline: none;\n  border: none;\n  text-transform: lowercase;\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var BotDashboard = function(param) {
    var openDetailedStat = param.openDetailedStat;
    var transformTechnologyData = function transformTechnologyData(data) {
        var result = [
            {
                title: "RPA + ACS",
                children: []
            },
            {
                title: "ACS",
                children: []
            },
            {
                title: "RPA",
                children: []
            }, 
        ];
        data.forEach(function(item) {
            var ref;
            var technology = (ref = item.technology) === null || ref === void 0 ? void 0 : ref.trim();
            // Skip Total Bots if you don't want it
            if (technology === "Total Bots") return;
            if (technology === "RPA") {
                // Only RPA
                result[2].children.push(item);
            } else if (technology === null || technology === void 0 ? void 0 : technology.includes("RPA,")) {
                // RPA + Something
                result[0].children.push(item);
            } else {
                // Everything else
                result[1].children.push(item);
            }
        });
        return result;
    };
    var ref;
    var filter = [
        {
            label: "HAP Delivery Lead ",
            filter: "engagementLead"
        },
        {
            label: "Functional HAP SMEs",
            filter: "functionalHAPSMEs"
        },
        {
            label: "Technology",
            filter: "technology"
        },
        {
            label: "Status",
            filter: "status"
        },
        {
            label: "Platform",
            filter: "platform"
        }, 
    ];
    var ref1 = (0,react.useState)(0), activeFilter = ref1[0], setActiveFilter = ref1[1];
    var handleActiveFilter = function(filter) {
        "";
        setActiveFilter(filter);
    };
    var ref2 = (0,react.useState)({
        fromDate: "",
        toDate: ""
    }), dates = ref2[0], setDates = ref2[1];
    var handleDateChange = function(e) {
        console.log("handleDateChange", e.target.name, e.target.value);
        setDates((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dates), (0,src_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    var ref3 = (0,react.useState)([]), botDashboardData = ref3[0], setBotDashboardData = ref3[1];
    var ref4 = (0,react.useState)([]), technologyTreeData = ref4[0], setTechnologyTreeData = ref4[1];
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var getBotDasboardData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var auth, config, ref, res, ref1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (true) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                        }
                        config = {
                            headers: {
                                Authorization: auth === null || auth === void 0 ? void 0 : auth.accessToken
                            }
                        };
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            axios_default().get("".concat(shared_config/* config.baseUrl */.v.baseUrl, "/bot/dashboard?filter=").concat(filter[activeFilter].filter, "&dateFrom=").concat(dates.fromDate, "&dateTo=").concat(dates.toDate), config)
                        ];
                    case 2:
                        res = _state.sent();
                        if (((ref = res.data) === null || ref === void 0 ? void 0 : ref.status) === "success") {
                            ;
                            setBotDashboardData((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.log("Error:", error);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function getBotDasboardData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getBotDasboardData();
    }, [
        activeFilter,
        dates
    ]);
    (0,react.useEffect)(function() {
        if (activeFilter === 2 && botDashboardData.length > 0) {
            setTechnologyTreeData(transformTechnologyData(botDashboardData));
        }
    }, [
        activeFilter,
        botDashboardData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(openDetailedStat ? "w-[90%]" : "w-0", " transition-all absolute left-[50%] top-12 bg-white min-h-[100px] max-h-[70vh] overflow-y-auto shadow-md z-20 translate-x-[-50%]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center py-3 bg-[#1F36C7] font-unilever-shilling-medium text-white",
                children: "Detailed Bot Stats"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-5 xl:gap-0 xl:flex-row xl:items-center justify-between px-3 py-3 bg-[#e9ebf9]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center gap-4",
                        children: filter.map(function(f, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return handleActiveFilter(index);
                                },
                                className: " ".concat(index === activeFilter ? "bg-[#1F36C7] text-[#fff]" : "bg-[#d5d9f4] text-[#1F36C7] hover:bg-[rgba(31,54,199,0.2)]", " !border-[1px] !border-[rgba(31,54,199,0.1)] px-4 py-2 rounded-full cursor-pointer  uppercase font-unilever-shilling-medium text-[12px] "),
                                children: f.label
                            }, f.filter);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "From:",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDate, {
                                        type: "date",
                                        name: "fromDate",
                                        value: dates.fromDate,
                                        onChange: handleDateChange
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "To:",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDate, {
                                        type: "date",
                                        name: "toDate",
                                        value: dates.toDate,
                                        onChange: handleDateChange
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (botDashboardData === null || botDashboardData === void 0 ? void 0 : (ref = botDashboardData[0]) === null || ref === void 0 ? void 0 : ref.count) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "h-48 flex justify-center items-center",
                children: "No bots found! Try changing filters or date range."
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: filter[activeFilter].filter === "technology" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-24 p-4 h-[70vh]",
                    children: technologyTreeData.map(function(column, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "rounded-md h-[100px] md:w-[25%] xl:w-[20%] bg-[#1F36C7] p-3 text-white text-[17px] flex flex-col justify-between relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        " ",
                                        column.title
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: column.children.reduce(function(acc, item) {
                                        return acc + item.count;
                                    }, 0)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute top-[103px] flex flex-col gap-5 pt-[42px] pl-16 bg-transparent rounded-none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute h-full w-[2px] bg-[#1F36C7] rounded-b-2xl left-0 top-[-3px] rounded-t-full"
                                        }),
                                        column.children.map(function(item, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                className: "bg-[#e9ebf9] text-[#1F36C7] p-3 rounded-md relative text-sm flex flex-col gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: item === null || item === void 0 ? void 0 : item.technology
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-xs",
                                                        children: item === null || item === void 0 ? void 0 : item.count
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute top-[50%] translate-y-[-50%] left-[-62px] w-[62px] h-[2px] bg-[#1F36C7] rounded-r-2xl"
                                                    })
                                                ]
                                            }, index);
                                        })
                                    ]
                                })
                            ]
                        });
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 p-4",
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: Array.from({
                            length: 12
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[120px] ".concat((skeleton_module_default()).skeleton_box, " rounded-md")
                            }, index);
                        })
                    }) : botDashboardData === null || botDashboardData === void 0 ? void 0 : botDashboardData.map(function(bot, i) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: " ".concat(i === 0 ? "bg-[#1F36C7]" : "bg-[#e9ebf9]", " rounded-md h-[120px] p-3 flex flex-col justify-between"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat(i === 0 ? "text-[#fff] text-[15px]" : "text-[#1F36C7] text-[13px]", " font-unilever-shilling-medium"),
                                    children: bot === null || bot === void 0 ? void 0 : bot[filter[activeFilter].filter]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat(i === 0 ? "text-[#fff]" : "text-[#1F36C7]", " text-[30px] font-unilever-shilling-normal"),
                                    children: bot === null || bot === void 0 ? void 0 : bot.count
                                })
                            ]
                        }, i);
                    })
                })
            })
        ]
    });
};
var InputDate = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-4f53d4e1-0"
})(_templateObject());
/* harmony default export */ var botStats_BotDashboard = (BotDashboard);

;// CONCATENATED MODULE: ./components/banner/index.jsx








function banner_index(props) {
    //console.log(props,"boturl")
    var image = props.data.field_background_image[0];
    var bgimage = props.data.field_background_image_mobile[0];
    var ref = (0,react.useState)(false), openDetailedStat = ref[0], setOpenDetailedStat = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((banner_module_default()).bannerWrapper, " container-fluid"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((banner_module_default()).row, " row"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (banner_module_default()).imaging,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (banner_module_default()).image,
                                        src: utility_endpoints/* default.drupalIp */.ZP.drupalIp + image.file_url,
                                        alt: image.image_alt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (banner_module_default()).imageMobile,
                                        src: utility_endpoints/* default.drupalIp */.ZP.drupalIp + bgimage.file_url,
                                        alt: bgimage.image_alt
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((banner_module_default()).container, " container py-4 relative"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (banner_module_default()).bannerHead,
                                        children: props.data.field_hedaing
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (banner_module_default()).bannerText,
                                        dangerouslySetInnerHTML: {
                                            __html: props.data.field_details
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute z-10 right-5 top-0 h-full w-[47%] hidden lg:flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(botStats_BotStats, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        onClick: function() {
                                            return setOpenDetailedStat(!openDetailedStat);
                                        },
                                        className: "absolute flex items-center right-5 top-3 px-[4px] py-[2px] z-10 text-xs bg-[rgba(255,255,255,0.8)] ",
                                        children: [
                                            "Detailed Stats",
                                            " ",
                                            openDetailedStat && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdClose */.QAE, {
                                                className: "w-4 h-4"
                                            })
                                        ]
                                    }),
                                    openDetailedStat && /*#__PURE__*/ (0,jsx_runtime.jsx)(botStats_BotDashboard, {
                                        openDetailedStat: openDetailedStat
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:hidden flex bg-[#00d7c5] justify-center items-center py-3 w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-2/3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(botStats_BotStats, {})
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./styles/components/exportBotBand.module.scss
var exportBotBand_module = __webpack_require__(59727);
var exportBotBand_module_default = /*#__PURE__*/__webpack_require__.n(exportBotBand_module);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./components/shared/PlayIcon.jsx
var PlayIcon = __webpack_require__(41708);
// EXTERNAL MODULE: ./node_modules/react-icons/rx/index.esm.js
var rx_index_esm = __webpack_require__(55788);
;// CONCATENATED MODULE: ./components/exportBotBand/CRDemo.jsx
/* provided dependency */ var process = __webpack_require__(83454);






var CRDemo = function() {
    var ref = (0,react.useState)(false), showVideo = ref[0], setShowVideo = ref[1];
    var videoRef = (0,react.useRef)();
    var videoUrl = "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/instructionvideos/Change_Request.mp4?" + process.env.NEXT_PUBLIC_SAS_TOKEN;
    (0,react.useEffect)(function() {
        if (showVideo) {
            var ref;
            (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
        } else {
            var ref1;
            (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
        }
    }, [
        showVideo
    ]);
    var closeVideo = function(e) {
        e.stopPropagation();
        setShowVideo(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                onClick: function() {
                    return setShowVideo(true);
                },
                className: "flex px-3 py-2 animate-pulse items-center justify-center gap-2 h-full !border !border-purple-600 text-purple-600 cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaVideo */.KoQ, {}),
                    " CR Demo Video"
                ]
            }),
            showVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-[9999] fixed left-0 top-0 w-screen h-screen bg-[rgba(0,0,0,0.2)] flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "h-[85%] relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: closeVideo,
                            className: "w-8 h-8 flex justify-center items-center bg-red-500 absolute z-[99999] right-0 top-0 !cursor-pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rx_index_esm/* RxCross2 */.$iT, {
                                className: "text-white w-5 h-5"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon/* CustomVideo */.j, {
                            ref: videoRef,
                            src: videoUrl,
                            controls: true,
                            className: "!w-full !h-full"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var exportBotBand_CRDemo = (CRDemo);

;// CONCATENATED MODULE: ./components/exportBotBand/AssociateBots.jsx






var AssociateBots = function() {
    var ref = (0,react.useState)(false), updating = ref[0], setUpdating = ref[1];
    var updateAssociateBots = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var auth, page, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (true) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                        }
                        page = prompt("Enter the page number");
                        setUpdating(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            axios_default().post("".concat(shared_config/* config.baseUrl */.v.baseUrl, "/bot/update-associate-bots?page=").concat(page), {}, {
                                headers: {
                                    Authorization: auth === null || auth === void 0 ? void 0 : auth.accessToken
                                }
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setUpdating(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function updateAssociateBots() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        onClick: updateAssociateBots,
        className: "flex px-3 py-2 items-center justify-center gap-2 h-full !border !border-purple-600 text-purple-600 cursor-pointer mx-2",
        children: updating ? "Updating..." : "Update Associate Bots"
    });
};
/* harmony default export */ var exportBotBand_AssociateBots = (AssociateBots);

;// CONCATENATED MODULE: ./components/exportBotBand/index.jsx















function exportBotBand_index(props) {
    var ref = (0,react.useState)(true), admin = ref[0], setadmin = ref[1];
    var router = (0,next_router.useRouter)();
    var createBot = function() {
        router.push("/createBotNew");
    };
    var ref1 = (0,react.useState)([
        "admin",
        "qrManager",
        "internalUser",
        "supportStatus", 
    ]), createAccess = ref1[0], setCreateAccess = ref1[1];
    var getAllBotsInExcel = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var exportFilter, authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        exportFilter = props.filters;
                        if (exportFilter.search != undefined) {
                            delete exportFilter.search;
                        }
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            props.setLoading(true);
                            axios_default()({
                                method: "get",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/getBotsInExcel"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                params: exportFilter
                            }).then(function(resp) {
                                props.setLoading(false);
                                if (resp.data.code == 200) {
                                    //console.log(resp.data, "demandexcelresponse");
                                    window.open(resp.data.data);
                                } else if (resp.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            props.sessionTimeOutCheck(true);
                            props.setLoading(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getAllBotsInExcel() {
            return _ref.apply(this, arguments);
        };
    }();
    var exportCustomBots = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            props.setLoading(true);
                            axios_default()({
                                method: "get",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/custom-export"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(resp) {
                                props.setLoading(false);
                                if (resp.data.status === "success" && resp.data.message === "Bot data fetched") {
                                    window.open(resp.data.data.URL);
                                } else if (resp.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                            }).catch(function(e) {
                                console.log(e);
                                props.setLoading(false);
                            });
                        } else {
                            props.sessionTimeOutCheck(true);
                            props.setLoading(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function exportCustomBots() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (exportBotBand_module_default()).bandWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (exportBotBand_module_default()).configBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (exportBotBand_module_default()).btn,
                                onClick: getAllBotsInExcel,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                        name: "uploadicon",
                                        className: (exportBotBand_module_default()).exportIcon
                                    }),
                                    "Export Bot list"
                                ]
                            }),
                            createAccess.includes(props.userRole) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (exportBotBand_module_default()).createbtn,
                                onClick: createBot,
                                children: "Create a New Bot"
                            }) : null,
                            props.userRole !== "endUser" && props.userRole !== "businessOwner" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: exportCustomBots,
                                className: "mx-3 px-3 cursor-pointer bg-[#00d7c5] text-[#1f36c7] font-unilever-shilling-medium hidden md:flex justify-center items-center",
                                children: "Export Custom Bots"
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(exportBotBand_CRDemo, {}),
                            props.userRole === "admin" && /*#__PURE__*/ (0,jsx_runtime.jsx)(exportBotBand_AssociateBots, {})
                        ]
                    })
                })
            })
        })
    });
}
var exportBotBand_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function exportBotBand_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var exportBotBand = ((0,es/* connect */.$j)(exportBotBand_mapStateToProps, exportBotBand_mapDispatchToProps)(exportBotBand_index));

// EXTERNAL MODULE: ./styles/components/filters.module.scss
var filters_module = __webpack_require__(33239);
var filters_module_default = /*#__PURE__*/__webpack_require__.n(filters_module);
// EXTERNAL MODULE: ./redux/storeBot/actions.js
var storeBot_actions = __webpack_require__(64362);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./components/Filters/index.jsx















function Filters_index(props) {
    var camelize = // to convert labels into camelcase
    function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    var inputRef = (0,react.useRef)(null);
    // console.log(props, "props at the start ");
    var _data = props.data, field_label = _data.field_label, field_title = _data.field_title, field_bot_store_filters_fields = _data.field_bot_store_filters_fields;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    // saving bots camalcased label as value
    field_bot_store_filters_fields.map(function(item) {
        item.value = camelize(item.field_label);
    });
    var dropDownsInitialStates = {};
    field_bot_store_filters_fields.map(function(item) {
        if (item.field_label != "Search") {
            props.initialStates[camelize(item.field_label)] = "";
        }
        if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
            dropDownsInitialStates[camelize(item.field_label)] = false;
        }
    });
    react.useEffect(function() {
        var relatedDropdownToSet = {};
        field_bot_store_filters_fields.map(function(item) {
            if (item.field_input_type == "Related Dropdown") {
                relatedDropdownToSet[camelize(item.field_label)] = item.field_dropdown_option_component;
            }
        });
        setRelatedDropdowns(relatedDropdownToSet);
        if (props.state.search && props.state.search.length > 0) {
            inputRef.current.focus();
        }
    }, []);
    var ref = (0,react.useState)(false), admin = ref[0], setadmin = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), relatedDropdowns = ref1[0], setRelatedDropdowns = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(dropDownsInitialStates), 2), dropDownState = ref2[0], setDropdownState = ref2[1];
    var ref3 = (0,react.useState)(false), reload = ref3[0], setReload = ref3[1];
    var ref4 = (0,react.useState)(props.state.search), search = ref4[0], setSearch = ref4[1];
    react.useEffect(function() {
        if (reload) {
            props.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.state), (0,src_define_property/* default */.Z)({}, "search", search)));
        }
    }, [
        reload
    ]);
    var callApi = function() {
        setReload(true);
    }; // You might be able to call API directly here, I haven't tried
    var ref5 = (0,react.useState)(function() {
        return lodash_default().debounce(callApi, 300);
    }), debouncedCallApi = ref5[0];
    var inputChange = function(e) {
        if (e.target.value.length == 0) {
            //  console.log(e.target.value, "before");
            var statess = props.state;
            delete statess.search;
            props.setState((0,src_object_spread/* default */.Z)({}, statess));
            if (lodash_default().isEmpty(statess)) {
                props.clearALLFilter();
            }
        } else {
            //  console.log(e.target.value)
            setSearch(e.target.value);
            debouncedCallApi();
        }
    };
    var handleDropDown = function(item) {
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownsInitialStates), (0,src_define_property/* default */.Z)({}, item, !dropDownState[item])));
    };
    var gotDropDownValue = function(value, dropdownParent, haveRelated) {
        var stateToChange = props.state;
        if (haveRelated) {
            var relatedDropdown = relatedDropdowns[haveRelated];
            relatedDropdown.nowValues = relatedDropdowns[haveRelated].filter(function(item) {
                return item.field_title == value;
            })[0].field_options;
            setRelatedDropdowns((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, relatedDropdowns), (0,src_define_property/* default */.Z)({}, haveRelated, relatedDropdown)));
            delete stateToChange[haveRelated];
            var ChildObj = props.data.field_bot_store_filters_fields.filter(function(item) {
                return item.value == haveRelated;
            });
            var grandChildren = camelize(ChildObj[0].field_related_dropdown);
            if (grandChildren) {
                var realll = relatedDropdowns;
                delete realll[grandChildren].nowValues;
                setRelatedDropdowns((0,src_object_spread/* default */.Z)({}, realll));
            }
        }
        setDropdownState(dropDownsInitialStates);
        props.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, stateToChange), (0,src_define_property/* default */.Z)({}, dropdownParent, value)));
    // props.getFilterValue(value);
    };
    var clearAllFilters = function() {
        props.setState({});
        setDropdownState(dropDownsInitialStates);
        // dispatch(getBotsAction(0));
        props.clearALLFilter();
        props.setReset(true);
    };
    react.useEffect(function() {
        if (props.reset) {
            props.setReset(false);
            var reall = relatedDropdowns;
            for(var i in reall){
                delete reall[i].nowValues;
            }
            setRelatedDropdowns((0,src_object_spread/* default */.Z)({}, reall));
        }
    }, [
        props.reset
    ]);
    react.useEffect(function() {
        //  console.log(router.query, "all kinda queries");
        delete router.query.path;
    // console.log(props.state, "state at route query");
    //setState(...state, ...router.query);
    }, [
        router.query
    ]);
    var closeAllDropdowns = function() {
        setDropdownState(dropDownsInitialStates);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (filters_module_default()).filtersWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (filters_module_default()).filtersContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (filters_module_default()).head,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (filters_module_default()).left,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: field_title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (filters_module_default()).right,
                            onClick: clearAllFilters,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (filters_module_default()).more,
                                children: field_label
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (filters_module_default()).listWrapper,
                    children: field_bot_store_filters_fields.map(function(item, index) {
                        if (item.field_input_type == "Radio") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (filters_module_default()).formGroup,
                                onChange: inputChange,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: (filters_module_default()).mainLabel,
                                        children: [
                                            item.field_label,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                className: (filters_module_default()).mandatoryField,
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (filters_module_default()).inputGroupWrapper,
                                        children: item.field_options.map(function(radioItem, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (filters_module_default()).radioWrapper,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (filters_module_default()).subLabel,
                                                        children: radioItem
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "radio",
                                                        className: (filters_module_default()).radioBox,
                                                        value: camelize(radioItem),
                                                        name: item.value
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (filters_module_default()).radioCheckmark
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            });
                        } else if (item.field_input_type == "Plain Text") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((filters_module_default()).inputGroup, " "),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: item.field_label
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "".concat((filters_module_default()).input),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: (filters_module_default()).inputText,
                                            type: "text",
                                            placeholder: item.field_title,
                                            name: item.value,
                                            onChange: inputChange,
                                            value: search ? search : "",
                                            ref: inputRef
                                        })
                                    })
                                ]
                            });
                        } else if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
                            if (item.value == "area" && !props.state.leadPlatform) {
                                return null;
                            }
                            // console.log(props.state[item.value], "inside filter")
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (filters_module_default()).inputGroup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: item.field_label
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "".concat((filters_module_default()).input),
                                        onClick: function() {
                                            handleDropDown(item.value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (filters_module_default()).left,
                                                children: props.state[item.value] == null || props.state[item.value] === undefined || props.state[item.value].length == 0 ? item.field_input : props.state[item.value]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (filters_module_default()).right,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                    name: "chevron",
                                                    className: (filters_module_default()).chevron
                                                })
                                            })
                                        ]
                                    }),
                                    dropDownState[item.value] == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                        dropdownParent: item.value,
                                        closeAllDropdowns: closeAllDropdowns,
                                        params: "botStoreFilters",
                                        values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? relatedDropdowns[camelize(item.field_label)].nowValues : [
                                            "No parent Selected"
                                        ] : item.field_options,
                                        getDropdownValue: gotDropDownValue,
                                        haveRelated: camelize(item.field_related_dropdown)
                                    }) : null
                                ]
                            });
                        }
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/botStoreCard/index.jsx





function botStoreCard_index() {
    var createBot = function() {
        Router.push("/botDetailPage");
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.cardWrapper,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.cardHead,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.icon,
                        children: /*#__PURE__*/ _jsx(Icons, {
                            name: "shoppingIcon",
                            className: styles.shoppingIcon
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.text,
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.code,
                                children: "5310"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.label,
                                children: "Content Marketing"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.cardBody,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.title,
                        children: "Web Scrapping for E-commerce channels"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "".concat(styles.label, " ").concat(styles.rejectStatus),
                        children: "LIVE"
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: styles.content,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.title,
                                children: "Area"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.text,
                                children: "Purchasing Indirect"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: styles.content,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.title,
                                children: "Area"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.text,
                                children: "Purchasing Indirect"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.cardFoot,
                children: /*#__PURE__*/ _jsxs("span", {
                    className: styles.actionBtn,
                    onClick: createBot,
                    children: [
                        /*#__PURE__*/ _jsx(Icons, {
                            name: "whitelist",
                            className: styles.listIcon
                        }),
                        "View Details"
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/dynamicBotCard/index.jsx
var dynamicBotCard = __webpack_require__(71835);
// EXTERNAL MODULE: ./styles/pages/botStore.module.scss
var botStore_module = __webpack_require__(77984);
var botStore_module_default = /*#__PURE__*/__webpack_require__.n(botStore_module);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(246);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
;// CONCATENATED MODULE: ./components/Pages/botStorePage/index.jsx



























function botStorePage_index(props) {
    var camelize = function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var myScroll = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var data = props.data;
    var bannerData = lodash_default().get(data[0], "component.content", "");
    //  const {component : {content }} = data[1]
    var content = lodash_default().get(data[1], "component.content", "");
    // _.get(data[2], "component.content.field_no_result_image[0].file_url", "")
    var initialStates = {};
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref[0], setState = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), allBots = ref1[0], setAllBots = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), filters = ref2[0], setFilters = ref2[1];
    var ref3 = (0,react.useState)(false), filterOn = ref3[0], setFilterOn = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(true), 2), hasMore = ref4[0], setHasMore = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), filterActive = ref5[0], setFilterActive = ref5[1];
    var ref6 = (0,react.useState)({}), auth = ref6[0], setAuth = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(1), 2), infiniteKey = ref7[0], setInfiniteKey = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), noResultFlag = ref8[0], setNoResultFlag = ref8[1];
    var ref9 = (0,react.useState)([
        "admin",
        "internalUser",
        "qrManager",
        "supportStatus"
    ]), nonRestrictedUser = ref9[0], setnonRestrictedUser = ref9[1];
    var ref10 = (0,react.useState)({}), filterStateExport = ref10[0], setfilterStateExport = ref10[1];
    var ref11 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), loadState = ref11[0], setLoadState = ref11[1];
    var ref12 = (0,src_sliced_to_array/* default */.Z)(react.useState(true), 2), hasMoreBots = ref12[0], setHasMoreBots = ref12[1];
    var ref13 = (0,react.useState)(0), length = ref13[0], setLength = ref13[1];
    var ref14 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), loading = ref14[0], setLoading = ref14[1];
    var ref15 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), mobileFilterRelatedInfo = ref15[0], setMobileFilterRelatedInfo = ref15[1];
    var ref16 = (0,src_sliced_to_array/* default */.Z)(react.useState(0), 2), totalIndexFilter = ref16[0], setTotalIndexFilter = ref16[1];
    var ref17 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), currentFilters = ref17[0], setCurrentFilters = ref17[1];
    var ref18 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), reset = ref18[0], setReset = ref18[1];
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            // state = { ...router.query };
            setLoading(true);
            dispatch((0,storeBot_actions/* getBotsAction */.x6)(0));
            try {
                if (localStorage.getItem("auth") != undefined) {
                    setAuth(JSON.parse(localStorage.getItem("auth").data));
                }
            } catch (e) {}
            return [
                2
            ];
        });
    }), []);
    react.useEffect(function() {
        //console.log(state, "statefirst")
        var _$Filters = {};
        for(var i in state){
            if (state[i]) {
                if (state[i].length > 0) {
                    _$Filters[i] = state[i];
                }
            }
        }
        setfilterStateExport(_$Filters);
        if (_$Filters && Object.keys(_$Filters).length === 0 && _$Filters.constructor === Object) {
            if (props.storeBot.filter !== null) {
                window.scrollTo(0, 200);
            }
            setLoading(true);
            setInfiniteKey(infiniteKey + 1);
            dispatch((0,storeBot_actions/* getBotsAction */.x6)(0));
            setHasMoreBots(true);
            setLoadState(true);
            setSearch("");
        } else {
            setLoading(true);
            setInfiniteKey(infiniteKey + 1);
            setHasMoreBots(true);
            setLoadState(true);
            window.scrollTo(0, 200);
            if (_$Filters["catalogueProducts"]) {
                _$Filters["catalogueProducts"] = _$Filters["catalogueProducts"] == "Yes" ? "true" : "false";
            }
            setCurrentFilters(_$Filters);
            dispatch((0,storeBot_actions/* getFilterBotsAction */.uW)(0, _$Filters));
        }
    }, [
        state
    ]);
    react.useEffect(function() {
        // if (props.storeBot.type == "all") {
        //  setLoading(false);
        if (props.storeBot.allBots && props.storeBot.filter !== null) {
            if (props.storeBot.allBots.length == 0) {
                setNoResultFlag(true);
            }
            setLoading(false);
            setTotalIndexFilter(props.storeBot.totalIndex);
            setAllBots((0,src_to_consumable_array/* default */.Z)(props.storeBot.allBots));
            setHasMoreBots(true);
            setLoadState(true);
            if (state.search && state.search.length > 0) {
                inputRef.current.focus();
            }
        // setInfiniteKey(infiniteKey+1)
        }
    //  }
    }, [
        props.storeBot
    ]);
    var loadFunc = function(a) {
        //console.log(props.storeBot.totalIndex, "totalIndex")
        if (allBots.length < totalIndexFilter) {
            setHasMoreBots(true);
            setLoadState(true);
            if (!props.storeBot.filter) {
                dispatch((0,storeBot_actions/* getBotsAction */.x6)(a));
                setLoadState(false);
            } else {
                dispatch((0,storeBot_actions/* getFilterBotsAction */.uW)(a, currentFilters));
                setLoadState(false);
            }
        } else {
            //  setLoadState(false)
            setHasMoreBots(false);
        // setHasMoreBots(false)
        }
    };
    var clearALLFilter = function() {
        window.scrollTo(0, 200);
        setState({});
        //setLoadState(true)
        setNoResultFlag(false);
    // dispatch(getBotsAction(0))
    // setAllBots([])
    // setInfiniteKey(infiniteKey + 1)
    // setHasMoreBots(true)
    };
    var removeFilter = function(keyname) {
        if (keyname == "leadPlatform") {
            setReset(true);
            var otherState = mobileFilterRelatedInfo;
            delete otherState["Area"];
            setMobileFilterRelatedInfo((0,src_object_spread/* default */.Z)({}, otherState));
        }
        var stateToChange = state;
        var itemToBeRemoved = content.field_bot_store_filters_fields.filter(function(item) {
            return item.value == keyname;
        });
        if (itemToBeRemoved.length > 0) {
            if (itemToBeRemoved[0].field_related_dropdown) {
                delete stateToChange[camelize(itemToBeRemoved[0].field_related_dropdown)];
            }
        }
        delete stateToChange[keyname];
        setState((0,src_object_spread/* default */.Z)({}, stateToChange));
        if (length > 0) {
            setLength(length - 1);
        }
    };
    var inputRef = (0,react.useRef)(null);
    var ref19 = (0,react.useState)(false), reload = ref19[0], setReload = ref19[1];
    var ref20 = (0,react.useState)(state.search), search = ref20[0], setSearch = ref20[1];
    react.useEffect(function() {
        if (reload) {
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, "search", search)));
            setReload(false);
        }
    }, [
        reload
    ]);
    var callApi = function() {
        setReload(true);
    }; // You might be able to call API directly here, I haven't tried
    var ref21 = (0,react.useState)(function() {
        return lodash_default().debounce(callApi, 800);
    }), debouncedCallApi = ref21[0];
    var inputChange = function(e) {
        if (e.target.value.length == 0) {
            //  console.log(e.target.value, "before");
            var statess = state;
            delete statess.search;
            setSearch("");
            setState((0,src_object_spread/* default */.Z)({}, statess));
            if (lodash_default().isEmpty(statess)) {
                clearALLFilter();
            }
        } else {
            setSearch(e.target.value);
            debouncedCallApi();
        }
    };
    // console.log("statestate", state);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_infinite_scroller_default()), {
                    pageStart: 0,
                    loadMore: loadState ? loadFunc : null,
                    hasMore: hasMoreBots,
                    loader: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (botStore_module_default()).loader,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (botStore_module_default()).spinner
                        })
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (botStore_module_default()).storeContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_index, {
                                data: bannerData
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(exportBotBand, {
                                userRole: props.userRole,
                                filters: filterStateExport,
                                setLoading: setLoading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((botStore_module_default()).search, " container"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                        name: "searchGrayIcon",
                                        className: (botStore_module_default()).searchIcon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        placeholder: lodash_default().get(props, "data[1].component.content.field_bot_store_filters_fields[0].field_title", ""),
                                        onChange: inputChange,
                                        name: "search",
                                        value: search ? search : "",
                                        ref: inputRef
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (botStore_module_default()).blankDiv
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                className: "".concat((botStore_module_default()).mainContainer, " container"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_index, {
                                        data: content,
                                        clearALLFilter: clearALLFilter,
                                        initialStates: initialStates,
                                        state: state,
                                        setState: setState,
                                        reset: reset,
                                        setReset: setReset
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (botStore_module_default()).filtergray,
                                        children: [
                                            !Object.values(state).every(function(x) {
                                                return x == "";
                                            }) && Object.keys(state).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (botStore_module_default()).filtercontent,
                                                children: Object.keys(state).map(function(keyname, i) {
                                                    return state[keyname] == "" || state[keyname] == null ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((botStore_module_default()).labelfilter),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: state[keyname]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                name: "grayclose",
                                                                className: (botStore_module_default()).closeicon,
                                                                onClick: function() {
                                                                    return removeFilter(keyname);
                                                                }
                                                            })
                                                        ]
                                                    }, i);
                                                })
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: allBots.length != 0 ? (botStore_module_default()).cardContainer : (botStore_module_default()).noresultsmain,
                                                children: [
                                                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {
                                                        parent: "botStore"
                                                    }) : null,
                                                    allBots.length != 0 ? allBots.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (botStore_module_default()).card,
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicBotCard["default"], {
                                                                    data: item
                                                                }, index)
                                                            ]
                                                        }, index);
                                                    }) : noResultFlag ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (botStore_module_default()).noresults,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(lodash_default().get(data[2], "component.content.field_no_result_image[0].file_url", ""))
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                className: (botStore_module_default()).head,
                                                                children: [
                                                                    " ",
                                                                    lodash_default().get(data[2], "component.content.field_title", "")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (botStore_module_default()).content,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: lodash_default().get(data[2], "component.content.field_details", "")
                                                                }
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (botStore_module_default()).mobileFilterBtn,
                                onClick: function() {
                                    return setFilterActive(true);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (botStore_module_default()).btn,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                            name: "filters",
                                            className: (botStore_module_default()).filterIcon
                                        }),
                                        "Filters",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                            className: (botStore_module_default()).filterCount,
                                            children: length > 5 ? 5 : length
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }, infiniteKey)
            }, infiniteKey),
            filterActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilters_index, {
                filterMobileData: content.field_bot_store_filters_fields.filter(function(item) {
                    return item.field_label != "Search";
                }),
                setState: setState,
                setFilterActive: setFilterActive,
                previousState: state,
                mobileFilterRelatedInfo: mobileFilterRelatedInfo,
                setMobileFilterRelatedInfo: setMobileFilterRelatedInfo,
                setLength: setLength,
                length: length,
                setFilterOn: setFilterOn,
                initialState: initialStates
            }) : null
        ]
    });
}
var botStorePage_mapStateToProps = function(state) {
    return {
        storeBot: state.storeBot
    };
};
/* harmony default export */ var botStorePage = ((0,es/* connect */.$j)(botStorePage_mapStateToProps, null)(botStorePage_index));

// EXTERNAL MODULE: ./redux/products/actionTypes.js
var products_actionTypes = __webpack_require__(39880);
;// CONCATENATED MODULE: ./redux/products/actions.js










var getProductAction = function(param) {
    var currentPage = param.currentPage, size = param.size, filter = param.filter;
    return function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(dispatch) {
            var authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            (0,actions/* checkExpiry */.Wr)(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            return [
                                2,
                                axios_default()({
                                    method: "post",
                                    url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/getProducts"),
                                    data: {
                                        "product_id": "All",
                                        "page": currentPage,
                                        "size": size,
                                        "cluster": filter["cluster"] || "",
                                        "clusters_live": filter["clusters_live"] || "",
                                        "catalog_products": filter["catalog_products"] || "",
                                        "sub_area": filter["sub_area"] || "",
                                        "product_title": filter["product_title"] || ""
                                    },
                                    headers: {
                                        Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                    }
                                }).then(function(response) {
                                    if (response.data.code == 200) {
                                        var ref;
                                        dispatch(saveBotsAction({
                                            data: response.data.data,
                                            filter: false,
                                            total: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.total
                                        }));
                                    } else if (response.data.code == 403) {
                                        localStorage.removeItem("auth");
                                        sessionStorage.clear();
                                        // router.push("/login");
                                        dispatch((0,actions/* sessionTimeOutCheck */.Iy)(true));
                                    } else {
                                        dispatch(getBotsFailed());
                                    }
                                })
                            ];
                        } else {
                            dispatch((0,actions/* sessionTimeOutCheck */.Iy)(true));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getFilterBotsAction = function(botIndex, Filters) {
    var auth = JSON.parse(localStorage.getItem("auth")).data;
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var authCheck, expiryStatus, auth;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            return [
                                2,
                                axios({
                                    method: "get",
                                    url: "".concat(endpoint.baseUrl, "/elastic/searchQuery"),
                                    params: _object_spread_props(_object_spread({}, Filters), {
                                        botIndex: botIndex
                                    }),
                                    headers: {
                                        Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                    }
                                }).then(function(resp) {
                                    if (resp.data.code == 200) {
                                        dispatch(saveBotsAction({
                                            data: resp.data.data,
                                            filter: true,
                                            botIndex: botIndex
                                        }));
                                    } else if (resp.data.code == 403) {
                                        localStorage.removeItem("auth");
                                        sessionStorage.clear();
                                        // router.push("/login");
                                        dispatch(sessionTimeOutCheck(true));
                                    } else {
                                        dispatch(getBotsFailed());
                                    }
                                })
                            ];
                        } else {
                            dispatch(sessionTimeOutCheck(true));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getFilterListAction = function() {
    var auth = JSON.parse(localStorage.getItem("auth")).data;
    return function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(dispatch) {
            var authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            (0,actions/* checkExpiry */.Wr)(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            return [
                                2,
                                axios_default()({
                                    method: "get",
                                    url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/getProductFilters"),
                                    headers: {
                                        Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                    }
                                }).then(function(resp) {
                                    if (resp.data.code == 200) {
                                        dispatch(saveFilterListProd({
                                            data: resp.data.data
                                        }));
                                    } else if (resp.data.code == 403) {
                                        localStorage.removeItem("auth");
                                        sessionStorage.clear();
                                        // router.push("/login");
                                        dispatch((0,actions/* sessionTimeOutCheck */.Iy)(true));
                                    } else {
                                        dispatch(getBotsFailed());
                                    }
                                })
                            ];
                        } else {
                            dispatch((0,actions/* sessionTimeOutCheck */.Iy)(true));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getBotsFailed = function() {
    return {
        type: products_actionTypes/* getBotsFailed */.$o
    };
};
var saveBotsAction = function(payload) {
    return {
        type: products_actionTypes/* saveBotsActionType */.Le,
        payload: payload
    };
};
// to save the bot that user clicked on
var saveCurrentBot = function(payload) {
    //console.log("at action");
    return {
        type: products_actionTypes/* saveCurrentBotActionType */.ZG,
        payload: payload
    };
};
var saveFilterListProd = function(payload) {
    //console.log("at action");
    return {
        type: products_actionTypes/* saveFilterListProdnType */.YH,
        payload: payload
    };
};
var currentBotEditedStateAction = function(payload) {
    //console.log(payload, "currentBotEditedState");
    return {
        type: actionTypes.editCurrentBotActionType,
        payload: payload
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./styles/pages/addproduct.module.scss
var addproduct_module = __webpack_require__(74039);
var addproduct_module_default = /*#__PURE__*/__webpack_require__.n(addproduct_module);
// EXTERNAL MODULE: ./node_modules/multiselect-react-dropdown/dist/index.js
var dist = __webpack_require__(60878);
// EXTERNAL MODULE: ./node_modules/react-select/creatable/dist/react-select-creatable.esm.js + 4 modules
var react_select_creatable_esm = __webpack_require__(12929);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-641ee5b8.esm.js + 4 modules
var index_641ee5b8_esm = __webpack_require__(45350);
;// CONCATENATED MODULE: ./components/Pages/Product/Addproduct.jsx



















function Addproduct_index(param) {
    var isAdd = param.isAdd, setAddProduct = param.setAddProduct, data = param.data, onSuccess = param.onSuccess;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var ref14 = (0,react.useState)({}), inputData = ref14[0], setInputData = ref14[1];
    var ref15 = (0,react.useState)([]), benefits = ref15[0], setBenifits = ref15[1];
    var ref16 = (0,react.useState)([]), process = ref16[0], setProcess = ref16[1];
    var ref17 = (0,react.useState)(false), isFormValid = ref17[0], setIsFormValid = ref17[1];
    var onChange = function(key, value) {
        checkValid();
        setInputData(function(old) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, old), (0,src_define_property/* default */.Z)({}, key, value));
        });
    };
    var onChangeBenefit = function(key, value) {
        checkValid();
        setInputData(function(old) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, old), (0,src_define_property/* default */.Z)({}, key, value.map(function(item) {
                if (item === null || item === void 0 ? void 0 : item.__isNew__) {
                    var obj = {
                        benefit: item.value,
                        benefit_icon: "benefits1.svg"
                    };
                    var _$old = (0,src_to_consumable_array/* default */.Z)(benefits);
                    _$old.push(obj);
                    setBenifits(_$old);
                    return obj;
                }
                return item.value;
            })));
        });
    };
    var onChangeProcess = function(key, value) {
        checkValid();
        setInputData(function(old) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, old), (0,src_define_property/* default */.Z)({}, key, value.map(function(item) {
                if (item === null || item === void 0 ? void 0 : item.__isNew__) {
                    var obj = {
                        process_text: item.value,
                        process_head: ""
                    };
                    var _$old = (0,src_to_consumable_array/* default */.Z)(process);
                    _$old.push(obj);
                    setProcess(_$old);
                    return obj;
                }
                return item.value;
            })));
        });
    };
    (0,react.useEffect)(function() {
        if (data) {
            var ccData = JSON.parse(JSON.stringify(data));
            var lead = (0,src_to_consumable_array/* default */.Z)(ccData.lead);
            var act = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ccData), {
                lead: lead.map(function(item) {
                    item.country = item.country.toString();
                    return item;
                })
            });
            setInputData(act);
            setBenifits(data.benefits);
            setProcess(data.process);
        } else {
            setInputData({
                lead: [
                    {
                        cluster: "",
                        country: ""
                    }
                ]
            });
        }
    }, []);
    var addUpdateProduct = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var auth, body, productResponse, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        body = (0,src_object_spread/* default */.Z)({}, inputData);
                        body.lead = body.lead.map(function(item) {
                            var ref;
                            item.country = item === null || item === void 0 ? void 0 : (ref = item.country) === null || ref === void 0 ? void 0 : ref.split(",");
                            return item;
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl).concat(isAdd ? "/task/createProduct" : "/task/updateProduct"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: body
                            })
                        ];
                    case 2:
                        productResponse = _state.sent();
                        onSuccess();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.log("failed to create Product" + e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function addUpdateProduct() {
            return _ref.apply(this, arguments);
        };
    }();
    var onLeadChange = function(idx, key, value) {
        var cc = (0,src_to_consumable_array/* default */.Z)(inputData.lead);
        cc[idx] = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cc[idx]), (0,src_define_property/* default */.Z)({}, key, value));
        onChange("lead", cc);
    };
    var addLead = function() {
        var cc = (0,src_to_consumable_array/* default */.Z)(inputData.lead);
        cc.push({
            cluster: "",
            country: ""
        });
        onChange("lead", cc);
    };
    var removeLead = function(idx) {
        var cc = (0,src_to_consumable_array/* default */.Z)(inputData.lead);
        cc.splice(idx, 1);
        onChange("lead", cc);
    };
    var checkValid = function() {
        var ref;
        var isValid = (inputData === null || inputData === void 0 ? void 0 : inputData.catalog_products) != "" && (inputData === null || inputData === void 0 ? void 0 : inputData.catalog_products) != null && (inputData === null || inputData === void 0 ? void 0 : (ref = inputData.lead) === null || ref === void 0 ? void 0 : ref.length) > 0 && (inputData === null || inputData === void 0 ? void 0 : inputData.subarea) != "" && (inputData === null || inputData === void 0 ? void 0 : inputData.subarea) != null && (inputData === null || inputData === void 0 ? void 0 : inputData.product_title) != "" && (inputData === null || inputData === void 0 ? void 0 : inputData.product_title) != null && (inputData === null || inputData === void 0 ? void 0 : inputData.product_caption) != "" && (inputData === null || inputData === void 0 ? void 0 : inputData.product_caption) != null && (inputData === null || inputData === void 0 ? void 0 : inputData.hrs_saved) != "" && (inputData === null || inputData === void 0 ? void 0 : inputData.hrs_saved) != null && (inputData === null || inputData === void 0 ? void 0 : inputData.hrs_saved_text) != "" && (inputData === null || inputData === void 0 ? void 0 : inputData.hrs_saved_text) != null && (inputData === null || inputData === void 0 ? void 0 : inputData.product_banner) != "" && (inputData === null || inputData === void 0 ? void 0 : inputData.product_banner) != null && (inputData === null || inputData === void 0 ? void 0 : inputData.product_video) != "" && (inputData === null || inputData === void 0 ? void 0 : inputData.product_video) != null && (inputData === null || inputData === void 0 ? void 0 : inputData.product_description) != "" && (inputData === null || inputData === void 0 ? void 0 : inputData.product_description) != null;
        setIsFormValid(isValid);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (botStore_module_default()).storeContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            name: "product",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((addproduct_module_default()).addProductContainer, " container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: "Lead Platform"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                disabled: true,
                                                value: inputData.lead_platform,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("lead_platform", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Business Function",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                value: inputData.catalog_products,
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("catalog_products", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: "Product Status"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                disabled: true,
                                                value: inputData.product_status,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("product_status", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    inputData === null || inputData === void 0 ? void 0 : (ref = inputData.lead) === null || ref === void 0 ? void 0 : ref.map(function(item, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (addproduct_module_default()).addFormControl,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                children: [
                                                    "Cluster",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            color: "red"
                                                        },
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (addproduct_module_default()).field,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    value: item.cluster,
                                                    type: "text",
                                                    onChange: function(e) {
                                                        var ref;
                                                        return onLeadChange(idx, "cluster", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (addproduct_module_default()).addFormControl,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                children: [
                                                    "Country",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            color: "red"
                                                        },
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (addproduct_module_default()).field,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    value: item.country,
                                                    type: "text",
                                                    onChange: function(e) {
                                                        var ref;
                                                        return onLeadChange(idx, "country", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((addproduct_module_default()).leadRowButtons, " col-md-1"),
                                    children: [
                                        idx == inputData.lead.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                return addLead();
                                            },
                                            children: "Add"
                                        }),
                                        inputData.lead.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                return removeLead(idx);
                                            },
                                            children: "Remove"
                                        })
                                    ]
                                })
                            ]
                        });
                    }),
                    (inputData === null || inputData === void 0 ? void 0 : (ref1 = inputData.lead) === null || ref1 === void 0 ? void 0 : ref1.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((addproduct_module_default()).leadRowButtons, " col-md-1"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: function() {
                                        return addLead();
                                    },
                                    children: "Add"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Area",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                value: inputData.area,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("area", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Subarea",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                value: inputData.subarea,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("subarea", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Product Title",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                value: inputData.product_title,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("product_title", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: "Clusters Live"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                disabled: true,
                                                type: "text",
                                                value: inputData.clusters_live,
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("clusters_live", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Product Caption",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                value: inputData.product_caption,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("product_caption", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                },
                                                required: "true"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Hrs Saved",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                value: inputData.hrs_saved,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("hrs_saved", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Hrs_saved_text",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                value: inputData.hrs_saved_text,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("hrs_saved_text", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Benefits",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_creatable_esm/* default */.Z, {
                                            value: inputData === null || inputData === void 0 ? void 0 : (ref2 = inputData.benefits) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                                                return {
                                                    label: item.benefit,
                                                    value: item
                                                };
                                            }),
                                            onChange: function(e) {
                                                onChangeBenefit("benefits", e);
                                            },
                                            options: benefits === null || benefits === void 0 ? void 0 : benefits.map(function(item) {
                                                return {
                                                    label: item.benefit,
                                                    value: item
                                                };
                                            }),
                                            isMulti: true,
                                            hideSelectedOptions: false,
                                            components: {
                                                ValueContainer: ValueContainer
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Process",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_creatable_esm/* default */.Z, {
                                            value: inputData === null || inputData === void 0 ? void 0 : (ref3 = inputData.process) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
                                                return {
                                                    label: item.process_text,
                                                    value: item
                                                };
                                            }),
                                            onChange: function(e) {
                                                onChangeProcess("process", e);
                                            },
                                            options: process === null || process === void 0 ? void 0 : process.map(function(item) {
                                                return {
                                                    label: item.process_text,
                                                    value: item
                                                };
                                            }),
                                            isMulti: true,
                                            hideSelectedOptions: false,
                                            components: {
                                                ValueContainer: ValueContainer
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Product Icon",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                value: inputData.product_banner,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("product_banner", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Product Video",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                value: inputData.product_video,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("product_video", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).addFormControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                "Product Description ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (addproduct_module_default()).field,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                value: inputData.product_description,
                                                type: "text",
                                                onChange: function(e) {
                                                    var ref;
                                                    return onChange("product_description", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (addproduct_module_default()).addFormControl,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#73706e",
                                            fontSize: "14px",
                                            paddingRight: "3px"
                                        },
                                        children: "Document URL"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "checkbox",
                                        checked: inputData.isDocument,
                                        onChange: function(e) {
                                            var ref;
                                            return onChange("isDocument", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.checked);
                                        }
                                    }),
                                    inputData.isDocument && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (addproduct_module_default()).field,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            value: inputData.document_url,
                                            type: "text",
                                            onChange: function(e) {
                                                var ref;
                                                return onChange("document_url", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row mt-5 pt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-6 col-12 align-self-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (addproduct_module_default()).iframe_section,
                                dangerouslySetInnerHTML: {
                                    __html: "<iframe src=".concat((inputData === null || inputData === void 0 ? void 0 : (ref4 = inputData.product_video) === null || ref4 === void 0 ? void 0 : ref4.includes("https://www.youtube.com/watch?v=")) ? (ref5 = inputData === null || inputData === void 0 ? void 0 : inputData.product_video) === null || ref5 === void 0 ? void 0 : ref5.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/") : (inputData === null || inputData === void 0 ? void 0 : (ref6 = inputData.product_video) === null || ref6 === void 0 ? void 0 : ref6.includes("https://drive.google.com")) ? (ref7 = inputData === null || inputData === void 0 ? void 0 : inputData.product_video) === null || ref7 === void 0 ? void 0 : ref7.replace("view", "preview") : inputData === null || inputData === void 0 ? void 0 : inputData.product_video, " paused/>")
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        class: "row mb-3 mt-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: (addproduct_module_default()).actionButtons,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    class: (addproduct_module_default()).buttons,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            class: (addproduct_module_default()).cancel,
                                            onClick: function() {
                                                return setAddProduct(false);
                                            },
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            class: isFormValid ? (addproduct_module_default()).save : (addproduct_module_default()).saveBlock,
                                            onClick: addUpdateProduct,
                                            children: "Save"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    ((inputData === null || inputData === void 0 ? void 0 : (ref8 = inputData.benefits) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 || (inputData === null || inputData === void 0 ? void 0 : (ref9 = inputData.process) === null || ref9 === void 0 ? void 0 : ref9.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (addproduct_module_default()).benefits_section,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container h-100",
                            children: [
                                (inputData === null || inputData === void 0 ? void 0 : (ref10 = inputData.benefits) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addproduct_module_default()).Frist_section,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                children: "Top Benefits"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row ",
                                            children: (inputData === null || inputData === void 0 ? void 0 : (ref11 = inputData.benefits) === null || ref11 === void 0 ? void 0 : ref11.length) > 0 && (inputData === null || inputData === void 0 ? void 0 : inputData.benefits.map(function(va) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-3 col-6 mb-4 mb-md-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (addproduct_module_default()).cards_benefits,
                                                        style: {
                                                            marginBottom: "15px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(imageBaseURL + va.benefit_icon),
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: va.benefit
                                                            })
                                                        ]
                                                    })
                                                });
                                            }))
                                        })
                                    ]
                                }),
                                (inputData === null || inputData === void 0 ? void 0 : (ref12 = inputData.process) === null || ref12 === void 0 ? void 0 : ref12.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-6 ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-center position-relative bot_section ".concat((addproduct_module_default()).cards_benefits_card),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "robo.png"),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "back_image",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(imageBaseURL, "dot.svg"),
                                                                className: (addproduct_module_default()).img_1,
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(imageBaseURL, "dot1.svg"),
                                                                className: (addproduct_module_default()).img_2,
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(imageBaseURL, "dot2.svg"),
                                                                className: (addproduct_module_default()).img_3,
                                                                alt: ""
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "",
                                                    style: {
                                                        fontWeight: "600"
                                                    },
                                                    children: inputData === null || inputData === void 0 ? void 0 : inputData.process_caption
                                                }),
                                                (inputData === null || inputData === void 0 ? void 0 : inputData.process_tex) !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mb-4",
                                                    children: inputData === null || inputData === void 0 ? void 0 : inputData.process_text
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                                    children: (inputData === null || inputData === void 0 ? void 0 : (ref13 = inputData.process) === null || ref13 === void 0 ? void 0 : ref13.length) > 0 && (inputData === null || inputData === void 0 ? void 0 : inputData.process.map(function(va) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    va.process_head !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        style: {
                                                                            color: "#1F36C7"
                                                                        },
                                                                        children: "Detection Systems"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: va.process_text
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    }))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var ValueContainer = function(_param) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var _children = (0,src_sliced_to_array/* default */.Z)(children, 2), values = _children[0], input = _children[1];
    if (Array.isArray(values)) {
        var length = values.length;
        values = "".concat(length, " item selected");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_641ee5b8_esm.c.ValueContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: [
            values,
            input
        ]
    }));
};
/* harmony default export */ var Addproduct = (Addproduct_index);

;// CONCATENATED MODULE: ./components/Pages/Product/ProductDetailsPage.jsx














function ProductDetailsPage_index(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31;
    var ref32 = (0,react.useState)({}), auth = ref32[0], setAuth = ref32[1];
    var ref33 = (0,react.useState)(false), editProduct = ref33[0], setEditProduct = ref33[1];
    var ref34 = (0,react.useState)({}), editData = ref34[0], setEditData = ref34[1];
    var router = (0,next_router.useRouter)();
    var goToPage1 = function(link) {
        router.push("/product");
    };
    var ref35 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), currentBot = ref35[0], setCurrentBot = ref35[1];
    var ref36 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), loading = ref36[0], setLoading = ref36[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    react.useEffect(function() {
        //console.log(props.currentBot,"====>cuurender")
        setCurrentBot(props.currentBot);
        if (props.currentBot[0]) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            var editData = {
                product_id: window.atob(router.query.prodId),
                mco: "",
                clusters_live: (ref = props.currentBot[0]) === null || ref === void 0 ? void 0 : ref.clusters_live,
                subarea: (ref1 = props.currentBot[0]) === null || ref1 === void 0 ? void 0 : ref1.subarea,
                lead_platform: (ref2 = props.currentBot[0].lead[0]) === null || ref2 === void 0 ? void 0 : ref2.lead_platform,
                lead: (ref3 = props.currentBot[0]) === null || ref3 === void 0 ? void 0 : ref3.leads,
                catalog_products: (ref4 = props.currentBot[0]) === null || ref4 === void 0 ? void 0 : ref4.catalog_products,
                product_status: (ref5 = props.currentBot[0]) === null || ref5 === void 0 ? void 0 : ref5.product_status,
                product_title: (ref6 = props.currentBot[0]) === null || ref6 === void 0 ? void 0 : ref6.product_title,
                product_caption: (ref7 = props.currentBot[0]) === null || ref7 === void 0 ? void 0 : ref7.product_caption,
                hrs_saved: (ref8 = props.currentBot[0]) === null || ref8 === void 0 ? void 0 : ref8.hrs_saved,
                hrs_saved_text: (ref9 = props.currentBot[0]) === null || ref9 === void 0 ? void 0 : ref9.hrs_saved_text,
                benefits: (ref10 = props.currentBot[0]) === null || ref10 === void 0 ? void 0 : ref10.benefits_array,
                process: (ref11 = props.currentBot[0]) === null || ref11 === void 0 ? void 0 : ref11.process_array,
                product_banner: (ref12 = props.currentBot[0]) === null || ref12 === void 0 ? void 0 : ref12.product_banner,
                product_video: (ref13 = props.currentBot[0]) === null || ref13 === void 0 ? void 0 : ref13.product_video,
                product_description: (ref14 = props.currentBot[0]) === null || ref14 === void 0 ? void 0 : ref14.product_description,
                isDocument: (ref15 = props.currentBot[0]) === null || ref15 === void 0 ? void 0 : ref15.isDocument,
                document_url: (ref16 = props.currentBot[0]) === null || ref16 === void 0 ? void 0 : ref16.document_url,
                area: (ref17 = props.currentBot[0]) === null || ref17 === void 0 ? void 0 : ref17.area
            };
            setEditData(editData);
        }
    }, [
        props.currentBot
    ]);
    var fetchProd = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(auth) {
            var authCheck, expiryStatus;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!router.query.prodId) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        authCheck = _state.sent();
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            axios_default()({
                                method: "post",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/getProducts"),
                                data: {
                                    "product_id": window.atob(router.query.prodId),
                                    "cluster": "",
                                    "clusters_live": "",
                                    "catalog_products": "",
                                    "product_title": "",
                                    "sub_area": ""
                                },
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(res) {
                                if (res.data.code == 200) {
                                    //console.log(res.data.data, "data bot from response");
                                    if (res.data.data) {
                                        dispatch(saveCurrentBot(res.data.data));
                                    }
                                }
                            });
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchProd(auth) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var authCheck, expiryStatus, auth;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authCheck = _.get(JSON.parse(localStorage.getItem("auth")), "data", "");
                    return [
                        4,
                        props.checkExpiry(authCheck)
                    ];
                case 1:
                    expiryStatus = _state.sent();
                    if (expiryStatus) {
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        fetchProd(auth);
                        setAuth(auth);
                    } else {
                        setLoading(false);
                        props.sessionTimeOutCheck(true);
                    }
                    if (router.query.searchResults) {
                        setSearchResults(true);
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        router.query
    ]);
    react.useEffect(function() {
    //console.log(router.query, "all kinda queries")
    }, [
        router.query
    ]);
    var deleteProduct = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var auth, productResponse, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/deleteProduct"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    "product_id": window.atob(router.query.prodId)
                                }
                            })
                        ];
                    case 2:
                        productResponse = _state.sent();
                        goToPage1();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.log("failed to delete Product " + e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteProduct() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !editProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "800px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader, {})
            }) : currentBot.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container h-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                class: (botStore_module_default()).breadcrumb,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: function() {
                                                return void 0;
                                            },
                                            onClick: function() {
                                                return goToPage1();
                                            },
                                            children: "Product Page"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: function() {
                                                return void 0;
                                            },
                                            children: (ref = currentBot[0]) === null || ref === void 0 ? void 0 : ref.catalog_products
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: (ref1 = currentBot[0]) === null || ref1 === void 0 ? void 0 : ref1.product_title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row mt-5 pt-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-md-6 col-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (botStore_module_default()).crard_main_section,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center mb-2 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(imageBaseURL + ((ref2 = currentBot[0]) === null || ref2 === void 0 ? void 0 : ref2.product_banner)),
                                                                alt: "",
                                                                className: "mr-2"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                style: {
                                                                    fontWeight: "600"
                                                                },
                                                                children: (ref3 = currentBot[0]) === null || ref3 === void 0 ? void 0 : ref3.product_title
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (botStore_module_default()).card_section1,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mb-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "".concat(imageBaseURL, "maps.svg"),
                                                                        alt: "",
                                                                        className: "mr-2"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: (ref4 = currentBot[0]) === null || ref4 === void 0 ? void 0 : ref4.lead[0].lead_platform
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: ((ref5 = currentBot[0]) === null || ref5 === void 0 ? void 0 : ref5.leads.length) > 0 && ((ref6 = currentBot[0]) === null || ref6 === void 0 ? void 0 : ref6.leads.map(function(va) {
                                                                    return va.country && va.country != "" ? "".concat(va.cluster, " (").concat(va.country, ") ") : "".concat(va.cluster);
                                                                }))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "crard_main_section_p",
                                                        children: (ref7 = currentBot[0]) === null || ref7 === void 0 ? void 0 : ref7.product_caption
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (botStore_module_default()).blue_card_section,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex align-items-center justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex mr-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                className: "align-self-center mr-4",
                                                                children: (ref8 = currentBot[0]) === null || ref8 === void 0 ? void 0 : ref8.hrs_saved
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "align-self-center",
                                                                children: (ref9 = currentBot[0]) === null || ref9 === void 0 ? void 0 : ref9.hrs_saved_text
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-6 col-12 align-self-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (botStore_module_default()).iframe_section,
                                            dangerouslySetInnerHTML: {
                                                __html: '<iframe src="'.concat(((ref10 = currentBot[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.product_video) === null || ref11 === void 0 ? void 0 : ref11.includes("https://www.youtube.com/watch?v=")) ? (ref13 = (ref12 = currentBot[0]) === null || ref12 === void 0 ? void 0 : ref12.product_video) === null || ref13 === void 0 ? void 0 : ref13.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/") : ((ref14 = currentBot[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.product_video) === null || ref15 === void 0 ? void 0 : ref15.includes("https://drive.google.com")) ? (ref17 = (ref16 = currentBot[0]) === null || ref16 === void 0 ? void 0 : ref16.product_video) === null || ref17 === void 0 ? void 0 : ref17.replace("view", "preview") : (ref18 = currentBot[0]) === null || ref18 === void 0 ? void 0 : ref18.product_video, '" paused/>')
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                style: {
                                    marginTop: "10px",
                                    marginBottom: "15px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-8",
                                        children: ((ref19 = currentBot[0]) === null || ref19 === void 0 ? void 0 : ref19.isDocument) && ((ref20 = currentBot[0]) === null || ref20 === void 0 ? void 0 : ref20.document_url) && ((ref21 = currentBot[0]) === null || ref21 === void 0 ? void 0 : ref21.document_url) != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: (ref22 = currentBot[0]) === null || ref22 === void 0 ? void 0 : ref22.document_url,
                                            target: "blank",
                                            children: "Document URL"
                                        })
                                    }),
                                    auth.userType === "admin" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-2",
                                                style: {
                                                    paddingLeft: "50px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        minWidth: "123px",
                                                        height: "39px",
                                                        padding: "8px 16px",
                                                        border: "0.4px solid #000000",
                                                        borderRadius: "4px",
                                                        fontSize: "15px",
                                                        fontWeight: 400,
                                                        color: "#000000",
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return setEditProduct(true);
                                                    },
                                                    children: "Edit Product"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-2",
                                                style: {
                                                    paddingLeft: "30px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        minWidth: "123px",
                                                        height: "39px",
                                                        padding: "8px 16px",
                                                        border: "0.4px solid red",
                                                        borderRadius: "4px",
                                                        fontSize: "15px",
                                                        fontWeight: 400,
                                                        color: "red",
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return deleteProduct(true);
                                                    },
                                                    children: "Delete Product"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (botStore_module_default()).benefits_section,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container h-100",
                            children: [
                                ((ref23 = currentBot[0]) === null || ref23 === void 0 ? void 0 : ref23.benefits_array.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (botStore_module_default()).Frist_section,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                children: "Top Benefits"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row ",
                                            children: ((ref24 = currentBot[0]) === null || ref24 === void 0 ? void 0 : ref24.benefits_array.length) > 0 && ((ref25 = currentBot[0]) === null || ref25 === void 0 ? void 0 : ref25.benefits_array.map(function(va) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-3 col-6 mb-4 mb-md-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (botStore_module_default()).cards_benefits,
                                                        style: {
                                                            marginBottom: "15px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(imageBaseURL + va.benefit_icon),
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: va.benefit
                                                            })
                                                        ]
                                                    })
                                                });
                                            }))
                                        })
                                    ]
                                }),
                                ((ref26 = currentBot[0]) === null || ref26 === void 0 ? void 0 : ref26.process_array.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-6 ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-center position-relative bot_section ".concat((botStore_module_default()).cards_benefits_card),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "robo.png"),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "back_image",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(imageBaseURL, "dot.svg"),
                                                                className: (botStore_module_default()).img_1,
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(imageBaseURL, "dot1.svg"),
                                                                className: (botStore_module_default()).img_2,
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(imageBaseURL, "dot2.svg"),
                                                                className: (botStore_module_default()).img_3,
                                                                alt: ""
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "",
                                                    style: {
                                                        fontWeight: "600"
                                                    },
                                                    children: (ref27 = currentBot[0]) === null || ref27 === void 0 ? void 0 : ref27.process_caption
                                                }),
                                                ((ref28 = currentBot[0]) === null || ref28 === void 0 ? void 0 : ref28.process_tex) !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mb-4",
                                                    children: (ref29 = currentBot[0]) === null || ref29 === void 0 ? void 0 : ref29.process_text
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                                    children: ((ref30 = currentBot[0]) === null || ref30 === void 0 ? void 0 : ref30.process_array.length) > 0 && ((ref31 = currentBot[0]) === null || ref31 === void 0 ? void 0 : ref31.process_array.map(function(va) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    va.process_head !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        style: {
                                                                            color: "#1F36C7"
                                                                        },
                                                                        children: "Detection Systems"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        style: {
                                                                            marginBottom: "0px"
                                                                        },
                                                                        children: va.process_text
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    }))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Addproduct, {
            setAddProduct: setEditProduct,
            data: editData,
            onSuccess: function() {
                setEditProduct(false);
                location.reload();
            },
            isAdd: false
        })
    });
}
var ProductDetailsPage_mapStateToProps = function(state) {
    return {
        currentBot: state.storeProduct.currentProducts
    };
};
/* harmony default export */ var ProductDetailsPage = ((0,es/* connect */.$j)(ProductDetailsPage_mapStateToProps, null)(ProductDetailsPage_index));

;// CONCATENATED MODULE: ./components/Pages/Product/Productdetailscupa.jsx






function Productdetailscupa_index(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), currentBot = ref[0], setCurrentBot = ref[1];
    react.useEffect(function() {
        setCurrentBot(props.currentBot);
    }, [
        props.currentBot
    ]);
    react.useEffect(function() {
    //console.log(router.query, "all kinda queries")
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container h-100",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row mt-5 pt-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-md-6 col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (botStore_module_default()).crard_main_section,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex align-items-center mb-2 pb-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(imageBaseURL, "product01.svg"),
                                            alt: "",
                                            className: "mr-2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            style: {
                                                fontWeight: "600"
                                            },
                                            children: "Coupa PO Creation"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (botStore_module_default()).card_section1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mb-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "maps.svg"),
                                                    alt: "",
                                                    className: "mr-2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Clusters Live"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Europe(Poland, Romania)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "crard_main_section_p",
                                    children: "We can help you automate PO Creation with Coupa for a faster & efficient solution"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (botStore_module_default()).blue_card_section,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex justify-content-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex align-items-center justify-content-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "align-self-center mr-4",
                                                children: "1400+"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "align-self-center",
                                                children: "Manual hours saved per country"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: " Business places creation requests in Sharepoint"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Bot runs on agreed schedules"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Picks pending requests"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Send PR requests details & attachments to Mule API"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Approver to review & approve requests"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Send PO pending requests to Mule API"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Acknowledge users about completion"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var Productdetailscupa = (Productdetailscupa_index);

;// CONCATENATED MODULE: ./components/Pages/Product/Productdetailssap.jsx






function Productdetailssap_index(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), currentBot = ref[0], setCurrentBot = ref[1];
    react.useEffect(function() {
        setCurrentBot(props.currentBot);
    }, [
        props.currentBot
    ]);
    react.useEffect(function() {
        console.log(router.query, "all kinda queries");
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container h-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row mt-5 pt-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-6 col-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (botStore_module_default()).crard_main_section,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex align-items-center mb-2 pb-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "product01.svg"),
                                                    alt: "",
                                                    className: "mr-2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    style: {
                                                        fontWeight: "600"
                                                    },
                                                    children: "PO Creation SAP"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).card_section1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "".concat(imageBaseURL, "maps.svg"),
                                                            alt: "",
                                                            className: "mr-2"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Clusters Live"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "NAMETRUB (Turkey), SEAA (Malaysia, Singapore) North America (USA), EU(Italy)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "crard_main_section_p",
                                            children: "Reduced the manual effort spent on PO creation transactions"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (botStore_module_default()).blue_card_section,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex d-flex justify-content-center text-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "align-self-center mr-4",
                                                children: "70%"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "align-self-center ",
                                                children: "Reduction in Manual effort"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-6 col-12 align-self-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (botStore_module_default()).iframe_section,
                                dangerouslySetInnerHTML: {
                                    __html: "<iframe src=".concat(imageBaseURL, "sap.mp4 />")
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (botStore_module_default()).benefits_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container h-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Top Benefits"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (botStore_module_default()).Frist_section,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "70% of reduction in the manual effects"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits1.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Increased accuracy"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits2.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Scalable "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Process"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits3.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Timely outputs shared with users"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center position-relative ".concat((botStore_module_default()).cards_benefits_card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(imageBaseURL, "robo.png"),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "back_image",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot.svg"),
                                                        className: (botStore_module_default()).img_1,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot1.svg"),
                                                        className: (botStore_module_default()).img_2,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot2.svg"),
                                                        className: (botStore_module_default()).img_3,
                                                        alt: ""
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mb-5",
                                            style: {
                                                fontWeight: "600"
                                            },
                                            children: "Process"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: " Users will send the data in an excel file to the Bot"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Bot will perform validations on the data shared by users and will log in to SAP"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Bot will generate the PO copy and will update users on the completion"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Bot will then created the POs in SAP"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var Productdetailssap = (Productdetailssap_index);

;// CONCATENATED MODULE: ./components/Pages/Product/Productdetailschatbot.jsx






function Productdetailschatbot_index(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), currentBot = ref[0], setCurrentBot = ref[1];
    react.useEffect(function() {
        setCurrentBot(props.currentBot);
    }, [
        props.currentBot
    ]);
    react.useEffect(function() {
    //console.log(router.query, "all kinda queries")
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container h-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row mt-5 pt-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-6 col-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (botStore_module_default()).crard_main_section,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex align-items-center mb-2 pd-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "product-details.svg"),
                                                    alt: "",
                                                    className: "mr-2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    style: {
                                                        fontWeight: "600"
                                                    },
                                                    children: "Shareholder Chatbot"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).card_section1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "".concat(imageBaseURL, "maps.svg"),
                                                            alt: "",
                                                            className: "mr-2"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Clusters Live"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "South Asia (India)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "crard_main_section_p",
                                            children: "Your one stop guide for all information related to trading and investing in unilever shares"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (botStore_module_default()).blue_card_section,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex align-items-center justify-content-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "align-self-center mr-4",
                                                    children: "24x7"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "align-self-center",
                                                    children: "Availability of an assistant to answer all your HUL Share queries"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-6 col-12 align-self-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (botStore_module_default()).iframe_section,
                                dangerouslySetInnerHTML: {
                                    __html: "<iframe src=".concat(imageBaseURL, "chat.mp4 />")
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (botStore_module_default()).benefits_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container h-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Top Benefits"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (botStore_module_default()).Frist_section,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: " Increased Effectiveness"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits1.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Informed decision making"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits2.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Simplified Process "
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits3.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "24X7 Availability"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center position-relative ".concat((botStore_module_default()).cards_benefits_card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(imageBaseURL, "robo.png"),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "back_image",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot.svg"),
                                                        className: (botStore_module_default()).img_1,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot1.svg"),
                                                        className: (botStore_module_default()).img_2,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot2.svg"),
                                                        className: (botStore_module_default()).img_3,
                                                        alt: ""
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "",
                                            style: {
                                                fontWeight: "600"
                                            },
                                            children: "Features"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Your stop guide!"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: " Addresses queries discreetly"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Notifies you on timelines"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Buying and selling multiples shares"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Alerts during Open & Closed periods"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Do's and Dont's of trading"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var Productdetailschatbot = (Productdetailschatbot_index);

;// CONCATENATED MODULE: ./components/Pages/Product/Productsdetailssuit.jsx






function Productsdetailssuit_index(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), currentBot = ref[0], setCurrentBot = ref[1];
    react.useEffect(function() {
        setCurrentBot(props.currentBot);
    }, [
        props.currentBot
    ]);
    react.useEffect(function() {
    //console.log(router.query, "all kinda queries")
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container h-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row mt-5 pt-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-6 col-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (botStore_module_default()).crard_main_section,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex align-items-center mb-2 pb-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "product-details.svg"),
                                                    alt: "",
                                                    className: "mr-2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    style: {
                                                        fontWeight: "600"
                                                    },
                                                    children: " Safety Suite"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).card_section1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "".concat(imageBaseURL, "maps.svg"),
                                                            alt: "",
                                                            className: "mr-2"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Clusters Live"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: " South Asia (India) , LATAM (Guatemala,El Salvador) "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "crard_main_section_p",
                                            children: "A video analytics tool specifically designed for people’s health and safety. Get real time SMS, Whatsapp alerts, Web & Desktop Dashboards."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((botStore_module_default()).blue_card_section, " col-12 col-md-4"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        class: "justify-content-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                children: "24x7"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "availability"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-6 col-12 align-self-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (botStore_module_default()).iframe_section,
                                dangerouslySetInnerHTML: {
                                    __html: "<iframe src=".concat(imageBaseURL, "suit.mp4 />")
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (botStore_module_default()).benefits_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container h-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Used By"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (botStore_module_default()).Frist_section,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "suit.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Factories"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "suit1.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Construction sites"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "suit2.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Warehouses "
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "suit3.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Travel Safety"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center position-relative ".concat((botStore_module_default()).cards_benefits_card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(imageBaseURL, "robo.png"),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "back_image",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot.svg"),
                                                        className: (botStore_module_default()).img_1,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot1.svg"),
                                                        className: (botStore_module_default()).img_2,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot2.svg"),
                                                        className: (botStore_module_default()).img_3,
                                                        alt: ""
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "",
                                            style: {
                                                fontWeight: "600"
                                            },
                                            children: "Safety Solution"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-4",
                                            children: "Let's be all in Safety!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                style: {
                                                                    color: "#1F36C7"
                                                                },
                                                                children: "Detection Systems"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Helmets, Face Shields, Safety Shoes, Goggles, Hand Gloves"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                style: {
                                                                    color: "#1F36C7"
                                                                },
                                                                children: "Intrusion Detection "
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Detects any unauthorised access to the restricted areas"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                style: {
                                                                    color: "#1F36C7"
                                                                },
                                                                children: " COVID Appropriate"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Detects violations in social distancing, sanitisation, and more"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                style: {
                                                                    color: "#1F36C7"
                                                                },
                                                                children: " Handrail Compliance"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Capability to prevent 'slip / trip and fall' accidents at workplace"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var Productsdetailssuit = (Productsdetailssuit_index);

// EXTERNAL MODULE: ./components/shared/Figure.js
var Figure = __webpack_require__(96326);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/suniti.png
/* harmony default export */ var suniti = ({"src":"/_next/static/media/suniti.6e1f83e3.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AJO32Ja724OWpHKSqc3Z48XQ2gDC0t+otcG0hlB3VjCWoq2Zo7EAjpyra25z1Z9nuIZVS1thbHZ1AFpfVzNDQqh5TKR1SQAfJmFhSQCCe2MWOFVhWF1vVkQUDg1YV1IAW2JcIzpYP05gACVEAAAmABYzAKWDYklIVjNAUwAeQplyVIVqTgDUn2lWSUsAJ0RiTUPfpWqPdU8NnDzr4ZpZLAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/vidish.png
/* harmony default export */ var vidish = ({"src":"/_next/static/media/vidish.3eea0316.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AMXGvn2lwXSivYSqv4esxJmwvwC0vb24xsedinmfiXS8ysrQyLcAmpCAwLqqtZR4s5R4yce8l4x/AIdtSoh2X5+Ic5aBbYFzZYNuUgCXd0tBMyfFs5aYinQAAB2Mc1EAxJliRTcstaSKcWhZGR8nkXNLANaoazo0MKSVf09MRyElKnpeOwDRo2dmV0UlLjUVKjd3YUmng1Qr50cY+U8aHgAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/anubha.png
/* harmony default export */ var anubha = ({"src":"/_next/static/media/anubha.408c8f7f.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AIyNhKq3trfFwbHGxMPFuMiVVwCEaECTf2SJd2B+WDKKbkh+XjMAWUYqtZBXm3RAzIQtbk4ooIBRAHheOqmHVmpLLMB4LmM/G7CKVADqt3DJn2QAAAhvRyUAFBpKPi0Az6Bfpn9Jcm5hb2RRAAAAS0U4AJd1RKd9RnZxYUdBNQgNE0c/MQCrgUmqgU0AABsEGyJkSy9lUDZyljjk08M+pQAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/soumya.png
/* harmony default export */ var soumya = ({"src":"/_next/static/media/soumya.a72759d1.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAx0lEQVR42g3Ku2rCUACA4f8cexClNoRCY6SlpdDStVs7dC4+h0+jz+DmG+jgBUFE3BRcRF1EIqgRLxHjJYIe/eZPFPM5/fluUxicCSnF/9uFruNpaY5LbF2HcjZNdNVDHNZsqhkhMqkfHTUsvq2AzcVgFBh0mhVkf7jAW064ixjIcIx8rc18H0Ymf195eVT0ggT3zx+U6nNiD7cUNyMMHZcn2+J41sCYma+Rjb5HqztCopm6KwAW/gn592VixxMgFf7uCIAKCa6c+kmc6o8negAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/abhilasha.png
/* harmony default export */ var abhilasha = ({"src":"/_next/static/media/abhilasha.2a0f1fba.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AMCXaaqnnK+8wu/iw7i+vZyyvwCjbzq2jVG+ro6+tZ7q3sHj2sAAY0Moelk6l2Umt4dNwrWbzLqcAIFdN21XOZVpPbV/RZ+DWLCMWgClcz95WDFnUDiQcE09Oy+ph1kAu4lOblAtlH5bgm1NAA4ax59lAMKOUWpNLXhtWFZLO0w/LZl6TwC9jVJRQCxFRDs7OzNLQjOyiVL3ukPbaa/wSAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/mamatha.png
/* harmony default export */ var mamatha = ({"src":"/_next/static/media/mamatha.6841abe6.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AKfD37nP43625sHU5JGx0aKjrwDF0dWzsK1/maeHmaLDpIC8lGQAp4lzjFwwq3lEgVUfVj4pXUUyAKyGW39kSMiUZ8iRY1I+LHtcPgC5kmiVeFd8UzSkdE0eJCGOa0gAfGBCAAAAdmVUfGdUAAAAjm5MAHJaQFE2IoZ0YlRDNikfHLOIXACIaEdyVD6zj3FMPzZQPC64iVkxuEBi+JBqGAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/tanu.png
/* harmony default export */ var tanu = ({"src":"/_next/static/media/tanu.57d7c33c.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AM/e4q7J2yul27vP2dLb24KIjgC4vru30NWz1N3B19uvta+gglUAonlEko2DnZmUnZB9mnpIcVUlAJyDVo9zRLR2La9yLnNcNXlcNQCUekzPp2zQkle3eUKNc0aMbD0Ad2A7R0Q5uZuCqY54QDswon9KAFFKOQAAALuvnbCkkwAAAMWWWgCFakcAAA2YjYCEe28AAACyhU1GB0bNPUQBRAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/ritika.png
/* harmony default export */ var ritika = ({"src":"/_next/static/media/ritika.ff7d70f1.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAyklEQVR42g3Du2rCYBiA4feP32+KNaKlpBEK0hYslN5AL6DX0q1jh95Ex24du3XsGlw8IYi6CMmioARBxCiaeIw+8Ci32TtmTFHhTjigyCYrgm4FGXddVbh9xIgX6CQmiPYMqt/IzHNZTHy2I49S7sD/IIWTvUeeymXMizQfvx7Ptgb7jl2ikNKNRccPaPSHvL99IvMhlmNjaEkRLtcA6MsccTpPMW9iTGchTiFzfsXXzx/tvo/WGiOKIorXFq8vD9TqLSTZs91sOAFodkZDOC7mZQAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/vijay.png
/* harmony default export */ var vijay = ({"src":"/_next/static/media/vijay.862115ff.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/ALPK36nI4qC91FKh2KTE4bXF0gDFvbDJ3+ukgmWhoaTL3+qaiHgAkoJxy8/Nw5h3xaKFxLyvlXZQAHdeQoNuVa6QgKKEdnlgQHdZOQCPdVcqHQiwqqyjnZ8AAACEZ0kA5Ld+Y00tl5agkIuOAAAAr4lcANWocEo4G4mKl3t6ggAAALKLXQDgr3FNOBqVmKeKiZMAAAC9kVwHVUp9ewzjxwAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/madhurima.png
/* harmony default export */ var madhurima = ({"src":"/_next/static/media/madhurima.9dc0116d.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AFJUWczNzMDDxJaxycDAwLi1twCsnpS9vr2JaEq2l4Cako6ifmEAel5InINwypFh2ZxllHlncltIAHJVPYJoU7CAW8WMXF9TSlxMPwBqUT1LPjhIQDzLon1qW1FdSz0AfFxBOjY1AAAEv6aKt5yBQi0jAIplR0Y7NgAADZR9aLKTdlU9KgCac1JPQTgADR6bgWucgGd+XUB0Yz99XGMsOAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/vishali.png
/* harmony default export */ var vishali = ({"src":"/_next/static/media/vishali.c70562af.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAoklEQVR42mNw1uBram2cuXVfZnZsc4ZtkIsJQ7SvXUZa2OaJhXMT1ZoSHXMDTBiqC+JqC/ynplseqfNy0ZU2NdJgSPY1mF3qH2mnub3UKdZZpzrCgqE41m5DlWeah/6dtTUlUfbTUqwYYryNi7z1CkMsbm9szA0wY2DgZIj2MC5w06iNstk5OSvISjXMSZfB1kA500q6OMCkPtXTWVfG21obAAz7Mt9xI4tmAAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/bhavya.png
/* harmony default export */ var bhavya = ({"src":"/_next/static/media/bhavya.78508ad8.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAxklEQVR42gWAzW7BcADAf/9/ywyNrWE7uEjmsGSu22HZvIPEo3gAN88jcXVzESQiNCgi9XFS4rslbUX0jLFfNaXY+wpZLeA7LWj2rUB9iqiikJN0Vg562OdZgBjWhDpv1vHDUZRRi1BMoRvPMptOUH4Tk3KMPWa7geZYHOwRzmmH/Mv/40mJcUxwT+aoGy6DdYD8zOh0jAWXqI73/sFpu6FU/EK1ljbnq8fUtKjMbX7SSTKpCDIkPN5e4vTsgMPtRupVw3VcHozLT2qy5pnUAAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/mriganshi.png
/* harmony default export */ var mriganshi = ({"src":"/_next/static/media/mriganshi.c6ceb33e.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAoklEQVR42mOYM2NyaXKwgypTsovGlHyf3lw/huWTmqvivdojjRJtVcuDjRuiLBk6khwqwsx3V7u1+msnOKpW+WsztCQ4ZPsZz0ixTHPWDLdWbQrVZ2hPdjLQUF1VF1gRZc3AIJXtocOwriHYy9rw1Kz0ugRHBgbpaGddhvwgMycLw4drS2vinRkYZRLt1RlstOWN9HQX14TEe1kwCMh5GsoBAP+qLr/FpLe4AAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/komal.png
/* harmony default export */ var komal = ({"src":"/_next/static/media/komal.0c7ac6dd.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/ANLXzrGxq76aa8Ogb39kTZ6JcgCurpm6rJKgd0urjGWmiGVyX0oAin5Vo4lbwH0+m2g+06dypHxTAIRtQn5nQaNiL1guELqIXK6GXQCYdFRjTTm8iFE9MShtTjd/YEAARDAhWkAquY1aAAAVdlg6i21KAI5zUpyAW4VbOH5WN3NWOqB0SQDhtH7ftoKWWSfHl2TWq3iEYUDPzkIXEQe0MwAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/deevesha.png
/* harmony default export */ var deevesha = ({"src":"/_next/static/media/deevesha.55631af7.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/AWZiYv8hKjQAR0M2ABIQDADK5ggA3O79/wGainz/LEBPAMrAvgAU/ucADDJUAB8aFAABmXtc//kPIgAN4rYAQjEkAK/VBAAyOjsAAY9xTv/P4OsALgn9AE08JgBzrtwAGBELAAGsi2D/u87nAMnK2ACMZTcARIfKAIRiOgABhWtK/5m74gAbDQAAjnRUAFl7pQBbRSkAAVtUPv+lxe4AWDUWAHBfRQA4ZJ4AXUAeAAGMcFD/dKLbAFI5GQBPQS0AX4S7AGRGGgBBGEYCmmSE4QAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/abhishek.png
/* harmony default export */ var abhishek = ({"src":"/_next/static/media/abhishek.edbe06ed.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/AcGkgP/6+fYAAQwXAAj+9QDDvsIA/AAE/wHc0bj/wrzCAPL7AgBEMx0A0MG5ALTB2AABqqOL/xP68wDk7PQAHB4UAPHg1AC/w9YAAWJdUP8oFwcAEwH3ALHL5AA0KRoA7+PjAAFcT0H/EhIMAFVFMwCRn7YAEAkBAAb69gABcFc9/+v6BQBEOCgAn6/FAPj19AAwGwwAAYlnRf/j8fsAlKjJAF5HKQAmEgEA5u32AAGRcE7+8fHzAe7w9QAMBP8AExQRABQUD/8UmFTLNhSg9wAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/gokul.png
/* harmony default export */ var gokul = ({"src":"/_next/static/media/gokul.9cefb736.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AMTS2s3Z3tPX08vRz8vR052ViQDTy7+4uLiWiIWjjn/EvrR3Wz8AoodkuJ2ApXNOoGw9r45mgF43AJN7Wn1pSZR3XJx6W2BNNXRWNgCth1oAAACRgGrErY4kEwSzh1MAo31QAAAAdWZVs5x/JxUDn3hHALKJWQAAAXVmVK2Weh8TDJ13RADBlF5SQjM1Mi48OzVpTjLOmVsfZUKYcqcCMAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/caique.png
/* harmony default export */ var caique = ({"src":"/_next/static/media/caique.9c4dc451.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/ALjCznqj0TWAxkNrkJGitVBWaAC3vr+4zNqLkJySUgB0Y1+Uh4QAooRpsq2l1K2M7KBRyKSIoo19AGU/FmhIKLeIXsuHRdyicaV8XABZRjsAKTq3jmmreE7Oj1K6g00AQTs8AAAdn4dxupt/TT84e1k/ADczNQAAEIl0ZMKjhwAAACIoMAA5MjIAABZ2Y1ikh3E5IBEiJSxd7T22mXOzaQAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/kathambari.png
/* harmony default export */ var kathambari = ({"src":"/_next/static/media/kathambari.1cd75039.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/AcC2of8TFBYAzOkMAM/n9wAtGAwAKhkFAAHKu5//9v8IAImYqABFCbEA7ht7ACE4OgABy7uW/73LwAAC3uQAWzsYALXYGwDjFhcAAcq7kv+QqKAAdzEiAA8F/ADJ9yQA1/fkAAGelXD/2+nmAFsbDQDr6OIAvf4XAP79+gABf3pM/7zUBAB0SS8AEvzoAMXrBgASEPwAAVRVWf++2e8ADgwCALZ+RwDQ3OgAExYQAAFFTFT/5+nrANTL7ACzoloAEQwHAOzw9f9581TeNaM7gwAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/parvathy.png
/* harmony default export */ var parvathy = ({"src":"/_next/static/media/parvathy.16196bce.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/ALrGyMvMwtTQwsTJxdfSwrK/xQDY18jQ1czY1MTj28bR1MrQ1MwArZp1vKyMxL2lu7qrzMiz0cqyAJZ6Q5yIWpyDW5pkKqSWeJeCYACinH23tJuFdGGJUyVrY1STfV4AurCToJ6Ka15OdGdWGTA/dmtWAKyLXYtxT6yXeqaRdQAALIx5XQCHbkxTSDyNfGR3aVkjLTiQd1XOX1DObkObvwAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/neeharika.png
/* harmony default export */ var neeharika = ({"src":"/_next/static/media/neeharika.40e35757.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AItvUtDOwJ+8zJm3ydPSxpOzxQCde1XAxbyqtLCDm6S9y8nK0ssAdFIwe3FZlG48u4RDuL63vbGdAGlNMGlWN7J/R9ucWJeDZn5eNwB5WzZlUzuWdFHQllmEaUeVc0oAjWtBKS42Z19S4b+NdmlYvI5VAKZ/UAAmNj89POjKmZeGbKh9SgCFaUlQRDorLjPQsoV+cV6XcUaDR0f9GKoYsQAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/harshitha.png
/* harmony default export */ var harshitha = ({"src":"/_next/static/media/harshitha.137ebbfc.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/AZOJQv8MI18ABhUvAEMi+gC52wcABQH6AAGPimX/LjFAAPgMIwDuzLIAFS09AAEHDQABqaCF/wAMHwAzEfcAtIVlAN41cABRQzYAAZCHSP8NFDcAFOrjAO/bwgCf6iYAWEgvAAF8dVX/8vnyACDy7gDc5/gAyu4AAEQ/KQABrJFk/+nr9wAGBAMAkKfGABkWEwBpVjgAAcmlcf/7/wUAs8fgAImVxgAuMBcAZU8uAAHYq27/scvuAKW/3gDSy+wAYFAZAEk/Kv+YTUw6f09RFgAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/sujith.png
/* harmony default export */ var sujith = ({"src":"/_next/static/media/sujith.e165aa4a.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAxklEQVR42gWAT0vCUADAf729rIwOL6E/ZIFIHfpzKepYx6Bj0bGv0Afwu4lHD56E4R8QJipTJ5uM6XS+Nyd7/5Xv7Ov9h/jkmY3RFPYTrMwgjqQh0AqxHKM7VVKTMHMdJCZgOKxxNo8paYeGOMX3bKQXlnHCFvdIkoMCzUUdHbmIW3VM186hrp94+/ygZwdYaRFxmTc021OCMOKqeIGSGx7OLUR3koK3wp9HxPGal7Li9S6PeCyp7O/3hsV6S3/kcZizGLg+O8+JUzc/Vb1aAAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/lakshmi.png
/* harmony default export */ var lakshmi = ({"src":"/_next/static/media/lakshmi.3b5dff09.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AJC4183V09LZ2myt2NPW1JW61gDC0M6+1t6fv8ywxc3A1NmyzNYAkZaEwMvJoYNknX1embC5pq6sAH1oRXh0W9ybWa91PUpdXn5uUwCbflWId1Ctc0SCUS11Z0ucgVsAuZNfQkNDgGxcsJF0W003xJphALaPXgAbO0lKSt/Lq4x7ZpBwQACPcU8bLToAFSzGspeTgm+adUIdBU0vr6QrWwAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/shubhankar.png
/* harmony default export */ var shubhankar = ({"src":"/_next/static/media/shubhankar.6067a03d.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AHVsZ7/JzKzD2Gqn3Ymx1aXA0QCTcUSap6qWr7uMprKwwMiOorEAWUMdcWFDeE4inW0xd3h1g2lLAHRaOXRfPapuPOKraX9lQGNNNgCGYzuBZkOQYD3Ol1mogVKMZj0AdVtAACc7b2JWuJd2i25PypRSAFNEOh8uPExHRty/l413YJtyQAAzNDoqLzgADi/CqIeEdGKGZDuIPUFsi9Lj9gAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/ramkala.png
/* harmony default export */ var ramkala = ({"src":"/_next/static/media/ramkala.0325ce0e.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AHtYNdXCp9TNu6KwudHFsfLZsACAWSfOup2kknl9cV7e0bjVxq4AjmU2n4Vmx5Ndw41Sp5aBo4lsAJJnOIFfNq97ScqPVl5IL2hLKwCmdkBOPSqVbkS3iFUAFiKMZj0AnXFAAAAAvJptrI5lAAAAo3VCAJhrOwAAB7SQY4FoSgAADIhfNQCTaDoAABGbeVFgTDYAABeLYTXbJz4nGJw+fgAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/deena.png
/* harmony default export */ var deena = ({"src":"/_next/static/media/deena.749d4d69.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AMDHyK29yXmatGyTspOvycjJxQDGuKTCxLt5XUOIWy+9vrXo2sEAr4Zgp450vHw81Yw+nIdxupp5AKmCWoFmSqZqNceBQnRYP6F+VACYc0lLQzhUOSiqZy0AHydxVjsAimpKJTVDGCcrw5txTkM6eVw8AIFjSQAsQQAAAL+piKmVeEAlEwBwV0UAIjkAAACOfWeynHwAAAJAcD700tsZAAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/sadashiv.png
/* harmony default export */ var sadashiv = ({"src":"/_next/static/media/sadashiv.bcfee811.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AMrMyMjNzmF/mE9le8XGwb/GxQC2squ7w8KhekulaACeqKvEtqQAhGNCtaOR3653xoxPtJ6IooFZAI1wUJiAY7qKW6ZwPoxtSV9JNACCZktMTU2PeGS8kmpLSEeDYkEAa1tMABc6YlxV4safWlVRqIFUAFlQSg0nOTo8Qtu/l1xZVLCIWAAwNj8fKzcRJjjEqYZXVFGVcUrHUEPmePFxwgAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/mary.png
/* harmony default export */ var mary = ({"src":"/_next/static/media/mary.ccfae395.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/AcnEu/8EHi8A2+f0AOvo5gAaGhsAKAfp/wGjhmv/JDxRALK9wgCHgYIAkJGNABH76wABtJBq/9zk7QBwjKkAwIROAOf2/AC21vcAAaWAWP9bp9EAq0kWAEI5KgCrzegAqr/dAAGMakf/dJa5AKRkKQAfISwAvOLzAC8iFgABSzww/wUYLwBcMAsAVHypAFxOMABYPx4AAT5HUv+AdGYAxMfKAH5+hQAAHC4AiVAbAAGWkpD/PjUoAEtddwD7+vsA5gMKAIZJHQCaA05k/bYNmAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/shahid.png
/* harmony default export */ var shahid = ({"src":"/_next/static/media/shahid.dbdfee86.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AJ291a3H23ep0a/D08XS2qSYkwCdl5THysmxq6iloKOgqrGBZk0AimU4noBkqYlxpHpZp4VeYUAQAHJeS3FcSHVnWI59bGBLN4poSAB1W0FNRDweMDhNS0hIQDl7XD8AjWtHW0w/MDM1DyApLy8vhGREALGDU19PQBIlLSIpLFVGOrGDUwDEjleEZUoGHigCGx9sUz3SmmBggjzoM9HnNQAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/scott.png
/* harmony default export */ var scott = ({"src":"/_next/static/media/scott.31242726.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AJSnx8rS2j6Qz2udzp+42p+62gCfnpq1z+Cyi2+lg3WdvdmfqLMAb2RZtLKu255qz515o6alqoRZAGNLLIRuVLqLZpZtVZaBaoVrTABfUEQACi2ciXO1m341MC9+YUUARkA9ABEqZ15Txa+SJCUsjWtFADo3NwYdKiswNmthWQASJqyDVwAtLzM6NDEZKDMWICkAACKkeVClXj5tkhnhmAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/ramya.png
/* harmony default export */ var ramya = ({"src":"/_next/static/media/ramya.f9cb578d.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/AXd2Sv8WGi4AS0ZXAMbmDwANAfQA/+zP/wFxbz7/JyY4APwPOgAFBwoAIxUEAM3PywABiHlY/wEOFgDXvrQAQCgNAOomZgD58cwAAYdwX//b9/MAKvnmAFA4HQCNzwQA8wUKAAGJdlf/7vUGAM/GxgBiRSMAotYGABIXGgABnoRf/9Db8wCSodMAspZOAOnv+AD0/QIAAamKZ/+TsdkAxMXkAKSOTQAkHxgAoLPIAAGCbFb/uc7oAMXg8wB+Vi8AJyAWAM/V4f/3MFITfiBJxgAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/saurabh.png
/* harmony default export */ var saurabh = ({"src":"/_next/static/media/saurabh.652f7001.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AJay17fO6KTD557D6c3Z5cvb6wC6qJzN4O61vsisoqLF3fPL0tYAr49ywbWswa2dwaKMztPUi3ttAJJzUoNqT2VhY6yknpF6Yl9QQgDer3iEbVgAJkCrpp+SeF2UeV0A87+DdWFRABgvpqGdnoJhq4ZWAPjBgKB+XAAjP3JwcI9zWIluSgD3vXzImmkAIj0/NjPIl2WcelAW5VD7fJF4fAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/franklin.png
/* harmony default export */ var franklin = ({"src":"/_next/static/media/franklin.e452e442.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/ANPX2rDD2Yi245i84cTN2bPG3ADOuKbS29+Uscmqv9Dq5tvPy8MArX9XzcG4t4tkzKuQ0MzGh3htAHVSM6B4Va2EaZ6AcJl5WpFsRgChdkykfE6XkZBETllkTTiUdFIA5a5xupNnfoCHOjk+SD88d11EANKjaLyRY1ZgbRYmNGZPPqd6TgCpe0i0hVYAABs5NDmFZEWOaUR7ekyWvkmUIAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/sureshNakka.png
/* harmony default export */ var sureshNakka = ({"src":"/_next/static/media/sureshNakka.54262eb4.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/Aaq6zf+n1f4Ar+8BAJUzCAAqE/cA9sajAAG2xtH/+QIIANHi8AAlDv0ACfnsAOGwhwABnpKN/zJGSQD0288A8efjAOn+CwC9n3wAAYJgRf8jMT0ABgMCANff5gAYDQAAAO7eAAGTdFf/LR0MANP4GgCywMwAEPHbAD8xIwABlXBI/xwUFQC55AcAqbnEAGE5HQA0IA4AAWROOP8iFxMAudjxAMHa6wCjYi4AIhIDAAGEYUX/HhcPAJS31wAQCwgAdkwlAAQA/P9AzkzEf0W/fwAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/kushal.png
/* harmony default export */ var kushal = ({"src":"/_next/static/media/kushal.f16c9854.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AJeDf6++yZCvy26ex5OsxWucxACumIWuwcmFl6OZsL3Czcuivs4AallJmJ6emVsAqaiktcjNwLanAHFfTpyRhYtyYKWWiKuWgI1rQgCRZjk5HwRSVViSg3aYc0R4XEAAqH5PMC4xKy0ygn13tItbpHxMAMibZDcxLiIkK2BfYHxfP5dzPwDQmltwWEAAFC0vLS+RbEWBZDxPtUS2SxVGtQAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/jagadeesh.png
/* harmony default export */ var jagadeesh = ({"src":"/_next/static/media/jagadeesh.6da2ef1a.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/AVCT1/71/gQACvTnAOD6AQB4OhYAKhb5AAGtvtf/BQgHAP3NqgDm5u4APWBoABQC7gAB29HH/wQLEADf2doA1s7PABs2QwAH/PUAAbSPgf8JEhcA6wgTALW3uQD05+AAWUs2AAGafFn/EAsSAPkZMwCfo6sA6ertAE4xDgABqn9Q/wIHDgDzGUMAqquvAPLo4QAoHg8AAb6HT/8ABQsAbajlAPX8AQBqPBAAQSwQAAG0hEv/HBUSAGCU0wD/AwoAonQ1ACobCwDa3Erd3rZzvQAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/vishnu.png
/* harmony default export */ var vishnu = ({"src":"/_next/static/media/vishnu.a748509a.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AKWts2uGqyFurU94qJ6gpqemqQCUmZ+Fp8U/g7CVoai5ubG9urAAoo59tMC/q3tPsJR/prKyaF9ZAGtOMqeVf7CBW7CIZIh5ZlMyAACJZTllRx5iXFyKdmh/XTBmTzQAr35ESjkuUVFQiYR/pXZAl3A/AL6GRz8zKkRCQ399fnpXMZxxQAC/hUJcRjM1NzpTUVF+XDecbzrooEIo1WwW+wAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/nisar.png
/* harmony default export */ var nisar = ({"src":"/_next/static/media/nisar.6a3fcf0e.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/ALvG01qa0Vib1V2f1ay906W71ACqxNmZvtuBpcSeuM7U293OzMcAusLJ0NvgvJd5xKSKzdLSl4h7AJaFfrCtrqqJd6h7VoR1Z11ORACwkGyhg2Cfi3ySgngGHSxvWEQA67uClHdVr6OUkIR2AAAisopfAN2veXRdRqSblXFpZQIUJNSmcADsuX2PdFhfYGRBRkxvX07su4B1VFDAPw2hZgAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/suresh.png
/* harmony default export */ var suresh = ({"src":"/_next/static/media/suresh.800bc306.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/AbTJ3P7Y5/oB7/wEABkPBABMI/wA+Pv+/wHMz8v/Aw4ZANnZ3wDv2NAAMklMAAH8+AABopWI/yMlKADw288AEPDRAAlHdwDiwagAAWxUOv8pIx0A4+8LAB8UCgAC/OYA09C/AAF6YUf/q8foADQxLwBNRT0A5NS5ADstGwABupRn/4Gj0QD7/gEAbmdfANLHugBTPBoAAc2kcv9mjsQA9PT3AG5rZgDe0MIARSoAAAHerHH/k7DYAJXE6gAoGBEAVzILAFpAHgAT/1Sh50wXrAAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/ambarish.png
/* harmony default export */ var ambarish = ({"src":"/_next/static/media/ambarish.2f4bbb6a.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AOLk5sDZ9n6t2o+14OPt+d/W0QDQxcPe6fG3kXl0Y2Lc3uPRuawAwZ2Fz7mxwJJ1rX1hza+TonpRAL6eeKqNbIt1cLaTintpWbGIXQC+ooEAAA5xcHvZzNEQMU2bd1QATEZGfWFXcV9h1MvSZmNtdF9FAGhTP8GQZKV1Zbq5y5KMmDYmHACUbkeBZkQyLT5eW2VHRlBpV1LEa05ym5KxMQAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/suhel.png
/* harmony default export */ var suhel = ({"src":"/_next/static/media/suhel.917926c7.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AJmisL3M42Se32ek4czR2sLQ3gCCc2a0vcS8wMjXpYK9xdCysLYAaUsmf3d4wZN30YAAr4t3p4ZnAGZRPZF3VtCOVcqARNOmb5x6UQBTRj80Q0+rjoCrdlqag2bWpm0AaFpUABI4e3d5wbSuAAA/v5RiADk8RgAbM2FeX9XHuzlFUp14UQAtN0UBHC9BRU25srE0QlJwWUbaQkZia7c/6AAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/assets/newTeam/vivek.png
/* harmony default export */ var vivek = ({"src":"/_next/static/media/vivek.6a6c375d.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAo0lEQVR42gGYAGf/AM+4qM/W4bPM6NDb47vU7JrE7AC9lXG6q6aon56bfG+nqLKvtsYAl25KuJJrsYFh24xSwJJ6uKmiAKZ+W6uHZbyGXs+MYMmff66QcQCfelxvXU2bf3TSk226nH2cel4AJzNBABIwend54c7Ghn98so1kADIzOykrNFVUV+/p4Zuamn5cOgApLTUiJzAmKzfe2NOlpad+XzzNsk3z5aUGsQAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/contactUser.js











































var contactUser = [
    {
        email: "Suniti.Satnalika@unilever.com",
        img: suniti,
        name: "Suniti Satnalika"
    },
    {
        email: "Vidish.Verma@unilever.com",
        img: vidish,
        name: "Vidish Verma"
    },
    {
        email: "Anubha.Aggarwal@unilever.com",
        img: anubha,
        name: "Anubha Aggarwal"
    },
    {
        email: "Soumya.Mohanty@unilever.com",
        img: soumya,
        name: "Soumya Mohanty"
    },
    {
        email: "md.suhel@unilever.com",
        img: suhel,
        name: "Suhel Md"
    },
    {
        email: "vivek.sagar@unilever.com",
        img: vivek,
        name: "Vivek Sagar"
    },
    {
        email: "Mamatha.Raju@unilever.com",
        img: mamatha,
        name: "Mamatha Raju"
    },
    {
        email: "Tanu.Gupta2@unilever.com",
        img: tanu,
        name: "Tanu Gupta"
    },
    {
        email: "Ritika.Kaushik@unilever.com",
        img: ritika,
        name: "Ritika Kaushik"
    },
    {
        email: "Md.Shahid@unilever.com",
        img: shahid,
        name: "Shahid Md"
    },
    {
        email: "Scott.J.Johnson@unilever.com",
        img: scott,
        name: "Scott J Johnson"
    },
    {
        email: "vijay.reddy@unilever.com",
        img: vijay,
        name: "Vijay Reddy"
    },
    {
        email: "Abhilasha.Sinha@unilever.com",
        img: abhilasha,
        name: "Abhilasha Sinha"
    },
    {
        email: "Madhurima.Jaggi@unilever.com",
        img: madhurima,
        name: "Madhurima Jaggi"
    },
    {
        email: "Vishali.Sharma@unilever.com",
        img: vishali,
        name: "Vishali Sharma"
    },
    {
        email: "Bhavya.Sajnani@unilever.com",
        img: bhavya,
        name: "Bhavya Sajnani"
    },
    {
        email: "Mriganshi.Sharma@unilever.com",
        img: mriganshi,
        name: "Mriganshi Sharma"
    },
    {
        email: "Komal.Falodiya@unilever.com",
        img: komal,
        name: "Komal Falodiya"
    },
    {
        email: "deevesha.sharma@unilever.com",
        img: deevesha,
        name: "Deevesha Sharma"
    },
    {
        email: "abhishek.u@unilever.com",
        img: abhishek,
        name: "Abhishek U"
    },
    {
        email: "Gokul.Sreenivas@unilever.com",
        img: gokul,
        name: "Gokul Sreenivas"
    },
    {
        email: "Caique.Amaral@unilever.com",
        img: caique,
        name: "Caique Amaral"
    },
    {
        email: "Kathambari.KK@unilever.com",
        img: kathambari,
        name: "Kathambari KK"
    },
    {
        email: "Parvathy.TR@unilever.com",
        img: parvathy,
        name: "Parvathy TR"
    },
    {
        email: "Neeharika.Peri@unilever.com",
        img: neeharika,
        name: "Neeharika Peri"
    },
    {
        email: "Harshitha.Tirupati@unilever.com",
        img: harshitha,
        name: "Harshitha Tirupati"
    },
    {
        email: "Ramya.Karunakaran@unilever.com",
        img: ramya,
        name: "Ramya Karunakaran"
    },
    {
        email: "Sujith.Kumar@unilever.com",
        img: sujith,
        name: "Sujith Kumar"
    },
    {
        email: "V.Lakshmi@unilever.com",
        img: lakshmi,
        name: "Lakshmi V"
    },
    {
        email: "Shubhankar.Das@unilever.com",
        img: shubhankar,
        name: "Shubhankar Das"
    },
    {
        email: "Ramkala.Giri@unilever.com",
        img: ramkala,
        name: "Ramkala Giri"
    },
    {
        email: "Deena.Joel@unilever.com",
        img: deena,
        name: "Deena Joel"
    },
    {
        email: "Sadashiv.Kanalae@unilever.com",
        img: sadashiv,
        name: "Sadashiv Kanalae"
    },
    {
        email: "Mary-Prasanna.Lawrence-Dorai@unilever.com",
        img: mary,
        name: "Mary-Prasanna"
    },
    {
        email: "Franklin.Dsouza@unilever.com",
        img: franklin,
        name: "Franklin Dsouza"
    },
    {
        email: "Saurabh.Priyadarshi@unilever.com",
        img: saurabh,
        name: "Saurabh Priyadarshi"
    },
    {
        email: "suresh.nakka@unilever.com",
        img: sureshNakka,
        name: "Suresh Nakka"
    },
    {
        email: "Kushal.Jha@unilever.com",
        img: kushal,
        name: "Kushal Jha"
    },
    {
        email: "Vishnu.Reddy@unilever.com",
        img: vishnu,
        name: "Vishnu Reddy"
    },
    {
        email: "Nisar.Khan@unilever.com",
        img: nisar,
        name: "Nisar Khan"
    },
    {
        email: "Gudditi.Suresh@unilever.com",
        img: suresh,
        name: "Suresh Gudditi"
    },
    {
        email: "Ambarish.Mishra@unilever.com",
        img: ambarish,
        name: "Ambarish Mishra"
    }
];
/* harmony default export */ var contactUsPage_contactUser = (contactUser);

// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(53854);
;// CONCATENATED MODULE: ./components/Pages/contactUsPage/index.jsx







function contactUsPage_index(props) {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-[url('/bernard/contactus_bg.png')] bg-cover bg-no-repeat min-h-screen p-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-unilever-shilling-medium text-center text-2xl",
                children: "Our Team"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-[rgba(96,10,23,0.1)] rounded-md p-8 m-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-16 grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10",
                    children: contactUsPage_contactUser.map(function(param, idx) {
                        var email = param.email, img = param.img, name = param.name;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Figure/* Figure */.B, {
                            className: "mx-auto relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: img,
                                    alt: "",
                                    placeholder: "blur"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute -bottom-2 w-[90%] left-[50%] translate-x-[-50%] bg-[#D9D9D9] rounded-md px-[0.65rem]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-unilever-shilling-medium mt-[3px]",
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-unilever-shilling-normal text-[10px] lowercase",
                                            children: email
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiOutlineMail */.Zuw, {
                                            onClick: function() {
                                                router.push("mailto:".concat(email));
                                            },
                                            className: "w-4 h-4 absolute right-2 -top-1 cursor-pointer"
                                        })
                                    ]
                                })
                            ]
                        }, idx);
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/header/index.jsx + 1 modules
var header = __webpack_require__(30223);
// EXTERNAL MODULE: ./components/footer/index.jsx
var footer = __webpack_require__(40632);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./styles/pages/cezPage.module.scss
var cezPage_module = __webpack_require__(26798);
var cezPage_module_default = /*#__PURE__*/__webpack_require__.n(cezPage_module);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
;// CONCATENATED MODULE: ./components/Pages/cezs/index.jsx







//import Banner from "../../cezBanner/index";
var Banner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1902).then(__webpack_require__.bind(__webpack_require__, 96216));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96216)
            ];
        }
    }
});

//import Icons from "../../../public/assets/svg/index";
var cezs_Icons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18023));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18023)
            ];
        }
    }
});
var Cez = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5206).then(__webpack_require__.bind(__webpack_require__, 35206));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35206)
            ];
        }
    }
});
//import Cez from "../../cez1";




//import gsap from "gsap";
//import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
// import ScrollTrigger from "gsap/ScrollTrigger";
function cezs_index(props) {
    var myFunction = function myFunction() {
        var header = document.getElementById("mohit");
        var stickydiv = null;
        if (header) {
            stickydiv = header.offsetTop;
        }
        //console.log("mohittttttttttt",stickydiv,window.pageYOffset,window.pageYOffset > sticky);
        if (window.pageYOffset > 1000) {
            if (header) {
                header.classList.add((cezPage_module_default()).sticky);
            }
            // console.log("kritikaaaaaaaaaaaaaa",);
            setsticky(true);
        } else {
            if (header) {
                header.classList.remove((cezPage_module_default()).sticky);
            }
            setsticky(false);
        }
    };
    var router = (0,next_router.useRouter)();
    //console.log("props at cez", props);
    var backgroundUrlMobile = get_default()(props.data[0], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl = get_default()(props, "data[0]component.content.field_background_image[0].file_url", "");
    var cezDetails = get_default()(props, "data[0].component.content.field_details", "");
    var cezHeading = get_default()(props, "data[0]component.content.field_hedaing", "");
    var imageUrlWhat = get_default()(props, "data[1]component.content.field_image[0].file_url", "");
    // const messageWhat = _get(
    //   props.data[1],
    //   "component.content.field_message_input",
    //   ""
    // );
    // const titleWhat = _get(props.data[1], "component.content.field_title", "");
    var imageUrlMobileWhat = get_default()(props, "data[1]component.content.field_image_mobile[0].file_url", "");
    // content
    var cez1Info = get_default()(props, "data[2].component.content", "");
    var cez2Info = get_default()(props, "data[3].component.content", "");
    var cez3Info = get_default()(props, "data[4].component.content", "");
    var cez4Info = get_default()(props, "data[5].component.content", "");
    var cez5Info = get_default()(props, "data[6]component.content", "");
    var cez6Info = get_default()(props, "data[7]component.content", "");
    var cez7Info = get_default()(props, "data[8]component.content", "");
    var allCezNavs = [
        cez1Info,
        cez2Info,
        cez3Info,
        cez4Info,
        cez5Info,
        cez6Info,
        cez7Info
    ];
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(true), 2), cez1 = ref[0], setcez1 = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), cez2 = ref1[0], setcez2 = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), cez3 = ref2[0], setcez3 = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), cez4 = ref3[0], setcez4 = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), cez5 = ref4[0], setcez5 = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState("/assets/svg/frame1_bottom.svg"), 2), imageactive = ref5[0], setimageactive = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState("/assets/svg/frame1_top.svg"), 2), imagetop = ref6[0], setimagetop = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), shownav = ref7[0], setshownav = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState(true), 2), showtop = ref8[0], setshowtop = ref8[1];
    var ref9 = (0,src_sliced_to_array/* default */.Z)(react.useState("1"), 2), stage = ref9[0], setStage = ref9[1];
    var initialCezState = {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false
    };
    var bannerRef = react.useRef(null);
    var ref10 = (0,src_sliced_to_array/* default */.Z)(react.useState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), {
        0: true
    })), 2), cezState = ref10[0], setCezState = ref10[1];
    var cezClicked = function(index) {
        setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), (0,src_define_property/* default */.Z)({}, index, true)));
    };
    var ref11 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), sticky = ref11[0], setsticky = ref11[1];
    react.useEffect(function() {
        window.onscroll = function() {
            myFunction();
        };
    }, []);
    react.useEffect(function() {
        //console.log('router ----', router.query.cezSection);
        debugger;
        if (router.query.cezSection) {
            // window.scrollTo({
            //   top: 840,
            // });
            setshownav(true);
            //   alert("yahn tak sab sahi hai")
            switch(router.query.cezSection){
                case "RPA":
                    setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), {
                        0: true
                    }));
                    break;
                case "Conversational AI":
                    setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), {
                        1: true
                    }));
                    break;
                case "Text classification & analytics":
                    setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), {
                        2: true
                    }));
                    break;
                case "Anomaly detection service":
                    setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), {
                        3: true
                    }));
                    break;
                case "Image and video analytics":
                    setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), {
                        4: true
                    }));
                    break;
                case "Document digitization":
                    setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), {
                        5: true
                    }));
                    break;
                case "Web scrapping":
                    setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), {
                        6: true
                    }));
                    break;
            }
        }
    }, [
        router.query
    ]);
    var handlePage = function(e, index) {
        setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), (0,src_define_property/* default */.Z)({}, index, true)));
        //bannerRef.current.scrollIntoView() 
        window.scrollTo(0, 0);
    };
    var cezIconClicked = function(index) {
        setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), (0,src_define_property/* default */.Z)({}, index, true)));
        setshownav(true);
        window.scrollTo(0, 0);
    // window.scrollTo({
    //   top: 0
    // })
    };
    var ref12 = (0,src_sliced_to_array/* default */.Z)(react.useState(true), 2), showHideNav = ref12[0], setShowHidNav = ref12[1];
    //console.log(allCezNavs)
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (cezPage_module_default()).cezContainer,
        children: [
            shownav ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                data: {
                    cezDetails: cezDetails,
                    cezHeading: cezHeading,
                    backgroundUrl: backgroundUrl,
                    backgroundUrlMobile: backgroundUrlMobile
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cezPage_module_default()).mainHeading,
                children: shownav ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: showHideNav ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((cezPage_module_default()).submenu, " container-fluid"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 flexy-sbc hw-100",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: function() {
                                                return setshownav(false);
                                            }
                                        }),
                                        allCezNavs.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: cezState[index] ? "".concat((cezPage_module_default()).iconDiv, "  ").concat((cezPage_module_default())["active".concat(index)]) : "".concat((cezPage_module_default()).iconDiv),
                                                onClick: function(e) {
                                                    handlePage(e, index);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                            src: cezState[index] ? "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(get_default()(item, "field_active_image_icon[0].file_url", "")) : "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(get_default()(item, "field_icon_image[0].file_url", ""))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (cezPage_module_default()).cezheading,
                                                            children: get_default()(item, "field_title", "")
                                                        })
                                                    ]
                                                })
                                            });
                                        })
                                    ]
                                })
                            })
                        })
                    }) : null
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((cezPage_module_default()).cezMainContainer, " container"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cezPage_module_default()).cezCircleOuter,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                        src: "/assets/svg/unilever.svg",
                                        className: (cezPage_module_default()).cezMainCircle,
                                        alt: "cezcircle"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (cezPage_module_default()).cezCircleLine
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cezPage_module_default()).cezIcons,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (cezPage_module_default()).cezIconOuter,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (cezPage_module_default()).cezIcon,
                                                onClick: function() {
                                                    cezIconClicked(0);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconDefault,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cezs_Icons, {
                                                            name: "RPA"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconActive,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                            src: "/assets/svg/rpa-selected.png",
                                                            alt: "none"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (cezPage_module_default()).cezIconText,
                                                        children: "RPA"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                src: "/assets/svg/Green-bullet.png",
                                                className: (cezPage_module_default()).bulletIcon
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (cezPage_module_default()).cezIconOuter,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (cezPage_module_default()).cezIcon,
                                                onClick: function() {
                                                    cezIconClicked(1);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconDefault,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cezs_Icons, {
                                                            name: "ConversationalAi"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconActive,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                            src: "/assets/svg/conversational-ai-selected.png",
                                                            alt: "none"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (cezPage_module_default()).cezIconText,
                                                        children: "Conversation AI"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                src: "/assets/svg/Blue-bullet.png",
                                                className: (cezPage_module_default()).bulletIcon
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (cezPage_module_default()).cezIconOuter,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (cezPage_module_default()).cezIcon,
                                                onClick: function() {
                                                    cezIconClicked(2);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconDefault,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cezs_Icons, {
                                                            name: "TestClassification"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconActive,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                            src: "/assets/svg/Test-Classification-Analytics-default-selected.png"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (cezPage_module_default()).cezIconText,
                                                        children: "Text Classification & Analytics"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                src: "/assets/svg/Green-bullet.png",
                                                className: (cezPage_module_default()).bulletIcon
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (cezPage_module_default()).cezIconOuter,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (cezPage_module_default()).cezIcon,
                                                id: "cezAnime3",
                                                onClick: function() {
                                                    cezIconClicked(3);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconDefault,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cezs_Icons, {
                                                            name: "AnomalyDetection"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconActive,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                            src: "/assets/svg/Anomaly-Detection-Service-selected.png"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (cezPage_module_default()).cezIconText,
                                                        children: "Anomaly Detection Service"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                src: "/assets/svg/Purple-bullet.png",
                                                className: (cezPage_module_default()).bulletIcon
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (cezPage_module_default()).cezIconOuter,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (cezPage_module_default()).cezIcon,
                                                onClick: function() {
                                                    cezIconClicked(4);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconDefault,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cezs_Icons, {
                                                            name: "ImgVdoAnalytics"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconActive,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                            src: "/assets/svg/Image-Video-Analytics-selected.png"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (cezPage_module_default()).cezIconText,
                                                        children: "Image and Video Analytics"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                src: "/assets/svg/Red-bullet.png",
                                                className: (cezPage_module_default()).bulletIcon
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (cezPage_module_default()).cezIconOuter,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (cezPage_module_default()).cezIcon,
                                                onClick: function() {
                                                    cezIconClicked(5);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconDefault,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cezs_Icons, {
                                                            name: "DocumentDigitalization"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconActive,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                            src: "/assets/svg/Document-Digitization-selected.png"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (cezPage_module_default()).cezIconText,
                                                        children: "Document Digitization"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                src: "/assets/svg/Pink-bullet.png",
                                                className: (cezPage_module_default()).bulletIcon
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (cezPage_module_default()).cezIconOuter,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (cezPage_module_default()).cezIcon,
                                                onClick: function() {
                                                    cezIconClicked(6);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconDefault,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cezs_Icons, {
                                                            name: "WebScrapping"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (cezPage_module_default()).cezIconActive,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                            src: "/assets/svg/webscrapping-selected.png"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (cezPage_module_default()).cezIconText,
                                                        children: "Web Scrapping"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                src: "/assets/svg/Blue-bulletnew.png",
                                                className: (cezPage_module_default()).bulletIcon
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            shownav ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (cezPage_module_default()).mobileView,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (cezPage_module_default()).diagramWrappermobile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: function() {
                                    cezIconClicked(0);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                        src: "/assets/svg/rpa-mobile-individual.png"
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: function() {
                                    cezIconClicked(1);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                        src: "/assets/svg/conversational-ai-mobile-individual.png"
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: function() {
                                    cezIconClicked(2);
                                },
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                        src: "/assets/svg/test-classification-analytics-mobile-individual.png"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: function() {
                                    cezIconClicked(3);
                                },
                                children: [
                                    "  ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                        src: "/assets/svg/anomaly-detection-service-mobile-individual .png"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: function() {
                                    cezIconClicked(4);
                                },
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                        src: "/assets/svg/image-video-analytics-mobile-individual.png"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    cezIconClicked(5);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                    src: "/assets/svg/document-digitization-mobile-individual.png"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    cezIconClicked(6);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                    src: "/assets/svg/web-scrapping-mobile-individual.png"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (cezPage_module_default()).verticalLine
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (cezPage_module_default()).para,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cezPage_module_default()).bundle,
                                onClick: function() {
                                    cezIconClicked(0);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (cezPage_module_default()).cezhead,
                                        children: "RPA"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                            src: "/assets/svg/cezarrow2.png"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cezPage_module_default()).bundle,
                                onClick: function() {
                                    cezIconClicked(1);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (cezPage_module_default()).cezhead,
                                        children: "Conversational AI"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                            src: "/assets/svg/cezarrow1.png"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cezPage_module_default()).bundle,
                                onClick: function() {
                                    cezIconClicked(2);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (cezPage_module_default()).cezhead,
                                        children: "Test Classification & Analytics"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                            src: "/assets/svg/cezarrow2.png"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cezPage_module_default()).bundle,
                                onClick: function() {
                                    cezIconClicked(3);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (cezPage_module_default()).cezhead,
                                        children: "Anomaly Detection Service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                            src: "/assets/svg/cezarrow3.png"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cezPage_module_default()).bundle,
                                onClick: function() {
                                    cezIconClicked(4);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (cezPage_module_default()).cezhead,
                                        children: "Image and Video Analytics"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                            src: "/assets/svg/cezarrow4.png"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cezPage_module_default()).bundle,
                                onClick: function() {
                                    cezIconClicked(5);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (cezPage_module_default()).cezhead,
                                        children: "Document Digitization"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                            src: "/assets/svg/cezarrow5.png"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cezPage_module_default()).bundle,
                                onClick: function() {
                                    cezIconClicked(6);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (cezPage_module_default()).cezhead,
                                        children: "Web Scrapping"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                            src: "/assets/svg/cezarrow1.png"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            cezState["0"] && shownav ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cezPage_module_default()).dummydiv,
                id: "intro-bannar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cez, {
                    data: cez1Info,
                    pageNum: 1,
                    setshownav: setshownav,
                    bannerRef: bannerRef
                })
            }) : cezState["1"] && shownav ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cezPage_module_default()).dummydiv,
                id: "intro-bannar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cez, {
                    data: cez2Info,
                    pageNum: 2,
                    setshownav: setshownav,
                    bannerRef: bannerRef
                })
            }) : cezState["2"] && shownav ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cezPage_module_default()).dummydiv,
                id: "intro-bannar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cez, {
                    data: cez3Info,
                    pageNum: 3,
                    setshownav: setshownav,
                    bannerRef: bannerRef
                })
            }) : cezState["3"] && shownav ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cezPage_module_default()).dummydiv,
                id: "intro-bannar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cez, {
                    data: cez4Info,
                    pageNum: 4,
                    setshownav: setshownav,
                    bannerRef: bannerRef
                })
            }) : cezState["4"] && shownav ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cezPage_module_default()).dummydiv,
                id: "intro-bannar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cez, {
                    data: cez5Info,
                    pageNum: 5,
                    setshownav: setshownav,
                    bannerRef: bannerRef
                })
            }) : cezState["5"] && shownav ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cezPage_module_default()).dummydiv,
                id: "intro-bannar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cez, {
                    data: cez6Info,
                    pageNum: 6,
                    setshownav: setshownav,
                    bannerRef: bannerRef
                })
            }) : cezState["6"] && shownav ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cezPage_module_default()).dummydiv,
                id: "intro-bannar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cez, {
                    data: cez7Info,
                    pageNum: 7,
                    setshownav: setshownav,
                    bannerRef: bannerRef
                })
            }) : null
        ]
    });
}

// EXTERNAL MODULE: ./styles/pages/ProfilePage.module.scss
var ProfilePage_module = __webpack_require__(7877);
var ProfilePage_module_default = /*#__PURE__*/__webpack_require__.n(ProfilePage_module);
;// CONCATENATED MODULE: ./components/Pages/ProfilePage/index.jsx























var blobSasUrl = "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
var blobSasUrlNew = utility_endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
//   "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
var containerClient = blobServiceClient.getContainerClient("botstorevideo");
var drupalIp = utility_endpoints/* default.drupalIp */.ZP.drupalIp;
var imagebaseUrl = "".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/");
function ProfilePage_index(props) {
    var camelize = // to convert labels into camelcase
    function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    //console.log("props at profile", props);
    var ref = props.data[0], _component = ref.component, _content = _component.content, field_profile_image = _content.field_profile_image, field_user_profile_details = _content.field_user_profile_details;
    var leadPlatformData = props.globalData.lead_platform_main_component[0];
    //console.log(leadPlatformData, "leadPlatformdata at user profile ");
    leadPlatformData.field_related_dropdown = "";
    var areaData = props.globalData.lead_platform_main_component[1];
    var subAreaData = props.globalData.lead_platform_main_component[2];
    var clusterData = props.globalData.cluster_main_component[0];
    var mcoData = props.globalData.cluster_main_component[1];
    var countryData = props.globalData.cluster_main_component[2];
    var profileDrupalData = [
        leadPlatformData,
        clusterData,
        mcoData,
        countryData, 
    ];
    //console.log(profileDrupalData, "profileDrupalData")
    // saving bots camalcased label as value
    profileDrupalData.map(function(item) {
        item.value = camelize(item.field_label);
    });
    var initialStates = {};
    var dropDownsInitialStates = {};
    // drupal
    profileDrupalData.map(function(item) {
        if (item.field_input_type == "Related Dropdown" && item.field_related_dropdown.length > 0) {
            var fieldOptions = [];
            item.field_dropdown_option_component.map(function(item) {
                fieldOptions = (0,src_to_consumable_array/* default */.Z)(fieldOptions).concat((0,src_to_consumable_array/* default */.Z)(item.field_options));
            });
        // item.field_options =
        }
    });
    profileDrupalData.map(function(item) {
        initialStates[camelize(item.field_label)] = "";
        if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
            dropDownsInitialStates[camelize(item.field_label)] = false;
        }
    });
    var intitailValues = {
        email: "",
        toUpdateUser: {
            image: "",
            name: "",
            cluster: "",
            country: "",
            leadPlatform: "",
            area: ""
        }
    };
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(intitailValues), 2), userApi = ref1[0], setUserApi = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), auth = ref2[0], setAuthData = ref2[1];
    var ref3 = (0,react.useState)(false), invalidFlag = ref3[0], setInvalidFlag = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref4[0], setSuccessModal = ref4[1];
    var ref5 = (0,react.useState)(false), loader = ref5[0], setLoader = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState("Profile Updated successfully!"), 2), message = ref6[0], setMessage = ref6[1];
    react.useEffect(function() {
        // get and set auth data
        var relatedDropdownToSet = {};
        //console.log(profileDrupalData, "firstBest");
        profileDrupalData.map(function(item) {
            if (item.field_input_type == "Related Dropdown") {
                relatedDropdownToSet = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, relatedDropdownToSet), (0,src_define_property/* default */.Z)({}, item.value, {
                    allValues: item.field_dropdown_option_component
                }));
            }
        });
        if ( true && localStorage.getItem("auth") != undefined && localStorage.getItem("auth") != "") {
            var _loop = function(i) {
                var myCountriesToSet = [];
                relatedDropdownToSet.country.allValues.map(function(countryItem, index) {
                    if (countryItem.field_title == relatedDropdownToSet.mCO.nowValues[i]) {
                        //console.log(countryItem, "relatedDropdownnnsssCountry")
                        myCountriesToSet = {
                            country: countryItem,
                            index: index
                        };
                    }
                });
                myCountries = (0,src_to_consumable_array/* default */.Z)(myCountries).concat((0,src_to_consumable_array/* default */.Z)(myCountriesToSet.country.field_options));
                myCountriesInfo = (0,src_to_consumable_array/* default */.Z)(myCountriesInfo).concat([
                    myCountriesToSet
                ]);
            };
            profileDrupalData.map(function(item) {
                if (item.field_related_dropdown) {
                    if (relatedDropdownToSet[camelize(item.field_related_dropdown)]) {
                        var nowValues = _.get(relatedDropdownToSet[camelize(item.field_related_dropdown)].allValues.filter(function(innerItem) {
                            return innerItem.field_title == JSON.parse(localStorage.getItem("auth")).data[item.value == "mCO" ? "personalMco" : item.value == "country" ? "personalCountry" : item.value == "cluster" ? "personalCluster" : item.value];
                        })[0], "field_options", []);
                        relatedDropdownToSet[camelize(item.field_related_dropdown)].nowValues = nowValues;
                    }
                }
            });
            var myCountries = [];
            var myCountriesInfo = [];
            //console.log(relatedDropdownToSet, "NEWSTATE")
            for(var i in relatedDropdownToSet.mCO.nowValues)_loop(i);
            relatedDropdownToSet.country.countryInfo = myCountriesInfo;
            relatedDropdownToSet.country.nowValues = myCountries;
        }
        setRelatedDropdowns((0,src_object_spread/* default */.Z)({}, relatedDropdownToSet));
        try {
            if ( true && localStorage.getItem("auth") != undefined && localStorage.getItem("auth") != "") {
                var auth = JSON.parse(localStorage.getItem("auth")).data;
                //console.log(auth, "profileState");
                var myState = state;
                myState.mCO = auth.personalMco;
                myState.country = auth.personalCountry;
                myState.cluster = auth.personalCluster;
                myState.leadPlatform = auth.personalLeadPlatform;
                myState.area = auth.personalArea;
                myState.subArea = auth.subArea;
                setState((0,src_object_spread/* default */.Z)({}, state, auth, myState));
                //console.log(state, "profileState");
                setAuthData(auth);
                setProfileImage(auth.image);
                setUserApi({
                    email: auth.email,
                    toUpdateUser: {
                        name: auth.name
                    }
                });
            }
        } catch (e) {
            //console.log("user update auth  error ----------------------");
            console.log("error  --", e);
        //console.log("user update error ----------------------");
        }
    }, []);
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), relatedDropdowns = ref7[0], setRelatedDropdowns = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref8[0], setState = ref8[1];
    var ref9 = (0,src_sliced_to_array/* default */.Z)(react.useState(dropDownsInitialStates), 2), dropDownState = ref9[0], setDropdownState = ref9[1];
    var ref10 = (0,src_sliced_to_array/* default */.Z)(react.useState([
        "firstGfcf",
        "gfcf",
        "gCad"
    ]), 2), cantUpdateCluster = ref10[0], setCantUpdateCluster = ref10[1];
    var ref11 = (0,src_sliced_to_array/* default */.Z)(react.useState([
        "gpmApprover",
        "firstLevelGPMApprover"
    ]), 2), cantUpdateLeadPlatform = ref11[0], setCantUpdateLeadPlatform = ref11[1];
    var inputChange = function(e) {
        setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    var handleDropDown = function(item) {
        //console.log(item, "item")
        // if( item == "cluster" || item == "mCO" || item == "country") {
        //   if (cantUpdateCluster.includes(auth.userType)) {
        //     return;
        //   }
        // }
        // else if (item == "leadPlatform") {
        //   if (cantUpdateLeadPlatform.includes(auth.userType)) {
        //     return;
        //   }
        // }
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownsInitialStates), (0,src_define_property/* default */.Z)({}, item, !dropDownState[item])));
    };
    var ref12 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), profileImageUrl = ref12[0], setProfileImageUrl = ref12[1];
    var ref13 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), profileImage = ref13[0], setProfileImage = ref13[1];
    var ref14 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), imageType = ref14[0], setImageType = ref14[1];
    //
    var handleUserApi = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var moveAhead, requiredFields, auth, payload, authCheck, expiryStatus, auth1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        moveAhead = true;
                        setLoader(true);
                        requiredFields = [
                            "cluster",
                            "mco",
                            "country"
                        ];
                        if (!moveAhead) return [
                            3,
                            6
                        ];
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            setUserApi((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, userApi), {
                                email: userApi.email,
                                toUpdateUser: {
                                    image: profileImageUrl,
                                    name: auth.name,
                                    cluster: state.cluster,
                                    leadPlatform: state.function,
                                    mco: state.mCO,
                                    subArea: state.subArea,
                                    country: state.country,
                                    area: state.subFunction
                                }
                            }))
                        ];
                    case 1:
                        _state.sent();
                        payload = {
                            email: auth.email,
                            toUpdateUser: {
                                image: profileImageUrl ? profileImageUrl : auth.image,
                                name: auth.name,
                                personalCluster: state.cluster,
                                personalLeadPlatform: state.leadPlatform,
                                personalCountry: state.country,
                                personalArea: state.area,
                                personalMco: state.mCO,
                                personalSubArea: state.subArea
                            }
                        };
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            4
                        ];
                        auth1 = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default().put("".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/user/updateUserPersonalDetails"), payload, {
                                headers: {
                                    Authorization: "".concat(auth1.accessToken, "|").concat(auth1.email)
                                }
                            }).then(function(res) {
                                if (res.data.code == 200) {
                                    //console.log(res.data, "response of update profileeeeeeeeeeeeeee");
                                    var presentAuth = JSON.parse(localStorage.getItem("auth"));
                                    res.data.data.accessToken = presentAuth.data.accessToken;
                                    //console.log("res.data", res.data);
                                    localStorage.setItem("auth", JSON.stringify(res.data));
                                    setSuccessModal(true);
                                    setLoader(false);
                                } else if (res.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    // router.push("/login");
                                    setLoader(false);
                                    props.sessionTimeOutCheck(true);
                                }
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoader(false);
                        props.sessionTimeOutCheck(true);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setInvalidFlag(true);
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUserApi() {
            return _ref.apply(this, arguments);
        };
    }();
    var gotDropDownValue = function(value, dropdownParent, haveRelated) {
        //console.log(value, dropdownParent, haveRelated, "testing");
        var newState = state;
        if (haveRelated != null && haveRelated.length > 0) {
            newState[haveRelated] = "";
            //console.log(props.data, "props ka data idhar hi hai ");
            profileDrupalData.map(function(item, index) {
                //console.log("value", item.field_label, "have related", haveRelated);
                if (camelize(item.field_label) == haveRelated) {
                    //console.log(item, "pehle");
                    //console.log(haveRelated, "as");
                    if (camelize(item.field_related_dropdown) != null && camelize(item.field_related_dropdown).length > 0) {
                        //  let newerState = state
                        newState[camelize(item.field_related_dropdown)] = "";
                    }
                }
            });
            //console.log(relatedDropdowns, "related Ka Khel");
            var selectedRelatedDropdown = relatedDropdowns;
            selectedRelatedDropdown[haveRelated].nowValues = selectedRelatedDropdown[haveRelated].allValues.filter(function(item) {
                return item.field_title == value;
            })[0].field_options;
            //console.log(selectedRelatedDropdown, "relatedDropdownnnsss")
            if (dropdownParent == "cluster") {
                var _loop = function(i) {
                    var myCountriesToSet = [];
                    selectedRelatedDropdown.country.allValues.map(function(countryItem, index) {
                        if (countryItem.field_title == selectedRelatedDropdown.mCO.nowValues[i]) {
                            //console.log(countryItem, "relatedDropdownnnsssCountry")
                            myCountriesToSet = {
                                country: countryItem,
                                index: index
                            };
                        }
                    });
                    myCountries = (0,src_to_consumable_array/* default */.Z)(myCountries).concat((0,src_to_consumable_array/* default */.Z)(myCountriesToSet.country.field_options));
                    myCountriesInfo = (0,src_to_consumable_array/* default */.Z)(myCountriesInfo).concat([
                        myCountriesToSet
                    ]);
                };
                var myCountries = [];
                var myCountriesInfo = [];
                for(var i in selectedRelatedDropdown.mCO.nowValues)_loop(i);
                selectedRelatedDropdown.country.countryInfo = myCountriesInfo;
                selectedRelatedDropdown.country.nowValues = myCountries;
            }
            //console.log(dropdownParent, "SELECTEDcOUNTRY")
            setRelatedDropdowns((0,src_object_spread/* default */.Z)({}, selectedRelatedDropdown));
        }
        var myFlag = false;
        if (dropdownParent == "country") {
            myFlag = true;
            //console.log(value, "SELECTEDcOUNTRYValue")
            //console.log(relatedDropdowns, "SELECTEDcOUNTRYRelated")
            var selectedCountryRightNow;
            relatedDropdowns.country.countryInfo.map(function(item, index) {
                if (item.country.field_options.includes(value)) {
                    selectedCountryRightNow = item;
                }
            });
        //console.log(relatedDropdowns.country.allValues[selectedCountryRightNow.index].field_title, "SELECTEDcOUNTRYMCO")
        }
        setDropdownState(dropDownsInitialStates);
        var _obj;
        //console.log(newState , "NEWSTATE")
        setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, newState), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, dropdownParent, value), (0,src_define_property/* default */.Z)(_obj, "mCO", myFlag ? relatedDropdowns.country.allValues[selectedCountryRightNow.index].field_title : state.mCO), _obj)));
    };
    var nameInfo = field_user_profile_details.filter(function(item) {
        return item.field_label == "Full Name";
    });
    var parentArray = [];
    for(var i = 0; i < profileDrupalData.length; i++){
        if (i % 2 == 0) {
            var twoItemArray = [];
            twoItemArray.push(profileDrupalData[i]);
            twoItemArray.push(profileDrupalData[i + 1]);
            parentArray.push(twoItemArray);
        }
    }
    var uploadImage = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var file, fileName, type, blockBlobClient, options, resp, imageUrl, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        file = e.target.files[0];
                        fileName = e.target.files[0].name;
                        type = e.target.files[0].type;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        imageUrl = resp._response.request.url.split("?")[0].split("/");
                        //console.log("image url  ----", imageUrl);
                        imageUrl = imageUrl[imageUrl.length - 1];
                        // console.log("exact url ---", imageUrl);
                        //console.log(type, "exa")
                        if (type == "image/png" || type == "image/jpeg" || type == "image/jpg") {
                            setProfileImageUrl(imageUrl);
                            setImageType(false);
                            setProfileImage(imageUrl);
                        } else {
                            setProfileImageUrl(auth.image);
                            setImageType(true);
                        //  setProfileImage("");
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadImage(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ProfilePage_module_default()).container, " container my-4"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ProfilePage_module_default()).profileDetailsWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ProfilePage_module_default()).profileImgContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ProfilePage_module_default()).img,
                            children: [
                                profileImage != "" && profileImage != null && profileImageUrl !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: profileImageUrl == null ? "".concat(imagebaseUrl).concat(auth.image) : "".concat(imagebaseUrl).concat(profileImageUrl)
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ProfilePage_module_default()).dummy,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/svg/userDummy.png"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ProfilePage_module_default()).inputGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            for: "file-input",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (ProfilePage_module_default()).uploadIcon,
                                                src: "/assets/svg/camera.png"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "file",
                                            accept: ".jpg,.jpeg,.png",
                                            style: {
                                                display: "none"
                                            },
                                            id: "file-input",
                                            onChange: uploadImage
                                        })
                                    ]
                                })
                            ]
                        }),
                        imageType ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProfilePage_module_default()).imgerror,
                            children: "Wrong image type selected !!!"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProfilePage_module_default()).name,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: userApi.toUpdateUser.name
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ProfilePage_module_default()).detailsSec,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ProfilePage_module_default()).row,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((ProfilePage_module_default()).formGroup, " "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Full Name"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            defaultValue: userApi.toUpdateUser.name,
                                            disabled: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((ProfilePage_module_default()).formGroup, " "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Email ID"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            defaultValue: userApi.email,
                                            disabled: true
                                        })
                                    ]
                                })
                            ]
                        }, ProfilePage_index),
                        parentArray.map(function(parentItem, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProfilePage_module_default()).row,
                                children: parentItem.map(function(item, index) {
                                    if (item.field_form_field_title != "MCO") return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ProfilePage_module_default()).colFirst,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ProfilePage_module_default()).row,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ProfilePage_module_default()).formGroup,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (ProfilePage_module_default()).label,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: item.field_label
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (ProfilePage_module_default()).required,
                                                                children: invalidFlag ? state[item.value] === "" || //state[requiredFields[i]] == false ||
                                                                state[item.value] === undefined || state[item.value] == [] || state[item.value] == "undefined" || state[item.value] == null ? "Required Field" : null : null
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "".concat((ProfilePage_module_default()).input),
                                                        onClick: function() {
                                                            handleDropDown(item.value);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (ProfilePage_module_default()).left,
                                                                children: state[item.value] == null || state[item.value] == "undefined" || state[item.value] === "" ? item.field_input : state[item.value]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (ProfilePage_module_default()).right,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                    name: "chevron",
                                                                    className: (ProfilePage_module_default()).chevron
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    dropDownState[item.value] == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                                        dropdownParent: item.value,
                                                        values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? relatedDropdowns[camelize(item.field_label)].nowValues : [
                                                            "No parent Selected"
                                                        ] : item.field_options,
                                                        getDropdownValue: gotDropDownValue,
                                                        haveRelated: camelize(item.field_related_dropdown),
                                                        param: "profile"
                                                    }) : null
                                                ]
                                            })
                                        })
                                    }, index);
                                })
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProfilePage_module_default()).row,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProfilePage_module_default()).saveDetails,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (ProfilePage_module_default()).btn,
                                    onClick: handleUserApi,
                                    children: "Save Details"
                                })
                            })
                        })
                    ]
                }),
                loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                    setSuccessModal: setSuccessModal,
                    title: "Profile",
                    message: message
                }) : null
            ]
        })
    });
}
var ProfilePage_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function ProfilePage_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var ProfilePage = ((0,es/* connect */.$j)(ProfilePage_mapStateToProps, ProfilePage_mapDispatchToProps)(ProfilePage_index));

// EXTERNAL MODULE: ./components/Pages/EditBotPage/index.js
var EditBotPage = __webpack_require__(76538);
// EXTERNAL MODULE: ./styles/pages/logout.module.scss
var logout_module = __webpack_require__(90788);
var logout_module_default = /*#__PURE__*/__webpack_require__.n(logout_module);
;// CONCATENATED MODULE: ./components/Pages/Logout/index.jsx






function Logout_index(props) {
    react.useEffect(function() {
        try {
            if (localStorage.getItem("auth")) {
                localStorage.clear();
            }
        } catch (e) {
            console.log(e);
        }
    }, []);
    //console.log('logout props  ----', props);
    // console.log('site info ---', props.data.data.site_info.menu_component.menu_list);
    var logoutInfo = props.data[0].component.content;
    //console.log(logoutInfo, "ney")
    var field_label = logoutInfo.field_label, field_title = logoutInfo.field_title, field_logout_image = logoutInfo.field_logout_image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (logout_module_default()).mainlogout,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (logout_module_default()).logoutContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (logout_module_default()).left,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: utility_endpoints/* default.drupalIp */.ZP.drupalIp + get_default()(field_logout_image[0], "file_url", "")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (logout_module_default()).right,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (logout_module_default()).head,
                            children: get_default()(logoutInfo, "field_title", "")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (logout_module_default()).text,
                            dangerouslySetInnerHTML: {
                                __html: get_default()(logoutInfo, "field_logout_description", "")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (logout_module_default()).btn,
                            onClick: function() {
                                router_default().push(props.pageRoutes.Login);
                            },
                            children: get_default()(logoutInfo, "field_label", "")
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var Logout = (Logout_index);

// EXTERNAL MODULE: ./styles/pages/userMapping.module.scss
var userMapping_module = __webpack_require__(70355);
var userMapping_module_default = /*#__PURE__*/__webpack_require__.n(userMapping_module);
// EXTERNAL MODULE: ./styles/components/userEdit.module.scss
var userEdit_module = __webpack_require__(23344);
var userEdit_module_default = /*#__PURE__*/__webpack_require__.n(userEdit_module);
// EXTERNAL MODULE: ./styles/components/basicForm.module.scss
var basicForm_module = __webpack_require__(58059);
var basicForm_module_default = /*#__PURE__*/__webpack_require__.n(basicForm_module);
// EXTERNAL MODULE: ./node_modules/react-datetime/dist/react-datetime.cjs.js
var react_datetime_cjs = __webpack_require__(8660);
var react_datetime_cjs_default = /*#__PURE__*/__webpack_require__.n(react_datetime_cjs);
// EXTERNAL MODULE: ./node_modules/react-datetime/css/react-datetime.css
var react_datetime = __webpack_require__(86060);
;// CONCATENATED MODULE: ./components/BasicForm2/index.js











// import Router from "next/router";



function BasicForm2_index(props) {
    var camelize = function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    //console.log(props, "props at dropdown in edit user");
    var notRequired = [
        "Area",
        "Sub Area",
        "MCO",
        "Lead Platform"
    ];
    var dispatch = (0,es/* useDispatch */.I0)();
    var inputprops = {
        placeholder: "DD-MM-YYYY",
        readOnly: true
    };
    props.data.map(function(item) {
        if (item.field_label == "Comments From Stakeholders") {
            item.value = "commentsFromStakeHolder";
        } else if (item.field_label == "EL") {
            item.value = "el";
        } else if (item.field_label == "MCO") {
            item.value = "mco";
        } else if (item.field_label == "SPOC") {
            item.value = "spoc";
        } else {
            item.value = camelize(item.field_label);
        }
    });
    var initialStates = {};
    var dropDownsInitialStates = {};
    var requiredFields = [];
    var relatedDropdownToSet = {};
    // nested dropdown
    props.data.map(function(item) {
        if (item.field_input_type == "Related Dropdown" && item.field_related_dropdown.length > 0) {
            var fieldOptions = [];
            item.field_dropdown_option_component.map(function(item) {
                fieldOptions = (0,src_to_consumable_array/* default */.Z)(fieldOptions).concat((0,src_to_consumable_array/* default */.Z)(item.field_options));
            });
        }
    });
    // intial states setup
    props.data.map(function(item) {
        initialStates[item.value] = "";
        if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
            dropDownsInitialStates[item.value] = false;
        }
        if (item.field_required == "1") {
            if (!props.notRequired.includes(item.field_label)) requiredFields.push(item.value);
        }
    });
    props.data.map(function(item) {
        if (item.field_input_type == "Related Dropdown") {
            relatedDropdownToSet[item.value] = item.field_dropdown_option_component;
        }
    });
    // states
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(relatedDropdownToSet), 2), relatedDropdowns = ref[0], setRelatedDropdowns = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref1[0], setState = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(dropDownsInitialStates), 2), dropDownState = ref2[0], setDropdownState = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref3[0], setInvalidFlag = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), value = ref4[0], setValue = ref4[1];
    // related dropdowns initial setup
    //   React.useEffect(() => {
    //     console.log(relatedDropdownToSet, "relatedDropdownToSet");
    //     setRelatedDropdowns();
    //   }, []);
    // handling input values
    // text input changes
    var inputChange = function(e) {
        setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    // dropdown open close
    var handleDropDown = function(item) {
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownsInitialStates), (0,src_define_property/* default */.Z)({}, item, !dropDownState[item])));
        //console.log(relatedDropdowns,"relatedDropdowns");
        props.data.map(function(item) {
            if (props.formType == "userCreateData" || props.formType == "userAccessEdit") {
                if (value == "") {
                    if (item.field_related_dropdown != "") {
                        var reall = relatedDropdowns;
                        for(var i in reall){
                            delete reall[i].nowValues;
                        }
                        setRelatedDropdowns((0,src_object_spread/* default */.Z)({}, reall));
                    }
                }
            }
        });
    };
    // dropdown value selected
    var gotDropDownValue = function(value, dropdownParent, haveRelated) {
        setValue(value);
        if (value == "None") {
            if (dropdownParent == "country") {
                setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, dropdownParent, [])));
            } else {
                var newState = state;
                delete newState[dropdownParent];
                setState((0,src_object_spread/* default */.Z)({}, newState));
            }
            setDropdownState(dropDownsInitialStates);
        } else {
            var newState1 = state;
            if (haveRelated) {
                delete newState1[haveRelated];
                var relatedDropdownsToChange = relatedDropdowns;
                props.data.map(function(item, index) {
                    if (item.value == haveRelated) {
                        if (camelize(item.field_related_dropdown) != null && camelize(item.field_related_dropdown).length > 0) {
                            //  let newerState = state
                            delete newState1[camelize(item.field_related_dropdown)];
                            delete relatedDropdownsToChange[camelize(item.field_related_dropdown)].nowValues;
                        }
                    }
                });
                var selectedRelatedDropdown = relatedDropdownsToChange[haveRelated];
                selectedRelatedDropdown.nowValues = selectedRelatedDropdown.filter(function(item) {
                    return item.field_title == value;
                })[0].field_options;
                setRelatedDropdowns((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, relatedDropdownsToChange), (0,src_define_property/* default */.Z)({}, haveRelated, selectedRelatedDropdown)));
            }
            setDropdownState((0,src_object_spread/* default */.Z)({}, dropDownsInitialStates));
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, newState1), (0,src_define_property/* default */.Z)({}, dropdownParent, value)));
            if (props.formType == "approval") {
                if (dropdownParent == "1.PleaseSelectTheProcessArea") {
                    props.sendDataToApproval({
                        subProcess: state["1.PleaseSelectTheSub-ProcessArea"],
                        process: value
                    });
                } else {
                    props.sendDataToApproval({
                        process: state["1.PleaseSelectTheProcessArea"],
                        subProcess: value
                    });
                }
            }
        }
    };
    // date selected
    var handleDate = function(date, parent) {
        if (typeof date == "object") {
            var bigDate = date._d;
            var dd = String(bigDate.getDate()).padStart(2, "0");
            var mm = String(bigDate.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = bigDate.getFullYear();
            var myDate = dd + "-" + mm + "-" + yyyy;
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, parent, myDate)));
        } else {
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, parent, date._d)));
        }
    };
    // send state to parent
    react.useEffect(function() {
        if (props.getFormValues == true) {
            var moveAhead = true;
            //console.log("required Fields", requiredFields);
            for(var i in requiredFields){
                if (state[requiredFields[i]] == "" || state[requiredFields[i]] == false || state[requiredFields[i]] === undefined || state[requiredFields[i]] == undefined || state[requiredFields[i]] == "undefined" || state[requiredFields[i]] == null) {
                    moveAhead = false;
                    break;
                }
            }
            if (moveAhead == true) {
                props.sendFormValues(state);
                setInvalidFlag(false);
            } else {
                if (props.setGetFormValues) {
                    props.setGetFormValues(false);
                }
                setInvalidFlag(true);
            }
        }
    }, [
        props.getFormValues
    ]);
    // empty states after submit
    react.useEffect(function() {
        setState(initialStates);
        setDropdownState(dropDownsInitialStates);
    }, [
        props.emptyFormValues
    ]);
    react.useEffect(function() {
        if (props.formType == "demand" || props.formType == "userAccessEdit" || props.formType == "userCreateData") {
            if (props.demandEditData != null) {
                setState(props.demandEditData);
            }
        }
    }, []);
    return props.data.map(function(item, index) {
        if (item.field_input_type == "Radio") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (basicForm_module_default()).colFirst,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (basicForm_module_default()).row,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((basicForm_module_default()).formGroup, " ").concat(item.field_column_size == "Large" ? (basicForm_module_default()).fullWidth : null),
                        onChange: inputChange,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: (basicForm_module_default()).mainLabel,
                                children: [
                                    item.field_label,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                        className: (basicForm_module_default()).mandatoryField,
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (basicForm_module_default()).inputGroupWrapper,
                                children: item.field_options.map(function(radioItem, index) {
                                    var a = item.value;
                                    // console.log(state.a, "whpppppp")
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: (basicForm_module_default()).radioWrapper,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (basicForm_module_default()).subLabel,
                                                children: radioItem
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "radio",
                                                className: (basicForm_module_default()).radioBox,
                                                value: radioItem,
                                                name: item.value,
                                                checked: state[item.value] == "" ? false : state[item.value] == radioItem ? true : false
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (basicForm_module_default()).radioCheckmark
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                })
            });
        } else if (item.field_input_type == "Plain Text") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (basicForm_module_default()).colFirst,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (basicForm_module_default()).row,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((basicForm_module_default()).inputGroup, " ").concat(item.field_column_size == "Large" ? (basicForm_module_default()).fullWidth : null),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            " ",
                                            item.field_label,
                                            " ",
                                            item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                children: "*"
                                            }) : null
                                        ]
                                    }),
                                    invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basicForm_module_default()).errorMessage,
                                        children: item.field_message_ip_error_message
                                    }) : null : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "".concat((basicForm_module_default()).input, "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (basicForm_module_default()).errorBorder : null : null),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    placeholder: item.field_title,
                                    name: item.value,
                                    onChange: inputChange,
                                    defaultValue: state[item.value]
                                })
                            })
                        ]
                    })
                })
            });
        } else if (item.field_input_type == "Large Plain Text") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (basicForm_module_default()).colFirst,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (basicForm_module_default()).row,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((basicForm_module_default()).inputGroup, " ").concat((basicForm_module_default()).fullWidth),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            " ",
                                            item.field_label,
                                            " ",
                                            item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                children: "*"
                                            }) : null
                                        ]
                                    }),
                                    invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basicForm_module_default()).errorMessage,
                                        children: item.field_message_ip_error_message
                                    }) : null : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "".concat((basicForm_module_default()).input, "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (basicForm_module_default()).errorBorder : null : null),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    placeholder: item.field_title,
                                    name: item.value,
                                    onChange: inputChange,
                                    defaultValue: state[item.value]
                                })
                            })
                        ]
                    })
                })
            });
        } else if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (basicForm_module_default()).colFirst,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (basicForm_module_default()).row,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: props.params === "approval" ? "".concat((basicForm_module_default()).approvalgroup) : props.type === "user" ? "".concat((basicForm_module_default()).userGroup) : "".concat((basicForm_module_default()).inputGroup),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            item.field_label,
                                            props.notRequired.includes(item.field_label) ? null : item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                children: "*"
                                            }) : null
                                        ]
                                    }),
                                    invalidFlag ? !props.notRequired.includes(item.field_label) && (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basicForm_module_default()).errorMessage,
                                        children: item.field_message_ip_error_message
                                    }) : null : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "".concat((basicForm_module_default()).input, " ").concat(invalidFlag ? !props.notRequired.includes(item.field_label) && (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (basicForm_module_default()).errorBorder : null : null),
                                onClick: function() {
                                    handleDropDown(item.value);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basicForm_module_default()).left,
                                        children: state[item.value] == "" || state[item.value] == null || state[item.value] == "undefined" || item.field_label == "Country" ? item.field_input : state[item.value]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basicForm_module_default()).right,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                            name: "chevron",
                                            className: (basicForm_module_default()).chevron
                                        })
                                    })
                                ]
                            }),
                            dropDownState[item.value] == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (basicForm_module_default()).dropdown,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                    dropdownParent: item.value,
                                    params: props.params,
                                    values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? // "None",
                                    (0,src_to_consumable_array/* default */.Z)(relatedDropdowns[item.value].nowValues) : [
                                        "No parent Selected"
                                    ] : // "None",
                                    (0,src_to_consumable_array/* default */.Z)(item.field_options),
                                    getDropdownValue: gotDropDownValue,
                                    haveRelated: camelize(item.field_related_dropdown),
                                    closeAllDropdowns: function() {
                                        setDropdownState(dropDownsInitialStates);
                                    }
                                })
                            }) : null,
                            item.field_label == "Country" ? state[item.value].map(function(multipleItem, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (basicForm_module_default()).multipleItems,
                                    children: multipleItem
                                }, index);
                            }) : null
                        ]
                    })
                })
            });
        } else if (item.field_input_type == "Date") {
            //  console.log(state[item.value], 'statevalue');
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (basicForm_module_default()).colFirst,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (basicForm_module_default()).row,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((basicForm_module_default()).inputGroup, " "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            " ",
                                            item.field_label,
                                            " ",
                                            item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                children: "*"
                                            }) : null
                                        ]
                                    }),
                                    invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basicForm_module_default()).errorMessage,
                                        children: "Incorrect Format"
                                    }) : null : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datetime_cjs_default()), {
                                closeOnSelect: true,
                                // initialValue={_.get(state, "dateLogged", [
                                //   "2020-11-12",
                                // ])}
                                value: get_default()(state, item.value, Date.now()),
                                initialValue: Date.now(),
                                timeFormat: false,
                                dateFormat: "DD-MM-YYYY",
                                className: "".concat((basicForm_module_default()).calender, "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (basicForm_module_default()).errorBorder : null : null),
                                inputProps: inputprops,
                                onChange: function(date) {
                                    return handleDate(date, item.value);
                                }
                            })
                        ]
                    })
                })
            });
        }
    });
}
/* harmony default export */ var BasicForm2 = (BasicForm2_index);

;// CONCATENATED MODULE: ./components/BasicForm3/index.js











// import Router from "next/router";



function BasicForm3_index(props) {
    var camelize = function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    //console.log(props, "props at dropdown in edit user");
    var notRequired = [
        "Area",
        "Sub Area",
        "MCO",
        "Lead Platform"
    ];
    var dispatch = (0,es/* useDispatch */.I0)();
    var inputprops = {
        placeholder: "DD-MM-YYYY",
        readOnly: true
    };
    props.data.map(function(item) {
        if (item.field_label == "Comments From Stakeholders") {
            item.value = "commentsFromStakeHolder";
        } else if (item.field_label == "EL") {
            item.value = "el";
        } else if (item.field_label == "MCO") {
            item.value = "mco";
        } else if (item.field_label == "SPOC") {
            item.value = "spoc";
        } else {
            item.value = camelize(item.field_label);
        }
    });
    var initialStates = {};
    var dropDownsInitialStates = {};
    var requiredFields = [];
    var relatedDropdownToSet = {};
    // nested dropdown
    props.data.map(function(item) {
        if (item.field_input_type == "Related Dropdown" && item.field_related_dropdown.length > 0) {
            var fieldOptions = [];
            item.field_dropdown_option_component.map(function(item) {
                fieldOptions = (0,src_to_consumable_array/* default */.Z)(fieldOptions).concat((0,src_to_consumable_array/* default */.Z)(item.field_options));
            });
        }
    });
    // intial states setup
    props.data.map(function(item) {
        initialStates[item.value] = "";
        if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
            dropDownsInitialStates[item.value] = false;
        }
        if (item.field_required == "1") {
            if (!props.notRequired.includes(item.field_label)) requiredFields.push(item.value);
        }
    });
    props.data.map(function(item) {
        if (item.field_input_type == "Related Dropdown") {
            relatedDropdownToSet[item.value] = item.field_dropdown_option_component;
        }
    });
    // states
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(relatedDropdownToSet), 2), relatedDropdowns = ref[0], setRelatedDropdowns = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref1[0], setState = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(dropDownsInitialStates), 2), dropDownState = ref2[0], setDropdownState = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref3[0], setInvalidFlag = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), value = ref4[0], setValue = ref4[1];
    // related dropdowns initial setup
    //   React.useEffect(() => {
    //     console.log(relatedDropdownToSet, "relatedDropdownToSet");
    //     setRelatedDropdowns();
    //   }, []);
    // handling input values
    // text input changes
    var inputChange = function(e) {
        setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    react.useEffect(function() {
    //console.log(state, "state in form3")
    }, [
        state
    ]);
    // dropdown open close
    var handleDropDown = function(item) {
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownsInitialStates), (0,src_define_property/* default */.Z)({}, item, !dropDownState[item])));
        //console.log(relatedDropdowns,"relatedDropdowns");
        props.data.map(function(item) {
            if (props.formType == "userCreateData" || props.formType == "userAccessEdit") {
                if (value == "") {
                    if (item.field_related_dropdown != "") {
                        var reall = relatedDropdowns;
                        for(var i in reall){
                            delete reall[i].nowValues;
                        }
                        setRelatedDropdowns((0,src_object_spread/* default */.Z)({}, reall));
                    }
                }
            }
        });
    };
    // dropdown value selected
    var gotDropDownValue = function(value, dropdownParent, haveRelated) {
        // debugger
        setValue(value);
        if (value == "None") {
            if (dropdownParent == "country") {
                setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, dropdownParent, [])));
            } else {
                var newState = state;
                delete newState[dropdownParent];
                setState((0,src_object_spread/* default */.Z)({}, newState));
            }
            setDropdownState(dropDownsInitialStates);
        } else {
            var newState1 = state;
            if (haveRelated) {
                delete newState1[haveRelated];
                var relatedDropdownsToChange = relatedDropdowns;
                props.data.map(function(item, index) {
                    if (item.value == haveRelated) {
                        if (camelize(item.field_related_dropdown) != null && camelize(item.field_related_dropdown).length > 0) {
                            //  let newerState = state
                            delete newState1[camelize(item.field_related_dropdown)];
                            delete relatedDropdownsToChange[camelize(item.field_related_dropdown)].nowValues;
                        }
                    }
                });
                var selectedRelatedDropdown = relatedDropdownsToChange[haveRelated];
                selectedRelatedDropdown.nowValues = selectedRelatedDropdown.filter(function(item) {
                    return item.field_title == value;
                })[0].field_options;
                setRelatedDropdowns((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, relatedDropdownsToChange), (0,src_define_property/* default */.Z)({}, haveRelated, selectedRelatedDropdown)));
            }
            setDropdownState((0,src_object_spread/* default */.Z)({}, dropDownsInitialStates));
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, newState1), (0,src_define_property/* default */.Z)({}, dropdownParent, value)));
            if (props.params == "approval") {
                props.sendFormValues((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, newState1), (0,src_define_property/* default */.Z)({}, dropdownParent, value)));
            }
            if (props.formType == "approval") {
                if (dropdownParent == "1.PleaseSelectTheProcessArea") {
                    props.sendDataToApproval({
                        subProcess: state["1.PleaseSelectTheSub-ProcessArea"],
                        process: value
                    });
                } else {
                    props.sendDataToApproval({
                        process: state["1.PleaseSelectTheProcessArea"],
                        subProcess: value
                    });
                }
            }
        }
    };
    // date selected
    var handleDate = function(date, parent) {
        if (typeof date == "object") {
            var bigDate = date._d;
            var dd = String(bigDate.getDate()).padStart(2, "0");
            var mm = String(bigDate.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = bigDate.getFullYear();
            var myDate = dd + "-" + mm + "-" + yyyy;
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, parent, myDate)));
        } else {
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, parent, date._d)));
        }
    };
    // send state to parent
    react.useEffect(function() {
        if (props.getFormValues == true) {
            var moveAhead = true;
            //console.log("required Fields", requiredFields);
            for(var i in requiredFields){
                if (state[requiredFields[i]] == "" || state[requiredFields[i]] == false || state[requiredFields[i]] === undefined || state[requiredFields[i]] == undefined || state[requiredFields[i]] == "undefined" || state[requiredFields[i]] == null) {
                    moveAhead = false;
                    break;
                }
            }
            if (moveAhead == true) {
                props.sendFormValues(state);
                setInvalidFlag(false);
            } else {
                if (props.setGetFormValues) {
                    props.setGetFormValues(false);
                }
                setInvalidFlag(true);
            }
        }
    }, [
        props.getFormValues
    ]);
    // empty states after submit
    react.useEffect(function() {
        setState(initialStates);
        setDropdownState(dropDownsInitialStates);
    }, [
        props.emptyFormValues
    ]);
    react.useEffect(function() {
        if (props.formType == "demand" || props.formType == "userAccessEdit" || props.formType == "userCreateData") {
            if (props.demandEditData != null) {
                setState(props.demandEditData);
            }
        }
    }, []);
    return props.data.map(function(item, index) {
        if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (basicForm_module_default()).colFirst,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (basicForm_module_default()).row,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: props.params === "approval" ? "".concat((basicForm_module_default()).approvalgroup) : props.type === "user" ? "".concat((basicForm_module_default()).userGroup) : "".concat((basicForm_module_default()).inputGroup),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            item.field_label,
                                            props.notRequired.includes(item.field_label) ? null : item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                children: "*"
                                            }) : null
                                        ]
                                    }),
                                    invalidFlag ? !props.notRequired.includes(item.field_label) && (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basicForm_module_default()).errorMessage,
                                        children: item.field_message_ip_error_message
                                    }) : null : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "".concat((basicForm_module_default()).input, " ").concat(invalidFlag ? !props.notRequired.includes(item.field_label) && (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (basicForm_module_default()).errorBorder : null : null),
                                onClick: function() {
                                    handleDropDown(item.value);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basicForm_module_default()).left,
                                        children: state[item.value] == "" || state[item.value] == null || state[item.value] == "undefined" || item.field_label == "Country" ? item.field_input : state[item.value]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basicForm_module_default()).right,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                            name: "chevron",
                                            className: (basicForm_module_default()).chevron
                                        })
                                    })
                                ]
                            }),
                            dropDownState[item.value] == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (basicForm_module_default()).dropdown,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                    dropdownParent: item.value,
                                    params: props.params,
                                    values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? // "None",
                                    (0,src_to_consumable_array/* default */.Z)(relatedDropdowns[item.value].nowValues) : [
                                        "No parent Selected"
                                    ] : // "None",
                                    (0,src_to_consumable_array/* default */.Z)(item.field_options),
                                    getDropdownValue: gotDropDownValue,
                                    // haveRelated={camelize(item.field_related_dropdown)}
                                    closeAllDropdowns: function() {
                                        setDropdownState(dropDownsInitialStates);
                                    }
                                })
                            }) : null,
                            item.field_label == "Country" ? state[item.value].map(function(multipleItem, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (basicForm_module_default()).multipleItems,
                                    children: multipleItem
                                }, index);
                            }) : null
                        ]
                    })
                })
            });
        } else if (item.field_input_type == "Date") {
            //  console.log(state[item.value], 'statevalue');
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (basicForm_module_default()).colFirst,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (basicForm_module_default()).row,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((basicForm_module_default()).inputGroup, " "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            " ",
                                            item.field_label,
                                            " ",
                                            item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                children: "*"
                                            }) : null
                                        ]
                                    }),
                                    invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basicForm_module_default()).errorMessage,
                                        children: "Incorrect Format"
                                    }) : null : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datetime_cjs_default()), {
                                closeOnSelect: true,
                                // initialValue={_.get(state, "dateLogged", [
                                //   "2020-11-12",
                                // ])}
                                value: get_default()(state, item.value, Date.now()),
                                initialValue: Date.now(),
                                timeFormat: false,
                                dateFormat: "DD-MM-YYYY",
                                className: "".concat((basicForm_module_default()).calender, "  ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] == false || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (basicForm_module_default()).errorBorder : null : null),
                                inputProps: inputprops,
                                onChange: function(date) {
                                    return handleDate(date, item.value);
                                }
                            })
                        ]
                    })
                })
            });
        }
    });
}
/* harmony default export */ var BasicForm3 = (BasicForm3_index);

;// CONCATENATED MODULE: ./components/userEditModal/index.jsx






















var userEditModal_ModalExample = function(props) {
    //console.log("Edit User props", props);
    var landscapData = {
        "field_form_field_title": "Landscape",
        "field_label": "Landscape",
        "field_input_type": "Dropdown",
        "field_related_dropdown": null,
        "field_options": [
            "Cordillera",
            "Fusion",
            "Global",
            "Sirius",
            "U2K2"
        ],
        "field_input": "Select Landscape",
        "field_message_ip_error_message": "Landscape is mandatory",
        "field_required": "1",
        "field_dropdown_option_component": [
            {
                "field_title": "",
                "field_options": []
            }
        ],
        "field_editable": "",
        "field_column_size": ""
    };
    //console.log("failure", props.editUserSucessFailure[1].field_message[0]);
    var ref = (0,react.useState)([]), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react.useState)({}), state = ref1[0], setState = ref1[1];
    var ref2 = (0,react.useState)(false), loader = ref2[0], setLoader = ref2[1];
    var leadPlatformData = props.globalData.lead_platform_main_component[0];
    var areaData = props.globalData.lead_platform_main_component[1];
    var subAreaData = props.globalData.lead_platform_main_component[2];
    var clusterData = props.globalData.cluster_main_component[0];
    var mcoData = props.globalData.cluster_main_component[1];
    var countryData = props.globalData.cluster_main_component[2];
    clusterData.field_related_dropdown = "mco";
    mcoData.field_related_dropdown = "";
    //  if (props.userToBeEdited.leadPlatform.length>0){
    //   areaData.nowValues = areaData.field_dropdown_option_component.filter(
    //     (item) => item.field_title == props.userToBeEdited.leadPlatform
    //   )[0].field_options;
    //  }
    //  if (props.userToBeEdited.area.length>0){
    //      subAreaData.nowValues = subAreaData.field_dropdown_option_component.filter(
    //        (item) => item.field_title == props.userToBeEdited.area
    //      )[0].field_options;
    //  }
    // if (props.userToBeEdited.cluster.length > 0) {
    //  mcoData.nowValues = mcoData.field_dropdown_option_component.filter(
    //    (item) => item.field_title == props.userToBeEdited.cluster
    //  )[0].field_options;
    // }
    var ref3 = (0,react.useState)([
        clusterData,
        mcoData
    ]), formData1 = ref3[0], setFormData1 = ref3[1];
    var ref4 = (0,react.useState)([
        leadPlatformData,
        areaData,
        subAreaData, 
    ]), formData2 = ref4[0], setFormData2 = ref4[1];
    var ref5 = (0,react.useState)([
        landscapData
    ]), formData3 = ref5[0], setFormData3 = ref5[1];
    react.useEffect(function() {
        setState(props.userToBeEdited);
    }, []);
    //console.log(props, "props of edit user");
    //console.log(props.editFormDrupalData.component.content.field_title);
    var inputChange = function(e) {
        setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
            userType: e.target.value
        }));
    //console.log("editable  data  ------", e.target.value);
    };
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref6[0], setGetFormValues = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref7[0], setEmptyFormValues = ref7[1];
    var submitDemandForm = function() {
        //console.log("here  ---- on submit", state);
        if (state.userType == "firstGfcf" || state.userType == "gfcf" || state.userType == "firstLevelGPMApprover" || state.userType == "GPMapprover" || state.userType == "businessUserRegionWise" || state.userType == "landscape") {
            setGetFormValues(true);
        } else {
            submitForm((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                userType: state.userType
            }));
            setGetFormValues(false);
        }
    };
    var recievedFormValues = function(formState) {
        //console.log("state of the form of the state ---edit modal ----", formState);
        //setState({ ...state, ...formState });
        submitForm((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state, formState), {
            userType: state.userType
        }));
        setGetFormValues(false);
    };
    var toSend = {};
    var submitForm = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(finalEditedState) {
            var authCheck, expiryStatus, auth, resp, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        //console.log("submit form", getFormValues);
                        if (finalEditedState.userType == "firstGfcf" || finalEditedState.userType == "gfcf" || finalEditedState.userType == "businessUserRegionWise") {
                            toSend = {
                                email: finalEditedState.email,
                                toUpdateUser: {
                                    userType: finalEditedState.userType,
                                    mco: finalEditedState.mco,
                                    cluster: finalEditedState.cluster,
                                    leadPlatform: finalEditedState.leadPlatform,
                                    area: finalEditedState.area,
                                    subArea: finalEditedState.subArea
                                }
                            };
                        } else if (finalEditedState.userType == "firstLevelGPMApprover" || finalEditedState.userType == "GPMapprover") {
                            //console.log("final state --", finalEditedState);
                            toSend = {
                                email: finalEditedState.email,
                                toUpdateUser: {
                                    userType: finalEditedState.userType,
                                    leadPlatform: finalEditedState.leadPlatform,
                                    area: finalEditedState.area,
                                    subArea: finalEditedState.subArea
                                }
                            };
                        } else if (finalEditedState.userType == "gCad") {
                            toSend = {
                                email: finalEditedState.email,
                                toUpdateUser: {
                                    userType: finalEditedState.userType,
                                    mco: "Global",
                                    cluster: "Global"
                                }
                            };
                        } else if (finalEditedState.userType == "landscape") {
                            if (finalEditedState.landscape == "Global") {
                                finalEditedState.landscapeId = "0";
                            }
                            if (finalEditedState.landscape == "Fusion") {
                                finalEditedState.landscapeId = "1";
                            }
                            if (finalEditedState.landscape == "Sirius") {
                                finalEditedState.landscapeId = "2";
                            }
                            if (finalEditedState.landscape == "Cordillera") {
                                finalEditedState.landscapeId = "3";
                            }
                            if (finalEditedState.landscape == "U2K2") {
                                finalEditedState.landscapeId = "4";
                            }
                            toSend = {
                                email: finalEditedState.email,
                                toUpdateUser: {
                                    userType: finalEditedState.userType,
                                    landscape: finalEditedState.landscape,
                                    landscapeId: finalEditedState.landscapeId
                                }
                            };
                        } else if (finalEditedState.userType == "infosec") {
                            toSend = {
                                email: finalEditedState.email,
                                toUpdateUser: {
                                    userType: finalEditedState.userType
                                }
                            };
                        } else {
                            toSend = {
                                email: finalEditedState.email,
                                toUpdateUser: {
                                    userType: finalEditedState.userType
                                }
                            };
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        setLoader(true);
                        if (!expiryStatus) return [
                            3,
                            4
                        ];
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                method: "PUT",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/user/updateUserDetails"),
                                data: toSend,
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 3:
                        resp = _state.sent();
                        //console.log("respose all user ", resp.data.data);
                        setLoader(false);
                        if (resp.data.code == 403) {
                            setLoader(false);
                            props.sessionTimeOutCheck(true);
                        // alert("unauthorized user")
                        } else if (resp.data.code == 401 || resp.data.code == 402) {
                            props.setFail(true);
                            props.setedituser(false);
                            props.getUserData();
                            props.setSuccessModal(true);
                            props.setMessage(props.editUserSucessFailure[1].field_message[0]);
                        // alert(resp.data.message)
                        } else if (resp.data.code == 200) {
                            // alert("user Edited")
                            props.setFail(false);
                            props.setedituser(false);
                            props.userEdited();
                            props.setSuccessModal(true);
                            props.setMessage(props.editUserSucessFailure[0].field_message[0]);
                        } else if (resp.data.code == 405) {
                            props.setFail(true);
                            props.setedituser(false);
                            props.getUserData();
                            props.setSuccessModal(true);
                            props.setMessage(resp.data.message);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoader(false);
                        props.sessionTimeOutCheck(true);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        //console.log(toSend, "state of final form ");
        });
        return function submitForm(finalEditedState) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (userEdit_module_default()).editModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (userEdit_module_default()).modalBox,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (userEdit_module_default()).modalHeader,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (userEdit_module_default()).content,
                        children: lodash_default().get(props, "editFormDrupalData.component.content.field_title", "")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (userEdit_module_default()).modalBody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (userEdit_module_default()).formGroup,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: (userEdit_module_default()).mainLabel,
                                    children: lodash_default().get(props, "editFormDrupalData.component.content.field_label", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (userEdit_module_default()).inputGroupWrapper,
                                    onChange: inputChange,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "Support"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "supportStatus",
                                                    checked: state.userType == "supportStatus"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "Admin"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "admin",
                                                    checked: state.userType == "admin" ? true : false
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "First Level GFCF"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "firstGfcf",
                                                    checked: state.userType == "firstGfcf"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "Second Level GFCF"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "gfcf",
                                                    checked: state.userType == "gfcf"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "First Level GPM"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "firstLevelGPMApprover",
                                                    checked: state.userType == "firstLevelGPMApprover"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "Second Level GPM"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "GPMapprover",
                                                    checked: state.userType == "GPMapprover"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "GCAD"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "gCad",
                                                    checked: state.userType == "gCad"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "End User"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "endUser",
                                                    checked: state.userType == "endUser"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "Internal User"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "internalUser",
                                                    checked: state.userType == "internalUser"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "Business User – Regionwise"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "businessUserRegionWise",
                                                    checked: state.userType == "businessUserRegionWise"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "QR Manager"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "qrManager",
                                                    checked: state.userType == "qrManager"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "Landscape"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "landscape",
                                                    checked: state.userType == "landscape"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (userEdit_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).subLabel,
                                                    children: "Infosec"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (userEdit_module_default()).radioBox,
                                                    name: "userTypeEdit",
                                                    value: "infosec",
                                                    checked: state.userType == "infosec"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (userEdit_module_default()).radioCheckmark
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : null,
                        state.userType == "businessUserRegionWise" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (userEdit_module_default()).basicFormWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(basicForm["default"], {
                                data: formData1,
                                sendFormValues: recievedFormValues,
                                getFormValues: getFormValues,
                                emptyFormValues: emptyFormValues,
                                formType: "userAccessEdit",
                                params: "userAccessEdit",
                                // editState={state}
                                setGetFormValues: setGetFormValues,
                                demandEditData: props.userToBeEdited,
                                userType: state.userType,
                                type: "form"
                            })
                        }) : null,
                        state.userType == "firstGfcf" || state.userType == "gfcf" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (userEdit_module_default()).basicFormWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicForm2, {
                                    data: (0,src_to_consumable_array/* default */.Z)(formData1).concat((0,src_to_consumable_array/* default */.Z)(formData2)),
                                    sendFormValues: recievedFormValues,
                                    getFormValues: getFormValues,
                                    emptyFormValues: emptyFormValues,
                                    formType: "userCreateData",
                                    notRequired: [
                                        "Area",
                                        "Sub Area",
                                        "MCO",
                                        "Lead Platform"
                                    ],
                                    // editState={state}
                                    demandEditData: props.userToBeEdited,
                                    type: "user",
                                    setGetFormValues: setGetFormValues,
                                    params: "userAccess"
                                })
                            })
                        }) : null,
                        state.userType == "firstLevelGPMApprover" || state.userType == "GPMapprover" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (userEdit_module_default()).basicFormWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicForm2, {
                                data: formData2,
                                sendFormValues: recievedFormValues,
                                getFormValues: getFormValues,
                                emptyFormValues: emptyFormValues,
                                notRequired: [
                                    "Area",
                                    "Sub Area",
                                    "MCO"
                                ],
                                formType: "userAccessEdit",
                                params: "userAccessEdit",
                                // editState={state}
                                demandEditData: props.userToBeEdited,
                                setGetFormValues: setGetFormValues,
                                type: "form"
                            })
                        }) : null,
                        state.userType == "landscape" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (userEdit_module_default()).basicFormWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicForm3, {
                                data: formData3,
                                sendFormValues: recievedFormValues,
                                getFormValues: getFormValues,
                                emptyFormValues: emptyFormValues,
                                notRequired: [
                                    "Area",
                                    "Sub Area",
                                    "MCO"
                                ],
                                formType: "userAccessEdit",
                                params: "userAccessEdit",
                                // editState={state}
                                demandEditData: props.userToBeEdited,
                                setGetFormValues: setGetFormValues,
                                type: "form"
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (userEdit_module_default()).modalFooter,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (userEdit_module_default()).combinedBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (userEdit_module_default()).rowBtn,
                                onClick: function() {
                                    props.setedituser(false);
                                    document.body.style.overflow = "unset";
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (userEdit_module_default()).exportListBtn,
                                onClick: function() {
                                    submitDemandForm();
                                },
                                children: "Edit User"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var userEditModal_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function userEditModal_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var userEditModal = ((0,es/* connect */.$j)(userEditModal_mapStateToProps, userEditModal_mapDispatchToProps)(userEditModal_ModalExample));

// EXTERNAL MODULE: ./components/adduser/index.module.scss
var index_module = __webpack_require__(41579);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/adduser/index.jsx













//import SucessModal from "../dynamicSuccessModal";






function adduser_index(props) {
    var mobileProps = props.mobileAddUser;
    var initialState = {
        name: "",
        image: "",
        email: "",
        userType: ""
    };
    var ref = (0,react.useState)(false), loader = ref[0], setloader = ref[1];
    var ref1 = (0,react.useState)({}), finalState = ref1[0], setfinalState = ref1[1];
    var recievedFormValues = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(formState) {
            var finalState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                finalState = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.createUserState, formState), {
                    userType: userType
                });
                //console.log("final State ----", finalState);
                if (!props.editUser) {
                    props.addUser(finalState);
                } else if (props.editUser) {
                    editUser(finalState);
                }
                setGetFormValues(false);
                return [
                    2
                ];
            });
        });
        return function recievedFormValues(formState) {
            return _ref.apply(this, arguments);
        };
    }();
    var editUser = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(finalEditedState) {
            var toSend, authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        toSend = "";
                        if (finalEditedState.userType == "firstGfcf" || finalEditedState.userType == "gfcf" || finalEditedState.userType == "businessUserRegionWise") {
                            toSend = {
                                email: finalEditedState.email,
                                toUpdateUser: {
                                    userType: finalEditedState.userType,
                                    mco: finalEditedState.mco,
                                    leadPlatform: finalEditedState.leadPlatform,
                                    area: finalEditedState.area,
                                    subArea: finalEditedState.subArea,
                                    cluster: finalEditedState.cluster
                                }
                            };
                        } else if (finalEditedState.userType == "firstLevelGPMApprover" || finalEditedState.userType == "GPMapprover") {
                            //console.log("final state --", finalEditedState);
                            toSend = {
                                email: finalEditedState.email,
                                toUpdateUser: {
                                    userType: finalEditedState.userType,
                                    leadPlatform: finalEditedState.leadPlatform,
                                    area: finalEditedState.area,
                                    subArea: finalEditedState.subArea
                                }
                            };
                        } else {
                            toSend = {
                                email: finalEditedState.email,
                                toUpdateUser: {
                                    userType: finalEditedState.userType
                                }
                            };
                        }
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        authCheck = _state.sent();
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            updateUser(auth, toSend);
                        } else {
                            setLoader(false);
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function editUser(finalEditedState) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateUser = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(auth, toSend) {
            var authCheck, expiryStatus, resp, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        setloader(true);
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        authCheck = _state.sent();
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            axios_default()({
                                method: "PUT",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/user/updateUserDetails"),
                                data: toSend,
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 3:
                        resp = _state.sent();
                        //console.log("respose all user ", resp.data);
                        if (resp.data.code == 403) {
                            setloader(false);
                            props.sessionTimeOutCheck(true);
                        } else if (resp.data.code == 401 || resp.data.code == 402) {
                            setloader(false);
                            props.setmobileSucess(true);
                            props.getUserData();
                            props.setEditUser(false);
                        } else if (resp.data.code == 200) {
                            setloader(false);
                            props.setmobileSucess(true);
                            props.userEdited();
                            props.setEditUser(false);
                        //console.log("response udapte user  ---", resp.data);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        props.sessionTimeOutCheck(true);
                        setLoader(false);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        console.log("eroor", e);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function updateUser(auth, toSend) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), sucess = ref2[0], setsucess = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref3[0], setInvalidFlag = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), userType = ref4[0], setUserType = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref5[0], setGetFormValues = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref6[0], setEmptyFormValues = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), userToBeEdited = ref7[0], setUserToBeEdited = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidUsertypeFlag = ref8[0], setInvalidUserType = ref8[1];
    // const [props.createUserState, setCreateUserState] = React.useState(initialState);
    react.useEffect(function() {
        if (props.editUser) {
            //console.log("User to be edited", props.userToBeEdited);
            setUserToBeEdited(props.userToBeEdited);
            setUserType(props.userToBeEdited.userType);
        }
    }, []);
    var message = {
        field_title: "User created"
    };
    var radioInputChange = function(e) {
        // console.log(e.target.name, "name of state to chanfge ", "e target value ---", e.target.value);
        setUserType(e.target.value);
    };
    react.useEffect(function() {
        setInvalidFlag(props.mobileError);
    }, [
        props.mobileError
    ]);
    react.useEffect(function() {
        setInvalidUserType(props.invalidUsertypeMobileError);
    }, [
        props.invalidUsertypeMobileError
    ]);
    react.useEffect(function() {
        setsucess(props.mobileSucess);
    }, [
        props.mobileSucess
    ]);
    var addEditUser = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var editUserState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                //console.log("Add or edit user ---");
                if (userType == "firstGfcf" || userType == "gfcf" || userType == "firstLevelGPMApprover" || userType == "GPMapprover" || userType == "businessUserRegionWise" || userType == "landscape" || userType == "infosec") {
                    setGetFormValues(true);
                } else if (!props.editUser) {
                    //console.log(props.createUserState, "props.createUserState", userType)
                    props.addUser((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.createUserState), {
                        userType: userType
                    }));
                } else if (props.editUser) {
                    editUserState = userToBeEdited;
                    //console.log("user to be edited ---", editUserState);
                    editUserState.userType = userType;
                    editUser(editUserState);
                }
                return [
                    2
                ];
            });
        // else if (props.editUser) {
        // }
        });
        return function addEditUser() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).editModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).modalBox,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (index_module_default()).modalHeader,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (index_module_default()).content,
                        children: props.editUser ? "Edit User" : "Add User"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).modalBody,
                    children: [
                        props.editUser == false ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (index_module_default()).formGroup,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    children: [
                                        "Email",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "".concat(invalidFlag ? (index_module_default()).errorBorder : null),
                                    type: "text",
                                    placeholder: "Email",
                                    name: "email",
                                    onChange: props.inputChange,
                                    value: props.createUserState.email
                                }),
                                invalidFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (index_module_default()).errorMessage,
                                    children: "Email can't be Empty / Enter valid unilever email"
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).userTypeerrorMessage,
                                    children: invalidUsertypeFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (index_module_default()).errorMessage,
                                        children: "Please select usertype"
                                    }) : null
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (index_module_default()).formGroup,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: (index_module_default()).mainLabel,
                                    children: get_default()(mobileProps, "data.field_component[1].component.content.field_label", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (index_module_default()).inputGroupWrapper,
                                    onChange: radioInputChange,
                                    children: [
                                        get_default()(mobileProps, "data.field_component[0].component.content.field_user_mapping_fields[1].field_input_values", []).map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (index_module_default()).radioWrapper,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (index_module_default()).subLabel,
                                                        children: get_default()(item, "field_input_value_1", "")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "radio",
                                                        className: (index_module_default()).radioBox,
                                                        value: get_default()(item, "field_input_value_2", ""),
                                                        name: "couldBeAnything",
                                                        checked: get_default()(item, "field_input_value_2", "") == userType
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (index_module_default()).radioCheckmark
                                                    })
                                                ]
                                            }, index);
                                        }),
                                        userType == "firstGfcf" || userType == "gfcf" || userType == "businessUserRegionWise" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicForm2, {
                                            data: (0,src_to_consumable_array/* default */.Z)(props.formData1).concat((0,src_to_consumable_array/* default */.Z)(props.formData2)),
                                            notRequired: [
                                                "Area",
                                                "Sub Area",
                                                "MCO",
                                                "Lead Platform"
                                            ],
                                            sendFormValues: recievedFormValues,
                                            getFormValues: getFormValues,
                                            emptyFormValues: emptyFormValues,
                                            formType: "userCreateData",
                                            //editState={state}
                                            demandEditData: userToBeEdited,
                                            setGetFormValues: setGetFormValues,
                                            type: "user"
                                        }) : null,
                                        userType == "firstLevelGPMApprover" || userType == "GPMapprover" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicForm2, {
                                            data: props.formData2,
                                            notRequired: [
                                                "Area",
                                                "Sub Area",
                                                "MCO"
                                            ],
                                            sendFormValues: recievedFormValues,
                                            getFormValues: getFormValues,
                                            emptyFormValues: emptyFormValues,
                                            formType: "userCreateData",
                                            // editState={state}
                                            demandEditData: userToBeEdited,
                                            type: "user",
                                            setGetFormValues: setGetFormValues
                                        }) : null,
                                        userType == "landscape" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicForm3, {
                                            data: props.formData3,
                                            sendFormValues: recievedFormValues,
                                            notRequired: [],
                                            getFormValues: getFormValues,
                                            emptyFormValues: emptyFormValues,
                                            formType: "userCreateData",
                                            // editState={state}
                                            demandEditData: userToBeEdited,
                                            type: "user",
                                            setGetFormValues: setGetFormValues
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (index_module_default()).modalFooter,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).combinedBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (index_module_default()).rowBtn,
                                onClick: props.editUser ? function() {
                                    props.setEditUser(false);
                                } : function() {
                                    return props.setMobileAddUserForm(false);
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (index_module_default()).exportListBtn,
                                onClick: addEditUser,
                                children: props.editUser ? "Edit User" : "Add User"
                            })
                        ]
                    })
                }),
                loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : null
            ]
        })
    });
}
var adduser_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function adduser_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var adduser = ((0,es/* connect */.$j)(adduser_mapStateToProps, adduser_mapDispatchToProps)(adduser_index));

;// CONCATENATED MODULE: ./components/Pagination/index.jsx





var Pagination_index = function(props) {
    var ref = (0,react.useState)([]), allPages = ref[0], setAllPages = ref[1];
    var ref1 = (0,react.useState)(1), first = ref1[0], setFirst = ref1[1];
    var ref2 = (0,react.useState)(2), second = ref2[0], setSecond = ref2[1];
    var ref3 = (0,react.useState)(true), forward = ref3[0], setForward = ref3[1];
    var ref4 = (0,react.useState)(false), backward = ref4[0], setBackward = ref4[1];
    react.useEffect(function() {
        var pages = [];
        //console.log(props.totalLength, "totalLength kitni hai")
        for(var i = 1; i <= Math.ceil(props.totalLength / 10); i++){
            pages.push(i);
        }
        //console.log(pages)
        setAllPages((0,src_to_consumable_array/* default */.Z)(pages));
        if (props.paginationNum == 1) {
            setFirst(1);
            setSecond(2);
            setBackward(false);
            setForward(true);
        }
    }, [
        props.totalLength
    ]);
    var pageNumClicked = function(pageNum) {
        props.setPaginationNum(pageNum);
        if (pageNum == Math.ceil(props.totalLength / 10)) {
            setForward(false);
            setBackward(true);
            setFirst(pageNum - 1);
            setSecond(pageNum);
        } else if (pageNum == 1) {
            setBackward(false);
            setForward(true);
            setFirst(1);
            setSecond(2);
        }
    };
    var nextPage = function() {
        if (props.paginationNum < Math.ceil(props.totalLength / 10)) {
            if (props.paginationNum == 2) {
                setBackward(true);
            }
            if (props.paginationNum >= Math.ceil(props.totalLength / 10) - 2) {
                setForward(false);
            //    setFirst(1)
            //   setSecond(Math.ceil(props.totalLength/5)-1)
            } else {
                setForward(true);
            }
            if (props.paginationNum == second && props.totalLength > 30) {
                setFirst(props.paginationNum + 1);
                setSecond(props.paginationNum + 2);
            }
            props.setPaginationNum(props.paginationNum + 1);
        }
    };
    var previousPage = function() {
        if (props.paginationNum > 1) {
            if (props.paginationNum == Math.ceil(props.totalLength / 10) - 1) {
                setForward(true);
            }
            if (props.paginationNum <= 3) {
                setBackward(false);
            } else {
                setBackward(true);
            }
            // if (second ==  Math.ceil(props.totalLength/5)-2){
            //     setForward(false)
            //     setFirst(1)
            //     setSecond(Math.ceil(props.totalLength/5)-1)
            //     props.setPaginationNum(props.paginationNum-1)
            // }
            if (props.paginationNum != 1) {
                if (props.paginationNum == first && props.totalLength > 30) {
                    setFirst(props.paginationNum - 2);
                    setSecond(props.paginationNum - 1);
                }
            }
            props.setPaginationNum(props.paginationNum - 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (pagination_module_default()).paginationOuter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (pagination_module_default()).leftArrow,
                        onClick: previousPage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/svg/paginationarrow.png"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (pagination_module_default()).main,
                        children: allPages.map(function(item, index) {
                            if (item == 1 || item == allPages[allPages.length - 1]) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        forward && item == allPages[allPages.length - 1] && props.totalLength > 30 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "    .    .    ."
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat((pagination_module_default()).number, " ").concat(props.paginationNum == item ? (pagination_module_default()).active : null),
                                            onClick: function() {
                                                return pageNumClicked(item);
                                            },
                                            children: item
                                        }, index),
                                        backward && item == 1 && props.totalLength > 30 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "    .    .    ."
                                        }) : null
                                    ]
                                });
                            } else if (item == first || item == second) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "".concat((pagination_module_default()).number, " ").concat(props.paginationNum == item ? (pagination_module_default()).active : null),
                                        onClick: function() {
                                            return pageNumClicked(item);
                                        },
                                        children: item
                                    }, index)
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (pagination_module_default()).rightArrow,
                        onClick: nextPage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/svg/paginationarrow.png"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Pagination = (Pagination_index);

;// CONCATENATED MODULE: ./components/Pages/userAccessMapping/index.jsx
// dependencies













// scss


// endpoint


// components














//import { Dropdown } from "reactstrap";
function userAccessMapping_index(props) {
    //console.log("props admin access ", props)
    var editUserSucessFailure = get_default()(props, "data.field_component[4].component.content.field_message_type_value_pair", []);
    var deleteUser = get_default()(props, "data.field_component[3].component.content.field_message_type_value_pair", []);
    var createUser = get_default()(props, "data.field_component[2].component.content.field_message_type_value_pair", []);
    //console.log("Create User  ---", createUser);
    var ref = (0,react.useState)(false), loader = ref[0], setLoaader = ref[1];
    var drupalData = props.data;
    var globalData = props.globalData;
    var inputRef = react.useRef(null);
    var notRequired = [
        "Area",
        "Sub Area",
        "MCO",
        "Lead Platform"
    ];
    // console.log("Drupal data user acess mapping  ---", props);
    var isMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 720px)"
    });
    // get routes of all page
    var routes = props.data.site_info.menu_component.menu_list;
    // sucess modal state and message
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref1[0], setSuccessModal = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState("User created!"), 2), message = ref2[0], setMessage = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), fail = ref3[0], setFail = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState("All"), 2), usertypeToShow = ref4[0], setUserTypeToShow = ref4[1];
    // saving auth data to state
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), authData = ref5[0], setAuthData = ref5[1];
    // edit user data
    var ref6 = (0,react.useState)(false), editUser = ref6[0], setedituser = ref6[1];
    // user data from get api
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), userData = ref7[0], setUserData = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), filteredUserData = ref8[0], setFilteredUserData = ref8[1];
    // the user to be edited
    var ref9 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), userToBeEdited = ref9[0], setUserToBeEdited = ref9[1];
    var ref10 = (0,react.useState)(0), offset = ref10[0], setOffset = ref10[1];
    var ref11 = (0,react.useState)(1), paginationNum = ref11[0], setPaginationNum = ref11[1];
    var ref12 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), dropDownState = ref12[0], setDropdownState = ref12[1];
    var ref13 = (0,react.useState)(0), userCount = ref13[0], setCount = ref13[1];
    var ref14 = (0,react.useState)(""), searchUser = ref14[0], setsearchUser = ref14[1];
    var ref15 = (0,react.useState)(false), checked = ref15[0], setChecked = ref15[1];
    var ref16 = (0,react.useState)(""), valued = ref16[0], setValued = ref16[1];
    var ref17 = (0,react.useState)(true), firstTime = ref17[0], setFirstTime = ref17[1];
    // get user user data
    var getUserData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(search, userFilter, initial) {
            var sr, offsetA, auth, resp, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sr = "";
                        offsetA = offset;
                        //console.log("Offset", offset);
                        if (search) {
                            //console.log("here");
                            sr = search;
                        //console.log("search", search);
                        // offsetA = 0;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 2:
                        auth = _state.sent();
                        setAuthData(auth);
                        // let offset = 5;
                        setLoaader(true);
                        return [
                            4,
                            axios_default()({
                                method: "GET",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/user/allUser"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                params: {
                                    offset: initial ? 0 : offsetA,
                                    search: sr,
                                    userTypeFilter: userFilter ? userFilter : "All"
                                }
                            })
                        ];
                    case 3:
                        resp = _state.sent();
                        setLoaader(false);
                        if (resp.data.code == 403) {
                            localStorage.removeItem("auth");
                            router_default().push(routes.Login);
                            setLoaader(false);
                            props.sessionTimeOutCheck(true);
                        } else {
                            //console.log(resp.data.data, "response of response");
                            setFirstTime(false);
                            //console.log("thisBeforesettingfalse")
                            setCount(resp.data.data.count);
                            setUserData(resp.data.data.rows);
                            setFilteredUserData((0,src_to_consumable_array/* default */.Z)(resp.data.data.rows));
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        console.log(e, "error that I want");
                        router_default().push(routes.Login);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function getUserData(search, userFilter, initial) {
            return _ref.apply(this, arguments);
        };
    }();
    // Get User Data From Data
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!firstTime) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getUserData(searchUser, userTypeFilter)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        offset
    ]);
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getUserData(searchUser, userTypeFilter)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), []);
    react.useEffect(function() {
        paginationNum >= 1 && setOffset((paginationNum - 1) * 10);
    }, [
        paginationNum
    ]);
    // initial state for create user
    var initialState = {
        name: "",
        image: "",
        email: "",
        userType: ""
    };
    var ref18 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialState), 2), createUserState = ref18[0], setCreateUserState = ref18[1];
    var ref19 = (0,react.useState)(false), invalidUserType = ref19[0], setInvalidUserType = ref19[1];
    var ref20 = (0,react.useState)(false), invalidUsertypeMobileError = ref20[0], setUsertypeMobileError = ref20[1];
    var ref21 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref21[0], setInvalidFlag = ref21[1];
    var ref22 = (0,src_sliced_to_array/* default */.Z)(react.useState("All"), 2), userTypeFilter = ref22[0], setUserTypeFilter = ref22[1];
    // drop down values from global component
    var leadPlatformData = props.globalData.lead_platform_main_component[0];
    var areaData = props.globalData.lead_platform_main_component[1];
    var subAreaData = props.globalData.lead_platform_main_component[2];
    var clusterData = props.globalData.cluster_main_component[0];
    var mcoData = props.globalData.cluster_main_component[1];
    var landscapData = {
        "field_form_field_title": "Landscape",
        "field_label": "Landscape",
        "field_input_type": "Dropdown",
        "field_related_dropdown": null,
        "field_options": [
            "Cordillera",
            "Fusion",
            "Global",
            "Sirius",
            "U2K2"
        ],
        "field_input": "Select Landscape",
        "field_message_ip_error_message": "Landscape is mandatory",
        "field_required": "1",
        "field_dropdown_option_component": [
            {
                "field_title": "",
                "field_options": []
            }
        ],
        "field_editable": "",
        "field_column_size": ""
    };
    //console.log(clusterData, "mcoDaata");
    //console.log(mcoData, "clusterData");
    clusterData.field_related_dropdown = "mco";
    mcoData.field_related_dropdown = "";
    // set cluster and mco data in table
    var ref23 = (0,react.useState)([
        clusterData,
        mcoData
    ]), formData1 = ref23[0], setFormData1 = ref23[1];
    // set lead paltform and area and subareaData
    var ref24 = (0,react.useState)([
        leadPlatformData,
        areaData,
        subAreaData, 
    ]), formData2 = ref24[0], setFormData2 = ref24[1];
    // set Landscape approvers
    var ref25 = (0,react.useState)([
        landscapData
    ]), formData3 = ref25[0], setFormData3 = ref25[1];
    // get form values from form component
    var ref26 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref26[0], setGetFormValues = ref26[1];
    // empty from values
    var ref27 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref27[0], setEmptyFormValues = ref27[1];
    // state for form  values
    var ref28 = (0,react.useState)({}), state = ref28[0], setState = ref28[1];
    var ref29 = (0,react.useState)(false), mobileAddUserForm = ref29[0], setMobileAddUserForm = ref29[1];
    var ref30 = (0,react.useState)(false), mobileError = ref30[0], setmobileError = ref30[1];
    var ref31 = (0,react.useState)(false), mobileSucess = ref31[0], setmobileSucess = ref31[1];
    // create user
    var submitCreateUser = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(createUserState.userType == "firstGfcf" || createUserState.userType == "gfcf" || createUserState.userType == "firstLevelGPMApprover" || createUserState.userType == "GPMapprover" || createUserState.userType == "businessUserRegionWise" || createUserState.userType == "landscape")) return [
                            3,
                            1
                        ];
                        setGetFormValues(true);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            addUser(createUserState)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        if (checked) {
                            setChecked(false);
                            setValued("");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function submitCreateUser() {
            return _ref.apply(this, arguments);
        };
    }();
    // create user
    var addUser = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(finalState) {
            var bearerToken, dataToSend, authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        //console.log("finalState", finalState);
                        //console.log("at the rate ---", createUserState.email.includes("@"));
                        if (createUserState.email == "" || !createUserState.email.includes("@") || createUserState.email.split("@")[1] != "unilever.com") {
                            //console.log("set flag true");
                            if (isMobile) {
                                //console.log("mobile  ---view");
                                setmobileError(true);
                                return [
                                    2
                                ];
                            }
                            setInvalidFlag(true);
                            return [
                                2
                            ];
                        } else {
                            setmobileError(false);
                            setInvalidFlag(false);
                        }
                        if (!finalState.userType) {
                            setInvalidUserType(true);
                            setUsertypeMobileError(true);
                            return [
                                2
                            ];
                        } else {
                            setInvalidUserType(false);
                            setUsertypeMobileError(false);
                        }
                        bearerToken = "";
                        if ( true && localStorage.getItem("auth") != undefined && localStorage.getItem("auth") != null) {
                            bearerToken = JSON.parse(localStorage.getItem("auth")).data.accessToken;
                        //console.log("bearer Token ", bearerToken);
                        }
                        dataToSend = finalState;
                        //console.log("CHECKKKKKBEFORE", dataToSend);
                        if (dataToSend.userType == "gCad") {
                            dataToSend.mco = "Global";
                            dataToSend.cluster = "Global";
                        }
                        //console.log("CHECKKKKKlater", dataToSend)
                        setLoaader(true);
                        window.scrollTo(0, 0);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 2:
                        auth = _state.sent();
                        axios_default()({
                            method: "post",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/user/createUser"),
                            headers: {
                                Authorization: auth.accessToken
                            },
                            data: dataToSend
                        }).then(function(response) {
                            setLoaader(false);
                            if (response.data.code == 200) {
                                if (isMobile) {
                                    //setmobileSucess(true);
                                    setMobileAddUserForm(false);
                                }
                                //createUser[1].field_message[0]
                                // else {
                                setMessage(createUser[0].field_message[0]);
                                setSuccessModal(true);
                                setFail(false);
                                //}
                                setInvalidFlag(false);
                                setmobileError(false);
                                setCreateUserState(initialState);
                            } else if (response.data.code == 403) {
                                localStorage.removeItem("auth");
                                sessionStorage.clear();
                                setLoaader(false);
                                props.sessionTimeOutCheck(true);
                            } else if (response.data.code == 402) {
                                setFail(true);
                                setMessage(response.data.message);
                                setSuccessModal(true);
                                setInvalidFlag(false);
                                setCreateUserState(initialState);
                            } else if (response.data.code == 401) {
                                setFail(true);
                                setMessage(response.data.message);
                                if (isMobile) {
                                    //setmobileSucess(true);
                                    setMobileAddUserForm(false);
                                }
                                // } else {
                                setSuccessModal(true);
                                //}
                                setInvalidFlag(false);
                                setCreateUserState(initialState);
                            }
                            //console.log("resposne create user api----", response);
                            getUserData(null, "All", true);
                            setFirstTime(true);
                            setOffset(0);
                            setPaginationNum(1);
                            inputRef.current.value = "";
                            setUserTypeFilter("All");
                            setUserTypeToShow("All");
                            setCreateUserState(initialState);
                            setsearchUser("");
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoaader(false);
                        props.sessionTimeOutCheck(true);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function addUser(finalState) {
            return _ref.apply(this, arguments);
        };
    }();
    // receive form data
    var recievedFormValues = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(formState) {
            var finalState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        finalState = (0,src_object_spread/* default */.Z)({}, createUserState, formState);
                        //console.log("final State ----", finalState);
                        if (finalState.userType == "landscape") {
                            if (finalState.landscape == "Global") {
                                finalState.landscapeId = "0";
                            }
                            if (finalState.landscape == "Fusion") {
                                finalState.landscapeId = "1";
                            }
                            if (finalState.landscape == "Sirius") {
                                finalState.landscapeId = "2";
                            }
                            if (finalState.landscape == "Cordillera") {
                                finalState.landscapeId = "3";
                            }
                            if (finalState.landscape == "U2K2") {
                                finalState.landscapeId = "4";
                            }
                        }
                        return [
                            4,
                            addUser(finalState)
                        ];
                    case 1:
                        _state.sent();
                        setGetFormValues(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function recievedFormValues(formState) {
            return _ref.apply(this, arguments);
        };
    }();
    // set state sa change of data
    var inputChange = function(e) {
        {}
        if (e.target.name == "userType") {
            setChecked(e.target.checked);
            setValued(e.target.value);
        }
        setCreateUserState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, createUserState), (0,src_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    // React.useEffect(()=>{
    //     e.target.checked=false
    // },[checked])
    };
    var editThis = function(email) {
        //console.log(userData, "useralldataaaaa");
        setUserToBeEdited(filteredUserData.filter(function(item) {
            return item.email == email;
        })[0]);
        var modal = !editUser;
        setedituser(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var deleteThis = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(index) {
            var deleteEmail, authCheck, expiryStatus, auth, deleteUserResponse, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        deleteEmail = userData[index].email;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 3:
                        auth = _state.sent();
                        setAuthData(auth);
                        setLoaader(true);
                        return [
                            4,
                            axios_default()({
                                method: "DELETE",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/user/deleteUser"),
                                headers: {
                                    Authorization: auth.accessToken
                                },
                                data: {
                                    email: deleteEmail
                                }
                            })
                        ];
                    case 4:
                        deleteUserResponse = _state.sent();
                        setLoaader(false);
                        //console.log("Delete user  ---", deleteUserResponse);
                        //console.log("delete failed ", deleteUser[1].field_message);
                        if (deleteUserResponse.data.code == 200) {
                            //deleteUser[0].field_message
                            setMessage("".concat(deleteUser[0].field_message, " ").concat(deleteEmail));
                            setSuccessModal(true);
                            getUserData(null, "All", true);
                            setFirstTime(true);
                            setOffset(0);
                            setPaginationNum(1);
                            inputRef.current.value = "";
                            setUserTypeFilter("All");
                            setUserTypeToShow("All");
                            setsearchUser("");
                        } else if (deleteUserResponse.data.code == 401) {
                            setMessage("".concat(deleteUser[1].field_message, " ").concat(deleteEmail));
                            setSuccessModal(true);
                            getUserData(searchUser, userTypeFilter);
                            setLoaader(false);
                        } else if (deleteUserResponse.data.code == 403) {
                            props.sessionTimeOutCheck(true);
                            setLoaader(false);
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        props.sessionTimeOutCheck(true);
                        setLoaader(false);
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        e = _state.sent();
                        console.log("error ---delete user", e);
                        setLoaader(false);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteThis(index) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref32 = (0,react.useState)(false), reload = ref32[0], setReload = ref32[1];
    react.useEffect(function() {
        if (reload) {
            getUserData(searchUser);
            setReload(false);
        }
    }, [
        reload
    ]);
    var handleDropDown = function(item) {
        setDropdownState(!dropDownState);
    };
    var closeAllDropdowns = function() {
        setDropdownState(false);
    };
    var userTypeArr = [
        "All",
        "Business Owner",
        "End user"
    ];
    props.data.field_component[0].component.content.field_user_mapping_fields[1].field_input_values.map(function(item) {
        return [
            userTypeArr.push(item.field_input_value_1)
        ];
    });
    //console.log(userTypeArr,"userTypeArr");
    var gotDropDownValue = function(value, dropdownParent, haveRelated) {
        var dropdownValueArr = props.data.field_component[0].component.content.field_user_mapping_fields[1].field_input_values.filter(function(item) {
            return item.field_input_value_1 == value;
        });
        //console.log(dropdownValueArr,"dropdownValueArr");
        var filterParam = "";
        if (value == "All") {
            filterParam = "All";
            setUserTypeFilter("All");
        } else if (value == "Business Owner") {
            filterParam = "businessOwner";
            setUserTypeFilter("businessOwner");
        } else if (value == "End user") {
            filterParam = "endUser";
            setUserTypeFilter("endUser");
        } else {
            setUserTypeFilter(dropdownValueArr[0].field_input_value_2);
            filterParam = dropdownValueArr[0].field_input_value_2;
        }
        getUserData(null, filterParam, true);
        setOffset(0);
        setPaginationNum(1);
        inputRef.current.value = "";
        setDropdownState(false);
        setUserTypeToShow(value);
    };
    var userEdited = function() {
        //console.log("Icamehere")
        getUserData(null, "All", true);
        setFirstTime(true);
        setOffset(0);
        setPaginationNum(1);
        inputRef.current.value = "";
        setUserTypeFilter("All");
        setUserTypeToShow("All");
        setsearchUser("");
    };
    var callApi = function() {
        setReload(true);
    };
    var ref33 = (0,src_sliced_to_array/* default */.Z)(react.useState(function() {
        return lodash_default().debounce(callApi, 1000);
    }), 1), debounceCall = ref33[0];
    var searchInTable = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var search;
            return (0,tslib_es6.__generator)(this, function(_state) {
                //console.log("search addmin acess zone ---", e.target.value);
                if (e.target.value.length >= 3) {
                    setUserTypeFilter("All");
                    setUserTypeToShow("All");
                    setOffset(0);
                    search = e.target.value.split(" ");
                    //console.log("search ", search[0]);
                    setsearchUser(search[0]);
                    debounceCall();
                    // getUserData(search[0]);
                    setPaginationNum(1);
                } else {
                    setsearchUser("");
                    debounceCall();
                }
                return [
                    2
                ];
            });
        // if (e.target.value.length == 0) {
        //   setFilteredUserData(userData);
        // } else {
        //   const options = {
        //     shouldSort: true,
        //     keys: ["userType", "email"],
        //   };
        //   const fuse = new Fuse(userData, options);
        //   // Change the pattern
        //   const pattern = e.target.value;
        //   console.log("pattern  -----", pattern);
        //   let fuseResult = fuse.search(`${pattern}`);
        //   let filteredResult = [];
        //   console.log("fusee result  ----", fuseResult);
        //   for (let i in fuseResult) {
        //     filteredResult.push(fuseResult[i].item);
        //   }
        //   setFilteredUserData(filteredResult);
        // }
        });
        return function searchInTable(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container mt-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (userMapping_module_default()).containerUser,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (userMapping_module_default()).left,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: get_default()(props, "data.field_component[0].component.content.field_title", "")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (userMapping_module_default()).userModal,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (userMapping_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                lodash_default().get(props, "data.field_component[0].component.content.field_user_mapping_fields[0].field_label", ""),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "".concat(invalidFlag ? (userMapping_module_default()).errorBorder : null),
                                            type: "text",
                                            placeholder: lodash_default().get(props, "data.field_component[0].component.content.field_user_mapping_fields[0].field_title", ""),
                                            name: "email",
                                            onChange: inputChange,
                                            value: createUserState.email
                                        }),
                                        invalidFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (userMapping_module_default()).errorMessage,
                                            children: lodash_default().get(props, "data.field_component[0].component.content.field_user_mapping_fields[0].field_message_ip_error_message", "")
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (userMapping_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (userMapping_module_default()).mainLabel,
                                            children: lodash_default().get(props, "data.field_component[0].component.content.field_user_mapping_fields[1].field_label", "")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (userMapping_module_default()).inputGroupWrapper,
                                            onChange: inputChange,
                                            children: get_default()(props, "data.field_component[0].component.content.field_user_mapping_fields[1].field_input_values", []).map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (userMapping_module_default()).radioWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (userMapping_module_default()).subLabel,
                                                            children: get_default()(item, "field_input_value_1", "")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "radio",
                                                            className: (userMapping_module_default()).radioBox,
                                                            value: get_default()(item, "field_input_value_2", ""),
                                                            name: "userType",
                                                            checked: get_default()(item, "field_input_value_2", "") == valued ? true : false
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (userMapping_module_default()).radioCheckmark
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                createUserState.userType == "businessUserRegionWise" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(basicForm["default"], {
                                    data: formData1,
                                    sendFormValues: recievedFormValues,
                                    getFormValues: getFormValues,
                                    emptyFormValues: emptyFormValues,
                                    formType: "userCreateData",
                                    // editState={state}
                                    demandEditData: props.userToBeEdited,
                                    setGetFormValues: setGetFormValues,
                                    type: "user",
                                    params: "userAccess"
                                }) : null,
                                createUserState.userType == "firstGfcf" || createUserState.userType == "gfcf" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicForm2, {
                                        data: (0,src_to_consumable_array/* default */.Z)(formData1).concat((0,src_to_consumable_array/* default */.Z)(formData2)),
                                        sendFormValues: recievedFormValues,
                                        getFormValues: getFormValues,
                                        emptyFormValues: emptyFormValues,
                                        notRequired: [
                                            "Area",
                                            "Sub Area",
                                            "MCO",
                                            "Lead Platform"
                                        ],
                                        formType: "userCreateData",
                                        // editState={state}
                                        demandEditData: props.userToBeEdited,
                                        type: "user",
                                        setGetFormValues: setGetFormValues,
                                        params: "userAccess"
                                    })
                                }) : null,
                                createUserState.userType == "landscape" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicForm3, (_obj = {
                                    data: formData3,
                                    notRequired: [],
                                    sendFormValues: recievedFormValues,
                                    getFormValues: getFormValues,
                                    emptyFormValues: emptyFormValues,
                                    formType: "userCreateData",
                                    demandEditData: props.userToBeEdited
                                }, (0,src_define_property/* default */.Z)(_obj, "notRequired", [
                                    ""
                                ]), (0,src_define_property/* default */.Z)(_obj, "type", "user"), (0,src_define_property/* default */.Z)(_obj, "setGetFormValues", setGetFormValues), (0,src_define_property/* default */.Z)(_obj, "params", "userAccess"), _obj)) : null,
                                createUserState.userType == "firstLevelGPMApprover" || createUserState.userType == "GPMapprover" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicForm2, {
                                    data: formData2,
                                    sendFormValues: recievedFormValues,
                                    getFormValues: getFormValues,
                                    emptyFormValues: emptyFormValues,
                                    formType: "userCreateData",
                                    notRequired: [
                                        "Area",
                                        "Sub Area",
                                        "MCO"
                                    ],
                                    // editState={state}
                                    demandEditData: props.userToBeEdited,
                                    type: "user",
                                    setGetFormValues: setGetFormValues,
                                    params: "userAccess"
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (userMapping_module_default()).userTypeerrorMessage,
                                    children: invalidUserType ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (userMapping_module_default()).errorMessage,
                                        children: "Please select usertype"
                                    }) : null
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (userMapping_module_default()).formGroup,
                                    onClick: submitCreateUser,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (userMapping_module_default()).btn,
                                        children: get_default()(props, "data.field_component[0].component.content.field_label", "")
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (userMapping_module_default()).right,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (userMapping_module_default()).head,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: get_default()(props, "data.field_component[0].component.content.field_input", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (userMapping_module_default()).dropdownsearch,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (userMapping_module_default()).listWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (userMapping_module_default()).inputGroup,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "".concat((userMapping_module_default()).input),
                                                        onClick: function() {
                                                            handleDropDown(props.data.field_component[0].component.content.field_user_mapping_fields[1].field_label);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (userMapping_module_default()).left,
                                                                children: usertypeToShow ? usertypeToShow : "Select User Type"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (userMapping_module_default()).right,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                    name: "chevron",
                                                                    className: (userMapping_module_default()).chevron
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                dropDownState == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                                    dropdownParent: props.data.field_component[0].component.content.field_user_mapping_fields[1].field_label,
                                                    closeAllDropdowns: closeAllDropdowns,
                                                    //params = ""
                                                    values: userTypeArr,
                                                    getDropdownValue: gotDropDownValue
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (userMapping_module_default()).mobileBtn,
                                            onClick: function() {
                                                return setMobileAddUserForm(true);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (userMapping_module_default()).mobile,
                                                children: get_default()(props, "data.field_component[0].component.content.field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (userMapping_module_default()).search,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                    name: "searchGrayIcon",
                                                    className: (userMapping_module_default()).searchIcon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "Search",
                                                    onChange: searchInTable,
                                                    ref: inputRef
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (userMapping_module_default()).scrollableTable,
                            children: loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : filteredUserData.length != 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "SN"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "E mail Id"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Work level"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Actions"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: filteredUserData.map(function(user, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: offset + index + 1
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: user.email
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: user.userType == "admin" ? "Admin" : user.userType == "gCad" ? "GCAD" : user.userType == "supportStatus" ? "Support" : user.userType == "releaseManager" ? "Release Manager" : user.userType == "firstLevelGPMApprover" ? "First level GPM" : user.userType == "endUser" ? "End user" : user.userType == "GPMapprover" ? "Second level GPM" : user.userType == "firstGfcf" ? "First level GFCF" : user.userType == "gfcf" ? "Second level GFCF" : user.userType == "internalUser" ? "Internal user" : user.userType == "businessUserRegionWise" ? "Business user(region-wise)" : user.userType == "qrManager" ? "QR Manager" : user.userType == "businessOwner" ? "Business Owner" : user.userType
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                name: "pencilDark",
                                                                className: (userMapping_module_default()).editInactive,
                                                                onClick: function() {
                                                                    editThis(user.email);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                name: "deleteicon",
                                                                className: (userMapping_module_default()).icon,
                                                                onClick: function() {
                                                                    deleteThis(index);
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            });
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((userMapping_module_default()).noresults, " container"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(lodash_default().get(props.data, "field_component[5].component.content.field_no_result_image[0].file_url", ""))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: (userMapping_module_default()).head,
                                        children: [
                                            " ",
                                            lodash_default().get(props.data, "field_component[5].component.content.field_title", "")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (userMapping_module_default()).content,
                                        dangerouslySetInnerHTML: {
                                            __html: lodash_default().get(props.data, "field_component[5].component.content.field_details", "")
                                        }
                                    })
                                ]
                            })
                        }),
                        filteredUserData.length != 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                            totalLength: userCount,
                            paginationNum: paginationNum,
                            setPaginationNum: setPaginationNum
                        }) : null
                    ]
                }),
                successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                    setSuccessModal: setSuccessModal,
                    title: "User Access Mapping",
                    message: message,
                    setMessage: setMessage,
                    fail: fail,
                    setFail: setFail
                }) : null,
                !isMobile && editUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(userEditModal, {
                    userToBeEdited: userToBeEdited,
                    globalData: props.globalData,
                    editFormDrupalData: get_default()(props, "data.field_component[1]", []),
                    setedituser: setedituser,
                    getUserData: getUserData,
                    setSuccessModal: setSuccessModal,
                    setMessage: setMessage,
                    setFail: setFail,
                    editUserSucessFailure: editUserSucessFailure,
                    inputRef: inputRef,
                    userEdited: userEdited
                }) : isMobile && editUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(adduser, {
                    editUser: true,
                    mobileAddUser: props,
                    inputChange: inputChange,
                    setEditUser: setedituser,
                    formData1: formData1,
                    formData2: formData2,
                    formData3: formData3,
                    mobileSucess: mobileSucess,
                    setmobileSucess: setmobileSucess,
                    userToBeEdited: userToBeEdited,
                    getUserData: getUserData,
                    userEdited: userEdited
                }) : null,
                mobileAddUserForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(adduser, {
                    editUser: false,
                    mobileAddUser: props,
                    inputChange: inputChange,
                    createUserState: createUserState,
                    setMobileAddUserForm: setMobileAddUserForm,
                    addUser: addUser,
                    formData1: formData1,
                    formData2: formData2,
                    formData3: formData3,
                    mobileError: mobileError,
                    setmobileError: setmobileError,
                    invalidUsertypeMobileError: invalidUsertypeMobileError,
                    setUsertypeMobileError: setUsertypeMobileError,
                    mobileSucess: mobileSucess,
                    setmobileSucess: setmobileSucess,
                    userEdited: userEdited
                }) : null
            ]
        })
    });
}
var userAccessMapping_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function userAccessMapping_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var userAccessMapping = ((0,es/* connect */.$j)(userAccessMapping_mapStateToProps, userAccessMapping_mapDispatchToProps)(userAccessMapping_index));

// EXTERNAL MODULE: ./styles/pages/approvals.module.scss
var approvals_module = __webpack_require__(87003);
var approvals_module_default = /*#__PURE__*/__webpack_require__.n(approvals_module);
;// CONCATENATED MODULE: ./components/Pages/approvals/index.jsx


















//import Pagination from '../../Pagination'




function approvals_index(props) {
    var isTabletOrMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 768px)"
    });
    var intialOffset = 0;
    var ref = (0,react.useState)(intialOffset), offset = ref[0], setOffset = ref[1];
    var ref1 = (0,react.useState)(false), filterOn = ref1[0], setFilterOn = ref1[1];
    //console.log("Props approval druple data-----", props.data);
    //props.data[0].component.content.field_approvals_component[0].field_options
    // console.log("zerodata -",props.data[1].component.content)
    //console.log("Props approval -----", props);
    //console.log("zerodata -", props.data[1].component.content)
    var ref2 = (0,react.useState)(""), searchKeyword = ref2[0], setsearchKeyword = ref2[1];
    // const filterDrupalData = props.data[0].component.content.field_approvals_component[0].field_demand_table_filters
    //  console.log("props global data ----", props.globalData);
    props.globalData.cluster_main_component[0].field_related_dropdown = "";
    var landscapData = {
        "field_form_field_title": "Landscape",
        "field_label": "Landscape",
        "field_input_type": "Dropdown",
        "field_related_dropdown": null,
        "field_options": [
            "Cordillera",
            "Fusion",
            "Global",
            "Sirius",
            "U2K2"
        ],
        "field_input": "Select Landscape",
        "field_message_ip_error_message": "Landscape is mandatory",
        "field_required": "0",
        "field_dropdown_option_component": [
            {
                "field_title": "",
                "field_options": []
            }
        ],
        "field_editable": "",
        "field_column_size": ""
    };
    var ref3 = (0,react.useState)([
        props.globalData.cluster_main_component[0],
        props.globalData.lead_platform_main_component[0],
        props.globalData.lead_platform_main_component[1],
        props.globalData.lead_platform_main_component[2]
    ]), filterDropdowns = ref3[0], setFiltersDropdowns = ref3[1];
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)(false), clearDropDown = ref4[0], setClearDropdown = ref4[1];
    var ref5 = (0,react.useState)(false), modalactive = ref5[0], setmodalactive = ref5[1];
    var ref6 = (0,react.useState)([]), botState = ref6[0], setBotState = ref6[1];
    var ref7 = (0,react.useState)(false), loader = ref7[0], setloader = ref7[1];
    var ref8 = (0,react.useState)(false), noResultImage = ref8[0], setNoResultImage = ref8[1];
    var ref9 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        kfa: true
    }), 2), filterState = ref9[0], setFilterState = ref9[1];
    var ref10 = (0,react.useState)(0), length = ref10[0], setLength = ref10[1];
    var ref11 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref11[0], setSubmitForm = ref11[1];
    var ref12 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref12[0], setEmptyFormValues = ref12[1];
    var ref13 = (0,react.useState)(""), auth = ref13[0], setAuth = ref13[1];
    var ref14 = (0,react.useState)(false), gfcfSeleted = ref14[0], setGfcfSeleted = ref14[1];
    var ref15 = (0,react.useState)(false), reset = ref15[0], setreset = ref15[1];
    var ref16 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), filterActive = ref16[0], setFilterActive = ref16[1];
    var ref17 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), readMoreState = ref17[0], setReadMoreState = ref17[1];
    var ref18 = (0,react.useState)(1), paginationNum = ref18[0], setPaginationNum = ref18[1];
    var ref19 = (0,react.useState)(0), botCount = ref19[0], setBotCount = ref19[1];
    var ref20 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), mobileFilterRelatedInfo = ref20[0], setMobileFilterRelatedInfo = ref20[1];
    // "businessOwnerAutomatic",
    // "internalUser",
    //"supportStatus",
    // "editAccess",
    var ref21 = (0,react.useState)([
        "admin",
        "internalUser",
        "qrManager",
        "supportStatus",
        "releaseManager"
    ]), nonApprovers = ref21[0], setNonApprovers = ref21[1];
    var ref22 = (0,react.useState)([
        "gCad",
        "firstLevelGPMApprover",
        "GPMapprover",
        "firstGfcf",
        "gfcf",
        "businessOwner",
        "landscape",
        "infosec"
    ]), approvers = ref22[0], setApprovers = ref22[1];
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getBotsForApproval()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    //console.log("Filter  ----", filterState);
    //console.log("Offset ", offset);
    }), [
        filterState,
        offset
    ]);
    react.useEffect(function() {
        paginationNum >= 1 && setOffset((paginationNum - 1) * 5);
    }, [
        paginationNum
    ]);
    var ref23 = (0,react.useState)(""), searchApproval = ref23[0], setsearchApproval = ref23[1];
    var getBotsForApproval = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(kfaOffset) {
            var auth, filter, authCheck, expiryStatus, auth1, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        setAuth(auth);
                        filter = filterState;
                        if (auth.userType == "businessUserRegionWise") {
                            delete filter.kfa;
                        } else if (auth.userType == "businessOwner") {
                            delete filter.kfa;
                            filter.businessOwnerEmailID = auth.email;
                        } else if (auth.userType == "firstLevelGPMApprover" || auth.userType == "GPMapprover") {
                            delete filter.kfa;
                        } else if (auth.userType == "landscape") {
                            if (filter.landscapeId == "") {
                                delete filter.landscapeId;
                            }
                            delete filter.kfa;
                            filter.landscape = true;
                            filter.offset = 0;
                        } else if (auth.userType == "infosec") {
                            delete filter.kfa;
                            filter.infosec = true;
                            filter.offset = 0;
                        }
                        //console.log("filter ---object", filter);
                        if (kfaOffset != undefined) {
                            filter.offset = kfaOffset;
                        } else {
                            filter.offset = offset;
                        }
                        //console.log("Final Filter --", filter);
                        //console.log("search apporval", searchApproval);
                        //console.log(filter, "filter before")
                        setloader(true);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth1 = JSON.parse(localStorage.getItem("auth")).data;
                            axios_default()({
                                method: "get",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/getBotsForApproval"),
                                headers: {
                                    Authorization: "".concat(auth1.accessToken, "|").concat(auth1.email)
                                },
                                params: filter
                            }).then(function(response) {
                                if (response.data.code == 403) {
                                    setloader(false);
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                                if (response.data.code == 200) {
                                    setloader(false);
                                    //console.log("response  ---", response.data.data);
                                    if (response.data.data.rows.length == 0) {
                                        //console.log("empty response  --", response.data.data.rows.length);
                                        setNoResultImage(true);
                                    } else {
                                        console.log("No reslut image");
                                        setNoResultImage(false);
                                    }
                                    setBotCount(response.data.data.count);
                                    setBotState(response.data.data.rows);
                                }
                            });
                        } else {
                            props.sessionTimeOutCheck(true);
                            setloader(false);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        setloader(false);
                        console.log("error", e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getBotsForApproval(kfaOffset) {
            return _ref.apply(this, arguments);
        };
    }();
    // revice filtre from drop dowm
    var recievedFormValues = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(formState) {
            var filter, i, landscapeId, obje;
            return (0,tslib_es6.__generator)(this, function(_state) {
                filter = formState;
                for(var i in filter){
                    if (filter[i] == "") {
                        delete filter[i];
                    }
                }
                landscapeId = "";
                if (formState.landscape == "Global") {
                    landscapeId = "0";
                }
                if (formState.landscape == "Fusion") {
                    landscapeId = "1";
                }
                if (formState.landscape == "Sirius") {
                    landscapeId = "2";
                }
                if (formState.landscape == "Cordillera") {
                    landscapeId = "3";
                }
                if (formState.landscape == "U2K2") {
                    landscapeId = "4";
                }
                obje = (0,src_object_spread/* default */.Z)({}, filter);
                obje.kfa = filterState.kfa;
                obje.gpm = filterState.gpm;
                obje.infosec = filterState.infosec;
                obje.landscape = filterState.landscape;
                if (formState.landscape !== "") {
                    obje.landscapeId = landscapeId;
                }
                setFilterState((0,src_object_spread/* default */.Z)({}, obje));
                setPaginationNum(1);
                return [
                    2
                ];
            });
        });
        return function recievedFormValues(formState) {
            return _ref.apply(this, arguments);
        };
    }();
    var searchInTable = function(e) {
        setsearchKeyword(e.target.value);
        //console.log("Search parameter", e.target.value);
        if (e.target.value.length >= 3) {
            setOffset(0);
            var filter = filterState;
            filter.search = e.target.value;
            //console.log("FIter ---", filter);
            setFilterState((0,src_object_spread/* default */.Z)({}, filter));
            setPaginationNum(1);
        } else {
            var filter1 = filterState;
            if (Object.keys(filter1).includes("search")) {
                delete filter1.search;
                setFilterState((0,src_object_spread/* default */.Z)({}, filter1));
            }
        }
    };
    // export all bots
    var exportAllBot = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var filter, authCheck, expiryStatus, getBotUsingExcel, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        filter = filterState;
                        if (auth.userType == "businessUserRegionWise") {
                            filter.mco = auth.personalMco;
                            filter.cluster = auth.personalCluster;
                        } else if (auth.userType == "businessOwner") {
                            filter.businessOwnerEmailID = auth.email;
                        }
                        //console.log("filter ---object", filter);
                        setloader(true);
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        authCheck = _state.sent();
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            axios_default()({
                                method: "GET",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/getBotsInExcelApprover"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                params: filter
                            })
                        ];
                    case 3:
                        getBotUsingExcel = _state.sent();
                        if (getBotUsingExcel.data.code == 200) {
                            //console.log("get bot using excel", getBotUsingExcel);
                            setloader(false);
                            window.open(getBotUsingExcel.data.data);
                        }
                        setloader(false);
                        //console.log("get bot using excel response  ---", getBotUsingExcel);
                        if (getBotUsingExcel.data.code == 403) {
                            setloader(false);
                            localStorage.removeItem("auth");
                            sessionStorage.clear();
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setloader(false);
                        props.sessionTimeOutCheck(true);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        setloader(false);
                        console.log("error ---", e);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function exportAllBot() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKfaButton = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var filterGfcf, filterGfcf1, filterGfcf2, filterValues;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        //console.log("id ---", e.target.id);
                        setOffset(0);
                        setPaginationNum(1);
                        if (!(e.target.id == "gfcf")) return [
                            3,
                            1
                        ];
                        filterGfcf = filterState;
                        filterGfcf.kfa = true;
                        filterGfcf.offset = 0;
                        if (Object.keys(filterGfcf).includes("gpm") || Object.keys(filterGfcf).includes("infosec") || Object.keys(filterGfcf).includes("landscape")) {
                            delete filterGfcf["gpm"];
                            delete filterGfcf["infosec"];
                            delete filterGfcf["landscape"];
                            delete filterGfcf["landscapeId"];
                        }
                        //console.log("filter state --", filterGfcf);
                        setFilterState((0,src_object_spread/* default */.Z)({}, filterGfcf));
                        return [
                            3,
                            5
                        ];
                    case 1:
                        if (!(e.target.id == "infosec")) return [
                            3,
                            2
                        ];
                        filterGfcf1 = filterState;
                        filterGfcf1.infosec = true;
                        filterGfcf1.offset = 0;
                        if (Object.keys(filterGfcf1).includes("gpm") || Object.keys(filterGfcf1).includes("kfa") || Object.keys(filterGfcf1).includes("landscape")) {
                            delete filterGfcf1["gpm"];
                            delete filterGfcf1["kfa"];
                            delete filterGfcf1["landscape"];
                            delete filterGfcf1["landscapeId"];
                        }
                        //console.log("filter state --", filterGfcf);
                        setFilterState((0,src_object_spread/* default */.Z)({}, filterGfcf1));
                        return [
                            3,
                            5
                        ];
                    case 2:
                        if (!(e.target.id == "landscape")) return [
                            3,
                            3
                        ];
                        filterGfcf2 = filterState;
                        filterGfcf2.landscape = true;
                        filterGfcf2.offset = 0;
                        if (Object.keys(filterGfcf2).includes("gpm") || Object.keys(filterGfcf2).includes("infosec") || Object.keys(filterGfcf2).includes("kfa")) {
                            delete filterGfcf2["gpm"];
                            delete filterGfcf2["kfa"];
                            delete filterGfcf2["infosec"];
                        }
                        //console.log("filter state --", filterGfcf);
                        // setFilterState(filterGfcf);
                        setFilterState((0,src_object_spread/* default */.Z)({}, filterGfcf2));
                        return [
                            3,
                            5
                        ];
                    case 3:
                        filterValues = filterState;
                        if (Object.keys(filterValues).includes("kfa") || Object.keys(filterValues).includes("infosec") || Object.keys(filterValues).includes("landscape")) {
                            delete filterValues["kfa"];
                            delete filterValues["infosec"];
                            delete filterValues["landscape"];
                            delete filterValues["landscapeId"];
                        }
                        filterValues.gpm = true;
                        filterValues.offset = 0;
                        //console.log("on gpm ---", filterValues);
                        setFilterState(filterValues);
                        return [
                            4,
                            getBotsForApproval(0)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleKfaButton(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var convertToDDMMYYYY = function(date) {
        if (date === undefined || date == null || date == "" || date == "undefined" || date == "NA") {
            return "--";
        } else {
            var year = date.slice(0, 4);
            var month = date.slice(5, 7);
            var day = date.slice(8, 10);
            var newDate = day + "-" + month + "-" + year;
            return newDate;
        }
    };
    var getLandscapeById = function(id) {
        if (id == "0") {
            return "Global";
        }
        if (id == "1") {
            return "Fusion";
        }
        if (id == "2") {
            return "Sirius";
        }
        if (id == "3") {
            return "Cordillera";
        }
        if (id == "4") {
            return "U2K2";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (approvals_module_default()).containerApproval,
        children: [
            nonApprovers.includes(auth.userType) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (approvals_module_default()).buttonstwins,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: filterState.kfa ? (approvals_module_default()).onebtn : (approvals_module_default()).onebtnInactive,
                                    onClick: handleKfaButton,
                                    id: "gfcf",
                                    children: get_default()(props, "data[0].component.content.field_options[0]", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: filterState.gpm ? (approvals_module_default()).twobtn : (approvals_module_default()).twobtnInactive,
                                    onClick: handleKfaButton,
                                    id: "gpm",
                                    children: get_default()(props, "data[0].component.content.field_options[1]", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: filterState.infosec ? (approvals_module_default()).onebtn : (approvals_module_default()).onebtnInactive,
                                    onClick: handleKfaButton,
                                    id: "infosec",
                                    children: get_default()(props, "data[0].component.content.field_options[2]", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: filterState.landscape ? (approvals_module_default()).twobtn : (approvals_module_default()).twobtnInactive,
                                    onClick: handleKfaButton,
                                    id: "landscape",
                                    children: get_default()(props, "data[0].component.content.field_options[3]", "")
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (approvals_module_default()).demandActionHead,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (approvals_module_default()).top,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (approvals_module_default()).left,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (approvals_module_default()).search,
                                                onChange: searchInTable,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                        name: "searchGrayIcon",
                                                        className: (approvals_module_default()).searchIcon
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: searchInTable,
                                                        placeholder: get_default()(props, "data[0].component.content.field_search_placeholder", ""),
                                                        value: searchKeyword != "" ? searchKeyword : ""
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (approvals_module_default()).right,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (approvals_module_default()).combinedBtn,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (approvals_module_default()).rowBtn,
                                                        onClick: function() {
                                                            setFilterState({});
                                                            setreset(true);
                                                            setsearchKeyword("");
                                                            setPaginationNum(1);
                                                        },
                                                        children: get_default()(props, "data[0].component.content.field_button_text[0]", "")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (approvals_module_default()).exportListBtn,
                                                        onClick: exportAllBot,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                name: "uploadicon",
                                                                className: (approvals_module_default()).uploadIcon
                                                            }),
                                                            get_default()(props, "data[0].component.content.field_button_text[1]", "")
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (approvals_module_default()).bottom,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(basicForm["default"], {
                                            data: filterDropdowns,
                                            params: "approval",
                                            sendFormValues: recievedFormValues,
                                            emptyFormValues: emptyFormValues,
                                            reset: reset,
                                            setreset: setreset,
                                            notRequired: []
                                        }),
                                        auth.userType == "admin" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicForm3, {
                                            data: [
                                                landscapData
                                            ],
                                            params: "approval",
                                            notRequired: [],
                                            sendFormValues: recievedFormValues,
                                            emptyFormValues: emptyFormValues,
                                            reset: reset,
                                            setreset: setreset
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            !noResultImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (approvals_module_default()).demandDataBody,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (approvals_module_default()).scrollableTable,
                                    children: [
                                        loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                        children: get_default()(props, "data[0].component.content.field_table_labels", []).map(function(item) {
                                                            if (item != "Process ID") {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    children: item
                                                                });
                                                            } else {
                                                                return null;
                                                            }
                                                        })
                                                    })
                                                }),
                                                isTabletOrMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                    children: botState.map(function(item, index) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.botExternalId
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            target: "_blank",
                                                                            className: (approvals_module_default()).processName,
                                                                            href: "".concat(utility_endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "botDetails?botID=").concat(item.botExternalId),
                                                                            children: item.processName
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.processDescription
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.leadPlatform
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.area
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.subArea
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.cluster
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.country ? item.country.split(";").join(",") : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        children: [
                                                                            item.landscapeId,
                                                                            item.landscapeId !== "" && item.landscapeId !== undefined && item.landscapeId !== null ? getLandscapeById(item.landscapeId) : ""
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.requesterEmailID == "NA" ? "" : item.requesterEmailID
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.engagementLead == "NA" ? "" : item.engagementLead
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.status == "NA" ? "" : item.status
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelgfcfApprover
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGfcfApprovalDate == "2018-12-31" || item.firstLevelGfcfApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.firstLevelGfcfApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelgfcfApprovalStatus ? "Approved" : item.firstLevelgfcfApprovalStatus === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGfcfComment
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGfcfApprover
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGfcfApprovalDate == "2018-12-31" || item.secondLevelGfcfApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.secondLevelGfcfApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGfcfApprovalStatus ? "Approved" : item.secondLevelGfcfApprovalStatus === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGfcfComment
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGpmApprover
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGpmApprovalDate == "2018-12-31" || item.firstLevelGpmApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.firstLevelGpmApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGpmApprovalStatus ? "Approved" : item.firstLevelGpmApprovalStatus === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGpmComment
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGpmApprover
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGpmApprovalDate == "2018-12-31" || item.secondLevelGpmApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.secondLevelGpmApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGpmApprovalStatus ? "Approved" : item.secondLevelGpmApprovalStatus === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGpmComment
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.gcadApprover
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.gcadApprovalDate == "2018-12-31" || item.gcadApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.gcadApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.gcadApprovalStatus ? "Approved" : item.gcadApprovalStatus === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.gcadComments
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.businessOwnerComments
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.landscapeApprovers
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.landscapeApprovalDate == "2018-12-31" || item.landscapeApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.landscapeApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.landscapeApprovalStatuss ? "Approved" : item.landscapeApprovalStatuss === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.landscapeComments
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.infosecApprovers
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.infosecApprovalDate == "2018-12-31" || item.infosecApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.infosecApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.infosecApprovalStatuss ? "Approved" : item.infosecApprovalStatuss === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.infosecComments
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item === null || item === void 0 ? void 0 : item.controlActivityType
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item === null || item === void 0 ? void 0 : item.controlNumber
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                    children: botState.map(function(item, index) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.botExternalId
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            target: "_blank",
                                                                            className: (approvals_module_default()).processName,
                                                                            href: "".concat(utility_endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "botDetails?botID=").concat(window.btoa(item.botID)),
                                                                            children: item.processName
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.processDescription
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.leadPlatform
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.area
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.subArea
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.cluster
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.country.replaceAll(";", ",").substring(0, item.country.length)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.requesterEmailID == "NA" ? "" : item.requesterEmailID
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.engagementLead == "NA" ? "" : item.engagementLead
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.status == "NA" ? "" : item.status
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.landscapeId !== "" && item.landscapeId !== undefined && item.landscapeId !== null ? getLandscapeById(item.landscapeId) : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelgfcfApprover
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGfcfApprovalDate == "2018-12-31" || item.firstLevelGfcfApprovalDate == "2018-12-30" || item.firstLevelGfcfApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.firstLevelGfcfApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelgfcfApprovalStatus ? "Approved" : item.firstLevelgfcfApprovalStatus === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGfcfComment
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGfcfApprover
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGfcfApprovalDate == "2018-12-31" || item.secondLevelGfcfApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.secondLevelGfcfApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGfcfApprovalStatus ? "Approved" : item.secondLevelGfcfApprovalStatus === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGfcfComment
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGpmApprover
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGpmApprovalDate == "2018-12-31" || item.firstLevelGpmApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.firstLevelGpmApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGpmApprovalStatus ? "Approved" : item.firstLevelGpmApprovalStatus === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.firstLevelGpmComment
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGpmApprover
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGpmApprovalDate == "2018-12-31" || item.secondLevelGpmApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.secondLevelGpmApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGpmApprovalStatus ? "Approved" : item.secondLevelGpmApprovalStatus === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.secondLevelGpmComment
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.gcadApprover
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.gcadApprovalDate == "2018-12-31" || item.gcadApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.gcadApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.gcadApprovalStatus ? "Approved" : item.gcadApprovalStatus === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.gcadComments
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.businessOwnerComments
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.landscapeApprovers
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.landscapeApprovalDate == "2018-12-31" || item.landscapeApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.landscapeApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.landscapeApprovalStatuss ? "Approved" : item.landscapeApprovalStatuss === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.landscapeComments
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.infosecApprovers
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.infosecApprovalDate == "2018-12-31" || item.infosecApprovalDate == "2018-12-30" ? "" : convertToDDMMYYYY(item.infosecApprovalDate)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.infosecApprovalStatuss ? "Approved" : item.infosecApprovalStatuss === false ? "Rejected" : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item.infosecComments
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item === null || item === void 0 ? void 0 : item.controlActivityType
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: item === null || item === void 0 ? void 0 : item.controlNumber
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (approvals_module_default()).fixedTable,
                                    children: [
                                        loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                        children: approvers.includes(auth.userType) && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Actions"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                    children: [
                                                        botState.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                                className: (approvals_module_default()).actionMobile,
                                                                children: approvers.includes(auth.userType) && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    onClick: function() {
                                                                        {
                                                                            router.push({
                                                                                pathname: "/approvalForm",
                                                                                query: {
                                                                                    botID: window.btoa(item.botID)
                                                                                }
                                                                            });
                                                                        }
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                            name: "pencilDark",
                                                                            className: (approvals_module_default()).editInactive
                                                                        })
                                                                    })
                                                                })
                                                            });
                                                        }),
                                                        botState.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                                className: (approvals_module_default()).actionDesktop,
                                                                children: approvers.includes(auth.userType) && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    onClick: function() {
                                                                        {
                                                                            router.push({
                                                                                pathname: "/approvalForm",
                                                                                query: {
                                                                                    botID: window.btoa(item.botID)
                                                                                }
                                                                            });
                                                                        }
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                            name: "pencilDark",
                                                                            className: (approvals_module_default()).editInactive
                                                                        })
                                                                    })
                                                                })
                                                            });
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (approvals_module_default()).noresults,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(_.get(props.data[1].component.content, "field_no_result_image[0].file_url", ""))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: (approvals_module_default()).head,
                        children: [
                            " ",
                            _.get(props.data[1].component.content, "field_title", "")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (approvals_module_default()).content,
                        dangerouslySetInnerHTML: {
                            __html: _.get(props.data[1].component.content, "field_details", "")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (approvals_module_default()).mobileFilterBtn,
                onClick: function() {
                    return setFilterActive(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (approvals_module_default()).btn,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                            name: "filters",
                            className: (approvals_module_default()).filterIcon
                        }),
                        "Filters",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                            className: (approvals_module_default()).filterCount,
                            children: length > 4 ? 4 : length
                        })
                    ]
                })
            }),
            botCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationDemand, {
                totalLength: botCount,
                paginationNum: paginationNum,
                setPaginationNum: setPaginationNum
            }) : null,
            filterActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilters_index, {
                filterMobileData: filterDropdowns,
                setState: setFilterState,
                setFilterActive: setFilterActive,
                previousState: filterState,
                mobileFilterRelatedInfo: mobileFilterRelatedInfo,
                setMobileFilterRelatedInfo: setMobileFilterRelatedInfo,
                setLength: setLength,
                length: length,
                setFilterOn: setFilterOn,
                initialState: {
                    kfa: true
                }
            }) : null
        ]
    });
}
var approvals_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function approvals_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var approvals = ((0,es/* connect */.$j)(approvals_mapStateToProps, approvals_mapDispatchToProps)(approvals_index));

// EXTERNAL MODULE: ./styles/pages/globalsearch.module.scss
var globalsearch_module = __webpack_require__(64356);
var globalsearch_module_default = /*#__PURE__*/__webpack_require__.n(globalsearch_module);
;// CONCATENATED MODULE: ./components/Pages/globalSearch/index.jsx










function globalSearch_index(props) {
    var camelize = function camelize(str) {
        return str.toString().replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    var router = (0,next_router.useRouter)();
    var isTabletOrMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 768px)"
    });
    //console.log("props-------------", props);
    var openBotDetailPage = function(botID) {
        // router.push({
        //   pathname: "/botDetails",
        //   query: { botID: botID, searchResults : true },
        // });
        window.open(utility_endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin + "botDetails?botID=".concat(botID, "&searchResults=", true));
    };
    var downloadPdf = function(pdfLink) {
        window.open(pdfLink);
    };
    var formatDocumentSize = function(sizeInBytes) {
        var megaBytes = sizeInBytes / 1e6;
        var kiloBytes = sizeInBytes / 1e3;
        if (megaBytes >= 1) {
            return "".concat(megaBytes.toFixed(1), " mb");
        } else {
            return "".concat(Math.trunc(kiloBytes), " kb");
        }
    };
    var intialState = {
        cez: false,
        botindex: false,
        framework: false,
        contact_us: false,
        all: true
    };
    var indexes = [
        "cez",
        "botindex",
        "framework",
        "contact_us"
    ];
    var ref = (0,react.useState)(intialState), globalIndex = ref[0], setglobalIndex = ref[1];
    react.useEffect(function() {
        //console.log('global search ', props);
        try {
            if (props.searchResult != null) {
                var indexesFromSearch = Object.keys(props.searchResult);
                //console.log(props.searchResult, "SEARCHH")
                var dummy = globalIndex;
                //console.log('Index from search ---', indexesFromSearch);
                for(var i = 0; i < indexes.length; i++){
                    if (indexesFromSearch.includes(indexes[i])) {
                        //console.log("index of --", indexes[i]);
                        //console.log("global1234", globalIndex);
                        if (props.searchResult[indexes[i]].length > 0) {
                            dummy[indexes[i]] = true;
                        } else {
                            dummy[indexes[i]] = false;
                        }
                    }
                }
                var flag = true;
                for(var i1 in dummy){
                    if (i1 != "all") {
                        if (dummy[i1] == true) flag = false;
                    }
                }
                dummy.all = flag;
                setglobalIndex((0,src_object_spread/* default */.Z)({}, dummy));
            }
        } catch (e) {
            console.log(e);
        }
    }, [
        props
    ]);
    react.useEffect(function() {
    //console.log(globalIndex, 'testing');
    }, [
        globalIndex
    ]);
    var contact = _.get(props, "searchResult.contact_us[0]._source.email");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((globalsearch_module_default()).container, " container my-4"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (globalsearch_module_default()).globalContainer,
            children: globalIndex.all ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (globalsearch_module_default()).noresults,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/svg/noresult.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (globalsearch_module_default()).head,
                        children: "No Results to show"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Please check spelling or try different keywords."
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (globalsearch_module_default()).head,
                        children: [
                            " ",
                            "Below listed are the results for the keyword(s) you searched."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (globalsearch_module_default()).text,
                        children: [
                            " ",
                            "Keyword: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: (globalsearch_module_default()).data,
                                children: props.keyword
                            })
                        ]
                    }),
                    globalIndex.cez == false ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (globalsearch_module_default()).cezSearch,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (globalsearch_module_default()).cezhead,
                                children: "Experience Zone"
                            }),
                            get_default()(props.searchResult, "cez", []).map(function(c, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (globalsearch_module_default()).datacez,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (globalsearch_module_default()).datahead,
                                            onClick: function() {
                                                //   router.push({
                                                //   pathname: "/cez",
                                                //   query: { cezSection: c._source.title ==  "Conversational AI" ? "Conversational AI"  : c._source.title == "Test Classification & Analytics" ? "Test classification & analytics": c._source.title == "Anomaly Detection Service" ? "Anomaly detection service" : c._source.title == "Image and Video Analytics" ? "Image and video analytics" : c._source.title == "Document Digitization" ? "Document digitization": "" },
                                                // });
                                                window.open("".concat(utility_endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "cez?cezSection=").concat(c._source.title == "Conversational AI" ? "Conversational AI" : c._source.title == "Text Classification & Analytics" ? "Text+classification+%26+analytics" : c._source.title == "Anomaly Detection Service" ? "Anomaly detection service" : c._source.title == "Image and Video Analytics" ? "Image and video analytics" : c._source.title == "Document Digitization" ? "Document digitization" : ""));
                                            },
                                            children: c._source.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (globalsearch_module_default()).datadetail,
                                            onClick: function() {
                                                // router.push({
                                                //   pathname: "/cez",
                                                //   query: { cezSection: c._source.title ==  "Conversational AI" ? "Conversational AI"  : c._source.title == "Test Classification & Analytics" ? "Test classification & analytics": c._source.title == "Anomaly Detection Service" ? "Anomaly detection service" : c._source.title == "Image and Video Analytics" ? "Image and video analytics" : c._source.title == "Document Digitization" ? "Document digitization": "" },
                                                // });
                                                window.open("".concat(utility_endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "cez?cezSection=").concat(c._source.title == "Conversational AI" ? "Conversational AI" : c._source.title == "Text Classification & Analytics" ? "Text+classification+%26+analytics" : c._source.title == "Anomaly Detection Service" ? "Anomaly detection service" : c._source.title == "Image and Video Analytics" ? "Image and video analytics" : c._source.title == "Document Digitization" ? "Document digitization" : ""));
                                            },
                                            children: "View Details"
                                        })
                                    ]
                                });
                            })
                        ]
                    }),
                    globalIndex.botindex == false ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (globalsearch_module_default()).botSearch,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (globalsearch_module_default()).bothead,
                                children: "Bot Store"
                            }),
                            get_default()(props.searchResult, "botindex", []).sort(function(a, b) {
                                return a._source.botID < b._source.botID ? 1 : -1;
                            }).map(function(b, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (globalsearch_module_default()).databot,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (globalsearch_module_default()).cardHead,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (globalsearch_module_default()).icon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                        onClick: function() {
                                                            return openBotDetailPage(b._source.botID);
                                                        },
                                                        name: camelize(b._source.leadPlatform),
                                                        className: (globalsearch_module_default()).shoppingIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (globalsearch_module_default()).text,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (globalsearch_module_default()).code,
                                                            children: b._source.botID + "        -        " + b._source.processName
                                                        }),
                                                        isTabletOrMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (globalsearch_module_default()).label,
                                                            onClick: function() {
                                                                openBotDetailPage(b._source.botID);
                                                            },
                                                            children: b._source.leadPlatform
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (globalsearch_module_default()).label,
                                                            children: b._source.leadPlatform
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (globalsearch_module_default()).datadetail,
                                            onClick: function() {
                                                return openBotDetailPage(b._source.botID);
                                            },
                                            children: "View Details"
                                        })
                                    ]
                                });
                            })
                        ]
                    }),
                    globalIndex.framework == false ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (globalsearch_module_default()).frameworkSearch,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (globalsearch_module_default()).frameworkhead,
                                children: "Framework"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (globalsearch_module_default()).dataframe,
                                children: get_default()(props.searchResult, "framework", []).map(function(c, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (globalsearch_module_default()).pdfCard,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (globalsearch_module_default()).pdfhead,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (globalsearch_module_default()).iconWrap,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                            name: camelize(c._source.docType),
                                                            className: (globalsearch_module_default()).icon
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        class: (globalsearch_module_default()).pdfTitle,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: c._source.docName
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                children: formatDocumentSize(c._source.docSize)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        onClick: function() {
                                                            downloadPdf("".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(c._source.docUrl));
                                                        },
                                                        className: (globalsearch_module_default()).mobileDownloadIcon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                            name: "downloadBlue"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (globalsearch_module_default()).body,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (globalsearch_module_default()).downloadOverlay,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            onClick: function() {
                                                                downloadPdf("".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/").concat(c._source.docUrl));
                                                            },
                                                            className: (globalsearch_module_default()).downloadBtn,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                    name: "downloadWhite",
                                                                    className: (globalsearch_module_default()).download
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Download"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (globalsearch_module_default()).objWrapper,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                            style: {
                                                                width: "100%"
                                                            },
                                                            src: c._source.docType == "xlsx" || c._source.docType == "doc" || c._source.docType == "docx" ? "https://docs.google.com/viewerng/viewer?embedded=true&url=".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(c._source.docUrl) : c._source.docType == "ppt" || c._source.docType == "pptx" || c._source.docType == "msg" ? "https://view.officeapps.live.com/op/embed.aspx?src=".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(c._source.docUrl) : "".concat(utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl, "/FrameworkDocuments/").concat(c._source.docUrl),
                                                            type: "application/".concat(c._source.docType),
                                                            width: "220",
                                                            height: "100"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    }),
                    globalIndex.contact_us == false ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (globalsearch_module_default()).ContactSearch,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (globalsearch_module_default()).Contacthead,
                                children: "Contact"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (globalsearch_module_default()).datacard,
                                children: get_default()(props.searchResult, "contact_us", []).sort(function(a, b) {
                                    return parseInt(a._id.slice(10)) > parseInt(b._id.slice(10)) ? 1 : -1;
                                }).map(function(c, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (globalsearch_module_default()).contactCard,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (globalsearch_module_default()).userImageWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(get_default()(c._source, "image")),
                                                    className: (globalsearch_module_default()).imagesrc
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (globalsearch_module_default()).infoWrapper,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (globalsearch_module_default()).name,
                                                        children: c._source.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (globalsearch_module_default()).email,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:".concat(contact),
                                                            children: c._source.email
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (globalsearch_module_default()).designation,
                                                        children: c._source.designation
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (globalsearch_module_default()).datadetail,
                                onClick: function() {
                                    return window.open(utility_endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin + "contactUs");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "View More"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var globalSearch_mapStateToProps = function(state) {
    return {
        searchResult: state.search.searchResult,
        keyword: state.search.keyword
    };
};
/* harmony default export */ var globalSearch = ((0,es/* connect */.$j)(globalSearch_mapStateToProps, null)(globalSearch_index));

// EXTERNAL MODULE: ./styles/pages/approvalForm.module.scss
var approvalForm_module = __webpack_require__(57196);
var approvalForm_module_default = /*#__PURE__*/__webpack_require__.n(approvalForm_module);
;// CONCATENATED MODULE: ./components/Pages/approvalForm/index.jsx


























function approvalForm_index(props) {
    var dropDownAr = [
        {
            field_form_field_title: "1. Please select the Process Area",
            field_label: "1. Please select the Process Area",
            field_input_type: "Dropdown",
            field_related_dropdown: "2. Please select the Sub-Process Area",
            field_options: [
                "General",
                "MTD",
                "OTC",
                "STP",
                "RTR"
            ],
            field_input: "Select process area",
            field_message_ip_error_message: "Area is mandatory",
            field_required: "1",
            field_dropdown_option_component: [
                {
                    field_title: "",
                    field_options: []
                }, 
            ],
            field_editable: ""
        },
        {
            field_form_field_title: "2. Please select the Sub-Process Area",
            field_label: "2. Please select the Sub-Process Area",
            field_input_type: "Related Dropdown",
            field_related_dropdown: "",
            field_options: [],
            field_input: "Select sub-process area",
            field_message_ip_error_message: "Area is mandatory",
            field_required: "1",
            field_dropdown_option_component: [
                {
                    field_title: "General",
                    field_options: [
                        "Local Table of Authorities"
                    ]
                },
                {
                    field_title: "MTD",
                    field_options: [
                        "SCF -Inventory Valuation and Variance analysis",
                        "Make - Production and physical inventory movements",
                        "Make & Deliver - Production and physical inventory movements",
                        "Deliver - Production and physical inventory movements",
                        "Make & Deliver - Physical verification/ consignment",
                        "SCF - Obsolete and Unsalable",
                        "SCF - Transfer Pricing",
                        "Master Data",
                        "Make - BOM Maintenance",
                        "SCF - Production and Physical Inventory Movement", 
                    ]
                },
                {
                    field_title: "OTC",
                    field_options: [
                        "Credit Management",
                        "Master Data",
                        "Order Fulfilment",
                        "Customer Billing",
                        "Creation of Rebate Accruals",
                        "Review of rebate accruals",
                        "Rebate claims processing",
                        "Credit / Debit Notes",
                        "Cash Application",
                        "Accounts Receivable",
                        "Order Management",
                        "Refusals / Returns", 
                    ]
                },
                {
                    field_title: "STP",
                    field_options: [
                        "Master Data",
                        "Invoice Processing",
                        "Data transfer",
                        "POs Coupa",
                        "POs Production Item (SAP POs)",
                        "Contract approval",
                        "PO Invoices",
                        "Invoice receipt and Validation",
                        "Blocked Invoices Review",
                        "Payments",
                        "NON SAP system Time and Expenses", 
                    ]
                },
                {
                    field_title: "RTR",
                    field_options: [
                        "Journal Entries",
                        "Reclassification of balances",
                        "Inter-Company",
                        "Reporting",
                        "Master Data",
                        "Foreign Currency",
                        "Period Close",
                        "Open/Close Accounting Periods",
                        "Reconciliations",
                        "Fixed Assets",
                        "Payroll",
                        "Leases",
                        "Sundry Invoices",
                        "Allocations",
                        "Depreciation",
                        "VAT",
                        "Prepare Statutory Reporting", 
                    ]
                }, 
            ]
        }, 
    ];
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState({
        controlActivity: null,
        controlActivityType: "None",
        kfaIuc: null,
        dropData: {},
        controlNumber: ""
    }), 2), state = ref[0], setState = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref1[0], setSubmitForm = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref2[0], setGetFormValues = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref3[0], setEmptyFormValues = ref3[1];
    var ref4 = (0,react.useState)(false), fail = ref4[0], setFail = ref4[1];
    var ref5 = (0,react.useState)(false), showFileName = ref5[0], setShowFileName = ref5[1];
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(false), Loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,react.useState)({}), processData = ref7[0], setProcessData = ref7[1];
    var ref8 = (0,react.useState)(false), successModal = ref8[0], setSuccessModal = ref8[1];
    var ref9 = (0,react.useState)(""), message = ref9[0], setMessage = ref9[1];
    var ref10 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), authData = ref10[0], setAuthData = ref10[1];
    var ref11 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), userType = ref11[0], setUserType = ref11[1];
    var ref12 = (0,react.useState)(false), invalidFlag = ref12[0], setInvalidFlag = ref12[1];
    var ref13 = (0,react.useState)(""), approvalDocument = ref13[0], setApprovalDocument = ref13[1];
    var ref14 = (0,react.useState)({}), editData = ref14[0], setEditData = ref14[1];
    var ref15 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        status: false
    }), 2), dropDownState = ref15[0], setDropdownState = ref15[1];
    var ref16 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), tableData = ref16[0], setTableData = ref16[1];
    var ref17 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), tableCheckbox = ref17[0], setTableCheckbox = ref17[1];
    var ref18 = (0,react.useState)([
        "firstGfcf",
        "gfcf",
        "gCad",
        "businessOwner"
    ]), gfcfApporvers = ref18[0], setgfcfApporvers = ref18[1];
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var auth, authCheck, expiryStatus, getBotToApprove, _obj, editDataoth, botData, is, previouslyFilledControlActivityandKfaIuc, previouslyFilledCommentsandStatus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(localStorage.getItem("auth") != undefined)) return [
                        3,
                        9
                    ];
                    setLoading(true);
                    setState((0,src_object_spread/* default */.Z)({}, state, router.query));
                    auth = JSON.parse(localStorage.getItem("auth")).data;
                    setAuthData(auth);
                    return [
                        4,
                        JSON.parse(localStorage.getItem("auth")).data
                    ];
                case 1:
                    authCheck = _state.sent();
                    return [
                        4,
                        props.checkExpiry(authCheck)
                    ];
                case 2:
                    expiryStatus = _state.sent();
                    if (!expiryStatus) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        axios_default()({
                            method: "GET",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/getBotUsingId?botID=").concat(window.atob(router.query.botID)),
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            }
                        })
                    ];
                case 3:
                    getBotToApprove = _state.sent();
                    if (getBotToApprove.data.code == 403) {
                        setLoading(false);
                        props.sessionTimeOutCheck(true);
                    } else {
                        setProcessData((0,src_object_spread/* default */.Z)({}, getBotToApprove.data.data));
                    }
                    editDataoth = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, "1.PleaseSelectTheProcessArea", getBotToApprove.data.data.firstLevelControlProcessArea), (0,src_define_property/* default */.Z)(_obj, "2.PleaseSelectTheSub-ProcessArea", getBotToApprove.data.data.firstLevelControlSubProcessArea), _obj);
                    setEditData((0,src_object_spread/* default */.Z)({}, editDataoth));
                    botData = getBotToApprove.data.data;
                    is = {
                        controlActivity: botData.firstLevelControlActivity,
                        kfaIuc: botData.kfaIuc
                    };
                    previouslyFilledControlActivityandKfaIuc = {};
                    if (!(auth.userType == "gfcf" || auth.userType == "firstGfcf" || auth.userType == "businessOwner" || auth.userType == "gCad" || auth.userType == "landscape" || auth.userType == "infosec")) return [
                        3,
                        6
                    ];
                    if (!(botData.firstLevelControlTable && botData.firstLevelControlActivity)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        sendDataToApproval({
                            process: botData.firstLevelControlProcessArea,
                            subProcess: botData.firstLevelControlSubProcessArea
                        }, JSON.parse(botData.firstLevelControlTable), true)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    previouslyFilledControlActivityandKfaIuc = (0,src_object_spread/* default */.Z)({
                        dropData: {
                            process: botData.firstLevelControlProcessArea,
                            subProcess: botData.firstLevelControlSubProcessArea
                        }
                    }, is);
                    _state.label = 6;
                case 6:
                    previouslyFilledCommentsandStatus = {};
                    switch(auth.userType){
                        case "firstGfcf":
                            previouslyFilledCommentsandStatus = {
                                status: botData.firstLevelgfcfApprovalStatus ? "Approve" : botData.firstLevelgfcfApprovalStatus === false ? "Reject" : null,
                                comments: botData.firstLevelGfcfComment
                            };
                            break;
                        case "gfcf":
                            previouslyFilledCommentsandStatus = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                status: botData.secondLevelGfcfApprovalStatus ? "Approve" : botData.secondLevelGfcfApprovalStatus === false ? "Reject" : null,
                                comments: botData.secondLevelGfcfComment
                            });
                            break;
                        case "firstLevelGPMApprover":
                            previouslyFilledCommentsandStatus = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                status: botData.firstLevelGpmApprovalStatus ? "Approve" : botData.firstLevelGpmApprovalStatus === false ? "Reject" : null,
                                comments: botData.firstLevelGpmComment
                            });
                            break;
                        case "GPMapprover":
                            previouslyFilledCommentsandStatus = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                status: botData.secondLevelGpmApprovalStatus ? "Approve" : botData.secondLevelGpmApprovalStatus === false ? "Reject" : null,
                                comments: botData.secondLevelGpmComment
                            });
                            break;
                        case "gCad":
                            previouslyFilledCommentsandStatus = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                status: botData.gcadApprovalStatus ? "Approve" : botData.gcadApprovalStatus === false ? "Reject" : null,
                                comments: botData.gcadComments
                            });
                            break;
                        case "landscape":
                            previouslyFilledCommentsandStatus = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                status: botData.landscapeApprovalStatuss ? "Approve" : botData.landscapeApprovalStatuss === false ? "Reject" : null,
                                comments: botData.landscapeComments
                            });
                            break;
                        case "infosec":
                            previouslyFilledCommentsandStatus = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                status: botData.infosecApprovalStatuss ? "Approve" : botData.infosecApprovalStatuss === false ? "Reject" : null,
                                comments: botData.infosecComments
                            });
                            break;
                        case "businessOwner":
                            previouslyFilledCommentsandStatus = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                comments: botData.businessOwnerComments
                            });
                            break;
                        default:
                            break;
                    }
                    setState((0,src_object_spread/* default */.Z)({}, state, previouslyFilledCommentsandStatus, previouslyFilledControlActivityandKfaIuc));
                    setUserType(auth.userType);
                    return [
                        3,
                        8
                    ];
                case 7:
                    // router.push("/login");
                    props.sessionTimeOutCheck(true);
                    setLoading(false);
                    _state.label = 8;
                case 8:
                    setLoading(false);
                    _state.label = 9;
                case 9:
                    return [
                        2
                    ];
            }
        });
    }), [
        router.query
    ]);
    //Retrienving Control number on DropDown Data Change
    (0,react.useEffect)(function() {
        var controlNumber = [];
        Object.keys(tableCheckbox).forEach(function(item, idx) {
            tableData.forEach(function(data, index) {
                if (idx === index) {
                    controlNumber.push(data.control);
                }
            });
        });
        setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
            controlNumber: controlNumber.join(",")
        }));
        console.log(state, "state");
    }, [
        tableCheckbox
    ]);
    // getting control table data and setting it up 
    var sendDataToApproval = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(dropData, controlTable, start) {
            var i, authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(var i in dropData){
                            if (dropData[i] == "") {
                                delete dropData[i];
                            }
                        }
                        if (!start) {
                            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                dropData: dropData
                            }));
                        }
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            setAuthData(auth);
                            axios_default()({
                                method: "get",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/gfcf/getGfcf"),
                                params: dropData,
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(response) {
                                if (response.data.code == 200) {
                                    if (controlTable) {
                                        var newCheckBox = {};
                                        controlTable.map(function(firstItem) {
                                            response.data.data.map(function(secondItem, index) {
                                                if (firstItem.control == secondItem.control) {
                                                    newCheckBox[index] = {
                                                        checked: true,
                                                        mitigationComment: firstItem.mitigationComment
                                                    };
                                                }
                                            });
                                        });
                                        setTableCheckbox(newCheckBox);
                                        setTableData((0,src_to_consumable_array/* default */.Z)(response.data.data));
                                    //	alert("hii2")
                                    } else {
                                        setTableData((0,src_to_consumable_array/* default */.Z)(response.data.data));
                                        setTableCheckbox({});
                                        setEditData({});
                                    }
                                } else if (response.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                    setLoading(false);
                                }
                            });
                        } else {
                            props.sessionTimeOutCheck(true);
                            setLoading(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function sendDataToApproval(dropData, controlTable, start) {
            return _ref.apply(this, arguments);
        };
    }();
    //  for status dropdown
    var handleDropDown = function(item) {
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownState), (0,src_define_property/* default */.Z)({}, item, !dropDownState[item])));
    };
    var gotDropDownValue = function(value, dropdownParent, haveRelated) {
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownState), (0,src_define_property/* default */.Z)({}, dropdownParent, false)));
        setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, dropdownParent, value)));
    };
    var inputChange = function(e) {
        if (e.target.value == "yes") {
            var _obj;
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, e.target.name, true), (0,src_define_property/* default */.Z)(_obj, "controlActivityType", "Global"), _obj)));
        } else if (e.target.value == "no") {
            var _obj1;
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, e.target.name, false), (0,src_define_property/* default */.Z)(_obj1, "controlActivityType", "None"), _obj1)));
        } else {
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, e.target.name, e.target.value)));
        }
    };
    var submitFormData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var moveAhead, requiredFields, i, dataToSend, controlTableJson, controlTableDataArray, i1, tableDataToAdd, authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        moveAhead = true;
                        requiredFields = [
                            "comments",
                            "status"
                        ];
                        for(var i in requiredFields){
                            if (authData.userType != "businessOwner" && (state[requiredFields[i]] === "" || //state[requiredFields[i]] === false ||
                            state[requiredFields[i]] === undefined || state[requiredFields[i]] == undefined || state[requiredFields[i]] == "undefined" || state[requiredFields[i]] == null) || state.controlActivity ? state.dropData.process === undefined || state.dropData.subProcess === undefined || state.dropData.process === "undefined" || state.dropData.subProcess === "undefined" : false) {
                                moveAhead = false;
                            } else if (authData.userType == "businessOwner") {
                                if (state["comments"] == "" || state["comments"] == undefined || state["comments"] == null) {
                                    moveAhead = false;
                                }
                            }
                        }
                        if (!moveAhead) return [
                            3,
                            2
                        ];
                        controlTableJson = "";
                        if (lodash_default().isEmpty(tableCheckbox) != true && state.controlActivity) {
                            controlTableDataArray = [];
                            for(var i1 in tableCheckbox){
                                if (tableCheckbox[i1].checked == true) {
                                    tableDataToAdd = tableData[i1];
                                    tableDataToAdd.mitigationComment = tableCheckbox[i1].mitigationComment;
                                    controlTableDataArray.push(tableDataToAdd);
                                }
                            }
                            controlTableJson = JSON.stringify(controlTableDataArray);
                        }
                        if (authData.userType == "firstGfcf") {
                            //console.log("State  ----", state);
                            dataToSend = {
                                botID: processData.botID,
                                toUpdateBotFileds: {
                                    firstLevelgfcfApprover: authData.name,
                                    firstLevelgfcfApprovalStatus: state.status == "Approve" ? true : state.status == "Reject" ? false : null,
                                    firstLevelGfcfComment: state.comments,
                                    firstLevelGfcfApprovalDate: Date.now(),
                                    firstLevelControlActivity: state.controlActivity,
                                    firstLevelControlTable: controlTableJson,
                                    firstLevelControlProcessArea: state.controlActivity ? state.dropData.process : "",
                                    firstLevelControlSubProcessArea: state.controlActivity ? state.dropData.subProcess : "",
                                    kfaIuc: state.kfaIuc,
                                    controlActivityType: state.controlActivityType,
                                    controlNumber: state.controlNumber
                                }
                            };
                        //console.log(dataToSend, "datatosend");
                        } else if (authData.userType == "firstLevelGPMApprover") {
                            dataToSend = {
                                botID: processData.botID,
                                toUpdateBotFileds: {
                                    firstLevelGpmApprover: authData.name,
                                    firstLevelGpmApprovalStatus: state.status == "Approve" ? true : state.status == "Reject" ? false : null,
                                    firstLevelGpmComment: state.comments,
                                    firstLevelGpmApprovalDate: Date.now(),
                                    controlActivityType: state.controlActivityType,
                                    controlNumber: state.controlNumber
                                }
                            };
                        } else if (authData.userType == "gfcf") {
                            dataToSend = {
                                botID: processData.botID,
                                toUpdateBotFileds: {
                                    secondLevelGfcfApprover: authData.name,
                                    secondLevelGfcfApprovalStatus: state.status == "Approve" ? true : state.status == "Reject" ? false : null,
                                    secondLevelGfcfComment: state.comments,
                                    secondLevelGfcfApprovalDate: Date.now(),
                                    firstLevelControlActivity: state.controlActivity,
                                    firstLevelControlTable: controlTableJson,
                                    firstLevelControlProcessArea: state.dropData.process,
                                    firstLevelControlSubProcessArea: state.dropData.subProcess,
                                    kfaIuc: state.kfaIuc,
                                    controlActivityType: state.controlActivityType,
                                    controlNumber: state.controlNumber
                                }
                            };
                        } else if (authData.userType == "GPMapprover") {
                            dataToSend = {
                                botID: processData.botID,
                                toUpdateBotFileds: {
                                    secondLevelGpmApprover: authData.name,
                                    secondLevelGpmApprovalStatus: state.status == "Approve" ? true : state.status == "Reject" ? false : null,
                                    secondLevelGpmComment: state.comments,
                                    secondLevelGpmApprovalDate: Date.now(),
                                    controlActivityType: state.controlActivityType,
                                    controlNumber: state.controlNumber
                                }
                            };
                        } else if (authData.userType == "landscape") {
                            dataToSend = {
                                botID: processData.botID,
                                toUpdateBotFileds: {
                                    landscapeApprovers: authData.name,
                                    landscapeApprovalStatuss: state.status == "Approve" ? true : state.status == "Reject" ? false : null,
                                    landscapeApprovalDate: Date.now(),
                                    landscapeComments: state.comments,
                                    controlActivityType: state.controlActivityType,
                                    controlNumber: state.controlNumber
                                }
                            };
                        } else if (authData.userType == "infosec") {
                            dataToSend = {
                                botID: processData.botID,
                                toUpdateBotFileds: {
                                    infosecApprovers: authData.name,
                                    infosecApprovalStatuss: state.status == "Approve" ? true : state.status == "Reject" ? false : null,
                                    infosecApprovalDate: Date.now(),
                                    infosecComments: state.comments,
                                    controlActivityType: state.controlActivityType,
                                    controlNumber: state.controlNumber
                                }
                            };
                        } else if (authData.userType == "gCad") {
                            dataToSend = {
                                botID: processData.botID,
                                toUpdateBotFileds: {
                                    firstLevelControlActivity: state.controlActivity,
                                    firstLevelControlTable: controlTableJson,
                                    firstLevelControlProcessArea: state.dropData.process,
                                    firstLevelControlSubProcessArea: state.dropData.subProcess,
                                    gcadApprover: authData.name,
                                    kfaIuc: state.kfaIuc,
                                    gcadApprovalStatus: state.status == "Approve" ? true : state.status == "Reject" ? false : null,
                                    gcadApprovalDate: Date.now(),
                                    gcadComments: state.comments,
                                    controlActivityType: state.controlActivityType,
                                    controlNumber: state.controlNumber
                                }
                            };
                        } else if (authData.userType == "businessOwner") {
                            dataToSend = {
                                botID: processData.botID,
                                toUpdateBotFileds: {
                                    businessOwnerComments: state.comments,
                                    firstLevelControlActivity: state.controlActivity,
                                    firstLevelControlTable: controlTableJson,
                                    firstLevelControlProcessArea: state.dropData.process,
                                    firstLevelControlSubProcessArea: state.dropData.subProcess,
                                    kfaIuc: state.kfaIuc,
                                    controlActivityType: state.controlActivityType,
                                    controlNumber: state.controlNumber
                                }
                            };
                        }
                        //console.log("state ---",authData.userType, state);
                        //console.log("final data to send", dataToSend);
                        if (authData.userType != "businessOwner" && (state["status"] == undefined || state["comments"] == undefined)) {
                            //console.log("here");
                            setMessage("Update the status to Approve/Reject and add some approval message");
                            setSuccessModal(true);
                            return [
                                2
                            ];
                        } else if (authData.userType == "businessOwner" && state["comments"] == undefined) {
                            setMessage("Add Some Comments");
                            setSuccessModal(true);
                            return [
                                2
                            ];
                        }
                        //console.log(approvalDocument, "approvalDocument");
                        //console.log(endPoints.fetchBlobUrl, "fetchBlob");
                        if (approvalDocument != "") {
                            switch(authData.userType){
                                case "firstGfcf":
                                    dataToSend.toUpdateBotFileds.firstLevelGfcfApprovalDocumentLink = approvalDocument;
                                    break;
                                case "gfcf":
                                    dataToSend.toUpdateBotFileds.secondLevelGfcfApprovalDocumentLink = approvalDocument;
                                    break;
                                case "firstLevelGPMApprover":
                                    dataToSend.toUpdateBotFileds.firstLevelGpmApprovalDocumentLink = approvalDocument;
                                    break;
                                case "GPMapprover":
                                    dataToSend.toUpdateBotFileds.secondLevelGpmApprovalDocumentLink = approvalDocument;
                                    break;
                                case "businessOwner":
                                    dataToSend.toUpdateBotFileds.businessOwnerApprovalDocumentLink = approvalDocument;
                                    break;
                                case "landscape":
                                    dataToSend.toUpdateBotFileds.landscapeApprovalDocumentLink = approvalDocument;
                                    break;
                                case "infosec":
                                    dataToSend.toUpdateBotFileds.infosecApprovalDocumentLink = approvalDocument;
                                    break;
                                case "gCad":
                                    dataToSend.toUpdateBotFileds.gCadApprovalDocumentLink = approvalDocument;
                            }
                        //dataToSend.toUpdateBotFileds.approvalDocumentLink = approvalDocument;
                        }
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            setAuthData(auth);
                            setLoading(true);
                            axios_default()({
                                method: "put",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/approveBot"),
                                data: dataToSend,
                                headers: {
                                    Authorization: auth.accessToken
                                }
                            }).then(function(response) {
                                //console.log("response", response);
                                if (response.data.code == 200) {
                                    //props.data[1].component.content.field_message_type_value_pair[0].field_message
                                    setMessage(props.data[1].component.content.field_message_type_value_pair[0].field_message);
                                    setSuccessModal(true);
                                    setLoading(false);
                                } else if (response.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                    setLoading(false);
                                    setFail(true);
                                } else if (response.data.code == 404) {
                                    setMessage(props.data[1].component.content.field_message_type_value_pair[1].field_message[0]);
                                    setSuccessModal(true);
                                    setFail(true);
                                }
                            });
                        } else {
                            props.sessionTimeOutCheck(true);
                            setLoading(false);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setInvalidFlag(true);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function submitFormData() {
            return _ref.apply(this, arguments);
        };
    }();
    // table checkbox change
    var checkBoxChange = function(e, index) {
        if (e.target.checked == true) {
            setTableCheckbox((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tableCheckbox), (0,src_define_property/* default */.Z)({}, index, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tableCheckbox[index]), {
                checked: true
            }))));
        } else {
            setTableCheckbox((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tableCheckbox), (0,src_define_property/* default */.Z)({}, index, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tableCheckbox[index]), {
                checked: false
            }))));
        }
    };
    // table comments change
    var tableMitigationChange = function(e, index) {
        setTableCheckbox((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tableCheckbox), (0,src_define_property/* default */.Z)({}, index, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tableCheckbox[index]), {
            mitigationComment: e.target.value
        }))));
    };
    // document upload
    var blobSasUrlNew = utility_endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo");
    var uploadFile = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(file, name) {
            var fileNameOriginal, fileNameWithSpaces, fileName, ar, extension, fileSize, blockBlobClient, options, resp, url, ar1, another, toSend, auth, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        //console.log(file);
                        setShowFileName(true);
                        fileNameOriginal = file.name;
                        fileNameWithSpaces = fileNameOriginal + Date.now();
                        fileName = fileNameWithSpaces.replace(/ /g, "");
                        ar = fileNameOriginal.split(".");
                        extension = ar[ar.length - 1];
                        fileSize = file.size;
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        url = resp._response.request.url;
                        ar1 = url.split("?");
                        another = ar1[0].split("/");
                        toSend = another[another.length - 1];
                        setApprovalDocument(toSend);
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error, "erro");
                        alert("Could not upload");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadFile(file, name) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (approvalForm_module_default()).formContainer,
        children: [
            Loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (approvalForm_module_default()).head,
                children: props.data[0].component.content.field_title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (approvalForm_module_default()).parentForm,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (approvalForm_module_default()).inputGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: props.data[0].component.content.field_approval_form_component[0].field_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "Approver Name",
                                name: "remark",
                                disabled: true,
                                defaultValue: authData.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (approvalForm_module_default()).ques1,
                        children: props.data[0].component.content.field_approval_form_component[1].field_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (approvalForm_module_default()).Group,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: props.data[0].component.content.field_approval_form_component[1].field_label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "1035",
                                disabled: true,
                                defaultValue: processData.botExternalId
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "1035",
                                hidden: true,
                                disabled: true,
                                defaultValue: processData.botID
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (approvalForm_module_default()).Group,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: props.data[0].component.content.field_approval_form_component[2].field_label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "Cd Operations",
                                disabled: true,
                                defaultValue: processData.processName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (approvalForm_module_default()).Group,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: props.data[0].component.content.field_approval_form_component[3].field_label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "Function",
                                disabled: true,
                                defaultValue: processData.leadPlatform
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (approvalForm_module_default()).Group,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: props.data[0].component.content.field_approval_form_component[4].field_label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "Cd Operations",
                                disabled: true,
                                defaultValue: processData.area
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (approvalForm_module_default()).ques1,
                        children: props.data[0].component.content.field_approval_form_component[5].field_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (approvalForm_module_default()).Group,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                            placeholder: "please enter your address",
                            className: (approvalForm_module_default()).area,
                            name: "briefDescription",
                            defaultValue: processData.processDescription,
                            disabled: true
                        })
                    }),
                    authData.userType == "firstGfcf" || authData.userType == "gfcf" || authData.userType == "gCad" || authData.userType == "businessOwner" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (approvalForm_module_default()).ques1,
                                children: [
                                    "3.",
                                    "  ".concat(props.data[0].component.content.field_approval_form_component[6].field_title, " *")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (approvalForm_module_default()).Group,
                                onChange: inputChange,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (approvalForm_module_default()).radio,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (approvalForm_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (approvalForm_module_default()).subLabel,
                                                    children: "Yes"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (approvalForm_module_default()).radioBox,
                                                    checked: state.controlActivity == null ? false : state.controlActivity ? true : false,
                                                    name: "controlActivity",
                                                    value: "yes"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (approvalForm_module_default()).radioCheckmark
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (approvalForm_module_default()).radio,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (approvalForm_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (approvalForm_module_default()).subLabel,
                                                    children: "No"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (approvalForm_module_default()).radioBox,
                                                    checked: state.controlActivity == null ? false : state.controlActivity === false ? true : false,
                                                    name: "controlActivity",
                                                    value: "no"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (approvalForm_module_default()).radioCheckmark
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            state.controlActivity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (approvalForm_module_default()).ques1,
                                        children: [
                                            "4.",
                                            " Control impacted type: * "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (approvalForm_module_default()).Group,
                                        onChange: inputChange,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (approvalForm_module_default()).radio,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (approvalForm_module_default()).radioWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (approvalForm_module_default()).subLabel,
                                                            children: "Global"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "radio",
                                                            className: (approvalForm_module_default()).radioBox,
                                                            checked: state.controlActivityType === "Global" ? true : false,
                                                            name: "controlActivityType",
                                                            value: "Global"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (approvalForm_module_default()).radioCheckmark
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (approvalForm_module_default()).radio,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (approvalForm_module_default()).radioWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (approvalForm_module_default()).subLabel,
                                                            children: "Local"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "radio",
                                                            className: (approvalForm_module_default()).radioBox,
                                                            checked: state.controlActivityType === "Local" ? true : false,
                                                            name: "controlActivityType",
                                                            value: "Local"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (approvalForm_module_default()).radioCheckmark
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (approvalForm_module_default()).radio,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (approvalForm_module_default()).radioWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (approvalForm_module_default()).subLabel,
                                                            children: "Both (global and local)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "radio",
                                                            className: (approvalForm_module_default()).radioBox,
                                                            checked: state.controlActivityType === "Both (global and local)" ? true : false,
                                                            name: "controlActivityType",
                                                            value: "Both (global and local)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (approvalForm_module_default()).radioCheckmark
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            state.controlActivity ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (approvalForm_module_default()).ques1,
                                        children: [
                                            state.controlActivityType === "None" ? "4. " : "5. ",
                                            "  ".concat(props.data[0].component.content.field_approval_form_component[7].field_title)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (approvalForm_module_default()).ques4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(basicForm["default"], {
                                            invalidFlag: invalidFlag,
                                            state: state,
                                            data: dropDownAr,
                                            // sendFormValues={recievedFormValues}
                                            getFormValues: getFormValues,
                                            emptyFormValues: emptyFormValues,
                                            sendDataToApproval: sendDataToApproval,
                                            formType: "approval",
                                            approvalEditData: editData,
                                            editData: editData
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (approvalForm_module_default()).scrollableTable,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    fontSize: "12px",
                                                    fontWeight: "normal"
                                                },
                                                children: "3."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    children: "Control Number"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    children: "Control Name"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    children: "Control Description"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    children: "Impact"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    children: "Mitigation"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                        children: tableData.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: item.control
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: item.controlName
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: item.controlDescription
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (approvalForm_module_default()).check,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                    className: (approvalForm_module_default()).list_Checkbox_container,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                            type: "checkbox",
                                                                                            onChange: function(e) {
                                                                                                checkBoxChange(e, index);
                                                                                            },
                                                                                            checked: tableCheckbox[index] ? tableCheckbox[index].checked ? true : false : false
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (approvalForm_module_default()).list_checkmark
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                        children: [
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                                                placeholder: "comments",
                                                                                onChange: function(e) {
                                                                                    tableMitigationChange(e, index);
                                                                                },
                                                                                defaultValue: tableCheckbox[index] ? tableCheckbox[index].mitigationComment : ""
                                                                            }, lodash_default().isEmpty(tableCheckbox) ? "notLoded" : "loaded")
                                                                        ]
                                                                    })
                                                                ]
                                                            });
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }) : null,
                    processData.kfa == true && gfcfApporvers.includes(authData.userType) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (approvalForm_module_default()).ques1,
                                children: [
                                    state.controlActivity ? "5. " : "4. ",
                                    props.data[0].component.content.field_approval_form_component[9].field_title
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (approvalForm_module_default()).Group,
                                onChange: inputChange,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (approvalForm_module_default()).radio,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (approvalForm_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (approvalForm_module_default()).subLabel,
                                                    children: "Yes"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (approvalForm_module_default()).radioBox,
                                                    name: "kfaIuc",
                                                    value: "yes",
                                                    checked: state.kfaIuc == null ? false : state.kfaIuc ? true : false
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (approvalForm_module_default()).radioCheckmark
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (approvalForm_module_default()).radio,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (approvalForm_module_default()).radioWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (approvalForm_module_default()).subLabel,
                                                    children: "No"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    className: (approvalForm_module_default()).radioBox,
                                                    name: "kfaIuc",
                                                    checked: state.kfaIuc == null ? false : state.kfaIuc === false ? true : false,
                                                    value: "no"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (approvalForm_module_default()).radioCheckmark
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    authData.userType == "infosec" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (approvalForm_module_default()).ques1,
                                        children: [
                                            "3.",
                                            props.data[0].component.content.field_approval_form_component[12].field_title
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (approvalForm_module_default()).Group_sub,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            placeholder: "1030",
                                            disabled: true,
                                            defaultValue: processData.dataClassification
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (approvalForm_module_default()).ques1,
                                        children: [
                                            "4.",
                                            props.data[0].component.content.field_approval_form_component[13].field_title
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (approvalForm_module_default()).Group_sub,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            placeholder: "1035",
                                            disabled: true,
                                            defaultValue: processData.applications
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (approvalForm_module_default()).ques1,
                                        children: [
                                            "5.",
                                            props.data[0].component.content.field_approval_form_component[14].field_title
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (approvalForm_module_default()).Group_sub,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            placeholder: "1035",
                                            disabled: true,
                                            defaultValue: processData.kfa
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (approvalForm_module_default()).ques1,
                                    children: [
                                        "6.",
                                        props.data[0].component.content.field_approval_form_component[10].field_title + "*"
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    authData.userType == "firstLevelGPMApprover" || authData.userType == "GPMapprover" || authData.userType == "landscape" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (approvalForm_module_default()).ques1,
                            children: [
                                "3.",
                                props.data[0].component.content.field_approval_form_component[10].field_title + " "
                            ]
                        })
                    }) : authData.userType !== "infosec" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (approvalForm_module_default()).ques1,
                        children: [
                            state.controlActivity ? "6. " : state.controlActivityType === "None" ? "4. " : "5. ",
                            props.data[0].component.content.field_approval_form_component[10].field_title + "*"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (approvalForm_module_default()).areaGroup,
                        children: [
                            invalidFlag && !state.comments ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (approvalForm_module_default()).errorMessage,
                                children: "Comments cannot be empty"
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                placeholder: props.data[0].component.content.field_approval_form_component[10].field_placeholder,
                                className: (approvalForm_module_default()).area,
                                name: "comments",
                                onChange: inputChange,
                                value: state.comments
                            })
                        ]
                    }),
                    authData.userType != "businessOwner" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (approvalForm_module_default()).ques1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                gfcfApporvers.includes(authData.userType) ? state.controlActivity ? "7. " : state.controlActivityType === "None" ? "5. " : "6. " : authData.userType == "infosec" ? "7. " : "4. ",
                                                props.data[0].component.content.field_approval_form_component[11].field_label + "*"
                                            ]
                                        }),
                                        invalidFlag && !state["status"] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (approvalForm_module_default()).errorMessage,
                                            children: "Please select a status"
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (approvalForm_module_default()).inputGroupDropdown,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "".concat((approvalForm_module_default()).input),
                                        onClick: function() {
                                            handleDropDown("status");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (approvalForm_module_default()).left,
                                                children: state["status"] == null ? "select status" : state["status"]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (approvalForm_module_default()).right,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                    name: "chevron",
                                                    className: (approvalForm_module_default()).chevron
                                                })
                                            })
                                        ]
                                    }),
                                    dropDownState["status"] == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                        dropdownParent: "status",
                                        values: [
                                            "Approve",
                                            "Reject"
                                        ],
                                        getDropdownValue: gotDropDownValue,
                                        haveRelated: null,
                                        className: (approvalForm_module_default()).dropStatus
                                    }) : null
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (approvalForm_module_default()).ques1,
                        children: [
                            gfcfApporvers.includes(authData.userType) ? state.controlActivity ? authData.userType != "businessOwner" ? "8. " : "7. " : authData.userType != "businessOwner" ? "7. " : "6." : state.controlActivity ? "6. " : authData.userType == "infosec" ? "8. " : "5. ",
                            "Upload Document"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (approvalForm_module_default()).Group,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_uploadFile/* default */.Z, {
                            type: "approvalForm",
                            uploadFile: uploadFile,
                            uploaded: showFileName,
                            fileType: [
                                ".pdf",
                                ".doc",
                                ".docx"
                            ],
                            value: "approvalDocument"
                        })
                    }),
                    authData.userType == "firstGfcf" || authData.userType == "gfcf" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (approvalForm_module_default()).documentLinkWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: processData.firstLevelGfcfApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (approvalForm_module_default()).Group,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (approvalForm_module_default()).ques1,
                                            children: " First level GFCF approval document"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (approvalForm_module_default()).documentLink,
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl + "/" + processData.firstLevelGfcfApprovalDocumentLink,
                                                    target: "_blank",
                                                    children: processData.firstLevelGfcfApprovalDocumentLink
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: processData.secondLevelGfcfApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (approvalForm_module_default()).Group,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (approvalForm_module_default()).ques1,
                                            children: " Second level GFCF approval document"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (approvalForm_module_default()).documentLink,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                href: utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl + "/" + processData.secondLevelGfcfApprovalDocumentLink,
                                                children: processData.secondLevelGfcfApprovalDocumentLink
                                            })
                                        })
                                    ]
                                }) : null
                            })
                        ]
                    }) : authData.userType == "GPMapprover" || authData.userType == "firstLevelGPMApprover" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (approvalForm_module_default()).documentLinkWrapper,
                        children: [
                            processData.firstLevelGpmApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (approvalForm_module_default()).Group,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (approvalForm_module_default()).ques1,
                                        children: " First level GPM approval document"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (approvalForm_module_default()).documentLink,
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                href: utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl + "/" + processData.firstLevelGpmApprovalDocumentLink,
                                                children: processData.firstLevelGpmApprovalDocumentLink
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            processData.secondLevelGpmApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (approvalForm_module_default()).Group,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (approvalForm_module_default()).ques1,
                                        children: " Second level GPM approval document"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (approvalForm_module_default()).documentLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl + "/" + processData.secondLevelGpmApprovalDocumentLink,
                                            children: processData.secondLevelGpmApprovalDocumentLink
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    }) : authData.userType == "gCad" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (approvalForm_module_default()).documentLinkWrapper,
                        children: processData.gCadApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (approvalForm_module_default()).Group,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (approvalForm_module_default()).ques1,
                                    children: " GCAD approval document"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (approvalForm_module_default()).documentLink,
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl + "/" + processData.gCadApprovalDocumentLink,
                                            children: processData.gCadApprovalDocumentLink
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    }) : authData.userType == "landscape" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (approvalForm_module_default()).documentLinkWrapper,
                        children: processData.landscapeApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (approvalForm_module_default()).Group,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (approvalForm_module_default()).ques1,
                                    children: " Landscape approval document"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (approvalForm_module_default()).documentLink,
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl + "/" + processData.landscapeApprovalDocumentLink,
                                            children: processData.landscapeApprovalDocumentLink
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    }) : authData.userType == "businessOwner" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (approvalForm_module_default()).documentLinkWrapper,
                        children: processData.businessOwnerApprovalDocumentLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (approvalForm_module_default()).Group,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (approvalForm_module_default()).ques1,
                                    children: " Business Owner approval document"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (approvalForm_module_default()).documentLink,
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: utility_endpoints/* default.fetchBlobUrl */.ZP.fetchBlobUrl + "/" + processData.businessOwnerApprovalDocumentLink,
                                            children: processData.businessOwnerApprovalDocumentLink
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (approvalForm_module_default()).bottomBtns,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (approvalForm_module_default()).btn,
                                onClick: submitFormData,
                                children: props.data[0].component.content.field_submit_button_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (approvalForm_module_default()).btn,
                                onClick: function() {
                                    router.push("/approvals");
                                },
                                children: "Back to Approval"
                            })
                        ]
                    })
                ]
            }),
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: function() {
                    return router.push("/approvals");
                },
                title: "Approval Form",
                message: message,
                fail: fail,
                setFail: setFail
            }) : null
        ]
    });
}
var approvalForm_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function approvalForm_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var approvalForm = ((0,es/* connect */.$j)(approvalForm_mapStateToProps, approvalForm_mapDispatchToProps)(approvalForm_index));

// EXTERNAL MODULE: ./styles/components/offering.module.scss
var offering_module = __webpack_require__(84942);
var offering_module_default = /*#__PURE__*/__webpack_require__.n(offering_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styles/components/offeringBanner.module.scss
var offeringBanner_module = __webpack_require__(49365);
var offeringBanner_module_default = /*#__PURE__*/__webpack_require__.n(offeringBanner_module);
;// CONCATENATED MODULE: ./components/OfferingBanner/OfferingBanner.jsx




function OfferingBanner_index(props) {
    //console.log(props, "framaework page image")
    var _data = props.data, field_background_image = _data.field_background_image, field_hedaing = _data.field_hedaing, field_details = _data.field_details, field_background_mobile = _data.field_background_mobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((offeringBanner_module_default()).frameworkbannerWrapper, " container-fluid"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((offeringBanner_module_default()).row, " row"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (offeringBanner_module_default()).imaging,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (offeringBanner_module_default()).image,
                                src: field_background_image,
                                alt: field_background_image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (offeringBanner_module_default()).imageMobile,
                                src: field_background_mobile,
                                alt: "abc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (offeringBanner_module_default()).content,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((offeringBanner_module_default()).container, " container py-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (offeringBanner_module_default()).frameworkbannerHead,
                                    children: field_hedaing
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (offeringBanner_module_default()).frameworkbannerText,
                                    dangerouslySetInnerHTML: {
                                        __html: field_details
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/offerings/offerings.jsx










function offerings_index(props) {
    //console.log(props, "propsatoffer123");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (offering_module_default()).offeringParent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferingBanner_index, {
                data: {
                    field_background_image: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(props.data[0].component.content.field_background_image[0].file_url),
                    field_hedaing: get_default()(props, "data[0].component.content.field_hedaing", ""),
                    field_details: get_default()(props, "data[0].component.content.field_details", ""),
                    field_background_mobile: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(props.data[0].component.content.field_background_image_mobile[0].file_url)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (offering_module_default()).heximages,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (offering_module_default()).title,
                            children: "Automation Offerings"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((offering_module_default()).hexImage, " d-flex justify-content-center"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((offering_module_default()).imagesAlign, " row"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (offering_module_default()).Image,
                                    children: get_default()(props, "data[1].component.content.field_offerings_content", []).map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.field_title == "Catalogue Products" ? "/catalogue-products" : item.field_title == "Touchless Processes" ? "/touchless-processes" : item.field_title == "Profile Automation" ? "/profile-automation" : item.field_title == "Organic Demand" ? "/organic-demand" : item.field_title == "Intelligent Applications" ? "/intelligent-applications" : "/404",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (offering_module_default()).hexCard,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (offering_module_default()).hex,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (offering_module_default()).border,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(item.field_offerings_image[0].file_url),
                                                                alt: ""
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: item.field_title
                                                    })
                                                ]
                                            }, index)
                                        });
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var offerings_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function offerings_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var offerings = ((0,es/* connect */.$j)(offerings_mapStateToProps, offerings_mapDispatchToProps)(offerings_index));

// EXTERNAL MODULE: ./styles/pages/iaOffering.module.scss
var iaOffering_module = __webpack_require__(96844);
var iaOffering_module_default = /*#__PURE__*/__webpack_require__.n(iaOffering_module);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var react_player_lib = __webpack_require__(22004);
var react_player_lib_default = /*#__PURE__*/__webpack_require__.n(react_player_lib);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(86529);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/lib/styles.css
var lib_styles = __webpack_require__(16494);
;// CONCATENATED MODULE: ./components/offeringCard/index.jsx




function offeringCard_index(props) {
    //console.log(props, "offeringcard")
    var _data = props.data, field_background_image = _data.field_background_image, field_title = _data.field_title, field_description = _data.field_description, field_link = _data.field_link, pdf_link = _data.pdf_link;
    var handleClick = function() {
        props.setPdfModal(true);
        props.setPdfUrl(pdf_link);
        props.setPdfTitle(field_title);
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles.cardContainer,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.card,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.image,
                    children: /*#__PURE__*/ _jsx("img", {
                        src: field_background_image,
                        alt: "img"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.head,
                    children: field_title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.desc,
                    children: field_description
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.knowMore,
                    onClick: function() {
                        return handleClick();
                    },
                    children: field_link
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./styles/components/pdfModalViewer.module.scss
var pdfModalViewer_module = __webpack_require__(66609);
var pdfModalViewer_module_default = /*#__PURE__*/__webpack_require__.n(pdfModalViewer_module);
;// CONCATENATED MODULE: ./utility/useClickOutsideHook.js
function useClickOutside(handler, myRef, myUseEffect) {
    var domNode = myRef();
    myUseEffect(function() {
        var dropdownHandler = function(event) {
            if (domNode.current) {
                if (!domNode.current.contains(event.target)) {
                    handler();
                }
            }
        };
        document.addEventListener("click", dropdownHandler);
        return function() {
            document.removeEventListener("click", dropdownHandler);
        };
    });
    return domNode;
}

;// CONCATENATED MODULE: ./components/pdfModalViewer/index.jsx





var SubmitIdea = function(props) {
    //console.log(props, "pdfviewerprops");
    //const [ Loading, setLoading ] = React.useState(false)
    //const dispatch = useDispatch()
    var domNode = useClickOutside(function() {
        props.setPdfModal(false);
    }, react.useRef, react.useEffect);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (pdfModalViewer_module_default()).editModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (pdfModalViewer_module_default()).modalBox,
            ref: domNode,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (pdfModalViewer_module_default()).modalHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (pdfModalViewer_module_default()).leftHeader,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                    name: "pdf",
                                    className: (pdfModalViewer_module_default()).icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (pdfModalViewer_module_default()).content,
                                    children: [
                                        " ",
                                        props.pdfTitle
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pdfModalViewer_module_default()).download,
                                    onClick: function() {
                                        return window.open(props.pdfUrl);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                        name: "downloadBlue"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (pdfModalViewer_module_default()).close,
                            onClick: function() {
                                return props.setPdfModal(false);
                            },
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (pdfModalViewer_module_default()).modalBody,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        //  
                        src: props.pdfUrl != "" ? "".concat(props.pdfUrl, '#toolbar=0&navpanes=0&scrollbar=0&frameBorder=0"') : "http://www.africau.edu/images/default/sample.pdf#toolbar=0&navpanes=0&scrollbar=0",
                        type: "application/pdf",
                        width: "100%",
                        height: "450px",
                        children: " "
                    })
                })
            ]
        })
    });
};
// const mapStateToProps = (state) => {
//   return {
//     submitAnIdeaApiState: state.submitAnIdea
//   }
// }
/* harmony default export */ var pdfModalViewer = (SubmitIdea);

// EXTERNAL MODULE: ./node_modules/react-use/esm/useIntersection.js
var useIntersection = __webpack_require__(80621);
;// CONCATENATED MODULE: ./components/Pages/iaProductDevelopment&Deployment/index.jsx



















var ButtonGroup = function(_param) {
    var next = _param.next, previous = _param.previous, goToSlide = _param.goToSlide, rest = _object_without_properties(_param, [
        "next",
        "previous",
        "goToSlide"
    ]);
    var currentSlide = rest.carouselState.currentSlide;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: currentSlide === 0 ? styles.customprev : styles.customprev,
                onClick: function() {
                    return previous();
                },
                children: /*#__PURE__*/ _jsx(LazyLoadImage, {
                    src: "/assets/svg/Lefti.png"
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.customnext,
                onClick: function() {
                    return next();
                },
                children: /*#__PURE__*/ _jsx(LazyLoadImage, {
                    src: "/assets/svg/righti.png"
                })
            })
        ]
    });
};
var responsive3 = {
    superLargeDesktop: {
        breakpoint: {
            max: 4000,
            min: 3000
        },
        items: 4
    },
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 3
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 2
    },
    mobile: {
        breakpoint: {
            max: 767,
            min: 0
        },
        items: 1,
        partialVisibilityGutter: 40
    }
};
function iaProductDevelopment_Deployment_index(props) {
    var isTabletOrMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 768px)"
    });
    //console.log(props, "propsatiaofferingsyou");
    var ref = (0,react.useState)(false), playing = ref[0], setPlaying = ref[1];
    var ref1 = (0,react.useState)(false), pdfModal = ref1[0], setPdfModal = ref1[1];
    var ref2 = (0,react.useState)(""), pdfUrl = ref2[0], setPdfUrl = ref2[1];
    var ref3 = (0,react.useState)(""), pdfTitle = ref3[0], setPdfTitle = ref3[1];
    //console.log(pdfUrl,"pdf_link");
    var intersectionRef = react.useRef(null);
    var videoIntersection = (0,useIntersection/* default */.Z)(intersectionRef, {
        root: null,
        rootMargin: "0px",
        threshold: 1
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (iaOffering_module_default()).heximages,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((iaOffering_module_default()).hexImage),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((iaOffering_module_default()).imagesAlign, " row justify-content-md-around"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (iaOffering_module_default()).Image,
                                children: get_default()(props, "data[2].component.content.field_offerings_content", []).map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: isTabletOrMobile ? item.field_title == props.title ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/offerings",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/svg/cezarrow1.png",
                                                        className: (iaOffering_module_default()).backarrow
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((iaOffering_module_default()).hexCard, " ").concat(item.field_title == props.title ? (iaOffering_module_default()).active : null),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((iaOffering_module_default()).hex, " ").concat(item.field_title == props.title ? (iaOffering_module_default()).hexactive : null),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (iaOffering_module_default()).border,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (iaOffering_module_default()).imgWrapper,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(item.field_offerings_image[0].file_url),
                                                                        alt: ""
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(item.field_title == props.title ? (iaOffering_module_default()).span : null),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (iaOffering_module_default()).hexCardText,
                                                                children: item.field_title
                                                            })
                                                        })
                                                    ]
                                                }, index)
                                            ]
                                        }) : null : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.field_title == "Catalogue Products" ? "/catalogue-products" : item.field_title == "Touchless Processes" ? "/touchless-processes" : item.field_title == "Profile Automation" ? "/profile-automation" : item.field_title == "Organic Demand" ? "/organic-demand" : item.field_title == "Intelligent Applications" ? "/intelligent-applications" : "/404",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((iaOffering_module_default()).hexCard, " ").concat(item.field_title == props.title ? (iaOffering_module_default()).active : null),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((iaOffering_module_default()).hex, " ").concat(item.field_title == props.title ? (iaOffering_module_default()).hexactive : null),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (iaOffering_module_default()).border,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (iaOffering_module_default()).imgWrapper,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(item.field_offerings_image[0].file_url),
                                                                    alt: ""
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat(item.field_title == props.title ? (iaOffering_module_default()).span : null),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (iaOffering_module_default())["null"],
                                                            children: item.field_title
                                                        })
                                                    })
                                                ]
                                            }, index)
                                        })
                                    });
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (iaOffering_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (iaOffering_module_default()).wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (iaOffering_module_default()).heading,
                                children: get_default()(props, "title", "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (iaOffering_module_default()).description,
                                children: get_default()(props, "data[0].component.content.field_description_1", "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (iaOffering_module_default()).image,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(get_default()(props, "data[0].component.content.field_offering_image[0].file_url", "")),
                                    alt: get_default()(props, "data[0].component.content.field_offering_image[0].image_alt", "")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (iaOffering_module_default()).desc,
                                dangerouslySetInnerHTML: {
                                    __html: get_default()(props, "data[0].component.content.field_description_2", "")
                                }
                            })
                        ]
                    })
                })
            }),
            //  (props.title==="Profile Automation" || props.title==="No Touch Process" ) &&
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (iaOffering_module_default()).videoContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (iaOffering_module_default()).videoWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (iaOffering_module_default()).video,
                                ref: intersectionRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: intersectionRef !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)((react_player_lib_default()), {
                                        width: isTabletOrMobile ? "100%" : "83%",
                                        height: "100%",
                                        playing: (videoIntersection === null || videoIntersection === void 0 ? void 0 : videoIntersection.isIntersecting) ? true : false,
                                        muted: false,
                                        loop: true,
                                        autoplay: true,
                                        controls: true,
                                        url: get_default()(props, "data[0].component.content.field_video_type", "") != "video_url" ? utility_endpoints/* default.drupalIp */.ZP.drupalIp + get_default()(props, "data[0].component.content.field_offering_video[0].file_url", "") : get_default()(props, "data[0].component.content.field_offering_video_link[0].uri", "")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (iaOffering_module_default()).videoTextWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (iaOffering_module_default()).videoTitle,
                                        children: get_default()(props, "data[0].component.content.field_offering_video_title", "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (iaOffering_module_default()).download,
                                        onClick: function() {
                                            return window.open("".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp + get_default()(props, "data[0].component.content.field_offering_video[0].file_url", ""), "?download"));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (iaOffering_module_default()).downloadIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                    name: "downloadBlue"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (iaOffering_module_default()).downloadText,
                                                children: "Download Video"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            pdfModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pdfModalViewer, {
                setPdfModal: setPdfModal,
                pdfUrl: pdfUrl,
                pdfTitle: pdfTitle
            }) : null
        ]
    });
}
var iaProductDevelopment_Deployment_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function iaProductDevelopment_Deployment_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var iaProductDevelopment_Deployment = ((0,es/* connect */.$j)(iaProductDevelopment_Deployment_mapStateToProps, iaProductDevelopment_Deployment_mapDispatchToProps)(iaProductDevelopment_Deployment_index));

// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 9 modules
var collapse = __webpack_require__(99160);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 7 modules
var es_button = __webpack_require__(2342);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 33 modules
var es_radio = __webpack_require__(51987);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 3 modules
var space = __webpack_require__(23748);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__(80882);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(24969);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/SaveOutlined.js + 1 modules
var SaveOutlined = __webpack_require__(60219);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseOutlined.js + 1 modules
var CloseOutlined = __webpack_require__(97937);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EditOutlined.js + 1 modules
var EditOutlined = __webpack_require__(86548);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DeleteOutlined.js + 1 modules
var DeleteOutlined = __webpack_require__(48689);
;// CONCATENATED MODULE: ./components/Pages/Product/index.jsx





















var Product_Banner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1902).then(__webpack_require__.bind(__webpack_require__, 96216));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96216)
            ];
        }
    }
});







// import MobileFilters from '../../MobileFilters'
var Panel = collapse/* default.Panel */.Z.Panel;
function Product_index(props) {
    var camelize = function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    var pagenumber;
    var dispatch = (0,es/* useDispatch */.I0)();
    var size = 9;
    var ref = (0,react.useState)(0), totalPage = ref[0], settotalPage = ref[1];
    var ref1 = (0,react.useState)([]), page = ref1[0], setpage = ref1[1];
    var ref2 = (0,react.useState)(1), currentPage = ref2[0], setCurrentPage = ref2[1];
    var ref3 = (0,react.useState)(false), showMore = ref3[0], setShowMore = ref3[1];
    var myScroll = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var data = props.data;
    var bannerData = lodash_default().get(data[0], "component.content", "");
    //  const {component : {content }} = data[1]
    var content = lodash_default().get(data[1], "component.content", "");
    // _.get(data[2], "component.content.field_no_result_image[0].file_url", "")
    var initialStates = {};
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref4[0], setState = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), allProducts = ref5[0], setallProducts = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), filters = ref6[0], setFilters = ref6[1];
    var ref7 = (0,react.useState)(false), filterOn = ref7[0], setFilterOn = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState(true), 2), hasMore = ref8[0], setHasMore = ref8[1];
    var ref9 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), filterActive = ref9[0], setFilterActive = ref9[1];
    var ref10 = (0,react.useState)({}), auth = ref10[0], setAuth = ref10[1];
    var ref11 = (0,src_sliced_to_array/* default */.Z)(react.useState(1), 2), infiniteKey = ref11[0], setInfiniteKey = ref11[1];
    var ref12 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), noResultFlag = ref12[0], setNoResultFlag = ref12[1];
    var ref13 = (0,react.useState)(true), isHidden = ref13[0], setIsHidden = ref13[1];
    var toggleVisibility = function() {
        setIsHidden(!isHidden);
    };
    var ref14 = (0,react.useState)([
        "admin",
        "internalUser",
        "qrManager",
        "supportStatus"
    ]), nonRestrictedUser = ref14[0], setnonRestrictedUser = ref14[1];
    var goToPage = function(link) {
        var encBotId = window.btoa(link);
        window.open(utility_endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin + "product_details?prodId=".concat(encBotId));
    // router.push('/product_details');
    };
    var count = 0;
    var ref15 = (0,react.useState)({}), filterStateExport = ref15[0], setfilterStateExport = ref15[1];
    var ref16 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), loadState = ref16[0], setLoadState = ref16[1];
    var ref17 = (0,src_sliced_to_array/* default */.Z)(react.useState(true), 2), hasMoreBots = ref17[0], setHasMoreBots = ref17[1];
    var ref18 = (0,react.useState)(0), length = ref18[0], setLength = ref18[1];
    var ref19 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), loading = ref19[0], setLoading = ref19[1];
    var ref20 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), mobileFilterRelatedInfo = ref20[0], setMobileFilterRelatedInfo = ref20[1];
    var ref21 = (0,src_sliced_to_array/* default */.Z)(react.useState(0), 2), totalIndexFilter = ref21[0], setTotalIndexFilter = ref21[1];
    var ref22 = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), currentFilters = ref22[0], setCurrentFilters = ref22[1];
    var ref23 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), reset = ref23[0], setReset = ref23[1];
    var cezDetails = "";
    var cezHeading = "Our Product";
    var backgroundUrl = "/sites/default/files/2021-03/banner-cez-web.png";
    var backgroundUrlMobile = {
        file_url: "/sites/default/files/2021-03/banner-cez-mobile.png",
        file_name: "banner-cez-mobile.png",
        mime_type: "image/png",
        image_alt: "banner-cez-mobile"
    };
    var ref24 = (0,src_sliced_to_array/* default */.Z)(react.useState("all.svg"), 2), cardImage = ref24[0], setCardImage = ref24[1];
    //  const [businessFilters, setBusinessFilter] = React.useState([{"business_unit_id":1,"cluster":"SEAA"},{"business_unit_id":2,"cluster":"LATAM"},{"business_unit_id":3,"cluster":"North America"},{"business_unit_id":4,"cluster":"Africa"},{"business_unit_id":5,"cluster":"South Asia"},{"business_unit_id":6,"cluster":"South Africa"},{"business_unit_id":7,"cluster":"Europe"},{"business_unit_id":8,"cluster":"NAMETRUB"},{"business_unit_id":9,"cluster":"North America"},{"business_unit_id":10,"cluster":"Global"},{"business_unit_id":11,"cluster":"North Asia"}])
    //  const [functionFilters, setFunctionFilter] = React.useState([{"function_id":1,"function_name":"Supply Chain"},{"function_id":2,"function_name":"Finance"},{"function_id":3,"function_name":"Customer Development"},{"function_id":4,"function_name":"Marketing"},{"function_id":5,"function_name":"R&D"},{"function_id":6,"function_name":"HR"},{"function_id":7,"function_name":"IT Services"}])
    //  const [subAreaFilters, setSubAreaFilter] = React.useState([{"sub_area_id":1,"sub_area":"Procurement"},{"sub_area_id":2,"sub_area":"Mask"},{"sub_area_id":3,"sub_area":"Deliver"},{"sub_area_id":4,"sub_area":"Customer Services"},{"sub_area_id":5,"sub_area":"R2R"},{"sub_area_id":6,"sub_area":"P2P"},{"sub_area_id":7,"sub_area":"Reporting"},{"sub_area_id":8,"sub_area":"Marketing"},{"sub_area_id":9,"sub_area":"R&D"},{"sub_area_id":10,"sub_area":"HR"},{"sub_area_id":11,"sub_area":"IT Services"}, {"sub_area_id":12,"sub_area":"Customer Development"}])
    var ref25 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), businessFilters = ref25[0], setBusinessFilter = ref25[1];
    var ref26 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), functionFilters = ref26[0], setFunctionFilter = ref26[1];
    var ref27 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), subAreaFilters = ref27[0], setSubAreaFilter = ref27[1];
    var ref28 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), addEditBusinessFlag = ref28[0], setAddEditBusinessFlag = ref28[1];
    var ref29 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), addEditFunctionFlag = ref29[0], setAddEditFunctionFlag = ref29[1];
    var ref30 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), addEditSubAreaFlag = ref30[0], setAddEditSubAreaFlag = ref30[1];
    var ref31 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        "business_unit_id": -1,
        "cluster": ""
    }), 2), addEditBusiness = ref31[0], setAddEditBusiness = ref31[1];
    var ref32 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        "function_id": -1,
        "function_name": ""
    }), 2), addEditFunction = ref32[0], setAddEditFunction = ref32[1];
    var ref33 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        "sub_area_id": -1,
        "sub_area": ""
    }), 2), addEditSubArea = ref33[0], setAddEditSubArea = ref33[1];
    var ref34 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        "cluster": "",
        "catalog_products": "",
        "sub_area": ""
    }), 2), filterRadio = ref34[0], setFilterRadio = ref34[1];
    react.useEffect(function() {
    //console.log(state, "statefirstaa")
    //   let Filters = {};
    //   for (let i in state) {
    //     if (state[i]) {
    //       if (state[i].length > 0) {
    //         Filters[i] = state[i];
    //       }
    //     }
    //   }
    //   setfilterStateExport(Filters);
    //   if (
    //     Filters &&
    //     Object.keys(Filters).length === 0 &&
    //     Filters.constructor === Object
    //   ) {
    //     if (props.storeBot.filter !== null){
    //     window.scrollTo(0,200)
    //   }
    //     setLoading(true);  
    //     setInfiniteKey(infiniteKey+1)
    //     dispatch(getBotsAction(0))
    //     setHasMoreBots(true)
    //     setLoadState(true)
    //     setSearch("")
    //   }
    // else {
    //   setLoading(true);  
    //   setInfiniteKey(infiniteKey+1)
    //   setHasMoreBots(true)
    //   setLoadState(true)
    //   window.scrollTo(0,200)
    //   setCurrentFilters(Filters)
    //   dispatch(getFilterBotsAction(0, Filters));
    // }
    }, [
        state
    ]);
    var addTofilters = function(e, k, v) {
        var ref;
        //console.log("addtofilters",e?.target?.checked,k,v)
        var obj = (0,src_object_spread/* default */.Z)({}, state);
        if (obj.hasOwnProperty(k)) {
            delete obj[k];
        }
        if (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.checked) {
            obj[k] = [
                v
            ];
        }
        setState(obj);
        setFilterRadio(function(old) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, old), (0,src_define_property/* default */.Z)({}, k, v));
        });
    // if(e.target.checked){
    //   let obj={...state}
    //   if(obj.hasOwnProperty(k)){
    //     obj[k]=[...obj[k],v]
    //   }else{
    //     obj[k]=[v]
    //   }
    //   setState(obj)
    // }else{
    //   let obj={...state}
    //   if(obj.hasOwnProperty(k)){
    //     const ind=Array.isArray(obj[k])&& [...obj[k]].findIndex((val)=>v==val)
    //     if(ind>=0){
    //     console.log("obj[k]11")
    //       obj[k].splice(ind,1)
    //       if(obj[k].length==0){
    //         delete obj[k]
    //       }
    //     }
    //   setState(obj)
    //   }
    // }
    };
    var isChecked = function(k, v) {
        if (state.hasOwnProperty(k)) {
            var id = state[k].findIndex(function(val) {
                return v === val;
            });
            if (id >= 0) {
                //console.log("true")
                return true;
            } else {
                //console.log("false")
                return false;
            }
        } else {
            //console.log("false1")
            return false;
        }
    };
    react.useEffect(function() {
        var ref, ref1;
        //console.log("storeProduct", props?.storeProduct)
        if ((props === null || props === void 0 ? void 0 : (ref = props.storeProduct) === null || ref === void 0 ? void 0 : ref.allProducts) && (props === null || props === void 0 ? void 0 : (ref1 = props.storeProduct) === null || ref1 === void 0 ? void 0 : ref1.filter) !== null) {
            var ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
            if ((props === null || props === void 0 ? void 0 : (ref2 = props.storeProduct) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.allProducts) === null || ref3 === void 0 ? void 0 : ref3.length) == 0) {
                setNoResultFlag(true);
            }
            setLoading(false);
            setTotalIndexFilter(props === null || props === void 0 ? void 0 : (ref4 = props.storeProduct) === null || ref4 === void 0 ? void 0 : ref4.length);
            setallProducts((0,src_to_consumable_array/* default */.Z)(props === null || props === void 0 ? void 0 : (ref5 = props.storeProduct) === null || ref5 === void 0 ? void 0 : ref5.allProducts));
            settotalPage(props === null || props === void 0 ? void 0 : (ref6 = props.storeProduct) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.allProducts) === null || ref7 === void 0 ? void 0 : ref7.length);
            setFilters(props === null || props === void 0 ? void 0 : (ref8 = props.storeProduct) === null || ref8 === void 0 ? void 0 : ref8.filterList);
            var totalRec = (props === null || props === void 0 ? void 0 : (ref9 = props.storeProduct) === null || ref9 === void 0 ? void 0 : ref9.totalRecords) / size;
            var arr = [];
            //console.log("totalRec", totalRec)
            if (totalRec > 1) {
                for(var _$index = 0; _$index < totalRec; _$index++){
                    arr === null || arr === void 0 ? void 0 : arr.push(_$index + 1);
                }
                setpage(arr);
            } else if (totalRec > 0) {
                setpage([
                    1
                ]);
            }
            setHasMoreBots(true);
            setLoadState(true);
            if ((state === null || state === void 0 ? void 0 : state.search) && (state === null || state === void 0 ? void 0 : (ref10 = state.search) === null || ref10 === void 0 ? void 0 : ref10.length) > 0) {
                var ref11;
                inputRef === null || inputRef === void 0 ? void 0 : (ref11 = inputRef.current) === null || ref11 === void 0 ? void 0 : ref11.focus();
            }
        }
    }, [
        props.storeProduct
    ]);
    // const loadFunc = (a) => {
    //       console.log(props.storeBot.totalIndex, "totalIndex")
    //       if (allBots.length < totalIndexFilter) {
    //         setHasMoreBots(true)
    //         setLoadState(true)
    //         if (!props.storeBot.filter)  {
    //           dispatch(getBotsAction(a));
    //           setLoadState(false)
    //         }
    //         else {
    //           dispatch(getFilterBotsAction(a, currentFilters))
    //           setLoadState(false)
    //         }
    //       } else {
    //       //  setLoadState(false)
    //         setHasMoreBots(false)
    //        // setHasMoreBots(false)
    //       }
    // };
    var clearALLFilter = function() {
        window.scrollTo(0, 200);
        setState({});
        //setLoadState(true)
        setNoResultFlag(false);
        setSearchValue("");
    // dispatch(getBotsAction(0))
    // setAllBots([])
    // setInfiniteKey(infiniteKey + 1)
    // setHasMoreBots(true)
    };
    var removeFilter = function(keyname) {
        var ref;
        if (keyname == "leadPlatform") {
            setReset(true);
            var otherState = mobileFilterRelatedInfo;
            delete otherState["Area"];
            setMobileFilterRelatedInfo((0,src_object_spread/* default */.Z)({}, otherState));
        }
        var stateToChange = state;
        var itemToBeRemoved = content === null || content === void 0 ? void 0 : (ref = content.field_bot_store_filters_fields) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.value) == keyname;
        });
        if ((itemToBeRemoved === null || itemToBeRemoved === void 0 ? void 0 : itemToBeRemoved.length) > 0) {
            var ref1;
            if ((ref1 = itemToBeRemoved[0]) === null || ref1 === void 0 ? void 0 : ref1.field_related_dropdown) {
                delete stateToChange[camelize(itemToBeRemoved[0].field_related_dropdown)];
            }
        }
        delete stateToChange[keyname];
        setState((0,src_object_spread/* default */.Z)({}, stateToChange));
        if (length > 0) {
            setLength(length - 1);
        }
    };
    var inputRef = (0,react.useRef)(null);
    var ref35 = (0,react.useState)(false), reload = ref35[0], setReload = ref35[1];
    var ref36 = (0,react.useState)(state.search), search = ref36[0], setSearch = ref36[1];
    var query = (0,next_router.useRouter)().query;
    var isTabOneSelected = !!(query === null || query === void 0 ? void 0 : query.tabOne);
    var isTabTwoSelected = !!(query === null || query === void 0 ? void 0 : query.tabTwo);
    var isTabThreeSelected = !!(query === null || query === void 0 ? void 0 : query.tabThree);
    react.useEffect(function() {
        if (reload) {
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, "search", search)));
            setReload(false);
        }
    }, [
        reload
    ]);
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            dispatch(getFilterListAction());
            return [
                2
            ];
        });
    }), []);
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            // state = { ...router.query };
            setLoading(true);
            dispatch(getProductAction({
                currentPage: currentPage,
                size: size,
                filter: state
            }));
            // dispatch(getFilterListAction());
            try {
                if (localStorage.getItem("auth") != undefined) {
                    setAuth(JSON.parse(localStorage.getItem("auth").data));
                }
            } catch (e) {}
            return [
                2
            ];
        });
    }), [
        currentPage,
        state
    ]);
    var callApi = function() {
        setReload(true);
    }; // You might be able to call API directly here, I haven't tried
    var ref37 = (0,react.useState)(function() {
        return lodash_default().debounce(callApi, 800);
    }), debouncedCallApi = ref37[0];
    var inputChange = function(e) {
        var ref, ref1;
        if ((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.length) == 0) {
            //  console.log(e.target.value, "before");
            var statess = state;
            statess === null || statess === void 0 ? void 0 : delete statess.search;
            setSearch("");
            setState((0,src_object_spread/* default */.Z)({}, statess));
            if (lodash_default().isEmpty(statess)) {
                clearALLFilter();
            }
        } else {
            var ref2;
            setSearch(e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : ref2.value);
            debouncedCallApi();
        }
    };
    var ref38 = (0,react.useState)(1), toggleState = ref38[0], setToggleState = ref38[1];
    var toggleTab = function(index) {
        setToggleState(index);
    // console.log(index);
    };
    var ref39 = (0,react.useState)(false), addProduct = ref39[0], setAddProduct = ref39[1];
    // console.log("statestate", state);
    var ref40 = (0,react.useState)(""), searchValue = ref40[0], setSearchValue = ref40[1];
    var searchProduct = function() {
        setLoading(true);
        dispatch(getProductAction({
            currentPage: "",
            size: "",
            filter: {
                product_title: searchValue
            }
        }));
    };
    var deleteBusinessFilter = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(id) {
            var auth, businessResponse, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/deleteBusinessUnit"),
                                // url: "http://localhost:4550/node/api/task/deleteBusinessUnit",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    "business_unit_id": id
                                }
                            })
                        ];
                    case 2:
                        businessResponse = _state.sent();
                        getFilterData();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.log("failed to delete Business filter " + e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteBusinessFilter(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteFunctionFilter = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(id) {
            var auth, businessResponse, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/deleteFunctionFilters"),
                                // url: "http://localhost:4550/node/api/task/deleteFunctionFilters",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    "function_id": id
                                }
                            })
                        ];
                    case 2:
                        businessResponse = _state.sent();
                        getFilterData();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.log("failed to delete Function filter " + e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteFunctionFilter(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteSubAreaFilter = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(id) {
            var auth, businessResponse, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/deleteSubAreaFilter"),
                                // url: "http://localhost:4550/node/api/task/deleteSubAreaFilter",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    "sub_area_id": id
                                }
                            })
                        ];
                    case 2:
                        businessResponse = _state.sent();
                        getFilterData();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.log("failed to delete SubArea filter " + e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteSubAreaFilter(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var onFilterAdd = function(type) {
        if (type === "Business") {
            setAddEditBusinessFlag(true);
            setAddEditBusiness({
                "business_unit_id": -1,
                "cluster": ""
            });
        } else if (type === "Function") {
            setAddEditFunctionFlag(true);
            setAddEditFunction({
                "function_id": -1,
                "function_name": ""
            });
        } else {
            setAddEditSubAreaFlag(true);
            setAddEditSubArea({
                "sub_area_id": -1,
                "sub_area": ""
            });
        }
    };
    var onFilterEdit = function(type, item) {
        if (type === "Business") {
            setAddEditBusinessFlag(true);
            setAddEditBusiness(item);
        } else if (type === "Function") {
            setAddEditFunctionFlag(true);
            setAddEditFunction(item);
        } else {
            setAddEditSubAreaFlag(true);
            setAddEditSubArea(item);
        }
    };
    var onFilterSave = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(type) {
            var auth, body, response, e, auth1, body1, response1, e1, auth2, body2, response2, e2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(type === "Business")) return [
                            3,
                            5
                        ];
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        body = (0,src_object_spread/* default */.Z)({}, addEditBusiness);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/createOrUpdateBusinessUnit"),
                                // url: "http://localhost:4550/node/api/task/createOrUpdateBusinessUnit",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: body
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        getFilterData();
                        onFilterClear(type);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.log("failed to create/update Business Filter" + e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            14
                        ];
                    case 5:
                        if (!(type === "Function")) return [
                            3,
                            10
                        ];
                        auth1 = JSON.parse(localStorage.getItem("auth")).data;
                        body1 = (0,src_object_spread/* default */.Z)({}, addEditFunction);
                        _state.label = 6;
                    case 6:
                        _state.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/createOrUpdateFunctionFilter"),
                                // url: "http://localhost:4550/node/api/task/createOrUpdateFunctionFilter",
                                headers: {
                                    Authorization: "".concat(auth1.accessToken, "|").concat(auth1.email)
                                },
                                data: body1
                            })
                        ];
                    case 7:
                        response1 = _state.sent();
                        getFilterData();
                        onFilterClear(type);
                        return [
                            3,
                            9
                        ];
                    case 8:
                        e1 = _state.sent();
                        console.log("failed to create/update Filter Filter" + e1);
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            3,
                            14
                        ];
                    case 10:
                        auth2 = JSON.parse(localStorage.getItem("auth")).data;
                        body2 = (0,src_object_spread/* default */.Z)({}, addEditSubArea);
                        _state.label = 11;
                    case 11:
                        _state.trys.push([
                            11,
                            13,
                            ,
                            14
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/createOrUpdateSubAreaFilters"),
                                // url: "http://localhost:4550/node/api/task/createOrUpdateSubAreaFilters",
                                headers: {
                                    Authorization: "".concat(auth2.accessToken, "|").concat(auth2.email)
                                },
                                data: body2
                            })
                        ];
                    case 12:
                        response2 = _state.sent();
                        getFilterData();
                        onFilterClear(type);
                        return [
                            3,
                            14
                        ];
                    case 13:
                        e2 = _state.sent();
                        console.log("failed to create/update SubArea Filter" + e2);
                        return [
                            3,
                            14
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFilterSave(type) {
            return _ref.apply(this, arguments);
        };
    }();
    var onFilterClear = function(type) {
        if (type === "Business") {
            setAddEditBusinessFlag(false);
            setAddEditBusiness({
                "business_unit_id": -1,
                "cluster": ""
            });
        } else if (type === "Function") {
            setAddEditFunctionFlag(false);
            setAddEditFunction({
                "function_id": -1,
                "function_name": ""
            });
        } else {
            setAddEditSubAreaFlag(false);
            setAddEditSubArea({
                "sub_area_id": -1,
                "sub_area": ""
            });
        }
    };
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            getFilterData();
            return [
                2
            ];
        });
    }), []);
    var getFilterData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var response, ref, ref1, ref2, ref3, ref4, ref5, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "GET",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/task/getFilterData"),
                                // url: "http://localhost:4550/node/api/task/getFilterData",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response) {
                            ;
                            setBusinessFilter(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.business_array);
                            setFunctionFilter(response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.function_array);
                            setSubAreaFilter(response === null || response === void 0 ? void 0 : (ref4 = response.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.subarea_array);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.log("failed to get Filters data" + e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getFilterData() {
            return _ref.apply(this, arguments);
        };
    }();
    var setFunctionIcon = function(type) {
        if (type === "All") {
            // clearALLFilter();
            // setState({"catalog_products":["All"]});
            setCardImage("all.svg");
        } else if (type === "Finance") {
            // setState({"catalog_products":[type]});
            setCardImage("finance.svg");
        } else if (type === "IT Services") {
            // setState({"catalog_products":[type]});
            setCardImage("hr.svg");
        } else if (type === "Legal") {
            // setState({"catalog_products":[type]});
            setCardImage("legal.svg");
        } else if (type === "Supply Chain") {
            // setState({"catalog_products":[type]});
            setCardImage("supply.svg");
        } else if (type === "Marketing") {
            // setState({"catalog_products":[type]});
            setCardImage("marketing.svg");
        } else if (type === "Customer Development") {
            // setState({"catalog_products":[type]});
            setCardImage("customer.svg");
        } else {
            // setState({"catalog_products":[type]});
            setCardImage("all.svg");
        }
    };
    //console.log("current page==>",currentPage*9-9);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !addProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "800px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (botStore_module_default()).storeContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (botStore_module_default()).mainSection_space,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (botStore_module_default()).banner_card_section,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: (botStore_module_default()).frist_image,
                                    src: "".concat(imageBaseURL, "banner-product.png"),
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "m-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: "Our Products"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Our ready-to-deploy solutions called “Products” can reduce your automation timeline from 8 to 12 weeks to just a week!."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: (botStore_module_default()).second_image,
                                    src: "".concat(imageBaseURL, "banner-product2.png"),
                                    alt: ""
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (botStore_module_default()).mainContainersection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            className: "".concat((botStore_module_default()).mainContainer2),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    !isHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).filters_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (botStore_module_default()).filters_card_section,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: function() {
                                                                    return searchProduct();
                                                                },
                                                                children: "Filters"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "d-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    onClick: function() {
                                                                        return clearALLFilter();
                                                                    },
                                                                    style: {
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: "Clear All"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        position: "relative"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            className: "".concat((botStore_module_default()).search_section, " mb-3"),
                                                            type: "text",
                                                            placeholder: "Search by Product Title",
                                                            onChange: function(e) {
                                                                return setSearchValue(e.target.value);
                                                            },
                                                            value: searchValue,
                                                            onKeyPress: function(e) {
                                                                if (e.key === "Enter") {
                                                                    searchProduct();
                                                                }
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                            name: "searchGrayIcon",
                                                            className: (botStore_module_default()).searchIcon
                                                        })
                                                    ]
                                                }),
                                                props.userRole === "admin" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(collapse/* default */.Z, {
                                                        defaultActiveKey: [],
                                                        expandIconPosition: "end",
                                                        expandIcon: function(param) {
                                                            var isActive = param.isActive;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined/* default */.Z, {
                                                                rotate: isActive ? -180 : 0
                                                            });
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Panel, {
                                                                header: "Business Units",
                                                                children: [
                                                                    !addEditBusinessFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        style: {
                                                                            height: 50,
                                                                            width: "100%",
                                                                            display: "flex",
                                                                            justifyContent: "end"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                            color: "primary",
                                                                            style: {
                                                                                color: "#1f36c7",
                                                                                border: "none"
                                                                            },
                                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusOutlined/* default */.Z, {}),
                                                                            onClick: function() {
                                                                                return onFilterAdd("Business");
                                                                            },
                                                                            children: " Add Business "
                                                                        })
                                                                    }),
                                                                    addEditBusinessFlag && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "add-filters",
                                                                        style: {
                                                                            height: 50,
                                                                            width: "100%",
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "add-filters-input",
                                                                                style: {
                                                                                    width: "75%"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                    placeholder: "Enter Business Unit",
                                                                                    style: {
                                                                                        width: "100%",
                                                                                        padding: "2px 15px",
                                                                                        borderRadius: 5
                                                                                    },
                                                                                    type: "text",
                                                                                    value: addEditBusiness.cluster,
                                                                                    onChange: function(e) {
                                                                                        setAddEditBusiness(function(old) {
                                                                                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, old), {
                                                                                                "cluster": e.target.value
                                                                                            });
                                                                                        });
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "add-filters-action",
                                                                                style: {
                                                                                    width: "22%"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                        style: {
                                                                                            color: "#1f36c7",
                                                                                            border: "none"
                                                                                        },
                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveOutlined/* default */.Z, {}),
                                                                                        onClick: function() {
                                                                                            return onFilterSave("Business");
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                        style: {
                                                                                            color: "#1f36c7",
                                                                                            border: "none"
                                                                                        },
                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {}),
                                                                                        onClick: function() {
                                                                                            return onFilterClear("Business");
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default.Group */.ZP.Group, {
                                                                        onChange: function() {},
                                                                        style: {
                                                                            width: "100%"
                                                                        },
                                                                        value: filterRadio.cluster,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(space/* default */.Z, {
                                                                            direction: "vertical",
                                                                            style: {
                                                                                width: "100%"
                                                                            },
                                                                            children: businessFilters === null || businessFilters === void 0 ? void 0 : businessFilters.map(function(item, idx) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "radio-items",
                                                                                        style: {
                                                                                            display: "flex",
                                                                                            justifyContent: "space-between"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default */.ZP, {
                                                                                                className: "radio",
                                                                                                style: {
                                                                                                    width: "75%"
                                                                                                },
                                                                                                value: item.cluster,
                                                                                                onClick: function(e) {
                                                                                                    return addTofilters(e, "cluster", item.cluster);
                                                                                                },
                                                                                                children: item.cluster
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "action-buttons",
                                                                                                style: {
                                                                                                    width: "22%"
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                                        style: {
                                                                                                            color: "#1f36c7",
                                                                                                            border: "none"
                                                                                                        },
                                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOutlined/* default */.Z, {}),
                                                                                                        onClick: function() {
                                                                                                            return onFilterEdit("Business", item);
                                                                                                        }
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                                        style: {
                                                                                                            color: "red",
                                                                                                            border: "none"
                                                                                                        },
                                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteOutlined/* default */.Z, {}),
                                                                                                        onClick: function() {
                                                                                                            return deleteBusinessFilter(item.business_unit_id);
                                                                                                        }
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                });
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }, "1"),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Panel, {
                                                                header: "Function",
                                                                children: [
                                                                    !addEditFunctionFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        style: {
                                                                            height: 50,
                                                                            width: "100%",
                                                                            display: "flex",
                                                                            justifyContent: "end"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                            color: "primary",
                                                                            style: {
                                                                                color: "#1f36c7",
                                                                                border: "none"
                                                                            },
                                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusOutlined/* default */.Z, {}),
                                                                            onClick: function() {
                                                                                return onFilterAdd("Function");
                                                                            },
                                                                            children: " Add Function "
                                                                        })
                                                                    }),
                                                                    addEditFunctionFlag && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "add-filters",
                                                                        style: {
                                                                            height: 50,
                                                                            width: "100%",
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "add-filters-input",
                                                                                style: {
                                                                                    width: "75%"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                    placeholder: "Enter Function",
                                                                                    style: {
                                                                                        width: "100%",
                                                                                        padding: "2px 15px",
                                                                                        borderRadius: 5
                                                                                    },
                                                                                    type: "text",
                                                                                    value: addEditFunction.function_name,
                                                                                    onChange: function(e) {
                                                                                        setAddEditFunction(function(old) {
                                                                                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, old), {
                                                                                                "function_name": e.target.value
                                                                                            });
                                                                                        });
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "add-filters-action",
                                                                                style: {
                                                                                    width: "22%"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                        style: {
                                                                                            color: "#1f36c7",
                                                                                            border: "none"
                                                                                        },
                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveOutlined/* default */.Z, {}),
                                                                                        onClick: function() {
                                                                                            return onFilterSave("Function");
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                        style: {
                                                                                            color: "#1f36c7",
                                                                                            border: "none"
                                                                                        },
                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {}),
                                                                                        onClick: function() {
                                                                                            return onFilterClear("Function");
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default.Group */.ZP.Group, {
                                                                        onChange: function() {},
                                                                        style: {
                                                                            width: "100%"
                                                                        },
                                                                        value: filterRadio.catalog_products,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(space/* default */.Z, {
                                                                            direction: "vertical",
                                                                            style: {
                                                                                width: "100%"
                                                                            },
                                                                            children: functionFilters === null || functionFilters === void 0 ? void 0 : functionFilters.map(function(item, idx) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "radio-items",
                                                                                        style: {
                                                                                            display: "flex",
                                                                                            justifyContent: "space-between"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default */.ZP, {
                                                                                                className: "radio",
                                                                                                style: {
                                                                                                    width: "75%"
                                                                                                },
                                                                                                value: item.function_name,
                                                                                                onClick: function(e) {
                                                                                                    addTofilters(e, "catalog_products", item.function_name);
                                                                                                    setFunctionIcon(item.function_name);
                                                                                                },
                                                                                                children: item.function_name
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "action-buttons",
                                                                                                style: {
                                                                                                    width: "22%"
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                                        style: {
                                                                                                            color: "#1f36c7",
                                                                                                            border: "none"
                                                                                                        },
                                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOutlined/* default */.Z, {}),
                                                                                                        onClick: function() {
                                                                                                            return onFilterEdit("Function", item);
                                                                                                        }
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                                        style: {
                                                                                                            color: "red",
                                                                                                            border: "none"
                                                                                                        },
                                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteOutlined/* default */.Z, {}),
                                                                                                        onClick: function() {
                                                                                                            return deleteFunctionFilter(item.function_id);
                                                                                                        }
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                });
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }, "2"),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Panel, {
                                                                header: "Sub Area",
                                                                children: [
                                                                    !addEditSubAreaFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        style: {
                                                                            height: 50,
                                                                            width: "100%",
                                                                            display: "flex",
                                                                            justifyContent: "end"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                            color: "primary",
                                                                            style: {
                                                                                color: "#1f36c7",
                                                                                border: "none"
                                                                            },
                                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusOutlined/* default */.Z, {}),
                                                                            onClick: function() {
                                                                                return onFilterAdd("sub_area");
                                                                            },
                                                                            children: " Add SubArea "
                                                                        })
                                                                    }),
                                                                    addEditSubAreaFlag && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "add-filters",
                                                                        style: {
                                                                            height: 50,
                                                                            width: "100%",
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "add-filters-input",
                                                                                style: {
                                                                                    width: "75%"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                    placeholder: "Enter Sub Area",
                                                                                    style: {
                                                                                        width: "100%",
                                                                                        padding: "2px 15px",
                                                                                        borderRadius: 5
                                                                                    },
                                                                                    type: "text",
                                                                                    value: addEditSubArea.sub_area,
                                                                                    onChange: function(e) {
                                                                                        setAddEditSubArea(function(old) {
                                                                                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, old), {
                                                                                                "sub_area": e.target.value
                                                                                            });
                                                                                        });
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "add-filters-action",
                                                                                style: {
                                                                                    width: "22%"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                        style: {
                                                                                            color: "#1f36c7",
                                                                                            border: "none"
                                                                                        },
                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveOutlined/* default */.Z, {}),
                                                                                        onClick: function() {
                                                                                            return onFilterSave("sub_area");
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                        style: {
                                                                                            color: "#1f36c7",
                                                                                            border: "none"
                                                                                        },
                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {}),
                                                                                        onClick: function() {
                                                                                            return onFilterClear("sub_area");
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default.Group */.ZP.Group, {
                                                                        onChange: function() {},
                                                                        style: {
                                                                            width: "100%"
                                                                        },
                                                                        value: filterRadio.sub_area,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(space/* default */.Z, {
                                                                            direction: "vertical",
                                                                            style: {
                                                                                width: "100%"
                                                                            },
                                                                            children: subAreaFilters === null || subAreaFilters === void 0 ? void 0 : subAreaFilters.map(function(item, idx) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "radio-items",
                                                                                        style: {
                                                                                            display: "flex",
                                                                                            justifyContent: "space-between"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default */.ZP, {
                                                                                                className: "radio",
                                                                                                style: {
                                                                                                    width: "75%"
                                                                                                },
                                                                                                value: item.sub_area,
                                                                                                onClick: function(e) {
                                                                                                    return addTofilters(e, "sub_area", item.sub_area);
                                                                                                },
                                                                                                children: item.sub_area
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "action-buttons",
                                                                                                style: {
                                                                                                    width: "22%"
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                                        style: {
                                                                                                            color: "#1f36c7",
                                                                                                            border: "none"
                                                                                                        },
                                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOutlined/* default */.Z, {}),
                                                                                                        onClick: function() {
                                                                                                            return onFilterEdit("sub_area", item);
                                                                                                        }
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                                                        style: {
                                                                                                            color: "red",
                                                                                                            border: "none"
                                                                                                        },
                                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteOutlined/* default */.Z, {}),
                                                                                                        onClick: function() {
                                                                                                            return deleteSubAreaFilter(item.sub_area_id);
                                                                                                        }
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                });
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }, "3")
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-md-9",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-8"
                                                    }),
                                                    props.userRole === "admin" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-4",
                                                        style: {
                                                            paddingLeft: "100px",
                                                            paddingBottom: "30px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            style: {
                                                                minWidth: "135px",
                                                                height: "39px",
                                                                padding: "8px 16px",
                                                                borderRadius: "4px",
                                                                fontSize: "15px",
                                                                fontWeight: 400,
                                                                color: "#ffffff",
                                                                backgroundColor: "#1F36C7",
                                                                cursor: "pointer"
                                                            },
                                                            onClick: function() {
                                                                return setAddProduct(true);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "../../assets/svg/add.svg",
                                                                    alt: "",
                                                                    className: "position-relative",
                                                                    color: "#FFF",
                                                                    style: {
                                                                        paddingRight: "5px",
                                                                        display: "inherit"
                                                                    }
                                                                }),
                                                                "Add Product"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-1"
                                                    })
                                                ]
                                            }),
                                            !isHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                children: allProducts.length > 0 && allProducts.map(function(va) {
                                                    count++;
                                                    pagenumber = currentPage * 9 - 9 + count;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((botStore_module_default()).cardHead, " col-md-4"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (botStore_module_default()).cardBody,
                                                                style: {
                                                                    height: "11rem"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "d-flex",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "".concat((botStore_module_default()).para, " ").concat((botStore_module_default()).title),
                                                                                    style: {
                                                                                        paddingBottom: "0",
                                                                                        marginTop: "10px"
                                                                                    },
                                                                                    children: [
                                                                                        "S",
                                                                                        pagenumber,
                                                                                        " ",
                                                                                        va.pid,
                                                                                        " ",
                                                                                        va.product_title
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (botStore_module_default()).content1,
                                                                                    style: {
                                                                                        fontSize: "12px"
                                                                                    },
                                                                                    children: va.product_caption
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: "".concat(imageBaseURL + va.product_banner),
                                                                                alt: "",
                                                                                className: "position-relative "
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((botStore_module_default()).cardFoot, " d-flex align-items-center justify-content-between"),
                                                                style: {
                                                                    backgroundColor: "#E9EDF3",
                                                                    padding: " 0px 10px",
                                                                    height: "64px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "baseline",
                                                                            paddingRight: 8
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "mr-2",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                    src: "".concat(imageBaseURL, "product-data.svg"),
                                                                                    alt: ""
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "".concat((botStore_module_default()).content),
                                                                                    style: {
                                                                                        fontSize: "12px"
                                                                                    },
                                                                                    children: [
                                                                                        va.hrs_saved,
                                                                                        " ",
                                                                                        va.hrs_saved_text
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        style: {
                                                                            cursor: "pointer"
                                                                        },
                                                                        src: "".concat(imageBaseURL, "bg_white_arrow.svg"),
                                                                        alt: "",
                                                                        className: "position-relative ",
                                                                        onClick: function() {
                                                                            return goToPage(va.product_id);
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    });
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (botStore_module_default()).mainSection_space,
                        children: [
                            !isHidden && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (botStore_module_default()).Products_section,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: "Introduction To Products"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (botStore_module_default()).iframe_section,
                                        dangerouslySetInnerHTML: {
                                            __html: "<iframe src=".concat(imageBaseURL, "intro_product.mp4 pused/>")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((botStore_module_default()).Products_section),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (botStore_module_default()).Section_2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6 col-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        children: "Always happy to help you."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Email us your question or quaries and we would be happy to answer by seting up a call with you."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        children: "Get in touch with us"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-6 col-6",
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "product_user.png"),
                                                    alt: ""
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        }, infiniteKey) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Addproduct, {
            setAddProduct: setAddProduct,
            onSuccess: function() {
                setAddProduct(false);
                location.reload();
            },
            isAdd: true
        }, infiniteKey)
    });
}
var Product_mapStateToProps = function(state) {
    return {
        storeProduct: state.storeProduct
    };
};
/* harmony default export */ var Product = ((0,es/* connect */.$j)(Product_mapStateToProps, null)(Product_index));

;// CONCATENATED MODULE: ./components/Pages/Product/Productdetailsshareonshelf.jsx



// import Botdetail from "../../botDetailEndUser/index";




function Productdetailsshareonshelf_index(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), currentBot = ref[0], setCurrentBot = ref[1];
    react.useEffect(function() {
        setCurrentBot(props.currentBot);
    }, [
        props.currentBot
    ]);
    react.useEffect(function() {
        console.log(router.query, "all kinda queries");
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container h-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row mt-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-6 col-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (botStore_module_default()).crard_main_section,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex align-items-center mb-3 mt-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "product5.svg"),
                                                    alt: "",
                                                    className: "mr-2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    style: {
                                                        fontWeight: "600"
                                                    },
                                                    children: "Share on Shelf"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).card_section1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "".concat(imageBaseURL, "maps.svg"),
                                                            alt: "",
                                                            className: "mr-2"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Clusters Live"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "South Asia (India), LATAM (Argentina)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "crard_main_section_p",
                                            children: "Now we have Image Analytics to detect SKUs on Shelf & use that information to recommend order to the salesmen"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((botStore_module_default()).blue_card_section, " col-12 col-md-6"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        class: "justify-content-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                children: "55,000"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Manhours saved"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-6 col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (botStore_module_default()).iframe_section,
                                dangerouslySetInnerHTML: {
                                    __html: "<iframe src=".concat(imageBaseURL, "share.mp4 paused/>")
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (botStore_module_default()).benefits_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container h-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Benefits"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (botStore_module_default()).Frist_section,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benefits8.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Time savings for Salesmen and retailers"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benefits9.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Efficient Sales call"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center position-relative ".concat((botStore_module_default()).cards_benefits_card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(imageBaseURL, "robo.png"),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "back_image",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot.svg"),
                                                        className: (botStore_module_default()).img_1,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot1.svg"),
                                                        className: (botStore_module_default()).img_2,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot2.svg"),
                                                        className: (botStore_module_default()).img_3,
                                                        alt: ""
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mb-5",
                                            style: {
                                                fontWeight: "600"
                                            },
                                            children: "Process"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "Salesmen clicks the shelf photographs in his",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " HHT and then the image is sent for processing"
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "Model runs on the image that is clicked and is",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " trained for all competitor brands as well"
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "The solution provides recommendation on ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " what order needs to be taken"
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var Productdetailsshareonshelf = (Productdetailsshareonshelf_index);

;// CONCATENATED MODULE: ./components/Pages/Product/Productdetailsneo.jsx



// import Botdetail from "../../botDetailEndUser/index";




function Productdetailsneo_index(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), currentBot = ref[0], setCurrentBot = ref[1];
    react.useEffect(function() {
        setCurrentBot(props.currentBot);
    }, [
        props.currentBot
    ]);
    react.useEffect(function() {
        console.log(router.query, "all kinda queries");
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container h-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row mt-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-6 col-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (botStore_module_default()).crard_main_section,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex align-items-center mb-3 mt-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "product10.svg"),
                                                    alt: "",
                                                    className: "mr-2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    style: {
                                                        fontWeight: "600"
                                                    },
                                                    children: "Neo"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).card_section1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "".concat(imageBaseURL, "maps.svg"),
                                                            alt: "",
                                                            className: "mr-2"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Clusters Live"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "South Africa"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "crard_main_section_p",
                                            children: "With our Neo product the order capturng is fully automated, all the PDFs/ Excels / Images sent via mail have automated extraction of data."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (botStore_module_default()).blue_card_section,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex align-items-center justify-content-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " mr-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: "45000+"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Man Hours Saved"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-6 col-12 mt-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (botStore_module_default()).iframe_section,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(imageBaseURL, "productneo.png"),
                                    width: "100%",
                                    height: 345
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (botStore_module_default()).benefits_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container h-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Top Benefits"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (botStore_module_default()).Frist_section,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Accurate process"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits1.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Manual efforts saved"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits2.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Full automated solution"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3 col-6 mb-4 mb-md-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (botStore_module_default()).cards_benefits,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(imageBaseURL, "benifits3.svg"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Real time insigts for orders processed"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center position-relative ".concat((botStore_module_default()).cards_benefits_card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(imageBaseURL, "robo.png"),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "back_image",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot.svg"),
                                                        className: (botStore_module_default()).img_1,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot1.svg"),
                                                        className: (botStore_module_default()).img_2,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(imageBaseURL, "dot2.svg"),
                                                        className: (botStore_module_default()).img_3,
                                                        alt: ""
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mb-5",
                                            style: {
                                                fontWeight: "600"
                                            },
                                            children: "Process"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Customers send mail to Neo id"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Abby (OCR Tool) extracts all informations from the documents send"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "From there the format is converted to EDIFACT"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "This is then sent to Dell Boomi (The middleware)"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "And Dell Boomi processes towards SAP"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Once this is processed all order status are sent to the Dashboards"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var Productdetailsneo = (Productdetailsneo_index);

// EXTERNAL MODULE: ./styles/pages/order.module.scss
var order_module = __webpack_require__(54801);
var order_module_default = /*#__PURE__*/__webpack_require__.n(order_module);
// EXTERNAL MODULE: ./styles/components/feedback.module.scss
var feedback_module = __webpack_require__(47283);
var feedback_module_default = /*#__PURE__*/__webpack_require__.n(feedback_module);
;// CONCATENATED MODULE: ./components/Pages/Feedback/index.jsx




















var Feedback_ModalExample = function(props) {
    var useOutsideAlerter = // method to close the modal if clicked outside
    function useOutsideAlerter(ref) {
        (0,react.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                //props.closeModal();
                }
            }
            // Bind the event listener
            document.addEventListener("click", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    //console.log("Props soft skill ---", props);
    var sucessFailure = props.data[1].component.content.field_message_type_value_pair;
    var requestDemoInfo = props.data[0].component.content;
    var field_title = requestDemoInfo.field_title, field_message_input = requestDemoInfo.field_message_input, field_options = requestDemoInfo.field_options, field_request_demo_form_componen = requestDemoInfo.field_request_demo_form_componen;
    var modalRef = react.useRef(null);
    useOutsideAlerter(modalRef);
    var router = (0,next_router.useRouter)();
    var initialState = {
        "Rating": "",
        "Description": ""
    };
    var rawErrorData = {
        name: false
    };
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(initialState), 2), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useState)(rawErrorData), stateError = ref1[0], setStateError = ref1[1];
    var ref2 = (0,react.useState)([]), items = ref2[0], setItems = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), sskillid = ref3[0], setSskillid = ref3[1];
    var ref4 = (0,react.useState)(false), successModal = ref4[0], setSuccessModal = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref5[0], setSubmitForm = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref6[0], setGetFormValues = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref7[0], setEmptyFormValues = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), Loading = ref8[0], setLoading = ref8[1];
    var ref9 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), msg = ref9[0], setMsg = ref9[1];
    var remarkComponent = props.data[0].component.content.field_request_demo_form_componen[0];
    var feedbackname = props.data[0].component.content.field_request_demo_form_componen[1];
    var softskillForm = function() {
        setGetFormValues(true);
    };
    var onValueChange = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = e.target.value;
                setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, e.target.id, value)));
                if (e.target.value) {
                    setStateError((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, stateError), (0,src_define_property/* default */.Z)({}, e.target.id, "valid")));
                } else {
                    setStateError((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, stateError), (0,src_define_property/* default */.Z)({}, e.target.id, true)));
                }
                return [
                    2
                ];
            });
        });
        return function onValueChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var onFromSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var authCheck, expiryStatus, moveAhead, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSubmitForm(true);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        moveAhead = true;
                        if (!(state.Rating == "" || state.Description == "")) return [
                            3,
                            2
                        ];
                        return [
                            3,
                            5
                        ];
                    case 2:
                        if (!expiryStatus) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 3:
                        auth = _state.sent();
                        axios_default()({
                            method: "POST",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/feedback"),
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            },
                            data: (0,src_object_spread/* default */.Z)({}, state)
                        }).then(function(resp) {
                            if (resp.data.code == 403) {
                                props.closeModal();
                                props.setSuccessModal(true);
                                props.setMessage(sucessFailure[0].field_message);
                                setLoading(true);
                                props.setSuccessModal(true);
                            } else if (resp.status == 200) {
                                setLoading(true);
                                setMsg(true);
                                props.closeModal();
                                props.setSuccessModal(true);
                                props.setMessage(sucessFailure[0].field_message);
                                setLoading(true);
                                props.setSuccessModal(true);
                            } else if (resp.data.code == 400) {
                                props.closeModal();
                                props.setSuccessModal(true);
                                props.setMessage(sucessFailure[0].field_message);
                                setLoading(true);
                                props.setSuccessModal(true);
                            }
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        props.sessionTimeOutCheck(true);
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFromSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handledemo = function() {
        props.closeModal();
        document.body.style.overflow = "unset";
    };
    //console.log("iteam_check------>" , items)
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (feedback_module_default()).editModalWrapper,
        children: [
            Loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feedback_module_default()).modalBox,
                ref: modalRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((feedback_module_default()).formContainer),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (feedback_module_default()).rowBtn,
                                    onClick: function() {
                                        handledemo();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (feedback_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/close.png",
                                            className: (feedback_module_default()).iconimg
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (feedback_module_default()).head,
                                            children: "Feedback Form "
                                        }),
                                        msg ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Your Feedback sent successfully"
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (feedback_module_default()).modalBody,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (feedback_module_default()).row
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (feedback_module_default()).row,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-12 col-md-12 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (feedback_module_default()).formGroup,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (feedback_module_default()).combine,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (feedback_module_default()).mainLabel,
                                                        children: [
                                                            get_default()(feedbackname, "field_form_field_title", ""),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                className: (feedback_module_default()).mandatoryField,
                                                                children: "*"
                                                            }),
                                                            submitForm ? state.Rating == "" && state.Rating.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (feedback_module_default()).errorMessage,
                                                                children: get_default()(feedbackname, "field_message_ip_error_message", "")
                                                            }) : null : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    className: (feedback_module_default()).inputtext,
                                                    id: "Rating",
                                                    name: "Rating",
                                                    onChange: onValueChange
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-12 col-md-12 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (feedback_module_default()).formGroup,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (feedback_module_default()).labelstyle,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        children: [
                                                            get_default()(remarkComponent, "field_form_field_title", ""),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                className: (feedback_module_default()).mandatoryField,
                                                                children: "*"
                                                            }),
                                                            submitForm ? state.Description == "" && state.Description.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (feedback_module_default()).errorMessage,
                                                                children: get_default()(feedbackname, "field_message_ip_error_message", "")
                                                            }) : null : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    // className={`${invalidFlag ? styles.errorBorder : null}`}
                                                    placeholder: remarkComponent.field_title,
                                                    id: "Description",
                                                    name: "Description",
                                                    onChange: onValueChange
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (feedback_module_default()).modalFooter,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (feedback_module_default()).combinedBtn,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (feedback_module_default()).exportListBtn,
                                onClick: onFromSubmit,
                                children: field_options[0]
                            })
                        })
                    })
                ]
            }),
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessModal, {
                setSuccessModal: function() {
                    setSuccessModal(false);
                    setFileNameError(false);
                },
                title: "Framework",
                message: filenameError ? "Document with this name already exists." : message,
                fail: filenameError ? true : false
            }) : null
        ]
    });
};
var Feedback_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function Feedback_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var Feedback = ((0,es/* connect */.$j)(Feedback_mapStateToProps, Feedback_mapDispatchToProps)(Feedback_ModalExample));

;// CONCATENATED MODULE: ./components/Pages/Order/index.jsx















function Order_index(props) {
    var openpopup = function openpopup() {
        var modal = !feedbackModal;
        setFeedbackModal(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var router = (0,next_router.useRouter)();
    // let ip = "http://20.56.91.182";
    //console.log(props, "props at login");
    var loginData = props.data[0].component.content;
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), feedbackModal = ref[0], setFeedbackModal = ref[1];
    var ref1 = (0,react.useState)(false), successModal = ref1[0], setSuccessModal = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState("We have received your feedback. Thank you for your feedback"), 2), message = ref2[0], setMessage = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), sucessOrFailure = ref3[0], setsucessOrFailure = ref3[1];
    var data = props.data;
    var empid = JSON.parse(localStorage.getItem("empid"));
    var orderid = JSON.parse(localStorage.getItem("orderid"));
    var livedate = JSON.parse(localStorage.getItem("livedate"));
    var goTo = function(link) {
        router.push({
            pathname: link
        });
    };
    var ref4 = data[0], _component = ref4.component, _content = _component.content, field_details = _content.field_details, field_input = _content.field_input, field_label = _content.field_label, field_login_image = _content.field_login_image, field_logos = _content.field_logos, field_title = _content.field_title;
    var emailHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/orderMail"),
                                method: "POST",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    orderID: orderid
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setGlobalskill(data.GlobalSkill);
                            setLocalskill(data.LocalSkill);
                            setSoftskill(data.softSkill);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function emailHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        emailHandler();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((order_module_default()).Container, " container-fluid"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (order_module_default()).userLoginContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (order_module_default()).backimage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/bannerbg.png",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (order_module_default()).loginModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (order_module_default()).right,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (order_module_default()).top,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (order_module_default()).textWrapper,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: (order_module_default()).head,
                                            children: loginData.field_title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (order_module_default()).content,
                                            dangerouslySetInnerHTML: {
                                                __html: loginData.field_details
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            className: (order_module_default()).head1,
                                            children: [
                                                "Your Request ID is ",
                                                orderid,
                                                " and Go live date is ",
                                                livedate
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (order_module_default()).content,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (order_module_default()).text1,
                                                    children: "Engagement lead will reach out to you to discuss your requirement"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (order_module_default()).text1,
                                                    onClick: function() {
                                                        return goTo(props.pageRoutes.Orderlisting);
                                                    },
                                                    style: {
                                                        cursor: "pointer",
                                                        color: "#1f36d2"
                                                    },
                                                    children: "Click here to check the Order Status"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (order_module_default()).bottom,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (order_module_default()).lovedbtn,
                                        onClick: function() {
                                            return goTo(props.pageRoutes.Employeetwin);
                                        },
                                        children: "Love It"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (order_module_default()).betterbtn,
                                        onClick: function() {
                                            openpopup();
                                        },
                                        children: "Can Be Better"
                                    })
                                ]
                            }),
                            feedbackModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback, {
                                data: props.feedback.data.field_component,
                                closeModal: function() {
                                    setFeedbackModal(false);
                                },
                                pageRoutes: props.pageRoutes,
                                setSuccessModal: setSuccessModal,
                                setMessage: setMessage,
                                setsucessOrFailure: setsucessOrFailure,
                                empid: empid
                            }) : null,
                            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                                setSuccessModal: setSuccessModal,
                                title: "Feedback",
                                message: message,
                                fail: sucessOrFailure
                            }) : null
                        ]
                    })
                })
            ]
        })
    });
}
var Order_mapStateToProps = function(state) {
    return {};
};
function Order_mapDispatchToProps(dispatch) {}
/* harmony default export */ var Order = ((0,es/* connect */.$j)(Order_mapStateToProps, null)(Order_index));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var src_type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./styles/pages/createemptwin.module.scss
var createemptwin_module = __webpack_require__(96182);
var createemptwin_module_default = /*#__PURE__*/__webpack_require__.n(createemptwin_module);
// EXTERNAL MODULE: ./components/uploadFileemptwin/index.jsx
var uploadFileemptwin = __webpack_require__(50543);
// EXTERNAL MODULE: ./styles/components/basicemptwinForm.module.scss
var basicemptwinForm_module = __webpack_require__(63487);
var basicemptwinForm_module_default = /*#__PURE__*/__webpack_require__.n(basicemptwinForm_module);
// EXTERNAL MODULE: ./styles/components/listDropdownforemptwin.module.scss
var listDropdownforemptwin_module = __webpack_require__(1034);
var listDropdownforemptwin_module_default = /*#__PURE__*/__webpack_require__.n(listDropdownforemptwin_module);
;// CONCATENATED MODULE: ./components/listDropdown/indexemptwin.jsx





function indexemptwin(props) {
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), keepTrack = ref[0], setKeepTrack = ref[1];
    react.useEffect(function() {
        console.log(props.presentState, "presentState");
        if (props.presentState != null && props.presentState != undefined && props.presentState.length != 0) {
            var previousVStateAr = [];
            props.presentState.map(function(previousItem, index) {
                props.values.map(function(item, index) {
                    console.log(previousItem, item, "========>itemsspreviousitems");
                    if (previousItem == item) {
                        previousVStateAr.push(index);
                    }
                });
            });
            setKeepTrack((0,src_to_consumable_array/* default */.Z)(previousVStateAr));
        }
    }, []);
    var checkChange = function(option, index, e) {
        // if (option == "No parent Selected")
        //   {
        //     return; 
        //   }
        if (e.target.checked) {
            console.log(keepTrack, "========>keepTrack", index);
            setKeepTrack((0,src_to_consumable_array/* default */.Z)(keepTrack).concat([
                index
            ]));
            if (props.dropdownParent == "mco") {
                var arr = (0,src_to_consumable_array/* default */.Z)(props.presentState);
                console.log("========>mco i", arr);
                arr.push(option);
                console.log("========>mco im", arr);
                console.log("========>mco im2", props.presentState);
                props.getDropdownValue(arr, props.dropdownParent, props.haveRelated, true);
            } else {
                var arr1 = (0,src_to_consumable_array/* default */.Z)(props.presentState);
                arr1.push(option);
                console.log("========>mco im", arr1);
                console.log("========>mco im2", props.presentState);
                props.getDropdownValue(option, props.dropdownParent, props.haveRelated, true);
            }
        } else {
            var newKeepTrack = keepTrack.filter(function(item) {
                return item != index;
            });
            setKeepTrack((0,src_to_consumable_array/* default */.Z)(newKeepTrack));
            props.removeCheckedValue(option, props.dropdownParent, props.haveRelated);
        }
    };
    react.useEffect(function() {
        console.log(keepTrack, "this is what you ");
    }, [
        keepTrack
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (listDropdownforemptwin_module_default()).listContainer,
        children: props.values.map(function(option, index) {
            return(// <li onClick={() => optionSelected(option)}>{option}</li> // give a color on hover , make curson pointer,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: (listDropdownforemptwin_module_default()).list_Checkbox_container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (listDropdownforemptwin_module_default()).lableHead,
                        children: option
                    }),
                    option == "No parent Selected" ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        onChange: function(e) {
                            return checkChange(option, index, e);
                        },
                        checked: keepTrack.includes(index) ? true : false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (listDropdownforemptwin_module_default()).list_checkmark
                    })
                ]
            }));
        })
    });
}

;// CONCATENATED MODULE: ./components/basicemptwinForm1/index.jsx





















function basicemptwinForm1_index(props) {
    var camelize = function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    // to convert labels into camelcase
    //console.log(props.data,"savedState");
    var ref = (0,react.useState)({}), auth = ref[0], setAuth = ref[1];
    var ref1 = (0,react.useState)([]), allGlobalFields = ref1[0], setAllGlobalFields = ref1[1];
    var ref2 = (0,react.useState)([]), requiredFieldsArray = ref2[0], setRequiredFieldsArray = ref2[1];
    var initialStates = {};
    var dropDownsInitialStates = {};
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), requiredFields = ref3[0], setRequiredFields = ref3[1];
    react.useEffect(function() {
        setAuth(JSON.parse(localStorage.getItem("auth")).data);
        props.data.map(function(item) {
            //console.log("jjjjjjj",item)
            if (item.field_label == "MCO") {
                item.value = "mco";
            } else {
                item.value = camelize(item.field_label);
            }
        });
        props.data.map(function(item) {
            if (item.field_input_type == "Related Dropdown" && item.field_related_dropdown.length > 0) {
                var fieldOptions = [];
                item.field_dropdown_option_component.map(function(item) {
                    fieldOptions = (0,src_to_consumable_array/* default */.Z)(fieldOptions).concat((0,src_to_consumable_array/* default */.Z)(item.field_options));
                });
            }
        });
        var requiredFields = [];
        props.data.map(function(item) {
            if (item.field_required == "1") {
                if (item.field_label == "Country") {
                    initialStates[item.value] = [];
                } else {
                // initialStates[item.value] = "";
                }
            }
            if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
                dropDownsInitialStates[item.value] = false;
            }
            if (item.field_required == "1") {
                requiredFields.push(item.value);
            }
        });
        setRequiredFieldsArray((0,src_to_consumable_array/* default */.Z)(requiredFields));
        setAllGlobalFields(props.data);
    }, []);
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), relatedDropdowns = ref4[0], setRelatedDropdowns = ref4[1];
    react.useEffect(function() {
        var relatedDropdownToSet = {};
        props.data.map(function(item) {
            if (item.field_input_type == "Related Dropdown") {
                relatedDropdownToSet = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, relatedDropdownToSet), (0,src_define_property/* default */.Z)({}, item.value, {
                    allValues: item.field_dropdown_option_component
                }));
            }
        });
        props.data.map(function(item) {
            if (item.field_related_dropdown !== "" && item.field_related_dropdown !== null && item.field_related_dropdown !== undefined) {
                if (!lodash_default().isEmpty(props.savedState)) {
                    //console.log(props.savedState.country, "countryy");
                    //console.log("====>#1",relatedDropdownToSet["mco"])
                    //console.log("====>#11",camelize(item.field_related_dropdown))
                    if (relatedDropdownToSet[camelize(item.field_related_dropdown) == "mCO" ? "mco" : camelize(item.field_related_dropdown)] !== undefined) {
                        //console.log(relatedDropdownToSet,"savedState");
                        var nowValuesArr = relatedDropdownToSet[camelize(item.field_related_dropdown) == "mCO" ? "mco" : camelize(item.field_related_dropdown)].allValues.filter(function(innerItem) {
                            return camelize(item.field_related_dropdown) == "country" ? props.savedState[item.value].includes(innerItem.field_title) : innerItem.field_title == props.savedState[item.value];
                        });
                        //console.log("====>#2",props.savedState[item.value])
                        //console.log("====>#3",nowValuesArr)
                        if (nowValuesArr.length > 0) {
                            var nowValues = [];
                            nowValuesArr.map(function(val) {
                                var _nowValues;
                                (_nowValues = nowValues).push.apply(_nowValues, (0,src_to_consumable_array/* default */.Z)(val.field_options));
                            });
                        }
                        //console.log("====>#4",nowValues)
                        //console.log(nowValues,"relatedDropdownToSet");
                        relatedDropdownToSet[camelize(item.field_related_dropdown) == "mCO" ? "mco" : camelize(item.field_related_dropdown)].nowValues = nowValues;
                    }
                }
            }
        });
        setRelatedDropdowns(relatedDropdownToSet);
    }, []);
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref5[0], setState = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(dropDownsInitialStates), 2), dropDownState = ref6[0], setDropdownState = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref7[0], setInvalidFlag = ref7[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleDropDown = function(item) {
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownsInitialStates), (0,src_define_property/* default */.Z)({}, item, !dropDownState[item])));
    };
    var gotDropDownValue = function(value, dropdownParent, haveRelated, checkbox) {
        //console.log("========>1",value)
        //console.log("========>2",dropdownParent)
        //console.log("========>3", haveRelated)
        //console.log("========>4", checkbox)
        if (value == "None") {
            if (dropdownParent == "country") {
                setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, dropdownParent, [])));
            } else {
                var newState = state;
                delete newState[dropdownParent];
                setState((0,src_object_spread/* default */.Z)({}, newState));
            }
        } else {
            if (dropdownParent == "status") {
            //console.log(value, "valuessToBeAttatchedToForLIFE")
            } else {
                if (haveRelated != null && haveRelated.length > 0) {
                    var newState1 = state;
                    delete newState1[haveRelated];
                    var myArr = props.data.filter(function(item) {
                        return item.value == haveRelated;
                    });
                    if (myArr.length > 0) {
                        if (myArr[0].field_related_dropdown) {
                            var emptyNowValues = camelize(myArr[0].field_related_dropdown);
                        }
                    }
                    props.data.map(function(item, index) {
                        if (item.value == haveRelated) {
                            if (camelize(item.field_related_dropdown) != null && camelize(item.field_related_dropdown).length > 0) {
                                //  let newerState = state
                                if (camelize(item.field_related_dropdown) == "country") {
                                    newState1["country"] = [];
                                    newState1["mco"] = [];
                                } else {
                                    delete newState1[camelize(item.field_related_dropdown)];
                                }
                            }
                        }
                    });
                    setState(newState1);
                    //console.log(relatedDropdowns, "related Ka Khel");
                    var selectedRelatedDropdown = relatedDropdowns;
                    // selectedRelatedDropdown[haveRelated].nowValues =
                    // selectedRelatedDropdown[haveRelated].allValues.filter(
                    //   (item) => item.field_title == value
                    // )[0].field_options;
                    selectedRelatedDropdown[haveRelated].nowValues = "";
                    if (Array.isArray(value)) {
                        var _arr;
                        var arr = [];
                        selectedRelatedDropdown[haveRelated].allValues.filter(function(item) {
                            return value.includes(item.field_title);
                        //  item.field_title == value
                        }).map(function(va, index) {
                            return (_arr = arr).push.apply(_arr, (0,src_to_consumable_array/* default */.Z)(va.field_options));
                        });
                        selectedRelatedDropdown[haveRelated].nowValues = arr;
                    } else {
                        selectedRelatedDropdown[haveRelated].nowValues = selectedRelatedDropdown[haveRelated].allValues.filter(function(item) {
                            return item.field_title == value;
                        })[0].field_options;
                    }
                    if (emptyNowValues) {
                        delete selectedRelatedDropdown[emptyNowValues].nowValues;
                    }
                    setRelatedDropdowns((0,src_object_spread/* default */.Z)({}, selectedRelatedDropdown));
                }
                if (dropdownParent == "country") {
                    var repeatedFlag = false;
                    // alert(value+"==="+JSON.stringify(state[dropdownParent]))
                    for(var i in state[dropdownParent]){
                        if (state[dropdownParent][i] == value) {
                            repeatedFlag = true;
                            break;
                        }
                    }
                    if (!repeatedFlag) {
                        // console.log("state[dropdownParent]",state[dropdownParent])
                        setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, dropdownParent, (0,src_to_consumable_array/* default */.Z)(state[dropdownParent]).concat([
                            value
                        ]))));
                    }
                // setState({ ...state, [dropdownParent]: [value] });
                } else if (dropdownParent == "mco") {
                    var repeatedFlag1 = false;
                    for(var i1 in state[dropdownParent]){
                        if (Array.isArray(value)) {
                            if (state[dropdownParent][i1] == value[value.length - 1]) {
                                repeatedFlag1 = true;
                                break;
                            }
                        } else {
                            if (state[dropdownParent][i1] == value) {
                                repeatedFlag1 = true;
                                break;
                            }
                        }
                    }
                    if (!repeatedFlag1) {
                        if (Array.isArray(value)) {
                            var _obj;
                            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, dropdownParent, (0,src_to_consumable_array/* default */.Z)(state[dropdownParent]).concat([
                                value[value.length - 1]
                            ])), (0,src_define_property/* default */.Z)(_obj, "country", []), _obj)));
                        } else {
                            var _obj1;
                            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, dropdownParent, (0,src_to_consumable_array/* default */.Z)(state[dropdownParent]).concat([
                                value
                            ])), (0,src_define_property/* default */.Z)(_obj1, "country", []), _obj1)));
                        }
                    }
                // setState({ ...state, [dropdownParent]: [value] });
                } else {
                    setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, dropdownParent, value)));
                }
            }
        }
        if (!checkbox) {
            setDropdownState(dropDownsInitialStates);
        }
    };
    react.useEffect(function() {
    //console.log(state.mco, "========>stateisAllineed")
    }, [
        state
    ]);
    react.useEffect(function() {
        //console.log("props.savedState",props.savedState)
        if (props.savedState) {
            if (props.savedState.country) {
                if (typeof props.savedState.country == "string") {
                    props.savedState.country = props.savedState.country.split(",");
                    if (props.savedState.country[props.savedState.country.length - 1] == "") {
                        props.savedState.country.pop();
                    }
                }
            }
            if (props.savedState.mco) {
                if (typeof props.savedState.mco == "string") {
                    props.savedState.mco = props.savedState.mco.split(",");
                    if (props.savedState.mco[props.savedState.mco.length - 1] == "") {
                        props.savedState.mco.pop();
                    }
                }
            }
            setState((0,src_object_spread/* default */.Z)({}, state, props.savedState));
        }
    }, []);
    var removeCheckedValue = function(option, dropdownParent, haveRelated) {
        if (dropdownParent == "mco") {
            var _arr;
            //console.log("removedChecked Value",option,dropdownParent,haveRelated)
            var changedCheckBoxAr = state[dropdownParent].filter(function(item) {
                return item != option;
            });
            var selectedRelatedDropdown = relatedDropdowns;
            var arr = [];
            selectedRelatedDropdown[haveRelated].allValues.filter(function(item) {
                return changedCheckBoxAr.includes(item.field_title);
            //  item.field_title == value
            }).map(function(va, index) {
                return (_arr = arr).push.apply(_arr, (0,src_to_consumable_array/* default */.Z)(va.field_options));
            });
            selectedRelatedDropdown[haveRelated].nowValues = arr;
            setRelatedDropdowns((0,src_object_spread/* default */.Z)({}, selectedRelatedDropdown));
            var _obj;
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, dropdownParent, (0,src_to_consumable_array/* default */.Z)(changedCheckBoxAr)), (0,src_define_property/* default */.Z)(_obj, "country", []), _obj)));
        } else {
            var changedCheckBoxAr1 = state[dropdownParent].filter(function(item) {
                return item != option;
            });
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, dropdownParent, (0,src_to_consumable_array/* default */.Z)(changedCheckBoxAr1))));
        //console.log("removedChecked Value 1",changedCheckBoxAr)
        }
    };
    react.useEffect(function() {
        //console.log("========>state",state)
        var leadplatform = state.leadPlatform;
        var area = state.area;
        var subarea = state.subArea;
        var cluser = state.cluster;
        var mco = state.mco;
        var country = state.country;
        //console.log("leadplatform" , leadplatform);
        props.pass_GetData(state);
    }, [
        state
    ]);
    react.useEffect(function() {
        //console.log("state get form value basic form-----", state);
        //console.log(props.getFormValues, "getFormValues")
        if (props.getFormValues) {
            var moveAhead = true;
            //console.log("required Fields", requiredFieldsArray);
            for(var i in requiredFieldsArray){
                if (state[requiredFieldsArray[i]] == "" || state[requiredFieldsArray[i]] == false || state[requiredFieldsArray[i]] === undefined || state[requiredFieldsArray[i]] == undefined || state[requiredFieldsArray[i]] == "undefined" || state[requiredFieldsArray[i]] == null) {
                    //console.log(state[requiredFieldsArray[i]], "let's see")
                    moveAhead = false;
                    break;
                }
            }
            if (moveAhead == true) {
                //console.log("sendfrom ----" ,state)
                props.sendFormValues(state);
                setInvalidFlag(false);
            } else {
                setInvalidFlag(true);
            }
            if (props.setGetFormValues) {
                props.setGetFormValues(false);
            }
        }
    }, [
        props.getFormValues
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: allGlobalFields.map(function(item, index) {
            if (item.field_input_type == "Dropdown" || item.field_input_type == "Related Dropdown") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-6 col-md-6 col-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (basicemptwinForm_module_default()).formGroup,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: (basicemptwinForm_module_default()).mainLabel,
                                    children: [
                                        item.field_form_field_title,
                                        item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                            className: (basicemptwinForm_module_default()).mandatoryField,
                                            children: "*"
                                        }) : null,
                                        invalidFlag ? (state[item.value] == "" || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (basicemptwinForm_module_default()).errorMessage,
                                            children: item.field_message_ip_error_message
                                        }) : null : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "".concat((basicemptwinForm_module_default()).input, " ").concat(invalidFlag ? (state[item.value] == "" || state[item.value] === undefined || state[item.value] == undefined || state[item.value] == "undefined" || state[item.value] == null) && item.field_required == "1" ? (basicemptwinForm_module_default()).errorBorder : null : null),
                                    disabled: props.formType == "editBot",
                                    onClick: function() {
                                        props.formType == "editBot" && item.field_label == "Landscape" ? void 0 : handleDropDown(item.value);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (basicemptwinForm_module_default()).left,
                                            children: state[item.value] == null || state[item.value] == "undefined" || state[item.value] === "" || state[item.value] === undefined ? item.field_input : item.field_label == "Country" ? state.country != undefined && state.country != null ? state.country.length == 0 ? item.field_input : "".concat(state.country.length, " items selected") : item.field_input : item.field_label == "MCO" ? state.mco != undefined && state.mco != null ? state.mco.length == 0 ? item.field_input : "".concat(state.mco.length, " items selected") : item.field_input : state[item.value]
                                        }),
                                        auth.userType != "supportStatus" ? item.field_label != "Support Status" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (basicemptwinForm_module_default()).right,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                name: "chevron",
                                                className: (basicemptwinForm_module_default()).chevron
                                            })
                                        }) : null : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (basicemptwinForm_module_default()).right,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                name: "chevron",
                                                className: (basicemptwinForm_module_default()).chevron
                                            })
                                        })
                                    ]
                                }),
                                dropDownState[item.value] == true ? item.field_label == "Country" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(indexemptwin, {
                                    values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? // "None",
                                    (0,src_to_consumable_array/* default */.Z)(relatedDropdowns[item.value].nowValues) : [
                                        "No parent Selected"
                                    ] : // "None",
                                    (0,src_to_consumable_array/* default */.Z)(item.field_options),
                                    removeCheckedValue: removeCheckedValue,
                                    presentState: state.country,
                                    getDropdownValue: gotDropDownValue,
                                    haveRelated: item.field_related_dropdown == "MCO" ? "mco" : camelize(item.field_related_dropdown),
                                    dropdownParent: item.value
                                }) : item.field_label == "MCO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(indexemptwin, {
                                    values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? // "None",
                                    (0,src_to_consumable_array/* default */.Z)(relatedDropdowns[item.value].nowValues) : [
                                        "No parent Selected"
                                    ] : // "None",
                                    (0,src_to_consumable_array/* default */.Z)(item.field_options),
                                    removeCheckedValue: removeCheckedValue,
                                    presentState: state.mco,
                                    getDropdownValue: gotDropDownValue,
                                    haveRelated: camelize(item.field_related_dropdown),
                                    dropdownParent: item.value
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                    dropdownParent: item.value,
                                    values: item.field_input_type == "Related Dropdown" ? relatedDropdowns[item.value].nowValues != undefined ? // "None",
                                    (0,src_to_consumable_array/* default */.Z)(relatedDropdowns[item.value].nowValues) : [
                                        "No parent Selected"
                                    ] : // "None",
                                    (0,src_to_consumable_array/* default */.Z)(item.field_options),
                                    getDropdownValue: gotDropDownValue,
                                    // haveRelated={"mco"}
                                    haveRelated: item.field_related_dropdown == "MCO" ? "mco" : camelize(item.field_related_dropdown),
                                    closeAllDropdowns: function() {
                                        setDropdownState(dropDownsInitialStates);
                                    }
                                }) : null
                            ]
                        })
                    })
                });
            }
        })
    });
}
var basicemptwinForm1_mapStateToProps = function(state) {
    return {
        currentBot: state.storeBot.currentBot
    };
};
function basicemptwinForm1_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var basicemptwinForm1 = ((0,es/* connect */.$j)(basicemptwinForm1_mapStateToProps, basicemptwinForm1_mapDispatchToProps)(basicemptwinForm1_index));

// EXTERNAL MODULE: ./components/Pages/SoftSkill/index.jsx + 1 modules
var SoftSkill = __webpack_require__(50355);
// EXTERNAL MODULE: ./styles/components/documentUploader.module.scss
var documentUploader_module = __webpack_require__(38710);
var documentUploader_module_default = /*#__PURE__*/__webpack_require__.n(documentUploader_module);
// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.esm.js
var fuse_esm = __webpack_require__(74221);
;// CONCATENATED MODULE: ./components/DocumentETUploader/index.jsx














var DocumentETUploader_ModalExample = function(props) {
    var ref = (0,react.useState)({}), uploaded = ref[0], setUploaded = ref[1];
    var ref1 = (0,react.useState)({}), couldNotUpload = ref1[0], setCouldNotUpload = ref1[1];
    var ref2 = (0,react.useState)(null), totalItems = ref2[0], setTotalItems = ref2[1];
    var ref3 = (0,react.useState)(0), uploadedItems = ref3[0], setUploadedItems = ref3[1];
    var ref4 = (0,react.useState)({}), originalFileNames = ref4[0], setOriginalFileNames = ref4[1];
    var ref5 = (0,react.useState)({}), azureFileNames = ref5[0], setAzureFileNames = ref5[1];
    var blobSasUrl = "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp";
    var blobSasUrlNew = utility_endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    var blobSasUrl1 = utility_endpoints/* default.blobSasUrl */.ZP.blobSasUrl;
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin/".concat(props.documentFolderName));
    // const createContainer = async () => {
    //   try {
    //     // reportStatus(`Creating container "${containerName}"...`);
    //     await containerClient.create();
    //     console.log("done");
    //     // reportStatus(`Done.`);
    //   } catch (error) {
    //     console.log(error);
    //     // reportStatus(error.message);
    //   }
    // };
    // createContainer()
    /**
 *

   
 */ react.useEffect(function() {
        if (props.uploadedDocumentsState != null) {
            console.log("consoling em down ", props.uploadedDocumentsState, "dsada", props.uploadedDocumentsState.uploaded, props.uploadedDocumentsState.totalItems, props.uploadedDocumentsState.uploadedItems, props.uploadedDocumentsState.originalFileNames);
            setUploaded(props.uploadedDocumentsState.uploaded);
            setTotalItems(props.uploadedDocumentsState.totalItems);
            setUploadedItems(props.uploadedDocumentsState.uploadedItems);
            setOriginalFileNames(props.uploadedDocumentsState.originalFileNames);
            setAzureFileNames(props.uploadedDocumentsState.azureFileNames);
        }
    }, []);
    var documentAr = [
        {
            title: "SOP",
            value: "sopDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx",
                ".msg",
                ".png",
                ".jpeg",
                ".jpg",
                ".xls",
                ".xlsx",
                ".ppt",
                ".pptx"
            ]
        },
        {
            title: "PDD",
            value: "pddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "PDD Approval",
            value: "pddApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "SDD",
            value: "sddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "QSG",
            value: "qsgDocument",
            type: [
                ".doc",
                ".docx"
            ]
        },
        {
            title: "ODI",
            value: "odiDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "BRD",
            value: "brdDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Cost Apporval",
            value: "costApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Landscape Approval",
            value: "explicitLandscapeApplicationOwnerApprovalDocument",
            type: ".msg"
        },
        {
            title: "GPM Approval",
            value: "explicitGPMApprovalSupplyChainFinanceDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "GFCF Approval",
            value: "explicitGFCFApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Dev Quality Crendentails Available",
            value: "devQualityCredentialsAvailableDocument",
            type: ".msg"
        },
        {
            title: "Infosec Approval",
            value: "infosecApprovalDocument",
            type: ".msg"
        },
        {
            title: "DA Review Sign Off",
            value: "dAReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "Test Data Development",
            value: "testDataAvailableForDevelopmentDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Request Raised Product Credentials",
            value: "requestRaisedForProductionCredentialsDocument",
            type: ".msg"
        },
        {
            title: "Internal Testing Completed",
            value: "internalTestingCompletedDocument",
            type: ".msg"
        },
        {
            title: "Peer Review Sign Off",
            value: "peerReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "DA Review Second Sign Off",
            value: "daReviewSecondSignOffDocument",
            type: ".msg"
        },
        {
            title: "BP Release Sign Off",
            value: "bpReleaseSignOffFromDaDocument",
            type: ".msg"
        },
        {
            title: "UAT Scripts With Results",
            value: "uatScriptsWithResultsDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Gate Form",
            value: "gateFormDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Peer Review Checklist",
            value: "peerReviewchecklistDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "QA Sign Off",
            value: "qaSignOffDocument",
            type: ".msg"
        },
        {
            title: "Walk Through Video",
            value: "walkthroughVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        },
        {
            title: "KT Video",
            value: "ktVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        }, 
    ];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(documentAr), 2), filteredDocumentAr = ref6[0], setFilteredDocumentAr = ref6[1];
    react.useEffect(function() {
        setTotalItems(documentAr.length);
    }, []);
    // to upload a file
    var ref7 = (0,react.useState)(false), fileUplaodState = ref7[0], setfileUplaodState = ref7[1];
    var ref8 = (0,react.useState)(false), currentlyUploading = ref8[0], setCurrentlyUploading = ref8[1];
    var ref9 = (0,react.useState)({}), presentState = ref9[0], setPresentState = ref9[1];
    var uploadFile = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(file, name, title, originalFileName, extension) {
            var counter, i, fileName, blockBlobClient, options, resp, ar, another, finalUrl, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("thisConsole", file, "file", name, "name", title, "title", originalFileName, "orginalFileName");
                        counter = 0;
                        console.log(originalFileName, "originalFileNamesfirst", originalFileNames);
                        for(var i in originalFileNames){
                            if (originalFileNames[i].split(".")[0].split("~")[0] + "." + originalFileNames[i].split(".")[originalFileNames[i].split(".").length - 1] == originalFileName) {
                                counter = counter + 1;
                            }
                        }
                        console.log(counter, "originalFileNameCounter");
                        if (counter > 0) {
                            originalFileName = originalFileName.split(".")[0] + "~" + counter + "." + originalFileName.split(".")[1];
                        }
                        fileName = originalFileName;
                        console.log(originalFileNames, "originalFileNames");
                        setCurrentlyUploading(true);
                        setAzureFileNames((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, azureFileNames), (0,src_define_property/* default */.Z)({}, name, fileName)));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            },
                            concurrency: 25
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        console.log("blob upload response----", resp);
                        setUploaded((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, uploaded), (0,src_define_property/* default */.Z)({}, name, true)));
                        setUploadedItems(uploadedItems + 1);
                        setOriginalFileNames((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, originalFileNames), (0,src_define_property/* default */.Z)({}, name, originalFileName)));
                        //props.setUploadedFileToShowOutside(title)
                        console.log(extension, "url idhar hai");
                        ar = resp._response.request.url.split("?");
                        another = ar[0].split("/");
                        finalUrl = another[another.length - 1];
                        // props.sendDocInfo(
                        //   name,
                        //   resp._response.request.url,
                        //   title,
                        //   uploadedItems + 1,
                        //   extension
                        // );
                        setPresentState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, presentState), (0,src_define_property/* default */.Z)({}, name, finalUrl)));
                        setCurrentlyUploading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setCurrentlyUploading(false);
                        setCouldNotUpload((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, couldNotUpload), (0,src_define_property/* default */.Z)({}, name, true)));
                        setUploaded((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, uploaded), (0,src_define_property/* default */.Z)({}, name, false)));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadFile(file, name, title, originalFileName, extension) {
            return _ref.apply(this, arguments);
        };
    }();
    console.log("Anshu file code", originalFileNames);
    // to delete a file
    var ref10 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), deleteDocumentsLater = ref10[0], setDeleteDocumentsLater = ref10[1];
    var deleteThis = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(name) {
            var fileName, azureFileNamesVar, previousFileTitle, i, toDelete, azureFileNamesVar1, previousFileTitle1, i1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                console.log(azureFileNames);
                fileName = "1" + name;
                console.log(name, "azureFileName", azureFileNames);
                setPresentState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, presentState), (0,src_define_property/* default */.Z)({}, name, "")));
                // if (azureFileNames[name]) {
                if (props.formType == "editBot") {
                    // setDeleteDocumentsLater([
                    //   ...deleteDocumentsLater,
                    //   azureFileNames[name],
                    // ]);
                    console.log(uploaded, "uploadedBeforeDeleting");
                    setUploaded((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, uploaded), (0,src_define_property/* default */.Z)({}, name, false)));
                    setUploadedItems(uploadedItems - 1);
                    azureFileNamesVar = (0,src_object_spread/* default */.Z)({}, azureFileNames);
                    delete azureFileNamesVar[name];
                    setAzureFileNames((0,src_object_spread/* default */.Z)({}, azureFileNamesVar));
                    previousFileTitle = null;
                    // console.log(uploaded, "xadsda", name)
                    for(var i in uploaded){
                        if (uploaded[i] == true && i != name) {
                            previousFileTitle = i;
                            break;
                        }
                    }
                //  props.sendDocInfo(name, "", previousFileTitle, uploadedItems - 1);
                } else {
                    toDelete = azureFileNames[name];
                    setUploaded((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, uploaded), (0,src_define_property/* default */.Z)({}, name, false)));
                    setUploadedItems(uploadedItems - 1);
                    azureFileNamesVar1 = (0,src_object_spread/* default */.Z)({}, azureFileNames);
                    delete azureFileNamesVar1[name];
                    setAzureFileNames((0,src_object_spread/* default */.Z)({}, azureFileNamesVar1));
                    previousFileTitle1 = null;
                    // console.log(uploaded, "xadsda", name)
                    for(var i1 in uploaded){
                        if (uploaded[i1] == true && i1 != name) {
                            previousFileTitle1 = i1;
                            break;
                        }
                    }
                //   props.sendDocInfo(name, "", previousFileTitle, uploadedItems - 1);
                //   try {
                //  await containerClient.deleteBlob(toDelete);
                // }
                // catch(err) {
                //   console.log(err)
                // }
                }
                return [
                    2
                ];
            });
        // alert("there");
        // }
        });
        return function deleteThis(name) {
            return _ref.apply(this, arguments);
        };
    }();
    var searchDocuments = function(e) {
        if (e.target.value.length == 0) {
            setFilteredDocumentAr(documentAr);
        } else {
            var options = {
                shouldSort: true,
                keys: [
                    "title",
                    "value",
                    "type"
                ]
            };
            var fuse = new fuse_esm/* default */.Z(documentAr, options);
            // Change the pattern
            var pattern = e.target.value;
            console.log("pattern  -----", pattern);
            var fuseResult = fuse.search("".concat(pattern));
            var filteredResult = [];
            console.log("fusee result  ----", fuseResult);
            for(var i in fuseResult){
                filteredResult.push(fuseResult[i].item);
            }
            setFilteredDocumentAr(filteredResult);
        }
    };
    // const allDone = () => {
    //   const docURL=blobSasUrl1+"/"+props.documentFolderName;
    //   console.log("line number 329",docURL);
    //   localStorage.setItem("docURL", JSON.stringify(docURL));
    //   if (!currentlyUploading) {
    //   props.sendAllInfoAboutUploadModal(
    //     uploaded,
    //     totalItems,
    //     uploadedItems,
    //     originalFileNames,
    //     azureFileNames,
    //     deleteDocumentsLater,
    //     presentState
    //   );
    //   props.closeModal();
    //   }
    // };
    var allDone = function() {
        var docURL1 = blobSasUrl1 + "/" + props.documentFolderName;
        console.log("line number 329", docURL1);
        localStorage.setItem("docURL1", JSON.stringify(originalFileNames));
        if (!currentlyUploading) {
            props.sendAllInfoAboutUploadModal(uploaded, totalItems, uploadedItems, originalFileNames, azureFileNames, deleteDocumentsLater, presentState);
            props.closeModal();
        }
    };
    // to download a file
    // const downloadThis = async (e) => {
    //   let fileName = "1" + e.target.name;
    //   const blockBlobClient = containerClient.getBlobClient(fileName);
    //   const downloadBlockBlobResponse = await blockBlobClient.download(0);
    //   console.log(downloadBlockBlobResponse);
    // };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (documentUploader_module_default()).editModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (documentUploader_module_default()).modalBox,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (documentUploader_module_default()).modalHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (documentUploader_module_default()).content,
                            children: "Document Uploader"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (documentUploader_module_default()).search,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                    name: "searchGrayIcon",
                                    className: (documentUploader_module_default()).searchIcon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    placeholder: "Search",
                                    onChange: searchDocuments
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (documentUploader_module_default()).modalBody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (documentUploader_module_default()).formatType,
                            children: "Upload files in the format of .pdf, .doc, .docx, .msg, .png, .jpeg, .jpg, .xls, .xlsx, .ppt, .pptx"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: filteredDocumentAr.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    style: {
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (documentUploader_module_default()).left,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    item.title,
                                                    item.title == "SOP" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        children: "*"
                                                    }) : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (documentUploader_module_default()).right,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_uploadFile/* default */.Z, {
                                                    data: true,
                                                    title: item.title,
                                                    value: item.value,
                                                    fileType: item.value == "walkthroughVideo" || item.value == "ktVideo" ? item.type : [
                                                        ".pdf",
                                                        ".doc",
                                                        ".docx",
                                                        ".msg",
                                                        ".png",
                                                        ".jpeg",
                                                        ".jpg",
                                                        ".xls",
                                                        ".xlsx",
                                                        ".ppt",
                                                        ".pptx"
                                                    ],
                                                    uploadFile: uploadFile,
                                                    uploaded: uploaded[item.value],
                                                    couldNotUpload: couldNotUpload[item.value],
                                                    originalFileName: originalFileNames[item.value],
                                                    type: "createBot",
                                                    specialCase: item.value == "walkthroughVideo" || item.value == "ktVideo" ? true : false,
                                                    currentlyUploading: currentlyUploading
                                                }),
                                                uploaded[item.value] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: function() {
                                                        return deleteThis(item.value);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                        name: "deleteicon",
                                                        className: (documentUploader_module_default()).icon
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (documentUploader_module_default()).modalFooter,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (documentUploader_module_default()).left,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (documentUploader_module_default()).countFilesSelected,
                                children: "".concat(uploadedItems, "/").concat(totalItems, " files selected")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (documentUploader_module_default()).right,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (documentUploader_module_default()).combinedBtn,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (documentUploader_module_default()).rowBtn,
                                        onClick: function() {
                                            return props.closeModal();
                                        },
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (documentUploader_module_default()).exportListBtn,
                                        onClick: function() {
                                            return allDone();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                name: "uploadicon"
                                            }),
                                            "Upload files"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var DocumentETUploader = (DocumentETUploader_ModalExample);

;// CONCATENATED MODULE: ./components/CreateEmployeeTwin/index.jsx
















//import UploadDocuments from "../uploadDocuments";






//import BasicForm from "../basicemptwinForm";








//multiple document		

function CreateEmployeeTwin_index(props) {
    var openpopup = //console.log("line number 64",leadState);
    /*end upload file code*/ function openpopup() {
        var modal = !softSkillModal;
        setsoftSkillModal(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var alphanumric = function alphanumric(val) {
        var re = /^[a-z][a-zA-Z0-9_]*$/;
        if (re.test(String(val))) {
            return true;
        } else {
            return false;
        }
    // return re.test(String(email).toLowerCase());
    };
    var camelize = function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "");
    };
    var router = (0,next_router.useRouter)();
    var emptwinForm = props.data;
    var dropDownsInitialStates = {};
    /*lead platform, area, subarea code*/ var leadPlatformData = props.globalData.lead_platform_main_component[0];
    var areaData = props.globalData.lead_platform_main_component[1];
    var subAreaData = props.globalData.lead_platform_main_component[2];
    var clusterData = props.globalData.cluster_main_component[0];
    var mcoData = props.globalData.cluster_main_component[1];
    var countryData = props.globalData.cluster_main_component[2];
    var ref = (0,react.useState)([
        props.globalData.lead_platform_main_component[0],
        props.globalData.lead_platform_main_component[1],
        props.globalData.lead_platform_main_component[2],
        props.globalData.cluster_main_component[0],
        props.globalData.cluster_main_component[1],
        props.globalData.cluster_main_component[2]
    ]), filterDropdowns = ref[0], setFiltersDropdowns = ref[1];
    /*end lead platform, area, subarea code*/ //console.log("Emptwin form data  ----", emptwinForm);
    var ref1 = (0,react.useState)(false), fileError = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(null), file = ref2[0], setFile = ref2[1];
    var ref3 = (0,react.useState)(null), file1 = ref3[0], setFile1 = ref3[1];
    var ref4 = (0,react.useState)(null), fileNameOriginal = ref4[0], setFileName = ref4[1];
    var ref5 = (0,react.useState)(null), fileNameOriginal1 = ref5[0], setFileName1 = ref5[1];
    var ref6 = (0,react.useState)(false), showFileName = ref6[0], setShowFileName = ref6[1];
    var ref7 = (0,react.useState)(false), showFileName1 = ref7[0], setShowFileName1 = ref7[1];
    var ref8 = (0,react.useState)([]), automationPdfs = ref8[0], setAutomationPdfs = ref8[1];
    var ref9 = (0,react.useState)([]), confidentialPdfs = ref9[0], setConfidentialPdfs = ref9[1];
    var ref10 = (0,react.useState)(false), filenameError = ref10[0], setFileNameError = ref10[1];
    var ref11 = (0,react.useState)([
        "pdf",
        "docx",
        "doc",
        "xlsx",
        "ppt",
        "pptx",
        "mp4"
    ]), fileTypes = ref11[0], setfileTypes = ref11[1];
    var ref12 = (0,react.useState)([
        "jpg",
        "jpeg",
        "png", 
    ]), fileTypesp = ref12[0], setfileTypesp = ref12[1];
    var ref13 = (0,react.useState)({}), auth = ref13[0], setAuth = ref13[1];
    var initialStates = {};
    var ref14 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), empid = ref14[0], setEmpid = ref14[1];
    var initialState = {
        "newRequest": "new",
        "employeeTwinID": "",
        "employeeTwinName": "",
        "employeeTwinDescription": "",
        "status": "",
        "leadPlatform": "",
        "area": "",
        "subArea": "",
        "cluster": "",
        "mco": "",
        "geoItPartner": "",
        "country": "",
        "businessOwner": "",
        "businessgroup": "",
        "businessunit": "",
        "businessoption": "",
        "engagementLead": "",
        "globalSkill": "",
        "localSkill": "",
        "softSkill": "",
        "manualhour": "",
        "fte": "",
        "businessRequest": "",
        "uploadPhoto": "",
        "uploadDocument": "",
        "product_id": "",
        "sopDocument": "",
        "pddDocument": "",
        "pddApprovalDocument": "",
        "sddDocument": "",
        "qsgDocument": "",
        "odiDocument": "",
        "brdDocument": "",
        "costApprovalDocument": "",
        "explicitLandscapeApplicationOwnerApprovalDocument": "",
        "explicitGPMApprovalSupplyChainFinanceDocument": "",
        "explicitGFCFApprovalDocument": "",
        "devQualityCredentialsAvailableDocument": "",
        "infosecApprovalDocument": "",
        "dAReviewSignOffDocument": "",
        "testDataAvailableForDevelopmentDocument": "",
        "requestRaisedForProductionCredentialsDocument": "",
        "internalTestingCompletedDocument": "",
        "peerReviewSignOffDocument": "",
        "daReviewSecondSignOffDocument": "",
        "bpReleaseSignOffFromDaDocument": "",
        "uatScriptsWithResultsDocument": "",
        "uatSignOffDocument": "",
        "releaseManagerSignOffDocument": "",
        "gateFormDocument": "",
        "peerReviewchecklistDocument": "",
        "qaSignOffDocument": "",
        "walkthroughVideo": "",
        "ktVideo": "",
        "transactions": "",
        "reporting": "",
        "cognitive": "",
        "decisionautomations": "",
        "genAi": "",
        "securityGroupId": ""
    };
    var initialState1 = {
        "newRequest": "new",
        "employeeTwinName": "",
        "employeeTwinDescription": "",
        "uploadPhoto": "",
        "status": "",
        "geoItPartner": "",
        "businessOwner": "",
        "businessgroup": "",
        "businessunit": "",
        "businessoption": "",
        "engagementLead": "",
        "manualhour": "",
        "fte": "",
        "uploadDocument": "",
        "goLiveDate": "",
        "product_id": "",
        "sopDocument": "",
        "pddDocument": "",
        "pddApprovalDocument": "",
        "sddDocument": "",
        "qsgDocument": "",
        "odiDocument": "",
        "brdDocument": "",
        "costApprovalDocument": "",
        "explicitLandscapeApplicationOwnerApprovalDocument": "",
        "explicitGPMApprovalSupplyChainFinanceDocument": "",
        "explicitGFCFApprovalDocument": "",
        "devQualityCredentialsAvailableDocument": "",
        "infosecApprovalDocument": "",
        "dAReviewSignOffDocument": "",
        "testDataAvailableForDevelopmentDocument": "",
        "requestRaisedForProductionCredentialsDocument": "",
        "internalTestingCompletedDocument": "",
        "peerReviewSignOffDocument": "",
        "daReviewSecondSignOffDocument": "",
        "bpReleaseSignOffFromDaDocument": "",
        "uatScriptsWithResultsDocument": "",
        "uatSignOffDocument": "",
        "releaseManagerSignOffDocument": "",
        "gateFormDocument": "",
        "peerReviewchecklistDocument": "",
        "qaSignOffDocument": "",
        "walkthroughVideo": "",
        "ktVideo": "",
        "securityGroupId": ""
    };
    //multiple document		
    var ref15 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), modalShow = ref15[0], setModalShow = ref15[1];
    var ref16 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), uploadedDocumentsState = ref16[0], setUploadedDocumentsState = ref16[1];
    var ref17 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), uploadedFileToShow = ref17[0], setUploadedFileToShow = ref17[1];
    var ref18 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), totalUploadedItems = ref18[0], setTotalUploadedItems = ref18[1];
    var ref19 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialState), 2), emptwin = ref19[0], setEmptwin = ref19[1];
    var ref20 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialState1), 2), emptwin1 = ref20[0], setEmptwin1 = ref20[1];
    var ref21 = (0,react.useState)(""), childData = ref21[0], setChildData = ref21[1];
    var ref22 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), emailCheck = ref22[0], setEmailCheck = ref22[1];
    var ref23 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), requiredFields = ref23[0], setRequiredFields = ref23[1];
    var ref24 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), numberCheck = ref24[0], setNumberCheck = ref24[1];
    var ref25 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref25[0], setInvalidFlag = ref25[1];
    var ref26 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref26[0], setSuccessModal = ref26[1];
    var ref27 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal1 = ref27[0], setSuccessModal1 = ref27[1];
    var ref28 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), sucessOrFailure = ref28[0], setsucessOrFailure = ref28[1];
    var ref29 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref29[0], setGetFormValues = ref29[1];
    var ref30 = (0,src_sliced_to_array/* default */.Z)(react.useState("We added soft skill"), 2), message = ref30[0], setMessage = ref30[1];
    /*Upload file code */ var ref31 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref31[0], setSubmitForm = ref31[1];
    //for transactional and global skill
    var ref32 = (0,react.useState)([]), globalskills = ref32[0], setGlobalskills = ref32[1];
    var ref33 = (0,react.useState)([]), globalvalue = ref33[0], setGlobalvalue = ref33[1];
    var ref34 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checked = ref34[0], setChecked = ref34[1];
    //for reporting and local skill
    var ref35 = (0,react.useState)([]), localskills = ref35[0], setLocalskills = ref35[1];
    var ref36 = (0,react.useState)([]), localvalue = ref36[0], setLocalvalue = ref36[1];
    var ref37 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedL = ref37[0], setCheckedL = ref37[1];
    //for cognitive skill
    var ref38 = (0,react.useState)([]), cognitiveskills = ref38[0], setCognitiveskills = ref38[1];
    var ref39 = (0,react.useState)([]), cognitivevalue = ref39[0], setCognitivevalue = ref39[1];
    var ref40 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedC = ref40[0], setCheckedC = ref40[1];
    //for decisionautomations skill
    var ref41 = (0,react.useState)([]), decisionautomationsskills = ref41[0], setDecisionautomationsskills = ref41[1];
    var ref42 = (0,react.useState)([]), decisionautomationsvalue = ref42[0], setDecisionautomationsvalue = ref42[1];
    var ref43 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedD = ref43[0], setCheckedD = ref43[1];
    var ref44 = (0,react.useState)(""), inputValue = ref44[0], setInputValue = ref44[1];
    var ref45 = (0,react.useState)(""), inputValue1 = ref45[0], setInputValue1 = ref45[1];
    // for genAI Skills
    var ref46 = (0,react.useState)([]), genAISkills = ref46[0], setGenAISkills = ref46[1];
    var ref47 = (0,react.useState)([]), genAIvalue = ref47[0], setGenAIvalue = ref47[1];
    var ref48 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedG = ref48[0], setCheckedG = ref48[1];
    //for gen AI skills search
    var ref49 = (0,react.useState)(""), inputValueg = ref49[0], setInputValueg = ref49[1];
    //for cognitive skill search
    var ref50 = (0,react.useState)(""), inputValuec = ref50[0], setInputValuec = ref50[1];
    //for decisionautomation skill search
    var ref51 = (0,react.useState)(""), inputValued = ref51[0], setInputValued = ref51[1];
    var ref52 = (0,react.useState)([]), skillvalue = ref52[0], setSkillvalue = ref52[1];
    var ref53 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedS = ref53[0], setCheckedS = ref53[1];
    var ref54 = (0,react.useState)([]), products = ref54[0], setProducts = ref54[1];
    var ref55 = (0,react.useState)([]), productids = ref55[0], setProductids = ref55[1];
    var ref56 = (0,react.useState)([]), productvalue = ref56[0], setProductvalue = ref56[1];
    var ref57 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedP = ref57[0], setCheckedP = ref57[1];
    var ref58 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), sopInvalid = ref58[0], setSopInvalid = ref58[1];
    // For Global and soft skill added by satyam
    //const items = JSON.parse(localStorage.getItem('myData')) || [];
    var items;
    var sid;
    var checkedSoft = function(e) {
        sid = e.target.value;
        if (items.includes(sid)) {} else {
            items.push(sid);
            localStorage.setItem("myData", JSON.stringify(items));
        }
        setCheckedS(false);
    };
    items = JSON.parse(localStorage.getItem("myData")) || [];
    /*Dropdown Added by Anshu*/ var ref59 = (0,react.useState)(false), reset = ref59[0], setreset = ref59[1];
    var ref60 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), leadPlatform = ref60[0], setLeadPlatform = ref60[1];
    var ref61 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), area = ref61[0], setArea = ref61[1];
    var ref62 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), subArea = ref62[0], setSubArea = ref62[1];
    var ref63 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), cluster = ref63[0], setCluster = ref63[1];
    var ref64 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), mco = ref64[0], setMco = ref64[1];
    var ref65 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), country = ref65[0], setCuntry = ref65[1];
    var GetData = function(recive) {
        // function code here
        //console.log("recive" , recive.leadPlatform)
        setLeadPlatform(recive.leadPlatform);
        setArea(recive.area);
        setSubArea(recive.subArea);
        setCluster(recive.cluster);
        setMco(recive.mco);
        setCuntry(recive.country);
    };
    //console.log("161-----",leadPlatform);
    var recievedFormValues = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(formState) {
            var filter, i;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setEmptyFormValues(true);
                setGetFormValues(false);
                filter = formState;
                for(var i in filter){
                    if (filter[i] == "") {
                        delete filter[i];
                    }
                }
                return [
                    2
                ];
            });
        });
        return function recievedFormValues(formState) {
            return _ref.apply(this, arguments);
        };
    }();
    var onValueChange = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = e.target.value;
                //console.log(e.target.id,e.target.value)
                setEmptwin((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, emptwin), (0,src_define_property/* default */.Z)({}, e.target.id, value)));
                setEmptwin1((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, emptwin1), (0,src_define_property/* default */.Z)({}, e.target.id, value)));
                return [
                    2
                ];
            });
        });
        return function onValueChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //console.log(emptwin.businessgroup)
    // if (e.target.value) {
    //   setStateError({ ...stateError, [e.target.id]: "valid" });
    // } 
    // else {
    //   setStateError({ ...stateError, [e.target.id]: true });
    // }
    //multiple document		
    var gotDocInfo = function(name, url, title, uploadedItems, extension) {
        var ar = url.split("?");
        var another = ar[0].split("/");
        var toSend = another[another.length - 1];
        // console.log(title, uploadedItems, "uploaded data of data");		
        // console.log(name, "nameat uploaderrr", title)		
        console.log(extension, "extension at 56");
        //  setUploadedFileToShow(title);		
        setTotalUploadedItems(uploadedItems);
        sendDocInfo(name, toSend, extension);
    };
    var sendAllInfoAboutUploadModal = function(uploaded, totalItems, uploadedItems, originalFileNames, azureFileNames, deleteDocumentsLater, presentState) {
        if (uploaded.sopDocument) {
            setSopInvalid(false);
        } else {
            setSopInvalid(true);
        }
        console.log("sab console kara lo", uploaded, "1", totalItems, "22", uploadedItems, "33", originalFileNames, "44", azureFileNames, "555", deleteDocumentsLater, "6666", presentState);
        //setUploadedFileToShow(documentAr.filter((item) => item.value === Object.keys(presentState)[Object.keys(presentState).length-1])[0].title)		
        console.log(azureFileNames, "azurefiles234latest");
        console.log(uploadedDocumentsState, "azurefiles234previous");
        var deleteDocumentsLaterToSet = [];
        if (uploadedDocumentsState && uploadedDocumentsState.deleteDocumentsLater && uploadedDocumentsState.deleteDocumentsLater.length > 0) {
            deleteDocumentsLaterToSet = (0,src_to_consumable_array/* default */.Z)(uploadedDocumentsState.deleteDocumentsLater);
            for(var i in uploadedDocumentsState.azureFileNames){
                if (!(i in azureFileNames)) {
                    deleteDocumentsLaterToSet.push(uploadedDocumentsState.azureFileNames[i]);
                }
            }
        }
        setUploadedDocumentsState({
            uploaded: uploaded,
            totalItems: totalItems,
            uploadedItems: uploadedItems,
            originalFileNames: originalFileNames,
            azureFileNames: (0,src_object_spread/* default */.Z)({}, azureFileNames),
            deleteDocumentsLater: (0,src_to_consumable_array/* default */.Z)(deleteDocumentsLaterToSet)
        });
        setTotalUploadedItems(uploadedItems);
    };
    var openDocumentModal = function() {
        var modal = !modalShow;
        setModalShow(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var closeDocumentModal = function() {
        var modal = !modalShow;
        setModalShow(false);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var azurefilepath;
    var blobSasUrl = "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
    var blobSasUrlNew = utility_endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    // "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin/emp");
    var uploadFile = function(file, name) {
        //console.log(file.name, "pdfsauto");
        azurefilepath = "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp" + file.name;
        //console.log("azure file path",azurefilepath)
        //console.log(automationPdfs, "pdfsauto");
        if (automationPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0 || confidentialPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0) {
            setFileNameError(true);
            //      setSuccessModal1(true);
            return;
        }
        setFile(file);
        setShowFileName(true);
        setFileName(file.name);
    };
    var uploadButtonClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var fileNameWithSpaces, fileName, ar, extension, fileSize, blockBlobClient, options, resp, url, ar1, another, toSend, authCheck, expiryStatus, auth, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fileNameWithSpaces = fileNameOriginal;
                        fileName = fileNameWithSpaces.replace(/ /g, " ");
                        ar = fileNameOriginal.split(".");
                        extension = ar[ar.length - 1];
                        fileSize = file.size;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        url = resp._response.request.url;
                        ar1 = url.split("?");
                        another = ar1[0].split("/");
                        toSend = another[another.length - 1];
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 3:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            axios_default()({
                                method: "post",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/framework/createFramework"),
                                data: {
                                    docType: extension,
                                    docName: fileNameOriginal,
                                    docCategory: "png",
                                    docUrl: toSend,
                                    docSize: fileSize
                                },
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(resp) {
                                if (resp.data.code == 200) {
                                    //  console.log(resp);
                                    //window.scrollTo(0, 0);
                                    setSuccessModal1(true);
                                    setTimeout(function() {
                                        setSuccessModal1(false);
                                    }, 1000);
                                    //setShowFileName(false);
                                    //setLoader(false);
                                    //setFile(null);
                                    setError(false);
                                // setFileName(null);
                                // getAllPdfs();
                                } else if (resp.data.code == 403) {
                                    setLoader(false);
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            setLoader(false);
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        //console.log(error, "erro");
                        alert("Could not upload");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var uploadFile1 = function(file, name) {
        //console.log(file.name, "pdfsauto");
        azurefilepath = "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + file.name;
        //console.log("azure file path",azurefilepath)
        //console.log(automationPdfs, "pdfsauto");
        if (automationPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0 || confidentialPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0) {
            setFileNameError(true);
            //setSuccessModal1(true);
            return;
        }
        setFile1(file);
        setShowFileName1(true);
        setFileName1(file.name);
    };
    var uploadButtonClick1 = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var fileNameWithSpaces, fileName, ar, extension, fileSize, blockBlobClient, options, resp, url, ar1, another, toSend, authCheck, expiryStatus, auth, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fileNameWithSpaces = fileNameOriginal1;
                        fileName = fileNameWithSpaces.replace(/ /g, " ");
                        ar = fileNameOriginal1.split(".");
                        extension = ar[ar.length - 1];
                        fileSize = file.size;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        url = resp._response.request.url;
                        ar1 = url.split("?");
                        another = ar1[0].split("/");
                        toSend = another[another.length - 1];
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 3:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            axios_default()({
                                method: "post",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/framework/createFramework"),
                                data: {
                                    docType: extension,
                                    docName: fileNameOriginal1,
                                    docCategory: "png",
                                    docUrl: toSend,
                                    docSize: fileSize
                                },
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(resp) {
                                if (resp.data.code == 200) {
                                    //  console.log(resp);
                                    // window.scrollTo(0, 0);
                                    setSuccessModal1(true);
                                    setTimeout(function() {
                                        setSuccessModal1(false);
                                    }, 1000);
                                    //setShowFileName1(false);
                                    //setLoader(false);
                                    //setFile1(null);
                                    setError(false);
                                //setFileName1(null);
                                //getAllPdfs();
                                } else if (resp.data.code == 403) {
                                    setLoader(false);
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            setLoader(false);
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error, "erro");
                        alert("Could not upload");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadButtonClick1() {
            return _ref.apply(this, arguments);
        };
    }();
    var myDate;
    var ref66 = (0,src_sliced_to_array/* default */.Z)(react.useState(), 2), godate = ref66[0], setGodate = ref66[1];
    var handleDate = function(date, parent) {
        if (typeof date == "object") {
            var bigDate = date._d;
            var dd = String(bigDate.getDate()).padStart(2, "0");
            var mm = String(bigDate.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = bigDate.getFullYear();
            var myDate = mm + "/" + dd + "/" + yyyy;
            //console.log("mydate",myDate);
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, parent, myDate)));
        } else {
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, parent, date)));
        }
        setGodate(date);
    //console.log("golivedate",date);
    };
    var inputprops = {
        placeholder: "DD/MM/YYYY"
    };
    //multiple document		
    var ref67 = (0,react.useState)(false), softdocument = ref67[0], setSoftdocument = ref67[1];
    var submitemptwinForm = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var authCheck, expiryStatus, softdocs, sopDocument, pddDocument, pddApprovalDocument, sddDocument, qsgDocument, odiDocument, brdDocument, costApprovalDocument, explicitLandscapeApplicationOwnerApprovalDocument, explicitGPMApprovalSupplyChainFinanceDocument, explicitGFCFApprovalDocument, devQualityCredentialsAvailableDocument, infosecApprovalDocument, dAReviewSignOffDocument, testDataAvailableForDevelopmentDocument, requestRaisedForProductionCredentialsDocument, internalTestingCompletedDocument, peerReviewSignOffDocument, daReviewSecondSignOffDocument, bpReleaseSignOffFromDaDocument, uatScriptsWithResultsDocument, uatSignOffDocument, releaseManagerSignOffDocument, gateFormDocument, peerReviewchecklistDocument, qaSignOffDocument, walkthroughVideo, ktVideo, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSubmitForm(true);
                        setGetFormValues(true);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        softdocs = JSON.parse(localStorage.getItem("docURL1"));
                        if (!localStorage.getItem("docURL1")) {
                            setSoftdocument(true);
                        }
                        if (localStorage.getItem("docURL1")) {
                            setSoftdocument(false);
                        }
                        sopDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.sopDocument) || "";
                        pddDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.pddDocument) || "";
                        pddApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.pddApprovalDocument) || "";
                        sddDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.sddDocument) || "";
                        qsgDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.qsgDocument) || "";
                        odiDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.odiDocument) || "";
                        brdDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.brdDocument) || "";
                        costApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.costApprovalDocument) || "";
                        explicitLandscapeApplicationOwnerApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.explicitLandscapeApplicationOwnerApprovalDocument) || "";
                        explicitGPMApprovalSupplyChainFinanceDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.explicitGPMApprovalSupplyChainFinanceDocument) || "";
                        explicitGFCFApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.explicitGFCFApprovalDocument) || "";
                        devQualityCredentialsAvailableDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.devQualityCredentialsAvailableDocument) || "";
                        infosecApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.infosecApprovalDocument) || "";
                        dAReviewSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.dAReviewSignOffDocument) || "";
                        testDataAvailableForDevelopmentDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.testDataAvailableForDevelopmentDocument) || "";
                        requestRaisedForProductionCredentialsDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.requestRaisedForProductionCredentialsDocument) || "";
                        internalTestingCompletedDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.internalTestingCompletedDocument) || "";
                        peerReviewSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.peerReviewSignOffDocument) || "";
                        daReviewSecondSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.daReviewSecondSignOffDocument) || "";
                        bpReleaseSignOffFromDaDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.bpReleaseSignOffFromDaDocument) || "";
                        uatScriptsWithResultsDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.uatScriptsWithResultsDocument) || "";
                        uatSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.uatSignOffDocument) || "";
                        releaseManagerSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.releaseManagerSignOffDocument) || "";
                        gateFormDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.gateFormDocument) || "";
                        peerReviewchecklistDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.peerReviewchecklistDocument) || "";
                        qaSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.qaSignOffDocument) || "";
                        walkthroughVideo = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.walkthroughVideo) || "";
                        ktVideo = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.ktVideo) || "";
                        if (!(emptwin1.employeeTwinName == "" || emptwin1.employeeTwinDescription == "" || emptwin1.status == "" || emptwin1.geoItPartner == "" || emptwin1.businessOwner == "" || emptwin1.businessgroup == "" || emptwin1.businessunit == "" || emptwin1.engagementLead == "" || emptwin1.manualhour == "" || emptwin1.fte == "" || leadPlatform == "" || area == "" || subArea == "" || cluster == "" || mco == "" || country == "" || softdocument)) return [
                            3,
                            2
                        ];
                        console.log("Please enter missing");
                        console.log("emptwin1", emptwin1);
                        console.log("leadPlatform", leadPlatform, "area", area, "subArea", subArea, "cluster", cluster, "mco", mco, "country", country, "softdocument", softdocument);
                        return [
                            3,
                            5
                        ];
                    case 2:
                        if (!expiryStatus) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 3:
                        auth = _state.sent();
                        axios_default()({
                            method: "POST",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/employeeTwin"),
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            },
                            data: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, emptwin1), {
                                employeeTwinID: empid,
                                globalSkill: globalvalue.join(","),
                                localSkill: localvalue.join(","),
                                transactions: globalvalue.join(","),
                                reporting: localvalue.join(","),
                                cognitive: cognitivevalue.join(","),
                                decisionautomations: decisionautomationsvalue.join(","),
                                genAi: genAIvalue.join(","),
                                softSkill: items.join(","),
                                product_id: productvalue.join(","),
                                leadPlatform: leadPlatform,
                                area: area,
                                subArea: subArea,
                                cluster: cluster,
                                mco: mco.join(","),
                                country: country.join(","),
                                businessRequest: "".concat(auth.email),
                                uploadPhoto: "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + fileNameOriginal,
                                uploadDocument: "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + fileNameOriginal1,
                                goLiveDate: godate,
                                sopDocument: sopDocument,
                                pddDocument: pddDocument,
                                pddApprovalDocument: pddApprovalDocument,
                                sddDocument: sddDocument,
                                qsgDocument: qsgDocument,
                                odiDocument: odiDocument,
                                brdDocument: brdDocument,
                                costApprovalDocument: costApprovalDocument,
                                explicitLandscapeApplicationOwnerApprovalDocument: explicitLandscapeApplicationOwnerApprovalDocument,
                                explicitGPMApprovalSupplyChainFinanceDocument: explicitGPMApprovalSupplyChainFinanceDocument,
                                explicitGFCFApprovalDocument: explicitGFCFApprovalDocument,
                                devQualityCredentialsAvailableDocument: devQualityCredentialsAvailableDocument,
                                infosecApprovalDocument: infosecApprovalDocument,
                                dAReviewSignOffDocument: dAReviewSignOffDocument,
                                testDataAvailableForDevelopmentDocument: testDataAvailableForDevelopmentDocument,
                                requestRaisedForProductionCredentialsDocument: requestRaisedForProductionCredentialsDocument,
                                internalTestingCompletedDocument: internalTestingCompletedDocument,
                                peerReviewSignOffDocument: peerReviewSignOffDocument,
                                daReviewSecondSignOffDocument: daReviewSecondSignOffDocument,
                                bpReleaseSignOffFromDaDocument: bpReleaseSignOffFromDaDocument,
                                uatScriptsWithResultsDocument: uatScriptsWithResultsDocument,
                                uatSignOffDocument: uatSignOffDocument,
                                releaseManagerSignOffDocument: releaseManagerSignOffDocument,
                                gateFormDocument: gateFormDocument,
                                peerReviewchecklistDocument: peerReviewchecklistDocument,
                                qaSignOffDocument: qaSignOffDocument,
                                walkthroughVideo: walkthroughVideo,
                                ktVideo: ktVideo
                            })
                        }).then(function(resp) {
                            if (resp.data.code == 403) {
                                props.sessionTimeOutCheck(true);
                                setState(initialState);
                                setGetFormValues(false);
                            } else if (resp.status == 200) {
                                // console.log(resp.data);
                                //console.log("data from api---->",resp)
                                localStorage.setItem("empid", JSON.stringify(empid));
                                localStorage.removeItem("myData");
                                // router.push("/Employeetwinskills");
                                router.push("/Employeetwinsdetails?empTwinId=" + "".concat(empid));
                                //setItems(resp.data.data.softSkillID)
                                localStorage.removeItem("docURL1");
                                setState(initialState);
                                setGetFormValues(false);
                            } else if (resp.data.code == 400) {
                                setState(initialState);
                                setGetFormValues(false);
                            }
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        props.sessionTimeOutCheck(true);
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function submitemptwinForm() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref68 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref68[0], setEmptyFormValues = ref68[1];
    var ref69 = (0,src_sliced_to_array/* default */.Z)(react.useState(dropDownsInitialStates), 2), dropDownState1 = ref69[0], setDropdownState1 = ref69[1];
    /*soft skill demo*/ var ref70 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), softSkillModal = ref70[0], setsoftSkillModal = ref70[1];
    var handleDropDown = function(item) {
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownsInitialStates), (0,src_define_property/* default */.Z)({}, item, !dropDownState[item])));
    };
    var gotDropDownValue = function(value, dropdownParent) {
        setDropdownState(dropDownsInitialStates);
        setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, dropdownParent, value)));
    };
    var ref71 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        status: false
    }), 2), dropDownState = ref71[0], setDropdownState = ref71[1];
    var ref72 = (0,react.useState)(), leadState = ref72[0], setLeadState = ref72[1];
    var inputChange = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = e.target.value;
                setLeadState(e.target.value);
                return [
                    2
                ];
            });
        });
        return function inputChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var inputHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data, auth1, data1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        setInputValue1(optionvalue);
                        if (!optionvalue.includes("P")) return [
                            3,
                            3
                        ];
                        if (!productvalue.includes(optionvalue)) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/get_product?product_id=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        console.log(data);
                        if (data.code === 200) {
                            setProductids(data.data);
                            setCheckedP(true);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        if (!(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) || decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            4
                        ];
                        return [
                            3,
                            6
                        ];
                    case 4:
                        auth1 = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/botSearch/globalLocal?botID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth1.accessToken, "|").concat(auth1.email)
                                }
                            })
                        ];
                    case 5:
                        data1 = _state.sent().data;
                        //console.log(data);
                        if (data1.code === 200) {
                            setGlobalskills(data1.data);
                            setChecked(true);
                        //console.log(data.data);
                        //console.log("globalskill update",globalskills);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var inputHandler1 = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        setInputValue(optionvalue);
                        if (!(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) || decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/botSearch/globalLocal?botID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    botID: optionvalue
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setLocalskills(data.data);
                            setCheckedL(true);
                        //console.log(data.data);
                        //console.log("globalskill update",globalskills);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandler1(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //for cognitive skill
    var inputHandlerc = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        setInputValuec(optionvalue);
                        if (!(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) || decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/botSearch/globalLocal?botID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    botID: optionvalue
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        console.log(data);
                        if (data.code === 200) {
                            setCognitiveskills(data.data);
                            setCheckedC(true);
                        // console.log(data.data);
                        //console.log("globalskill update",globalskills);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandlerc(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //for decision automation skill
    var inputHandlerd = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        setInputValued(optionvalue);
                        if (!(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) || decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/botSearch/globalLocal?botID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    botID: optionvalue
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        console.log(data);
                        if (data.code === 200) {
                            setDecisionautomationsskills(data.data);
                            setCheckedD(true);
                        // console.log(data.data);
                        //console.log("globalskill update",globalskills);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandlerd(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //for genAI skills
    var inputHandlerg = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data, auth1, data1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        setInputValueg(optionvalue);
                        console.log("optionvalue", typeof optionvalue === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(optionvalue));
                        console.log("globalvalue", globalvalue);
                        console.log("localvalue", localvalue);
                        console.log("optionvalue", optionvalue);
                        console.log("softskill", softskills);
                        if (!(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) || decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/botSearch/globalLocal?botID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    botID: optionvalue
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        console.log("setGenAISkills", data.data);
                        if (data.code === 200) {
                            setGenAISkills(data.data);
                            setCheckedG(true);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        if (!(optionvalue.startsWith("SS") && !items.includes(optionvalue))) return [
                            3,
                            7
                        ];
                        if (!(items.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            4
                        ];
                        return [
                            3,
                            7
                        ];
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        auth1 = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/softSkill/get?softSkillID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth1.accessToken, "|").concat(auth1.email)
                                },
                                data: {
                                    softSkillID: optionvalue
                                }
                            })
                        ];
                    case 5:
                        data1 = _state.sent().data;
                        if (data1.code === 200) {
                            console.log("skilldata", data1);
                            console.log("softSkillID", data1.data[0].softSkillID);
                            setGenAISkills(data1.data);
                            setCheckedG(true);
                        }
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.log("Error", error);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandlerg(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //for global and transaction skill
    var checkedGlobal = function(e) {
        setChecked(false);
        setInputValue1("");
        setGlobalvalue((0,src_to_consumable_array/* default */.Z)(globalvalue).concat([
            e.target.value
        ]));
    };
    var checkedProduct = function(e) {
        setCheckedP(false);
        setInputValue1("");
        setProductvalue((0,src_to_consumable_array/* default */.Z)(productvalue).concat([
            e.target.value
        ]));
        submitemptwinFormp(e.target.name);
    };
    var submitemptwinFormp = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(prodid) {
            var auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                console.log(prodid);
                auth = JSON.parse(localStorage.getItem("auth")).data;
                axios_default()({
                    method: "POST",
                    url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/store_product"),
                    headers: {
                        Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                    },
                    data: {
                        product_id: prodid
                    }
                }).then(function(resp) {
                    if (resp.data.code == 403) {} else if (resp.status == 200) {
                        console.log("data from api---->", resp);
                    } else if (resp.data.code == 400) {}
                });
                return [
                    2
                ];
            });
        });
        return function submitemptwinFormp(prodid) {
            return _ref.apply(this, arguments);
        };
    }();
    //for reporting and local skill
    var checkedLocal = function(e) {
        setCheckedL(false);
        setLocalvalue((0,src_to_consumable_array/* default */.Z)(localvalue).concat([
            e.target.value
        ]));
        setInputValue("");
    };
    //for cognitive skill
    var checkedCognitive = function(e) {
        setCheckedC(false);
        setInputValuec("");
        setCognitivevalue((0,src_to_consumable_array/* default */.Z)(cognitivevalue).concat([
            e.target.value
        ]));
    };
    //for decisionautomation skill
    var checkedDecision = function(e) {
        setCheckedD(false);
        setInputValued("");
        setDecisionautomationsvalue((0,src_to_consumable_array/* default */.Z)(decisionautomationsvalue).concat([
            e.target.value
        ]));
    };
    //for GenAI  skill
    var checkedGenAI = function(e) {
        setCheckedG(false);
        setInputValueg("");
        setGenAIvalue((0,src_to_consumable_array/* default */.Z)(genAIvalue).concat([
            e.target.value
        ]));
    };
    var deleteByValue = function(item) {
        setGlobalvalue(function(oldValues) {
            return oldValues.filter(function(globalvalue) {
                return globalvalue !== item;
            });
        });
        setLocalvalue(function(oldValues) {
            return oldValues.filter(function(localvalue) {
                return localvalue !== item;
            });
        });
        setSkillvalue(function(oldValues) {
            return oldValues.filter(function(skillvalue) {
                return skillvalue !== item;
            });
        });
        setProductvalue(function(oldValues) {
            return oldValues.filter(function(productvalue) {
                return productvalue !== item;
            });
        });
        setCognitivevalue(function(oldValues) {
            return oldValues.filter(function(cognitivevalue) {
                return cognitivevalue !== item;
            });
        });
        setDecisionautomationsvalue(function(oldValues) {
            return oldValues.filter(function(decisionautomationsvalue) {
                return decisionautomationsvalue !== item;
            });
        });
        setGenAIvalue(function(oldValues) {
            return oldValues.filter(function(genAIvalue) {
                return genAIvalue !== item;
            });
        });
    };
    var deleteByValue1 = function(index) {
        var storedArray = JSON.parse(localStorage.getItem("myData"));
        storedArray.splice(index, 1);
        localStorage.setItem("myData", JSON.stringify(storedArray));
        setSkillvalue(storedArray);
    // if (storedArray) {
    //   setSkillvalue(storedArray);
    // }
    // setSkillvalue(oldValues => {
    //   return oldValues.filter(skillvalue => skillvalue !== item)
    // })
    };
    react.useEffect(function() {
        var emailCheckAr = [];
        var numberCheckAr = [];
        var requiredFields = [];
        setEmailCheck((0,src_to_consumable_array/* default */.Z)(emailCheckAr));
        setNumberCheck((0,src_to_consumable_array/* default */.Z)(numberCheckAr));
    }, []);
    {}
    var ref73 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref73[0], setState = ref73[1];
    react.useEffect(function() {}, [
        state
    ]);
    react.useEffect(function() {
        var auth = JSON.parse(localStorage.getItem("auth")).data;
        axios_default()({
            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/employeeTwin"),
            method: "POST",
            headers: {
                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
            },
            data: (0,src_object_spread/* default */.Z)({}, emptwin)
        }).then(function(resp) {
            //console.log(resp);
            setEmpid(resp.data.data.employeeTwinID);
            localStorage.removeItem("myData");
        });
    }, []);
    react.useEffect(function() {
        //console.log("dropdown data at line 395",state);
        var storedArray = JSON.parse(localStorage.getItem("myData"));
        if (storedArray) {
            setSkillvalue(storedArray);
        }
    }, []);
    var ref74 = (0,react.useState)([]), softskills = ref74[0], setSoftskills = ref74[1];
    var inputHandlers = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        if (!items.includes(optionvalue)) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/softSkill/get?softSkillID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    softSkillID: optionvalue
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setSoftskills(data.data);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        setCheckedS(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandlers(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var ssid;
    var softidfrommodal = function(skillid) {
        ssid = skillid;
        console.log(ssid);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (createemptwin_module_default()).mainContain,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((createemptwin_module_default()).formContainer),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: (createemptwin_module_default()).head,
                                    children: "Create a New Twin"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (createemptwin_module_default()).text,
                                    children: "Enter all details in the form below to create a Employee Twin."
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((createemptwin_module_default()).inputGroupWrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((createemptwin_module_default()).Group, " container"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-12 col-md-12 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[0].component.content, "field_label", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()),
                                            children: get_default()(emptwinForm[0].component.content, "field_options", []).map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (createemptwin_module_default()).radioWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (createemptwin_module_default()).subLabel,
                                                            children: item
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "radio",
                                                            className: (createemptwin_module_default()).radioBox,
                                                            name: "requestType",
                                                            value: item,
                                                            checked: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (createemptwin_module_default()).radioCheckmark
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (createemptwin_module_default()).mainLabel,
                                                    children: [
                                                        get_default()(emptwinForm[1].component.content, "field_form_field_title", ""),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                            className: (createemptwin_module_default()).mandatoryField,
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                invalidFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (createemptwin_module_default()).errorMessage,
                                                    children: get_default()(emptwinForm[1].component.content, "field_message_ip_error_message", "")
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "employeeTwinID",
                                            id: "employeeTwinID",
                                            readOnly: true,
                                            value: empid
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[2].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? emptwin1.employeeTwinName == "" && emptwin1.employeeTwinName.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[2].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "employeeTwinName",
                                            id: "employeeTwinName",
                                            onChange: onValueChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-12 col-md-12 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[3].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? emptwin1.employeeTwinDescription == "" && emptwin1.employeeTwinDescription.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[3].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                            className: "".concat(invalidFlag ? (createemptwin_module_default()).errorBorder : null),
                                            name: "employeeTwinDescription",
                                            id: "employeeTwinDescription",
                                            onChange: onValueChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((createemptwin_module_default()).uploadBtnWrapper),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (createemptwin_module_default()).uploadFileContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (createemptwin_module_default()).mainLabel,
                                                    children: [
                                                        get_default()(emptwinForm[4].component.content, "field_title", ""),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                            className: (createemptwin_module_default()).mandatoryField,
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (createemptwin_module_default()).uploadControl,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(uploadFileemptwin/* default */.Z, {
                                                            type: "frameworkss",
                                                            fileType: fileTypesp,
                                                            uploadFile: uploadFile,
                                                            uploaded: showFileName,
                                                            value: "frameworkDocumentss"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (createemptwin_module_default()).actionBtn,
                                                            onClick: uploadButtonClick,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                        name: "uploadicon",
                                                                        className: (createemptwin_module_default()).uploadIcon
                                                                    }),
                                                                    "Upload File"
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[5].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? emptwin1.status == "" && emptwin1.status.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[5].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: (createemptwin_module_default()).select,
                                            onChange: onValueChange,
                                            name: "status",
                                            id: "status",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    defaultValue: true,
                                                    children: [
                                                        " ",
                                                        get_default()(emptwinForm[5].component.content, "field_form_field_title", "")
                                                    ]
                                                }),
                                                get_default()(emptwinForm[5].component.content, "field_options", []).map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item,
                                                        children: item
                                                    }, index);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(basicemptwinForm1, {
                                data: filterDropdowns,
                                sendFormValues: recievedFormValues,
                                getFormValues: getFormValues,
                                emptyFormValues: emptyFormValues,
                                params: "emptwin",
                                formType: "emptwin",
                                pass_GetData: GetData,
                                reset: reset,
                                setreset: setreset,
                                notRequired: []
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[6].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? emptwin1.geoItPartner == "" && emptwin1.geoItPartner.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[6].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "geoItPartner",
                                            id: "geoItPartner",
                                            onChange: onValueChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[7].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? emptwin1.businessOwner == "" && emptwin1.businessOwner.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[7].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "businessOwner",
                                            id: "businessOwner",
                                            onChange: onValueChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[8].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? emptwin1.engagementLead == "" && emptwin1.engagementLead.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[8].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: (createemptwin_module_default()).select,
                                            id: "engagementLead",
                                            name: "engagementLead",
                                            onChange: onValueChange,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    defaultValue: true,
                                                    children: [
                                                        " ",
                                                        get_default()(emptwinForm[8].component.content, "field_form_field_title", "")
                                                    ]
                                                }),
                                                get_default()(emptwinForm[8].component.content, "field_options", []).map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item,
                                                        children: item
                                                    }, index);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[18].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            onChange: function(e) {
                                                inputHandler(e);
                                            },
                                            placeholder: "Search Transactions skill",
                                            value: inputValue1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            id: "transactionsskill",
                                            name: "transactionsskill",
                                            value: globalvalue
                                        }),
                                        checked ? globalskills.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        value: item.botExternalId,
                                                        onChange: function(e) {
                                                            checkedGlobal(e);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).lableHead,
                                                        children: item.processName
                                                    })
                                                ]
                                            });
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: globalvalue.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue(item);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[19].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            onChange: function(e) {
                                                inputHandler1(e);
                                            },
                                            placeholder: "Search Reporting skill",
                                            value: inputValue
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "reportingskill",
                                            id: "reportingskill",
                                            value: localvalue
                                        }),
                                        checkedL ? localskills.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        value: item.botExternalId,
                                                        onChange: function(e) {
                                                            checkedLocal(e);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).lableHead,
                                                        children: item.processName
                                                    })
                                                ]
                                            });
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: localvalue.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue(item);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[20].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            onChange: function(e) {
                                                inputHandlerc(e);
                                            },
                                            placeholder: "Search Cognitive skill",
                                            value: inputValuec
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            id: "cognitiveskill",
                                            name: "cognitiveskill",
                                            value: cognitivevalue
                                        }),
                                        checkedC ? cognitiveskills.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        value: item.botExternalId,
                                                        onChange: function(e) {
                                                            checkedCognitive(e);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).lableHead,
                                                        children: item.processName
                                                    })
                                                ]
                                            });
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: cognitivevalue.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue(item);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[21].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            onChange: function(e) {
                                                inputHandlerd(e);
                                            },
                                            placeholder: "Search Decision Automations skill",
                                            value: inputValued
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "decisionAutomationsskill",
                                            id: "decisionAutomationsskill",
                                            value: decisionautomationsvalue
                                        }),
                                        checkedD ? decisionautomationsskills.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        value: item.botExternalId,
                                                        onChange: function(e) {
                                                            checkedDecision(e);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).lableHead,
                                                        children: item.processName
                                                    })
                                                ]
                                            });
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: decisionautomationsvalue.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue(item);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[22].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            onChange: function(e) {
                                                inputHandlerg(e);
                                            },
                                            placeholder: "Search Gen AI...",
                                            value: inputValueg
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "genAI",
                                            id: "genAI",
                                            value: genAIvalue
                                        }),
                                        checkedG ? genAISkills.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()),
                                                children: [
                                                    console.log("selected item", item.botExternalId),
                                                    console.log("selected item", item.softSkillID),
                                                    console.log("selectedItem", item.processName),
                                                    console.log("selectedItem", item.skillName),
                                                    item.botExternalId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                value: item.botExternalId,
                                                                onChange: function(e) {
                                                                    checkedGenAI(e);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createemptwin_module_default()).lableHead,
                                                                children: item.processName
                                                            })
                                                        ]
                                                    }),
                                                    item.softSkillID && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                value: item.softSkillID,
                                                                onChange: function(e) {
                                                                    checkedGenAI(e);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createemptwin_module_default()).lableHead,
                                                                children: item.skillName
                                                            })
                                                        ]
                                                    })
                                                ]
                                            });
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: genAIvalue.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue(item);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[23].component.content, "field_form_field_title", ""),
                                                    submitForm ? emptwin1.securityGroupId == "" && emptwin1.securityGroupId.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[2].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "securityGroupId",
                                            id: "securityGroupId",
                                            onChange: onValueChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[11].component.content, "field_form_field_title", ""),
                                                    submitForm ? !items == "" && items.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[11].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    className: (createemptwin_module_default()).inputtext,
                                                    placeholder: "Search Soft skill",
                                                    onChange: function(e) {
                                                        inputHandlers(e);
                                                    }
                                                }),
                                                checkedS ? softskills.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (createemptwin_module_default()),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                value: item.softSkillID,
                                                                onChange: function(e) {
                                                                    checkedSoft(e);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createemptwin_module_default()).lableHead,
                                                                children: item.skillName
                                                            })
                                                        ]
                                                    });
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "".concat((createemptwin_module_default()).button, " ").concat((createemptwin_module_default()).softskillAdd),
                                            onClick: function() {
                                                openpopup();
                                            },
                                            children: "Add"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "softskill",
                                            id: "softskill",
                                            value: items
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: items.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue1(index);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((createemptwin_module_default()).uploadBtnWrapper),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (createemptwin_module_default()).uploadFileContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (createemptwin_module_default()).mainLabel,
                                                    children: [
                                                        get_default()(emptwinForm[12].component.content, "field_title", ""),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                            className: (createemptwin_module_default()).mandatoryField,
                                                            children: "*"
                                                        }),
                                                        submitForm ? softdocument ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (createemptwin_module_default()).errorMessage,
                                                            children: "Please upload SOP Document"
                                                        }) : null : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (createemptwin_module_default()).uploadControl,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (createemptwin_module_default()).multiDocsWrapper,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createemptwin_module_default()).skillMultiDocs,
                                                                onClick: openDocumentModal,
                                                                children: "Open Document Uploader"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createemptwin_module_default()).text
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[13].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? emptwin1.manualhour == "" && emptwin1.manualhour.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[13].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "number",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "manualhour",
                                            id: "manualhour",
                                            onChange: onValueChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[14].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? emptwin1.fte == "" && emptwin1.fte.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[14].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "number",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "fte",
                                            id: "fte",
                                            onChange: onValueChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[15].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? emptwin1.businessgroup == "" && emptwin1.businessgroup.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[15].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: (createemptwin_module_default()).select,
                                            id: "businessgroup",
                                            name: "businessgroup",
                                            onChange: onValueChange,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    defaultValue: true,
                                                    children: [
                                                        " ",
                                                        get_default()(emptwinForm[15].component.content, "field_form_field_title", "")
                                                    ]
                                                }),
                                                get_default()(emptwinForm[15].component.content, "field_options", []).map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item,
                                                        children: item
                                                    }, index);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[16].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? emptwin1.businessunit == "" && emptwin1.businessunit.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: get_default()(emptwinForm[16].component.content, "field_message_ip_error_message", "")
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: (createemptwin_module_default()).select,
                                            id: "businessunit",
                                            name: "businessunit",
                                            onChange: onValueChange,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    defaultValue: true,
                                                    children: [
                                                        " ",
                                                        get_default()(emptwinForm[16].component.content, "field_form_field_title", "")
                                                    ]
                                                }),
                                                get_default()(emptwinForm[16].component.content, "field_options", []).map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item,
                                                        children: item
                                                    }, index);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            emptwin.businessunit != "Global" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: "Business Group Unit"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: (createemptwin_module_default()).select,
                                            id: "businessoption",
                                            name: "businessoption",
                                            onChange: onValueChange,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    defaultValue: true,
                                                    children: " Choose Business Option"
                                                }),
                                                emptwin.businessgroup == "Beauty & Wellbeing" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Health & Wellness",
                                                    children: "Health & Wellness "
                                                }) : null,
                                                emptwin.businessgroup == "Beauty & Wellbeing" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Prestige",
                                                    children: "Prestige "
                                                }) : null,
                                                emptwin.businessgroup == "Personal Care" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Dollar Shave Club",
                                                    children: "Dollar Shave Club"
                                                }) : null,
                                                emptwin.businessgroup == "Personal Care" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Elida Beauty",
                                                    children: "Elida Beauty"
                                                }) : null,
                                                emptwin.businessgroup == "Home Care" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Water and Air Wellness",
                                                    children: "Water and Air Wellness"
                                                }) : null,
                                                emptwin.businessgroup == "Nutrition" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Unilever Food Solutions",
                                                    children: "Unilever Food Solutions"
                                                }) : null,
                                                emptwin.businessgroup == "Ice Cream" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Ice Cream",
                                                    children: "Ice Cream"
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    "Go Live date",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    }),
                                                    submitForm ? myDate == "" && myDate.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).errorMessage,
                                                        children: "Go Live date is mandatory"
                                                    }) : null : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datetime_cjs_default()), {
                                            timeFormat: false,
                                            className: "".concat((createemptwin_module_default()).calender, "  ").concat((createemptwin_module_default()).errorBorder),
                                            inputProps: inputprops,
                                            onChange: function(date) {
                                                return handleDate(date, "goLiveDate");
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 ".concat(emptwin.businessunit != "Global" ? "col-12" : "col-lg-12 ".concat((createemptwin_module_default()).businessGroupUnit)),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (createemptwin_module_default()).submitbtn,
                                        onClick: submitemptwinForm,
                                        children: "Submit"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            softSkillModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SoftSkill/* default */.Z, {
                data: props.softskill.data.field_component,
                closeModal: function() {
                    setsoftSkillModal(false);
                },
                setSuccessModal: setSuccessModal,
                setMessage: setMessage,
                setsucessOrFailure: setsucessOrFailure,
                empid: empid,
                name: "empskillpage",
                softidfrommodal: softidfrommodal
            }) : null,
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: setSuccessModal,
                title: "Soft Skill",
                message: message,
                fail: sucessOrFailure
            }) : null,
            successModal1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: function() {
                    setSuccessModal(false);
                    setFileNameError(false);
                },
                title: "Framework",
                message: filenameError ? "Document with this name already exists." : "uploaded",
                fail: filenameError ? true : false
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (createemptwin_module_default()).uploadContainer,
                children: modalShow == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentETUploader, {
                    closeModal: closeDocumentModal,
                    sendDocInfo: gotDocInfo,
                    sendAllInfoAboutUploadModal: sendAllInfoAboutUploadModal,
                    uploadedDocumentsState: uploadedDocumentsState,
                    formType: fileTypes,
                    documentFolderName: "emp",
                    softSkillDoc: "softSkillDocState",
                    setSopInvalid: setSopInvalid
                }) : null
            })
        ]
    });
}
var CreateEmployeeTwin_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function CreateEmployeeTwin_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var CreateEmployeeTwin = ((0,es/* connect */.$j)(CreateEmployeeTwin_mapStateToProps, CreateEmployeeTwin_mapDispatchToProps)(CreateEmployeeTwin_index));

// EXTERNAL MODULE: ./components/listDropdown/index.jsx
var listDropdown = __webpack_require__(71554);
;// CONCATENATED MODULE: ./components/EditEmployeeTwin/index.jsx
















//import UploadDocuments from "../uploadDocuments";






//import BasicForm from "../basicemptwinForm";










//multiple document			

function EditEmployeeTwin_index(props) {
    var openpopup = //console.log("line number 64",leadState);
    /*end upload file code*/ function openpopup() {
        var modal = !softSkillModal;
        setsoftSkillModal(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var alphanumric = function alphanumric(val) {
        var re = /^[a-z][a-zA-Z0-9_]*$/;
        if (re.test(String(val))) {
            return true;
        } else {
            return false;
        }
    // return re.test(String(email).toLowerCase());
    };
    var camelize = function camelize(str) {
    // return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    //     return index === 0 ? word.toLowerCase() : word.toUpperCase();
    //   })
    //   .replace(/\s+/g, "");
    };
    var router = (0,next_router.useRouter)();
    var emptwinForm = props.data;
    // console.log("edit page data",emptwinForm);
    var empid = JSON.parse(localStorage.getItem("empid"));
    //console.log(empid)
    var dropDownsInitialStates = {};
    /*lead platform, area, subarea code*/ var leadPlatformData = props.globalData.lead_platform_main_component[0];
    var areaData = props.globalData.lead_platform_main_component[1];
    var subAreaData = props.globalData.lead_platform_main_component[2];
    var clusterData = props.globalData.cluster_main_component[0];
    var mcoData = props.globalData.cluster_main_component[1];
    var countryData = props.globalData.cluster_main_component[2];
    var ref = (0,react.useState)([
        props.globalData.lead_platform_main_component[0],
        props.globalData.lead_platform_main_component[1],
        props.globalData.lead_platform_main_component[2],
        props.globalData.cluster_main_component[0],
        props.globalData.cluster_main_component[1],
        props.globalData.cluster_main_component[2]
    ]), filterDropdowns = ref[0], setFiltersDropdowns = ref[1];
    /*end lead platform, area, subarea code*/ // console.log("Emptwin form data  ----", emptwinForm);
    var ref1 = (0,react.useState)(false), fileError = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(null), file = ref2[0], setFile = ref2[1];
    var ref3 = (0,react.useState)(null), file1 = ref3[0], setFile1 = ref3[1];
    var ref4 = (0,react.useState)(null), fileNameOriginal = ref4[0], setFileName = ref4[1];
    var ref5 = (0,react.useState)(null), fileNameOriginal1 = ref5[0], setFileName1 = ref5[1];
    var ref6 = (0,react.useState)(false), showFileName = ref6[0], setShowFileName = ref6[1];
    var ref7 = (0,react.useState)(false), showFileName1 = ref7[0], setShowFileName1 = ref7[1];
    var ref8 = (0,react.useState)([]), automationPdfs = ref8[0], setAutomationPdfs = ref8[1];
    var ref9 = (0,react.useState)([]), confidentialPdfs = ref9[0], setConfidentialPdfs = ref9[1];
    var ref10 = (0,react.useState)(null), logoFile = ref10[0], setLogoFile = ref10[1];
    var ref11 = (0,react.useState)(false), fileerror = ref11[0], setFileError = ref11[1];
    var ref12 = (0,react.useState)(false), filesuccess = ref12[0], setFilesuccess = ref12[1];
    // const [imageName,setImageName]=useState(null)
    var handleFileChange = function(event) {
        var file = event.target.files[0];
        //setLogoFile(file.name);
        uploadFiles(file);
    };
    console.log("logofile", logoFile);
    var uploadFiles = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(imageFile) {
            var originalFileName, fileName, _$index, extension, blockBlobClient, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        originalFileName = imageFile.name;
                        fileName = originalFileName;
                        setLogoFile("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + fileName);
                        _$index = 1;
                        _state.label = 1;
                    case 1:
                        return [
                            4,
                            containerClient.getBlockBlobClient(fileName).exists()
                        ];
                    case 2:
                        if (!_state.sent()) return [
                            3,
                            3
                        ];
                        {
                            extension = originalFileName.substring(originalFileName.lastIndexOf("."));
                            fileName = "".concat(originalFileName.substring(0, originalFileName.lastIndexOf(".")), "_").concat(_$index).concat(extension);
                            _$index++;
                        }
                        return [
                            3,
                            1
                        ];
                    case 3:
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(imageFile)
                        ];
                    case 5:
                        _state.sent();
                        console.log("Image uploaded successfully!");
                        setLogoFile("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + fileName);
                        setFilesuccess(true);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        setFileError(true);
                        console.error("Error uploading image:", error);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadFiles(imageFile) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref13 = (0,react.useState)(false), filenameError = ref13[0], setFileNameError = ref13[1];
    var ref14 = (0,react.useState)([
        "pdf",
        "docx",
        "doc",
        "xlsx",
        "ppt",
        "pptx",
        "mp4"
    ]), fileTypes = ref14[0], setfileTypes = ref14[1];
    var ref15 = (0,react.useState)([
        "jpg",
        "jpeg",
        "png", 
    ]), fileTypesp = ref15[0], setfileTypesp = ref15[1];
    var ref16 = (0,react.useState)({}), auth = ref16[0], setAuth = ref16[1];
    var initialStates = {};
    var initialState = {
        "newRequest": "new",
        "employeeTwinID": "",
        "employeeTwinName": "",
        "securityGroupId": "",
        "employeeTwinDescription": "",
        "status": "",
        "leadPlatform": "",
        "area": "",
        "subArea": "",
        "cluster": "",
        "mco": "",
        "geoItPartner": "",
        "country": "",
        "businessOwner": "",
        "engagementLead": "",
        "globalSkill": "",
        "localSkill": "",
        "softSkill": "",
        "manualhour": "",
        "fte": "",
        "businessRequest": "",
        "uploadPhoto": "",
        "uploadDocument": "",
        "businessgroup": "",
        "businessunit": "",
        "businessoption": "",
        "goLiveDate": "",
        "product_id": "",
        "sopDocument": "",
        "pddDocument": "",
        "pddApprovalDocument": "",
        "sddDocument": "",
        "qsgDocument": "",
        "odiDocument": "",
        "brdDocument": "",
        "costApprovalDocument": "",
        "explicitLandscapeApplicationOwnerApprovalDocument": "",
        "explicitGPMApprovalSupplyChainFinanceDocument": "",
        "explicitGFCFApprovalDocument": "",
        "devQualityCredentialsAvailableDocument": "",
        "infosecApprovalDocument": "",
        "dAReviewSignOffDocument": "",
        "testDataAvailableForDevelopmentDocument": "",
        "requestRaisedForProductionCredentialsDocument": "",
        "internalTestingCompletedDocument": "",
        "peerReviewSignOffDocument": "",
        "daReviewSecondSignOffDocument": "",
        "bpReleaseSignOffFromDaDocument": "",
        "uatScriptsWithResultsDocument": "",
        "uatSignOffDocument": "",
        "releaseManagerSignOffDocument": "",
        "gateFormDocument": "",
        "peerReviewchecklistDocument": "",
        "qaSignOffDocument": "",
        "walkthroughVideo": "",
        "ktVideo": "",
        "transactions": "",
        "reporting": "",
        "cognitive": "",
        "decisionautomations": "",
        "genAi": ""
    };
    var initialState1 = {
        "newRequest": "new",
        "employeeTwinName": "",
        "securityGroupId": "",
        "employeeTwinDescription": "",
        "uploadPhoto": "",
        "status": "",
        "geoItPartner": "",
        "businessOwner": "",
        "engagementLead": "",
        "manualhour": "",
        "fte": "",
        "uploadDocument": "",
        "businessgroup": "",
        "businessunit": "",
        "businessoption": "",
        "product_id": "",
        "sopDocument": "",
        "pddDocument": "",
        "pddApprovalDocument": "",
        "sddDocument": "",
        "qsgDocument": "",
        "odiDocument": "",
        "brdDocument": "",
        "costApprovalDocument": "",
        "explicitLandscapeApplicationOwnerApprovalDocument": "",
        "explicitGPMApprovalSupplyChainFinanceDocument": "",
        "explicitGFCFApprovalDocument": "",
        "devQualityCredentialsAvailableDocument": "",
        "infosecApprovalDocument": "",
        "dAReviewSignOffDocument": "",
        "testDataAvailableForDevelopmentDocument": "",
        "requestRaisedForProductionCredentialsDocument": "",
        "internalTestingCompletedDocument": "",
        "peerReviewSignOffDocument": "",
        "daReviewSecondSignOffDocument": "",
        "bpReleaseSignOffFromDaDocument": "",
        "uatScriptsWithResultsDocument": "",
        "uatSignOffDocument": "",
        "releaseManagerSignOffDocument": "",
        "gateFormDocument": "",
        "peerReviewchecklistDocument": "",
        "qaSignOffDocument": "",
        "walkthroughVideo": "",
        "ktVideo": ""
    };
    var ref17 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), sopInvalid = ref17[0], setSopInvalid = ref17[1];
    //multiple document			
    var ref18 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), modalShow = ref18[0], setModalShow = ref18[1];
    var ref19 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), uploadedDocumentsState = ref19[0], setUploadedDocumentsState = ref19[1];
    var ref20 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), uploadedFileToShow = ref20[0], setUploadedFileToShow = ref20[1];
    var ref21 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), totalUploadedItems = ref21[0], setTotalUploadedItems = ref21[1];
    var ref22 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialState), 2), emptwin = ref22[0], setEmptwin = ref22[1];
    var ref23 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialState1), 2), emptwin1 = ref23[0], setEmptwin1 = ref23[1];
    var ref24 = (0,react.useState)(""), childData = ref24[0], setChildData = ref24[1];
    var ref25 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), emailCheck = ref25[0], setEmailCheck = ref25[1];
    var ref26 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), requiredFields = ref26[0], setRequiredFields = ref26[1];
    var ref27 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), numberCheck = ref27[0], setNumberCheck = ref27[1];
    var ref28 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref28[0], setInvalidFlag = ref28[1];
    var ref29 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref29[0], setSuccessModal = ref29[1];
    var ref30 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal1 = ref30[0], setSuccessModal1 = ref30[1];
    var ref31 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal2 = ref31[0], setSuccessModal2 = ref31[1];
    var ref32 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), sucessOrFailure = ref32[0], setsucessOrFailure = ref32[1];
    var ref33 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref33[0], setGetFormValues = ref33[1];
    var ref34 = (0,src_sliced_to_array/* default */.Z)(react.useState("We added soft skill"), 2), message = ref34[0], setMessage = ref34[1];
    /*Upload file code */ var ref35 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref35[0], setSubmitForm = ref35[1];
    //for transactional and global skill
    var ref36 = (0,react.useState)([]), globalskills = ref36[0], setGlobalskills = ref36[1];
    var ref37 = (0,react.useState)([]), globalvalue = ref37[0], setGlobalvalue = ref37[1];
    var ref38 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checked = ref38[0], setChecked = ref38[1];
    //for reporting and local skill
    var ref39 = (0,react.useState)([]), localskills = ref39[0], setLocalskills = ref39[1];
    var ref40 = (0,react.useState)([]), localvalue = ref40[0], setLocalvalue = ref40[1];
    var ref41 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedL = ref41[0], setCheckedL = ref41[1];
    //for cognitive skill
    var ref42 = (0,react.useState)([]), cognitiveskills = ref42[0], setCognitiveskills = ref42[1];
    var ref43 = (0,react.useState)([]), cognitivevalue = ref43[0], setCognitivevalue = ref43[1];
    var ref44 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedC = ref44[0], setCheckedC = ref44[1];
    //for decisionautomations skill
    var ref45 = (0,react.useState)([]), decisionautomationsskills = ref45[0], setDecisionautomationsskills = ref45[1];
    var ref46 = (0,react.useState)([]), decisionautomationsvalue = ref46[0], setDecisionautomationsvalue = ref46[1];
    var ref47 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedD = ref47[0], setCheckedD = ref47[1];
    // for genAI Skills
    var ref48 = (0,react.useState)([]), genAISkills = ref48[0], setGenAISkills = ref48[1];
    var ref49 = (0,react.useState)([]), genAIvalue = ref49[0], setGenAIvalue = ref49[1];
    var ref50 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedG = ref50[0], setCheckedG = ref50[1];
    //for gen AI skills search
    var ref51 = (0,react.useState)(""), inputValueg = ref51[0], setInputValueg = ref51[1];
    var ref52 = (0,react.useState)(""), inputValue = ref52[0], setInputValue = ref52[1];
    var ref53 = (0,react.useState)(""), inputValue1 = ref53[0], setInputValue1 = ref53[1];
    //for cognitive skill search
    var ref54 = (0,react.useState)(""), inputValuec = ref54[0], setInputValuec = ref54[1];
    //for decisionautomation skill search
    var ref55 = (0,react.useState)(""), inputValued = ref55[0], setInputValued = ref55[1];
    var ref56 = (0,react.useState)([]), skillvalue = ref56[0], setSkillvalue = ref56[1];
    var ref57 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedS = ref57[0], setCheckedS = ref57[1];
    var ref58 = (0,react.useState)([]), products = ref58[0], setProducts = ref58[1];
    var ref59 = (0,react.useState)([]), productids = ref59[0], setProductids = ref59[1];
    var ref60 = (0,react.useState)([]), productvalue = ref60[0], setProductvalue = ref60[1];
    var ref61 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), checkedP = ref61[0], setCheckedP = ref61[1];
    var items;
    var sid;
    var checkedSoft = function(e) {
        sid = e.target.value;
        if (items.includes(sid)) {} else {
            items.push(sid);
            localStorage.setItem("myData", JSON.stringify(items));
        }
        setCheckedS(false);
    };
    items = JSON.parse(localStorage.getItem("myData")) || [];
    //  const items = JSON.parse(localStorage.getItem('myData')) || [];
    /*Dropdown Added by Anshu*/ var ref62 = (0,react.useState)(false), reset = ref62[0], setreset = ref62[1];
    var ref63 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), leadPlatform = ref63[0], setLeadPlatform = ref63[1];
    var ref64 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), area = ref64[0], setArea = ref64[1];
    var ref65 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), subArea = ref65[0], setSubArea = ref65[1];
    var ref66 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), cluster = ref66[0], setCluster = ref66[1];
    var ref67 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), mco = ref67[0], setMco = ref67[1];
    var ref68 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), country = ref68[0], setCuntry = ref68[1];
    /*code for dropdown select*/ var ref69 = (0,react.useState)([]), selectedOptions = ref69[0], setSelectedOptions = ref69[1];
    var ref70 = (0,react.useState)(false), toggle = ref70[0], setToggle = ref70[1];
    var ref71 = (0,react.useState)([]), selectedcountryOptions = ref71[0], setSelectedcountryOptions = ref71[1];
    var ref72 = (0,react.useState)(false), togglen = ref72[0], setTogglen = ref72[1];
    var ref73 = (0,react.useState)(false), loader = ref73[0], setloader = ref73[1];
    var handleSelect = function(e) {
        var value = e.target.value;
        setEmptwin((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, emptwin), (0,src_define_property/* default */.Z)({}, e.target.id, value)));
        if (selectedOptions.includes(value)) {
            setSelectedOptions(selectedOptions.filter(function(option) {
                return option !== value;
            }));
        } else {
            setSelectedOptions((0,src_to_consumable_array/* default */.Z)(selectedOptions).concat([
                value
            ]));
        }
    };
    var handleSelectcountry = function(e) {
        var value = e.target.value;
        setEmptwin((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, emptwin), (0,src_define_property/* default */.Z)({}, e.target.id, value)));
        if (selectedcountryOptions.includes(value)) {
            setSelectedcountryOptions(selectedcountryOptions.filter(function(option) {
                return option !== value;
            }));
        } else {
            setSelectedcountryOptions((0,src_to_consumable_array/* default */.Z)(selectedcountryOptions).concat([
                value
            ]));
        }
    };
    //console.log("country selected value",selectedcountryOptions);
    var GetData = function(recive) {
        // function code here
        // console.log("recive" , recive.leadPlatform)
        setLeadPlatform(recive.leadPlatform);
        setArea(recive.area);
        setSubArea(recive.subArea);
        setCluster(recive.cluster);
        setMco(recive.mco);
        setCuntry(recive.country);
    };
    var onToggle = function() {
        setToggle(true);
    };
    var onTogglen = function() {
        setTogglen(true);
    };
    var onValueChange = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = e.target.value;
                if (e.target.id == "cluster") {
                    setSelectedOptions([]);
                    setSelectedcountryOptions([]);
                }
                setEmptwin((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, emptwin), (0,src_define_property/* default */.Z)({}, e.target.id, value)));
                setEmptwin1((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, emptwin1), (0,src_define_property/* default */.Z)({}, e.target.id, value)));
                return [
                    2
                ];
            });
        });
        return function onValueChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    // if (e.target.value) {
    //   setStateError({ ...stateError, [e.target.id]: "valid" });
    // } 
    // else {
    //   setStateError({ ...stateError, [e.target.id]: true });
    // }
    //multiple document			
    var gotDocInfo = function(name, url, title, uploadedItems, extension) {
        var ar = url.split("?");
        var another = ar[0].split("/");
        var toSend = another[another.length - 1];
        // console.log(title, uploadedItems, "uploaded data of data");			
        // console.log(name, "nameat uploaderrr", title)			
        console.log(extension, "extension at 56");
        //  setUploadedFileToShow(title);			
        setTotalUploadedItems(uploadedItems);
        sendDocInfo(name, toSend, extension);
    };
    var sendAllInfoAboutUploadModal = function(uploaded, totalItems, uploadedItems, originalFileNames, azureFileNames, deleteDocumentsLater, presentState) {
        if (uploaded.sopDocument) {
            setSopInvalid(false);
        } else {
            setSopInvalid(true);
        }
        console.log("sab console kara lo", uploaded, "1", totalItems, "22", uploadedItems, "33", originalFileNames, "44", azureFileNames, "555", deleteDocumentsLater, "6666", presentState);
        //setUploadedFileToShow(documentAr.filter((item) => item.value === Object.keys(presentState)[Object.keys(presentState).length-1])[0].title)			
        console.log(azureFileNames, "azurefiles234latest");
        console.log(uploadedDocumentsState, "azurefiles234previous");
        var deleteDocumentsLaterToSet = [];
        if (uploadedDocumentsState && uploadedDocumentsState.deleteDocumentsLater && uploadedDocumentsState.deleteDocumentsLater.length > 0) {
            deleteDocumentsLaterToSet = (0,src_to_consumable_array/* default */.Z)(uploadedDocumentsState.deleteDocumentsLater);
            for(var i in uploadedDocumentsState.azureFileNames){
                if (!(i in azureFileNames)) {
                    deleteDocumentsLaterToSet.push(uploadedDocumentsState.azureFileNames[i]);
                }
            }
        }
        setUploadedDocumentsState({
            uploaded: uploaded,
            totalItems: totalItems,
            uploadedItems: uploadedItems,
            originalFileNames: originalFileNames,
            azureFileNames: (0,src_object_spread/* default */.Z)({}, azureFileNames),
            deleteDocumentsLater: (0,src_to_consumable_array/* default */.Z)(deleteDocumentsLaterToSet)
        });
        setTotalUploadedItems(uploadedItems);
    };
    var openDocumentModal = function() {
        var modal = !modalShow;
        setModalShow(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var closeDocumentModal = function() {
        var modal = !modalShow;
        setModalShow(false);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var azurefilepath;
    var blobSasUrl = "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
    var blobSasUrlNew = utility_endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    // "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin/emp");
    var uploadFile = function(file, name) {
        azurefilepath = "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + file.name;
        //console.log("azure file path",azurefilepath)
        //console.log(automationPdfs, "pdfsauto");
        if (automationPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0 || confidentialPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0) {
            setFileNameError(true);
            //setSuccessModal(true);
            return;
        }
        setFile(file);
        setShowFileName(true);
        setFileName(file.name);
    };
    var uploadButtonClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var fileNameWithSpaces, fileName, ar, extension, fileSize, blockBlobClient, options, resp, url, ar1, another, toSend, authCheck, expiryStatus, auth, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fileNameWithSpaces = fileNameOriginal;
                        fileName = fileNameWithSpaces.replace(/ /g, " ");
                        ar = fileNameOriginal.split(".");
                        extension = ar[ar.length - 1];
                        fileSize = file.size;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        url = resp._response.request.url;
                        ar1 = url.split("?");
                        another = ar1[0].split("/");
                        toSend = another[another.length - 1];
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 3:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            axios_default()({
                                method: "post",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/framework/createFramework"),
                                data: {
                                    docType: extension,
                                    docName: fileNameOriginal,
                                    docCategory: "png",
                                    docUrl: toSend,
                                    docSize: fileSize
                                },
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(resp) {
                                if (resp.data.code == 200) {
                                    //  console.log(resp);
                                    //    window.scrollTo(0, 0);
                                    //  setSuccessModal(true);
                                    //setShowFileName(false);
                                    //setFile(null);
                                    setError(false);
                                    //  setFileName(null);
                                    //getAllPdfs();
                                    setSuccessModal2(true);
                                    setTimeout(function() {
                                        setSuccessModal2(false);
                                    }, 1000);
                                } else if (resp.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        //console.log(error, "erro");
                        alert("Could not upload");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var uploadFile1 = function(file, name) {
        //console.log(file.name, "pdfsauto");
        azurefilepath = "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + file.name;
        //console.log("azure file path",azurefilepath)
        //console.log(automationPdfs, "pdfsauto");
        if (automationPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0 || confidentialPdfs.filter(function(item, index) {
            return item.docUrl == file.name;
        }).length > 0) {
            setFileNameError(true);
            // setSuccessModal(true);
            return;
        }
        setFile1(file);
        setShowFileName1(true);
        setFileName1(file.name);
    };
    var uploadButtonClick1 = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var fileNameWithSpaces, fileName, ar, extension, fileSize, blockBlobClient, options, resp, url, ar1, another, toSend, authCheck, expiryStatus, auth, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fileNameWithSpaces = fileNameOriginal1;
                        fileName = fileNameWithSpaces.replace(/ /g, " ");
                        ar = fileNameOriginal1.split(".");
                        extension = ar[ar.length - 1];
                        fileSize = file1.size;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file1.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file1, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        url = resp._response.request.url;
                        ar1 = url.split("?");
                        another = ar1[0].split("/");
                        toSend = another[another.length - 1];
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 3:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            axios_default()({
                                method: "post",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/framework/createFramework"),
                                data: {
                                    docType: extension,
                                    docName: fileNameOriginal1,
                                    docCategory: "png",
                                    docUrl: toSend,
                                    docSize: fileSize
                                },
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(resp) {
                                if (resp.data.code == 200) {
                                    //  console.log(resp);
                                    //     window.scrollTo(0, 0);
                                    setSuccessModal2(true);
                                    setTimeout(function() {
                                        setSuccessModal2(false);
                                    }, 1000);
                                    //   setShowFileName1(false);
                                    //setFile1(null);
                                    setError(false);
                                //setFileName1(null);
                                //getAllPdfs();
                                } else if (resp.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        //console.log(error, "erro");
                        alert("Could not upload");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadButtonClick1() {
            return _ref.apply(this, arguments);
        };
    }();
    var myDate;
    var ref74 = (0,src_sliced_to_array/* default */.Z)(react.useState(), 2), godate = ref74[0], setGodate = ref74[1];
    var handleDate = function(date, parent) {
        if (typeof date == "object") {
            var bigDate = date._d;
            var dd = String(bigDate.getDate()).padStart(2, "0");
            var mm = String(bigDate.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = bigDate.getFullYear();
            var myDate = mm + "/" + dd + "/" + yyyy;
            //console.log("mydate",myDate);
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, parent, myDate)));
        } else {
            setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, parent, date)));
        }
        setGodate(date);
    //console.log("golivedate",date);
    };
    var inputprops = {
        placeholder: emptwin.goLiveDate
    };
    var ref75 = (0,react.useState)(false), softdocument = ref75[0], setSoftdocument = ref75[1];
    var submitemptwinForm = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var authCheck, expiryStatus, softdocs, sopDocument, pddDocument, pddApprovalDocument, sddDocument, qsgDocument, odiDocument, brdDocument, costApprovalDocument, explicitLandscapeApplicationOwnerApprovalDocument, explicitGPMApprovalSupplyChainFinanceDocument, explicitGFCFApprovalDocument, devQualityCredentialsAvailableDocument, infosecApprovalDocument, dAReviewSignOffDocument, testDataAvailableForDevelopmentDocument, requestRaisedForProductionCredentialsDocument, internalTestingCompletedDocument, peerReviewSignOffDocument, daReviewSecondSignOffDocument, bpReleaseSignOffFromDaDocument, uatScriptsWithResultsDocument, uatSignOffDocument, releaseManagerSignOffDocument, gateFormDocument, peerReviewchecklistDocument, qaSignOffDocument, walkthroughVideo, ktVideo, uploadPhoto, uploadDocument, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSubmitForm(true);
                        setGetFormValues(true);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        softdocs = JSON.parse(localStorage.getItem("docURL1"));
                        if (!localStorage.getItem("docURL1")) {
                            setSoftdocument(true);
                        }
                        if (localStorage.getItem("docURL1")) {
                            setSoftdocument(false);
                        }
                        sopDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.sopDocument) || emptwin.sopsopDocument;
                        pddDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.pddDocument) || emptwin.pddDocument;
                        pddApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.pddApprovalDocument) || emptwin.pddApprovalDocument;
                        sddDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.sddDocument) || emptwin.sddDocument;
                        qsgDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.qsgDocument) || emptwin.qsgDocument;
                        odiDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.odiDocument) || emptwin.odiDocument;
                        brdDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.brdDocument) || emptwin.brdDocument;
                        costApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.costApprovalDocument) || emptwin.costApprovalDocument;
                        explicitLandscapeApplicationOwnerApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.explicitLandscapeApplicationOwnerApprovalDocument) || emptwin.explicitLandscapeApplicationOwnerApprovalDocument;
                        explicitGPMApprovalSupplyChainFinanceDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.explicitGPMApprovalSupplyChainFinanceDocument) || emptwin.explicitGPMApprovalSupplyChainFinanceDocument;
                        explicitGFCFApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.explicitGFCFApprovalDocument) || emptwin.explicitGFCFApprovalDocument;
                        devQualityCredentialsAvailableDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.devQualityCredentialsAvailableDocument) || emptwin.devQualityCredentialsAvailableDocument;
                        infosecApprovalDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.infosecApprovalDocument) || emptwin.infosecApprovalDocument;
                        dAReviewSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.dAReviewSignOffDocument) || emptwin.dAReviewSignOffDocument;
                        testDataAvailableForDevelopmentDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.testDataAvailableForDevelopmentDocument) || emptwin.testDataAvailableForDevelopmentDocument;
                        requestRaisedForProductionCredentialsDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.requestRaisedForProductionCredentialsDocument) || emptwin.requestRaisedForProductionCredentialsDocument;
                        internalTestingCompletedDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.internalTestingCompletedDocument) || emptwin.internalTestingCompletedDocument;
                        peerReviewSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.peerReviewSignOffDocument) || emptwin.peerReviewSignOffDocument;
                        daReviewSecondSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.daReviewSecondSignOffDocument) || emptwin.daReviewSecondSignOffDocument;
                        bpReleaseSignOffFromDaDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.bpReleaseSignOffFromDaDocument) || emptwin.bpReleaseSignOffFromDaDocument;
                        uatScriptsWithResultsDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.uatScriptsWithResultsDocument) || emptwin.uatScriptsWithResultsDocument;
                        uatSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.uatSignOffDocument) || emptwin.uatSignOffDocument;
                        releaseManagerSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.releaseManagerSignOffDocument) || emptwin.releaseManagerSignOffDocument;
                        gateFormDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.gateFormDocument) || emptwin.gateFormDocument;
                        peerReviewchecklistDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.peerReviewchecklistDocument) || emptwin.peerReviewchecklistDocument;
                        qaSignOffDocument = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.qaSignOffDocument) || emptwin.qaSignOffDocument;
                        walkthroughVideo = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.walkthroughVideo) || emptwin.walkthroughVideo;
                        ktVideo = (softdocs === null || softdocs === void 0 ? void 0 : softdocs.ktVideo) || emptwin.ktVideo;
                        if (logoFile !== null) {
                            uploadPhoto = logoFile;
                            console.log("not null");
                        } else {
                            uploadPhoto = emptwin.uploadPhoto;
                            console.log("null", emptwin.uploadPhoto);
                        }
                        if (fileNameOriginal1 !== null) {
                            uploadDocument = "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + fileNameOriginal1;
                        } else {
                            uploadDocument = emptwin.uploadDocument;
                        }
                        if (!expiryStatus) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 2:
                        auth = _state.sent();
                        axios_default()({
                            method: "POST",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/employeeTwin"),
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            },
                            data: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, emptwin), {
                                // employeeTwinID:empid,
                                globalSkill: globalvalue.join(","),
                                localSkill: localvalue.join(","),
                                transactions: globalvalue.join(","),
                                reporting: localvalue.join(","),
                                cognitive: cognitivevalue.join(","),
                                decisionautomations: decisionautomationsvalue.join(","),
                                genAi: genAIvalue.join(","),
                                product_id: productvalue.join(","),
                                softSkill: items.join(","),
                                businessRequest: "".concat(auth.email),
                                mco: selectedOptions.join(","),
                                country: selectedcountryOptions.join(","),
                                //uploadPhoto:"https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/"+fileNameOriginal,
                                //uploadDocument:"https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/"+fileNameOriginal1
                                uploadPhoto: uploadPhoto,
                                uploadDocument: uploadDocument,
                                sopDocument: sopDocument,
                                pddDocument: pddDocument,
                                pddApprovalDocument: pddApprovalDocument,
                                sddDocument: sddDocument,
                                qsgDocument: qsgDocument,
                                odiDocument: odiDocument,
                                brdDocument: brdDocument,
                                costApprovalDocument: costApprovalDocument,
                                explicitLandscapeApplicationOwnerApprovalDocument: explicitLandscapeApplicationOwnerApprovalDocument,
                                explicitGPMApprovalSupplyChainFinanceDocument: explicitGPMApprovalSupplyChainFinanceDocument,
                                explicitGFCFApprovalDocument: explicitGFCFApprovalDocument,
                                devQualityCredentialsAvailableDocument: devQualityCredentialsAvailableDocument,
                                infosecApprovalDocument: infosecApprovalDocument,
                                dAReviewSignOffDocument: dAReviewSignOffDocument,
                                testDataAvailableForDevelopmentDocument: testDataAvailableForDevelopmentDocument,
                                requestRaisedForProductionCredentialsDocument: requestRaisedForProductionCredentialsDocument,
                                internalTestingCompletedDocument: internalTestingCompletedDocument,
                                peerReviewSignOffDocument: peerReviewSignOffDocument,
                                daReviewSecondSignOffDocument: daReviewSecondSignOffDocument,
                                bpReleaseSignOffFromDaDocument: bpReleaseSignOffFromDaDocument,
                                uatScriptsWithResultsDocument: uatScriptsWithResultsDocument,
                                uatSignOffDocument: uatSignOffDocument,
                                releaseManagerSignOffDocument: releaseManagerSignOffDocument,
                                gateFormDocument: gateFormDocument,
                                peerReviewchecklistDocument: peerReviewchecklistDocument,
                                qaSignOffDocument: qaSignOffDocument,
                                walkthroughVideo: walkthroughVideo,
                                ktVideo: ktVideo
                            })
                        }).then(function(resp) {
                            //console.log(resp);
                            if (resp.data.code == 403) {
                                props.sessionTimeOutCheck(true);
                                setState(initialState);
                                setGetFormValues(false);
                            } else if (resp.status == 200) {
                                // console.log(resp.data);
                                //console.log("data from api---->",resp)
                                // localStorage.removeItem('myData');
                                //setItems(resp.data.data.softSkillID)
                                localStorage.removeItem("docURL1");
                                setState(initialState);
                                setGetFormValues(false);
                            } else if (resp.data.code == 400) {
                                setState(initialState);
                                setGetFormValues(false);
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        props.sessionTimeOutCheck(true);
                        _state.label = 4;
                    case 4:
                        window.scrollTo(0, 0);
                        setSuccessModal1(true);
                        setTimeout(function() {
                            setSuccessModal1(false);
                        }, 2000);
                        return [
                            2
                        ];
                }
            });
        //setSuccessModal(true);
        //router.push("/Employeetwinskills");
        });
        return function submitemptwinForm() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref76 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref76[0], setEmptyFormValues = ref76[1];
    var ref77 = (0,src_sliced_to_array/* default */.Z)(react.useState(dropDownsInitialStates), 2), dropDownState1 = ref77[0], setDropdownState1 = ref77[1];
    /*soft skill demo*/ var ref78 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), softSkillModal = ref78[0], setsoftSkillModal = ref78[1];
    var handleDropDown = function(item) {
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownsInitialStates), (0,src_define_property/* default */.Z)({}, item, !dropDownState[item])));
    };
    // const gotDropDownValue = (value, dropdownParent) => {
    //   setDropdownState(dropDownsInitialStates);
    //   setState({ ...state, [dropdownParent]: value });
    // };
    var ref79 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        status: false
    }), 2), dropDownState = ref79[0], setDropdownState = ref79[1];
    var ref80 = (0,react.useState)(), leadState = ref80[0], setLeadState = ref80[1];
    var inputChange = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = e.target.value;
                setLeadState(e.target.value);
                return [
                    2
                ];
            });
        });
        return function inputChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var inputHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data, auth1, data1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        setInputValue1(optionvalue);
                        if (!optionvalue.includes("P")) return [
                            3,
                            3
                        ];
                        if (!productvalue.includes(optionvalue)) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/get_product?product_id=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        console.log(data);
                        if (data.code === 200) {
                            setProductids(data.data);
                            setCheckedP(true);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        if (!(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) || decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            4
                        ];
                        return [
                            3,
                            6
                        ];
                    case 4:
                        auth1 = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/botSearch/globalLocal?botID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth1.accessToken, "|").concat(auth1.email)
                                }
                            })
                        ];
                    case 5:
                        data1 = _state.sent().data;
                        // console.log(data);
                        if (data1.code === 200) {
                            setGlobalskills(data1.data);
                            setChecked(true);
                        //console.log(data.data);
                        // console.log("globalskill update",globalskills);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var inputHandler1 = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        setInputValue(optionvalue);
                        if (!(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) || decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/botSearch/globalLocal?botID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    botID: optionvalue
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setLocalskills(data.data);
                            setCheckedL(true);
                        // console.log(data.data);
                        //console.log("globalskill update",globalskills);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandler1(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //for cognitive skill
    var inputHandlerc = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        setInputValuec(optionvalue);
                        if (!(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) || decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/botSearch/globalLocal?botID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    botID: optionvalue
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        console.log(data);
                        if (data.code === 200) {
                            setCognitiveskills(data.data);
                            setCheckedC(true);
                        // console.log(data.data);
                        //console.log("globalskill update",globalskills);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandlerc(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //for decision automation skill
    var inputHandlerd = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        setInputValued(optionvalue);
                        if (!(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) || decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/botSearch/globalLocal?botID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    botID: optionvalue
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        console.log(data);
                        if (data.code === 200) {
                            setDecisionautomationsskills(data.data);
                            setCheckedD(true);
                        // console.log(data.data);
                        //console.log("globalskill update",globalskills);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandlerd(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //for genAI skills
    var inputHandlerg = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data, auth1, data1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        setInputValueg(optionvalue);
                        console.log("optionvalue", typeof optionvalue === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(optionvalue));
                        console.log("globalvalue", globalvalue);
                        console.log("localvalue", localvalue);
                        console.log("optionvalue", optionvalue);
                        console.log("softskill", softskills);
                        if (!(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) || decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/botSearch/globalLocal?botID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    botID: optionvalue
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        console.log("setGenAISkills", data.data);
                        if (data.code === 200) {
                            setGenAISkills(data.data);
                            setCheckedG(true);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        if (!(optionvalue.startsWith("SS") && !items.includes(optionvalue))) return [
                            3,
                            7
                        ];
                        if (!(items.includes(optionvalue) || genAIvalue.includes(optionvalue))) return [
                            3,
                            4
                        ];
                        return [
                            3,
                            7
                        ];
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        auth1 = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/softSkill/get?softSkillID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth1.accessToken, "|").concat(auth1.email)
                                },
                                data: {
                                    softSkillID: optionvalue
                                }
                            })
                        ];
                    case 5:
                        data1 = _state.sent().data;
                        if (data1.code === 200) {
                            console.log("skilldata", data1);
                            console.log("softSkillID", data1.data[0].softSkillID);
                            setGenAISkills(data1.data);
                            setCheckedG(true);
                        }
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.log("Error", error);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandlerg(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //for global and transaction skill
    var checkedGlobal = function(e) {
        setChecked(false);
        setInputValue1("");
        setGlobalvalue((0,src_to_consumable_array/* default */.Z)(globalvalue).concat([
            e.target.value
        ]));
    };
    var checkedProduct = function(e) {
        setCheckedP(false);
        setInputValue1("");
        setProductvalue((0,src_to_consumable_array/* default */.Z)(productvalue).concat([
            e.target.value
        ]));
        submitemptwinFormp(e.target.name);
    };
    var submitemptwinFormp = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(prodid) {
            var auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                console.log(prodid);
                auth = JSON.parse(localStorage.getItem("auth")).data;
                axios_default()({
                    method: "POST",
                    url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/store_product"),
                    headers: {
                        Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                    },
                    data: {
                        product_id: prodid
                    }
                }).then(function(resp) {
                    if (resp.data.code == 403) {} else if (resp.status == 200) {
                        console.log("data from api---->", resp);
                    } else if (resp.data.code == 400) {}
                });
                return [
                    2
                ];
            });
        });
        return function submitemptwinFormp(prodid) {
            return _ref.apply(this, arguments);
        };
    }();
    //for reporting and local skill
    var checkedLocal = function(e) {
        setCheckedL(false);
        setLocalvalue((0,src_to_consumable_array/* default */.Z)(localvalue).concat([
            e.target.value
        ]));
        setInputValue("");
    };
    //for cognitive skill
    var checkedCognitive = function(e) {
        setCheckedC(false);
        setInputValuec("");
        setCognitivevalue((0,src_to_consumable_array/* default */.Z)(cognitivevalue).concat([
            e.target.value
        ]));
    };
    //for decisionautomation skill
    var checkedDecision = function(e) {
        setCheckedD(false);
        setInputValued("");
        setDecisionautomationsvalue((0,src_to_consumable_array/* default */.Z)(decisionautomationsvalue).concat([
            e.target.value
        ]));
    };
    //for GenAI  skill
    var checkedGenAI = function(e) {
        setCheckedG(false);
        setInputValueg("");
        setGenAIvalue((0,src_to_consumable_array/* default */.Z)(genAIvalue).concat([
            e.target.value
        ]));
    };
    var deleteByValue = function(item) {
        setGlobalvalue(function(oldValues) {
            return oldValues.filter(function(globalvalue) {
                return globalvalue !== item;
            });
        });
        setLocalvalue(function(oldValues) {
            return oldValues.filter(function(localvalue) {
                return localvalue !== item;
            });
        });
        setSkillvalue(function(oldValues) {
            return oldValues.filter(function(skillvalue) {
                return skillvalue !== item;
            });
        });
        setProductvalue(function(oldValues) {
            return oldValues.filter(function(productvalue) {
                return productvalue !== item;
            });
        });
        setCognitivevalue(function(oldValues) {
            return oldValues.filter(function(cognitivevalue) {
                return cognitivevalue !== item;
            });
        });
        setDecisionautomationsvalue(function(oldValues) {
            return oldValues.filter(function(decisionautomationsvalue) {
                return decisionautomationsvalue !== item;
            });
        });
        setGenAIvalue(function(oldValues) {
            return oldValues.filter(function(genAIvalue) {
                return genAIvalue !== item;
            });
        });
    };
    var deleteByValue1 = function(index) {
        var storedArray = JSON.parse(localStorage.getItem("myData"));
        storedArray.splice(index, 1);
        localStorage.setItem("myData", JSON.stringify(storedArray));
        setSkillvalue(storedArray);
    // if (storedArray) {
    //   setSkillvalue(storedArray);
    // }
    // setSkillvalue(oldValues => {
    //   return oldValues.filter(skillvalue => skillvalue !== item)
    // })
    };
    react.useEffect(function() {
        var emailCheckAr = [];
        var numberCheckAr = [];
        var requiredFields = [];
        setEmailCheck((0,src_to_consumable_array/* default */.Z)(emailCheckAr));
        setNumberCheck((0,src_to_consumable_array/* default */.Z)(numberCheckAr));
    }, []);
    {}
    var ref81 = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref81[0], setState = ref81[1];
    react.useEffect(function() {
        //console.log("dropdown data at line 395",state);
        var storedArray = JSON.parse(localStorage.getItem("myData"));
        if (storedArray) {
            setSkillvalue(storedArray);
        }
    }, []);
    var a = [];
    var b = [];
    var c = [];
    var localHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data, globals, locals, softs, storedArray, d, mco, e1, country, f, pids, cognitive, cognitivedata, decision, decisiondata, genAI, genAIData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/search?empTwinId=").concat(empid),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setEmptwin(data.allSkill[0]);
                            a = data.allSkill[0].globalSkill;
                            if (a == "") {
                                setGlobalvalue([]);
                            } else {
                                globals = a.split(",");
                                setGlobalvalue(globals);
                            }
                            b = data.allSkill[0].localSkill;
                            if (b == "") {
                                setLocalvalue([]);
                            } else {
                                locals = b.split(",");
                                setLocalvalue(locals);
                            }
                            c = data.allSkill[0].softSkill;
                            softs = c.split(",");
                            localStorage.setItem("myData", JSON.stringify(softs));
                            storedArray = JSON.parse(localStorage.getItem("myData"));
                            d = data.allSkill[0].mco;
                            mco = d.split(",");
                            setSelectedOptions(mco);
                            e1 = data.allSkill[0].country;
                            country = e1.split(",");
                            setSelectedcountryOptions(country);
                            f = data.allSkill[0].product_id;
                            if (f == "") {
                                setProductvalue([]);
                            } else {
                                pids = f.split(",");
                                setProductvalue(pids);
                            }
                            cognitive = data.allSkill[0].cognitive;
                            if (cognitive == "") {
                                setCognitivevalue([]);
                            } else {
                                cognitivedata = cognitive.split(",");
                                setCognitivevalue(cognitivedata);
                            }
                            decision = data.allSkill[0].decisionautomations;
                            if (decision == "") {
                                setDecisionautomationsvalue([]);
                            } else {
                                decisiondata = decision.split(",");
                                setDecisionautomationsvalue(decisiondata);
                            }
                            genAI = data.allSkill[0].genAi;
                            if (genAI == "") {
                                setGenAIvalue([]);
                            } else {
                                genAIData = genAI.split(",");
                                setGenAIvalue(genAIData);
                            }
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function localHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //setGlobalvalue(emptwin.globalSkill);
    react.useEffect(function() {
        localHandler();
    }, []);
    var ref82 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), relatedDropdowns = ref82[0], setRelatedDropdowns = ref82[1];
    var indexForArea, indexForsubarea, indexForMCO, indexforcountry;
    var ref83 = (0,react.useState)([]), softskills = ref83[0], setSoftskills = ref83[1];
    var inputHandlers = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var optionvalue, auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        optionvalue = e.target.value;
                        if (!items.includes(optionvalue)) return [
                            3,
                            1
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/softSkill/get?softSkillID=").concat(optionvalue),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    softSkillID: optionvalue
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setSoftskills(data.data);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 3;
                    case 3:
                        setCheckedS(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function inputHandlers(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var ssid;
    var softidfrommodal = function(skillid) {
        ssid = skillid;
        console.log(ssid);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (createemptwin_module_default()).mainContain,
        children: [
            loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((createemptwin_module_default()).formContainer),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: (createemptwin_module_default()).head,
                                    children: "Edit Employee Twin"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (createemptwin_module_default()).text,
                                    children: "Change details in the form below to edit a Employee Twin."
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((createemptwin_module_default()).inputGroupWrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((createemptwin_module_default()).Group, " container"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-12 col-md-12 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[0].component.content, "field_label", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()),
                                            children: get_default()(emptwinForm[0].component.content, "field_options", []).map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (createemptwin_module_default()).radioWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (createemptwin_module_default()).subLabel,
                                                            children: item
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "radio",
                                                            className: (createemptwin_module_default()).radioBox,
                                                            name: "requestType",
                                                            value: item,
                                                            checked: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (createemptwin_module_default()).radioCheckmark
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (createemptwin_module_default()).mainLabel,
                                                    children: [
                                                        get_default()(emptwinForm[1].component.content, "field_form_field_title", ""),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                            className: (createemptwin_module_default()).mandatoryField,
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                invalidFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (createemptwin_module_default()).errorMessage,
                                                    children: get_default()(emptwinForm[1].component.content, "field_message_ip_error_message", "")
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "employeeTwinID",
                                            id: "employeeTwinID",
                                            readOnly: true,
                                            value: empid
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[2].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "employeeTwinName",
                                            id: "employeeTwinName",
                                            onChange: onValueChange,
                                            value: emptwin.employeeTwinName
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-12 col-md-12 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[3].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                            className: "".concat(invalidFlag ? (createemptwin_module_default()).errorBorder : null),
                                            name: "employeeTwinDescription",
                                            id: "employeeTwinDescription",
                                            onChange: onValueChange,
                                            value: emptwin.employeeTwinDescription
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((createemptwin_module_default()).uploadBtnWrapper),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (createemptwin_module_default()).uploadFileContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (createemptwin_module_default()).mainLabel,
                                                    children: [
                                                        "Upload Logo",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                            className: (createemptwin_module_default()).mandatoryField,
                                                            children: "*"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "file",
                                                                className: (createemptwin_module_default()).aa,
                                                                name: "logoFile",
                                                                id: "employeeTwinName",
                                                                onChange: handleFileChange
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-red-400",
                                                                children: "Selected....!!!"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "./assets/img/Rectangle-347.png",
                                                        alt: "",
                                                        className: "w-10"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[5].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: (createemptwin_module_default()).select,
                                            onChange: onValueChange,
                                            name: "status",
                                            id: "status",
                                            value: emptwin.status,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    defaultValue: true,
                                                    children: [
                                                        " ",
                                                        get_default()(emptwinForm[5].component.content, "field_form_field_title", "")
                                                    ]
                                                }),
                                                get_default()(emptwinForm[5].component.content, "field_options", []).map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item,
                                                        children: item
                                                    }, index);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    "Lead Platform",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                            value: emptwin.leadPlatform,
                                            className: (createemptwin_module_default()).select,
                                            onChange: onValueChange,
                                            name: "leadPlatform",
                                            id: "leadPlatform",
                                            children: get_default()(leadPlatformData, "field_options", []).map(function(item, index) {
                                                emptwin.leadPlatform == item ? indexForArea = index : null;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: item,
                                                    children: item
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    "Area",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                            value: emptwin.area,
                                            className: (createemptwin_module_default()).select,
                                            onChange: onValueChange,
                                            name: "area",
                                            id: "area",
                                            children: get_default()(areaData.field_dropdown_option_component[indexForArea], "field_options", []).map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: item,
                                                    children: item
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    "Sub Area",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            value: emptwin.subArea,
                                            className: (createemptwin_module_default()).select,
                                            onChange: onValueChange,
                                            name: "subArea",
                                            id: "subArea",
                                            children: [
                                                get_default()(subAreaData, "field_dropdown_option_component", []).map(function(item, index) {
                                                    emptwin.area == item.field_title ? indexForsubarea = index : null;
                                                    {
                                                    /* console.log('emptwinForm[17]',indexForsubarea) */ }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    children: "Choose Subarea"
                                                }),
                                                get_default()(subAreaData.field_dropdown_option_component[indexForsubarea], "field_options", []).map(function(item, index) {
                                                    {
                                                    /* console.log('field_options',item); */ }
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item,
                                                        children: item
                                                    }, index);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    "Cluster",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                            value: emptwin.cluster,
                                            className: (createemptwin_module_default()).select,
                                            onChange: onValueChange,
                                            name: "cluster",
                                            id: "cluster",
                                            children: get_default()(clusterData, "field_options", []).map(function(item, index) {
                                                emptwin.cluster == item ? indexForMCO = index : null;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: item,
                                                    children: item
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    "MCO",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            value: emptwin.mco,
                                            className: (createemptwin_module_default()).selectdropdown,
                                            onClick: onToggle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    children: [
                                                        selectedOptions.length,
                                                        " Value Selected"
                                                    ]
                                                }),
                                                get_default()(mcoData.field_dropdown_option_component[indexForMCO], "field_options", []).map(function(item, index) {})
                                            ]
                                        }),
                                        toggle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: (createemptwin_module_default()).checkboxdropdown,
                                            children: get_default()(mcoData.field_dropdown_option_component[indexForMCO], "field_options", []).map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                value: item,
                                                                checked: selectedOptions.includes(item),
                                                                onChange: handleSelect,
                                                                name: "mco",
                                                                id: "mco"
                                                            }),
                                                            item
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    "Country",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            value: emptwin.country,
                                            className: (createemptwin_module_default()).selectdropdown,
                                            onClick: onTogglen,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                children: [
                                                    selectedcountryOptions.length,
                                                    " Value Selected"
                                                ]
                                            })
                                        }),
                                        togglen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: (createemptwin_module_default()).checkboxdropdown,
                                            children: get_default()(countryData, "field_dropdown_option_component", []).map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: selectedOptions.includes(item.field_title) ? get_default()(countryData.field_dropdown_option_component[index], "field_options", []).map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        type: "checkbox",
                                                                        value: item,
                                                                        checked: selectedcountryOptions.includes(item),
                                                                        onChange: handleSelectcountry,
                                                                        name: "country",
                                                                        id: "country"
                                                                    }),
                                                                    item
                                                                ]
                                                            })
                                                        });
                                                    }) : null
                                                });
                                            })
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[6].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "geoItPartner",
                                            id: "geoItPartner",
                                            onChange: onValueChange,
                                            value: emptwin.geoItPartner
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[7].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "businessOwner",
                                            id: "businessOwner",
                                            onChange: onValueChange,
                                            value: emptwin.businessOwner
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[8].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: (createemptwin_module_default()).select,
                                            id: "engagementLead",
                                            name: "engagementLead",
                                            onChange: onValueChange,
                                            value: emptwin.engagementLead,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    defaultValue: true,
                                                    children: [
                                                        " ",
                                                        get_default()(emptwinForm[8].component.content, "field_form_field_title", "")
                                                    ]
                                                }),
                                                get_default()(emptwinForm[8].component.content, "field_options", []).map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item,
                                                        children: item
                                                    }, index);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[11].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    className: (createemptwin_module_default()).inputtext,
                                                    onChange: function(e) {
                                                        inputHandlers(e);
                                                    },
                                                    placeholder: "Search Soft skill"
                                                }),
                                                checkedS ? softskills.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: (createemptwin_module_default()),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                value: item.softSkillID,
                                                                onChange: function(e) {
                                                                    checkedSoft(e);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createemptwin_module_default()).lableHead,
                                                                children: item.skillName
                                                            })
                                                        ]
                                                    });
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "".concat((createemptwin_module_default()).button, " ").concat((createemptwin_module_default()).softskillAdd),
                                            onClick: function() {
                                                openpopup();
                                            },
                                            children: "Add"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "softskill",
                                            id: "softskill",
                                            value: items
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: items.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue1(index);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((createemptwin_module_default()).uploadBtnWrapper),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (createemptwin_module_default()).uploadFileContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: (createemptwin_module_default()).mainLabel,
                                                    children: get_default()(emptwinForm[12].component.content, "field_title", "")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (createemptwin_module_default()).uploadControl,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (createemptwin_module_default()).multiDocsWrapper,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (createemptwin_module_default()).skillMultiDocs,
                                                            onClick: openDocumentModal,
                                                            children: "Open Document Uploader"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[13].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "number",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "manualhour",
                                            id: "manualhour",
                                            onChange: onValueChange,
                                            value: emptwin.manualhour
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[14].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "number",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "fte",
                                            id: "fte",
                                            onChange: onValueChange,
                                            value: emptwin.fte
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[15].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: (createemptwin_module_default()).select,
                                            id: "businessgroup",
                                            name: "businessgroup",
                                            onChange: onValueChange,
                                            value: emptwin.businessgroup,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    defaultValue: true,
                                                    children: [
                                                        " ",
                                                        get_default()(emptwinForm[15].component.content, "field_form_field_title", "")
                                                    ]
                                                }),
                                                get_default()(emptwinForm[15].component.content, "field_options", []).map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item,
                                                        children: item
                                                    }, index);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    get_default()(emptwinForm[16].component.content, "field_form_field_title", ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: (createemptwin_module_default()).select,
                                            id: "businessunit",
                                            name: "businessunit",
                                            onChange: onValueChange,
                                            value: emptwin.businessunit,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    defaultValue: true,
                                                    children: [
                                                        " ",
                                                        get_default()(emptwinForm[16].component.content, "field_form_field_title", "")
                                                    ]
                                                }),
                                                get_default()(emptwinForm[16].component.content, "field_options", []).map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item,
                                                        children: item
                                                    }, index);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            emptwin.businessunit != "Global" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: "Business Group Unit"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: (createemptwin_module_default()).select,
                                            id: "businessoption",
                                            name: "businessoption",
                                            onChange: onValueChange,
                                            value: emptwin.businessoption,
                                            children: [
                                                emptwin.businessgroup == "Beauty & Wellbeing" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    value: "Health & Wellness",
                                                    children: [
                                                        "Health & Wellness",
                                                        " "
                                                    ]
                                                }) : null,
                                                emptwin.businessgroup == "Beauty & Wellbeing" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Prestige",
                                                    children: "Prestige "
                                                }) : null,
                                                emptwin.businessgroup == "Personal Care" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Dollar Shave Club",
                                                    children: "Dollar Shave Club"
                                                }) : null,
                                                emptwin.businessgroup == "Personal Care" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Elida Beauty",
                                                    children: "Elida Beauty"
                                                }) : null,
                                                emptwin.businessgroup == "Home Care" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Water and Air Wellness",
                                                    children: "Water and Air Wellness"
                                                }) : null,
                                                emptwin.businessgroup == "Nutrition" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Unilever Food Solutions",
                                                    children: "Unilever Food Solutions"
                                                }) : null,
                                                emptwin.businessgroup == "Ice Cream" || emptwin.businessgroup == "All" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Ice Cream",
                                                    children: "Ice Cream"
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: [
                                                    "Go Live date",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                        className: (createemptwin_module_default()).mandatoryField,
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datetime_cjs_default()), {
                                            timeFormat: false,
                                            className: "".concat((createemptwin_module_default()).calender, "  ").concat((createemptwin_module_default()).errorBorder),
                                            inputProps: inputprops,
                                            onChange: function(date) {
                                                return handleDate(date, "goLiveDate");
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[18].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            onChange: function(e) {
                                                inputHandler(e);
                                            },
                                            placeholder: "Search Transactions skill",
                                            value: inputValue1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            id: "transactionsskill",
                                            name: "transactionsskill",
                                            value: globalvalue
                                        }),
                                        checked ? globalskills.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        value: item.botExternalId,
                                                        onChange: function(e) {
                                                            checkedGlobal(e);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).lableHead,
                                                        children: item.processName
                                                    })
                                                ]
                                            });
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: globalvalue.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue(item);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[19].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            onChange: function(e) {
                                                inputHandler1(e);
                                            },
                                            placeholder: "Search Reporting skill",
                                            value: inputValue
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "reportingskill",
                                            id: "reportingskill",
                                            value: localvalue
                                        }),
                                        checkedL ? localskills.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        value: item.botExternalId,
                                                        onChange: function(e) {
                                                            checkedLocal(e);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).lableHead,
                                                        children: item.processName
                                                    })
                                                ]
                                            });
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: localvalue.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue(item);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[20].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            onChange: function(e) {
                                                inputHandlerc(e);
                                            },
                                            placeholder: "Search Cognitive skill",
                                            value: inputValuec
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            id: "cognitiveskill",
                                            name: "cognitiveskill",
                                            value: cognitivevalue
                                        }),
                                        checkedC ? cognitiveskills.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        value: item.botExternalId,
                                                        onChange: function(e) {
                                                            checkedCognitive(e);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).lableHead,
                                                        children: item.processName
                                                    })
                                                ]
                                            });
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: cognitivevalue.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue(item);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[21].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            onChange: function(e) {
                                                inputHandlerd(e);
                                            },
                                            placeholder: "Search Decision Automations skill",
                                            value: inputValued
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "decisionAutomationsskill",
                                            id: "decisionAutomationsskill",
                                            value: decisionautomationsvalue
                                        }),
                                        checkedD ? decisionautomationsskills.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        value: item.botExternalId,
                                                        onChange: function(e) {
                                                            checkedDecision(e);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (createemptwin_module_default()).lableHead,
                                                        children: item.processName
                                                    })
                                                ]
                                            });
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: decisionautomationsvalue.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue(item);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[22].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            onChange: function(e) {
                                                inputHandlerg(e);
                                            },
                                            placeholder: "Search Gen AI...",
                                            value: inputValueg
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "genAI",
                                            id: "genAI",
                                            value: genAIvalue
                                        }),
                                        checkedG ? genAISkills.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (createemptwin_module_default()),
                                                children: [
                                                    console.log("selected item", item.botExternalId),
                                                    console.log("selected item", item.softSkillID),
                                                    console.log("selectedItem", item.processName),
                                                    console.log("selectedItem", item.skillName),
                                                    item.botExternalId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                value: item.botExternalId,
                                                                onChange: function(e) {
                                                                    checkedGenAI(e);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createemptwin_module_default()).lableHead,
                                                                children: item.processName
                                                            })
                                                        ]
                                                    }),
                                                    item.softSkillID && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                value: item.softSkillID,
                                                                onChange: function(e) {
                                                                    checkedGenAI(e);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (createemptwin_module_default()).lableHead,
                                                                children: item.skillName
                                                            })
                                                        ]
                                                    })
                                                ]
                                            });
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: genAIvalue.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (createemptwin_module_default()).checkedvalue,
                                                    id: index,
                                                    children: [
                                                        item,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                deleteByValue(item);
                                                            },
                                                            className: (createemptwin_module_default()).globallist,
                                                            children: "X"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (createemptwin_module_default()).combine,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (createemptwin_module_default()).mainLabel,
                                                children: get_default()(emptwinForm[23].component.content, "field_form_field_title", "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (createemptwin_module_default()).inputtext,
                                            name: "securityGroupId",
                                            id: "securityGroupId",
                                            onChange: onValueChange,
                                            value: emptwin.securityGroupId
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 ".concat(emptwin.businessunit != "Global" ? "col-12" : "col-lg-12 ".concat((createemptwin_module_default()).businessGroupUnit)),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (createemptwin_module_default()).formGroup,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (createemptwin_module_default()).submitbtn,
                                        onClick: submitemptwinForm,
                                        children: "Submit"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            softSkillModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SoftSkill/* default */.Z, {
                data: props.softskill.data.field_component,
                closeModal: function() {
                    setsoftSkillModal(false);
                },
                setSuccessModal: setSuccessModal,
                setMessage: setMessage,
                setsucessOrFailure: setsucessOrFailure,
                empid: empid,
                name: "empskillpage",
                softidfrommodal: softidfrommodal
            }) : null,
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: setSuccessModal,
                title: "Soft Skill",
                message: message,
                fail: sucessOrFailure
            }) : null,
            successModal1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: setSuccessModal,
                title: "Employee Twin",
                message: "Employee Twin updated successfully",
                fail: sucessOrFailure
            }) : null,
            successModal2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: function() {
                    setSuccessModal(false);
                    setFileNameError(false);
                },
                title: "Framework",
                message: filenameError ? "Document with this name already exists." : "uploaded",
                fail: filenameError ? true : false
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (createemptwin_module_default()).uploadContainer,
                children: modalShow == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentETUploader, {
                    closeModal: closeDocumentModal,
                    sendDocInfo: gotDocInfo,
                    sendAllInfoAboutUploadModal: sendAllInfoAboutUploadModal,
                    uploadedDocumentsState: uploadedDocumentsState,
                    editState: emptwin,
                    formType: fileTypes,
                    documentFolderName: "employeetwin",
                    softSkillDoc: "softSkillDocState",
                    sopInvalid: sopInvalid,
                    setSopInvalid: setSopInvalid,
                    name: "etedit"
                }) : null
            })
        ]
    });
}
var EditEmployeeTwin_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function EditEmployeeTwin_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var EditEmployeeTwin = ((0,es/* connect */.$j)(EditEmployeeTwin_mapStateToProps, EditEmployeeTwin_mapDispatchToProps)(EditEmployeeTwin_index));

// EXTERNAL MODULE: ./styles/pages/emptwin.module.scss
var emptwin_module = __webpack_require__(50637);
var emptwin_module_default = /*#__PURE__*/__webpack_require__.n(emptwin_module);
// EXTERNAL MODULE: ./styles/components/cart.module.scss
var cart_module = __webpack_require__(99849);
var cart_module_default = /*#__PURE__*/__webpack_require__.n(cart_module);
;// CONCATENATED MODULE: ./components/Pages/ExperienceemptwinModal/index.jsx









var ExperienceemptwinModal_ModalExample = function(props) {
    var useOutsideAlerter = // method to close the modal if clicked outside
    function useOutsideAlerter(ref) {
        (0,react.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                //props.closeModal();
                }
            }
            // Bind the event listener
            document.addEventListener("click", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    //console.log("Props cart ---", props);
    var modalRef = react.useRef(null);
    useOutsideAlerter(modalRef);
    var handledemo = function() {
        props.closeModal();
        document.body.style.overflow = "unset";
    };
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), Loading = ref[0], setLoading = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (cart_module_default()).editModalWrapper,
        children: Loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (cart_module_default()).modalBox,
            ref: modalRef,
            style: {
                height: "190px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((cart_module_default()).formContainer),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (cart_module_default()).rowBtn,
                                    onClick: function() {
                                        handledemo();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (cart_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/close.png",
                                            className: (cart_module_default()).iconimg
                                        })
                                    })
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (cart_module_default()).modalBody,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (cart_module_default()).row,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-12 col-md-12 col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (cart_module_default()).formGroup,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (cart_module_default()).formheading,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: (cart_module_default()).head,
                                        style: {
                                            fontSize: "14px"
                                        },
                                        children: "Hi, we have shared the details on your mail. Please Check your email details have been shared"
                                    })
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
var ExperienceemptwinModal_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function ExperienceemptwinModal_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var ExperienceemptwinModal = ((0,es/* connect */.$j)(ExperienceemptwinModal_mapStateToProps, ExperienceemptwinModal_mapDispatchToProps)(ExperienceemptwinModal_ModalExample));

;// CONCATENATED MODULE: ./components/Employeetwin/index.jsx










//import "react-responsive-carousel/lib/styles/carousel.min.css";
//import { Carousel } from "react-responsive-carousel";

//import Icons from "../../../public/assets/svg/index";
var Employeetwin_Icons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18023));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18023)
            ];
        }
    }
});
//import Card from "../../dynamicBotCard";
var Card = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7013).then(__webpack_require__.bind(__webpack_require__, 17013));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17013)
            ];
        }
    }
});
//import Slider from "react-slick";


//import Dropdown from "../../listWithoutcheck";

//import BasicForm from "../../basicForm";
//const BasicForm = dynamic(() => import("../../basicForm"));
var BasicForm = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35842)
            ];
        }
    }
});
//import Video from "../../../pages/videoModal";
var Video = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4657).then(__webpack_require__.bind(__webpack_require__, 72481));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72481)
            ];
        }
    }
});
var Empbanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6450).then(__webpack_require__.bind(__webpack_require__, 46450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46450)
            ];
        }
    }
});
var Empbanner1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 20).then(__webpack_require__.bind(__webpack_require__, 5826));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5826)
            ];
        }
    }
});
var Filters = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9944).then(__webpack_require__.bind(__webpack_require__, 99944));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99944)
            ];
        }
    }
});






var Employeetwin_SuccessModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 99696));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99696)
            ];
        }
    }
});

//import Loader from "./../../Loader";
var Employeetwin_Loader = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 16330));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16330)
            ];
        }
    }
});

//import DropDown from "../../listWithoutcheck";
//url={`https://newbotstore.blob.core.windows.net/botstorevideo/${myBot.ktV`ideo}`}
// helper component for carousels



var responsive = {
    superLargeDesktop: {
        breakpoint: {
            max: 4000,
            min: 3000
        },
        items: 5
    },
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 3
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 2
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0
        },
        items: 1
    }
};
var responsive1 = {
    superLargeDesktop: {
        breakpoint: {
            max: 4000,
            min: 3000
        },
        items: 1
    },
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 1
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 1
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0
        },
        items: 1,
        partialVisibilityGutter: 160
    }
};
var responsive2 = {
    superLargeDesktop: {
        breakpoint: {
            max: 4000,
            min: 3000
        },
        items: 3
    },
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 3
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 1
    },
    mobile: {
        breakpoint: {
            max: 768,
            min: 0
        },
        items: 1,
        partialVisibilityGutter: 40
    }
};
var Employeetwin_responsive3 = {
    superLargeDesktop: {
        breakpoint: {
            max: 4000,
            min: 3000
        },
        items: 4
    },
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 3
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 2
    },
    mobile: {
        breakpoint: {
            max: 768,
            min: 0
        },
        items: 1,
        partialVisibilityGutter: 40
    }
};
var arr = (/* unused pure expression or super */ null && ([
    "",
    "",
    "",
    "",
    ""
]));
var Employeetwin_ButtonGroup = function(_param) {
    var next = _param.next, previous = _param.previous, goToSlide = _param.goToSlide, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "next",
        "previous",
        "goToSlide"
    ]);
    var currentSlide = rest.carouselState.currentSlide;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: currentSlide === 0 ? (emptwin_module_default()).customprev : (emptwin_module_default()).customprev,
                onClick: function() {
                    return previous();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                    src: "/assets/svg/Lefti.png"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (emptwin_module_default()).customnext,
                onClick: function() {
                    return next();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                    src: "/assets/svg/righti.png"
                })
            })
        ]
    });
};
var ButtonGroup2 = function(_param) {
    var next = _param.next, previous = _param.previous, goToSlide = _param.goToSlide, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "next",
        "previous",
        "goToSlide"
    ]);
    var currentSlide = rest.carouselState.currentSlide;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: currentSlide === 0 ? (emptwin_module_default()).customprevguest : (emptwin_module_default()).customprevguest,
                onClick: function() {
                    return previous();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                    src: "/assets/svg/Lefti.png"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (emptwin_module_default()).customnextguest,
                onClick: function() {
                    return next();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                    src: "/assets/svg/righti.png"
                })
            })
        ]
    });
};
var ButtonGroupmain = function(_param) {
    var next = _param.next, previous = _param.previous, goToSlide = _param.goToSlide, rest = _object_without_properties(_param, [
        "next",
        "previous",
        "goToSlide"
    ]);
    var currentSlide = rest.carouselState.currentSlide;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: currentSlide === 0 ? styles.customprevmain : styles.customprevmain,
                onClick: function() {
                    return previous();
                },
                children: /*#__PURE__*/ _jsx(LazyLoadImage, {
                    src: "/assets/svg/Left-navigation-active.png"
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.customnextmain,
                onClick: function() {
                    return next();
                },
                children: /*#__PURE__*/ _jsx(LazyLoadImage, {
                    src: "/assets/svg/Right-navigation-active.png"
                })
            })
        ]
    });
};
var CustomDot = function(_param) {
    var onClick = _param.onClick, rest = _object_without_properties(_param, [
        "onClick"
    ]);
    var _$index = rest.index, active = rest.active;
    //  alert(active)
    var carouselItems = arr;
    return /*#__PURE__*/ _jsx("span", {
        className: active == true ? styles.dotActive + " " + styles.reactMultiCarouselDot : styles.dotInactive + " " + styles.reactMultiCarouselDot,
        onClick: function() {
            return onClick();
        }
    });
};
var CustomDot1 = function(_param) {
    var onClick = _param.onClick, rest = _object_without_properties(_param, [
        "onClick"
    ]);
    var _$index = rest.index, active = rest.active;
    var carouselItems = arr;
    return /*#__PURE__*/ _jsx("span", {
        className: active == true ? styles.dotActive + " " + styles.reactMultiCarouselDot : styles.dotInactive + " " + styles.reactMultiCarouselDot,
        onClick: function() {
            return onClick();
        }
    });
};
// real home component starts from here
function Employeetwin_index(props) {
    var openpopup = function openpopup() {
        var modal = !empModal;
        setEmpModal(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        var auth = JSON.parse(localStorage.getItem("auth")).data;
        axios_default()({
            method: "POST",
            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/randomMail"),
            headers: {
                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
            },
            data: {
                "Description": "test",
                "Rating": "test"
            }
        }).then(function(resp) {
            if (resp.data.code == 403) {} else if (resp.status == 200) {
            // console.log("data from api---->",resp);
            } else if (resp.data.code == 400) {}
        });
    };
    var router = (0,next_router.useRouter)();
    //console.log("props  ------ Employeetwin page  -----", props);
    var isMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 720px)"
    });
    var initialStates = {};
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref[0], setState = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref1[0], setSubmitForm = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref2[0], setInvalidFlag = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref3[0], setGetFormValues = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref4[0], setEmptyFormValues = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), bots = ref5[0], setBots = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref6[0], setSuccessModal = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState("We have received your request. Please wait for a while we get back to you."), 2), message = ref7[0], setMessage = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), empModal = ref8[0], setEmpModal = ref8[1];
    var ref9 = (0,react.useState)(), countdata = ref9[0], setCountdata = ref9[1];
    var ref10 = (0,react.useState)(), countdata1 = ref10[0], setCountdata1 = ref10[1];
    var ref11 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), noResultFlag = ref11[0], setNoResultFlag = ref11[1];
    var initialCezState = {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false
    };
    var ref12 = (0,src_sliced_to_array/* default */.Z)(react.useState(true), 2), spinner = ref12[0], setspinner = ref12[1];
    var ref13 = (0,src_sliced_to_array/* default */.Z)(react.useState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), {
        0: true
    })), 2), cezState = ref13[0], setCezState = ref13[1];
    var cezClicked = function(index) {
        //console.log("cezState", cezState, index);
        setCezState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialCezState), (0,src_define_property/* default */.Z)({}, index, true)));
    };
    var clearALLFilter = function() {
        window.scrollTo(0, 200);
        setState({});
        //setLoadState(true)
        setNoResultFlag(false);
    // dispatch(getBotsAction(0))
    // setAllBots([])
    // setInfiniteKey(infiniteKey + 1)
    // setHasMoreBots(true)
    };
    var initialFeatureImageState = {
        0: false,
        1: false,
        2: false,
        3: false
    };
    var ref14 = (0,src_sliced_to_array/* default */.Z)(react.useState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialFeatureImageState), {
        0: true
    })), 2), featureImageState = ref14[0], setFeatureImageState = ref14[1];
    var mouseEntered = function(index) {
        setFeatureImageState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialFeatureImageState), (0,src_define_property/* default */.Z)({}, index, true)));
    };
    // taking data out from drupal
    var imagewithtextComponents = props.data.filter(function(item) {
        return item.component.type == "image_with_text";
    });
    var carouselComponents = props.data.filter(function(item) {
        return item.component.type == "home_carousel_component";
    });
    var videoComponent = props.data.filter(function(item) {
        return item.component.type == "home_video_component";
    });
    var backgroundUrlMobile = get_default()(props.data[0], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl = get_default()(props, "data[0]component.content.field_background_image[0].file_url", "");
    var emptwinDetails = get_default()(props, "data[0].component.content.field_details", "");
    var emptwinHeading = get_default()(props, "data[0]component.content.field_hedaing", "");
    var backgroundUrlMobile1 = get_default()(props.data[10], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl1 = get_default()(props, "data[10]component.content.field_background_image[0].file_url", "");
    var emptwinDetails1 = get_default()(props, "data[10].component.content.field_details", "");
    var emptwinHeading1 = get_default()(props, "data[10]component.content.field_hedaing", "");
    var backgroundUrlMobileemptwin = get_default()(props.data[11], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrlemptwin = get_default()(props, "data[11]component.content.field_background_image[0].file_url", "");
    var _content = videoComponent[0].component.content, field_home_image = _content.field_home_image, field_hedaing = _content.field_hedaing, field_video_icon = _content.field_video_icon, field_label = _content.field_label, field_home_video = _content.field_home_video;
    {}
    var serviceComponent = props.data.filter(function(item) {
        return item.component.type == "home_service_component";
    });
    var noResultComponent = props.data.filter(function(item) {
        return item.component.type == "no_result_component";
    })[0];
    var content = get_default()(props, "data[12]component.content", "");
    //console.log(noResultComponent, "noooooooresultcomponent")
    var featureComponent = props.data.filter(function(item) {
        return item.component.type == "home_feature_component";
    });
    var botListingComponent = props.data.filter(function(item) {
        return item.component.type == "home_bot_listing_component";
    })[0].component.content;
    var getInTouchComponent = props.data.filter(function(item) {
        return item.component.type == "home_get_in_touch_component";
    })[0].component.content;
    var submitRequestDemoForm = function() {
        setGetFormValues(true);
    };
    var recievedFormValues = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(formState) {
            var authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!invalidFlag) return [
                            3,
                            2
                        ];
                        setState((0,src_object_spread/* default */.Z)({}, state, formState));
                        //console.log(state);
                        setSubmitForm(true);
                        setFullPageLoading(true);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            axios_default()({
                                method: "post",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/demo/createDemoRequest"),
                                headers: {
                                    Authorization: auth.accessToken
                                },
                                data: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formState, state), {
                                    UserEmail: auth.email
                                })
                            }).then(function(resp) {
                                if (resp.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    setFullPageLoading(false);
                                    props.sessionTimeOutCheck(true);
                                    setAlternateBotsLoading(false);
                                    setGetFormValues(false);
                                } else if (resp.data.code == 200) {
                                    setState(initialState);
                                    setSuccessModal(true);
                                    setGetFormValues(false);
                                    setFullPageLoading(false);
                                    setEmptyFormValues(!emptyFormValues);
                                    // setState(initialState);
                                    document.getElementById("remark").value = "";
                                }
                            });
                        } else {
                            setFullPageLoading(false);
                            setAlternateBotsLoading(false);
                            props.sessionTimeOutCheck(true);
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function recievedFormValues(formState) {
            return _ref.apply(this, arguments);
        };
    }();
    var leadPlatform = get_default()(props.globalData, "lead_platform_main_component[0].field_options", []);
    react.useEffect(function() {
        leadPlatform = leadPlatform.filter(function(item, index) {
            return index < 8;
        });
        setleadPlatformData(leadPlatform);
    }, []);
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var Filters, auth, i, authCheck, expiryStatus, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    Filters = {};
                    auth = JSON.parse(localStorage.getItem("auth")).data;
                    for(var i in auth){
                        //    console.log("i----", i);
                        if (i == "personalarea" || i == "personalCluster" || i == "personalCountry" || i == "personalLeadPlatform" || i == "personalMco" || i == "personalSubArea") {
                            if (auth[i] != null) {
                                if (auth[i].length > 0 && auth[i] != null) {
                                    //console.log("auths", auth[i]);
                                    if (i == "personalArea") {
                                        Filters.area = auth[i];
                                    } else if (i == "personalCluster") {
                                        Filters.cluster = auth[i];
                                    } else if (i == "personalMco") {
                                        Filters.mco = auth[i];
                                    } else if (i == "personalCountry") {
                                        Filters.country = auth[i];
                                    } else if (i == "personalSubArea") {
                                        Filters.subArea = auth[i];
                                    } else if (i == "personalLeadPlatform") {
                                        Filters.leadPlatform = auth[i];
                                    }
                                //  console.log(i[8], "filtersssssssssssss", i)
                                //   Filters[changeIt(i.slice(8))] = auth[i]; 
                                }
                            }
                        }
                    }
                    if (!(Object.keys(state).length == 0)) return [
                        3,
                        1
                    ];
                    setShowAlternateBots(true);
                    getAlternateBots(leadPlatform[0]);
                    console.log("not data");
                    return [
                        3,
                        3
                    ];
                case 1:
                    if (!showAlternateBots) {
                        Filters = {};
                    }
                    authCheck = JSON.parse(localStorage.getItem("auth")).data;
                    return [
                        4,
                        props.checkExpiry(authCheck)
                    ];
                case 2:
                    expiryStatus = _state.sent();
                    if (expiryStatus) {
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        axios_default()({
                            method: "get",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/elastic/searchQueryTwin"),
                            params: state,
                            headers: {
                                Authorization: auth.accessToken
                            }
                        }).then(function(resp) {
                            if (resp.data.code == 200) {
                                //console.log("line number 520",resp)
                                // dispatch(saveBotsAction({ data: resp.data.data, filter: "filter" }));
                                //    console.log(resp.data.data, "responseDotData  all use effect ")
                                if (resp.data.data.allTwinBots.length == 0) {
                                    //console.log("here  ----", resp.data.data.allTwinBots)
                                    // setShowAlternateBots(true);
                                    // getAlternateBots(leadPlatform[0]);
                                    //     console.log(leadPlatform[0], "leadPlatformData")
                                    setAlternateBots(resp.data.data.allTwinBots);
                                } else {
                                    setAlternateBots(resp.data.data.allTwinBots);
                                //console.log(resp.data.data.allTwinBots);
                                //setAlternateBots([...resp.data.data.allTwinBots]);
                                }
                            } else if (resp.data.code == 403) {
                                localStorage.removeItem("auth");
                                sessionStorage.clear();
                                setFullPageLoading(false);
                                setAlternateBotsLoading(false);
                                props.sessionTimeOutCheck(true);
                            } else {
                                setShowAlternateBots(true);
                                getAlternateBots(leadPlatform[0]);
                            //        console.log(leadPlatform[0], "leadPlatformData")
                            }
                        });
                    } else {
                        setFullPageLoading(false);
                        setAlternateBotsLoading(false);
                        props.sessionTimeOutCheck(true);
                    }
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    console.log(e);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        state
    ]);
    //console.log(state);
    // alternatebots
    var ref15 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), alternateBots = ref15[0], setAlternateBots = ref15[1];
    var ref16 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), showAlternateBots = ref16[0], setShowAlternateBots = ref16[1];
    var ref17 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), alternateBotsLoading = ref17[0], setAlternateBotsLoading = ref17[1];
    var ref18 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), leadPlatformData = ref18[0], setleadPlatformData = ref18[1];
    var ref19 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), fullPageLoading = ref19[0], setFullPageLoading = ref19[1];
    var getAlternateBots = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(leadPlatform) {
            var authCheck, expiryStatus, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setAlternateBotsLoading(true);
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 1:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            auth = JSON.parse(localStorage.getItem("auth")).data;
                            axios_default()({
                                method: "get",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/elastic/searchQueryTwin"),
                                headers: {
                                    Authorization: auth.accessToken
                                }
                            }).then(function(resp) {
                                if (resp.data.code == 200) {
                                    //console.log("line number 579",resp)
                                    // dispatch(saveBotsAction({ data: resp.data.data, filter: "filter" }));
                                    setAlternateBotsLoading(false);
                                    setAlternateBots(resp.data.data.allTwinBots);
                                // console.log("line 608", resp);
                                } else if (resp.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    setFullPageLoading(false);
                                    setAlternateBotsLoading(false);
                                    sessionStorage.clear();
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            setFullPageLoading(false);
                            setAlternateBotsLoading(false);
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getAlternateBots(leadPlatform) {
            return _ref.apply(this, arguments);
        };
    }();
    var leadPlatformRadioChange = function(e) {
        setDropdownState({
            leadPlatform: false
        });
        setDropdownValue(e.target.value);
        getAlternateBots(e.target.value);
    };
    var ref20 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        leadPlatform: false
    }), 2), dropDownState = ref20[0], setDropdownState = ref20[1];
    var ref21 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), dropdownValue = ref21[0], setDropdownValue = ref21[1];
    var handleDropDown = function(item) {
        setDropdownState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dropDownState), (0,src_define_property/* default */.Z)({}, item, !dropDownState[item])));
    };
    // React.useEffect(() => {
    //   getAlternateBots("Customer Development");
    // }, []);
    var goTo = function(link) {
        // console.log(link);
        router.push(link);
    };
    var ref22 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), video = ref22[0], setvideo = ref22[1];
    var handlevideo = function() {
        var modal = !video;
        setvideo(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var ref23 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), carouselRef = ref23[0], setCarouselRef = ref23[1];
    var ref24 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), carouselAutoplay = ref24[0], setCarouselAutoplay = ref24[1];
    var ref25 = (0,src_sliced_to_array/* default */.Z)(react.useState(true), 2), isPlaying = ref25[0], setIsPlaying = ref25[1];
    var sliderChanged = function(slideIndex, param) {
        var currentSlide = param.currentSlide, onMove = param.onMove;
        // console.log(currentSlide, "currentSlide");
        if (currentSlide == 2) {
            setCarouselAutoplay(false);
            setIsPlaying(true);
        } else {
            setIsPlaying(false);
            setCarouselAutoplay(false);
        }
    };
    var reactRef = react.useRef(null);
    var videoUrl = window.innerWidth >= 780 ? props.data[1].component.content.field_carousel_video[0].file_url : get_default()(props, "data[1].component.content.field_carousel_video_mobile[1].file_url", "");
    var clickedOnVideo = function(flag) {
        if (flag) {
            props.videoClicked();
        }
    };
    var getListItemColor = function(index) {
        if (index === 0) {
            return "#4ba58a";
        }
        if (index === 1) {
            return "#6ec5fa";
        }
        if (index === 2) {
            return "#61d4c4";
        }
        if (index === 3) {
            return "#9149ba";
        }
        if (index === 4) {
            return "#ff7c7d";
        }
        if (index === 5) {
            return "#e45ec2";
        }
        if (index === 6) {
            return "#4068d1";
        }
        return "#4ba58a";
    };
    //console.log("imagessection 1", carouselComponents);
    var ref26 = (0,react.useState)(null), twinuser = ref26[0], setTwinuser = ref26[1];
    var localHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data, a;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/sumManulAndFte "),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            a = data.data;
                            setCountdata(a.manualhour);
                            setCountdata1(a.fte.toFixed(2));
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function localHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        var authCheck = JSON.parse(localStorage.getItem("auth")).data;
        var expiryStatus = props.checkExpiry(authCheck);
        var auth = JSON.parse(localStorage.getItem("auth")).data;
        axios_default()({
            method: "GET",
            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/get"),
            headers: {
                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
            }
        }).then(function(resp) {
            setTwinuser(resp.data);
        });
        localHandler();
    }, []);
    if (!twinuser) return null;
    //console.log(countdata);
    //console.log("twinuser data", twinuser);
    var auth = JSON.parse(localStorage.getItem("auth")).data;
    //console.log(auth.email);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((emptwin_module_default()).landingContainer),
        children: [
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwin_SuccessModal, {
                setSuccessModal: setSuccessModal,
                title: "Request a demo",
                message: message
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "headTop"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Empbanner, {
                data: {
                    emptwinDetails: emptwinDetails,
                    emptwinHeading: emptwinHeading,
                    backgroundUrl: backgroundUrl,
                    backgroundUrlMobile: backgroundUrlMobile
                },
                name: "employeetwin"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((emptwin_module_default()).caramain),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (emptwin_module_default()).carousalimage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: get_default()(props.data[3], "component.content.field_banner_cta[0].uri", ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width: 780px)",
                                    srcSet: utility_endpoints/* default.drupalIp */.ZP.drupalIp + get_default()(props.data[3], "component.content.field_carousel_image_mobile[0].file_url", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                    src: utility_endpoints/* default.drupalIp */.ZP.drupalIp + get_default()(props.data[3], "component.content.field_carousel_image[0].file_url", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (emptwin_module_default()).counting,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (emptwin_module_default()).yellow,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (emptwin_module_default()).countingpara,
                                                children: [
                                                    countdata,
                                                    " Manual Hour Saving"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (emptwin_module_default()).purple,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (emptwin_module_default()).countingpara,
                                                children: [
                                                    countdata1,
                                                    " FTE Saving"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (emptwin_module_default()).pink,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (emptwin_module_default()).countingpara,
                                                children: [
                                                    "24x7 availability",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Reduction of manual efforts"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((emptwin_module_default()).mainbanner),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (emptwin_module_default()).secondaryBanner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: utility_endpoints/* default.drupalIp */.ZP.drupalIp + field_home_image[0].file_url,
                                className: (emptwin_module_default()).videoimage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (emptwin_module_default()).videobox,
                                onClick: handlevideo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (emptwin_module_default()).videoicon,
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                            src: utility_endpoints/* default.drupalIp */.ZP.drupalIp + field_video_icon[0].file_url,
                                            alt: field_video_icon[0].image_alt
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (emptwin_module_default()).submitbtn,
                                onClick: function() {
                                    openpopup();
                                },
                                children: "Experience Employee Twin "
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (emptwin_module_default()).videocard,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: (emptwin_module_default()).emptwinvideotext,
                                children: [
                                    field_hedaing,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Team"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (emptwin_module_default()).head,
                                children: field_label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (emptwin_module_default()).videolist,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (emptwin_module_default()).videolistli,
                                        children: "The Employee Twin should need to perform core transactions/activities being performed by the team​"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (emptwin_module_default()).videolistli,
                                        children: "Human in the Loop, where the output of a bot is validated and then further processed​"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (emptwin_module_default()).videolistli,
                                        children: "Need for personalised recommendations​"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (emptwin_module_default()).videolistli,
                                        children: "User triggered processes for ad-hoc runs, status checks and Knowledge search "
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showAlternateBots ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (emptwin_module_default()).guestBot,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container-fluid",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 mt-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (emptwin_module_default()).head,
                                        children: [
                                            get_default()(botListingComponent, "field_title", ""),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (emptwin_module_default()).headspan,
                                                children: "Twin"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (emptwin_module_default()).content,
                                        children: get_default()(botListingComponent, "field_message_input", "")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 mb-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((emptwin_module_default()).mainbot, " row"),
                                        children: [
                                            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (emptwin_module_default()).filterbot,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: (emptwin_module_default()).headfilter,
                                                            children: [
                                                                " ",
                                                                get_default()(botListingComponent, "field_label", "")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (emptwin_module_default()).radiolanding,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (emptwin_module_default()).inputGroupWrapper,
                                                                onChange: leadPlatformRadioChange,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {
                                                                    data: content,
                                                                    clearALLFilter: clearALLFilter,
                                                                    initialStates: initialStates,
                                                                    state: state,
                                                                    setState: setState
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (emptwin_module_default()).colFirst,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (emptwin_module_default()).row,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "".concat((emptwin_module_default()).input),
                                                                    onClick: function() {
                                                                        handleDropDown("leadPlatform");
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: (emptwin_module_default()).left,
                                                                            children: dropdownValue == "" ? get_default()(botListingComponent, "field_label", "") : dropdownValue
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: (emptwin_module_default()).right,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwin_Icons, {
                                                                                name: "chevron",
                                                                                className: (emptwin_module_default()).chevron
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                dropDownState["leadPlatform"] == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (emptwin_module_default()).editModalWrapper,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (emptwin_module_default()).modalBox,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (emptwin_module_default()).radiolanding,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (emptwin_module_default()).inputGroupWrapper,
                                                                                onChange: leadPlatformRadioChange,
                                                                                children: leadPlatformData.map(function(item, index) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                        className: (emptwin_module_default()).radioWrapper,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                                type: "radio",
                                                                                                className: (emptwin_module_default()).radioBox,
                                                                                                value: item,
                                                                                                name: "leadPlatformRadio",
                                                                                                defaultChecked: item == dropdownValue ? true : false
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: (emptwin_module_default()).radioCheckmark
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: (emptwin_module_default()).subLabel,
                                                                                                children: item
                                                                                            })
                                                                                        ]
                                                                                    });
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                }) : null
                                                            ]
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-7 col-xl-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (emptwin_module_default()).main,
                                                    children: alternateBotsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwin_Loader, {}) : alternateBots.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (emptwin_module_default()).noresults,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                                                src: "".concat(utility_endpoints/* default.drupalIp */.ZP.drupalIp).concat(get_default()(noResultComponent, "component.content.field_no_result_image[0].file_url", ""))
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                className: (emptwin_module_default()).head,
                                                                children: [
                                                                    " ",
                                                                    get_default()(noResultComponent, "component.content.field_title", "")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (emptwin_module_default()).content,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: get_default()(noResultComponent, "component.content.field_details", "")
                                                                }
                                                            })
                                                        ]
                                                    }) : alternateBots.length < 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (emptwin_module_default()).alternateBotsLessThan3,
                                                        children: alternateBots.map(function(bot, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (emptwin_module_default()).botcard,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                                                    data: bot,
                                                                    id: index
                                                                }, index)
                                                            });
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                                                        partialVisible: true,
                                                        responsive: responsive2,
                                                        ssr: true,
                                                        arrows: false,
                                                        transitionDuration: 0,
                                                        customButtonGroup: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup2, {}),
                                                        renderButtonGroupOutside: true,
                                                        infinite: true,
                                                        style: {
                                                            width: "100%"
                                                        },
                                                        children: alternateBots.map(function(bot, index) {
                                                            return bot._source.employeeTwinName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (emptwin_module_default()).botcard,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                                                    data: bot
                                                                }, index)
                                                            }) : null;
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    props.Etroles.includes(auth.email) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (emptwin_module_default()).filterbtn1,
                                        onClick: function() {
                                            return goTo(props.pageRoutes.CreateEmployeeTwin);
                                        },
                                        children: get_default()(botListingComponent, "field_input", "")
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (emptwin_module_default()).filterbtn,
                                        onClick: function() {
                                            return goTo(props.pageRoutes.Purchaseemployeetwin);
                                        },
                                        children: "Purchase Now"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (emptwin_module_default()).botstorePage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-12 my-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (emptwin_module_default()).head,
                                    children: [
                                        "Have a look at the",
                                        " ",
                                        get_default()(JSON.parse(localStorage.getItem("auth")), "data.personalLeadPlatform"),
                                        " ",
                                        "automations"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (emptwin_module_default()).content,
                                    children: get_default()(botListingComponent, "field_bot_listing_user_details", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (emptwin_module_default()).main,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                                            partialVisible: true,
                                            responsive: Employeetwin_responsive3,
                                            ssr: true,
                                            arrows: false,
                                            transitionDuration: 0,
                                            customButtonGroup: /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwin_ButtonGroup, {}),
                                            renderButtonGroupOutside: true,
                                            infinite: true,
                                            style: {
                                                width: "100%"
                                            },
                                            children: bots.map(function(bot, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (emptwin_module_default()).botcard,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                                        data: bot
                                                    }, index)
                                                });
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (emptwin_module_default()).parentbtn,
                                    onClick: function() {
                                        return goTo(props.pageRoutes.BotStore);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (emptwin_module_default()).btn,
                                        children: get_default()(botListingComponent, "field_input", "")
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((emptwin_module_default()).containerfluidbg, " container-fluid d-none d-md-block "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((emptwin_module_default()).contactLanding),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (emptwin_module_default()).head,
                                    children: get_default()(getInTouchComponent, "field_title", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (emptwin_module_default()).text,
                                    children: get_default()(getInTouchComponent, "field_message_input", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (emptwin_module_default()).btn,
                                    href: "mailto:automation.factory@unilever.com",
                                    children: get_default()(getInTouchComponent, "field_label", "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (emptwin_module_default()).image,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                        src: utility_endpoints/* default.drupalIp */.ZP.drupalIp + get_default()(getInTouchComponent, "field_get_in_touch_image[0].file_url", "")
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((emptwin_module_default()).contactLanding, " d-md-none"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (emptwin_module_default()).head,
                        children: get_default()(getInTouchComponent, "field_title", "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (emptwin_module_default()).text,
                        children: get_default()(getInTouchComponent, "field_message_input", "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (emptwin_module_default()).btn,
                        href: "mailto:sanjay.sharma@unilever.com",
                        children: get_default()(getInTouchComponent, "field_label", "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (emptwin_module_default()).image,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                            src: utility_endpoints/* default.drupalIp */.ZP.drupalIp + get_default()(getInTouchComponent, "field_get_in_touch_image[0].file_url", "")
                        })
                    })
                ]
            }),
            video ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                closeModal: function() {
                    setvideo(false);
                },
                name: "emptwin"
            }) : null,
            empModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperienceemptwinModal, {
                data: props.softskill.data.field_component,
                closeModal: function() {
                    setEmpModal(false);
                },
                pageRoutes: props.pageRoutes
            }) : null
        ]
    });
}
var Employeetwin_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function Employeetwin_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var Employeetwin = ((0,es/* connect */.$j)(Employeetwin_mapStateToProps, Employeetwin_mapDispatchToProps)(Employeetwin_index));

// EXTERNAL MODULE: ./styles/components/emptwinCart.module.scss
var emptwinCart_module = __webpack_require__(51301);
var emptwinCart_module_default = /*#__PURE__*/__webpack_require__.n(emptwinCart_module);
;// CONCATENATED MODULE: ./components/emptwincart/index.jsx

















function emptwincart_index(props) {
    document.body.style.overflow = "auto";
    var empid = JSON.parse(localStorage.getItem("empid"));
    var goTo = function(link) {
        router_default().push(link);
    };
    var ref = (0,react.useState)([]), localskill = ref[0], setLocalskill = ref[1];
    var ref1 = (0,react.useState)([]), globalskill = ref1[0], setGlobalskill = ref1[1];
    var ref2 = (0,react.useState)([]), softskill = ref2[0], setSoftskill = ref2[1];
    var ref3 = (0,react.useState)([]), localskilldata = ref3[0], setLocalskilldata = ref3[1];
    var ref4 = (0,react.useState)([]), globalskilldata = ref4[0], setGlobalskilldata = ref4[1];
    var ref5 = (0,react.useState)([]), softskilldata = ref5[0], setSoftskilldata = ref5[1];
    var ref6 = (0,react.useState)([]), products = ref6[0], setProducts = ref6[1];
    var ref7 = (0,react.useState)(""), ETname = ref7[0], setETname = ref7[1];
    var ref8 = (0,react.useState)("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/etdefault.jpg"), Etprofile = ref8[0], setEtprofile = ref8[1];
    var ref9 = (0,react.useState)([
        "jpg",
        "jpeg",
        "png", 
    ]), fileTypesp = ref9[0], setfileTypesp = ref9[1];
    // const [fileError, setError] = useState(false);
    var ref10 = (0,react.useState)(false), fileerror = ref10[0], setFileError = ref10[1];
    var ref11 = (0,react.useState)(false), filesuccess = ref11[0], setFilesuccess = ref11[1];
    var ref12 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref12[0], setSubmitForm = ref12[1];
    var ref13 = (0,react.useState)([
        "Mimi",
        "Aakartest",
        "Aarambhtest"
    ]), option = ref13[0], setoption = ref13[1];
    var ref14 = (0,react.useState)([]), optionname = ref14[0], setoptionname = ref14[1];
    var ref15 = (0,react.useState)(null), file = ref15[0], setFile = ref15[1];
    var ref16 = (0,react.useState)(null), fileNameOriginal = ref16[0], setFileName = ref16[1];
    var ref17 = (0,react.useState)(false), showFileName = ref17[0], setShowFileName = ref17[1];
    /*add Extra Local skill*/ /*end add Extra Local skill*/ var localHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/localSkill?empTwinId=").concat(empid),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code === 200) {
                            setLocalskill(data.data);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function localHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var globalHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/purchasecartTwin"),
                                method: "POST",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    employeeTwinID: empid,
                                    businessRequest: "".concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setGlobalskill(data.GlobalSkill);
                            setLocalskill(data.LocalSkill);
                            setSoftskill(data.softSkill);
                        // const botIDs = localskill.map((item) => item.botID);
                        // const processNames = localskill.map((item) => item.processName);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function globalHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var softHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/softSkill/search?empTwinId=").concat(empid),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code === 200) {
                            setSoftskill(data.data);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function softHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var deletelocalskill = function(botExternalId) {
        //console.log(botExternalId);
        var auth = JSON.parse(localStorage.getItem("auth")).data;
        var data = axios_default()({
            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/localSkill/deletepurchaseCart"),
            method: "DELETE",
            headers: {
                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
            },
            data: {
                businessRequest: "".concat(auth.email),
                skillID: botExternalId
            }
        }).then(function(resp) {
            //console.log(resp);
            if (resp.data.code === 200) {
                setLocalskill(function(oldValues) {
                    return oldValues.filter(function(localskill) {
                        return localskill !== botExternalId;
                    });
                });
            } else {
                console.log("No data found");
            }
        }).data;
    };
    var deleteglobalskill = function(botExternalId) {
        //console.log(botExternalId);
        //console.log(empid);
        var auth = JSON.parse(localStorage.getItem("auth")).data;
        var data = axios_default()({
            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/globalSkill/deletepurchaseCart"),
            method: "DELETE",
            headers: {
                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
            },
            data: {
                businessRequest: "".concat(auth.email),
                skillID: botExternalId
            }
        }).then(function(resp) {
            //console.log(resp);
            if (resp.data.code === 200) {
                setGlobalskill(function(oldValues) {
                    return oldValues.filter(function(globalskill) {
                        return globalskill !== botExternalId;
                    });
                });
            } else {
                console.log("No data found");
            }
        }).data;
    };
    var deletesoftskill = function(softSkillID) {
        //console.log(softSkillID);
        //console.log(softSkillID);
        var auth = JSON.parse(localStorage.getItem("auth")).data;
        var data = axios_default()({
            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/softSkill/deletepurchaseCart"),
            method: "DELETE",
            headers: {
                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
            },
            data: {
                businessRequest: "".concat(auth.email),
                skillID: softSkillID
            }
        }).then(function(resp) {
            //console.log(resp);
            if (resp.data.code === 200) {
                setSoftskill(function(oldValues) {
                    return oldValues.filter(function(softskill) {
                        return softskill !== softSkillID;
                    });
                });
            } else {
                console.log("No data found");
            }
        }).data;
    };
    var onValueChange = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = e.target.value;
                console.log(e.target.id, e.target.value);
                if (e.target.id == "etname") {
                    setETname(e.target.value);
                }
                return [
                    2
                ];
            });
        });
        return function onValueChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var azurefilepath;
    var blobSasUrl = "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
    var blobSasUrlNew = utility_endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    // "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin/emp");
    var uploadFile = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(imageFile) {
            var originalFileName, fileName, index, extension, blockBlobClient, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        {}
                        originalFileName = imageFile.name;
                        fileName = originalFileName;
                        index = 1;
                        _state.label = 1;
                    case 1:
                        return [
                            4,
                            containerClient.getBlockBlobClient(fileName).exists()
                        ];
                    case 2:
                        if (!_state.sent()) return [
                            3,
                            3
                        ];
                        {
                            extension = originalFileName.substring(originalFileName.lastIndexOf("."));
                            fileName = "".concat(originalFileName.substring(0, originalFileName.lastIndexOf(".")), "_").concat(index).concat(extension);
                            index++;
                        }
                        return [
                            3,
                            1
                        ];
                    case 3:
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(imageFile)
                        ];
                    case 5:
                        _state.sent();
                        console.log("Image uploaded successfully!");
                        setEtprofile("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + fileName);
                        setFilesuccess(true);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        setFileError(true);
                        console.error("Error uploading image:", error);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadFile(imageFile) {
            return _ref.apply(this, arguments);
        };
    }();
    var uploadButtonClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var fileNameWithSpaces, fileName, ar, extension, fileSize, blockBlobClient, options, resp, url, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fileNameWithSpaces = fileNameOriginal;
                        fileName = fileNameWithSpaces.replace(/ /g, "");
                        ar = fileNameOriginal.split(".");
                        extension = ar[ar.length - 1];
                        fileSize = file.size;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        console.log(resp, "response of azure");
                        url = resp._response.request.url;
                        setSuccessModal(true);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error, "erro");
                        alert("Could not upload");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var onFromSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var authCheck, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        if (!(ETname == "")) return [
                            3,
                            1
                        ];
                        setSubmitForm(true);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 2:
                        auth = _state.sent();
                        axios_default()({
                            method: "post",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/employee_order"),
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            },
                            data: {
                                "orderID": "",
                                businessRequest: "".concat(auth.email),
                                globalSkill: globalid.join(","),
                                localSkill: localid.join(","),
                                softSkill: softid.join(","),
                                product_id: productid.join(","),
                                GlobalSkill_ProcessName: GlobalSkill_ProcessName.join(","),
                                localSkill_ProcessName: localSkill_ProcessName.join(","),
                                softSkill_ProcessName: softSkill_ProcessName.join(","),
                                productSkill_ProcessName: productSkill_ProcessName.join(","),
                                ETname: ETname,
                                Etprofile: Etprofile
                            }
                        }).then(function(resp) {
                            if (resp.data.code == 403) {
                                setLoading(false);
                            } else if (resp.status == 200) {
                                //console.log(resp.data);
                                localStorage.setItem("orderid", JSON.stringify(resp.data.data.orderID));
                                localStorage.setItem("livedate", JSON.stringify(resp.data.data.goLiveDate));
                                // console.log(resp.data);
                                //           emailHandler();    
                                router_default().push(props.pageRoutes.Order);
                            } else if (resp.data.code == 400) {}
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFromSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    {}
    var deleteproduct = function(product_id) {
        //console.log(product_id);
        var auth = JSON.parse(localStorage.getItem("auth")).data;
        var data = axios_default()({
            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/product/deletepurchaseCart"),
            method: "DELETE",
            headers: {
                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
            },
            data: {
                businessRequest: "".concat(auth.email),
                skillID: product_id
            }
        }).then(function(resp) {
            //console.log(resp);
            if (resp.data.code === 200) {
                setProducts(function(oldValues) {
                    return oldValues.filter(function(products) {
                        return products !== product_id;
                    });
                });
            } else {
                console.log("No data found");
            }
        }).data;
    };
    var productHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/getProductCart"),
                                method: "POST",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    businessRequest: "".concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setProducts(data.data);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function productHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref18 = (0,react.useState)([]), twinname = ref18[0], settwinname = ref18[1];
    var twinHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data, nonEmptyValues, uniqueArray;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/getTwinname"),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code === 200) {
                            nonEmptyValues = data.data.filter(function(value) {
                                return value !== "";
                            });
                            settwinname(nonEmptyValues);
                            uniqueArray = (0,src_to_consumable_array/* default */.Z)(option.filter(function(element) {
                                return !nonEmptyValues.includes(element);
                            })).concat((0,src_to_consumable_array/* default */.Z)(nonEmptyValues.filter(function(element) {
                                return !option.includes(element);
                            })));
                            setoptionname(uniqueArray);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function twinHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        twinHandler();
    }, [
        twinname
    ]);
    react.useEffect(function() {
        productHandler();
    }, [
        products
    ]);
    // React.useEffect(() => {
    //   localHandler();
    // },[localskill]);
    react.useEffect(function() {
        globalHandler();
    }, [
        globalskill
    ]);
    // React.useEffect(() => {
    //   softHandler();
    // },[softskill])
    var globalid = globalskill.map(function(item, index) {
        return item.botExternalId;
    });
    var localid = localskill.map(function(item, index) {
        return item.botExternalId;
    });
    var softid = softskill.map(function(item, index) {
        return item.softSkillID;
    });
    var productid = products.map(function(item, index) {
        return item.product_id;
    });
    var GlobalSkill_ProcessName = globalskill.map(function(item, index) {
        return item.processName;
    });
    var localSkill_ProcessName = localskill.map(function(item, index) {
        return item.processName;
    });
    var softSkill_ProcessName = softskill.map(function(item, index) {
        return item.skillName;
    });
    var productSkill_ProcessName = products.map(function(item, index) {
        return item.product_title;
    });
    var handleFileChange = function(event) {
        var file = event.target.files[0];
        if (file) {
            uploadFile(file);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((emptwinCart_module_default()).emptwinbannerWrapper1, " container"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((emptwinCart_module_default()).row, " row pb-4"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                class: "col-lg-12 col-md-12 col-12 pt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                    className: (emptwinCart_module_default()).tableskill,
                    cellSpacing: "10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            className: (emptwinCart_module_default()).bottext1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: (emptwinCart_module_default()).heading,
                                        children: "My Automation Bag"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (emptwinCart_module_default()).heading,
                                            children: "1 Item"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            className: (emptwinCart_module_default()).bottext2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (emptwinCart_module_default()).text,
                                        children: "Bot Product"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (emptwinCart_module_default()).text,
                                        children: "Action"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            className: (emptwinCart_module_default()).skilllist,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                className: (emptwinCart_module_default()).firsttd,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/soft.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: (emptwinCart_module_default()).skillheading,
                                        children: [
                                            "Soft Skills",
                                            softskill.map(function(item, index) {
                                                var softSkillID = item.softSkillID, skillName = item.skillName, category = item.category;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "".concat((emptwinCart_module_default()).skillslisttext),
                                                    id: softSkillID,
                                                    children: [
                                                        skillName,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "remove",
                                                            onClick: function() {
                                                                deletesoftskill(softSkillID);
                                                            },
                                                            children: "\uD83D\uDDD9"
                                                        })
                                                    ]
                                                });
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            className: (emptwinCart_module_default()).skilllist,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                className: (emptwinCart_module_default()).firsttd,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/global.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: (emptwinCart_module_default()).skillheading,
                                        children: [
                                            "Global Skills",
                                            globalskill.map(function(item, index) {
                                                var botExternalId = item.botExternalId, processName = item.processName;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "".concat((emptwinCart_module_default()).skillslisttext),
                                                    id: botExternalId,
                                                    children: [
                                                        processName,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "remove",
                                                            onClick: function() {
                                                                deleteglobalskill(botExternalId);
                                                            },
                                                            children: "\uD83D\uDDD9"
                                                        })
                                                    ]
                                                });
                                            }),
                                            products.map(function(item, index) {
                                                var product_id = item.product_id, product_title = item.product_title, lead_platform = item.lead_platform, subarea = item.subarea;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "".concat((emptwinCart_module_default()).skillslisttext),
                                                    id: product_id,
                                                    children: [
                                                        product_title,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "remove",
                                                            onClick: function() {
                                                                deleteproduct(product_id);
                                                            },
                                                            children: "\uD83D\uDDD9"
                                                        })
                                                    ]
                                                });
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            className: (emptwinCart_module_default()).skilllist,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                className: (emptwinCart_module_default()).firsttd,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/local.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: (emptwinCart_module_default()).skillheading,
                                        children: [
                                            "Local Skills",
                                            localskill.map(function(item, index) {
                                                var botExternalId = item.botExternalId, processName = item.processName;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "".concat((emptwinCart_module_default()).skillslisttext),
                                                    id: botExternalId,
                                                    children: [
                                                        processName,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "remove",
                                                            onClick: function() {
                                                                deletelocalskill(botExternalId);
                                                            },
                                                            children: "\uD83D\uDDD9"
                                                        })
                                                    ]
                                                });
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            className: (emptwinCart_module_default()).skilllist,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    style: {
                                        width: "50%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-12 col-md-12 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (emptwinCart_module_default()).formGroup,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((emptwinCart_module_default()).uploadBtnWrapper),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (emptwinCart_module_default()).uploadFileContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (emptwinCart_module_default()).mainLabel,
                                                            children: [
                                                                "Employee Twin Name",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                    className: (emptwinCart_module_default()).mandatoryField,
                                                                    children: "*"
                                                                }),
                                                                submitForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (emptwinCart_module_default()).errorMessage,
                                                                    children: "Please Choose Employee Twin Name"
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                            className: (emptwinCart_module_default()).select,
                                                            id: "etname",
                                                            name: "etname",
                                                            onChange: onValueChange,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    defaultValue: true,
                                                                    children: " Choose Your Employee Twin Name"
                                                                }),
                                                                optionname.map(function(item) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: item,
                                                                        children: item
                                                                    });
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    style: {
                                        width: "50%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-12 col-md-12 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (emptwinCart_module_default()).formGroup,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((emptwinCart_module_default()).uploadBtnWrapper),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (emptwinCart_module_default()).uploadFileContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (emptwinCart_module_default()).mainLabel,
                                                            children: [
                                                                "Upload Profile",
                                                                filesuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    style: {
                                                                        color: "#00b190",
                                                                        fontSize: "12px"
                                                                    },
                                                                    children: "Uploaded Successfully"
                                                                }) : null,
                                                                fileerror ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    style: {
                                                                        color: "red",
                                                                        fontSize: "12px"
                                                                    },
                                                                    children: "Error when uploading"
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (emptwinCart_module_default()).uploadControl,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "file",
                                                                onChange: function(e) {
                                                                    handleFileChange(e);
                                                                },
                                                                className: (emptwinCart_module_default()).fileupload
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            styles: {
                                height: "100px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/back.png",
                                        onClick: function() {
                                            return goTo(props.pageRoutes.Purchaseemployeetwin);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (emptwinCart_module_default()).submitbtn,
                                            onClick: onFromSubmit,
                                            children: "Submit"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./components/Pages/Cartmodal/index.jsx
var Cartmodal = __webpack_require__(39775);
;// CONCATENATED MODULE: ./components/Employeetwinskills/index.jsx







var Employeetwinskills_Icons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18023));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18023)
            ];
        }
    }
});
var Employeetwinskills_Card = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 71835));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71835)
            ];
        }
    }
});



var Employeetwinskills_BasicForm = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35842)
            ];
        }
    }
});
var Employeetwinskills_Video = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3292).then(__webpack_require__.bind(__webpack_require__, 93292));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93292)
            ];
        }
    }
});
var Employeetwinskills_Empbanner = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2443), __webpack_require__.e(9795)]).then(__webpack_require__.bind(__webpack_require__, 59795));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59795)
            ];
        }
    }
});
var Emptwinskills = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2443), __webpack_require__.e(9698)]).then(__webpack_require__.bind(__webpack_require__, 89698));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89698)
            ];
        }
    }
});
var Employeetwinskills_Filters = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9944).then(__webpack_require__.bind(__webpack_require__, 99944));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99944)
            ];
        }
    }
});






var Employeetwinskills_SuccessModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 99696));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99696)
            ];
        }
    }
});

var Employeetwinskills_Loader = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 16330));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16330)
            ];
        }
    }
});




function Employeetwinskills_index(props) {
    var openpopup = function openpopup() {
        var modal = !cartModal;
        setCartModal(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var router = (0,next_router.useRouter)();
    console.log("props  ------ Employeetwin page  -----", props);
    var initialStates = {};
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref[0], setState = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref1[0], setSubmitForm = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref2[0], setInvalidFlag = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref3[0], setGetFormValues = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref4[0], setEmptyFormValues = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), bots = ref5[0], setBots = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref6[0], setSuccessModal = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), cartModal = ref7[0], setCartModal = ref7[1];
    var ref8 = (0,react.useState)([]), empdata = ref8[0], setEmpdata = ref8[1];
    var backgroundUrlMobile = get_default()(props.data[0], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl = get_default()(props, "data[0]component.content.field_background_image[0].file_url", "");
    var emptwinDetails = get_default()(props, "data[0].component.content.field_details", "");
    var emptwinHeading = get_default()(props, "data[0]component.content.field_hedaing", "");
    var backgroundUrlMobile1 = get_default()(props.data[10], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl1 = get_default()(props, "data[10]component.content.field_background_image[0].file_url", "");
    var backgroundUrl11 = get_default()(props, "data[0].component.content.field_background_image[1].file_url", "");
    console.log("backgroundUrl11", backgroundUrl11);
    // console.log('getting all images',props.data[0].component.content.field_background_image[1].file_url);
    var emptwinDetails1 = get_default()(props, "data[10].component.content.field_details", "");
    var emptwinHeading1 = get_default()(props, "data[10]component.content.field_hedaing", "");
    var backgroundUrlMobileemptwin = get_default()(props.data[11], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrlemptwin = get_default()(props, "data[11]component.content.field_background_image[0].file_url", "");
    var goTo = function(link) {
        // console.log(link);
        router.push(link);
    };
    var moveToCez = function(sectionName) {
        router.push({
            pathname: props.pageRoutes.CognitiveExperienceZone,
            query: {
                cezSection: sectionName
            }
        });
    };
    var empid = JSON.parse(localStorage.getItem("empid"));
    console.log(empid);
    var localHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/search?empTwinId=").concat(empid),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        console.log(data);
                        if (data.code === 200) {
                            setEmpdata(data.allSkill[0]);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function localHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var reactRef = react.useRef(null);
    react.useEffect(function() {
        localHandler();
    }, []);
    console.log(empdata);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((emptwin_module_default()).landingContainer),
        children: [
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwinskills_SuccessModal, {
                setSuccessModal: setSuccessModal,
                title: "Request a demo",
                message: message
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "headTop"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwinskills_Empbanner, {
                data: {
                    emptwinDetails: emptwinDetails,
                    emptwinHeading: emptwinHeading,
                    backgroundUrl: backgroundUrl,
                    backgroundUrl11: backgroundUrl11,
                    backgroundUrlMobile: backgroundUrlMobile
                },
                name: "employeetwinskills",
                empid: empid,
                empdata: empdata
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Emptwinskills, {
                data: {
                    emptwinDetails1: emptwinDetails1,
                    emptwinHeading1: emptwinHeading1,
                    backgroundUrl1: backgroundUrl1,
                    backgroundUrlMobile1: backgroundUrlMobile1
                },
                name: "employeetwinskills",
                allskillsData: props.data,
                data1: props.softskill1,
                empid: empid
            }),
            cartModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Cartmodal/* default */.Z, {
                data: props.softskill.data.field_component,
                closeModal: function() {
                    setCartModal(false);
                },
                pageRoutes: props.pageRoutes,
                empid: empid
            }) : null
        ]
    });
}
var Employeetwinskills_mapStateToProps = function(state) {
    console.log("state", state);
    return {
        session: state.session.session
    };
};
function Employeetwinskills_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var Employeetwinskills = ((0,es/* connect */.$j)(Employeetwinskills_mapStateToProps, Employeetwinskills_mapDispatchToProps)(Employeetwinskills_index));

;// CONCATENATED MODULE: ./components/Employeetwinsdetails/index.jsx







var Employeetwinsdetails_Icons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18023));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18023)
            ];
        }
    }
});
var Employeetwinsdetails_Card = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 71835));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71835)
            ];
        }
    }
});



var Employeetwinsdetails_BasicForm = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35842)
            ];
        }
    }
});
var Employeetwinsdetails_Video = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3292).then(__webpack_require__.bind(__webpack_require__, 93292));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93292)
            ];
        }
    }
});
//const Empbanner = dynamic(() => import("../emptwindetailBanner"));
var Employeetwinsdetails_Empbanner = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2443), __webpack_require__.e(3424)]).then(__webpack_require__.bind(__webpack_require__, 83424));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83424)
            ];
        }
    }
});
//const Emptwinskills = dynamic(() => import("../emptwinskills"));
var Employeetwinsdetails_Emptwinskills = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2443), __webpack_require__.e(9698)]).then(__webpack_require__.bind(__webpack_require__, 89698));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89698)
            ];
        }
    }
});
var Employeetwinsdetails_Filters = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9944).then(__webpack_require__.bind(__webpack_require__, 99944));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99944)
            ];
        }
    }
});






var Employeetwinsdetails_SuccessModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 99696));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99696)
            ];
        }
    }
});

var Employeetwinsdetails_Loader = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 16330));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16330)
            ];
        }
    }
});




function Employeetwinsdetails_index(props) {
    var openpopup = function openpopup() {
        var modal = !cartModal;
        setCartModal(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var router = (0,next_router.useRouter)();
    //console.log("props  ------ Employeetwin page  -----", props);
    var initialStates = {};
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref[0], setState = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref1[0], setSubmitForm = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref2[0], setInvalidFlag = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref3[0], setGetFormValues = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref4[0], setEmptyFormValues = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), bots = ref5[0], setBots = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref6[0], setSuccessModal = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), cartModal = ref7[0], setCartModal = ref7[1];
    var ref8 = (0,react.useState)([]), empdata = ref8[0], setEmpdata = ref8[1];
    var ref9 = (0,react.useState)([]), softskilldata = ref9[0], setSoftskilldata = ref9[1];
    var backgroundUrlMobile = get_default()(props.data[0], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl = get_default()(props, "data[0]component.content.field_background_image[0].file_url", "");
    var emptwinDetails = get_default()(props, "data[0].component.content.field_details", "");
    var emptwinHeading = get_default()(props, "data[0]component.content.field_hedaing", "");
    var backgroundUrlMobile1 = get_default()(props.data[10], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl1 = get_default()(props, "data[10]component.content.field_background_image[0].file_url", "");
    var backgroundUrl11 = get_default()(props, "data[0].component.content.field_background_image[1].file_url", "");
    //console.log('backgroundUrl11',backgroundUrl11);
    // console.log('getting all images',props.data[0].component.content.field_background_image[1].file_url);
    var emptwinDetails1 = get_default()(props, "data[10].component.content.field_details", "");
    var emptwinHeading1 = get_default()(props, "data[10]component.content.field_hedaing", "");
    var backgroundUrlMobileemptwin = get_default()(props.data[11], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrlemptwin = get_default()(props, "data[11]component.content.field_background_image[0].file_url", "");
    var goTo = function(link) {
        // console.log(link);
        router.push(link);
    };
    var moveToCez = function(sectionName) {
        router.push({
            pathname: props.pageRoutes.CognitiveExperienceZone,
            query: {
                cezSection: sectionName
            }
        });
    };
    var search = window.location.search;
    var params = new URLSearchParams(search);
    var empid = params.get("empTwinId");
    //console.log(empid);
    localStorage.setItem("empid", JSON.stringify(empid));
    var reactRef = react.useRef(null);
    var localHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/search?empTwinId=").concat(empid),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setEmpdata(data.allSkill[0]);
                            setSoftskilldata(data.softSkill);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function localHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        localHandler();
    }, []);
    //console.log(empdata);
    var auth = JSON.parse(localStorage.getItem("auth")).data;
    //console.log(auth.email);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((emptwin_module_default()).landingContainer),
        children: [
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwinsdetails_SuccessModal, {
                setSuccessModal: setSuccessModal,
                title: "Request a demo",
                message: message
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "headTop"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwinsdetails_Empbanner, {
                data: {
                    emptwinDetails: emptwinDetails,
                    emptwinHeading: emptwinHeading,
                    backgroundUrl: backgroundUrl,
                    backgroundUrl11: backgroundUrl11,
                    backgroundUrlMobile: backgroundUrlMobile
                },
                name: "employeetwinskills",
                empdata: empdata
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwinsdetails_Emptwinskills, {
                data: {
                    emptwinDetails1: emptwinDetails1,
                    emptwinHeading1: emptwinHeading1,
                    backgroundUrl1: backgroundUrl1,
                    backgroundUrlMobile1: backgroundUrlMobile1
                },
                name: "employeetwindetails",
                allskillsData: props.data,
                data1: props.softskill1,
                empid: empid,
                softskilldata: softskilldata
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((emptwin_module_default()).btndiv, " col-md-12 "),
                children: [
                    props.Etroles.includes(auth.email) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (emptwin_module_default()).editbtn,
                        onClick: function() {
                            return goTo(props.pageRoutes.EditEmployeeTwin);
                        },
                        children: "Edit"
                    }) : null,
                    empid == "ET00001" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return goTo(props.pageRoutes.ManageEmployeetwin);
                        },
                        className: (emptwin_module_default()).addtocartbtn,
                        children: "Manage Employee Twin"
                    }) : null
                ]
            }),
            cartModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Cartmodal/* default */.Z, {
                data: props.softskill.data.field_component,
                closeModal: function() {
                    setCartModal(false);
                },
                pageRoutes: props.pageRoutes,
                empid: empid
            }) : null
        ]
    });
}
var Employeetwinsdetails_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function Employeetwinsdetails_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var Employeetwinsdetails = ((0,es/* connect */.$j)(Employeetwinsdetails_mapStateToProps, Employeetwinsdetails_mapDispatchToProps)(Employeetwinsdetails_index));

// EXTERNAL MODULE: ./styles/components/softskillDetails.module.scss
var softskillDetails_module = __webpack_require__(78962);
var softskillDetails_module_default = /*#__PURE__*/__webpack_require__.n(softskillDetails_module);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(1864);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
;// CONCATENATED MODULE: ./components/SoftSkillsDetails/index.jsx





















// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // import { faQuoteLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
function SoftSkillsDetails_index(props) {
    var camelize = function camelize(str) {
        if (str === undefined) {
            return null;
        } else {
            return str.toString().replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
                return index === 0 ? word.toLowerCase() : word.toUpperCase();
            }).replace(/\s+/g, "");
        }
    };
    //console.log(props, "props at bot detail");
    //const routes = props.globalData.menu_component.menu_list;
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), myBot = ref[0], setMyBot = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)(); //"businessUserRegionWise", // //"businessUserRegionWise",
    var ref1 = (0,react.useState)(true), restrictedViewDetails = ref1[0], setRestrictedViewDetails = ref1[1];
    var restrictedUserDocumentView = [
        "businessUserRegionWise",
        "endUser",
        "businessOwner", 
    ];
    var restrictedDocumentTypes = [
        "SOP",
        "PDD"
    ];
    var documentAr = [
        {
            title: "SOP",
            value: "sopDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "PDD",
            value: "pddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "PDD Approval",
            value: "pddApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "SDD",
            value: "sddDocument",
            type: [
                ".pdf",
                ".doc",
                ".docx"
            ]
        },
        {
            title: "QSG",
            value: "qsgDocument",
            type: [
                ".doc",
                ".docx"
            ]
        },
        {
            title: "ODI",
            value: "odiDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "BRD",
            value: "brdDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Cost Apporval",
            value: "costApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Landscape Approval",
            value: "explicitLandscapeApplicationOwnerApprovalDocument",
            type: ".msg"
        },
        {
            title: "GPM Approval",
            value: "explicitGPMApprovalSupplyChainFinanceDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "GFCF Approval",
            value: "explicitGFCFApprovalDocument",
            type: [
                ".msg",
                ".png"
            ]
        },
        {
            title: "Dev Quality Crendentails Available",
            value: "devQualityCredentialsAvailableDocument",
            type: ".msg"
        },
        {
            title: "Infosec Approval",
            value: "infosecApprovalDocument",
            type: ".msg"
        },
        {
            title: "DA Review Sign Off",
            value: "dAReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "Test Data Development",
            value: "testDataAvailableForDevelopmentDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Request Raised Product Credentials",
            value: "requestRaisedForProductionCredentialsDocument",
            type: ".msg"
        },
        {
            title: "Internal Testing Completed",
            value: "internalTestingCompletedDocument",
            type: ".msg"
        },
        {
            title: "Peer Review Sign Off",
            value: "peerReviewSignOffDocument",
            type: ".msg"
        },
        {
            title: "DA Review Second Sign Off",
            value: "daReviewSecondSignOffDocument",
            type: ".msg"
        },
        {
            title: "BP Release Sign Off",
            value: "bpReleaseSignOffFromDaDocument",
            type: ".msg"
        },
        {
            title: "UAT Scripts With Results",
            value: "uatScriptsWithResultsDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Release Manager Sign Off",
            value: "releaseManagerSignOffDocument",
            type: ".msg"
        },
        {
            title: "Gate Form",
            value: "gateFormDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "Peer Review Checklist",
            value: "peerReviewchecklistDocument",
            type: [
                ".xlxs",
                ".xls"
            ]
        },
        {
            title: "QA Sign Off",
            value: "qaSignOffDocument",
            type: ".msg"
        },
        {
            title: "Walk Through Video",
            value: "walkthroughVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        },
        {
            title: "KT Video",
            value: "ktVideo",
            type: [
                ".mov",
                ".mp4",
                ".avi"
            ]
        }, 
    ];
    var search = window.location.search;
    var params = new URLSearchParams(search);
    var softSkillID = params.get("softSkillID");
    //console.log(softSkillID);
    var ref2 = (0,react.useState)([]), documentTypes = ref2[0], setDocumentTypes = ref2[1];
    react.useEffect(function() {
        //console.log("mybotUse Effect");
        //console.log("auth --mybot", auth);
        //console.log("mybotUse", myBot);
        if (myBot != null) {
            //console.log("Restricted User", restrictedUser);
            if (myBot.businessOwnerEmailID == auth.email) {
                setRestrictedViewDetails(false);
            } else if (restrictedUser.includes(auth.userType)) {
                setRestrictedViewDetails(true);
            } else {
                setRestrictedViewDetails(false);
            }
            //console.log("my bot bot detail end user ---", myBot);
            var documentsToSet = [];
            for(var i in documentAr){
                {}
                if (myBot[documentAr[i]["value"]] !== undefined && myBot[documentAr[i]["value"]] !== null && myBot[documentAr[i]["value"]] !== "" && myBot[documentAr[i]["value"]] !== "can be empty") {
                    //console.log("what Input doc-----", myBot[documentAr[i]["value"]]);
                    documentsToSet.push(documentAr[i].title);
                }
            }
            // if (myBot.botDemoVideo != undefined && myBot.botDemoVideo !== "" && myBot.botDemoVideo != undefined) {
            //   documentsToSet.push("Bot Demo Vedio");
            // }
            //console.log(documentsToSet, "DOCumentstoset");
            if (restrictedUserDocumentView.includes(auth.userType)) {
                if (auth.userType == "businessOwner") {
                    //console.log(myBot.businessOwnerEmailID, "DOCumentstoset");
                    //console.log(auth.email, "DOCumentstoset");
                    if (myBot.businessOwnerEmailID == auth.email) {
                        //console.log(documentsToSet, "DOCumentstoset");
                        setDocumentTypes((0,src_to_consumable_array/* default */.Z)(documentsToSet));
                    } else {
                        var restrictedNewDocumented = [];
                        if (documentsToSet.includes("SOP")) {
                            restrictedNewDocumented.push("SOP");
                        }
                        if (documentsToSet.includes("PDD")) {
                            restrictedNewDocumented.push("PDD");
                        }
                        setDocumentTypes(restrictedNewDocumented);
                    }
                } else {
                    var restrictedNewDocumented1 = [];
                    if (documentsToSet.includes("SOP")) {
                        restrictedNewDocumented1.push("SOP");
                    }
                    if (documentsToSet.includes("PDD")) {
                        restrictedNewDocumented1.push("PDD");
                    }
                    setDocumentTypes(restrictedNewDocumented1);
                }
            } else {
                setDocumentTypes(documentsToSet);
            }
        }
    }, [
        myBot
    ]);
    var ref3 = (0,react.useState)([
        "endUser",
        "businessUserRegionWise",
        "businessOwner",
        "firstGfcf",
        "gfcf",
        "firstLevelGPMApprover",
        "GPMapprover",
        "gCad",
        "infosec",
        "landscape", 
    ]), restrictedUser = ref3[0], setRestrictedUser = ref3[1];
    var ref4 = (0,react.useState)([
        "internalUser",
        "support",
        "releaseManager",
        "editAccess",
        "admin", 
    ]), allFieldsUserType = ref4[0], setallFieldsUserType = ref4[1];
    var ref5 = (0,react.useState)([
        "internalUser",
        "admin",
        "qrManager",
        "releaseManager",
        "supportStatus", 
    ]), editUser = ref5[0], setEditUser = ref5[1];
    var ref6 = (0,react.useState)(false), botModal = ref6[0], setbotModal = ref6[1];
    var ref7 = (0,react.useState)(true), Loading = ref7[0], setLoading = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), bots = ref8[0], setBots = ref8[1];
    var ref9 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref9[0], setSuccessModal = ref9[1];
    var ref10 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), documentDropdown = ref10[0], setDocumentDropdown = ref10[1];
    var ref11 = (0,src_sliced_to_array/* default */.Z)(react.useState("sopDocument"), 2), selectedDropdown = ref11[0], setSelectedDropdown = ref11[1];
    var ref12 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), similarBots = ref12[0], setSimilarBots = ref12[1];
    var ref13 = (0,src_sliced_to_array/* default */.Z)(react.useState("pdf"), 2), currentDocumentExtension = ref13[0], setCurrentDocumentExtension = ref13[1];
    var ref14 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), searchResults = ref14[0], setSearchResults = ref14[1];
    var ref15 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), documentEditState = ref15[0], setDocumentEditState = ref15[1];
    var ref16 = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), editedDocument = ref16[0], setEditedDocument = ref16[1];
    var ref17 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), editLoader = ref17[0], setEditLoader = ref17[1];
    var ref18 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidModal = ref18[0], setInvalidModal = ref18[1];
    var ref19 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), skilldetails = ref19[0], setSkilldetails = ref19[1];
    var getData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                axios_default()({
                    method: "get",
                    url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/softSkill/get?softSkillID=").concat(softSkillID),
                    headers: {
                        Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                    }
                }).then(function(resp) {
                    setSkilldetails(resp.data.data);
                });
                return [
                    2
                ];
            });
        });
        return function getData() {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        getData();
    }, []);
    //console.log("skilldetails", skilldetails);
    react.useEffect(function() {
    //console.log(currentDocumentExtension, "currentDocument");
    }, [
        currentDocumentExtension
    ]);
    var auth = lodash_default().get(JSON.parse(localStorage.getItem("auth")), "data", "");
    var openDocumentSelector = function() {
        setDocumentDropdown(!documentDropdown);
    };
    var ref20 = (0,react.useState)(""), authData = ref20[0], setAuthData = ref20[1];
    react.useEffect(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var authCheck, expiryStatus, auth;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authCheck = lodash_default().get(JSON.parse(localStorage.getItem("auth")), "data", "");
                    return [
                        4,
                        props.checkExpiry(authCheck)
                    ];
                case 1:
                    expiryStatus = _state.sent();
                    if (expiryStatus) {
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        fetchbot(auth);
                    } else {
                        setLoading(false);
                        props.sessionTimeOutCheck(true);
                    }
                    if (router.query.searchResults) {
                        setSearchResults(true);
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        router.query
    ]);
    var fetchbot = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(auth) {
            var authCheck, expiryStatus;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setAuthData(auth);
                        if (!router.query.botID) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        authCheck = _state.sent();
                        return [
                            4,
                            props.checkExpiry(authCheck)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (expiryStatus) {
                            axios_default()({
                                method: "get",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/getBotUsingId?botID=").concat(window.atob(router.query.botID)),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            }).then(function(res) {
                                if (res.data.code == 200) {
                                    if (res.data.data) {
                                        if (res.data.data.dateOfStatusChanged) {
                                            res.data.data.dateOfStatusChanged = res.data.data.dateOfStatusChanged.slice(0, 10);
                                        }
                                    }
                                    setMyBot(res.data.data);
                                    var initialExtensionAr = res.data.data.sopDocument.split(".");
                                    //console.log(initialExtensionAr, "initialExtensionAr");
                                    dispatch((0,storeBot_actions/* saveCurrentBot */.B1)(res.data.data));
                                    setLoading(false);
                                    if (initialExtensionAr.length > 1) {
                                        setCurrentDocumentExtension(initialExtensionAr[initialExtensionAr.length - 1]);
                                    }
                                    // if (res.data.data && (res.data.data.documentLink || res.data.data.path)) {
                                    //   setEditedDocument(res.data.data.documentLink ? res.data.data.documentLink : res.data.data.path)
                                    // }
                                    // fetching similar bots
                                    axios_default()({
                                        method: "get",
                                        url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/elastic/searchQuery"),
                                        params: {
                                            leadPlatform: res.data.data.leadPlatform
                                        },
                                        headers: {
                                            Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                        }
                                    }).then(function(resp) {
                                        if (resp.data.code == 200) {
                                            //console.log("response of similar bots elastic");
                                            setSimilarBots(resp.data.data.allBots.filter(function(item) {
                                                return item._source.botID != res.data.data.botID;
                                            }));
                                        // dispatch(saveBotsAction({ data: resp.data.data, filter: "filter" }));
                                        } else if (resp.data.code == 403) {
                                            localStorage.removeItem("auth");
                                            sessionStorage.clear();
                                            // router.push("/login");
                                            setLoading(false);
                                            props.sessionTimeOutCheck(true);
                                        }
                                    });
                                } else if (res.data.code == 403) {
                                    localStorage.removeItem("auth");
                                    sessionStorage.clear();
                                    // router.push("/login");
                                    setLoading(false);
                                    props.sessionTimeOutCheck(true);
                                }
                            });
                        } else {
                            setLoading(false);
                            props.sessionTimeOutCheck(true);
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchbot(auth) {
            return _ref.apply(this, arguments);
        };
    }();
    var frameRef = react.useRef(null);
    react.useEffect(function() {
        //console.log("myBot_Props", props);
        if (props.type == "previewPage") {
            setMyBot(props.myBot);
            setLoading(false);
            var initialExtensionAr = props.myBot.sopDocument.split(".");
            //console.log(initialExtensionAr, "initialExtensionAr");
            if (initialExtensionAr.length > 1) {
                setCurrentDocumentExtension(initialExtensionAr[initialExtensionAr.length - 1]);
            }
        }
        if (frameRef.current != null) {
            frameRef.current.contentWindow.location.reload();
        }
    //console.log(document.getElementById("youriframe"), "youriframe");
    //console.log(frameRef, "youriframe");
    }, []);
    var getBot = function() {
        var modal = !botModal;
        setbotModal(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var editBot = function() {
        router.push("/editBot");
    };
    var gotDropDownValue = function(value, dropdownParent, haveRelated) {
        // console.log(documentAr, "DOCUMENTAR")
        // console.log(value,"valueee")
        var selectedDocument = documentAr.filter(function(item, index) {
            return item.title == value;
        });
        // console.log(selectedDocument[0].value, "selected Dropdown")
        setSelectedDropdown(selectedDocument[0].value);
        //console.log(myBot[selectedDocument[0].value], "ye value check karne ka");
        //console.log(myBot[selectedDocument[0].value], "valueeeeesss");
        var extensionAr = myBot[selectedDocument[0].value].split(".");
        var extension = extensionAr[extensionAr.length - 1];
        setCurrentDocumentExtension(extension);
        setDocumentDropdown(false);
    };
    var fixCountry = function(str) {
        var fixedString = "";
        if (props.type == "previewPage") {
        //     for (let i in str) {
        //       if (i != str.length-1){
        //         fixedString = fixedString + str[i] + ", ";
        //       }
        //       else {
        //         fixedString = fixedString+ str[i]
        //       }
        //     }
        } else {
            if (str.includes(";")) {
                str.replace(";", ",");
            }
        }
        if (fixedString[fixedString.length - 1] == ",") {
            fixedString = fixedString.slice(0, fixedString.length - 1);
        }
        return fixedString;
    };
    var changeDocumentLink = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var auth, expiryStatus, res, initialExtensionAr;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!editedDocument.trim()) return [
                            3,
                            6
                        ];
                        setEditLoader(true);
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        auth = _state.sent();
                        return [
                            4,
                            props.checkExpiry(auth)
                        ];
                    case 2:
                        expiryStatus = _state.sent();
                        if (!expiryStatus) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            axios_default()({
                                method: "PUT",
                                data: {
                                    botID: myBot.botID,
                                    newDocumentLink: editedDocument
                                },
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/bot/editDocumentLink"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 3:
                        res = _state.sent();
                        setMyBot(res.data.data);
                        initialExtensionAr = res.data.data.sopDocument.split(".");
                        //console.log(initialExtensionAr, "initialExtensionAr");
                        dispatch((0,storeBot_actions/* saveCurrentBot */.B1)(res.data.data));
                        setDocumentEditState(false);
                        setEditLoader(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        props.sessionTimeOutCheck(true);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setInvalidModal(true);
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function changeDocumentLink() {
            return _ref.apply(this, arguments);
        };
    }();
    var getCurrentExtension, fetchURL;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: setSuccessModal
            }) : null,
            invalidModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                setSuccessModal: setInvalidModal,
                title: "Edit document link",
                message: "Document link cannot be empty",
                fail: true
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: skilldetails.map(function(item, index) {
                    var Profile = item.Profile, businessRequestorEmail = item.businessRequestorEmail, createdAt = item.createdAt, employeeTwinID = item.employeeTwinID, skillDescription = item.skillDescription, skillName = item.skillName, softSkillID = item.softSkillID, status = item.status, sopDocument = item.sopDocument, engagementLeadEmail = item.engagementLeadEmail, updatedAt = item.updatedAt;
                    {
                        {}
                        getCurrentExtension = path_browserify_default().extname(sopDocument).substring(1);
                    //console.log("getCurrentExtension", getCurrentExtension);
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (softskillDetails_module_default()).botDetailWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (softskillDetails_module_default()).detailHead,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (softskillDetails_module_default()).cardHead,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (softskillDetails_module_default()).left,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((softskillDetails_module_default()).dollarBack),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (softskillDetails_module_default()).rollBot,
                                                        onClick: function() {
                                                            router.push("/botStore");
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/lessthan.png"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((softskillDetails_module_default()).icon, " Iconimage"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((softskillDetails_module_default()).dollaricon),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((softskillDetails_module_default()).dollarspan),
                                                                children: "$"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((softskillDetails_module_default()).text),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (softskillDetails_module_default()).flexd,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (softskillDetails_module_default()).code,
                                                            children: softSkillID
                                                        })
                                                    }),
                                                    skillName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((softskillDetails_module_default()).statusTagWrapper),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "".concat((softskillDetails_module_default()).label, " ").concat((softskillDetails_module_default()).liveStatus),
                                                    children: [
                                                        " ",
                                                        status,
                                                        " "
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (softskillDetails_module_default()).detailBody,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (softskillDetails_module_default()).textualContent,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (softskillDetails_module_default()).txtCard,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((softskillDetails_module_default()).cardRow, " ").concat((softskillDetails_module_default()).fullwidth),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (softskillDetails_module_default()).left,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Profile"
                                                                }),
                                                                Profile
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (softskillDetails_module_default()).right,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "EmployeeTwin ID"
                                                                }),
                                                                employeeTwinID
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((softskillDetails_module_default()).cardRow, " ").concat((softskillDetails_module_default()).fullwidth),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (softskillDetails_module_default()).center,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Soft Skill DESCRIPTION"
                                                            }),
                                                            skillDescription
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((softskillDetails_module_default()).cardRow),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (softskillDetails_module_default()).left,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Status"
                                                                }),
                                                                status
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (softskillDetails_module_default()).right,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Upload Document"
                                                                }),
                                                                sopDocument
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((softskillDetails_module_default()).cardRow),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (softskillDetails_module_default()).left,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "CREATED AT"
                                                                }),
                                                                createdAt
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (softskillDetails_module_default()).right,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "BUSINESS OWNER E-MAIL ID"
                                                                }),
                                                                businessRequestorEmail
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((softskillDetails_module_default()).cardRow),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (softskillDetails_module_default()).left,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "EBGAGMENT LEAD"
                                                                }),
                                                                engagementLeadEmail
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (softskillDetails_module_default()).right,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Updated At"
                                                                }),
                                                                updatedAt
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                restrictedUserDocumentView.includes(auth.userType) ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((softskillDetails_module_default()).cardRow, " ").concat((softskillDetails_module_default()).fullwidth)
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (softskillDetails_module_default()).mediaContent,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (softskillDetails_module_default()).pdfWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (softskillDetails_module_default()).pdfHead,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (softskillDetails_module_default()).pdfText,
                                                            children: "Documents"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (softskillDetails_module_default()).threeDots,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                name: "threeDots",
                                                                className: (softskillDetails_module_default()).plusIcon
                                                            })
                                                        })
                                                    ]
                                                }),
                                                documentDropdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (softskillDetails_module_default()).dropdownWrapper,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (softskillDetails_module_default()).dropdown,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listWithoutcheck/* default */.Z, {
                                                            dropdownParent: "documentType",
                                                            values: documentTypes,
                                                            getDropdownValue: gotDropDownValue,
                                                            haveRelated: null,
                                                            params: "botDetailDocument",
                                                            closeAllDropdowns: function() {
                                                                return setDocumentDropdown(false);
                                                            }
                                                        })
                                                    })
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (softskillDetails_module_default()).pdfsubHead,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                            name: currentDocumentExtension,
                                                            className: (softskillDetails_module_default()).icon
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (softskillDetails_module_default()).pdfText,
                                                            children: "Document"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            onClick: function() {
                                                                // window.open(`${fetchURL}`);
                                                                window.open("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/" + "".concat(sopDocument));
                                                            },
                                                            className: (softskillDetails_module_default()).downloadIcon,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                                                name: "downloadBlue"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (softskillDetails_module_default()).pdfmainHead,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                        // src="https://docs.google.com/viewerng/viewer?embedded=true&url=https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/ETTaskBreaks.xlsx"
                                                        ref: frameRef,
                                                        src: (getCurrentExtension == "jpg" || getCurrentExtension == "mp4" || getCurrentExtension == "gif" ? "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/".concat(sopDocument) : getCurrentExtension == "xlsx" || getCurrentExtension == "pdf" || getCurrentExtension == "xls" || getCurrentExtension == "doc" || getCurrentExtension == "docx" ? "https://docs.google.com/viewerng/viewer?embedded=true&url=https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/".concat(sopDocument) : getCurrentExtension == "ppt" || getCurrentExtension == "pptx" || getCurrentExtension == "msg" ? "https://view.officeapps.live.com/op/embed.aspx?src=https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/".concat(sopDocument) : "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/".concat(sopDocument)) + "?ignore= ".concat(Math.floor(Math.random() * 1000)),
                                                        type: "application/".concat(getCurrentExtension),
                                                        width: "100%",
                                                        height: "532px"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
}
var SoftSkillsDetails_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session,
        tokenStatus: state.session.token
    };
};
function SoftSkillsDetails_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var SoftSkillsDetails = ((0,es/* connect */.$j)(SoftSkillsDetails_mapStateToProps, SoftSkillsDetails_mapDispatchToProps)(SoftSkillsDetails_index));

// EXTERNAL MODULE: ./styles/components/emptwinOrderListing.module.scss
var emptwinOrderListing_module = __webpack_require__(93454);
var emptwinOrderListing_module_default = /*#__PURE__*/__webpack_require__.n(emptwinOrderListing_module);
;// CONCATENATED MODULE: ./components/emptwinorderlisting/index.jsx








function emptwinorderlisting_index(props) {
    var empid = JSON.parse(localStorage.getItem("empid"));
    var goTo = function(link) {
        router_default().push({
            pathname: link,
            query: {
                orderid: orderid
            }
        });
    };
    var ref = (0,react.useState)(false), loader = ref[0], setloader = ref[1];
    var ref1 = (0,react.useState)([]), orderdetails = ref1[0], setOrderdetails = ref1[1];
    var ref2 = (0,react.useState)([]), globalSkillProcessName = ref2[0], setGlobalSkillProcessName = ref2[1];
    var ref3 = (0,react.useState)([]), localSkillProcessName = ref3[0], setLocalSkillProcessName = ref3[1];
    var ref4 = (0,react.useState)([]), softSkillProcessName = ref4[0], setSoftSkillProcessName = ref4[1];
    var ref5 = (0,react.useState)([]), productSkillProcessName = ref5[0], setProductSkillProcessName = ref5[1];
    var orderDetails = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        setloader(true);
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/employee_order?businessRequest=").concat(auth.email),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setloader(false);
                            setOrderdetails(data.data);
                        //            setGlobalSkillProcessName(data.globalSkillProcessName);
                        //    setLocalSkillProcessName(data.localSkillProcessName);
                        //  setSoftSkillProcessName(data.softSkillProcessName)
                        // setProductSkillProcessName(data.prdouctTitle)
                        } else {
                            console.log("No data found");
                            setloader(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function orderDetails(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //console.log("orderdetails", orderdetails);
    react.useEffect(function() {
        orderDetails();
    }, []);
    //console.log(props, "Emptwin banner data");
    var numItems = orderdetails.map(function(item, index) {
        if (item) {
            return item.employeeTwinID;
        }
    });
    numItems = numItems.filter(function(item) {
        return item !== undefined;
    });
    //console.log("numItems", numItems.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((emptwinOrderListing_module_default()).emptwinorderlisting, " container"),
            children: loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((emptwinOrderListing_module_default()).container, " ").concat((emptwinOrderListing_module_default()).containerHeight),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((emptwinOrderListing_module_default()).loader, " ").concat((emptwinOrderListing_module_default()).loader3)
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((emptwinOrderListing_module_default()).row, " row pb-4"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-12 col-md-12 col-12 pt-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: (emptwinOrderListing_module_default()).tableskill,
                        children: [
                            numItems.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        className: "".concat((emptwinOrderListing_module_default()).bottext1),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: (emptwinOrderListing_module_default()).heading,
                                                    children: "Order Details"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: (emptwinOrderListing_module_default()).heading,
                                                    children: orderDetails.length > 0 ? "".concat(numItems.length, " ").concat(orderdetails.length <= 1 ? "Item" : "Items") : ""
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                        className: (emptwinOrderListing_module_default()).bottext2
                                    })
                                ]
                            }) : "",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: (emptwinOrderListing_module_default()).skilllist,
                                style: {
                                    background: "#1f36c7",
                                    color: "#fff"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (emptwinOrderListing_module_default()).skillheading,
                                        children: "Order Id"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (emptwinOrderListing_module_default()).skillheading,
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (emptwinOrderListing_module_default()).skillheading,
                                        style: {
                                            width: "15%"
                                        },
                                        children: "Profile"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (emptwinOrderListing_module_default()).skillheading,
                                        children: "Soft Skills"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (emptwinOrderListing_module_default()).skillheading,
                                        children: "Global Skills"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (emptwinOrderListing_module_default()).skillheading,
                                        children: "ETA (Global & Soft Skill)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (emptwinOrderListing_module_default()).skillheading,
                                        children: "Local Skills"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (emptwinOrderListing_module_default()).skillheading,
                                        children: "Delivery Date"
                                    })
                                ]
                            }),
                            orderdetails.map(function(item, index) {
                                var orderID = item.orderID, softSkill = item.softSkill, globalSkill = item.globalSkill, localSkill = item.localSkill, goLiveDate = item.goLiveDate, product_id = item.product_id, createdAt = item.createdAt, updatedAt = item.updatedAt, ETname = item.ETname, Etprofile = item.Etprofile, GlobalSkill_ProcessName = item.GlobalSkill_ProcessName, localSkill_ProcessName = item.localSkill_ProcessName, softSkill_ProcessName = item.softSkill_ProcessName, productSkill_ProcessName = item.productSkill_ProcessName;
                                // let GlobalSkill_ProcessName1=[GlobalSkill_ProcessName];
                                //   let localSkill_ProcessName1=[localSkill_ProcessName];
                                // let softSkill_ProcessName1=[softSkill_ProcessName];
                                //softSkill_ProcessName1=softSkill_ProcessName;
                                // let productSkill_ProcessName1=[productSkill_ProcessName];
                                var a = GlobalSkill_ProcessName.split(",");
                                var GlobalSkill_ProcessName1 = a;
                                var b = localSkill_ProcessName.split(",");
                                var localSkill_ProcessName1 = b;
                                var c = softSkill_ProcessName.split(",");
                                var softSkill_ProcessName1 = c;
                                var d = productSkill_ProcessName.split(",");
                                var productSkill_ProcessName1 = d;
                                var date1 = new Date();
                                var date2 = new Date(updatedAt);
                                var diffTime = date2.getTime() - date1.getTime();
                                var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                var date = new Date(updatedAt).toLocaleDateString();
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        className: (emptwinOrderListing_module_default()).skilllist,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "".concat((emptwinOrderListing_module_default()).rightText),
                                                    children: orderID
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "".concat((emptwinOrderListing_module_default()).rightText),
                                                    children: ETname
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: Etprofile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: Etprofile,
                                                    style: {
                                                        maxWidth: "50%",
                                                        verticalAlign: "middle"
                                                    }
                                                }) : null
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    softSkill_ProcessName1.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: item
                                                                }, index),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                            ]
                                                        });
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    GlobalSkill_ProcessName1.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: item
                                                                }, index),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                            ]
                                                        });
                                                    }),
                                                    productSkill_ProcessName1.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: item
                                                                }, index),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                            ]
                                                        });
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((emptwinOrderListing_module_default()).rightText),
                                                        children: date
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    localSkill_ProcessName1.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: item
                                                                }, index),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                            ]
                                                        });
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    localSkill_ProcessName1[0].length <= 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((emptwinOrderListing_module_default()).rightText),
                                                        children: "Team will reach out to you."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                });
                            })
                        ]
                    })
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/PurchaseET/index.jsx








var PurchaseET_Icons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18023));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18023)
            ];
        }
    }
});
var PurchaseET_Card = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 71835));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71835)
            ];
        }
    }
});



var PurchaseET_BasicForm = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35842)
            ];
        }
    }
});
var PurchaseET_Video = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3292).then(__webpack_require__.bind(__webpack_require__, 93292));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93292)
            ];
        }
    }
});
var PurchaseET_Empbanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3260).then(__webpack_require__.bind(__webpack_require__, 53260));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53260)
            ];
        }
    }
});
var PurchaseET_Emptwinskills = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2443), __webpack_require__.e(8270)]).then(__webpack_require__.bind(__webpack_require__, 38270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38270)
            ];
        }
    }
});






var PurchaseET_SuccessModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 99696));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99696)
            ];
        }
    }
});

var PurchaseET_Loader = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 16330));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16330)
            ];
        }
    }
});




function PurchaseET_index(props) {
    var router = (0,next_router.useRouter)();
    //console.log("props  ------ Employeetwin page  -----", props);
    var initialStates = {};
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref[0], setState = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref1[0], setSuccessModal = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), cartModal = ref2[0], setCartModal = ref2[1];
    var ref3 = (0,react.useState)([]), empdata = ref3[0], setEmpdata = ref3[1];
    var ref4 = (0,react.useState)([]), softskilldata = ref4[0], setSoftskilldata = ref4[1];
    var ref5 = (0,react.useState)(false), categorydata = ref5[0], setCategorydata = ref5[1];
    var ref6 = (0,react.useState)(false), subcategorydata = ref6[0], setSubcategorydata = ref6[1];
    var backgroundUrlMobile = get_default()(props.data[0], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl = get_default()(props, "data[0]component.content.field_background_image[0].file_url", "");
    var emptwinDetails = get_default()(props, "data[0].component.content.field_details", "");
    var emptwinHeading = get_default()(props, "data[0]component.content.field_hedaing", "");
    var backgroundUrlMobile1 = get_default()(props.data[10], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl1 = get_default()(props, "data[10]component.content.field_background_image[0].file_url", "");
    var backgroundUrl11 = get_default()(props, "data[0].component.content.field_background_image[1].file_url", "");
    //console.log('backgroundUrl11',backgroundUrl11);
    // console.log('getting all images',props.data[0].component.content.field_background_image[1].file_url);
    var emptwinDetails1 = get_default()(props, "data[10].component.content.field_details", "");
    var emptwinHeading1 = get_default()(props, "data[10]component.content.field_hedaing", "");
    var backgroundUrlMobileemptwin = get_default()(props.data[11], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrlemptwin = get_default()(props, "data[11]component.content.field_background_image[0].file_url", "");
    var data = props.data;
    var onValueChange = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = e.target.value;
                //console.log(e.target.id,e.target.value);
                if (e.target.id === "leadPlatform" && e.target.value === "Supply Chain") {
                    setCategorydata(true);
                } else {
                    setCategorydata(false);
                }
                return [
                    2
                ];
            });
        });
        return function onValueChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref7 = (0,react.useState)([]), subcategoryindex = ref7[0], setSubcategoryindex = ref7[1];
    var onValueChangecategory = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                value = e.target.value;
                //console.log(e.target.id,e.target.value);
                if (e.target.id === "category" && e.target.value === "Plan") {
                    setSubcategorydata(true);
                    setSubcategoryindex(get_default()(props.data[4].component.content.field_bot_store_filters_fields[2].field_dropdown_option_component[0], "field_options", []));
                } else if (e.target.id === "category" && e.target.value === "Master Data") {
                    setSubcategorydata(true);
                    setSubcategoryindex(get_default()(props.data[4].component.content.field_bot_store_filters_fields[2].field_dropdown_option_component[1], "field_options", []));
                } else {
                    setSubcategorydata(false);
                }
                return [
                    2
                ];
            });
        });
        return function onValueChangecategory(e) {
            return _ref.apply(this, arguments);
        };
    }();
    //console.log(subcategoryindex);
    var content = _.get(data[4], "component.content", "");
    var clearALLFilter = function() {
        window.scrollTo(0, 200);
        setState({});
        //setLoadState(true)
        setNoResultFlag(false);
    // dispatch(getBotsAction(0))
    // setAllBots([])
    // setInfiniteKey(infiniteKey + 1)
    // setHasMoreBots(true)
    };
    var inputChange = function(e) {
        if (e.target.value.length == 0) {
            //  console.log(e.target.value, "before");
            var statess = state;
            delete statess.searchinput;
            setSearchinput("");
            setState((0,src_object_spread/* default */.Z)({}, statess));
            if (_.isEmpty(statess)) {
                clearALLFilter();
            }
        } else {
            setSearchinput(e.target.value);
            debouncedCallApi();
        }
    };
    var inputRef = (0,react.useRef)(null);
    var goTo = function(link) {
        // console.log(link);
        router.push(link);
    };
    var moveToCez = function(sectionName) {
        router.push({
            pathname: props.pageRoutes.CognitiveExperienceZone,
            query: {
                cezSection: sectionName
            }
        });
    };
    var search = window.location.search;
    var params = new URLSearchParams(search);
    var empid = params.get("empTwinId");
    //console.log(empid);
    localStorage.setItem("empid", JSON.stringify(empid));
    var reactRef = react.useRef(null);
    var localHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/search?empTwinId=").concat(empid),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            setEmpdata(data.allSkill[0]);
                            setSoftskilldata(data.softSkill);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function localHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        localHandler();
    }, []);
    //console.log(empdata);
    var auth = JSON.parse(localStorage.getItem("auth")).data;
    //console.log(auth.email);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((emptwin_module_default()).landingContainer),
        children: [
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseET_SuccessModal, {
                setSuccessModal: setSuccessModal,
                title: "Request a demo",
                message: message
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "headTop"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseET_Empbanner, {
                data: {
                    emptwinDetails: emptwinDetails,
                    emptwinHeading: emptwinHeading,
                    backgroundUrl: backgroundUrl,
                    backgroundUrl11: backgroundUrl11,
                    backgroundUrlMobile: backgroundUrlMobile
                },
                name: "purchaseET",
                empdata: empdata
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseET_Emptwinskills, {
                data: {
                    emptwinDetails1: emptwinDetails1,
                    emptwinHeading1: emptwinHeading1,
                    backgroundUrl1: backgroundUrl1,
                    backgroundUrlMobile1: backgroundUrlMobile1
                },
                name: "employeetwindetails",
                allskillsData: props.data,
                data1: props.softskill1,
                empid: empid,
                softskilldata: softskilldata,
                content: content,
                softSkill: props.softskill,
                pageRoutes: props.pageRoutes,
                globalData: props.globalData
            })
        ]
    });
}
var PurchaseET_mapStateToProps = function(state) {
    //console.log("state", state);
    return {
        session: state.session.session
    };
};
function PurchaseET_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var PurchaseET = ((0,es/* connect */.$j)(PurchaseET_mapStateToProps, PurchaseET_mapDispatchToProps)(PurchaseET_index));

;// CONCATENATED MODULE: ./components/ManageEmployeetwin/index.jsx







var ManageEmployeetwin_Icons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18023));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18023)
            ];
        }
    }
});
var ManageEmployeetwin_Card = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 71835));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71835)
            ];
        }
    }
});



var ManageEmployeetwin_BasicForm = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35842)
            ];
        }
    }
});
var ManageEmployeetwin_Video = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3292).then(__webpack_require__.bind(__webpack_require__, 93292));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93292)
            ];
        }
    }
});
var ManageEmployeetwin_Empbanner = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2443), __webpack_require__.e(3424)]).then(__webpack_require__.bind(__webpack_require__, 83424));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83424)
            ];
        }
    }
});
var ManageEmployeetwin_Emptwinskills = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2443), __webpack_require__.e(9698)]).then(__webpack_require__.bind(__webpack_require__, 89698));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89698)
            ];
        }
    }
});
var ManageEmployeetwin_Filters = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9944).then(__webpack_require__.bind(__webpack_require__, 99944));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99944)
            ];
        }
    }
});






var ManageEmployeetwin_SuccessModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 99696));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99696)
            ];
        }
    }
});

var ManageEmployeetwin_Loader = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 16330));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16330)
            ];
        }
    }
});





function ManageEmployeetwin_index(props) {
    var openpopup = function openpopup() {
        var modal = !cartModal;
        setCartModal(true);
        if (modal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    };
    var router = (0,next_router.useRouter)();
    console.log("props  ------ Employeetwin page  -----", props);
    var initialStates = {};
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(initialStates), 2), state = ref[0], setState = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref1[0], setSubmitForm = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), invalidFlag = ref2[0], setInvalidFlag = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), getFormValues = ref3[0], setGetFormValues = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), emptyFormValues = ref4[0], setEmptyFormValues = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), bots = ref5[0], setBots = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), successModal = ref6[0], setSuccessModal = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), cartModal = ref7[0], setCartModal = ref7[1];
    var ref8 = (0,react.useState)([]), empdata = ref8[0], setEmpdata = ref8[1];
    var ref9 = (0,react.useState)([]), softskilldata = ref9[0], setSoftskilldata = ref9[1];
    var backgroundUrlMobile = get_default()(props.data[0], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl = get_default()(props, "data[0]component.content.field_background_image[0].file_url", "");
    var emptwinDetails = get_default()(props, "data[0].component.content.field_details", "");
    var emptwinHeading = get_default()(props, "data[0]component.content.field_hedaing", "");
    var backgroundUrlMobile1 = get_default()(props.data[10], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrl1 = get_default()(props, "data[10]component.content.field_background_image[0].file_url", "");
    var backgroundUrl11 = get_default()(props, "data[0].component.content.field_background_image[1].file_url", "");
    console.log("backgroundUrl11", backgroundUrl11);
    // console.log('getting all images',props.data[0].component.content.field_background_image[1].file_url);
    var emptwinDetails1 = get_default()(props, "data[10].component.content.field_details", "");
    var emptwinHeading1 = get_default()(props, "data[10]component.content.field_hedaing", "");
    var backgroundUrlMobileemptwin = get_default()(props.data[11], "component.content.field_background_image_mobile[0]", "");
    var backgroundUrlemptwin = get_default()(props, "data[11]component.content.field_background_image[0].file_url", "");
    var goTo = function(link) {
        // console.log(link);
        router.push(link);
    };
    var moveToCez = function(sectionName) {
        router.push({
            pathname: props.pageRoutes.CognitiveExperienceZone,
            query: {
                cezSection: sectionName
            }
        });
    };
    var search = window.location.search;
    var params = new URLSearchParams(search);
    var empid = params.get("empTwinId");
    console.log(empid);
    localStorage.setItem("empid", JSON.stringify(empid));
    var reactRef = react.useRef(null);
    var localHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/search?empTwinId=ET00001"),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        console.log(data);
                        if (data.code === 200) {
                            setEmpdata(data.allSkill[0]);
                            setSoftskilldata(data.softSkill);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function localHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        localHandler();
    }, []);
    console.log(empdata);
    var auth = JSON.parse(localStorage.getItem("auth")).data;
    console.log(auth.email);
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var previousMonthindex = currentDate.getMonth() === 0 ? 11 : currentDate.getMonth() - 1;
    var montharray = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    var previousMonth = montharray[previousMonthindex];
    var ref10 = (0,react.useState)(previousMonth), months = ref10[0], setMonths = ref10[1];
    var onValueChange = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var value, data, softSkills, globalSkills, localSkills;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = e.target.value;
                        console.log(e.target.id, e.target.value);
                        setMonths(e.target.value);
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/getmanagetwin/").concat(year, "/").concat(e.target.value),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code === 200) {
                            softSkills = data.data.filter(function(item) {
                                return item.Skilltype === "Soft Skill";
                            });
                            globalSkills = data.data.filter(function(item) {
                                return item.Skilltype === "Global Skill";
                            });
                            localSkills = data.data.filter(function(item) {
                                return item.Skilltype === "Local Skill";
                            });
                            setSoftskill(softSkills);
                            setGlobalskill(globalSkills);
                            setLocalskill(localSkills);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onValueChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref11 = (0,react.useState)(currentYear), year = ref11[0], setYear = ref11[1];
    var yeararray = [
        "2022",
        "2023"
    ];
    var onValueChangeyear = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var value, data, softSkills, globalSkills, localSkills;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = e.target.value;
                        console.log(e.target.id, e.target.value);
                        setYear(e.target.value);
                        if (!(months.length > 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/getmanagetwin/").concat(e.target.value, "/").concat(months),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code === 200) {
                            softSkills = data.data.filter(function(item) {
                                return item.Skilltype === "Soft Skill";
                            });
                            globalSkills = data.data.filter(function(item) {
                                return item.Skilltype === "Global Skill";
                            });
                            localSkills = data.data.filter(function(item) {
                                return item.Skilltype === "Local Skill";
                            });
                            setSoftskill(softSkills);
                            setGlobalskill(globalSkills);
                            setLocalskill(localSkills);
                        } else {
                            console.log("No data found");
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onValueChangeyear(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref12 = (0,react.useState)([]), globalskill = ref12[0], setGlobalskill = ref12[1];
    var ref13 = (0,react.useState)([]), localskill = ref13[0], setLocalskill = ref13[1];
    var ref14 = (0,react.useState)([]), softskill = ref14[0], setSoftskill = ref14[1];
    var skillstat = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var auth, data, softSkills, globalSkills, localSkills;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/getmanagetwin/").concat(year, "/").concat(months),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code === 200) {
                            softSkills = data.data.filter(function(item) {
                                return item.Skilltype === "Soft Skill";
                            });
                            globalSkills = data.data.filter(function(item) {
                                return item.Skilltype === "Global Skill";
                            });
                            localSkills = data.data.filter(function(item) {
                                return item.Skilltype === "Local Skill";
                            });
                            setSoftskill(softSkills);
                            setGlobalskill(globalSkills);
                            setLocalskill(localSkills);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function skillstat(e) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        skillstat();
    }, []);
    var ref15 = (0,react.useState)(false), showupload = ref15[0], setShowupload = ref15[1];
    var ref16 = (0,react.useState)(false), fileerror = ref16[0], setFileError = ref16[1];
    var ref17 = (0,react.useState)(false), filesuccess = ref17[0], setFilesuccess = ref17[1];
    var manageskill = function() {
        setShowupload(true);
    };
    var azurefilepath;
    var blobSasUrlNew = utility_endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin/emp");
    var uploadFile = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(imageFile) {
            var originalFileName, fileName, _$index, extension, blockBlobClient, auth, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        originalFileName = imageFile.name;
                        fileName = originalFileName;
                        _$index = 1;
                        _state.label = 1;
                    case 1:
                        return [
                            4,
                            containerClient.getBlockBlobClient(fileName).exists()
                        ];
                    case 2:
                        if (!_state.sent()) return [
                            3,
                            3
                        ];
                        {
                            extension = originalFileName.substring(originalFileName.lastIndexOf("."));
                            fileName = "".concat(originalFileName.substring(0, originalFileName.lastIndexOf(".")), "_").concat(_$index).concat(extension);
                            _$index++;
                        }
                        return [
                            3,
                            1
                        ];
                    case 3:
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(imageFile)
                        ];
                    case 5:
                        _state.sent();
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        axios_default()({
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/manageet"),
                            method: "POST",
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            },
                            data: {
                                filelink: "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + imageFile.name
                            }
                        }).then(function(resp) {
                            console.log(resp);
                        });
                        console.log("Image uploaded successfully!");
                        setFilesuccess(true);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        setFileError(true);
                        console.error("Error uploading image:", error);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadFile(imageFile) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFileChange = function(event) {
        setFilesuccess(false);
        var file = event.target.files[0];
        if (file) {
            uploadFile(file);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((emptwin_module_default()).landingContainer),
        children: [
            successModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageEmployeetwin_SuccessModal, {
                setSuccessModal: setSuccessModal,
                title: "Request a demo",
                message: message
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "headTop"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageEmployeetwin_Empbanner, {
                data: {
                    emptwinDetails: emptwinDetails,
                    emptwinHeading: emptwinHeading,
                    backgroundUrl: backgroundUrl,
                    backgroundUrl11: backgroundUrl11,
                    backgroundUrlMobile: backgroundUrlMobile
                },
                name: "employeetwinskills",
                empdata: empdata
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                style: {
                    padding: "20px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-12 col-md-12 col-12 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (emptwin_module_default()).formGroup,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                    className: (emptwin_module_default()).select1,
                                    name: "year",
                                    id: "year",
                                    onChange: onValueChangeyear,
                                    value: year,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "All",
                                            children: "Select Year"
                                        }),
                                        yeararray.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: item,
                                                children: item
                                            }, index);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                    className: (emptwin_module_default()).select1,
                                    name: "month",
                                    id: "month",
                                    onChange: onValueChange,
                                    value: months,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "All",
                                            children: "Select Month"
                                        }),
                                        montharray.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: item,
                                                children: item
                                            }, index);
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((emptwin_module_default()).managetableContainer, " container-fluid"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((emptwin_module_default()).manageTable, " col-md-12"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((emptwin_module_default()).manageSkillHeading),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "".concat((emptwin_module_default()).skillHeading, " ").concat((emptwin_module_default()).softskillHeading),
                                            children: "Soft Skill"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                        className: "".concat((emptwin_module_default()).manage_table),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                className: "".concat((emptwin_module_default()).manage_thead),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: "".concat((emptwin_module_default()).manage_thead_row, " ").concat((emptwin_module_default()).soft_thead_row),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Skill"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "No. of User Accessing this Skill"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Number of Hits"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Cost"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                className: "".concat((emptwin_module_default()).manage_tbody, " ").concat((emptwin_module_default()).soft_tbody),
                                                children: softskill.map(function(item, index) {
                                                    var Cost = item.Cost, Skill = item.Skill, usercount = item.usercount, Hits = item.Hits;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        className: "".concat((emptwin_module_default()).manage_tbody_row),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: Skill
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: usercount
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: Hits
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: Cost
                                                            })
                                                        ]
                                                    });
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((emptwin_module_default()).manageTable, " col-md-12"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((emptwin_module_default()).manageSkillHeading),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "".concat((emptwin_module_default()).skillHeading, " ").concat((emptwin_module_default()).localskillHeading),
                                            children: "Local Skill"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                        className: "".concat((emptwin_module_default()).manage_table, " ").concat((emptwin_module_default()).local_table),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                className: "".concat((emptwin_module_default()).manage_thead, " ").concat((emptwin_module_default()).local_thead),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: "".concat((emptwin_module_default()).manage_thead_row, " ").concat((emptwin_module_default()).local_thead_row),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Skill"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "No. of User Accessing this Skill"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Number of Hits"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Cost"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                className: "".concat((emptwin_module_default()).manage_tbody, " ").concat((emptwin_module_default()).local_tbody),
                                                children: localskill.map(function(item, index) {
                                                    var Cost = item.Cost, Skill = item.Skill, usercount = item.usercount, Hits = item.Hits;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        className: "".concat((emptwin_module_default()).manage_tbody_row),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: Skill
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: usercount
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: Hits
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: Cost
                                                            })
                                                        ]
                                                    });
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((emptwin_module_default()).manageTable, " col-md-12"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((emptwin_module_default()).manageSkillHeading),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "".concat((emptwin_module_default()).skillHeading, " ").concat((emptwin_module_default()).globalskillHeading),
                                            children: "Global Skill"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                        className: "".concat((emptwin_module_default()).manage_table, " ").concat((emptwin_module_default()).global_table),
                                        style: {
                                            marginBottom: "30px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                className: "".concat((emptwin_module_default()).manage_thead, " ").concat((emptwin_module_default()).global_thead),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: "".concat((emptwin_module_default()).manage_thead_row, " ").concat((emptwin_module_default()).global_thead_row),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Skill"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "No. of User Accessing this Skill"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Number of Hits"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Cost"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                className: "".concat((emptwin_module_default()).manage_tbody, " ").concat((emptwin_module_default()).global_tbody),
                                                children: globalskill.map(function(item, index) {
                                                    var Cost = item.Cost, Skill = item.Skill, usercount = item.usercount, Hits = item.Hits;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        className: "".concat((emptwin_module_default()).manage_tbody_row),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: Skill
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: usercount
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: Hits
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: Cost
                                                            })
                                                        ]
                                                    });
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    "       ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (emptwin_module_default()).editdata,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: manageskill,
                                children: "Manage Skill Data"
                            }),
                            showupload ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((emptwin_module_default()).uploadBtnWrapper),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: (emptwin_module_default()).mainLabel,
                                        children: "Upload Excel File"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (emptwin_module_default()).uploadControl,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "file",
                                                onChange: function(e) {
                                                    handleFileChange(e);
                                                },
                                                className: (emptwin_module_default()).fileupload,
                                                accept: "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            }),
                                            filesuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    color: "#00b190",
                                                    fontSize: "12px",
                                                    verticalAlign: "middle",
                                                    lineHeight: "35px"
                                                },
                                                children: "Uploaded Successfully"
                                            }) : null,
                                            fileerror ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    color: "red",
                                                    fontSize: "12px",
                                                    verticalAlign: "middle",
                                                    lineHeight: "35px"
                                                },
                                                children: "Error when uploading"
                                            }) : null
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    "        "
                ]
            }),
            cartModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Cartmodal/* default */.Z, {
                data: props.softskill.data.field_component,
                closeModal: function() {
                    setCartModal(false);
                },
                pageRoutes: props.pageRoutes,
                empid: empid
            }) : null
        ]
    });
}
var ManageEmployeetwin_mapStateToProps = function(state) {
    console.log("state", state);
    return {
        session: state.session.session
    };
};
function ManageEmployeetwin_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var ManageEmployeetwin = ((0,es/* connect */.$j)(ManageEmployeetwin_mapStateToProps, ManageEmployeetwin_mapDispatchToProps)(ManageEmployeetwin_index));

// EXTERNAL MODULE: ./styles/pages/roiform.module.scss
var roiform_module = __webpack_require__(22449);
var roiform_module_default = /*#__PURE__*/__webpack_require__.n(roiform_module);
// EXTERNAL MODULE: ./components/Pages/roiModal/index.module.scss
var roiModal_index_module = __webpack_require__(93215);
var roiModal_index_module_default = /*#__PURE__*/__webpack_require__.n(roiModal_index_module);
;// CONCATENATED MODULE: ./components/Pages/roiModal/index.jsx






function roiModal_index(props) {
    var useOutsideAlerter = // method to close the modal if clicked outside
    function useOutsideAlerter(ref) {
        (0,react.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                //console.log(ref.current,"lllllll");
                //console.log(event.target,"eeeeeee");
                if (ref.current && !ref.current.contains(event.target)) {
                    if (props.roiFormModal == "closeBtn") {} else {
                        props.setSuccessModal(false);
                    }
                }
            }
            // Bind the event listener
            document.addEventListener("click", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    console.log("message", props.message);
    var auth = "";
    if (true) {
        if (JSON.parse(localStorage.getItem("auth")) != null) {
            auth = JSON.parse(localStorage.getItem("auth")).data;
        }
    }
    //console.log("this is prop message", props.message);
    var router = (0,next_router.useRouter)();
    var closeIt = function() {
        props.setSuccessModal(false);
        document.body.style.overflow = "unset";
        if (props.setfail) {
            props.setFail(false);
        }
        if (props.parent == "createBot") {
            router.push("/botStore");
        }
        if (props.title == "Feedback") {
            router.push("/employeetwin");
        }
        if (props.setMessage) {
            props.setMessage("");
        }
        if (props.session) {
            props.sessionTimeOutCheck(false);
        }
    // if(props.setFail){
    //   props.setFail(false)
    // }
    };
    var handlePopup = function() {
        props.onCloseModal();
    };
    var handleRoiModal = function() {
        props.closeModal(); // Call the closeModal function from the parent
    };
    var modalRef = react.useRef(null);
    useOutsideAlerter(modalRef);
    var userEmailName = auth.name.split(" ");
    var capitalizedWords = userEmailName.map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    var capitalizedUsername = capitalizedWords.join(" ");
    // console.log('capitalizedUsername',capitalizedUsername);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roiModal_index_module_default()).successContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (roiModal_index_module_default()).modalBox,
            ref: modalRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roiModal_index_module_default()).modalHeader,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (roiModal_index_module_default()).content,
                        children: props.title ? props.title : ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (roiModal_index_module_default()).modalBody,
                    children: [
                        props.fail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (roiModal_index_module_default()).fail,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                name: "failure"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (roiModal_index_module_default()).status,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg["default"], {
                                name: "whitetick"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((roiModal_index_module_default()).textBody, " ml-3"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roiModal_index_module_default()).textcontent,
                                children: props.message ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: props.roiFormModal == "closeBtn" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: !props.session ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: (roiModal_index_module_default()).texthead,
                                            children: [
                                                "Hi ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        capitalizedUsername,
                                                        ","
                                                    ]
                                                }),
                                                " Your Form Submitted Successfully."
                                            ]
                                        }) : null
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roiModal_index_module_default()).usersWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: (roiModal_index_module_default()).usersList,
                                            children: props.message.map(function(name, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: (roiModal_index_module_default()).userList,
                                                    children: name
                                                }, index);
                                            })
                                        })
                                    })
                                }) : " We have received your request for getting the bot and is shared with our team. We will reach you with your requirements."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roiModal_index_module_default()).modalFooter,
                    children: props.areYouSure ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roiModal_index_module_default()).areYouSureBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (roiModal_index_module_default()).exportListBtn,
                                onClick: function() {
                                    return props.setSuccessModal(true);
                                },
                                children: "Yes"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (roiModal_index_module_default()).exportListBtn,
                                onClick: function() {
                                    return props.setSuccessModal(false);
                                },
                                children: "No"
                            })
                        ]
                    }) : props.session ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roiModal_index_module_default()).combinedBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (roiModal_index_module_default()).exportListBtn,
                            onClick: function() {
                                return closeIt();
                            },
                            children: "Ok"
                        })
                    }) : props.manageEmpTwin == "removeCloseBtn" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roiModal_index_module_default()).SubmitAnIdeaBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (roiModal_index_module_default()).submitAnIdeaOk,
                            onClick: handlePopup,
                            children: "OK"
                        })
                    }) : props.roiFormModal == "closeBtn" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roiModal_index_module_default()).SubmitAnIdeaBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (roiModal_index_module_default()).submitAnIdeaOk,
                            onClick: handleRoiModal,
                            children: "OK"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roiModal_index_module_default()).combinedBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (roiModal_index_module_default()).exportListBtn,
                            onClick: function() {
                                return closeIt();
                            },
                            children: "Close"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var roiModal = (roiModal_index);

// EXTERNAL MODULE: ./node_modules/recharts/es6/chart/AreaChart.js
var AreaChart = __webpack_require__(46888);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/CartesianGrid.js
var CartesianGrid = __webpack_require__(14195);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(3023);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(75358);
// EXTERNAL MODULE: ./node_modules/recharts/es6/component/Tooltip.js + 3 modules
var Tooltip = __webpack_require__(26050);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/Area.js
var Area = __webpack_require__(86108);
;// CONCATENATED MODULE: ./components/roi/index.jsx










var roi_Icons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18023));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18023)
            ];
        }
    }
});














function roi_index(props) {
    var getRelatedCountries = function getRelatedCountries(selectedMCO) {
        var mcoGroup = clusterFormData[2].field_dropdown_option_component.find(function(group) {
            return group.field_title === selectedMCO;
        });
        if (mcoGroup) {
            return mcoGroup.field_options;
        }
        return [];
    };
    var getRelatedSubArea = function getRelatedSubArea(selectedArea) {
        var mcoGroup = leadplatFormData[2].field_dropdown_option_component.find(function(group) {
            return group.field_title === selectedArea;
        });
        if (mcoGroup) {
            return mcoGroup.field_options;
        }
        return [];
    };
    var router = (0,next_router.useRouter)();
    console.log("Props--Roi-Form", props);
    var _globalData = props.globalData, clusterFormData = _globalData.submitanidea_cluster_component, leadplatFormData = _globalData.submitanidea_leadplatform_component;
    var technologyData = props.technology.field_component[0].component.content.field_request_demo_form_componen;
    console.log("clusterFormData", clusterFormData);
    console.log("leadplatFotechnologyrmData", leadplatFormData);
    console.log("technologyData", technologyData);
    var formInitialState = {
        clusterProcess: "",
        expectedMcoType: "",
        expectedCountry: "",
        leadPlatformProcess: "",
        expectedArea: "",
        expectedSubArea: "",
        opportunityName: "",
        opportunityDescription: "",
        technology: "",
        botId: "",
        manualHours: "",
        annualExecutedProcess: "",
        resourceProcess: "",
        errorRateProcess: "",
        costAvoidance: "",
        impactOfOKR: "",
        developmentCost: "",
        runCostProcess: "",
        resRoiMonthsBreakdown: "",
        resRoiFor1Year: "",
        resRoiFor3Year: "",
        roiMonthsBreakdown: "",
        roiFor1Year: "",
        roiFor3Year: "",
        formSubmittedBy: ""
    };
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), errorMsg = ref2[0], setErrorMsg = ref2[1];
    var ref3 = (0,react.useState)({}), errors = ref3[0], setErrors = ref3[1];
    var ref4 = (0,react.useState)(1), step = ref4[0], setStep = ref4[1];
    var ref5 = (0,react.useState)(formInitialState), formData = ref5[0], setFormData = ref5[1];
    var ref6 = (0,react.useState)(false), formDataValid = ref6[0], setFormDataValid = ref6[1];
    var ref7 = (0,react.useState)(""), selectedOption = ref7[0], setSelectedOption = ref7[1];
    var ref8 = (0,react.useState)(false), showClusterOption = ref8[0], setShowClusterOption = ref8[1];
    var ref9 = (0,react.useState)(false), showMcoOption = ref9[0], setShowMcoOption = ref9[1];
    var ref10 = (0,react.useState)(false), showCountryOption = ref10[0], setShowCountryOption = ref10[1];
    var ref11 = (0,react.useState)(false), showLeadPlatformOption = ref11[0], setShowLeadPlatformOption = ref11[1];
    var ref12 = (0,react.useState)(false), showAreaOption = ref12[0], setShowAreaOption = ref12[1];
    var ref13 = (0,react.useState)(false), showSubAreaOption = ref13[0], setShowSubAreaOption = ref13[1];
    var ref14 = (0,react.useState)(""), selectedMCO = ref14[0], setSelectedMCO = ref14[1];
    var ref15 = (0,react.useState)(""), selectedArea = ref15[0], setSelectedArea = ref15[1];
    var ref16 = (0,react.useState)([]), relatedCountries = ref16[0], setRelatedCountries = ref16[1];
    var ref17 = (0,react.useState)([]), relatedSubArea = ref17[0], setRelatedSubArea = ref17[1];
    var ref18 = (0,react.useState)(false), technologyOption = ref18[0], setTechnologyOption = ref18[1];
    var ref19 = (0,react.useState)(null), indexForMCO = ref19[0], setIndexForMCO = ref19[1];
    var ref20 = (0,react.useState)(null), indexForArea = ref20[0], setIndexForArea = ref20[1];
    var ref21 = (0,react.useState)(true), activeTab = ref21[0], setActiveTab = ref21[1];
    var ref22 = (0,react.useState)(false), isModalVisible = ref22[0], setIsModalVisible = ref22[1];
    var clusterRef = (0,react.useRef)(null);
    var mcoRef = (0,react.useRef)(null);
    var countryRef = (0,react.useRef)(null);
    var leadPlatformRef = (0,react.useRef)(null);
    var areaRef = (0,react.useRef)(null);
    var subAreaRef = (0,react.useRef)(null);
    var technologyRef = (0,react.useRef)(null);
    var ref23 = (0,react.useState)("ROI For 1 Year"), resRoiYear = ref23[0], setResRoiYear = ref23[1];
    var ref24 = (0,react.useState)("ROI For 1 Year"), roiYear = ref24[0], setRoiYear = ref24[1];
    var goTo = function(link) {
        // console.log(link);
        router.push(link);
    };
    var closeSuccessModal = function() {
        setShowModal(false);
    };
    var search = window.location.search;
    var params = new URLSearchParams(search);
    var empid = params.get("empTwinId");
    console.log(empid);
    localStorage.setItem("empid", JSON.stringify(empid));
    var handleFieldChange = function(e) {
        setFormData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), (0,src_define_property/* default */.Z)({}, e.target.name, e.target.value)));
        // Check if the current field is empty (including spaces)
        var isEmptyField = e.target.value.trim() === "";
        setErrors((0,src_define_property/* default */.Z)({}, e.target.name, isEmptyField));
    };
    console.log("errors", errors);
    console.log("errorMsg", errorMsg);
    var handleResRoiYear = function(e) {
        setResRoiYear(e.target.value);
    };
    var handleRoiYear = function(e) {
        setRoiYear(e.target.value);
    };
    console.log("resRoiYear", resRoiYear);
    var checkAuthorization = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var auth, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "GET",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/roi/checkAuthorization"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        // console.log("checkAuthorization",data);
                        if (data.data.code === 200) {
                            console.log("Authorized User", data.data);
                        } else if (data.code === 403) {
                            setLoading(false);
                            console.log("Error in authorization", data);
                            props.sessionTimeOutCheck(true);
                        } else {}
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log("Error in Authorization", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function checkAuthorization() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleContinue = function() {
        // Validate the form fields
        checkAuthorization();
        var requiredFields = [
            "clusterProcess",
            "expectedMcoType",
            "expectedCountry",
            // "leadPlatformProcess",
            // "expectedArea",
            // "expectedSubArea",
            "opportunityName",
            "opportunityDescription", 
        ];
        var isFormValid = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = requiredFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var fieldName = _step.value;
                if (!formData[fieldName].trim()) {
                    // If the field is empty or contains only spaces
                    // alert(`Please enter valid input in the field "${fieldName}".`);
                    console.log('Please enter valid input in the field "'.concat(fieldName, '".'));
                    isFormValid = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setErrorMsg(isFormValid);
        if (!isFormValid) {
            setStep(function(prevStep) {
                return prevStep + 1;
            });
        }
    };
    var handleNext = function() {
        // Validate the form fields
        checkAuthorization();
        var requiredFields = [
            "manualHours",
            "annualExecutedProcess",
            "resourceProcess",
            "errorRateProcess", 
        ];
        var isFormValid = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = requiredFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var fieldName = _step.value;
                if (!formData[fieldName]) {
                    // If the field is empty or contains only spaces
                    // alert(`Please enter valid input in the field "${fieldName}".`);
                    console.log('Please enter valid input in the field "'.concat(fieldName, '".'));
                    isFormValid = true;
                    break;
                }
            // if (typeof !formData[fieldName] === 'string') {
            // }
            // else{
            // }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setErrorMsg(isFormValid);
        if (!isFormValid) {
            setStep(function(prevStep) {
                return prevStep + 1;
            });
        }
    };
    var handleBack = function() {
        setStep(function(prevStep) {
            return prevStep - 1;
        });
        setFormDataValid(false);
        if (step === 4) {
            setLoading(true);
            setTimeout(function() {
                setLoading(false);
            }, 1000);
        }
    };
    console.log("setFormDataValid", formDataValid);
    var handleShowRoi = function() {
        // Validate the form fields
        checkAuthorization();
        var requiredFields = [
            // "costAvoidance",
            // "impactOfOKR",
            "developmentCost",
            "runCostProcess", 
        ];
        var isFormValid = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = requiredFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var fieldName = _step.value;
                if (!formData[fieldName]) {
                    // If the field is empty or contains only spaces
                    // alert(`Please enter valid input in the field "${fieldName}".`);
                    console.log('Please enter valid input in the field "'.concat(fieldName, '".'));
                    isFormValid = true;
                    break;
                }
            // if (typeof !formData[fieldName] === 'string') {
            // }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setErrorMsg(isFormValid);
        if (!isFormValid) {
            setFormDataValid(true);
            setFormData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), {
                manualHours: saving_A,
                annualExecutedProcess: saving_B,
                resourceProcess: saving_C,
                errorRateProcess: saving_D,
                developmentCost: DevlopmentCost,
                runCostProcess: RunCost,
                resRoiMonthsBreakdown: ResBreakEvenInMonths,
                resRoiFor1Year: Math.round(ResROIOneYear),
                resRoiFor3Year: Math.round(ResROIThreeYear),
                roiMonthsBreakdown: RoiBreakEvenInMonths,
                roiFor1Year: Math.round(ROIOneYear),
                roiFor3Year: Math.round(ROIThreeYear)
            }));
            setLoading(true);
            if (step === 3) {
                setTimeout(function() {
                    setLoading(false);
                    setStep(function(prevStep) {
                        return prevStep + 1;
                    });
                }, 1000);
            }
        }
    };
    var handleProjectDetails = function() {
        setStep(1);
    };
    var activeBtn = step === 1 && (roiform_module_default()).activeBtn;
    var activeBtns = step !== 1 && (roiform_module_default()).activeBtns;
    var roiformData = props.data;
    var roiOnlyformData = props.data[0].component.content.field_request_demo_form_componen;
    console.log("roiformData", roiformData);
    console.log("roiOnlyformData", roiOnlyformData);
    var roiFormImage = utility_endpoints/* default.drupalIp */.ZP.drupalIp + props.data[2].component.content.field_background_image[0].file_url;
    console.log("roiFormImage", roiFormImage);
    var resRoiFormulaImage = utility_endpoints/* default.drupalIp */.ZP.drupalIp + props.data[2].component.content.field_background_image_mobile[0].file_url;
    var roiFormulaImage = utility_endpoints/* default.drupalIp */.ZP.drupalIp + props.data[2].component.content.field_background_image_mobile[1].file_url;
    var clusterProcess = formData.clusterProcess, expectedMcoType = formData.expectedMcoType, expectedCountry = formData.expectedCountry, leadPlatformProcess = formData.leadPlatformProcess, expectedArea = formData.expectedArea, expectedSubArea = formData.expectedSubArea, opportunityName = formData.opportunityName, opportunityDescription = formData.opportunityDescription, technology = formData.technology, botId = formData.botId, manualHours = formData.manualHours, annualExecutedProcess = formData.annualExecutedProcess, resourceProcess = formData.resourceProcess, errorRateProcess = formData.errorRateProcess, costAvoidance = formData.costAvoidance, impactOfOKR = formData.impactOfOKR, developmentCost = formData.developmentCost, runCostProcess = formData.runCostProcess;
    var saving_A = +manualHours;
    var saving_B = +annualExecutedProcess;
    var saving_C = +resourceProcess;
    var saving_D = +errorRateProcess;
    var CostAvoidance = +costAvoidance;
    var DevlopmentCost = +developmentCost;
    var RunCost = +runCostProcess;
    // for AnnualizedSavings For Res and Roi Calculation 
    var resourseSavings = 30000 * saving_A * saving_B * saving_C * (1 + saving_D / 100) / 2000;
    var resAnnualizedSavings = Math.round(resourseSavings * 100) / 100;
    var roiAnnualizedSavings = Math.round((resourseSavings + CostAvoidance) * 100) / 100;
    // for BreakEvenMonth Calculation 
    var ResBreakEvenInMonths = Math.round(DevlopmentCost * 12 / (resAnnualizedSavings - RunCost) * 100) / 100;
    var RoiBreakEvenInMonths = Math.round(DevlopmentCost * 12 / (roiAnnualizedSavings - RunCost) * 100) / 100;
    // For Res ROI And Roi Yearly Calculation
    var resRoiMonths = resRoiYear == "ROI For 1 Year" ? 1 : resRoiYear == "ROI For 2 Year" ? 2 : 3;
    var resROIForYear = Math.round((resAnnualizedSavings * resRoiMonths - DevlopmentCost - RunCost * resRoiMonths) / (RunCost * resRoiMonths + DevlopmentCost) * 100) / 100 * 100;
    var roiMonths = roiYear == "ROI For 1 Year" ? 1 : roiYear == "ROI For 2 Year" ? 2 : 3;
    var roiForYear = Math.round((roiAnnualizedSavings * roiMonths - DevlopmentCost - RunCost * roiMonths) / (RunCost * roiMonths + DevlopmentCost) * 100) / 100 * 100;
    // For Res ROI For 1 and 3 Year Calculation
    var ResROIOneYear = Math.round((resAnnualizedSavings - RunCost - DevlopmentCost) / (RunCost + DevlopmentCost) * 100) / 100 * 100;
    var ResROIThreeYear = Math.round((resAnnualizedSavings * 3 - RunCost * 3 - DevlopmentCost) / (RunCost * 3 + DevlopmentCost) * 100) / 100 * 100;
    // For ROI For 1 and 3 Year Calculation
    var ROIOneYear = Math.round((roiAnnualizedSavings - RunCost - DevlopmentCost) / (RunCost + DevlopmentCost) * 100) / 100 * 100;
    var ROIThreeYear = Math.round((roiAnnualizedSavings * 3 - RunCost * 3 - DevlopmentCost) / (RunCost * 3 + DevlopmentCost) * 100) / 100 * 100;
    console.log("ResBreakEvenInMonths", ResBreakEvenInMonths);
    console.log("RoiBreakEvenInMonths", RoiBreakEvenInMonths);
    console.log("resourseSavings", resourseSavings);
    console.log("resAnnualizedSavings", resAnnualizedSavings);
    console.log("roiAnnualizedSavings", roiAnnualizedSavings);
    console.log("resROIForYearly", resROIForYear);
    console.log("ResROIOneYear - ".concat(Math.round(ResROIOneYear), " ResROIThreeYear - ").concat(Math.round(ResROIThreeYear)));
    console.log("ROIOneYear - ".concat(Math.round(ROIOneYear), " ROIThreeYear - ").concat(Math.round(ROIThreeYear)));
    var handleFormSubmit = function(e) {
        if (formDataValid) {
            var cleanedFormData = {};
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(formData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = (0,src_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
                    if (typeof value === "string") {
                        cleanedFormData[key] = value.trim().replace(/\s+/g, " "); // Trim and remove extra spaces
                    } else {
                        cleanedFormData[key] = value; // Leave non-string values as they are
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // cleanedFormData.formSubmittedBy = 'satyam.kumar@ens.enterprises';
            cleanedFormData.formSubmittedBy = JSON.parse(localStorage.getItem("auth")).data.email;
            //console.log("Data Submitted Successfully",cleanedFormData);
            addFormData(cleanedFormData);
            // addFormDataWithEmail(cleanedFormData);
            setLoading(true);
            setTimeout(function() {
                setFormData(formInitialState);
                setFormDataValid(false);
                setStep(1);
            }, 2000);
        } else {
        // alert("Please Enter a valid form data");
        }
    };
    var extractExcelData = function(e) {
        if (formDataValid) {
            var cleanedFormData = {};
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(formData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = (0,src_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
                    if (typeof value === "string") {
                        cleanedFormData[key] = value.trim().replace(/\s+/g, " "); // Trim and remove extra spaces
                    } else {
                        cleanedFormData[key] = value; // Leave non-string values as they are
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            cleanedFormData.formSubmittedBy = JSON.parse(localStorage.getItem("auth")).data.email;
            console.log("Data Submitted Successfully");
            cleanedFormData.resRoiFor1Year = "".concat(Math.round(ResROIOneYear), " %");
            cleanedFormData.resRoiFor3Year = "".concat(Math.round(ResROIThreeYear), " %");
            cleanedFormData.roiFor1Year = "".concat(Math.round(ROIOneYear), " %");
            cleanedFormData.roiFor3Year = "".concat(Math.round(ROIThreeYear), " %");
            //excelData(cleanedFormData);
            checkAuthorizationAndExport(cleanedFormData);
            setLoading(true);
        } else {
        // alert("Please Enter a valid form data");
        }
    };
    // Code for insert Data in database and Send E-mail
    // const addFormDataWithEmail = async (formData) => {
    //   let auth = JSON.parse(localStorage.getItem("auth")).data;
    //   try {
    //     const { data } = await axios({
    //       method: "POST",
    //       url: `${endpoints.baseUrl}/roi/sendformdata`,
    //       headers: {
    //         Authorization: `${auth.accessToken}|${auth.email}`,
    //       },
    //       data: formData,
    //     });
    //     if (data.code === 200) {
    //       setTimeout(() => {
    //         setLoading(false);
    //         setShowModal(true);
    //       }, 2000);
    //       console.log("Successfully E-mail Sent & Data Added Into Database:", data);
    //     } else {
    //       setLoading(true);
    //       console.log("Error in sending data in database & Email Send:", data);
    //     }
    //   } catch (error) {
    //     console.log("Error in sending emai & data:", error);
    //   }
    // };
    // Code for inserting data into database only 
    var addFormData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(formData) {
            var auth, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/roi/getformdata"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: formData
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (data.code === 200) {
                            setTimeout(function() {
                                setLoading(false);
                                setShowModal(true);
                            }, 2000);
                            console.log("Data successfully added into database:", data);
                        } else {
                            console.log("Error in sending data in database:", data);
                            setLoading(false);
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log("Error in sending data:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function addFormData(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var excelData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(formData) {
            var auth, response, blob, url, a, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "POST",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/roi/exportInExcel"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: formData,
                                responseType: "blob"
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.status === 200) {
                            blob = new Blob([
                                response.data
                            ], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            });
                            url = window.URL.createObjectURL(blob);
                            a = document.createElement("a");
                            a.style.display = "none";
                            a.href = url;
                            a.download = "Roi Form Data.xlsx";
                            // Trigger a click event on the anchor element
                            document.body.appendChild(a);
                            a.click();
                            // Clean up by revoking the blob URL
                            setTimeout(function() {
                                setLoading(false);
                                window.URL.revokeObjectURL(url);
                            }, 1000);
                            console.log("Data successfully Exported in Excel");
                        } else {
                            console.log("Error in API response:", response);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log("Error in Exported Data:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function excelData(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var checkAuthorizationAndExport = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(formData) {
            var auth, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                method: "GET",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/roi/checkAuthorization"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        // console.log("checkAuthorization", data);
                        if (data.data.code === 200) {
                            // Authorization is successful, proceed to export Excel data
                            excelData(formData);
                        } else if (data.code === 403) {
                            setLoading(false);
                            props.sessionTimeOutCheck(true);
                        } else {
                            props.sessionTimeOutCheck(true);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log("Error in Authorization", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function checkAuthorizationAndExport(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    console.log("formDataValue", formData);
    var handleOptionChange = function(option, name, index) {
        var additionalStateChanges = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        setSelectedOption(option);
        setShowMcoOption(false);
        setShowClusterOption(false);
        setShowCountryOption(false);
        setShowLeadPlatformOption(false);
        setShowAreaOption(false);
        setShowSubAreaOption(false);
        setTechnologyOption(false);
        var updatedFormData = (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), (0,src_define_property/* default */.Z)({}, name, option)), additionalStateChanges);
        setFormData(updatedFormData);
        console.log("optionName", option, name, index);
    };
    var onClusterChange = function(option, name, index) {
        setIndexForMCO(index);
        handleOptionChange(option, name, index, {
            expectedMcoType: "",
            expectedCountry: ""
        });
    };
    var onLeadPlatformChange = function(option, name, index) {
        setIndexForArea(index);
        handleOptionChange(option, name, index, {
            expectedArea: "",
            expectedSubArea: ""
        });
    };
    var onMCOChange = function(option, name) {
        handleOptionChange(option, name, null, {
            expectedCountry: ""
        });
        setSelectedMCO(option);
    };
    var onAreaChange = function(option, name) {
        handleOptionChange(option, name, null, {
            expectedSubArea: ""
        });
        setSelectedArea(option);
    };
    var onCountryChange = function(option, name) {
        handleOptionChange(option, name);
    };
    var onSubAreaChange = function(option, name) {
        handleOptionChange(option, name);
    };
    var handleOptionSelect = function(option, name) {
        handleOptionChange(option, name);
    };
    (0,react.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(event) {
            if (clusterRef.current && !clusterRef.current.contains(event.target)) {
                setShowClusterOption(false);
            }
            if (mcoRef.current && !mcoRef.current.contains(event.target)) {
                setShowMcoOption(false);
            }
            if (countryRef.current && !countryRef.current.contains(event.target)) {
                setShowCountryOption(false);
            }
            if (leadPlatformRef.current && !leadPlatformRef.current.contains(event.target)) {
                setShowLeadPlatformOption(false);
            }
            if (areaRef.current && !areaRef.current.contains(event.target)) {
                setShowAreaOption(false);
            }
            if (subAreaRef.current && !subAreaRef.current.contains(event.target)) {
                setShowSubAreaOption(false);
            }
            if (technologyRef.current && !technologyRef.current.contains(event.target)) {
                setTechnologyOption(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    (0,react.useEffect)(function() {
        setRelatedCountries(getRelatedCountries(selectedMCO));
        setRelatedSubArea(getRelatedSubArea(selectedArea));
    }, [
        selectedMCO,
        selectedArea
    ]);
    var resRoiChartData = [
        {
            name: "1 Year",
            x: 0,
            y: Math.round(ResROIOneYear)
        },
        {
            name: "3 Year",
            x: 0,
            y: Math.round(ResROIThreeYear)
        }
    ];
    var roiChartData = [
        {
            name: "1 Year",
            x: 0,
            y: Math.round(ROIOneYear)
        },
        {
            name: "3 Year",
            x: 0,
            y: Math.round(ROIThreeYear)
        }
    ];
    var headerStyle = {
        backgroundImage: "linear-gradient(rgba(0, 94, 239, 0.9), rgba(0, 94, 239, 0.9)),url(".concat(roiFormImage, ")"),
        backgroundRepeat: "repeat",
        width: "100%",
        backgroundSize: "30px"
    };
    var handleMouseOver = function() {
        setIsModalVisible(true);
    };
    var handleMouseOut = function() {
        setIsModalVisible(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((roiform_module_default()).landingContainer),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((roiform_module_default()).roiHeader, " container-fluid"),
                style: headerStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((roiform_module_default()).roiHeaderText),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((roiform_module_default()).firstText),
                                    children: "R"
                                }),
                                "eturn ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((roiform_module_default()).firstText),
                                    children: "O"
                                }),
                                "n ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((roiform_module_default()).firstText),
                                    children: "I"
                                }),
                                "nvestment"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((roiform_module_default()).roiFormContainer, " container-fluid"),
                children: step === 4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((roiform_module_default()).roiFormRow, " ").concat((roiform_module_default()).roiCalculationRow, " row"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((roiform_module_default()).roiFormulaContainer, " col-md-12"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((roiform_module_default()).tabContainer, " container"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((roiform_module_default()).roiCalculation, " ").concat((roiform_module_default()).roiTabRow, " row"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((roiform_module_default()).roiBothTabs, " ").concat((roiform_module_default()).resourceRoiWrapper, " col-md-6"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((roiform_module_default()).btnTab, " ").concat(activeTab ? (roiform_module_default()).activeBtn : (roiform_module_default()).resBtn),
                                                onClick: function() {
                                                    return setActiveTab(true);
                                                },
                                                children: "Resource ROI"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((roiform_module_default()).roiBothTabs, " ").concat((roiform_module_default()).resourceRoiWrapper, " col-md-6"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((roiform_module_default()).btnTab, " ").concat(!activeTab ? (roiform_module_default()).activeBtn : (roiform_module_default()).roiBtn),
                                                onClick: function() {
                                                    return setActiveTab(false);
                                                },
                                                children: "ROI"
                                            })
                                        })
                                    ]
                                })
                            }),
                            activeTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((roiform_module_default()).roiCalculation, " ").concat((roiform_module_default()).resRoiRowWrapper, " row"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((roiform_module_default()).calculationWrapper, " ").concat((roiform_module_default()).resourceRoiWrapper, " col-md-6"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (roiform_module_default()).heading,
                                                children: [
                                                    "Resource ROI",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((roiform_module_default()).tooltipModal, " ").concat((roiform_module_default()).overlayModalContainer),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onMouseOver: handleMouseOver,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                name: "information",
                                                                className: "".concat((roiform_module_default()).information)
                                                            })
                                                        })
                                                    }),
                                                    resRoiFormulaImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).overlayModal, " ").concat(isModalVisible ? (roiform_module_default()).modalOpen : ""),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                class: (roiform_module_default()).popup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        class: (roiform_module_default()).close,
                                                                        href: "#",
                                                                        onClick: handleMouseOut,
                                                                        children: "\xd7"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: resRoiFormulaImage,
                                                                        alt: "Resource ROI Formula"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((roiform_module_default()).allCalculation, " ").concat((roiform_module_default()).monthsBreakdown),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (roiform_module_default()).result,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: (roiform_module_default()).text,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (roiform_module_default()).topText,
                                                                    children: "Months"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sub", {
                                                                    className: (roiform_module_default()).bottomText,
                                                                    children: "Breakeven"
                                                                })
                                                            ]
                                                        }),
                                                        " = ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: (roiform_module_default()).totalMonthBreak,
                                                            children: [
                                                                " ",
                                                                ResBreakEvenInMonths
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((roiform_module_default()).allCalculation, " ").concat((roiform_module_default()).RoiBreakdown),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (roiform_module_default()).formGroup,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                            className: "".concat((roiform_module_default()).selectGroup, " ").concat((roiform_module_default()).dropDownFields),
                                                            onChange: handleResRoiYear,
                                                            name: "resRoiYear",
                                                            id: "resRoiYear",
                                                            value: resRoiYear,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    defaultValue: true,
                                                                    children: "ROI For 1 Year"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    defaultValue: true,
                                                                    children: "ROI For 3 Year"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (roiform_module_default()).forOne,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (roiform_module_default()).topText,
                                                                children: resRoiYear
                                                            }),
                                                            " = ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: (roiform_module_default()).yearlyTotal,
                                                                children: [
                                                                    " ",
                                                                    Math.round(resROIForYear),
                                                                    " %"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((roiform_module_default()).calculationWrapper, " ").concat((roiform_module_default()).resourceRoiWrapper, " col-md-6"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AreaChart/* AreaChart */.T, {
                                            width: 350,
                                            height: 220,
                                            data: resRoiChartData,
                                            margin: {
                                                top: 25,
                                                right: 10,
                                                bottom: 0,
                                                left: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartesianGrid/* CartesianGrid */.q, {
                                                    stroke: "#ccc",
                                                    strokeDasharray: "3.5"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    dataKey: "name",
                                                    fontSize: "11px",
                                                    stroke: "#000"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    fontSize: "11px",
                                                    stroke: "#000"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Area/* Area */.u, {
                                                    dataKey: "x",
                                                    stroke: "#005dee",
                                                    fill: "#005dee8f"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Area/* Area */.u, {
                                                    dataKey: "y",
                                                    stroke: "#005dee",
                                                    fill: "#005dee8f"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            !activeTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((roiform_module_default()).roiCalculation, " ").concat((roiform_module_default()).roiRowWrapper, " row"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((roiform_module_default()).calculationWrapper, " ").concat((roiform_module_default()).RoiWrapper, " col-md-6"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (roiform_module_default()).heading,
                                                children: [
                                                    "ROI",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((roiform_module_default()).tooltipModal, " ").concat((roiform_module_default()).overlayModalContainer),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onMouseOver: handleMouseOver,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                name: "information",
                                                                className: "".concat((roiform_module_default()).information)
                                                            })
                                                        })
                                                    }),
                                                    roiFormulaImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).overlayModal, " ").concat(isModalVisible ? (roiform_module_default()).modalOpen : ""),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                class: (roiform_module_default()).popup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        class: (roiform_module_default()).close,
                                                                        href: "#",
                                                                        onClick: handleMouseOut,
                                                                        children: "\xd7"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: roiFormulaImage,
                                                                        alt: "ROI Formula"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((roiform_module_default()).allCalculation, " ").concat((roiform_module_default()).monthsBreakdown),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (roiform_module_default()).result,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: (roiform_module_default()).text,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (roiform_module_default()).topText,
                                                                    children: "Months"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sub", {
                                                                    className: (roiform_module_default()).bottomText,
                                                                    children: "Breakeven"
                                                                })
                                                            ]
                                                        }),
                                                        " =",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: (roiform_module_default()).totalMonthBreak,
                                                            children: [
                                                                " ",
                                                                RoiBreakEvenInMonths
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((roiform_module_default()).allCalculation, " ").concat((roiform_module_default()).RoiBreakdown),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (roiform_module_default()).formGroup,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                            className: "".concat((roiform_module_default()).selectGroup, " ").concat((roiform_module_default()).dropDownFields),
                                                            onChange: handleRoiYear,
                                                            name: "roiYear",
                                                            id: "roiYear",
                                                            value: roiYear,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    defaultValue: true,
                                                                    children: "ROI For 1 Year"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    defaultValue: true,
                                                                    children: "ROI For 3 Year"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (roiform_module_default()).forOne,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (roiform_module_default()).topText,
                                                                children: roiYear
                                                            }),
                                                            " = ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: (roiform_module_default()).yearlyTotal,
                                                                children: [
                                                                    " ",
                                                                    Math.round(roiForYear),
                                                                    " %"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((roiform_module_default()).calculationWrapper, " ").concat((roiform_module_default()).resourceRoiWrapper, " col-md-6"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AreaChart/* AreaChart */.T, {
                                            width: 350,
                                            height: 180,
                                            data: roiChartData,
                                            margin: {
                                                top: 25,
                                                right: 10,
                                                bottom: 0,
                                                left: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartesianGrid/* CartesianGrid */.q, {
                                                    strokeDasharray: "3.5"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    dataKey: "name",
                                                    fontSize: "11px"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    fontSize: "11px"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Area/* Area */.u, {
                                                    dataKey: "x",
                                                    stroke: "#005dee",
                                                    fill: "#005dee8f"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Area/* Area */.u, {
                                                    dataKey: "y",
                                                    stroke: "#005dee",
                                                    fill: "#005dee8f"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((roiform_module_default()).roiCalculation, " row"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((roiform_module_default()).actionBtnWrapper, " col-md-12"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((roiform_module_default()).actionBtn, " container"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "".concat((roiform_module_default()).btns, " ").concat((roiform_module_default()).backBtn),
                                                onClick: handleBack,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((roiform_module_default()).backArrowIcon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                            name: "leftArrow",
                                                            className: (roiform_module_default()).leftArrow
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((roiform_module_default()).text),
                                                        children: "Back"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "".concat((roiform_module_default()).btns, " ").concat((roiform_module_default()).extractDataBtn),
                                                onClick: extractExcelData,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((roiform_module_default()).text),
                                                        children: "Extract Data"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((roiform_module_default()).arrowIcon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                            name: "rightArrow",
                                                            className: (roiform_module_default()).rightArrow
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "".concat((roiform_module_default()).btns, " ").concat((roiform_module_default()).submitBtn),
                                                onClick: handleFormSubmit,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((roiform_module_default()).text),
                                                        children: "Submit"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((roiform_module_default()).arrowIcon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                            name: "rightArrow",
                                                            className: (roiform_module_default()).rightArrow
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((roiform_module_default()).roiFormRow, " row"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((roiform_module_default()).roiFormColumn, " col-md-12"),
                            children: [
                                step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((roiform_module_default()).projectDetailsField, " ").concat((roiform_module_default()).projectDetailsColumn, " container-fluid "),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((roiform_module_default()).projectClusterRow, " ").concat((roiform_module_default()).projectClusterLeft, " row"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (roiform_module_default()).formGroup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (roiform_module_default()).formLabel,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            className: (roiform_module_default()).mainLabel,
                                                                            children: [
                                                                                "Cluster",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                    className: (roiform_module_default()).mandatoryField,
                                                                                    children: "*"
                                                                                }),
                                                                                errorMsg ? clusterProcess == "" && clusterProcess.length == 0 || errors.clusterProcess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (roiform_module_default()).errorMessage,
                                                                                    children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                                }) : null : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat("".concat((roiform_module_default()).selectGroup, " ").concat((roiform_module_default()).dropDownFields), " ").concat((roiform_module_default()).dropDownFields),
                                                                        ref: clusterRef,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((roiform_module_default()).selectedOption, " ").concat(selectedOption),
                                                                                onClick: function() {
                                                                                    return setShowClusterOption(function(prev) {
                                                                                        return !prev;
                                                                                    });
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        className: "".concat((roiform_module_default()).leftSelect, " ").concat(clusterProcess == "" && clusterProcess.length == 0 ? (roiform_module_default()).leftSelectBlur : (roiform_module_default()).leftSelectText),
                                                                                        children: [
                                                                                            " ",
                                                                                            clusterProcess || "Select Cluster"
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: (roiform_module_default()).right,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                                            name: "chevron",
                                                                                            className: (roiform_module_default()).chevron
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            showClusterOption && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (roiform_module_default()).optionsContainer,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "".concat((roiform_module_default()).option),
                                                                                        onClick: function() {
                                                                                            onClusterChange("", "clusterProcess");
                                                                                        },
                                                                                        children: get_default()(clusterFormData[0], "field_input", "")
                                                                                    }),
                                                                                    get_default()(clusterFormData[0], "field_options", []).map(function(option, index) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (roiform_module_default()).option,
                                                                                            onClick: function() {
                                                                                                return onClusterChange(option, "clusterProcess", index);
                                                                                            },
                                                                                            children: option
                                                                                        }, index);
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (roiform_module_default()).formGroup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (roiform_module_default()).formLabel,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            className: (roiform_module_default()).mainLabel,
                                                                            children: [
                                                                                "MCO",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                    className: (roiform_module_default()).mandatoryField,
                                                                                    children: "*"
                                                                                }),
                                                                                errorMsg ? expectedMcoType == "" && expectedMcoType.length == 0 || errors.expectedMcoType ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (roiform_module_default()).errorMessage,
                                                                                    children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                                }) : null : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((roiform_module_default()).selectGroup, " ").concat((roiform_module_default()).dropDownFields),
                                                                        ref: mcoRef,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((roiform_module_default()).selectedOption, " ").concat(selectedOption),
                                                                                onClick: function() {
                                                                                    setShowMcoOption(function(prev) {
                                                                                        return !prev;
                                                                                    });
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        className: "".concat((roiform_module_default()).leftSelect, " ").concat(expectedMcoType == "" && expectedMcoType.length == 0 ? (roiform_module_default()).leftSelectBlur : (roiform_module_default()).leftSelectText),
                                                                                        children: [
                                                                                            " ",
                                                                                            expectedMcoType || "Select MCO"
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: (roiform_module_default()).right,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                                            name: "chevron",
                                                                                            className: (roiform_module_default()).chevron
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            showMcoOption && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (roiform_module_default()).optionsContainer,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "".concat((roiform_module_default()).option),
                                                                                        onClick: function() {
                                                                                            onMCOChange("", "expectedMcoType");
                                                                                        },
                                                                                        children: get_default()(clusterFormData[1], "field_input", "")
                                                                                    }),
                                                                                    get_default()(clusterFormData[1].field_dropdown_option_component[indexForMCO], "field_options", []).map(function(option, index) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (roiform_module_default()).option,
                                                                                            onClick: function() {
                                                                                                return onMCOChange(option, "expectedMcoType", index);
                                                                                            },
                                                                                            children: option
                                                                                        }, index);
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (roiform_module_default()).formGroup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (roiform_module_default()).formLabel,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            className: (roiform_module_default()).mainLabel,
                                                                            children: [
                                                                                "Country",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                    className: (roiform_module_default()).mandatoryField,
                                                                                    children: "*"
                                                                                }),
                                                                                errorMsg ? expectedCountry == "" && expectedCountry.length == 0 || errors.expectedCountry ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (roiform_module_default()).errorMessage,
                                                                                    children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                                }) : null : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((roiform_module_default()).selectGroup, " ").concat((roiform_module_default()).dropDownFields),
                                                                        ref: countryRef,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((roiform_module_default()).selectedOption, " ").concat(selectedOption),
                                                                                onClick: function() {
                                                                                    return setShowCountryOption(function(prev) {
                                                                                        return !prev;
                                                                                    });
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        className: "".concat((roiform_module_default()).leftSelect, " ").concat(expectedCountry == "" && expectedCountry.length == 0 ? (roiform_module_default()).leftSelectBlur : (roiform_module_default()).leftSelectText),
                                                                                        children: [
                                                                                            " ",
                                                                                            expectedCountry || "Select Country"
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: (roiform_module_default()).right,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                                            name: "chevron",
                                                                                            className: (roiform_module_default()).chevron
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            showCountryOption && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (roiform_module_default()).optionsContainer,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "".concat((roiform_module_default()).option),
                                                                                        onClick: function() {
                                                                                            onCountryChange("", "expectedCountry");
                                                                                        },
                                                                                        children: get_default()(clusterFormData[2], "field_input", "")
                                                                                    }),
                                                                                    relatedCountries.map(function(country, index) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (roiform_module_default()).option,
                                                                                            onClick: function() {
                                                                                                return onCountryChange(country, "expectedCountry", index);
                                                                                            },
                                                                                            children: country
                                                                                        }, index);
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (roiform_module_default()).formGroup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (roiform_module_default()).formLabel,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            className: (roiform_module_default()).mainLabel,
                                                                            children: "Lead Platform / Function"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((roiform_module_default()).selectGroup, " ").concat((roiform_module_default()).dropDownFields),
                                                                        ref: leadPlatformRef,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((roiform_module_default()).selectedOption, " ").concat(selectedOption),
                                                                                onClick: function() {
                                                                                    return setShowLeadPlatformOption(function(prev) {
                                                                                        return !prev;
                                                                                    });
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        className: "".concat((roiform_module_default()).leftSelect, " ").concat(leadPlatformProcess == "" && leadPlatformProcess.length == 0 ? (roiform_module_default()).leftSelectBlur : (roiform_module_default()).leftSelectText),
                                                                                        children: [
                                                                                            " ",
                                                                                            leadPlatformProcess || "Select lead platform"
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: (roiform_module_default()).right,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                                            name: "chevron",
                                                                                            className: (roiform_module_default()).chevron
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            showLeadPlatformOption && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (roiform_module_default()).optionsContainer,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "".concat((roiform_module_default()).option),
                                                                                        onClick: function() {
                                                                                            onLeadPlatformChange("", "leadPlatformProcess");
                                                                                        },
                                                                                        children: get_default()(leadplatFormData[0], "field_input", "")
                                                                                    }),
                                                                                    get_default()(leadplatFormData[0], "field_options", []).map(function(option, index) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (roiform_module_default()).option,
                                                                                            onClick: function() {
                                                                                                return onLeadPlatformChange(option, "leadPlatformProcess", index);
                                                                                            },
                                                                                            children: option
                                                                                        }, index);
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (roiform_module_default()).formGroup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (roiform_module_default()).formLabel,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            className: (roiform_module_default()).mainLabel,
                                                                            children: "Area"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((roiform_module_default()).selectGroup, " ").concat((roiform_module_default()).dropDownFields),
                                                                        ref: areaRef,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((roiform_module_default()).selectedOption, " ").concat(selectedOption),
                                                                                onClick: function() {
                                                                                    setShowAreaOption(function(prev) {
                                                                                        return !prev;
                                                                                    });
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        className: "".concat((roiform_module_default()).leftSelect, " ").concat(expectedArea == "" && expectedArea.length == 0 ? (roiform_module_default()).leftSelectBlur : (roiform_module_default()).leftSelectText),
                                                                                        children: [
                                                                                            " ",
                                                                                            expectedArea || "Select Area"
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: (roiform_module_default()).right,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                                            name: "chevron",
                                                                                            className: (roiform_module_default()).chevron
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            showAreaOption && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (roiform_module_default()).optionsContainer,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "".concat((roiform_module_default()).option),
                                                                                        onClick: function() {
                                                                                            onAreaChange("", "expectedArea");
                                                                                        },
                                                                                        children: get_default()(leadplatFormData[1], "field_input", "")
                                                                                    }),
                                                                                    get_default()(leadplatFormData[1].field_dropdown_option_component[indexForArea], "field_options", []).map(function(option, index) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (roiform_module_default()).option,
                                                                                            onClick: function() {
                                                                                                return onAreaChange(option, "expectedArea", index);
                                                                                            },
                                                                                            children: option
                                                                                        }, index);
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((roiform_module_default()).projectClusterRow, " ").concat((roiform_module_default()).projectClusterRight, " row"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (roiform_module_default()).formGroup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (roiform_module_default()).formLabel,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            className: (roiform_module_default()).mainLabel,
                                                                            children: "Sub Area"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((roiform_module_default()).selectGroup, " ").concat((roiform_module_default()).dropDownFields),
                                                                        ref: subAreaRef,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((roiform_module_default()).selectedOption, " ").concat(selectedOption),
                                                                                onClick: function() {
                                                                                    return setShowSubAreaOption(function(prev) {
                                                                                        return !prev;
                                                                                    });
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        className: "".concat((roiform_module_default()).leftSelect, " ").concat(expectedSubArea == "" && expectedSubArea.length == 0 ? (roiform_module_default()).leftSelectBlur : (roiform_module_default()).leftSelectText),
                                                                                        children: [
                                                                                            " ",
                                                                                            expectedSubArea || "Select Sub Area"
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: (roiform_module_default()).right,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                                            name: "chevron",
                                                                                            className: (roiform_module_default()).chevron
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            showSubAreaOption && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (roiform_module_default()).optionsContainer,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "".concat((roiform_module_default()).option),
                                                                                        onClick: function() {
                                                                                            onSubAreaChange("", "expectedSubArea");
                                                                                        },
                                                                                        children: get_default()(leadplatFormData[2], "field_input", "")
                                                                                    }),
                                                                                    relatedSubArea.map(function(country, index) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (roiform_module_default()).option,
                                                                                            onClick: function() {
                                                                                                return onSubAreaChange(country, "expectedSubArea", index);
                                                                                            },
                                                                                            children: country
                                                                                        }, index);
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (roiform_module_default()).formGroup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (roiform_module_default()).formLabel,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            className: (roiform_module_default()).mainLabel,
                                                                            children: get_default()(roiOnlyformData[5], "field_label", "")
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((roiform_module_default()).selectGroup, " ").concat((roiform_module_default()).dropDownFields),
                                                                        ref: technologyRef,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((roiform_module_default()).selectedOption, " ").concat(selectedOption),
                                                                                onClick: function() {
                                                                                    return setTechnologyOption(function(prev) {
                                                                                        return !prev;
                                                                                    });
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        className: "".concat((roiform_module_default()).leftSelect, " ").concat(technology == "" && technology.length == 0 ? (roiform_module_default()).leftSelectBlur : (roiform_module_default()).leftSelectText),
                                                                                        children: [
                                                                                            " ",
                                                                                            technology || "Select technology"
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: (roiform_module_default()).right,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                                            name: "chevron",
                                                                                            className: (roiform_module_default()).chevron
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            technologyOption && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (roiform_module_default()).optionsContainer,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "".concat((roiform_module_default()).option),
                                                                                        onClick: function() {
                                                                                            return handleOptionSelect("", "technology");
                                                                                        },
                                                                                        children: get_default()(technologyData[0], "field_input", "")
                                                                                    }),
                                                                                    get_default()(technologyData[0], "field_options", []).map(function(option, index) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (roiform_module_default()).option,
                                                                                            onClick: function() {
                                                                                                return handleOptionSelect(option, "technology");
                                                                                            },
                                                                                            children: option
                                                                                        }, index);
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (roiform_module_default()).formGroup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (roiform_module_default()).formLabel,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            className: (roiform_module_default()).mainLabel,
                                                                            children: [
                                                                                get_default()(roiOnlyformData[3], "field_label", ""),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                    className: (roiform_module_default()).mandatoryField,
                                                                                    children: "*"
                                                                                }),
                                                                                errorMsg ? opportunityName == "" && opportunityName.length == 0 || errors.opportunityName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (roiform_module_default()).errorMessage,
                                                                                    children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                                }) : null : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        type: "text",
                                                                        className: "".concat((roiform_module_default()).inputtext, " ").concat(errorMsg ? opportunityName == "" && opportunityName.length == 0 || errors.opportunityName ? (roiform_module_default()).emptyField : (roiform_module_default()).someTextField : null),
                                                                        name: "opportunityName",
                                                                        id: "opportunityName",
                                                                        onChange: handleFieldChange,
                                                                        value: opportunityName,
                                                                        placeholder: "".concat(get_default()(roiOnlyformData[3], "field_label", ""))
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (roiform_module_default()).formGroup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (roiform_module_default()).formLabel,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            className: (roiform_module_default()).mainLabel,
                                                                            children: [
                                                                                get_default()(roiOnlyformData[4], "field_label", ""),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                    className: (roiform_module_default()).mandatoryField,
                                                                                    children: "*"
                                                                                }),
                                                                                errorMsg ? opportunityDescription == "" && opportunityDescription.length == 0 || errors.opportunityDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (roiform_module_default()).errorMessage,
                                                                                    children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                                }) : null : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        type: "text",
                                                                        className: "".concat((roiform_module_default()).inputtext, " ").concat(errorMsg ? opportunityDescription == "" && opportunityDescription.length == 0 || errors.opportunityDescription ? (roiform_module_default()).emptyField : (roiform_module_default()).someTextField : null),
                                                                        name: "opportunityDescription",
                                                                        id: "opportunityDescription",
                                                                        onChange: handleFieldChange,
                                                                        value: opportunityDescription,
                                                                        placeholder: "".concat(get_default()(roiOnlyformData[4], "field_label", ""))
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (roiform_module_default()).formGroup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (roiform_module_default()).formLabel,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            className: (roiform_module_default()).mainLabel,
                                                                            children: get_default()(roiOnlyformData[6], "field_label", "")
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        type: "text",
                                                                        className: (roiform_module_default()).inputtext,
                                                                        name: "botId",
                                                                        id: "botId",
                                                                        onChange: handleFieldChange,
                                                                        value: botId,
                                                                        placeholder: "Enter Bot ID"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((roiform_module_default()).actionBtn, " ").concat((roiform_module_default()).continueBtn, " container"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "".concat((roiform_module_default()).btns),
                                                onClick: handleContinue,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((roiform_module_default()).text),
                                                        children: "Continue"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((roiform_module_default()).arrowIcon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                            name: "rightArrow",
                                                            className: (roiform_module_default()).rightArrow
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((roiform_module_default()).projectDetailsField, " ").concat((roiform_module_default()).currentProcessFields, " container"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((roiform_module_default()).projectDetailsRow, " row"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (roiform_module_default()).formGroup,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (roiform_module_default()).formLabel,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                        className: (roiform_module_default()).mainLabel,
                                                                        children: [
                                                                            get_default()(roiOnlyformData[7], "field_label", ""),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                className: (roiform_module_default()).mandatoryField,
                                                                                children: "*"
                                                                            }),
                                                                            errorMsg ? manualHours == "" && manualHours.length == 0 || errors.manualHours ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: (roiform_module_default()).errorMessage,
                                                                                children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                            }) : null : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "number",
                                                                    className: (roiform_module_default()).inputtext,
                                                                    name: "manualHours",
                                                                    id: "manualHours",
                                                                    onChange: handleFieldChange,
                                                                    value: manualHours,
                                                                    min: "0",
                                                                    placeholder: "Enter the number of hours"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (roiform_module_default()).formGroup,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (roiform_module_default()).formLabel,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                        className: (roiform_module_default()).mainLabel,
                                                                        children: [
                                                                            get_default()(roiOnlyformData[8], "field_label", ""),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                className: (roiform_module_default()).mandatoryField,
                                                                                children: "*"
                                                                            }),
                                                                            errorMsg ? annualExecutedProcess == "" && annualExecutedProcess.length == 0 || errors.annualExecutedProcess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: (roiform_module_default()).errorMessage,
                                                                                children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                            }) : null : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "number",
                                                                    className: (roiform_module_default()).inputtext,
                                                                    name: "annualExecutedProcess",
                                                                    id: "annualExecutedProcess",
                                                                    onChange: handleFieldChange,
                                                                    value: annualExecutedProcess,
                                                                    min: "0",
                                                                    placeholder: "Enter the annual execution frequency"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (roiform_module_default()).formGroup,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (roiform_module_default()).formLabel,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                        className: (roiform_module_default()).mainLabel,
                                                                        children: [
                                                                            get_default()(roiOnlyformData[9], "field_label", ""),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                className: (roiform_module_default()).mandatoryField,
                                                                                children: "*"
                                                                            }),
                                                                            errorMsg ? resourceProcess == "" && resourceProcess.length == 0 || errors.resourceProcess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: (roiform_module_default()).errorMessage,
                                                                                children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                            }) : null : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "number",
                                                                    className: (roiform_module_default()).inputtext,
                                                                    name: "resourceProcess",
                                                                    id: "resourceProcess",
                                                                    onChange: handleFieldChange,
                                                                    value: resourceProcess,
                                                                    min: "0",
                                                                    placeholder: "Enter the number of resources"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (roiform_module_default()).formGroup,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (roiform_module_default()).formLabel,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                        className: (roiform_module_default()).mainLabel,
                                                                        children: [
                                                                            get_default()(roiOnlyformData[10], "field_label", ""),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                className: (roiform_module_default()).mandatoryField,
                                                                                children: "*"
                                                                            }),
                                                                            errorMsg ? errorRateProcess == "" && errorRateProcess.length == 0 || errors.errorRateProcess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: (roiform_module_default()).errorMessage,
                                                                                children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                            }) : null : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "number",
                                                                    className: (roiform_module_default()).inputtext,
                                                                    name: "errorRateProcess",
                                                                    id: "errorRateProcess",
                                                                    onChange: handleFieldChange,
                                                                    value: errorRateProcess,
                                                                    min: "0",
                                                                    max: "0.99",
                                                                    step: "0.01",
                                                                    placeholder: "Enter the percentage error rate"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((roiform_module_default()).btnWrapper),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((roiform_module_default()).actionBtn),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "".concat((roiform_module_default()).btns, " ").concat((roiform_module_default()).backBtn, " ").concat((roiform_module_default()).FirstBackBtn),
                                                        onClick: handleBack,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((roiform_module_default()).backArrowIcon),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                    name: "leftArrow",
                                                                    className: (roiform_module_default()).leftArrow
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((roiform_module_default()).text),
                                                                children: "Back"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((roiform_module_default()).actionBtn),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "".concat((roiform_module_default()).btns, " ").concat((roiform_module_default()).nextBtn),
                                                        onClick: handleNext,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Next"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((roiform_module_default()).arrowIcon),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                    name: "rightArrow",
                                                                    className: (roiform_module_default()).rightArrow
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                step === 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((roiform_module_default()).projectDetailsField, " ").concat((roiform_module_default()).currentProcessField2, " container"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((roiform_module_default()).projectDetailsRow, " row"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (roiform_module_default()).formGroup,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (roiform_module_default()).formLabel,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        className: (roiform_module_default()).mainLabel,
                                                                        children: get_default()(roiOnlyformData[11], "field_label", "")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "number",
                                                                    className: (roiform_module_default()).inputtext,
                                                                    name: "costAvoidance",
                                                                    id: "costAvoidance",
                                                                    onChange: handleFieldChange,
                                                                    value: costAvoidance,
                                                                    min: "0",
                                                                    placeholder: "Enter cost avoidance"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (roiform_module_default()).formGroup,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (roiform_module_default()).formLabel,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        className: (roiform_module_default()).mainLabel,
                                                                        children: get_default()(roiOnlyformData[12], "field_label", "")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "text",
                                                                    className: (roiform_module_default()).inputtext,
                                                                    name: "impactOfOKR",
                                                                    id: "impactOfOKR",
                                                                    onChange: handleFieldChange,
                                                                    value: impactOfOKR,
                                                                    placeholder: "Enter impact of OKR's"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (roiform_module_default()).formGroup,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (roiform_module_default()).formLabel,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                        className: (roiform_module_default()).mainLabel,
                                                                        children: [
                                                                            get_default()(roiOnlyformData[13], "field_label", ""),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                className: (roiform_module_default()).mandatoryField,
                                                                                children: "*"
                                                                            }),
                                                                            errorMsg ? developmentCost == "" && developmentCost.length == 0 || errors.developmentCost ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: (roiform_module_default()).errorMessage,
                                                                                children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                            }) : null : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "number",
                                                                    className: (roiform_module_default()).inputtext,
                                                                    name: "developmentCost",
                                                                    id: "developmentCost",
                                                                    onChange: handleFieldChange,
                                                                    value: developmentCost,
                                                                    min: "0",
                                                                    placeholder: "Enter development cost"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((roiform_module_default()).projectFiledColumn, " col-md-12"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (roiform_module_default()).formGroup,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (roiform_module_default()).formLabel,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                        className: (roiform_module_default()).mainLabel,
                                                                        children: [
                                                                            get_default()(roiOnlyformData[14], "field_label", ""),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                className: (roiform_module_default()).mandatoryField,
                                                                                children: "*"
                                                                            }),
                                                                            errorMsg ? runCostProcess == "" && runCostProcess.length == 0 || errors.runCostProcess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: (roiform_module_default()).errorMessage,
                                                                                children: get_default()(roiOnlyformData[1], "field_message_ip_error_message", [])
                                                                            }) : null : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "number",
                                                                    className: (roiform_module_default()).inputtext,
                                                                    name: "runCostProcess",
                                                                    id: "runCostProcess",
                                                                    onChange: handleFieldChange,
                                                                    value: runCostProcess,
                                                                    min: "0",
                                                                    placeholder: "Enter the annual run cost"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((roiform_module_default()).btnWrapper),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((roiform_module_default()).actionBtn),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "".concat((roiform_module_default()).btns, " ").concat((roiform_module_default()).backBtn, " ").concat((roiform_module_default()).secondBackBtn),
                                                        onClick: handleBack,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((roiform_module_default()).backArrowIcon),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                    name: "leftArrow",
                                                                    className: (roiform_module_default()).leftArrow
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((roiform_module_default()).text),
                                                                children: "Back"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((roiform_module_default()).actionBtn),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "".concat((roiform_module_default()).btns, " ").concat((roiform_module_default()).showRoiBtn),
                                                        onClick: handleShowRoi,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((roiform_module_default()).text),
                                                                children: "Show ROI"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((roiform_module_default()).arrowIcon),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roi_Icons, {
                                                                    name: "rightArrow",
                                                                    className: (roiform_module_default()).rightArrow
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roiform_module_default()).editModalContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {})
                })
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(roiModal, {
                setSuccessModal: true,
                name: "roiForm",
                title: "ROI Form",
                message: "message",
                roiFormModal: "closeBtn",
                closeModal: closeSuccessModal
            })
        ]
    });
}
var roi_mapStateToProps = function(state) {
    console.log("state", state);
    return {
        session: state.session.session
    };
};
function roi_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var roi = ((0,es/* connect */.$j)(roi_mapStateToProps, roi_mapDispatchToProps)(roi_index));

// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./components/shared/Container.jsx
var Container = __webpack_require__(21707);
;// CONCATENATED MODULE: ./components/layout/home/AboutEt.jsx

function AboutEt_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 99999;\n  pointer-events: none;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.6s ease-in;\n\n  &.active {\n    visibility: visible;\n    pointer-events: all;\n    opacity: 1;\n    transition: all 0.5s ease-in-out;\n  }\n\n  video {\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    AboutEt_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Modal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4fac072-0"
})(AboutEt_templateObject());
// const Shadow = styled.div`
//   z-index: 99999;
//   pointer-events: none;
//   visibility: hidden;
//   opacity: 0;
//   transition: all 0.4s ease-in;
//   &.active {
//     visibility: visible;
//     pointer-events: all;
//     opacity: 1;
//     transition: all 0.4s ease-in;
//   }
// `;
var AboutEt = function() {
    var ref = (0,react.useState)(false), showVideo = ref[0], setShowVideo = ref[1];
    var ref1 = (0,react.useState)("/imagess/ET Video.mp4"), videoUrl = ref1[0], setVideoUrl = ref1[1];
    var videoRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        if (!videoRef.current) return;
        if (showVideo) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    }, [
        showVideo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-opaciy-50 bg-black fixed top-0 left-0 h-screen w-screen z-[9999] transition-all ".concat(showVideo ? "visible pointer-events-auto opacity-100 bg-opacity-80" : "pointer-events-none invisible opacity-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 right-0 pt-4 mx-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineClose */.oHP, {
                        onClick: function() {
                            return setShowVideo(false);
                        },
                        className: "bg-red-500 h-8 w-8 p-1 text-white cursor-pointer rounded-full z-50"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                className: "h-[500px] w-11/12 md:w-[60vw]  ".concat(showVideo ? "active" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    ref: videoRef,
                    src: videoUrl,
                    className: "object-cover ".concat(showVideo ? "block" : "hidden"),
                    controls: true,
                    autoPlay: true,
                    loop: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-[#EBF3FD] md:rounded-tl-[8rem] md:rounded-br-[8rem] relative mt-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: "py-12 md:py-24 relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:w-[65%]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    className: "text-[2rem] md:text-5xl leading-[1.3] font-medium",
                                    children: [
                                        "Simply Consistent. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " Surprisingly Creative."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "my-8 text-gray-600 text-lg leading-[2]",
                                    children: "The new employee twins from HAP come with all that you seek in your team - resilience, smartness & learnability. And with Generative AI, you have more reasons than ever to choose Employee Twin-Legend. Supercharged with over 200 skills and anchored on MS Teams, versatility never came this easy. What’s more - over 10 new skills added every month!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-main mt-6 font-medium md:flex items-center gap-x-6 text-xl md:text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "flex items-center gap-x-2 duration-500 hover:text-blue-400",
                                            onClick: function() {
                                                setVideoUrl("/imagess/ET Video.mp4");
                                                setShowVideo(true);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Watch the film"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsPlayCircle */.zti, {
                                                    className: "mt-1"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "flex items-center gap-x-2 duration-500 md:mt-0 hover:text-blue-400",
                                            onClick: function() {
                                                setVideoUrl("/imagess/AARAMBH VIDE.mp4");
                                                setShowVideo(true);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Watch ET in Action"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsPlayCircle */.zti, {
                                                    className: "mt-1"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            class: "md:absolute bottom-14 right-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "md:absolute bottom-14 right-14",
                                src: "/imagess/icon.png",
                                height: 250,
                                width: 250
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var home_AboutEt = (AboutEt);

;// CONCATENATED MODULE: ./components/layout/home/FAQ.jsx





var faq = [
    {
        id: 1,
        question: "What Is Employee Twin?",
        answer: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "leading-[1.6]",
                    children: "ET is a digital team member that can join any team & is accessible to all the team members. ET will both function specific skill & also soft skills."
                })
            });
        }
    },
    {
        id: 2,
        question: "Who Can Hire An ET?",
        answer: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "leading-[1.6]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "As of today, Employee Twins are not personal assistants. They are designed to be team workers who do a bunch of tasks for the team they get on to, and unlock capacity of all the other human team members to put their time into activities that help them pursue their purpose or play to their personal strengths. So, in a line, any team that intends to get a bunch of tasks done at a fraction of the cost & time incurred with a human resource can hire an ET."
                })
            });
        }
    },
    {
        id: 3,
        question: "It has been a week and my team is not warming up to using the ET. What should I do?",
        answer: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "leading-[1.6]",
                children: "Look at the Employee Twin just as you would look at a newly added team member. The new member would come in with their set of skills, but would need some time to learn and fit in. If you are the leader of the team, you would need to facilitate situations which would require old team members to collaborate with the new member, sometimes teach the new member a thing or two. It is not very different for ET either - if you want ET to fit in, you should communicate to your team on when and how to use ET, recognize those in the team who have embraced ET or taken time to teach it and sometimes lead by example for your own personal deliverables. The good news is that our ET has the required intellectual capacity and learnability to make itself more and more useful as time goes on; plus HAP keeps adding to the skills catalogue every passing day."
            });
        }
    },
    {
        id: 4,
        question: "How much time does it take for an ET to be onboarded?",
        answer: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "leading-[1.6]",
                children: "Your ET will be activated with the chosen Soft Skills within 72 hours of purchase. Based on the Functional Skills chosen, they may get activated between 1-4 weeks of purchase."
            });
        }
    }, 
];
var FAQ = function() {
    var ref = (0,react.useState)(null), currentActive = ref[0], setCurrentActive = ref[1];
    var router = (0,next_router.useRouter)();
    var auth = JSON.parse(localStorage.getItem("auth")).data;
    var Etroles = [
        "sanjay.bohra@unilever.com",
        "Shravyashree.JC@unilever.com",
        "Sachin.Jalota@unilever.com",
        "Arnik.Khillar@unilever.com",
        "ritish.verma@unilever.com",
        "dinesh.s3@unilever.com",
        "Abhishek.U@unilever.com",
        "mani.jha@unilever.com",
        "Vinoth.Bhaskar@unilever.com",
        "madhurima.jaggi@unilever.com",
        "Vidish.Verma@unilever.com",
        "Soumendra.Mishra@unilever.com",
        "Anshu.rani@unilever.com",
        "binay.kumar@unilever.com",
        "Gopikrishna.M@unilever.com",
        "Veshaly.varshney@unilever.com",
        "aakib.ansari@unilever.com",
        "Garima.Bhadauria@unilever.com",
        "Ayush.Rautela@unilever.com",
        "Subhadip.Das@unilever.com",
        "Arti.Hajnale@unilever.com"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-16 bg-accent md:rounded-tr-[8rem]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid md:grid-cols-2 gap-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "text-4xl font-medium text-main",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#00D7C4]",
                                        children: "F"
                                    }),
                                    "requently ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#00D7C4]",
                                        children: "A"
                                    }),
                                    "sked ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#00D7C4]",
                                        children: "Q"
                                    }),
                                    "uestions"
                                ]
                            }),
                            Etroles.includes(auth.email) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "300px",
                                    marginTop: "3rem"
                                },
                                onClick: function() {
                                    return router.push("/createEmployeetwin");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    class: "py-3 px-6 text-center inline-block min-w-full twinBots text-lg md:text-s font-medium text-dark border-2 border-main rounded-full duration-500 hover:bg-main hover:text-white cursor-pointer",
                                    children: "Create Employee Twin"
                                })
                            }) : ""
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: faq.map(function(param, index) {
                            var question = param.question, Answer = param.answer;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: function() {
                                            if (index === currentActive) {
                                                return setCurrentActive(null);
                                            }
                                            setCurrentActive(index);
                                        },
                                        className: " grid grid-cols-12 gap-3 cursor-pointer items-center ".concat(index % 2 === 0 ? "bg-main text-white" : "bg-accent text-main", " py-4 px-4 capitalize "),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "col-span-10 font-medium leading-7",
                                                children: question
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "col-span-2",
                                                children: currentActive === index ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineMinus */.ywL, {
                                                    className: "mt-1 h-5 w-5"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlinePlus */.Lfi, {
                                                    className: "mt-1 h-5 w-5"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(currentActive === index ? "block" : "hidden", " text-sm px-4 py-4"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Answer, {})
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var home_FAQ = (FAQ);

;// CONCATENATED MODULE: ./public/imagess/bigImage.jpg
/* harmony default export */ var bigImage = ({"src":"/_next/static/media/bigImage.77259f8c.jpg","height":1150,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAIQj/8QAGRAAAgMBAAAAAAAAAAAAAAAAAQMABCER/9oACAEBAAE/AKrmOX3AQBs//8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAgBAgEBPwB//8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAgBAwEBPwB//9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/imagess/skillImage.jpg
/* harmony default export */ var skillImage = ({"src":"/_next/static/media/skillImage.deae35f6.jpg","height":875,"width":1720,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAQACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABwEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAK0Cv//EABkQAAIDAQAAAAAAAAAAAAAAAAIRAAESUf/aAAgBAQABPwAa0L6p/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAIAQIBAT8Ar//EABURAQEAAAAAAAAAAAAAAAAAAAAC/9oACAEDAQE/AJf/2Q==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./components/layout/home/FlipSection.jsx

function FlipSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 500px;\n  perspective: 1000px;\n"
    ]);
    FlipSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: rotateY(180deg);\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  transition: transform 1.7s;\n  transform-style: preserve-3d;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  backface-visibility: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  backface-visibility: hidden;\n  transform: rotateY(180deg);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: 30;\n\n  svg {\n    transition: all 0.8s ease-in;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var FlipCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1a9f5fc-0"
})(FlipSection_templateObject());
var FlipSection_Card = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1a9f5fc-1"
})(_templateObject2(), function(props) {
    return props.isFlipped && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
var Front = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1a9f5fc-2"
})(_templateObject3());
var Back = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1a9f5fc-3"
})(_templateObject4());
var FlipIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1a9f5fc-4"
})(_templateObject5());
var FlippableSection = function() {
    var ref = (0,react.useState)(false), isFlipped = ref[0], setIsFlipped = ref[1];
    var handleFlip = function() {
        setIsFlipped(function(prevState) {
            return !prevState;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlipCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlipSection_Card, {
                isFlipped: isFlipped,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Front, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            className: "h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        srcSet: "/public/imagess/mobile-skillImage.jpg",
                                        media: "(max-width: 777px)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        fill: true,
                                        src: skillImage,
                                        height: 900,
                                        alt: "skill image",
                                        placeholder: "blur",
                                        className: "h-full w-full object-cover"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Back, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            className: "h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        media: "(max-width: 777px)",
                                        srcSet: "/public/imagess/flippable-sm.jpg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        fill: true,
                                        src: bigImage,
                                        height: 900,
                                        placeholder: "blur",
                                        className: "h-full w-full object-cover"
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlipIcon, {
                children: isFlipped ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineMinusCircle */._nT, {
                    className: "h-8 w-8 cursor-pointer text-white m-3",
                    onClick: handleFlip
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlinePlusCircle */.dEn, {
                    className: "h-8 w-8 cursor-pointer",
                    onClick: handleFlip
                })
            })
        ]
    });
};
/* harmony default export */ var FlipSection = (FlippableSection);

;// CONCATENATED MODULE: ./public/imagess/hero-right.png
/* harmony default export */ var hero_right = ({"src":"/_next/static/media/hero-right.a6924a29.png","height":852,"width":903,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA20lEQVR42mNABmu2nDB68f8/75v//zXe/7/FyAACvXNXMRZ+/Q/m9C87uW7awtUzejee/vvi+qTL/y8xGDGAwLqeBhYQvWHBzPBlW3Z/TJ976t/tc9P+/7qqsp+BYd9/ZoYZ/1lBChIZGOQ2nLq2efGNX//P7O34//WixTyGkxcqrWesnnSFYdJ0c5CignP/+NbsOTDn3OlVU/7fYuBlCJyyP8Vj+uL/DCtqqxkYwICRARm0pl8SY5o309N9cw43iD/tyHGm3r0PWY7vn8Xy/XoIqmLfVTWMDGgAAFN9YZR5ZQVCAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/layout/home/hero/Hero.jsx

function Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  @media (min-width: 640px) {\n    background: url("/imagess/hero-bg.png");\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n  }\n\n  h1 {\n    span > span:first-of-type {\n      &::after {\n        content: "";\n        background-image: url("/imagess/ee.svg");\n        background-size: contain;\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        background-repeat: no-repeat;\n      }\n    }\n  }\n'
    ]);
    Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// import HeroTitle from "./HeroTitle";

var HeroSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-[#EBF3FD] md:bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Hero, {
            className: "pt-10 md:pt-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid md:grid-cols-2 md:gap-12 items-center ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            style: {
                                width: "max-content"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-6xl md:text-7xl font-bold text-main",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "relative",
                                                children: "Employ"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block absolute -right-[6rem] mt-6",
                                                children: "Twin"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-3xl md:text-xl font-medium text-black mt-[100px] pt-6 mb-14 text-center md:text-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Simply consistent."
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: " md:mt-4 block sm:inline",
                                            children: "Surprisingly creative."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-11/12 md:w-auto flex flex-col gap-6 mt-6 md:mt-0",
                                    style: {
                                        marginLeft: "20px",
                                        marginRight: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/checkout/all?origin=home",
                                            className: "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "md:py-3 px-6 text-center inline-block min-w-full md:min-w-full twinBots text-lg md:text-s font-medium text-dark border-2 border-main rounded-full duration-500 hover:bg-main hover:text-white cursor-pointer",
                                                children: "Hire your Employee Twin now!"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/export-employeetwin",
                                            className: "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "md:py-3 px-6 text-center inline-block min-w-full md:min-w-full text-lg md:text-s font-medium text-[#00a888] border-2 border-[#00a888] rounded-full duration-500 hover:bg-[#00a888] hover:text-white cursor-pointer",
                                                children: "Export Employee Twins"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: hero_right,
                                    placeholder: "blur",
                                    alt: "employee twin"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Hero = (HeroSection);
var Hero_Hero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe3d3493-0"
})(Hero_templateObject());

// EXTERNAL MODULE: ./components/layout/home/twinSlider/TwinBots.jsx + 2 modules
var TwinBots = __webpack_require__(75166);
// EXTERNAL MODULE: ./components/shared/Layout.jsx + 12 modules
var Layout = __webpack_require__(65292);
;// CONCATENATED MODULE: ./components/newEmployeetwin/index.jsx










// Code for session







var HomePage = function(props) {
    //code for session
    var router = (0,next_router.useRouter)();
    var currentUrl = router.asPath;
    var ref = (0,react.useState)(false), successModal1 = ref[0], setSuccessModal1 = ref[1];
    var checkAuthorization = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var authData, auth, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authData = JSON.parse(localStorage.getItem("auth"));
                        if (!authData || !authData.data) {
                            // Handle the case when authData or authData.data is falsy
                            props.sessionTimeOutCheck(true);
                            localStorage.setItem("redirectprofileurl", JSON.stringify(currentUrl));
                            return [
                                2
                            ]; // Return without making the API call
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                method: "GET",
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/roi/checkAuthorization"),
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        console.log("checkAuthorization", data);
                        if (data.data.code === 200) {
                            console.log("Authorized User", data.data);
                        } else if (data.code === 403) {
                            setTimeout(function() {
                                props.sessionTimeOutCheck(true);
                            }, 1000);
                            console.log("Error in authorization", data);
                            localStorage.setItem("redirectprofileurl", JSON.stringify(currentUrl));
                        } else {
                            props.sessionTimeOutCheck(true);
                            localStorage.setItem("redirectprofileurl", JSON.stringify(currentUrl));
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log("Error in Authorization", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function checkAuthorization() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        checkAuthorization();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_AboutEt, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-10 bg-white relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlipSection, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TwinBots/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_FAQ, {})
            ]
        })
    });
};
//code for session
var newEmployeetwin_mapStateToProps = function(state) {
    console.log("state", state);
    return {
        session: state.session.session
    };
};
function newEmployeetwin_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch),
        checkExpiry: (0,redux/* bindActionCreators */.DE)(actions/* checkExpiry */.Wr, dispatch)
    };
}
/* harmony default export */ var newEmployeetwin = ((0,es/* connect */.$j)(newEmployeetwin_mapStateToProps, newEmployeetwin_mapDispatchToProps)(HomePage));

// EXTERNAL MODULE: ./components/layout/checkout/etprofile.module.scss
var etprofile_module = __webpack_require__(58001);
var etprofile_module_default = /*#__PURE__*/__webpack_require__.n(etprofile_module);
;// CONCATENATED MODULE: ./components/layout/checkout/ETProfile.jsx











function ETProfile(param) {
    var onNext = param.onNext, onPrevious = param.onPrevious, leadPlatform = param.leadPlatform, cluster = param.cluster;
    console.log(leadPlatform);
    var route = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), etName = ref[0], setETName = ref[1];
    var ref1 = (0,react.useState)("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/etdefault.jpg"), logoFile = ref1[0], setLogoFile = ref1[1];
    var ref2 = (0,react.useState)(""), functionValue = ref2[0], setFunctionValue = ref2[1];
    var ref3 = (0,react.useState)(""), regionValue = ref3[0], setRegionValue = ref3[1];
    var ref4 = (0,react.useState)(""), description = ref4[0], setDescription = ref4[1];
    var ref5 = (0,react.useState)([
        "jpg",
        "jpeg",
        "png", 
    ]), fileTypesp = ref5[0], setfileTypesp = ref5[1];
    var ref6 = (0,react.useState)(false), fileerror = ref6[0], setFileError = ref6[1];
    var ref7 = (0,react.useState)(false), filesuccess = ref7[0], setFilesuccess = ref7[1];
    var ref8 = (0,react.useState)(null), file = ref8[0], setFile = ref8[1];
    var ref9 = (0,react.useState)(null), fileNameOriginal = ref9[0], setFileName = ref9[1];
    var ref10 = (0,react.useState)(false), showFileName = ref10[0], setShowFileName = ref10[1];
    var ref11 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref11[0], setSubmitForm = ref11[1];
    var ref12 = (0,react.useState)(leadPlatform.field_options), functionname = ref12[0], setFunctionname = ref12[1];
    var ref13 = (0,react.useState)(cluster.field_options), clustername = ref13[0], setClustername = ref13[1];
    var handleFileChange = function(event) {
        var file = event.target.files[0];
        if (file) {
            uploadFile(file);
            setLogoFile(file);
        }
    };
    var azurefilepath;
    var blobSasUrl = "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
    var blobSasUrlNew = utility_endpoints/* default.blobSasUrlNew */.ZP.blobSasUrlNew;
    // "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
    var blobServiceClient = new BlobServiceClient/* BlobServiceClient */.N(blobSasUrlNew);
    var containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin/emp");
    var uploadFile = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(imageFile) {
            var originalFileName, fileName, index, extension, blockBlobClient, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        {}
                        originalFileName = imageFile.name;
                        fileName = originalFileName;
                        index = 1;
                        _state.label = 1;
                    case 1:
                        return [
                            4,
                            containerClient.getBlockBlobClient(fileName).exists()
                        ];
                    case 2:
                        if (!_state.sent()) return [
                            3,
                            3
                        ];
                        {
                            extension = originalFileName.substring(originalFileName.lastIndexOf("."));
                            fileName = "".concat(originalFileName.substring(0, originalFileName.lastIndexOf(".")), "_").concat(index).concat(extension);
                            index++;
                        }
                        return [
                            3,
                            1
                        ];
                    case 3:
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(imageFile)
                        ];
                    case 5:
                        _state.sent();
                        console.log("Image uploaded successfully!");
                        setLogoFile("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" + fileName);
                        setFilesuccess(true);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        setFileError(true);
                        console.error("Error uploading image:", error);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadFile(imageFile) {
            return _ref.apply(this, arguments);
        };
    }();
    var uploadButtonClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var fileNameWithSpaces, fileName, ar, extension, fileSize, blockBlobClient, options, resp, url, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fileNameWithSpaces = fileNameOriginal;
                        fileName = fileNameWithSpaces.replace(/ /g, "");
                        ar = fileNameOriginal.split(".");
                        extension = ar[ar.length - 1];
                        fileSize = file.size;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        blockBlobClient = containerClient.getBlockBlobClient(fileName);
                        options = {
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        };
                        return [
                            4,
                            blockBlobClient.uploadBrowserData(file, options)
                        ];
                    case 2:
                        resp = _state.sent();
                        console.log(resp, "response of azure");
                        url = resp._response.request.url;
                        setSuccessModal(true);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error, "erro");
                        alert("Could not upload");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var onFormsubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var authCheck, auth, orderID;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        if (!!etName) return [
                            3,
                            1
                        ];
                        setSubmitForm(true);
                        return [
                            3,
                            4
                        ];
                    case 1:
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 2:
                        auth = _state.sent();
                        return [
                            4,
                            JSON.parse(localStorage.getItem("orderID"))
                        ];
                    case 3:
                        orderID = _state.sent();
                        axios_default()({
                            method: "POST",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/createCartFormDataEntry"),
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            },
                            data: {
                                ET_name: etName,
                                ET_logo: logoFile,
                                "employeeTwinID": "",
                                "functionField": functionValue,
                                "region": regionValue,
                                "descriptions": description,
                                "Business_owner": "",
                                "Country_code": "",
                                "GL_Account": "",
                                "Cost_centre_owner": "",
                                "To_country_code": "",
                                "To_cost_centre": "",
                                "commentText": "",
                                "commentType": "",
                                "orderID": orderID
                            }
                        }).then(function(resp) {
                            if (resp.data.code == 403) {
                                setLoading(false);
                            } else if (resp.data.code == 201 || resp.data.code == 200) {
                                //    // route.push('/CCDetails');
                                if (typeof onNext === "function") {
                                    onNext(); // Call onNext if it's a function
                                }
                            } else if (resp.data.code == 400) {}
                        });
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFormsubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (etprofile_module_default()).et_container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (etprofile_module_default()).et_main_content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (etprofile_module_default()).et_top_heading,
                    children: "Create your ET Profile"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (etprofile_module_default()).etname_content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (etprofile_module_default()).et_content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: (etprofile_module_default()).et_label,
                                    children: [
                                        "Name Your ET",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (etprofile_module_default()).et_span,
                                            children: "* "
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    className: (etprofile_module_default()).et_input,
                                    value: etName,
                                    onChange: function(e) {
                                        return setETName(e.target.value);
                                    },
                                    name: "etname"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (etprofile_module_default()).et_content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: (etprofile_module_default()).et_label,
                                    children: "Upload Logo"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (etprofile_module_default()).et_logo_container,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "file",
                                            className: "".concat((etprofile_module_default()).et_input, " ").concat((etprofile_module_default()).logo_input),
                                            onChange: function(e) {
                                                handleFileChange(e);
                                            },
                                            name: "etlogo"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "./assets/img/Rectangle-347.png",
                                            alt: "",
                                            className: (etprofile_module_default()).Uploadlogo
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (etprofile_module_default()).etupload_content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (etprofile_module_default()).et_content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: (etprofile_module_default()).et_label,
                                    children: "Lead Platform"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                    className: (etprofile_module_default()).et_input,
                                    value: functionValue,
                                    onChange: function(e) {
                                        return setFunctionValue(e.target.value);
                                    },
                                    name: "etfunction",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            children: "Select"
                                        }),
                                        functionname.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: item,
                                                children: item
                                            }, index);
                                        }),
                                        ";"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (etprofile_module_default()).et_content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: (etprofile_module_default()).et_label,
                                    children: "Cluster"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                    className: (etprofile_module_default()).et_input,
                                    value: regionValue,
                                    onChange: function(e) {
                                        return setRegionValue(e.target.value);
                                    },
                                    name: "etregion",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            children: "Select"
                                        }),
                                        clustername.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: item,
                                                children: item
                                            }, index);
                                        }),
                                        ";"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (etprofile_module_default()).et_descrip_content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: (etprofile_module_default()).et_des_label,
                            children: "Descriptions"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                            rows: "4",
                            cols: "50",
                            className: (etprofile_module_default()).et_des_input,
                            value: description,
                            onChange: function(e) {
                                return setDescription(e.target.value);
                            },
                            name: "description"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (etprofile_module_default()).et_proceed_btn_content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (etprofile_module_default()).et_proceed_btn,
                            onClick: onPrevious,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowRoundBack */.PjY, {
                                    className: (etprofile_module_default()).et_arrow_btn
                                }),
                                "Previous"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (etprofile_module_default()).et_proceed_btn,
                            onClick: onFormsubmit,
                            children: [
                                "Proceed to hire ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowRoundForward */.fNt, {
                                    className: (etprofile_module_default()).et_arrow_btn
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var checkout_ETProfile = (ETProfile);

// EXTERNAL MODULE: ./components/layout/checkout/ccdetails.module.scss
var ccdetails_module = __webpack_require__(93432);
var ccdetails_module_default = /*#__PURE__*/__webpack_require__.n(ccdetails_module);
;// CONCATENATED MODULE: ./components/layout/checkout/CCDetails.jsx










function CCDetails(param) {
    var onNext = param.onNext, onPrevious = param.onPrevious;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), businessowner = ref[0], setBusinessowner = ref[1];
    var ref1 = (0,react.useState)(""), countrycode = ref1[0], SetCountrycode = ref1[1];
    var ref2 = (0,react.useState)(""), tocountrycode = ref2[0], SetToCountrycode = ref2[1];
    var ref3 = (0,react.useState)(""), glaccount = ref3[0], SetGlaccount = ref3[1];
    var ref4 = (0,react.useState)(""), costcenterowner = ref4[0], SetCostcenterowner = ref4[1];
    var ref5 = (0,react.useState)(""), tocostcenter = ref5[0], SetToCostcenter = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref6[0], setSubmitForm = ref6[1];
    var onFromSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var authCheck, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        {}
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        auth = _state.sent();
                        axios_default()({
                            method: "POST",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/createCartFormDataEntry"),
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            },
                            data: {
                                "employeeTwinID": "",
                                "Business_owner": businessowner,
                                "Country_code": countrycode,
                                "GL_Account": glaccount,
                                "Cost_centre_owner": costcenterowner,
                                "To_country_code": tocountrycode,
                                "To_cost_centre": tocostcenter
                            }
                        }).then(function(resp) {
                            if (resp.data.code == 403) {
                            // setLoading(false)
                            } else if (resp.data.code == 200 || resp.data.code == 201) {
                                // router.push('/ETComments');
                                if (typeof onNext === "function") {
                                    onNext(); // Call onNext if it's a function
                                }
                            } else if (resp.data.code == 400) {}
                        });
                        return [
                            2
                        ];
                }
            });
        //}
        });
        return function onFromSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ccdetails_module_default()).cc_details_bg,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ccdetails_module_default()).cc_details_bg_inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (ccdetails_module_default()).CC_main_heading,
                    children: "Add CC Details"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ccdetails_module_default()).cc_details_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ccdetails_module_default()).cc_details_business,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ccdetails_module_default()).cc_label_input_content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (ccdetails_module_default()).cc_details_label,
                                            children: " Business Owner "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (ccdetails_module_default()).cc_details_input,
                                            value: businessowner,
                                            onChange: function(e) {
                                                return setBusinessowner(e.target.value);
                                            },
                                            name: "etname"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ccdetails_module_default()).cc_label_input_content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (ccdetails_module_default()).cc_details_label,
                                            children: " GL Account "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (ccdetails_module_default()).cc_details_input,
                                            value: glaccount,
                                            onChange: function(e) {
                                                return SetGlaccount(e.target.value);
                                            },
                                            name: "glaccount"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ccdetails_module_default()).cc_label_input_content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (ccdetails_module_default()).cc_details_label,
                                            children: " To Country Code "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (ccdetails_module_default()).cc_details_input,
                                            value: tocountrycode,
                                            onChange: function(e) {
                                                return SetToCountrycode(e.target.value);
                                            },
                                            name: "tocountrycode"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ccdetails_module_default()).cc_details_code,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ccdetails_module_default()).cc_label_input_content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (ccdetails_module_default()).cc_details_label,
                                            children: " Country Code "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (ccdetails_module_default()).cc_details_input,
                                            value: countrycode,
                                            onChange: function(e) {
                                                return SetCountrycode(e.target.value);
                                            },
                                            name: "countrycode"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ccdetails_module_default()).cc_label_input_content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (ccdetails_module_default()).cc_details_label,
                                            children: " Cost Centre Owner "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (ccdetails_module_default()).cc_details_input,
                                            value: costcenterowner,
                                            onChange: function(e) {
                                                return SetCostcenterowner(e.target.value);
                                            },
                                            name: "costcenterowner"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ccdetails_module_default()).cc_label_input_content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (ccdetails_module_default()).cc_details_label,
                                            children: " To Cost Centre "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (ccdetails_module_default()).cc_details_input,
                                            value: tocostcenter,
                                            onChange: function(e) {
                                                return SetToCostcenter(e.target.value);
                                            },
                                            name: "tocostcenter"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ccdetails_module_default()).cc_details_btn_content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (ccdetails_module_default()).cc_details_btn,
                            onClick: onPrevious,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowRoundBack */.PjY, {
                                    className: (ccdetails_module_default()).cc_arrow_btn
                                }),
                                "Previous"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (ccdetails_module_default()).cc_details_btn,
                            onClick: onFromSubmit,
                            children: [
                                "Proceed to hire ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowRoundForward */.fNt, {
                                    className: (ccdetails_module_default()).cc_arrow_btn
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var checkout_CCDetails = (CCDetails);

// EXTERNAL MODULE: ./components/layout/checkout/etcomments.module.scss
var etcomments_module = __webpack_require__(791);
var etcomments_module_default = /*#__PURE__*/__webpack_require__.n(etcomments_module);
;// CONCATENATED MODULE: ./components/layout/checkout/ETComments.jsx










function ETComments(param) {
    var onNext = param.onNext, onPrevious = param.onPrevious;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), commentText = ref[0], setCommentText = ref[1];
    var ref1 = (0,react.useState)(""), commentType = ref1[0], setCommentType = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), submitForm = ref2[0], setSubmitForm = ref2[1];
    var ref3 = (0,react.useState)(""), selectedButtonType = ref3[0], setSelectedButtonType = ref3[1];
    var handleButtonClick = function(buttonType) {
        setCommentType(buttonType);
        setSelectedButtonType(buttonType); // Set the selected button type
    };
    var onFromSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var authCheck, auth;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        authCheck = JSON.parse(localStorage.getItem("auth")).data;
                        {}
                        return [
                            4,
                            JSON.parse(localStorage.getItem("auth")).data
                        ];
                    case 1:
                        auth = _state.sent();
                        axios_default()({
                            method: "POST",
                            url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/createCartFormDataEntry"),
                            headers: {
                                Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                            },
                            data: {
                                "employeeTwinID": "",
                                "commentText": commentText,
                                "commentType": commentType,
                                "status": 1
                            }
                        }).then(function(resp) {
                            if (resp.data.code == 403) {
                            // setLoading(false)
                            } else if (resp.data.code == 200 || resp.data.code == 201) {
                                router.push("/ETthankyou");
                            } else if (resp.data.code == 400) {}
                        });
                        return [
                            2
                        ];
                }
            });
        //}
        });
        return function onFromSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (etcomments_module_default()).etcommtcontainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (etcomments_module_default()).etcommentcontent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (etcomments_module_default()).etcommentheading,
                    children: "Comments"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (etcomments_module_default()).etcommtbtncontent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "".concat((etcomments_module_default()).etcmtbtn, " ").concat(selectedButtonType === "New Skill" && (etcomments_module_default()).selectedButton),
                            onClick: function() {
                                return handleButtonClick("New Skill");
                            },
                            children: "New Skill"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "".concat((etcomments_module_default()).etcmtbtn, " ").concat(selectedButtonType === "Feedback" && (etcomments_module_default()).selectedButton),
                            onClick: function() {
                                return handleButtonClick("Feedback");
                            },
                            children: "Feedback"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "".concat((etcomments_module_default()).etcmtbtn, " ").concat(selectedButtonType === "Queries" && (etcomments_module_default()).selectedButton),
                            onClick: function() {
                                return handleButtonClick("Queries");
                            },
                            children: "Queries"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "".concat((etcomments_module_default()).etcmtbtn, " ").concat(selectedButtonType === "Others" && (etcomments_module_default()).selectedButton),
                            onClick: function() {
                                return handleButtonClick("Others");
                            },
                            children: "Others"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (etcomments_module_default()).et_commt_area_div,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                        className: (etcomments_module_default()).et_commt_area,
                        placeholder: "Enter Comments",
                        value: commentText,
                        onChange: function(e) {
                            return setCommentText(e.target.value);
                        },
                        name: "commentText"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (etcomments_module_default()).et_commt_btn_content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (etcomments_module_default()).et_commt_btn,
                            onClick: onPrevious,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowRoundBack */.PjY, {
                                    className: (etcomments_module_default()).et_arrow_btn
                                }),
                                "Previous"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (etcomments_module_default()).et_commt_btn,
                            onClick: onFromSubmit,
                            children: [
                                "CHECK OUT ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowRoundForward */.fNt, {
                                    className: (etcomments_module_default()).et_arrow_btn
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var checkout_ETComments = (ETComments);

// EXTERNAL MODULE: ./components/layout/checkout/thankyoupage.module.scss
var thankyoupage_module = __webpack_require__(19677);
var thankyoupage_module_default = /*#__PURE__*/__webpack_require__.n(thankyoupage_module);
;// CONCATENATED MODULE: ./components/layout/checkout/Thankyoupage.jsx




var ThankyouPage = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (thankyoupage_module_default()).etthankBg,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (thankyoupage_module_default()).thankcross,
                onClick: function() {
                    return router.push("/newemployeetwin");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rx_index_esm/* RxCross2 */.$iT, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (thankyoupage_module_default()).etthankBnr,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (thankyoupage_module_default()).etthankparacontainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (thankyoupage_module_default()).etthankheading,
                            children: "Thank you! "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (thankyoupage_module_default()).etthankpara,
                            children: "Your new Hire will be joining you in 7 working days with the set of soft skills."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (thankyoupage_module_default()).etthankparamain,
                            children: "HAP Delivery will be in touch with you to help on onboarding the Employee Twin with the other skills within 2 working days."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (thankyoupage_module_default()).etthankpara,
                            children: [
                                "For any further queries, contact",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (thankyoupage_module_default()).etthankparaspan,
                                    children: "HAP@Unilever.com"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Thankyoupage = (ThankyouPage);

// EXTERNAL MODULE: ./components/layout/checkout/etskills.module.scss
var etskills_module = __webpack_require__(89214);
var etskills_module_default = /*#__PURE__*/__webpack_require__.n(etskills_module);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./components/elements/Loader.jsx
var elements_Loader = __webpack_require__(85789);
;// CONCATENATED MODULE: ./components/layout/checkout/ETskills.jsx













var ETskills = function(param) {
    var onNext = param.onNext;
    var route = (0,next_router.useRouter)();
    var storedCart = JSON.parse(localStorage.getItem("cartpopdata"));
    var auth = JSON.parse(localStorage.getItem("auth")).data;
    var ref = (0,react.useState)([]), allData = ref[0], setAllData = ref[1];
    var ref1 = (0,react.useState)(true), isLoadings = ref1[0], setIsLoadings = ref1[1];
    var ref2 = (0,react.useState)(false), deleted = ref2[0], setDeleted = ref2[1];
    var ref3 = (0,react.useState)(), skillItem = ref3[0], setSkillItem = ref3[1];
    var ref4 = (0,react.useState)(), skillPrice = ref4[0], setSkillPrice = ref4[1];
    var botImages = {
        SS00005: "/Currency Converter.png",
        SS00006: "/Schedule Meeting with Gen AI.png",
        SS00007: "/Send Emails.png",
        SS00009: "/Profile Specific Business News.png",
        SS00010: "/Profile Specific Organization Chart.png",
        SS00011: "/Profile Specific Roles & Responsibilities.png",
        SS00013: "/FAQ - SOPs, Knowledge Articles etc..png",
        SS00019: "/Dictionary.png",
        SS00023: "/Weather Report- Broadcastper request.png",
        SS00024: "/PPT Creation with Grunt.png",
        SS00025: "/World Clock.png",
        SS00027: "/Document Utilities.png",
        SS00028: "/Summarization.png",
        SS00034: "/ChatGPT translation.png",
        SS00035: "/Proof read documents.png",
        SS00042: "/Knowledge Management.png",
        SS00043: "/Ask ChatGPT.png",
        SS00044: "/Treasury.png",
        6099: "/BlueCollar Compensation Change.png",
        6100: "/BlueCollar Cost Centre Change.png",
        6101: "/BlueCollar LM Change.png",
        6357: "/Remove Unutilized BMI WBS.png",
        6405: "/Employee Advance-Knockoff.png",
        6554: "/TA Forms in Cognos.png",
        6235: "/Channel review.png",
        6170: "/POT_KPI DASHBOARD.png",
        6257: "/Consolidated financials.png",
        6293: "/Provision Proposal Notes.png",
        6312: "/B&W PBI KPI Dashboard.png",
        6500: "/TA Forms In Cognos Automation-OCR.png",
        5887: "/Balance Sheet P&L.png",
        6031: "/PNCC CNCC Non-Freight.png",
        6141: "/P2P_Progress barcode report.png",
        6417: "/SC - CS - DSLR ECOM.png",
        6422: "/DSLR Retail Process.png",
        6018: "/VAR Report.png",
        6476: "/CCR BaseFile Updation.png",
        6019: "/POR Tracker.png",
        5909: "/Related Party Transaction.png",
        5991: "/NSA Tracker.png",
        6032: "/Promo Slab Evaluation.png",
        6050: "/PLBS Phase 2.png",
        6104: "/Segment PL.png",
        6142: "/SEGMENT BALANCE SHEET.png",
        6259: "/UL FR Master Data Report.png",
        6306: "/SC - CS - Appointment Plan SAP.png",
        6308: "/SAP Master Extract.png",
        6340: "/Returns data.png",
        6350: "/Order Drop.png",
        6353: "/Allocation Report.png",
        6366: "/CS HANA Reports.png",
        6381: "/Bills Discounting Vendor Names.png",
        6401: "/PO Prioritization Retail.png",
        6404: "/ULBPSUPCUSF121POPrioritizationEcom.png",
        6409: "/PO Prioritization CSD.png",
        6412: "/FSA_Addition.png",
        6433: "/SC CS Retail MORE MRP Updation.png",
        6445: "/Duplicate Lines Check.png",
        6448: "/SC-CS-ECOMM Availability Master.png",
        6449: "/MOP Preparation.png",
        6464: "/Credit Blocks and Stamp Removal.png",
        6474: "/SC-CS-ECOMM Assortment Tracker.png",
        6485: "/BMI Scheduling.png",
        6486: "/CAPEX Reporting and MIS.png",
        6501: "/WBS Utilization Report.png",
        6298: "/Innoflex PBI Refresh.png"
    };
    //const totalCost = storedCart.reduce((acc, item) => acc + item.price, 0);
    var deleteCartSkill = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(item) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/deleteSelectedSkill?skillID=").concat(item.skillID),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        //console.log(data);
                        if (data.code === 200) {
                            console.log("data deleted from cart");
                            setDeleted(!deleted);
                        } else {
                            console.log("No data found");
                        }
                        react_toastify_esm/* toast.warn */.Am.warn("".concat(item === null || item === void 0 ? void 0 : item.skillName, " is removed"), {
                            position: react_toastify_esm/* toast.POSITION.TOP_RIGHT */.Am.POSITION.TOP_RIGHT,
                            autoClose: 3000
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteCartSkill(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var auth, resp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default()({
                                url: "".concat(utility_endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/getselectedSkills"),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 2:
                        resp = _state.sent();
                        localStorage.setItem("orderID", JSON.stringify(resp.data.response.orderID));
                        console.log(resp);
                        if (resp.data.code === 200) {
                            if (resp.data.response) {
                                setAllData(resp.data.response.selectedSkills);
                                setSkillItem(resp.data.response.totalItemsInMiniCart);
                                setSkillPrice(resp.data.response.totalPriceOfMiniCart);
                            } else {
                                setAllData([]);
                                setSkillItem(0);
                            }
                            console.log(resp);
                        } else {
                            setSkillItem(0);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error fetching data:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setIsLoadings(true);
        var fetchDataTimeout = setTimeout(function() {
            setIsLoadings(false);
            fetchData();
        }, 1500); // 3000 milliseconds = 3 seconds
        return function() {
            // Clear the timeouts if the component unmounts or if the dependency changes
            clearTimeout(fetchDataTimeout);
        };
    }, [
        deleted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (etskills_module_default()).maincontainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (etskills_module_default()).skillsheading,
                children: "Your Employee Twin Skills"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (etskills_module_default()).customTable,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                    className: "table table-striped ",
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            className: (etskills_module_default()).skillsheaddiv,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: (etskills_module_default()).tr,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: (etskills_module_default()).skillthead,
                                        children: "Skill Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: (etskills_module_default()).skillthead,
                                        children: "Cost"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: (etskills_module_default()).skillthead
                                    })
                                ]
                            })
                        }),
                        isLoadings ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center my-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_Loader/* default */.Z, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            className: (etskills_module_default()).skilltbody,
                            children: allData.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    className: index % 2 === 0 ? (etskills_module_default()).evenRow : (etskills_module_default()).oddRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: (etskills_module_default()).skillstd,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (etskills_module_default()).skillidcontainer,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: botImages[item.skillID] ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/skills/all".concat(botImages[item.skillID]),
                                                            alt: "skill",
                                                            height: 60,
                                                            width: 60
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "/imagess/skill.png",
                                                            alt: "skill",
                                                            height: 70,
                                                            width: 70
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (etskills_module_default()).skillidname,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (etskills_module_default()).skillbotid,
                                                                children: item.skillID
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (etskills_module_default()).skillbotname,
                                                                children: item.skillName
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "".concat((etskills_module_default()).skillstd, " ").concat((etskills_module_default()).skillbotprice),
                                            children: [
                                                "€",
                                                item.price
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: (etskills_module_default()).skillstd,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (etskills_module_default()).skillsdltbtndiv,
                                                onClick: function() {
                                                    deleteCartSkill(item);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiDeleteBin6Line */.GnT, {})
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (etskills_module_default()).totalskillcontainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (etskills_module_default()).totalskillcontent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (etskills_module_default()).skillhirebtn,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "d-flex",
                                onClick: function() {
                                    return route.push("checkout/all?origin=home");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowRoundBack */.PjY, {
                                        className: (etskills_module_default()).skillarrowbtn
                                    }),
                                    "Back"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (etskills_module_default()).ETskillstotal,
                                    children: "Total Skills"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (etskills_module_default()).ETskillstotalnumber,
                                    children: [
                                        skillItem,
                                        " skills"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (etskills_module_default()).costcontainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (etskills_module_default()).ETskillstotal,
                                    children: "Total Cost"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (etskills_module_default()).ETskillstotalnumber,
                                    children: [
                                        "€",
                                        skillPrice
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (etskills_module_default()).skillhirebtn,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        return onNext({
                                            skilldata: allData
                                        });
                                    },
                                    children: "Proceed to hire"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowRoundForward */.fNt, {
                                    className: (etskills_module_default()).skillarrowbtn
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var checkout_ETskills = (ETskills);

// EXTERNAL MODULE: ./components/layout/checkout/progressbar.module.scss
var progressbar_module = __webpack_require__(96820);
var progressbar_module_default = /*#__PURE__*/__webpack_require__.n(progressbar_module);
;// CONCATENATED MODULE: ./components/layout/checkout/Progressbar.jsx



var ProgressBar = function(param) {
    var currentStep = param.currentStep, totalSteps = param.totalSteps, onNext = param.onNext, onPrevious = param.onPrevious;
    var stepNames = [
        "1",
        "2",
        "3",
        "4"
    ];
    var stepColors = [
        "#100505",
        "#100505",
        "#100505",
        "#100505"
    ];
    var handleStepClick = function(index) {
        if (index < currentStep) {
            onPrevious(index);
        } else if (index > currentStep) {
            onNext(index);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (progressbar_module_default()).ProgressBarmain,
                children: stepNames.map(function(stepName, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (progressbar_module_default()).step,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((progressbar_module_default()).stepName, " ").concat(currentStep > index + 1 ? (progressbar_module_default()).completed : ""),
                                style: {
                                    color: currentStep > index + 1 ? stepColors[index] : "#100505"
                                }
                            }),
                            index < totalSteps - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((progressbar_module_default()).stepDivider, " ").concat(currentStep > index + 1 ? (progressbar_module_default()).completed : ""),
                                style: {
                                    backgroundColor: currentStep > index + 1 ? stepColors[index] : "#CFCDCD"
                                }
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (progressbar_module_default()).stepprogressbar,
                children: stepNames.map(function(stepName, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (progressbar_module_default()).stepprogressbarbtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                return handleStepClick(index + 1);
                            },
                            className: "".concat(currentStep === index + 1 ? (progressbar_module_default()).currentStep : (progressbar_module_default()).Stepallbtn),
                            children: stepName
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var Progressbar = (ProgressBar);

;// CONCATENATED MODULE: ./components/layout/checkout/ProgressBarData.jsx









function ProgressBarData(props) {
    console.log(props.globalData);
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(1), currentStep = ref1[0], setCurrentStep = ref1[1];
    var totalSteps = 4;
    var handleNext = function(skilldata) {
        if (currentStep < totalSteps) {
            setCurrentStep(currentStep + 1);
        }
        if (currentStep == 1) {
            localStorage.setItem("skilldata", JSON.stringify(skilldata));
        }
    };
    var handlePrevious = function() {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "loaderContainer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loader",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_Loader/* default */.Z, {})
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Progressbar, {
                    currentStep: currentStep,
                    totalSteps: totalSteps,
                    onNext: handleNext,
                    onPrevious: handlePrevious
                }),
                currentStep === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_ETskills, {
                    onNext: handleNext
                }),
                currentStep === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_ETProfile, {
                    onNext: handleNext,
                    onPrevious: handlePrevious,
                    leadPlatform: props.globalData.lead_platform_main_component[0],
                    cluster: props.globalData.cluster_main_component[0]
                }),
                currentStep === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_CCDetails, {
                    onNext: handleNext,
                    onPrevious: handlePrevious
                }),
                currentStep === 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_ETComments, {
                    onNext: handleNext,
                    onPrevious: handlePrevious
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (progressbar_module_default()).buttoncontainer,
                    children: [
                        currentStep > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (progressbar_module_default()).previousbutton,
                            onClick: handlePrevious
                        }),
                        currentStep < totalSteps && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (progressbar_module_default()).nextbutton,
                            onClick: handleNext
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var checkout_ProgressBarData = (ProgressBarData);

;// CONCATENATED MODULE: ./pages/[path].js





















































function Dynamic(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    //console.log("props===", props);
    var router = (0,next_router.useRouter)();
    //console.log("props", props);
    // console.log("a", props.createBotData.data);
    var ref9 = (0,react.useState)("admin"), userRole = ref9[0], setUserRole = ref9[1];
    var ref10 = (0,react.useState)(true), doNotRenderYet = ref10[0], SetDoNotRenderYet = ref10[1];
    var ref11 = (0,react.useState)(false), successModal = ref11[0], setSuccessModal = ref11[1];
    var ref12 = (0,react.useState)(false), fallBackPage = ref12[0], setFallBackPage = ref12[1];
    var scrollToTopRef = react.useRef(null);
    var ref13 = (0,react.useState)(false), Loading = ref13[0], setLoading = ref13[1];
    var Etroles = [
        "sanjay.bohra@unilever.com",
        "Shravyashree.JC@unilever.com",
        "Sachin.Jalota@unilever.com",
        "Arnik.Khillar@unilever.com",
        "dinesh.s3@unilever.com",
        "Prashant.Singh2@unilever.com",
        "Ritish.Verma@unilever.com",
        "swedha.balasubramanian@unilever.com",
        "Rahul.yadav2@unilever.com",
        "aswinkanth.haridas@unilever.com",
        "Abhishek.U@unilever.com",
        "Anshu.rani@unilever.com",
        "mani.jha@unilever.com",
        "madhurima.jaggi@unilever.com",
        "binay.kumar@unilever.com",
        "Vinoth.Bhaskar@unilever.com",
        "Vivek.Sharma@unilever.com",
        "Anubha.Aggarwal@unilever.com",
        "Komal.Falodiya@unilever.com",
        "Gopikrishna.M@unilever.com",
        "Soumya.Mohanty@unilever.com",
        "Ashish.Dhagat@unilever.com",
        "Mayuri.Bhavnani@unilever.com",
        "Vidish.Verma@unilever.com",
        "Ayush.Rautela@unilever.com",
        "Subhadip.Das@unilever.com",
        "Arti.Hajnale@unilever.com"
    ];
    (0,react.useEffect)(function() {
        try {
            if (props.path != "login") {
                if (localStorage.getItem("auth") != undefined) {
                    var token = JSON.parse(localStorage.getItem("auth"));
                    //  console.log(token, "auth path js");
                    // console.log("token userType  ", token.data.userType);
                    setUserRole(token.data.userType);
                    SetDoNotRenderYet(false);
                }
            } else {
                SetDoNotRenderYet(false);
            }
        } catch (err) {
        //console.log(err);
        }
    }, []);
    var _data = props.data, code = _data.code, data = _data.data;
    var pageRoutes = props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.site_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.menu_component) === null || ref3 === void 0 ? void 0 : ref3.menu_list;
    var footerProps = props === null || props === void 0 ? void 0 : (ref4 = props.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.site_info) === null || ref6 === void 0 ? void 0 : ref6.footer_component[0];
    var headerProps = (ref7 = props.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : ref8.site_info;
    //console.log(props, "props at path");
    var title = data.title;
    //console.log("line sakib==>>",title)
    var ComponentToRender;
    switch(title){
        case "Framework":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Frameworks, {
                data: props.data.data.field_basic_component,
                userRole: userRole
            });
            break;
        case "Employeetwin":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwin, {
                data: props.data.data.field_landing_page_component,
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes,
                softskill: props.cartData,
                Etroles: Etroles
            });
            break;
        case "Employeetwinskills":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwinskills, {
                data: props.data.data.field_component,
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes,
                softskill: props.cartData,
                softskill1: props.softSkillData,
                Etroles: Etroles
            });
            break;
        case "Employeetwinsdetails":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Employeetwinsdetails, {
                data: props.data.data.field_component,
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes,
                softskill: props.cartData,
                softskill1: props.softSkillData,
                Etroles: Etroles
            });
            break;
        case "ManageEmployeetwin":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageEmployeetwin, {
                data: props.data.data.field_component,
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes,
                softskill: props.cartData,
                softskill1: props.softSkillData,
                Etroles: Etroles
            });
            break;
        case "Return On Investment":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(roi, {
                data: props.data.data.field_component,
                globalData: props.data.data.site_info,
                technology: props.requestDemoData.data,
                pageRoutes: pageRoutes,
                Etroles: Etroles
            });
            break;
        case "CreateEmployeeTwin":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateEmployeeTwin, {
                data: props.data.data.field_new_bot_component,
                globalData: props.data.data.site_info,
                softskill: props.softSkillData
            });
            break;
        case "EditEmployeeTwin":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(EditEmployeeTwin, {
                data: props.data.data.field_new_bot_component,
                globalData: props.data.data.site_info,
                softskill: props.softSkillData
            });
            break;
        case "Emptwincart":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(emptwincart_index, {
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes
            });
            break;
        case "Order":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Order, {
                data: props.data.data.field_component,
                userRole: userRole,
                feedback: props.feedbackData,
                pageRoutes: pageRoutes
            });
            break;
        case "softskilldetails":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(SoftSkillsDetails, {
                data: props.data.data,
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes
            });
            break;
        case "Orderlisting":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(emptwinorderlisting_index, {
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes
            });
            break;
        case "Purchaseemployeetwin":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseET, {
                data: props.data.data.field_component,
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes,
                softskill: props.cartData,
                softskill1: props.softSkillData,
                Etroles: Etroles
            });
            break;
        case "Product":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Product, {
                data: props.data.data.field_component,
                userRole: userRole
            });
            break;
        case "Offerings":
            if (props.data.data.field_offering_variant == "0") {
                ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(offerings, {
                    data: props.data.data.field_content_component
                });
            } else {
                ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(offerings, {
                    data: props.data.data.field_content_component
                });
            }
            break;
        case "Catalogue Products":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(iaProductDevelopment_Deployment, {
                data: props.data.data.field_offering_content_component,
                title: props.data.data.title
            });
            break;
        case "Touchless Processes":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(iaProductDevelopment_Deployment, {
                data: props.data.data.field_offering_content_component,
                title: props.data.data.title
            });
            break;
        case "Profile Automation":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(iaProductDevelopment_Deployment, {
                data: props.data.data.field_offering_content_component,
                title: props.data.data.title
            });
            break;
        case "Organic Demand":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(iaProductDevelopment_Deployment, {
                data: props.data.data.field_offering_content_component,
                title: props.data.data.title
            });
            break;
        case "Intelligent Applications":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(iaProductDevelopment_Deployment, {
                data: props.data.data.field_offering_content_component,
                title: props.data.data.title
            });
            break;
        case "Demand":
            if (userRole == "admin" || userRole == "internalUser" || userRole == "supportStatus") {
                ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(demandPage, {
                    data: props.data.data.field_basic_content_component,
                    userRole: userRole
                });
            } else {
                ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: "800px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: "Unauthorised User"
                    })
                });
            }
            break;
        case "Bot Store":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(botStorePage, {
                data: props.data.data.field_component,
                userRole: userRole
            });
            break;
        case "Create Bot New":
            if (userRole == "admin" || userRole == "internalUser" || userRole == "qrManager" || userRole == "supportStatus") {
                ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(createBotFormss, {
                    data: props.data.data.field_new_bot_component,
                    userRole: userRole,
                    globalData: props.data.data.site_info
                });
            } else {
                ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: "800px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: "Unauthorised User"
                    })
                });
            }
            break;
        case "BotEdit":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(EditBotPage/* default */.Z, {
                userRole: userRole
            });
            break;
        case "Bot Details":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(botDetailPage, {
                userRole: userRole,
                globalData: props.data.data.site_info,
                data: props.data.data
            });
            break;
        case "Product Details":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailsPage, {
                checkExpiry: actions/* checkExpiry */.Wr,
                userRole: userRole,
                // globalData={props.data.data.site_info}
                data: props.data.data
            });
            break;
        case "Product Details Cuba":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Productdetailscupa, {
                userRole: userRole,
                // globalData={props.data.data.site_info}
                data: props.data.data
            });
            break;
        case "Product Details SAP":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Productdetailssap, {
                userRole: userRole,
                // globalData={props.data.data.site_info}
                data: props.data.data
            });
            break;
        case "Product Details Chat Bot":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Productdetailschatbot, {
                userRole: userRole,
                // globalData={props.data.data.site_info}
                data: props.data.data
            });
            break;
        case "Product Details Safety Suite":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Productsdetailssuit, {
                userRole: userRole,
                // globalData={props.data.data.site_info}
                data: props.data.data
            });
            break;
        case "Product Details Share":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Productdetailsshareonshelf, {
                userRole: userRole,
                // globalData={props.data.data.site_info}
                data: props.data.data
            });
            break;
        case "Product Details Neo":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Productdetailsneo, {
                userRole: userRole,
                // globalData={props.data.data.site_info}
                data: props.data.data
            });
            break;
        case "Contact Us":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(contactUsPage_index, {
                data: props.data.data.field_contact_component,
                userRole: userRole
            });
            break;
        case "Cognitive Experience Zone":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(cezs_index, {
                userRole: userRole,
                data: props.data.data.field_cez_content_component
            });
            break;
        case "Profile Page":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePage, {
                data: props.data.data.field_component,
                userRole: userRole,
                globalData: props.data.data.site_info
            });
            break;
        case "Logout Page":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Logout, {
                userRole: userRole,
                data: props.data.data.field_component,
                pageRoutes: pageRoutes
            });
            break;
        case "User Access Mapping":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(userAccessMapping, {
                userRole: userRole,
                data: props.data.data,
                globalData: props.data.data.site_info
            });
            break;
        case "Approvals":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(approvals, {
                userRole: userRole,
                data: props.data.data.field_basic_content_component,
                globalData: props.data.data.site_info
            });
            break;
        case "Global Search":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(globalSearch, {});
            break;
        case "Approval Form":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(approvalForm, {
                data: props.data.data.field_component
            });
            break;
        case "New Employeetwin":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(newEmployeetwin, {
                globalData: props.data.data.site_info
            });
            break;
        case "CartCheckout":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_ProgressBarData, {
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes
            });
            break;
        case "ETprofile":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_ETProfile, {
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes
            });
            break;
        case "CCDetails":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_CCDetails, {
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes
            });
            break;
        case "ETComments":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_ETComments, {
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes
            });
            break;
        case "ETthankyou":
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(Thankyoupage, {
                globalData: props.data.data.site_info,
                pageRoutes: pageRoutes
            });
            break;
        default:
            // setFallBackPage(true);
            ComponentToRender = /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "hii"
            });
            break;
    }
    return !doNotRenderYet ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            title == "Login Page" || title == "Logout Page" ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "headTop",
                        ref: scrollToTopRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                        title: title,
                        pageRoutes: pageRoutes,
                        userRole: userRole,
                        requestDemoData: props.requestDemoData,
                        headerProps: headerProps
                    })
                ]
            }),
            props.routeChangeState ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    height: "800px"
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader["default"], {}),
                    " "
                ]
            }) : ComponentToRender,
            props.session ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_successModal["default"], {
                message: "Session Expired",
                title: "Login Session Status",
                session: props.session,
                sessionTimeOutCheck: props.sessionTimeOutCheck,
                setSuccessModal: setSuccessModal,
                fail: true
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {
                footerProps: footerProps,
                title: title
            })
        ]
    }) : fallBackPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        children: "There's some problem. Please go to home"
    }) : null;
}
var _path_mapStateToProps = function(state) {
    //console.log("state",state)
    return {
        session: state.session.session
    };
};
function _path_mapDispatchToProps(dispatch) {
    return {
        sessionTimeOutCheck: (0,redux/* bindActionCreators */.DE)(actions/* sessionTimeOutCheck */.Iy, dispatch)
    };
}
var __N_SSP = true;
/* harmony default export */ var _path_ = ((0,es/* connect */.$j)(_path_mapStateToProps, _path_mapDispatchToProps)(Dynamic));


/***/ }),

/***/ 86889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"Loader_liveStatus__6tz3I","rejectedStatus":"Loader_rejectedStatus__LW79z","retiredStatus":"Loader_retiredStatus__f__Yr","onHoldStatus":"Loader_onHoldStatus__3UCMB","in-ProgressStatus":"Loader_in-ProgressStatus__koBwl","inProgressStatus":"Loader_inProgressStatus__AQ4bT","uATStatus":"Loader_uATStatus__oSeYO","initialDemandStatus":"Loader_initialDemandStatus__XPTZ0","designFeasibilityStatus":"Loader_designFeasibilityStatus__6TbBG","feasibilityStatus":"Loader_feasibilityStatus__YMT7p","designStatus":"Loader_designStatus__tX_QZ","ideasStatus":"Loader_ideasStatus__Uwaz4","buildStatus":"Loader_buildStatus__fC8Tv","container":"Loader_container__cy6a_","loader":"Loader_loader__Qiyey","loader3":"Loader_loader3__IpAyx","load3":"Loader_load3__Ve_W2","load":"Loader_load__XGt1g"};

/***/ }),

/***/ 93215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"roiModal_liveStatus__pzEuN","rejectedStatus":"roiModal_rejectedStatus__BkfKp","retiredStatus":"roiModal_retiredStatus__hS_Cu","onHoldStatus":"roiModal_onHoldStatus__YXcnK","in-ProgressStatus":"roiModal_in-ProgressStatus__zM4dV","inProgressStatus":"roiModal_inProgressStatus__4nxkI","uATStatus":"roiModal_uATStatus__c5RJv","initialDemandStatus":"roiModal_initialDemandStatus__iE__8","designFeasibilityStatus":"roiModal_designFeasibilityStatus__w7PxM","feasibilityStatus":"roiModal_feasibilityStatus__xVKav","designStatus":"roiModal_designStatus__Hh6eI","ideasStatus":"roiModal_ideasStatus__7SUZz","buildStatus":"roiModal_buildStatus__IT_P_","successContainer":"roiModal_successContainer__evP3x","modalBox":"roiModal_modalBox__LWCpc","modalHeader":"roiModal_modalHeader__YR_eN","content":"roiModal_content__EnwMU","modalBody":"roiModal_modalBody__5WfIA","status":"roiModal_status__LfJxZ","textBody":"roiModal_textBody__udemd","texthead":"roiModal_texthead__knhrv","textcontent":"roiModal_textcontent__qkIhm","usersWrapper":"roiModal_usersWrapper__zfsId","usersList":"roiModal_usersList__hMC_J","userList":"roiModal_userList__r4Ykr","modalFooter":"roiModal_modalFooter__LQMjC","areYouSureBtn":"roiModal_areYouSureBtn__uX1ed","exportListBtn":"roiModal_exportListBtn__MrxOL","uploadIcon":"roiModal_uploadIcon__RuhJ2","combinedBtn":"roiModal_combinedBtn__dO4BE","rowBtn":"roiModal_rowBtn__tFSmF","plusIcon":"roiModal_plusIcon__CpWXw","SubmitAnIdeaBtn":"roiModal_SubmitAnIdeaBtn__Pktgt","submitAnIdeaOk":"roiModal_submitAnIdeaOk__FsmHq"};

/***/ }),

/***/ 41579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"adduser_liveStatus__nm64C","rejectedStatus":"adduser_rejectedStatus__fQpuP","retiredStatus":"adduser_retiredStatus__WXLRM","onHoldStatus":"adduser_onHoldStatus__oj5qr","in-ProgressStatus":"adduser_in-ProgressStatus__diT7e","inProgressStatus":"adduser_inProgressStatus__FupG_","uATStatus":"adduser_uATStatus__jap2G","initialDemandStatus":"adduser_initialDemandStatus__LZWF9","designFeasibilityStatus":"adduser_designFeasibilityStatus__lwGTl","feasibilityStatus":"adduser_feasibilityStatus__MTRjt","designStatus":"adduser_designStatus__oRbXp","ideasStatus":"adduser_ideasStatus__1beKc","buildStatus":"adduser_buildStatus__RAkaJ","editModalWrapper":"adduser_editModalWrapper___Cyhd","modalBox":"adduser_modalBox__nWLFV","modalHeader":"adduser_modalHeader__Aj9IL","content":"adduser_content___PKVH","modalBody":"adduser_modalBody__ORHwp","textBody":"adduser_textBody__gGKcl","texthead":"adduser_texthead__qFwXm","textbody":"adduser_textbody__7uKAo","detailsSec":"adduser_detailsSec__x2Btk","row":"adduser_row__N6_1B","formGroup":"adduser_formGroup__QChhC","labelstyle":"adduser_labelstyle__1juxw","input":"adduser_input__b2eYa","right":"adduser_right__vmFN2","more":"adduser_more__WYzI7","fullWidth":"adduser_fullWidth__X6z3c","errorBorder":"adduser_errorBorder__EstUs","mainLabel":"adduser_mainLabel__7LhuW","mandatoryField":"adduser_mandatoryField__KqReW","inputGroupWrapper":"adduser_inputGroupWrapper__cR3ir","radioWrapper":"adduser_radioWrapper__ruAX0","subLabel":"adduser_subLabel__ntELl","radioCheckmark":"adduser_radioCheckmark__bLr5R","errorMessage":"adduser_errorMessage__indBN","userTypeerrorMessage":"adduser_userTypeerrorMessage__roB1_","btn":"adduser_btn__LvE3x","modalFooter":"adduser_modalFooter__OFK1u","combinedBtn":"adduser_combinedBtn__isfK1","rowBtn":"adduser_rowBtn__NXA4h","plusIcon":"adduser_plusIcon__rF1JE","exportListBtn":"adduser_exportListBtn__eYwDm","uploadIcon":"adduser_uploadIcon__KA5w6"};

/***/ }),

/***/ 93432:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cc_details_bg":"ccdetails_cc_details_bg__lGnwa","cc_details_bg_inner":"ccdetails_cc_details_bg_inner__A3vT1","cc_details_container":"ccdetails_cc_details_container___neNu","cc_label_input_content":"ccdetails_cc_label_input_content__UbwHp","cc_details_input":"ccdetails_cc_details_input__GoABV","CC_main_heading":"ccdetails_CC_main_heading__ErBV0","cc_details_label":"ccdetails_cc_details_label__ZdO66","cc_details_btn_content":"ccdetails_cc_details_btn_content__7DvoR","cc_details_btn":"ccdetails_cc_details_btn__CxT8O","ccdetails_cc_details_btn":"ccdetails_ccdetails_cc_details_btn__UokOF","cc_arrow_btn":"ccdetails_cc_arrow_btn__aJxHA"};

/***/ }),

/***/ 791:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"etcommtcontainer":"etcomments_etcommtcontainer__4K2cN","etcommentcontent":"etcomments_etcommentcontent__xyOu8","etcommentheading":"etcomments_etcommentheading__yEnm_","et_commt_area":"etcomments_et_commt_area__9KxgU","et_commt_btn_content":"etcomments_et_commt_btn_content__Z01hs","et_commt_btn":"etcomments_et_commt_btn__IB2EA","et_arrow_btn":"etcomments_et_arrow_btn__jwcZx","etcommtbtncontent":"etcomments_etcommtbtncontent__CO9gN","selectedButton":"etcomments_selectedButton__trrv4","etcmtbtn":"etcomments_etcmtbtn__fw3U7","et_commt_area_div":"etcomments_et_commt_area_div__k74k5"};

/***/ }),

/***/ 58001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"et_main_content":"etprofile_et_main_content__RrLsI","et_container":"etprofile_et_container__1erAi","etname_content":"etprofile_etname_content__tEv8g","etupload_content":"etprofile_etupload_content__tC8GV","et_content":"etprofile_et_content__scV0_","et_input":"etprofile_et_input__Sa1Js","et_top_heading":"etprofile_et_top_heading__RRREB","et_label":"etprofile_et_label__C7iTI","et_des_input":"etprofile_et_des_input__5QpRX","et_des_label":"etprofile_et_des_label__VaKdI","et_span":"etprofile_et_span__3DW7p","et_descrip_content":"etprofile_et_descrip_content__I2wRM","et_proceed_btn_content":"etprofile_et_proceed_btn_content__o1rtK","et_proceed_btn":"etprofile_et_proceed_btn__Y0Lfg","et_arrow_btn":"etprofile_et_arrow_btn__kwnLb","et_logo_container":"etprofile_et_logo_container__L3oIp","Uploadlogo":"etprofile_Uploadlogo__5UqPa","logo_input":"etprofile_logo_input__UZ0Hg","et_span_logo":"etprofile_et_span_logo__wWWxn"};

/***/ }),

/***/ 89214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"etskills_maincontainer__5EYEU","skillsheading":"etskills_skillsheading__ydt0H","evenRow":"etskills_evenRow__uDh1Y","oddRow":"etskills_oddRow__knbKy","skillstd":"etskills_skillstd__LhbCi","skillsdltbtndiv":"etskills_skillsdltbtndiv__Sq2BO","skillsheaddiv":"etskills_skillsheaddiv__pyvKs","skillthead":"etskills_skillthead__XO8M1","skillidname":"etskills_skillidname__c_kX4","skillbotid":"etskills_skillbotid__U_gqt","skillbotname":"etskills_skillbotname__uFqxY","skillidcontainer":"etskills_skillidcontainer__QAokr","customTable":"etskills_customTable__wSdhl","skillbotprice":"etskills_skillbotprice__dUTc1","totalskillcontainer":"etskills_totalskillcontainer__knq5h","totalskillcontent":"etskills_totalskillcontent__R0KZ6","skillhirebtn":"etskills_skillhirebtn__lGcrB","skillarrowbtn":"etskills_skillarrowbtn__AOyIU","ETskillstotal":"etskills_ETskillstotal__cVspL","ETskillstotalnumber":"etskills_ETskillstotalnumber__8LDO0","skilldiscount":"etskills_skilldiscount__iAX_C","skillinner":"etskills_skillinner__JOZrN","softskill":"etskills_softskill__ZeX7b","showskill":"etskills_showskill__xgfmy","softbg":"etskills_softbg__Q1qEq","softfree":"etskills_softfree__u4rK3","skillsfreecost":"etskills_skillsfreecost__90ccN","skillsfreecostspan":"etskills_skillsfreecostspan__cwEDZ"};

/***/ }),

/***/ 96820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProgressBarmain":"progressbar_ProgressBarmain__yFgvm","buttoncontainer":"progressbar_buttoncontainer__jJ4NB","nextbutton":"progressbar_nextbutton__ph7Mk","previousbutton":"progressbar_previousbutton__WT0O7","stepprogressbar":"progressbar_stepprogressbar___W_ug","currentStep":"progressbar_currentStep__zkZuT","stepprogressbarbtn":"progressbar_stepprogressbarbtn__2bzgN","Stepallbtn":"progressbar_Stepallbtn__7QRhn","step-progress-bar":"progressbar_step-progress-bar__dnoXs","stepname":"progressbar_stepname__djGov","completed":"progressbar_completed___KzN6","stepdivider":"progressbar_stepdivider__mRtCS"};

/***/ }),

/***/ 19677:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"etthankBg":"thankyoupage_etthankBg__Y_ZcS","etthankBnr":"thankyoupage_etthankBnr__Gkb_v","etthankparacontainer":"thankyoupage_etthankparacontainer__V54Pg","etthankheading":"thankyoupage_etthankheading__9BuTx","etthankpara":"thankyoupage_etthankpara__nGQjK","etthankparamain":"thankyoupage_etthankparamain__1L5Jv","etthankparaspan":"thankyoupage_etthankparaspan__eMt8J","thankcross":"thankyoupage_thankcross__co66m"};

/***/ }),

/***/ 23289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"banner_liveStatus__ktRtL","rejectedStatus":"banner_rejectedStatus__zej5Z","retiredStatus":"banner_retiredStatus__KejvW","onHoldStatus":"banner_onHoldStatus__hSbbl","in-ProgressStatus":"banner_in-ProgressStatus__21cSh","inProgressStatus":"banner_inProgressStatus__3AGjm","uATStatus":"banner_uATStatus__O9hOD","initialDemandStatus":"banner_initialDemandStatus__9h6LJ","designFeasibilityStatus":"banner_designFeasibilityStatus__fCumc","feasibilityStatus":"banner_feasibilityStatus__zJ9gn","designStatus":"banner_designStatus__Z1atG","ideasStatus":"banner_ideasStatus__7Sfan","buildStatus":"banner_buildStatus__ixJ96","bannerWrapper":"banner_bannerWrapper__N6odH","row":"banner_row__2vcb1","imaging":"banner_imaging__FvDLA","image":"banner_image__AnjCc","imageMobile":"banner_imageMobile__SPMnh","container":"banner_container__QnD22","bannerHead":"banner_bannerHead__AoytG","bannerText":"banner_bannerText__joFPm"};

/***/ }),

/***/ 58059:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"basicForm_liveStatus__AUwjP","rejectedStatus":"basicForm_rejectedStatus__cpmz_","retiredStatus":"basicForm_retiredStatus__i4sWQ","onHoldStatus":"basicForm_onHoldStatus__sFmso","in-ProgressStatus":"basicForm_in-ProgressStatus__3e9fZ","inProgressStatus":"basicForm_inProgressStatus__FtKuo","uATStatus":"basicForm_uATStatus__gIz0C","initialDemandStatus":"basicForm_initialDemandStatus__udUZO","designFeasibilityStatus":"basicForm_designFeasibilityStatus__ZEvbg","feasibilityStatus":"basicForm_feasibilityStatus__jGrWX","designStatus":"basicForm_designStatus__nm5Mk","ideasStatus":"basicForm_ideasStatus__GpFIg","buildStatus":"basicForm_buildStatus__a_6m7","colFirst":"basicForm_colFirst__EMqnJ","colSecond":"basicForm_colSecond__VBYQz","row":"basicForm_row__inyWW","inputGroup":"basicForm_inputGroup__aZuOi","errorMessage":"basicForm_errorMessage__mjCu2","multipleItems":"basicForm_multipleItems__I_GuB","input":"basicForm_input__QRxDp","right":"basicForm_right__Uvn7J","more":"basicForm_more__9MvrJ","errorBorder":"basicForm_errorBorder__WyuxL","fullWidth":"basicForm_fullWidth__xWA_P","approvalgroup":"basicForm_approvalgroup__IEW8P","approvalDrop":"basicForm_approvalDrop__tYPLT","userGroup":"basicForm_userGroup__7vIjN","formGroup":"basicForm_formGroup__Mawy7","mainLabel":"basicForm_mainLabel__txeyR","mandatoryField":"basicForm_mandatoryField__qtnGr","inputGroupWrapper":"basicForm_inputGroupWrapper__GjgMO","radioWrapper":"basicForm_radioWrapper__ripiM","subLabel":"basicForm_subLabel__alVAm","radioCheckmark":"basicForm_radioCheckmark__qd7oJ","dropdown":"basicForm_dropdown__XsJPT","coluser":"basicForm_coluser__LnRty","buttonBody":"basicForm_buttonBody__ExKQo","previousBtn":"basicForm_previousBtn__IHotl","prevBtn":"basicForm_prevBtn___cUAL","backarrow":"basicForm_backarrow__zmWzU","combinedBtn":"basicForm_combinedBtn__DLXjX","rowBtn":"basicForm_rowBtn__W0okZ","plusIcon":"basicForm_plusIcon__kxQbn","exportListBtn":"basicForm_exportListBtn__JJaK3","uploadIcon":"basicForm_uploadIcon__mTOLG","calender":"basicForm_calender__qHvsQ"};

/***/ }),

/***/ 63487:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"basicemptwinForm_liveStatus__JCWEG","rejectedStatus":"basicemptwinForm_rejectedStatus__XbyFV","retiredStatus":"basicemptwinForm_retiredStatus__9Av7b","onHoldStatus":"basicemptwinForm_onHoldStatus__COoJg","in-ProgressStatus":"basicemptwinForm_in-ProgressStatus__rwnrs","inProgressStatus":"basicemptwinForm_inProgressStatus__t7QUw","uATStatus":"basicemptwinForm_uATStatus__58DJq","initialDemandStatus":"basicemptwinForm_initialDemandStatus__hyBv0","designFeasibilityStatus":"basicemptwinForm_designFeasibilityStatus__d5X75","feasibilityStatus":"basicemptwinForm_feasibilityStatus__pmZgV","designStatus":"basicemptwinForm_designStatus__epyUr","ideasStatus":"basicemptwinForm_ideasStatus__Zi33f","buildStatus":"basicemptwinForm_buildStatus__ZVWk1","inputGroup":"basicemptwinForm_inputGroup__UkGnL","errorMessage":"basicemptwinForm_errorMessage__QHu0S","multipleItems":"basicemptwinForm_multipleItems__6_wUZ","input":"basicemptwinForm_input__KZgNR","right":"basicemptwinForm_right__e2xL6","more":"basicemptwinForm_more__B1prs","errorBorder":"basicemptwinForm_errorBorder__oSL1Z","fullWidth":"basicemptwinForm_fullWidth__UTto7","approvalgroup":"basicemptwinForm_approvalgroup__58oFj","approvalDrop":"basicemptwinForm_approvalDrop__wP1fh","userGroup":"basicemptwinForm_userGroup__mVXlq","formGroup":"basicemptwinForm_formGroup__ww3WJ","mainLabel":"basicemptwinForm_mainLabel__R6r9i","mandatoryField":"basicemptwinForm_mandatoryField__TosZJ","inputGroupWrapper":"basicemptwinForm_inputGroupWrapper__ZbI5E","radioWrapper":"basicemptwinForm_radioWrapper__1JoH_","subLabel":"basicemptwinForm_subLabel__Nv8gc","radioCheckmark":"basicemptwinForm_radioCheckmark__4oyaQ","dropdown":"basicemptwinForm_dropdown__01pZ_","coluser":"basicemptwinForm_coluser__1_tr5","row":"basicemptwinForm_row__pS7EF","colSecond":"basicemptwinForm_colSecond__edxIA","buttonBody":"basicemptwinForm_buttonBody__v7GQu","previousBtn":"basicemptwinForm_previousBtn__fL18P","prevBtn":"basicemptwinForm_prevBtn__fOh0_","backarrow":"basicemptwinForm_backarrow__e9Saq","combinedBtn":"basicemptwinForm_combinedBtn__qqE0T","rowBtn":"basicemptwinForm_rowBtn__YLI__","plusIcon":"basicemptwinForm_plusIcon__brpi_","exportListBtn":"basicemptwinForm_exportListBtn__thVMR","uploadIcon":"basicemptwinForm_uploadIcon___Z_nG","colFirst":"basicemptwinForm_colFirst__LD_MU","calender":"basicemptwinForm_calender__wS30G"};

/***/ }),

/***/ 99849:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"cart_liveStatus__d9zWI","rejectedStatus":"cart_rejectedStatus__3qOtI","retiredStatus":"cart_retiredStatus__GO06s","onHoldStatus":"cart_onHoldStatus__FNvM4","in-ProgressStatus":"cart_in-ProgressStatus___QM2E","inProgressStatus":"cart_inProgressStatus__m4OIU","uATStatus":"cart_uATStatus__PdJsb","initialDemandStatus":"cart_initialDemandStatus__Ami17","designFeasibilityStatus":"cart_designFeasibilityStatus__9n2qF","feasibilityStatus":"cart_feasibilityStatus__Zn1hH","designStatus":"cart_designStatus__u707a","ideasStatus":"cart_ideasStatus__ncHnu","buildStatus":"cart_buildStatus__fBnzD","editModalWrapper":"cart_editModalWrapper__eeZgo","formContainer":"cart_formContainer__Rf5DT","icon":"cart_icon__xh8c8","iconimg":"cart_iconimg__BsPac","modalBox":"cart_modalBox__8_w9l","modalHeader":"cart_modalHeader__Isg_G","content":"cart_content__yae9e","modalBody":"cart_modalBody__z_K0H","formheading":"cart_formheading__6rdwn","carticonimg":"cart_carticonimg__5NJkZ","head":"cart_head____gxu","textBody":"cart_textBody___rarq","texthead":"cart_texthead__oksMY","textbody":"cart_textbody__Xx9M2","row":"cart_row__eoi9G","formGroup":"cart_formGroup__w0cnz","radioWrapper":"cart_radioWrapper__kiN_7","radioCheckmark":"cart_radioCheckmark__JBzID","mainLabel":"cart_mainLabel__RJcnV","errorMessage":"cart_errorMessage__9PNN8","subLabel":"cart_subLabel__sBni8","select":"cart_select__qAG67","inputtext":"cart_inputtext__CFNb4","mandatoryField":"cart_mandatoryField__ERy5Y","radioBox":"cart_radioBox__tLWmx","labelstyle":"cart_labelstyle__0_DPd","input":"cart_input__7n80f","right":"cart_right__fTZzX","more":"cart_more__HFgPi","fullWidth":"cart_fullWidth__VdP3o","errorBorder":"cart_errorBorder__5561S","modalFooter":"cart_modalFooter__H6hZb","combinedBtn":"cart_combinedBtn__ALl1g","rowBtn":"cart_rowBtn__RnfDM","plusIcon":"cart_plusIcon__F0lAN","exportListBtn":"cart_exportListBtn__BEkqe","uploadIcon":"cart_uploadIcon__988gz"};

/***/ }),

/***/ 25615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"demandData_liveStatus__7FiKp","rejectedStatus":"demandData_rejectedStatus__xcffI","retiredStatus":"demandData_retiredStatus__cYuuE","onHoldStatus":"demandData_onHoldStatus__SuhF3","in-ProgressStatus":"demandData_in-ProgressStatus__EkZJZ","inProgressStatus":"demandData_inProgressStatus__Mxeb6","uATStatus":"demandData_uATStatus__YHbm4","initialDemandStatus":"demandData_initialDemandStatus__4quGU","designFeasibilityStatus":"demandData_designFeasibilityStatus__wkA0d","feasibilityStatus":"demandData_feasibilityStatus__lNerk","designStatus":"demandData_designStatus__6Mc0N","ideasStatus":"demandData_ideasStatus__VdTU5","buildStatus":"demandData_buildStatus__dG_6Q","demandDataWrapper":"demandData_demandDataWrapper__ABVpS","demandActionHead":"demandData_demandActionHead__SbmSR","top":"demandData_top__sUf5U","left":"demandData_left__7_fe8","search":"demandData_search__JlFvb","searchIcon":"demandData_searchIcon__dlUUJ","right":"demandData_right__vxs3_","combinedBtn":"demandData_combinedBtn__gYXKH","rowBtn":"demandData_rowBtn__jkBp_","plusIcon":"demandData_plusIcon__qhpHi","rowBtn2":"demandData_rowBtn2__CgdEq","exportListBtn":"demandData_exportListBtn__ikiSd","uploadIcon":"demandData_uploadIcon__cyD6S","bottom":"demandData_bottom__gBCkG","inputGroup":"demandData_inputGroup__zOeeS","input":"demandData_input__DTvGS","more":"demandData_more__NVPMs","first-of-type":"demandData_first-of-type__c_Nsm","dropi":"demandData_dropi__Yjat6","demandDataBody":"demandData_demandDataBody__uilK_","scrollableTable":"demandData_scrollableTable__3dKSN","noresults":"demandData_noresults__TxWxJ","head":"demandData_head__4DZWy","content":"demandData_content__AenBK","displayNone":"demandData_displayNone__4jDJO","dividedHead":"demandData_dividedHead__rqjXu","subHead":"demandData_subHead__wOT4f","subDivision":"demandData_subDivision__HuHD8","loadContainer":"demandData_loadContainer__NXdJG","mobileTable":"demandData_mobileTable__VH8lL","desktopTable":"demandData_desktopTable__kL5_W","container":"demandData_container__57SvP","loader":"demandData_loader__NfXn_","loader3":"demandData_loader3__vhFw9","load3":"demandData_load3__Mu2hd","dividedBody":"demandData_dividedBody__RVUus","editInactive":"demandData_editInactive__ymfdn","fixedTable":"demandData_fixedTable__gKlDn","actionMobile":"demandData_actionMobile__unJPu","actionDesktop":"demandData_actionDesktop__rtiFg","mobileFilterBtn":"demandData_mobileFilterBtn__Prd1Q","pagination":"demandData_pagination__Frs_Y","btn":"demandData_btn__MX5T3","filterCount":"demandData_filterCount__mkXOb","filterIcon":"demandData_filterIcon__3eYLC","load":"demandData_load__K00tX"};

/***/ }),

/***/ 87619:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"demandEdit_liveStatus__cYbAy","rejectedStatus":"demandEdit_rejectedStatus__Q3xU6","retiredStatus":"demandEdit_retiredStatus__TeFI2","onHoldStatus":"demandEdit_onHoldStatus__bdx0z","in-ProgressStatus":"demandEdit_in-ProgressStatus__awfwp","inProgressStatus":"demandEdit_inProgressStatus__S7lH7","uATStatus":"demandEdit_uATStatus__8_biF","initialDemandStatus":"demandEdit_initialDemandStatus__RmU9T","designFeasibilityStatus":"demandEdit_designFeasibilityStatus__iKdNY","feasibilityStatus":"demandEdit_feasibilityStatus__SnHzU","designStatus":"demandEdit_designStatus__bGwKU","ideasStatus":"demandEdit_ideasStatus__jn5E1","buildStatus":"demandEdit_buildStatus__9Yphm","editModalWrapper":"demandEdit_editModalWrapper__AVOdm","modalBox":"demandEdit_modalBox__hPzu6","modalHeader":"demandEdit_modalHeader__iYtCd","content":"demandEdit_content__9heHZ","modalBody":"demandEdit_modalBody__ZFIHn","row":"demandEdit_row__zPpJb","inputGroup":"demandEdit_inputGroup__dxEbP","input":"demandEdit_input__2ji9p","right":"demandEdit_right__4B2GF","more":"demandEdit_more__84EXD","fullWidth":"demandEdit_fullWidth__mddn3","formGroup":"demandEdit_formGroup__DAbX7","mainLabel":"demandEdit_mainLabel__Eohd4","mandatoryField":"demandEdit_mandatoryField__dSd3u","inputGroupWrapper":"demandEdit_inputGroupWrapper__GppQM","radioWrapper":"demandEdit_radioWrapper__vBRVB","subLabel":"demandEdit_subLabel__q8h0s","radioCheckmark":"demandEdit_radioCheckmark__472_e","actionBtn":"demandEdit_actionBtn__qWdck","sendIcon":"demandEdit_sendIcon__CAL7t","ModalFooter":"demandEdit_ModalFooter__ucUcj","combinedBtn":"demandEdit_combinedBtn__EzQJB","rowBtn":"demandEdit_rowBtn__IwkY2","plusIcon":"demandEdit_plusIcon__CnN8Y","exportListBtn":"demandEdit_exportListBtn___ngb0","uploadIcon":"demandEdit_uploadIcon__uwfws"};

/***/ }),

/***/ 34910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"demandFilters_liveStatus__5_2H4","rejectedStatus":"demandFilters_rejectedStatus__QvQXP","retiredStatus":"demandFilters_retiredStatus___pIFC","onHoldStatus":"demandFilters_onHoldStatus__NruXR","in-ProgressStatus":"demandFilters_in-ProgressStatus__oxbnz","inProgressStatus":"demandFilters_inProgressStatus__GBZyJ","uATStatus":"demandFilters_uATStatus__rx3xS","initialDemandStatus":"demandFilters_initialDemandStatus__fgrox","designFeasibilityStatus":"demandFilters_designFeasibilityStatus__UgML_","feasibilityStatus":"demandFilters_feasibilityStatus__Ob9Vr","designStatus":"demandFilters_designStatus__3zDKv","ideasStatus":"demandFilters_ideasStatus__M0Amo","buildStatus":"demandFilters_buildStatus__QKDSg","mobileFiltersWrapper":"demandFilters_mobileFiltersWrapper__wZu48","head":"demandFilters_head__8Wz1u","title":"demandFilters_title__HB2mm","clearFilters":"demandFilters_clearFilters__iYmse","body":"demandFilters_body__uzukG","left":"demandFilters_left__XhZOw","active":"demandFilters_active__azhLV","right":"demandFilters_right__5z9y_","list_Checkbox_container":"demandFilters_list_Checkbox_container__g7xIW","lableHead":"demandFilters_lableHead__lbcQ2","list_checkmark":"demandFilters_list_checkmark__jOB1e","foot":"demandFilters_foot__iMSMq","cancelBtn":"demandFilters_cancelBtn__8Fdy3","applyBtn":"demandFilters_applyBtn__QnL_E"};

/***/ }),

/***/ 51301:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"emptwinCart_liveStatus__4F_aQ","rejectedStatus":"emptwinCart_rejectedStatus__pbPaA","retiredStatus":"emptwinCart_retiredStatus__yFXml","onHoldStatus":"emptwinCart_onHoldStatus___H0Zm","in-ProgressStatus":"emptwinCart_in-ProgressStatus__gYyKA","inProgressStatus":"emptwinCart_inProgressStatus__H9JL2","uATStatus":"emptwinCart_uATStatus__erocR","initialDemandStatus":"emptwinCart_initialDemandStatus__xS4tJ","designFeasibilityStatus":"emptwinCart_designFeasibilityStatus__oY7Co","feasibilityStatus":"emptwinCart_feasibilityStatus__UkY_Y","designStatus":"emptwinCart_designStatus__IEnUh","ideasStatus":"emptwinCart_ideasStatus__00c7b","buildStatus":"emptwinCart_buildStatus__8hy_o","emptwinbannerWrapper":"emptwinCart_emptwinbannerWrapper__2v1lI","row":"emptwinCart_row__G1PdS","imaging":"emptwinCart_imaging__mSYkV","image":"emptwinCart_image__mi5or","imageMobile":"emptwinCart_imageMobile__RHKka","image1":"emptwinCart_image1__iZVWx","imageMobile1":"emptwinCart_imageMobile1__J3r8o","container":"emptwinCart_container__VwVJY","emptwinbannerHead":"emptwinCart_emptwinbannerHead__Zh8yt","emptwinbannerHead1":"emptwinCart_emptwinbannerHead1__E5oCO","emptwinbannerText":"emptwinCart_emptwinbannerText__uply3","emptwinbannerText1":"emptwinCart_emptwinbannerText1__JpDoz","contactLanding":"emptwinCart_contactLanding___6cqE","emptwinbannerWrapper1":"emptwinCart_emptwinbannerWrapper1__gqw75","heading":"emptwinCart_heading__glRx5","text":"emptwinCart_text__Zw3zn","submitbtn":"emptwinCart_submitbtn__OWNHR","tableskill":"emptwinCart_tableskill__5rH7B","skilllist":"emptwinCart_skilllist__IjNp4","skillslisttext":"emptwinCart_skillslisttext__EIO5H","firsttd":"emptwinCart_firsttd__Vmwxy","skillheading":"emptwinCart_skillheading__KtQFd","bottext2":"emptwinCart_bottext2__5NLjo","bottext1":"emptwinCart_bottext1__iB840","actionBtn":"emptwinCart_actionBtn__OIOcU","select":"emptwinCart_select__IfSln","uploadControl":"emptwinCart_uploadControl___6Mwh","mainLabel":"emptwinCart_mainLabel__lxTBz","errorMessage":"emptwinCart_errorMessage__BVsPl","mandatoryField":"emptwinCart_mandatoryField__xobBc","fileupload":"emptwinCart_fileupload__DLpFA"};

/***/ }),

/***/ 93454:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"emptwinOrderListing_liveStatus__Knb6q","rejectedStatus":"emptwinOrderListing_rejectedStatus__Qw8ju","retiredStatus":"emptwinOrderListing_retiredStatus___ntR5","onHoldStatus":"emptwinOrderListing_onHoldStatus__Cvs6v","in-ProgressStatus":"emptwinOrderListing_in-ProgressStatus__ETGEC","inProgressStatus":"emptwinOrderListing_inProgressStatus__ImBtV","uATStatus":"emptwinOrderListing_uATStatus__XCRX9","initialDemandStatus":"emptwinOrderListing_initialDemandStatus__JL243","designFeasibilityStatus":"emptwinOrderListing_designFeasibilityStatus__Jd5z0","feasibilityStatus":"emptwinOrderListing_feasibilityStatus__4fwoO","designStatus":"emptwinOrderListing_designStatus__Q6qbG","ideasStatus":"emptwinOrderListing_ideasStatus__C6bAz","buildStatus":"emptwinOrderListing_buildStatus__qNuLG","emptwinorderlisting":"emptwinOrderListing_emptwinorderlisting__gCEEv","row":"emptwinOrderListing_row__vCFJk","heading":"emptwinOrderListing_heading__WdFlN","text":"emptwinOrderListing_text__tt0Ei","submitbtn":"emptwinOrderListing_submitbtn__wHYUx","tableskill":"emptwinOrderListing_tableskill__mViJf","skilllist":"emptwinOrderListing_skilllist__kWHSb","skillslisttext":"emptwinOrderListing_skillslisttext__HmQu2","firsttd":"emptwinOrderListing_firsttd__M52ZL","skillheading":"emptwinOrderListing_skillheading__QDxBE","leftText":"emptwinOrderListing_leftText___5zWy","rightText":"emptwinOrderListing_rightText__SgTXh","bottext2":"emptwinOrderListing_bottext2__hnP0t","bottext1":"emptwinOrderListing_bottext1__9Wvpe","imaging":"emptwinOrderListing_imaging__aIc4L","image":"emptwinOrderListing_image__vOcUl","imageMobile":"emptwinOrderListing_imageMobile__Kq_PD","image1":"emptwinOrderListing_image1__kOHfZ","imageMobile1":"emptwinOrderListing_imageMobile1__LrJfV","container":"emptwinOrderListing_container__7B1MQ","emptwinbannerHead":"emptwinOrderListing_emptwinbannerHead__iX3ix","emptwinbannerHead1":"emptwinOrderListing_emptwinbannerHead1__FitmX","emptwinbannerText":"emptwinOrderListing_emptwinbannerText__tiIWb","emptwinbannerText1":"emptwinOrderListing_emptwinbannerText1__RX824","contactLanding":"emptwinOrderListing_contactLanding__Z3qol","containerHeight":"emptwinOrderListing_containerHeight__4SZXX","containerWidth":"emptwinOrderListing_containerWidth__58to6","loader":"emptwinOrderListing_loader__EFSEK","loader3":"emptwinOrderListing_loader3__RHJW3","load3":"emptwinOrderListing_load3__Ds9zz","load":"emptwinOrderListing_load__5ChJt"};

/***/ }),

/***/ 59727:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"exportBotBand_liveStatus__X4AxL","rejectedStatus":"exportBotBand_rejectedStatus__COpLV","retiredStatus":"exportBotBand_retiredStatus__DbG5v","onHoldStatus":"exportBotBand_onHoldStatus__9W_HG","in-ProgressStatus":"exportBotBand_in-ProgressStatus__rUNU1","inProgressStatus":"exportBotBand_inProgressStatus__Xq6Mk","uATStatus":"exportBotBand_uATStatus__jnMwi","initialDemandStatus":"exportBotBand_initialDemandStatus__cDmAL","designFeasibilityStatus":"exportBotBand_designFeasibilityStatus__Z9FNL","feasibilityStatus":"exportBotBand_feasibilityStatus__SyViu","designStatus":"exportBotBand_designStatus__Mc4F9","ideasStatus":"exportBotBand_ideasStatus__TYx1L","buildStatus":"exportBotBand_buildStatus__sKGft","bandWrapper":"exportBotBand_bandWrapper__Om0tx","txt":"exportBotBand_txt__bvoMv","configBtn":"exportBotBand_configBtn__xoGrk","btn":"exportBotBand_btn__zNmXn","exportIcon":"exportBotBand_exportIcon__0tiQ7","createbtn":"exportBotBand_createbtn__JFjDR"};

/***/ }),

/***/ 47283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"feedback_liveStatus__KJxMX","rejectedStatus":"feedback_rejectedStatus__Gy5L_","retiredStatus":"feedback_retiredStatus__D22_V","onHoldStatus":"feedback_onHoldStatus__gm90x","in-ProgressStatus":"feedback_in-ProgressStatus__7lyXG","inProgressStatus":"feedback_inProgressStatus__R_ig_","uATStatus":"feedback_uATStatus__upOom","initialDemandStatus":"feedback_initialDemandStatus__tcSn5","designFeasibilityStatus":"feedback_designFeasibilityStatus__lWC4h","feasibilityStatus":"feedback_feasibilityStatus__8Nxmx","designStatus":"feedback_designStatus__JfsTE","ideasStatus":"feedback_ideasStatus__dbCbQ","buildStatus":"feedback_buildStatus__AsnuR","editModalWrapper":"feedback_editModalWrapper__G2QBY","formContainer":"feedback_formContainer__kZ1RO","icon":"feedback_icon__1Yjb_","iconimg":"feedback_iconimg__ISHIA","modalBox":"feedback_modalBox__H0phz","modalHeader":"feedback_modalHeader__jwAwQ","content":"feedback_content__fL88t","modalBody":"feedback_modalBody__rQcJI","formheading":"feedback_formheading__yxnBs","textBody":"feedback_textBody__Durcc","texthead":"feedback_texthead__h9CYs","textbody":"feedback_textbody__rfpmC","row":"feedback_row__vU3r1","formGroup":"feedback_formGroup__PsfYW","radioWrapper":"feedback_radioWrapper__dOPdl","radioCheckmark":"feedback_radioCheckmark__MN1Lk","mainLabel":"feedback_mainLabel__zsYqA","errorMessage":"feedback_errorMessage__QN33_","subLabel":"feedback_subLabel__oNWMY","select":"feedback_select__Yj_Zt","inputtext":"feedback_inputtext__Neq1F","mandatoryField":"feedback_mandatoryField__zeOzg","radioBox":"feedback_radioBox__FsiIO","labelstyle":"feedback_labelstyle__zPEVU","input":"feedback_input__E9cx1","right":"feedback_right__4Lb_4","more":"feedback_more__LaYVR","fullWidth":"feedback_fullWidth__z4cul","errorBorder":"feedback_errorBorder__tFdIz","modalFooter":"feedback_modalFooter__DhfC7","combinedBtn":"feedback_combinedBtn__7RzXS","rowBtn":"feedback_rowBtn__cdB4r","plusIcon":"feedback_plusIcon___J9QU","exportListBtn":"feedback_exportListBtn__3KWpK","uploadIcon":"feedback_uploadIcon__xlskC"};

/***/ }),

/***/ 33239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"filters_liveStatus__SLWYy","rejectedStatus":"filters_rejectedStatus__uSk6s","retiredStatus":"filters_retiredStatus__ohNIE","onHoldStatus":"filters_onHoldStatus__gzKuS","in-ProgressStatus":"filters_in-ProgressStatus__pF3zZ","inProgressStatus":"filters_inProgressStatus__M9fyh","uATStatus":"filters_uATStatus__XCNLJ","initialDemandStatus":"filters_initialDemandStatus__BDrbN","designFeasibilityStatus":"filters_designFeasibilityStatus__aH2Qd","feasibilityStatus":"filters_feasibilityStatus__T6mp8","designStatus":"filters_designStatus__O0LqG","ideasStatus":"filters_ideasStatus__6aFZG","buildStatus":"filters_buildStatus__6x_VM","filtersContent":"filters_filtersContent__SJnYN","filtersWrapper":"filters_filtersWrapper__2wYgb","head":"filters_head__6ifFu","left":"filters_left__O2z8B","right":"filters_right__Y84W6","more":"filters_more__NO5T0","listWrapper":"filters_listWrapper__ssUsX","formGroup":"filters_formGroup__1ezwJ","mainLabel":"filters_mainLabel__mNeCE","mandatoryField":"filters_mandatoryField__AlFtF","inputGroupWrapper":"filters_inputGroupWrapper__unExd","radioWrapper":"filters_radioWrapper__9asEa","subLabel":"filters_subLabel__4n_tW","radioCheckmark":"filters_radioCheckmark__f0Hgq","inputGroup":"filters_inputGroup__JZ4JH","input":"filters_input__TQ5qy","first-of-type":"filters_first-of-type__wW9JU","dropdown":"filters_dropdown__Fk0Jk"};

/***/ }),

/***/ 30345:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"footer_liveStatus__unLxE","rejectedStatus":"footer_rejectedStatus__SwFD2","retiredStatus":"footer_retiredStatus__MdPA6","onHoldStatus":"footer_onHoldStatus__CRGVR","in-ProgressStatus":"footer_in-ProgressStatus__sG5hE","inProgressStatus":"footer_inProgressStatus__wBj1d","uATStatus":"footer_uATStatus__L7s1p","initialDemandStatus":"footer_initialDemandStatus__fEnIJ","designFeasibilityStatus":"footer_designFeasibilityStatus__51oSF","feasibilityStatus":"footer_feasibilityStatus__ZCAhm","designStatus":"footer_designStatus__FcdgL","ideasStatus":"footer_ideasStatus__11gSO","buildStatus":"footer_buildStatus__ynLVk","footer":"footer_footer__u526u","footWrapper":"footer_footWrapper__ZtQLf","left":"footer_left___7FtI","right":"footer_right__qk9xE","modFooter":"footer_modFooter__nZRUx"};

/***/ }),

/***/ 40070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"frameworkBanner_liveStatus__4Ixp_","rejectedStatus":"frameworkBanner_rejectedStatus__BTlpo","retiredStatus":"frameworkBanner_retiredStatus__9zXWd","onHoldStatus":"frameworkBanner_onHoldStatus__dbjW1","in-ProgressStatus":"frameworkBanner_in-ProgressStatus__pZAW1","inProgressStatus":"frameworkBanner_inProgressStatus__eQT0E","uATStatus":"frameworkBanner_uATStatus__IAUQQ","initialDemandStatus":"frameworkBanner_initialDemandStatus__HdLdh","designFeasibilityStatus":"frameworkBanner_designFeasibilityStatus__mXXXj","feasibilityStatus":"frameworkBanner_feasibilityStatus___B_lh","designStatus":"frameworkBanner_designStatus__218lC","ideasStatus":"frameworkBanner_ideasStatus__4VoWN","buildStatus":"frameworkBanner_buildStatus__kSqBO","frameworkbannerWrapper":"frameworkBanner_frameworkbannerWrapper__S_wh1","row":"frameworkBanner_row__KghIX","imaging":"frameworkBanner_imaging__4Ihj5","image":"frameworkBanner_image__SAbVf","imageMobile":"frameworkBanner_imageMobile__u1Has","container":"frameworkBanner_container__DlpU_","frameworkbannerHead":"frameworkBanner_frameworkbannerHead__G2q8X","frameworkbannerText":"frameworkBanner_frameworkbannerText__cn9qf"};

/***/ }),

/***/ 75503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"frameworkPdfComponent_liveStatus__JjIFx","rejectedStatus":"frameworkPdfComponent_rejectedStatus__hR9S3","retiredStatus":"frameworkPdfComponent_retiredStatus__PyySB","onHoldStatus":"frameworkPdfComponent_onHoldStatus__Q4ATN","in-ProgressStatus":"frameworkPdfComponent_in-ProgressStatus__fBN4M","inProgressStatus":"frameworkPdfComponent_inProgressStatus__16fw4","uATStatus":"frameworkPdfComponent_uATStatus__1J78t","initialDemandStatus":"frameworkPdfComponent_initialDemandStatus__lVVgd","designFeasibilityStatus":"frameworkPdfComponent_designFeasibilityStatus__uCYOA","feasibilityStatus":"frameworkPdfComponent_feasibilityStatus__p45G4","designStatus":"frameworkPdfComponent_designStatus__svO6U","ideasStatus":"frameworkPdfComponent_ideasStatus__uKboM","buildStatus":"frameworkPdfComponent_buildStatus__rdu1h","automationFactoryContainer":"frameworkPdfComponent_automationFactoryContainer__RORLL","factoryHead":"frameworkPdfComponent_factoryHead__O8_6W","left":"frameworkPdfComponent_left__yVAc9","right":"frameworkPdfComponent_right__0xC7z","downloadSelected":"frameworkPdfComponent_downloadSelected___MuNV","downloadAll":"frameworkPdfComponent_downloadAll__54Nfv","assetsWrapper":"frameworkPdfComponent_assetsWrapper__3iDj6","selectAllCheck":"frameworkPdfComponent_selectAllCheck__w2nPs","list_Checkbox_container":"frameworkPdfComponent_list_Checkbox_container__a2CGT","lableHead":"frameworkPdfComponent_lableHead__INoVE","list_checkmark":"frameworkPdfComponent_list_checkmark__hTwQz","pdfCard":"frameworkPdfComponent_pdfCard__o3UUA","head":"frameworkPdfComponent_head__M4b8y","deleteIcon":"frameworkPdfComponent_deleteIcon__xwTAm","mobileDownloadIcon":"frameworkPdfComponent_mobileDownloadIcon__36qj8","iconWrap":"frameworkPdfComponent_iconWrap__vKQzG","check":"frameworkPdfComponent_check__E8vdD","icon":"frameworkPdfComponent_icon__4DcMN","iconview":"frameworkPdfComponent_iconview__AvFlJ","pdfTitle":"frameworkPdfComponent_pdfTitle__6SVht","body":"frameworkPdfComponent_body__c6pLg","downloadOverlay":"frameworkPdfComponent_downloadOverlay__YPUuT","downloadBtn":"frameworkPdfComponent_downloadBtn__hd_Vd","objWrapper":"frameworkPdfComponent_objWrapper__TbX_I","active":"frameworkPdfComponent_active__Rxky6","mobileDownloadAll":"frameworkPdfComponent_mobileDownloadAll__B9v5Q","btn":"frameworkPdfComponent_btn__lPtUd"};

/***/ }),

/***/ 4440:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"header_liveStatus__JPvD4","rejectedStatus":"header_rejectedStatus__p0yvK","retiredStatus":"header_retiredStatus__zwh7n","onHoldStatus":"header_onHoldStatus__SexeW","in-ProgressStatus":"header_in-ProgressStatus__ZcRXT","inProgressStatus":"header_inProgressStatus__5g5zK","uATStatus":"header_uATStatus__7duBG","initialDemandStatus":"header_initialDemandStatus__gsLtF","designFeasibilityStatus":"header_designFeasibilityStatus__0Wuxg","feasibilityStatus":"header_feasibilityStatus__Ina6f","designStatus":"header_designStatus__paW2W","ideasStatus":"header_ideasStatus__viEQj","buildStatus":"header_buildStatus__Lpxs1","navbar":"header_navbar__krdYU","left":"header_left__yXeIc","active":"header_active__g4Oh_","header":"header_header__ChI0V","headWrapper":"header_headWrapper__VlQnt","logoMain":"header_logoMain__nxQtT","logowrapper":"header_logowrapper__v1tLI","sublogowrapper":"header_sublogowrapper___imRv","searchProfileWrapper":"header_searchProfileWrapper__y4gGa","search":"header_search__j_UMH","searchIcon":"header_searchIcon__i4PIb","demoButton":"header_demoButton__GBmX1","actionBtn":"header_actionBtn__L85SQ","ideaButton":"header_ideaButton__TYN01","profile":"header_profile__lJX73","userDesktop":"header_userDesktop__MRb6K","searchMenuWrapper":"header_searchMenuWrapper__zuDPi","adminLoginWrapper":"header_adminLoginWrapper__XP550","adminLogin":"header_adminLogin__NCqE_","logouticon":"header_logouticon__58UYr","logi":"header_logi__IrsUr","scrollToTop":"header_scrollToTop__7hO_Y","chevron":"header_chevron__w1fwq","chatBot":"header_chatBot__pvcU1","crossIcon":"header_crossIcon__OU11E","searchContain":"header_searchContain__6RgPW","searchMobileIcon":"header_searchMobileIcon__MjxYM","burgerMenu":"header_burgerMenu__qY8XE","burgerMenuIcon":"header_burgerMenuIcon__xSeVd"};

/***/ }),

/***/ 1034:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"listDropdownforemptwin_liveStatus__ngG1N","rejectedStatus":"listDropdownforemptwin_rejectedStatus__me1kn","retiredStatus":"listDropdownforemptwin_retiredStatus__S2wGL","onHoldStatus":"listDropdownforemptwin_onHoldStatus__W_726","in-ProgressStatus":"listDropdownforemptwin_in-ProgressStatus__6wQpC","inProgressStatus":"listDropdownforemptwin_inProgressStatus__Ksw18","uATStatus":"listDropdownforemptwin_uATStatus___dycX","initialDemandStatus":"listDropdownforemptwin_initialDemandStatus__B8l0G","designFeasibilityStatus":"listDropdownforemptwin_designFeasibilityStatus___Fl22","feasibilityStatus":"listDropdownforemptwin_feasibilityStatus__XdxWQ","designStatus":"listDropdownforemptwin_designStatus__p9n0Q","ideasStatus":"listDropdownforemptwin_ideasStatus__XuhxU","buildStatus":"listDropdownforemptwin_buildStatus__aFDCX","listContainer":"listDropdownforemptwin_listContainer__X_e2y","list_Checkbox_container":"listDropdownforemptwin_list_Checkbox_container____GuL","lableHead":"listDropdownforemptwin_lableHead__HW17K","list_checkmark":"listDropdownforemptwin_list_checkmark__7_UmZ"};

/***/ }),

/***/ 84942:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"offering_liveStatus__CoG_t","rejectedStatus":"offering_rejectedStatus__KdqNo","retiredStatus":"offering_retiredStatus__eQ4Re","onHoldStatus":"offering_onHoldStatus__3cQm_","in-ProgressStatus":"offering_in-ProgressStatus__kVZl7","inProgressStatus":"offering_inProgressStatus__UgApe","uATStatus":"offering_uATStatus__xX0gr","initialDemandStatus":"offering_initialDemandStatus__SvuL7","designFeasibilityStatus":"offering_designFeasibilityStatus__4T7d0","feasibilityStatus":"offering_feasibilityStatus__27ZAJ","designStatus":"offering_designStatus__jue7_","ideasStatus":"offering_ideasStatus__FCevJ","buildStatus":"offering_buildStatus__QJ04o","offeringParent":"offering_offeringParent__qKgOH","title":"offering_title__gz05I","Image":"offering_Image__tZlMr","hexCard":"offering_hexCard__6WCwF","hex":"offering_hex___o6lY","border":"offering_border___h9kZ"};

/***/ }),

/***/ 49365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"offeringBanner_liveStatus__6NLKB","rejectedStatus":"offeringBanner_rejectedStatus__ZzXK9","retiredStatus":"offeringBanner_retiredStatus__QGLfa","onHoldStatus":"offeringBanner_onHoldStatus__ker2x","in-ProgressStatus":"offeringBanner_in-ProgressStatus__orc_u","inProgressStatus":"offeringBanner_inProgressStatus__s4EbY","uATStatus":"offeringBanner_uATStatus__N6RdD","initialDemandStatus":"offeringBanner_initialDemandStatus__w_1k1","designFeasibilityStatus":"offeringBanner_designFeasibilityStatus__Z2BSf","feasibilityStatus":"offeringBanner_feasibilityStatus__1as8v","designStatus":"offeringBanner_designStatus__NYLtq","ideasStatus":"offeringBanner_ideasStatus__u29Tq","buildStatus":"offeringBanner_buildStatus__R_lmJ","frameworkbannerWrapper":"offeringBanner_frameworkbannerWrapper__zshhr","row":"offeringBanner_row__5M27V","content":"offeringBanner_content__HIuXz","imaging":"offeringBanner_imaging__55yUV","image":"offeringBanner_image__tQKtg","imageMobile":"offeringBanner_imageMobile__h_dCO","container":"offeringBanner_container__DmHkt","frameworkbannerHead":"offeringBanner_frameworkbannerHead__N9tue","frameworkbannerText":"offeringBanner_frameworkbannerText__5mXUl"};

/***/ }),

/***/ 98286:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"pagination_liveStatus__P2CZf","rejectedStatus":"pagination_rejectedStatus__yFY5g","retiredStatus":"pagination_retiredStatus__MsepF","onHoldStatus":"pagination_onHoldStatus__j_8N0","in-ProgressStatus":"pagination_in-ProgressStatus__ZPNk2","inProgressStatus":"pagination_inProgressStatus__snbTc","uATStatus":"pagination_uATStatus__rw0TP","initialDemandStatus":"pagination_initialDemandStatus__x8_J2","designFeasibilityStatus":"pagination_designFeasibilityStatus___rJv6","feasibilityStatus":"pagination_feasibilityStatus__X6YA8","designStatus":"pagination_designStatus__Qrs7F","ideasStatus":"pagination_ideasStatus__hMGO8","buildStatus":"pagination_buildStatus__oDBUp","paginationOuter":"pagination_paginationOuter__l5rUj","leftArrow":"pagination_leftArrow__t_m_C","rightArrow":"pagination_rightArrow__4OXqi","main":"pagination_main__tUEBA","number":"pagination_number__KaX4D","active":"pagination_active__r8Lrg"};

/***/ }),

/***/ 66609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"pdfModalViewer_liveStatus__GpAuf","rejectedStatus":"pdfModalViewer_rejectedStatus__hjb6_","retiredStatus":"pdfModalViewer_retiredStatus__b15xX","onHoldStatus":"pdfModalViewer_onHoldStatus__zHogw","in-ProgressStatus":"pdfModalViewer_in-ProgressStatus__moPar","inProgressStatus":"pdfModalViewer_inProgressStatus__06qGX","uATStatus":"pdfModalViewer_uATStatus__kLcV0","initialDemandStatus":"pdfModalViewer_initialDemandStatus__JusC3","designFeasibilityStatus":"pdfModalViewer_designFeasibilityStatus__6Hzo_","feasibilityStatus":"pdfModalViewer_feasibilityStatus__av_NK","designStatus":"pdfModalViewer_designStatus__1DzlQ","ideasStatus":"pdfModalViewer_ideasStatus__jBNze","buildStatus":"pdfModalViewer_buildStatus__NOm8S","editModalWrapper":"pdfModalViewer_editModalWrapper___EQLV","modalBox":"pdfModalViewer_modalBox__wtfXh","modalHeader":"pdfModalViewer_modalHeader__Yu1vx","leftHeader":"pdfModalViewer_leftHeader__7aEMV","icon":"pdfModalViewer_icon__vLwIA","content":"pdfModalViewer_content__M65NU","download":"pdfModalViewer_download__7vaHs","close":"pdfModalViewer_close__L45PA","modalBody":"pdfModalViewer_modalBody__QUugA","textBody":"pdfModalViewer_textBody__oUtB0","texthead":"pdfModalViewer_texthead__9LY4x","textbody":"pdfModalViewer_textbody__FYI1E","row":"pdfModalViewer_row__nKWMY","formGroup":"pdfModalViewer_formGroup__R_cLL","labelstyle":"pdfModalViewer_labelstyle__SoqWd","errorMessage":"pdfModalViewer_errorMessage__oB_mN","input":"pdfModalViewer_input__ODp8x","right":"pdfModalViewer_right__u0jxf","more":"pdfModalViewer_more__TEq77","fullWidth":"pdfModalViewer_fullWidth__TBDJq","errorBorder":"pdfModalViewer_errorBorder__CeOZj","modalFooter":"pdfModalViewer_modalFooter__YaSNg","combinedBtn":"pdfModalViewer_combinedBtn__3ra40","rowBtn":"pdfModalViewer_rowBtn__hwz_v","plusIcon":"pdfModalViewer_plusIcon__8_wXu","exportListBtn":"pdfModalViewer_exportListBtn__5FgBy","uploadIcon":"pdfModalViewer_uploadIcon__7gBun"};

/***/ }),

/***/ 33346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"softskill_liveStatus__v_225","rejectedStatus":"softskill_rejectedStatus__MEsfZ","retiredStatus":"softskill_retiredStatus__43pnZ","onHoldStatus":"softskill_onHoldStatus__zIxL3","in-ProgressStatus":"softskill_in-ProgressStatus__aSPas","inProgressStatus":"softskill_inProgressStatus__on_A3","uATStatus":"softskill_uATStatus__BhR6t","initialDemandStatus":"softskill_initialDemandStatus__Y7iHr","designFeasibilityStatus":"softskill_designFeasibilityStatus__NU7Aq","feasibilityStatus":"softskill_feasibilityStatus__ciuZ2","designStatus":"softskill_designStatus__fXMMg","ideasStatus":"softskill_ideasStatus__xIWfJ","buildStatus":"softskill_buildStatus__ffe6A","editModalWrapper":"softskill_editModalWrapper__sw3HU","formContainer":"softskill_formContainer__bgS87","icon":"softskill_icon__wN52g","iconimg":"softskill_iconimg__neWMo","modalBox":"softskill_modalBox__cbKFs","modalHeader":"softskill_modalHeader__cbp_7","content":"softskill_content__gFDOS","modalBody":"softskill_modalBody__GexIL","formheading":"softskill_formheading__hTr7W","textBody":"softskill_textBody__1jB76","texthead":"softskill_texthead__b0po9","textbody":"softskill_textbody__i3LLV","row":"softskill_row__GURFd","formGroup":"softskill_formGroup__bZuu9","radioWrapper":"softskill_radioWrapper__SYSQl","radioCheckmark":"softskill_radioCheckmark__Fpwn6","mainLabel":"softskill_mainLabel__6D3vC","actionBtn":"softskill_actionBtn__oKgFV","uploadControl":"softskill_uploadControl__Q8WDy","errorMessage":"softskill_errorMessage__J2mc7","subLabel":"softskill_subLabel__TvLxZ","select":"softskill_select__r4qSj","inputtext":"softskill_inputtext__HAwzm","mandatoryField":"softskill_mandatoryField__i79GG","radioBox":"softskill_radioBox__Crw_L","labelstyle":"softskill_labelstyle__rIEwK","input":"softskill_input__Mhvso","right":"softskill_right__Dbyr9","more":"softskill_more__BrHxN","fullWidth":"softskill_fullWidth__9LbZp","errorBorder":"softskill_errorBorder__Y6KeH","uploadBtnWrapper":"softskill_uploadBtnWrapper__Fd5T6","uploadFileContainer":"softskill_uploadFileContainer__NANvX","multiDocsWrapper":"softskill_multiDocsWrapper__6qHlB","skillMultiDocs":"softskill_skillMultiDocs__Czdi4","modalFooter":"softskill_modalFooter__r5eF4","combinedBtn":"softskill_combinedBtn__EU_Mn","rowBtn":"softskill_rowBtn__dlrU4","plusIcon":"softskill_plusIcon___9c2H","exportListBtn":"softskill_exportListBtn__amB_6","uploadIcon":"softskill_uploadIcon__WVJPz"};

/***/ }),

/***/ 78962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"softskillDetails_liveStatus__7ec47","rejectedStatus":"softskillDetails_rejectedStatus__JH_mJ","retiredStatus":"softskillDetails_retiredStatus__mY7yr","onHoldStatus":"softskillDetails_onHoldStatus__JShQp","in-ProgressStatus":"softskillDetails_in-ProgressStatus__M8tk6","inProgressStatus":"softskillDetails_inProgressStatus__os_ua","uATStatus":"softskillDetails_uATStatus__GoyU6","initialDemandStatus":"softskillDetails_initialDemandStatus__tJUnI","designFeasibilityStatus":"softskillDetails_designFeasibilityStatus__E9cRW","feasibilityStatus":"softskillDetails_feasibilityStatus__qrJ5U","designStatus":"softskillDetails_designStatus__4O9iV","ideasStatus":"softskillDetails_ideasStatus__KlfOv","buildStatus":"softskillDetails_buildStatus__IQweh","botDetailWrapper":"softskillDetails_botDetailWrapper__phWQA","editBotBtn":"softskillDetails_editBotBtn__jeu3e","detailHead":"softskillDetails_detailHead__huFqh","cardHead":"softskillDetails_cardHead__5bhXp","left":"softskillDetails_left__g9OGV","dollarBack":"softskillDetails_dollarBack__YGPhd","icon":"softskillDetails_icon__S9emG","dollaricon":"softskillDetails_dollaricon__Qj5AS","dollarspan":"softskillDetails_dollarspan__nCW3U","text":"softskillDetails_text__U8KsT","flexd":"softskillDetails_flexd__OY3a7","code":"softskillDetails_code__5mJQ8","list":"softskillDetails_list__mefGl","tooltiptext":"softskillDetails_tooltiptext__1FIQR","info":"softskillDetails_info__s5qGX","label":"softskillDetails_label__CZrFa","statusTagWrapper":"softskillDetails_statusTagWrapper__aktqD","editBot":"softskillDetails_editBot__XR4S_","right":"softskillDetails_right__V5nvt","backBot":"softskillDetails_backBot__PYEQV","backBotSearch":"softskillDetails_backBotSearch__N_xt7","detailBody":"softskillDetails_detailBody__K8__j","textualContent":"softskillDetails_textualContent__ng72z","txtCard":"softskillDetails_txtCard__zafs1","controlTable":"softskillDetails_controlTable__IHHff","cardRow":"softskillDetails_cardRow__DpWey","fullWidth":"softskillDetails_fullWidth__MneYQ","documentLinkHeading":"softskillDetails_documentLinkHeading__64Cv8","editRow":"softskillDetails_editRow__J_7AO","input":"softskillDetails_input__iSRC0","more":"softskillDetails_more__T5lrQ","container":"softskillDetails_container__TTKVd","loader":"softskillDetails_loader__NC09m","loader3":"softskillDetails_loader3__KYjg3","load3":"softskillDetails_load3__7awj7","cardHeading":"softskillDetails_cardHeading__qsU8P","mediaContent":"softskillDetails_mediaContent___cmU4","videWrapper":"softskillDetails_videWrapper__6qErP","pdfWrapper":"softskillDetails_pdfWrapper__ZeXB6","dropdownWrapper":"softskillDetails_dropdownWrapper__inOXl","dropdown":"softskillDetails_dropdown__j2F8J","pdfHead":"softskillDetails_pdfHead__iT3L7","pdfText":"softskillDetails_pdfText__jTgqX","threeDots":"softskillDetails_threeDots__5_CEj","pdfsubHead":"softskillDetails_pdfsubHead__mxXCW","downloadIcon":"softskillDetails_downloadIcon__mdXgI","pdfmainhead":"softskillDetails_pdfmainhead__cojBh","icard":"softskillDetails_icard__oXBKA","getBot":"softskillDetails_getBot__2ryA0","rollBot":"softskillDetails_rollBot__TBWxr","combinedBtn":"softskillDetails_combinedBtn__OJw09","rowBtn":"softskillDetails_rowBtn__AO0lm","plusIcon":"softskillDetails_plusIcon__KW4FM","exportListBtn":"softskillDetails_exportListBtn__nZUbm","uploadIcon":"softskillDetails_uploadIcon__Cdfdf","BotdetailsCard":"softskillDetails_BotdetailsCard__GVWw3","commonText":"softskillDetails_commonText__IPSAq","parentCard":"softskillDetails_parentCard__zxK9L","similarCards":"softskillDetails_similarCards__2MPBJ","load":"softskillDetails_load__qKAgv"};

/***/ }),

/***/ 23344:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"userEdit_liveStatus__zpAnW","rejectedStatus":"userEdit_rejectedStatus__e3yTJ","retiredStatus":"userEdit_retiredStatus__4uxcb","onHoldStatus":"userEdit_onHoldStatus__Fm97N","in-ProgressStatus":"userEdit_in-ProgressStatus__OVj3t","inProgressStatus":"userEdit_inProgressStatus__MzxMn","uATStatus":"userEdit_uATStatus__ZDlWr","initialDemandStatus":"userEdit_initialDemandStatus__ilYW6","designFeasibilityStatus":"userEdit_designFeasibilityStatus__YI6Qq","feasibilityStatus":"userEdit_feasibilityStatus__h8k7v","designStatus":"userEdit_designStatus__DtUFX","ideasStatus":"userEdit_ideasStatus__aTk9_","buildStatus":"userEdit_buildStatus__vt7jN","editModalWrapper":"userEdit_editModalWrapper__BQz2l","modalBox":"userEdit_modalBox__d_WeH","modalHeader":"userEdit_modalHeader__MuqK9","content":"userEdit_content__2irip","modalBody":"userEdit_modalBody__sZC3V","basicFormWrapper":"userEdit_basicFormWrapper__yGQ0w","textBody":"userEdit_textBody__gNuqR","texthead":"userEdit_texthead__mBynO","textbody":"userEdit_textbody__Ispgc","inputGroup":"userEdit_inputGroup__L0skf","input":"userEdit_input__VnL_K","right":"userEdit_right__fplI4","more":"userEdit_more__7UjW_","inputGroupWrapper":"userEdit_inputGroupWrapper__3jzMa","radioWrapper":"userEdit_radioWrapper__TAnSB","subLabel":"userEdit_subLabel___NOQD","radioCheckmark":"userEdit_radioCheckmark__IwiTf","modalFooter":"userEdit_modalFooter___v6ux","combinedBtn":"userEdit_combinedBtn__OO5YZ","rowBtn":"userEdit_rowBtn__Hmvgw","plusIcon":"userEdit_plusIcon__D6GxG","exportListBtn":"userEdit_exportListBtn__UIkMC","uploadIcon":"userEdit_uploadIcon__zSKLK"};

/***/ }),

/***/ 7877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"ProfilePage_liveStatus__graNK","rejectedStatus":"ProfilePage_rejectedStatus__NyaqY","retiredStatus":"ProfilePage_retiredStatus__2WK3m","onHoldStatus":"ProfilePage_onHoldStatus__HEGBB","in-ProgressStatus":"ProfilePage_in-ProgressStatus__SV3Uy","inProgressStatus":"ProfilePage_inProgressStatus__uPY_n","uATStatus":"ProfilePage_uATStatus__ktk__","initialDemandStatus":"ProfilePage_initialDemandStatus__FMEAT","designFeasibilityStatus":"ProfilePage_designFeasibilityStatus__U_fGa","feasibilityStatus":"ProfilePage_feasibilityStatus__lSmCh","designStatus":"ProfilePage_designStatus__XSsCb","ideasStatus":"ProfilePage_ideasStatus__QofXN","buildStatus":"ProfilePage_buildStatus___4K77","container":"ProfilePage_container__FJ_wZ","profileDetailsWrapper":"ProfilePage_profileDetailsWrapper__L6g_V","profileImgContainer":"ProfilePage_profileImgContainer__Mp2DX","img":"ProfilePage_img__7oli2","dummy":"ProfilePage_dummy__h_ql4","inputGroup":"ProfilePage_inputGroup__zIG69","uploadIcon":"ProfilePage_uploadIcon__HTj49","dropdown":"ProfilePage_dropdown__zY3_4","dropdwoncontain":"ProfilePage_dropdwoncontain__dXQ4_","input":"ProfilePage_input__mJQja","left":"ProfilePage_left__bZCuw","right":"ProfilePage_right__VqaSa","cameraIcon":"ProfilePage_cameraIcon__XKS6_","imgerror":"ProfilePage_imgerror__8jb3f","name":"ProfilePage_name__Q4RvT","detailsSec":"ProfilePage_detailsSec__EIRSz","row":"ProfilePage_row___W_wf","formGroup":"ProfilePage_formGroup__zIDhT","required":"ProfilePage_required__kDvk9","more":"ProfilePage_more__9gGE6","fullWidth":"ProfilePage_fullWidth__nSfj1","saveDetails":"ProfilePage_saveDetails__ZOs6N","btn":"ProfilePage_btn__7dOAg"};

/***/ }),

/***/ 74039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addProductContainer":"addproduct_addProductContainer__NGTrG","addFormControl":"addproduct_addFormControl__qeV4V","field":"addproduct_field__i4ILJ","actionButtons":"addproduct_actionButtons__CEhm3","buttons":"addproduct_buttons__FfJO_","cancel":"addproduct_cancel__SeZ9b","save":"addproduct_save__BrNpF","saveBlock":"addproduct_saveBlock__MXWQ6","leadRowButtons":"addproduct_leadRowButtons__MLt1S","multiSelectDropdown":"addproduct_multiSelectDropdown__nzuqh","iframe_section":"addproduct_iframe_section__CcmW9","benefits_section":"addproduct_benefits_section__RH_Jf","hl_blue":"addproduct_hl_blue___Kn_Q","Frist_section":"addproduct_Frist_section__1emIx","img_1":"addproduct_img_1__rd2_S","img_2":"addproduct_img_2__WWHO0","img_3":"addproduct_img_3__cMSG0","bot_section":"addproduct_bot_section__b2poi","cards_benefits_card":"addproduct_cards_benefits_card__8Oqd_","breadcrumb":"addproduct_breadcrumb__zCYtl","mainSection_space":"addproduct_mainSection_space__fIXMQ","Products_section":"addproduct_Products_section__N4EbJ","Section_2":"addproduct_Section_2__IxA1w","banner_card_section":"addproduct_banner_card_section__60kxV","frist_image":"addproduct_frist_image__60ebk","second_image":"addproduct_second_image__s1f86"};

/***/ }),

/***/ 57196:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"approvalForm_liveStatus__XBjkl","rejectedStatus":"approvalForm_rejectedStatus__bZmlj","retiredStatus":"approvalForm_retiredStatus__lPJRM","onHoldStatus":"approvalForm_onHoldStatus__0qfmi","in-ProgressStatus":"approvalForm_in-ProgressStatus__2TvSe","inProgressStatus":"approvalForm_inProgressStatus__h5Kz3","uATStatus":"approvalForm_uATStatus__eNQi1","initialDemandStatus":"approvalForm_initialDemandStatus__6zhvC","designFeasibilityStatus":"approvalForm_designFeasibilityStatus__zTRm6","feasibilityStatus":"approvalForm_feasibilityStatus__gI4mi","designStatus":"approvalForm_designStatus__FVo87","ideasStatus":"approvalForm_ideasStatus__ZAk6M","buildStatus":"approvalForm_buildStatus__QbtNO","ques4":"approvalForm_ques4__eBfcX","formContainer":"approvalForm_formContainer__D5iN_","head":"approvalForm_head__SFx13","parentForm":"approvalForm_parentForm__w8wiI","inputGroup":"approvalForm_inputGroup__XYjhF","ques1":"approvalForm_ques1__tPDra","errorMessage":"approvalForm_errorMessage__zjtlT","documentLinkWrapper":"approvalForm_documentLinkWrapper__KIQw8","Group_sub":"approvalForm_Group_sub__BPj0G","documentLink":"approvalForm_documentLink__ksaF2","radio":"approvalForm_radio__zRIZi","radioWrapper":"approvalForm_radioWrapper__vOmEM","subLabel":"approvalForm_subLabel___HGkb","radioCheckmark":"approvalForm_radioCheckmark__5V3s2","Group":"approvalForm_Group__ee_Cy","inputGroupDropdown":"approvalForm_inputGroupDropdown__JXyp_","input":"approvalForm_input__kH5ys","right":"approvalForm_right__U5vT5","more":"approvalForm_more__sB7mw","errorBorder":"approvalForm_errorBorder__k5S9t","fullWidth":"approvalForm_fullWidth__R7MWy","areaGroup":"approvalForm_areaGroup__p28k_","scrollableTable":"approvalForm_scrollableTable__dZ7i0","dividedHead":"approvalForm_dividedHead___NvYQ","subHead":"approvalForm_subHead__m7b3h","subDivision":"approvalForm_subDivision__p0v9f","dividedBody":"approvalForm_dividedBody__8F59o","editInactive":"approvalForm_editInactive__jLiWa","icon":"approvalForm_icon__qYGLa","check":"approvalForm_check__gf4zh","list_Checkbox_container":"approvalForm_list_Checkbox_container__TE_NJ","lableHead":"approvalForm_lableHead__nTWKs","list_checkmark":"approvalForm_list_checkmark__xe5SQ","bottomBtns":"approvalForm_bottomBtns__YjHyf","btn":"approvalForm_btn__KMGvc"};

/***/ }),

/***/ 87003:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"approvals_liveStatus__5Sl8G","rejectedStatus":"approvals_rejectedStatus__Re_Rs","retiredStatus":"approvals_retiredStatus__whtse","onHoldStatus":"approvals_onHoldStatus__O2Szf","in-ProgressStatus":"approvals_in-ProgressStatus__9mnKz","inProgressStatus":"approvals_inProgressStatus__lF4ri","uATStatus":"approvals_uATStatus__KfuaO","initialDemandStatus":"approvals_initialDemandStatus__4gcO_","designFeasibilityStatus":"approvals_designFeasibilityStatus__0B5cA","feasibilityStatus":"approvals_feasibilityStatus__T_PTD","designStatus":"approvals_designStatus__xK9pI","ideasStatus":"approvals_ideasStatus__4Do56","buildStatus":"approvals_buildStatus__XmoNQ","containerApproval":"approvals_containerApproval__wjc1j","mobileFilterBtn":"approvals_mobileFilterBtn__uU3qz","btn":"approvals_btn__VXimO","filterCount":"approvals_filterCount__ZxjeK","filterIcon":"approvals_filterIcon__axgOv","buttonstwins":"approvals_buttonstwins__Hq3QR","onebtn":"approvals_onebtn__m_qdu","onebtnInactive":"approvals_onebtnInactive__x4fsc","twobtn":"approvals_twobtn__gjasO","twobtnInactive":"approvals_twobtnInactive__UyyJJ","demandActionHead":"approvals_demandActionHead__dbmWL","top":"approvals_top__21ZMZ","left":"approvals_left__NY9J6","search":"approvals_search__sYDmM","searchIcon":"approvals_searchIcon__ihfAp","right":"approvals_right__J62eQ","combinedBtn":"approvals_combinedBtn___NpHN","rowBtn":"approvals_rowBtn__L0v_n","plusIcon":"approvals_plusIcon__pNdiA","exportListBtn":"approvals_exportListBtn__g6f_6","uploadIcon":"approvals_uploadIcon__E0I_t","bottom":"approvals_bottom__aP33Y","inputGroup":"approvals_inputGroup__ybzPi","input":"approvals_input__4aq_4","more":"approvals_more__z_tUi","first-of-type":"approvals_first-of-type__tT297","demandDataBody":"approvals_demandDataBody__K8lfI","scrollableTable":"approvals_scrollableTable__L1mMK","dividedHead":"approvals_dividedHead__qL3fH","subHead":"approvals_subHead__YTuNL","subDivision":"approvals_subDivision__Wlq6O","processName":"approvals_processName__I3wYu","dividedBody":"approvals_dividedBody__a4keS","editInactive":"approvals_editInactive__xY9TN","fixedTable":"approvals_fixedTable__S2IR3","actionMobile":"approvals_actionMobile__f7DOU","actionDesktop":"approvals_actionDesktop___e4y2","noresults":"approvals_noresults__NXv1p","content":"approvals_content__pgCCz"};

/***/ }),

/***/ 77984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"botStore_liveStatus__l23AS","rejectedStatus":"botStore_rejectedStatus__krobD","retiredStatus":"botStore_retiredStatus___3Ift","onHoldStatus":"botStore_onHoldStatus__XcLE0","in-ProgressStatus":"botStore_in-ProgressStatus__IvtMe","inProgressStatus":"botStore_inProgressStatus__MxQEi","uATStatus":"botStore_uATStatus__C6pXn","initialDemandStatus":"botStore_initialDemandStatus__GCmCy","designFeasibilityStatus":"botStore_designFeasibilityStatus__47pM2","feasibilityStatus":"botStore_feasibilityStatus__4HIR4","designStatus":"botStore_designStatus__mzNIN","ideasStatus":"botStore_ideasStatus__U8u3H","buildStatus":"botStore_buildStatus__tCAYM","tabs_list":"botStore_tabs_list__ym6Pu","mainContainer":"botStore_mainContainer__XtxW1","cardContainer":"botStore_cardContainer__HKmeE","card":"botStore_card__C2cHx","storeContainer":"botStore_storeContainer__7gvD_","flex_section":"botStore_flex_section__ZAi_x","search":"botStore_search__9CuTD","searchIcon":"botStore_searchIcon__t6kSW","iframe_section":"botStore_iframe_section__lVMxD","blankDiv":"botStore_blankDiv___xnFO","mainContainersection":"botStore_mainContainersection__cmRrR","mainContainer2":"botStore_mainContainer2__I0Dz0","checlk_list":"botStore_checlk_list__4v9fx","vehicle1":"botStore_vehicle1__RfNO9","filters_card":"botStore_filters_card__IuZwU","search_section":"botStore_search_section__0tnTQ","filters_card_section":"botStore_filters_card_section__7PZwO","cardHead":"botStore_cardHead__KNErg","title":"botStore_title__HCLwg","para":"botStore_para__PcOI1","content1":"botStore_content1__WAI4X","btn":"botStore_btn__emIFa","content":"botStore_content__JoD6W","cardFoot":"botStore_cardFoot__kVgCd","box-showde":"botStore_box-showde__hq6Qa","noresultsmain":"botStore_noresultsmain__nC7ie","noresults":"botStore_noresults__wmEtZ","head":"botStore_head__RND5p","filtergray":"botStore_filtergray__2_SOC","filtercontent":"botStore_filtercontent__EgiPZ","labelfilter":"botStore_labelfilter__owe6N","closeicon":"botStore_closeicon__VFAOY","filter":"botStore_filter__7YF_B","mobileFilterBtn":"botStore_mobileFilterBtn__xjZX8","loader":"botStore_loader__IXDai","spinner":"botStore_spinner__adZaU","spin":"botStore_spin__iFCOd","filterCount":"botStore_filterCount__m_i9r","filterIcon":"botStore_filterIcon__BHZWI","contentTabs":"botStore_contentTabs__dxbRW","content_active":"botStore_content_active__F5PyI","card_section1":"botStore_card_section1__HFj05","crard_main_section":"botStore_crard_main_section__9zA1i","blue_card_section":"botStore_blue_card_section__TUlZo","cards_benefits":"botStore_cards_benefits__ZqY_b","benefits_section":"botStore_benefits_section__z9_Ov","hl_blue":"botStore_hl_blue__9X4vd","Frist_section":"botStore_Frist_section__pRe61","img_1":"botStore_img_1__leqMc","img_2":"botStore_img_2___RAzu","img_3":"botStore_img_3__jbFp_","bot_section":"botStore_bot_section__sJMy5","cards_benefits_card":"botStore_cards_benefits_card__f2CtS","breadcrumb":"botStore_breadcrumb__frapl","mainSection_space":"botStore_mainSection_space__kDPNO","Products_section":"botStore_Products_section__MTkLX","Section_2":"botStore_Section_2__b3j2g","banner_card_section":"botStore_banner_card_section__It9dm","frist_image":"botStore_frist_image__hQL1_","second_image":"botStore_second_image__Y34D7","pagination":"botStore_pagination__xwFSx","active":"botStore_active__aUksG"};

/***/ }),

/***/ 26798:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"cezPage_liveStatus__lcYOC","rejectedStatus":"cezPage_rejectedStatus__75IdW","retiredStatus":"cezPage_retiredStatus__d6hQM","onHoldStatus":"cezPage_onHoldStatus__cbf7m","in-ProgressStatus":"cezPage_in-ProgressStatus__Kglac","inProgressStatus":"cezPage_inProgressStatus__4JJ0K","uATStatus":"cezPage_uATStatus___JGkD","initialDemandStatus":"cezPage_initialDemandStatus__eHVFh","designFeasibilityStatus":"cezPage_designFeasibilityStatus__UpjkQ","feasibilityStatus":"cezPage_feasibilityStatus__tMOxn","designStatus":"cezPage_designStatus__N_wag","ideasStatus":"cezPage_ideasStatus__BYPV2","buildStatus":"cezPage_buildStatus___KGn9","cezContainer":"cezPage_cezContainer__GoM65","gsapBox":"cezPage_gsapBox__BbP99","headBox":"cezPage_headBox__DtkBz","imgBoxSticky":"cezPage_imgBoxSticky__lz5uj","imgBoxOuter":"cezPage_imgBoxOuter__auoPB","imgBox":"cezPage_imgBox__1eP6k","mainHeading":"cezPage_mainHeading__lmWfT","head":"cezPage_head__TLBlO","text":"cezPage_text__Fl_8i","cezMainContainer":"cezPage_cezMainContainer__bqpur","cezCircleOuter":"cezPage_cezCircleOuter__0AuYL","cezMainCircle":"cezPage_cezMainCircle__p63js","cezCircleLine":"cezPage_cezCircleLine__5jxdx","cezIcons":"cezPage_cezIcons__9fmr7","cezIconOuter":"cezPage_cezIconOuter__C9Pam","cezIcon":"cezPage_cezIcon__PCMe5","cezIconText":"cezPage_cezIconText__BRvR4","cezIconDefault":"cezPage_cezIconDefault__nlBU5","cezIconActive":"cezPage_cezIconActive__iqlMJ","bulletIcon":"cezPage_bulletIcon__SFCGo","diagramWrapper":"cezPage_diagramWrapper__NHQ_F","top":"cezPage_top__EUH06","bottom":"cezPage_bottom__0_nIG","showHideBtn":"cezPage_showHideBtn__8cx1Y","hidden":"cezPage_hidden__a6GHs","submenu":"cezPage_submenu__QWdbL","sticky":"cezPage_sticky__truuW","iconDiv":"cezPage_iconDiv__nQ7_V","active0":"cezPage_active0__bG0sG","active1":"cezPage_active1__vmESe","active2":"cezPage_active2__NiZvc","active3":"cezPage_active3__7kdD_","active4":"cezPage_active4__md6C_","active5":"cezPage_active5__bBSy0","active6":"cezPage_active6___6kUZ","cezheading":"cezPage_cezheading__2czLQ","mobileView":"cezPage_mobileView__I_al8","diagramWrappermobile":"cezPage_diagramWrappermobile__ZBsM7","verticalLine":"cezPage_verticalLine__eFJby","para":"cezPage_para__Qe80r","bundle":"cezPage_bundle__OIpLw","cezhead":"cezPage_cezhead__GtY8x"};

/***/ }),

/***/ 96182:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"createemptwin_liveStatus__KQ_dZ","rejectedStatus":"createemptwin_rejectedStatus__hDr8G","retiredStatus":"createemptwin_retiredStatus___e6wB","onHoldStatus":"createemptwin_onHoldStatus__K096G","in-ProgressStatus":"createemptwin_in-ProgressStatus__TlndG","inProgressStatus":"createemptwin_inProgressStatus__T2VX8","uATStatus":"createemptwin_uATStatus__vx8A5","initialDemandStatus":"createemptwin_initialDemandStatus__XWy6g","designFeasibilityStatus":"createemptwin_designFeasibilityStatus__Ossj5","feasibilityStatus":"createemptwin_feasibilityStatus__q2n2S","designStatus":"createemptwin_designStatus__q7Ggx","ideasStatus":"createemptwin_ideasStatus__2IQsJ","buildStatus":"createemptwin_buildStatus__Kta8P","ques4":"createemptwin_ques4__RKEVM","inputGroupWrapper":"createemptwin_inputGroupWrapper__xiJrE","mandatoryField":"createemptwin_mandatoryField__4jDzH","formContainer":"createemptwin_formContainer___nOSj","head":"createemptwin_head__AZBNg","text":"createemptwin_text__E7XBB","label":"createemptwin_label__k0ft8","parentForm":"createemptwin_parentForm__JcpiS","inputGroup":"createemptwin_inputGroup__iXTy9","ques1":"createemptwin_ques1__0AcHU","errorMessage":"createemptwin_errorMessage__3cvbJ","documentLinkWrapper":"createemptwin_documentLinkWrapper__V6Ktr","Group_sub":"createemptwin_Group_sub__Zxsql","documentLink":"createemptwin_documentLink__x7U_J","radio":"createemptwin_radio__6SzwZ","radioWrapper":"createemptwin_radioWrapper__BFOwA","subLabel":"createemptwin_subLabel__kdxtr","radioCheckmark":"createemptwin_radioCheckmark__TgakQ","Group":"createemptwin_Group__Kgwv_","inputGroupDropdown":"createemptwin_inputGroupDropdown__egQMf","input":"createemptwin_input__GGhNv","right":"createemptwin_right__CVp9T","more":"createemptwin_more__WPU6W","errorBorder":"createemptwin_errorBorder__XRqKf","fullWidth":"createemptwin_fullWidth__nC3sj","areaGroup":"createemptwin_areaGroup__PlGwY","scrollableTable":"createemptwin_scrollableTable__aapN3","dividedHead":"createemptwin_dividedHead__RVsj1","subHead":"createemptwin_subHead__BcteG","subDivision":"createemptwin_subDivision__83sCx","dividedBody":"createemptwin_dividedBody__aoTgz","editInactive":"createemptwin_editInactive__QR8So","icon":"createemptwin_icon__CttSF","check":"createemptwin_check__hGO_F","list_Checkbox_container":"createemptwin_list_Checkbox_container__dsmSB","lableHead":"createemptwin_lableHead__ujWjf","list_checkmark":"createemptwin_list_checkmark__CciIX","bottomBtns":"createemptwin_bottomBtns__j4Egu","btn":"createemptwin_btn__x1lpY","lablepara":"createemptwin_lablepara__gsUy2","inputtextfiled":"createemptwin_inputtextfiled__Tc9qG","inputtextareafiled":"createemptwin_inputtextareafiled__L7R8u","formGroup":"createemptwin_formGroup__9Oe8U","checkedvalue":"createemptwin_checkedvalue__PflLP","softskillAdd":"createemptwin_softskillAdd__7pAYc","globallist":"createemptwin_globallist__0D_jT","mainLabel":"createemptwin_mainLabel__tgIY0","actionBtn":"createemptwin_actionBtn__2EP0A","uploadControl":"createemptwin_uploadControl__4VT63","maxWidth":"createemptwin_maxWidth__g_kaS","inputtext":"createemptwin_inputtext__NLMt_","submitbtn":"createemptwin_submitbtn__8o_2_","uploadBtnWrapper":"createemptwin_uploadBtnWrapper__XfZ1z","choosefilebtn":"createemptwin_choosefilebtn__ItFmm","checkboxdropdown":"createemptwin_checkboxdropdown__EraKL","selectdropdown":"createemptwin_selectdropdown__uxE8q","calender":"createemptwin_calender__fCTJ5","businessGroupUnit":"createemptwin_businessGroupUnit__mOKya","uploadFileContainer":"createemptwin_uploadFileContainer__ElrUx","multiDocsWrapper":"createemptwin_multiDocsWrapper__5lL2M","skillMultiDocs":"createemptwin_skillMultiDocs__RUGTx"};

/***/ }),

/***/ 79924:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"demand_liveStatus__j8Mvt","rejectedStatus":"demand_rejectedStatus__CgpPN","retiredStatus":"demand_retiredStatus__6jEx5","onHoldStatus":"demand_onHoldStatus__Tl59M","in-ProgressStatus":"demand_in-ProgressStatus__gZHqs","inProgressStatus":"demand_inProgressStatus__bdY76","uATStatus":"demand_uATStatus__6RfF7","initialDemandStatus":"demand_initialDemandStatus__cg08T","designFeasibilityStatus":"demand_designFeasibilityStatus__DCR3b","feasibilityStatus":"demand_feasibilityStatus__2kIGC","designStatus":"demand_designStatus__hp4rz","ideasStatus":"demand_ideasStatus__GN06R","buildStatus":"demand_buildStatus___BQ1Y","demandContainer":"demand_demandContainer__vWYEo","uploadBtnWrapper":"demand_uploadBtnWrapper__mzmm8","uploadFileContainer":"demand_uploadFileContainer__DnPsU","actionBtn":"demand_actionBtn__qU22q","iconUpload":"demand_iconUpload__2bY_k","uploadIcon":"demand_uploadIcon__xX_RI","downloadBtn":"demand_downloadBtn__TRQ5g"};

/***/ }),

/***/ 50637:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"emptwin_liveStatus__qyENE","rejectedStatus":"emptwin_rejectedStatus__gLMDO","retiredStatus":"emptwin_retiredStatus__CW4rt","onHoldStatus":"emptwin_onHoldStatus__P0gQG","in-ProgressStatus":"emptwin_in-ProgressStatus__Z7adU","inProgressStatus":"emptwin_inProgressStatus__f5HEb","uATStatus":"emptwin_uATStatus__5JhkE","initialDemandStatus":"emptwin_initialDemandStatus__61TNs","designFeasibilityStatus":"emptwin_designFeasibilityStatus__V3txq","feasibilityStatus":"emptwin_feasibilityStatus__cV7zw","designStatus":"emptwin_designStatus__e4qWI","ideasStatus":"emptwin_ideasStatus__8PpDH","buildStatus":"emptwin_buildStatus__JLoKF","cezDotList":"emptwin_cezDotList__6BTiS","cezDot":"emptwin_cezDot__3a1bj","containerfluidbg":"emptwin_containerfluidbg__W9nP8","landingContainer":"emptwin_landingContainer__O7mgw","caramain":"emptwin_caramain__QluEo","one":"emptwin_one__5bDVc","carousalimage":"emptwin_carousalimage__ZWsgX","carousalvideo":"emptwin_carousalvideo__2MngV","carouselVideoAlt":"emptwin_carouselVideoAlt__OrXcO","customnextmain":"emptwin_customnextmain__JMmTq","customprevmain":"emptwin_customprevmain__HhwVP","reactMultiCarouselDot":"emptwin_reactMultiCarouselDot__bSvMA","dotActive":"emptwin_dotActive__q4wjc","dotInactive":"emptwin_dotInactive__M3JfL","head":"emptwin_head__H2aHa","text":"emptwin_text__9w_q_","btnOuter":"emptwin_btnOuter__nqty3","btn":"emptwin_btn__0W8II","mainbanner":"emptwin_mainbanner__Lll9T","secondaryBanner":"emptwin_secondaryBanner__DVuLy","videoimage":"emptwin_videoimage__S3o51","videocard":"emptwin_videocard__gQW5N","videobox":"emptwin_videobox__HNfoU","contentInfo":"emptwin_contentInfo__PO9CB","left":"emptwin_left__pb0O8","right":"emptwin_right__Ff_hn","group":"emptwin_group__GGy_J","heading":"emptwin_heading__JLT68","content":"emptwin_content__s_ewy","midbanner":"emptwin_midbanner__2pwz_","homefeature":"emptwin_homefeature__zTsGf","homefeatureMobile":"emptwin_homefeatureMobile__Of9ge","extremeleft":"emptwin_extremeleft__3CHSd","infocard":"emptwin_infocard__V6N0w","detailImg":"emptwin_detailImg__LsQP3","scrabbleicon":"emptwin_scrabbleicon__Rpg1K","desc":"emptwin_desc__1N2pZ","hover":"emptwin_hover__M0hiW","landingStore":"emptwin_landingStore__FvXlJ","parent":"emptwin_parent__yXHIH","child":"emptwin_child__tmNJN","subchild":"emptwin_subchild__9zum9","mobileimg":"emptwin_mobileimg__sHrz1","childdesc":"emptwin_childdesc__k5Sez","desktopimg":"emptwin_desktopimg__WHMml","parentbtn":"emptwin_parentbtn__lBSiB","botstorePage":"emptwin_botstorePage__we7uM","main":"emptwin_main__40600","customnext":"emptwin_customnext__Ejnhl","customprev":"emptwin_customprev__6yHqA","alternateBotsLessThan3":"emptwin_alternateBotsLessThan3__4H2ei","botcard":"emptwin_botcard__BwfGq","cezlanding":"emptwin_cezlanding__J_40W","cezcards":"emptwin_cezcards__JdgyU","card0":"emptwin_card0__PIEhN","maincontent":"emptwin_maincontent__6JYFN","card1":"emptwin_card1__DxVn2","card2":"emptwin_card2__hxtAE","card3":"emptwin_card3__Cb7Su","card4":"emptwin_card4__GwfYW","card5":"emptwin_card5__Uwi9d","card6":"emptwin_card6__Bl7LY","cezbannerimage":"emptwin_cezbannerimage__Mj_bc","bullets":"emptwin_bullets__lMvfT","icons":"emptwin_icons__mz1Fe","mobilecez":"emptwin_mobilecez__HZ8qQ","cezheadmobile":"emptwin_cezheadmobile__Eq6TB","mobileView":"emptwin_mobileView___QSgE","diagramWrappermobile":"emptwin_diagramWrappermobile__UzFOe","verticalLine":"emptwin_verticalLine__IBDA2","para":"emptwin_para__pibEI","bundle":"emptwin_bundle__Ne5Vt","cezhead":"emptwin_cezhead__hkb7C","requestdemo":"emptwin_requestdemo__cTlSZ","reqAdDemobgImg":"emptwin_reqAdDemobgImg__k8YR9","extreme":"emptwin_extreme__YB_Iq","row":"emptwin_row___2A7_","inputGroup":"emptwin_inputGroup__DFZfe","labelstyle":"emptwin_labelstyle__P4f2z","errorMessage":"emptwin_errorMessage__o_xyZ","input":"emptwin_input__bhq_W","more":"emptwin_more___XiMT","errorBorder":"emptwin_errorBorder__GZb9x","fullWidth":"emptwin_fullWidth__1GxUC","headingmain":"emptwin_headingmain__eaqQ_","contentfull":"emptwin_contentfull__UL0Ul","sendIcon":"emptwin_sendIcon__Z1OQV","testiwrapper":"emptwin_testiwrapper__6jjYQ","testimain":"emptwin_testimain__Wsx_E","react-multi-carousel-list":"emptwin_react-multi-carousel-list__VLMTJ","react-multi-carousel-dot-list":"emptwin_react-multi-carousel-dot-list__vlPN7","react-multi-carousel-item":"emptwin_react-multi-carousel-item__VPYL8","testi":"emptwin_testi__i1yp3","wrappi":"emptwin_wrappi__j7p06","info":"emptwin_info__pyf5e","design":"emptwin_design__fSxwv","desighead":"emptwin_desighead__EP7V7","desigcontent":"emptwin_desigcontent__NXtMz","testihead":"emptwin_testihead__r3B09","contactLanding":"emptwin_contactLanding__KkY1C","image":"emptwin_image__fRQ22","guestBot":"emptwin_guestBot__u3WAQ","headspan":"emptwin_headspan__jwl9B","mainbot":"emptwin_mainbot__hP3jj","noresults":"emptwin_noresults__B1XTQ","customnextguest":"emptwin_customnextguest__Of_9s","customprevguest":"emptwin_customprevguest__NwbNy","filterbot":"emptwin_filterbot__BzTBI","headfilter":"emptwin_headfilter__EqFPQ","radiolanding":"emptwin_radiolanding__dLIIS","inputGroupWrapper":"emptwin_inputGroupWrapper__Y4YVd","radioWrapper":"emptwin_radioWrapper__rYMXw","subLabel":"emptwin_subLabel__Ib_fN","radioCheckmark":"emptwin_radioCheckmark__Wndv0","editModalWrapper":"emptwin_editModalWrapper__U5p58","modalBox":"emptwin_modalBox__hrNOg","colFirst":"emptwin_colFirst__Jd8w4","mainLabel":"emptwin_mainLabel__C_CBd","mandatoryField":"emptwin_mandatoryField__Qbmja","dropdown":"emptwin_dropdown__8Unra","filterbtn":"emptwin_filterbtn__3G1Rd","filterbtn1":"emptwin_filterbtn1__y9PZe","emptwinvideotext":"emptwin_emptwinvideotext__Re7Oa","cardWrapper":"emptwin_cardWrapper__SjCLh","cardHead":"emptwin_cardHead__JIgEQ","icon":"emptwin_icon__1oKdM","iconimg":"emptwin_iconimg__kTbIX","iconimg1":"emptwin_iconimg1__JfzPW","iconimg2":"emptwin_iconimg2__KFWIY","code":"emptwin_code__VCx8B","label":"emptwin_label__6_TSy","cardBody":"emptwin_cardBody__MqSaX","title":"emptwin_title__VwCNS","label1":"emptwin_label1__Dg0zD","emplabel":"emptwin_emplabel__gNDXv","cardFoot":"emptwin_cardFoot__4ic3F","actionBtn":"emptwin_actionBtn__DXmTV","listIcon":"emptwin_listIcon__WAFao","empsectionbanner":"emptwin_empsectionbanner__QRGF6","videolist":"emptwin_videolist__ZV4_R","videolistli":"emptwin_videolistli__EbL8A","btndiv":"emptwin_btndiv__lE1MI","addtocartbtn":"emptwin_addtocartbtn__9_Jjj","editbtn":"emptwin_editbtn__yMv5V","counting":"emptwin_counting__yvSr9","yellow":"emptwin_yellow__hMyJ1","purple":"emptwin_purple__fD0Z6","pink":"emptwin_pink__W5b_l","countingpara":"emptwin_countingpara__ZeRzN","submitbtn":"emptwin_submitbtn__ahMxb","managetableContainer":"emptwin_managetableContainer__SlPrh","manageTable":"emptwin_manageTable__7oL11","skillsHeadingImageMobile":"emptwin_skillsHeadingImageMobile__3qTW5","manageSkillHeading":"emptwin_manageSkillHeading__25_eB","skillHeading":"emptwin_skillHeading__8L__W","manage_table":"emptwin_manage_table__3Si45","soft_thead":"emptwin_soft_thead__4hN_X","global_thead":"emptwin_global_thead__Bt3ND","local_thead":"emptwin_local_thead__xizEA","manage_thead":"emptwin_manage_thead__5gc9w","manage_thead_row":"emptwin_manage_thead_row__JTYmh","soft_thead_row":"emptwin_soft_thead_row__YXUR7","global_thead_row":"emptwin_global_thead_row__Aue3U","local_thead_row":"emptwin_local_thead_row__VTZ8Z","manage_tbody":"emptwin_manage_tbody__RaZ_4","manage_tbody_row":"emptwin_manage_tbody_row__72uaU","soft_tbody":"emptwin_soft_tbody__BZbzu","global_tbody":"emptwin_global_tbody__bZXMj","local_tbody":"emptwin_local_tbody__t5mhz","select":"emptwin_select__k0o6m","editdata":"emptwin_editdata__Vs_Ty","uploadBtnWrapper":"emptwin_uploadBtnWrapper__oBZa9","uploadControl":"emptwin_uploadControl__FM4yg","fileupload":"emptwin_fileupload__FZR1o","select1":"emptwin_select1__v6PNa","formGroup":"emptwin_formGroup__Kbw3x"};

/***/ }),

/***/ 3519:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"frameworkPage_liveStatus__3kOiD","rejectedStatus":"frameworkPage_rejectedStatus__1_wEk","retiredStatus":"frameworkPage_retiredStatus__0vE4r","onHoldStatus":"frameworkPage_onHoldStatus__rlg0S","in-ProgressStatus":"frameworkPage_in-ProgressStatus__59vrP","inProgressStatus":"frameworkPage_inProgressStatus__pCNb7","uATStatus":"frameworkPage_uATStatus__LcyEv","initialDemandStatus":"frameworkPage_initialDemandStatus__JXWFZ","designFeasibilityStatus":"frameworkPage_designFeasibilityStatus__ZpjsA","feasibilityStatus":"frameworkPage_feasibilityStatus__wJJmG","designStatus":"frameworkPage_designStatus__o3MzF","ideasStatus":"frameworkPage_ideasStatus__TRqhL","buildStatus":"frameworkPage_buildStatus___s_5z","frameworkContainer":"frameworkPage_frameworkContainer__wzTsN","uploadControl":"frameworkPage_uploadControl__VqhZ2","uploadFileContainer":"frameworkPage_uploadFileContainer__CTe0d","actionBtn":"frameworkPage_actionBtn__F_zW_","uploadIcon":"frameworkPage_uploadIcon__dL_V2"};

/***/ }),

/***/ 64356:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"globalsearch_liveStatus__cBnmS","rejectedStatus":"globalsearch_rejectedStatus__4Htpo","retiredStatus":"globalsearch_retiredStatus__UeMrw","onHoldStatus":"globalsearch_onHoldStatus__PWRSE","in-ProgressStatus":"globalsearch_in-ProgressStatus__UWZ3a","inProgressStatus":"globalsearch_inProgressStatus__LCrnZ","uATStatus":"globalsearch_uATStatus__s_9P0","initialDemandStatus":"globalsearch_initialDemandStatus__q462e","designFeasibilityStatus":"globalsearch_designFeasibilityStatus__H1hRq","feasibilityStatus":"globalsearch_feasibilityStatus__8ZLp6","designStatus":"globalsearch_designStatus__S8OHr","ideasStatus":"globalsearch_ideasStatus__wWztZ","buildStatus":"globalsearch_buildStatus__JsNOH","container":"globalsearch_container__s52Cw","globalContainer":"globalsearch_globalContainer__s2k4k","head":"globalsearch_head__Pel1t","text":"globalsearch_text__AQuqd","data":"globalsearch_data__JBVD9","cezSearch":"globalsearch_cezSearch__Wa8_x","cezhead":"globalsearch_cezhead__yE1qz","datacez":"globalsearch_datacez___aPWB","datahead":"globalsearch_datahead__qUPl8","datadetail":"globalsearch_datadetail__SnnXi","botSearch":"globalsearch_botSearch__DeirF","bothead":"globalsearch_bothead__PtYGe","databot":"globalsearch_databot__0WhK3","cardHead":"globalsearch_cardHead__Fe0H0","icon":"globalsearch_icon__ol_no","code":"globalsearch_code__UCsOg","label":"globalsearch_label__n83KI","frameworkSearch":"globalsearch_frameworkSearch__DjcV4","frameworkhead":"globalsearch_frameworkhead__DrHPv","dataframe":"globalsearch_dataframe__jpEgO","pdfCard":"globalsearch_pdfCard__uhZRl","pdfhead":"globalsearch_pdfhead__BYO9X","mobileDownloadIcon":"globalsearch_mobileDownloadIcon__y6pP6","iconWrap":"globalsearch_iconWrap__oUo7j","check":"globalsearch_check__bxVG8","list_Checkbox_container":"globalsearch_list_Checkbox_container__H7hWI","lableHead":"globalsearch_lableHead__xA9fJ","list_checkmark":"globalsearch_list_checkmark__IqbOV","pdfTitle":"globalsearch_pdfTitle__3NyT3","body":"globalsearch_body__45nXO","downloadOverlay":"globalsearch_downloadOverlay__MxfJF","downloadBtn":"globalsearch_downloadBtn__cyLSA","objWrapper":"globalsearch_objWrapper__SS_03","ContactSearch":"globalsearch_ContactSearch__KqS6C","Contacthead":"globalsearch_Contacthead__mQDM1","datacard":"globalsearch_datacard__zGa8Y","contactCard":"globalsearch_contactCard__MvLMm","userImageWrapper":"globalsearch_userImageWrapper__N6JTO","infoWrapper":"globalsearch_infoWrapper__sKfFk","name":"globalsearch_name__WL6lz","email":"globalsearch_email__aH_Ds","designation":"globalsearch_designation__pHreF","noresults":"globalsearch_noresults__iR1Ex","content":"globalsearch_content__4vLX4"};

/***/ }),

/***/ 96844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"iaOffering_liveStatus__U4_hr","rejectedStatus":"iaOffering_rejectedStatus__f7S_g","retiredStatus":"iaOffering_retiredStatus__JgXL3","onHoldStatus":"iaOffering_onHoldStatus__U0hhN","in-ProgressStatus":"iaOffering_in-ProgressStatus__jVd6w","inProgressStatus":"iaOffering_inProgressStatus__YaEHZ","uATStatus":"iaOffering_uATStatus__PSwuQ","initialDemandStatus":"iaOffering_initialDemandStatus__NOa_k","designFeasibilityStatus":"iaOffering_designFeasibilityStatus__LJH8p","feasibilityStatus":"iaOffering_feasibilityStatus__1GJtZ","designStatus":"iaOffering_designStatus__JRRi_","ideasStatus":"iaOffering_ideasStatus__x5cOd","buildStatus":"iaOffering_buildStatus__6AUuW","container":"iaOffering_container__2yHQD","wrapper":"iaOffering_wrapper__chopA","heading":"iaOffering_heading__DaFyo","description":"iaOffering_description__5mqOy","image":"iaOffering_image__zUwEN","desc":"iaOffering_desc__AfJpo","videoContainer":"iaOffering_videoContainer__5yZCQ","videoWrapper":"iaOffering_videoWrapper__Z9dnS","video":"iaOffering_video__cl_xD","play":"iaOffering_play__UM05l","videoTitle":"iaOffering_videoTitle__heyfC","videoTextWrapper":"iaOffering_videoTextWrapper__41dDi","download":"iaOffering_download__faSiJ","downloadIcon":"iaOffering_downloadIcon__1U_mt","downloadText":"iaOffering_downloadText__0B_y4","articleContainer":"iaOffering_articleContainer__5rl4G","grid":"iaOffering_grid__y_nkb","imageWrapper":"iaOffering_imageWrapper__a2_tN","img":"iaOffering_img__1dz77","textWrapper":"iaOffering_textWrapper__pHTuB","textModal":"iaOffering_textModal__yYast","downloadButton":"iaOffering_downloadButton__1oavs","text":"iaOffering_text__BnvWX","botstorePage":"iaOffering_botstorePage__CJOA8","head":"iaOffering_head__ePZxk","carouselRow":"iaOffering_carouselRow__ydW8h","main":"iaOffering_main__5rae3","customnext":"iaOffering_customnext__cq_lf","customprev":"iaOffering_customprev__hzkHS","botcard":"iaOffering_botcard__nTroM","parentbtn":"iaOffering_parentbtn__NjeJj","btn":"iaOffering_btn__sUQLp","heximages":"iaOffering_heximages__F1C_E","Image":"iaOffering_Image__s6mJC","backarrow":"iaOffering_backarrow__6l4zJ","hexCard":"iaOffering_hexCard__RdDd1","hex":"iaOffering_hex__kfdiw","span":"iaOffering_span__BdxB0","border":"iaOffering_border__NXtie","hexactive":"iaOffering_hexactive__o4PIN","imgWrapper":"iaOffering_imgWrapper__DR1ID","active":"iaOffering_active__UGefI"};

/***/ }),

/***/ 90788:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"logout_liveStatus__3bBjn","rejectedStatus":"logout_rejectedStatus__F9RqL","retiredStatus":"logout_retiredStatus__ZiNdn","onHoldStatus":"logout_onHoldStatus__irAF8","in-ProgressStatus":"logout_in-ProgressStatus__t9b3T","inProgressStatus":"logout_inProgressStatus__Q6Y_O","uATStatus":"logout_uATStatus__0a9ez","initialDemandStatus":"logout_initialDemandStatus__jwi4B","designFeasibilityStatus":"logout_designFeasibilityStatus__lVyzi","feasibilityStatus":"logout_feasibilityStatus__F2hpc","designStatus":"logout_designStatus__ovpRd","ideasStatus":"logout_ideasStatus__HDMkM","buildStatus":"logout_buildStatus__xkfuT","mainlogout":"logout_mainlogout__TiHrM","logoutContainer":"logout_logoutContainer__kFFLl","left":"logout_left__ocMjZ","right":"logout_right__V6XXn","head":"logout_head__u3KLs","text":"logout_text__O5Nws","btn":"logout_btn__vpLg0"};

/***/ }),

/***/ 54801:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"order_liveStatus__yigH9","rejectedStatus":"order_rejectedStatus__s9TFq","retiredStatus":"order_retiredStatus__vh7Rp","onHoldStatus":"order_onHoldStatus__K26RT","in-ProgressStatus":"order_in-ProgressStatus__2MD1n","inProgressStatus":"order_inProgressStatus__GST9V","uATStatus":"order_uATStatus__mCYLO","initialDemandStatus":"order_initialDemandStatus__6VyCt","designFeasibilityStatus":"order_designFeasibilityStatus__HQmwM","feasibilityStatus":"order_feasibilityStatus__D0YtS","designStatus":"order_designStatus__3hvvN","ideasStatus":"order_ideasStatus__ja_s_","buildStatus":"order_buildStatus__azBza","Container":"order_Container__NtqNk","userLoginContainer":"order_userLoginContainer__B_GQy","backimage":"order_backimage__tVK63","loginModal":"order_loginModal__W3_xF","left":"order_left__hA8nd","right":"order_right__Ipjtf","top":"order_top__8xQOy","textWrapper":"order_textWrapper__z8Eaw","head":"order_head__QD__K","head1":"order_head1__Lkk5u","text1":"order_text1__K5am_","content":"order_content__d88ah","logoWrapper":"order_logoWrapper__mIzoH","uniliverLogo":"order_uniliverLogo__6RCH6","automationLogo":"order_automationLogo__C_3in","bottom":"order_bottom__tN6ns","betterbtn":"order_betterbtn__jEkii","lovedbtn":"order_lovedbtn__EDN7M"};

/***/ }),

/***/ 22449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"roiform_liveStatus__upZe9","rejectedStatus":"roiform_rejectedStatus__xZRNA","retiredStatus":"roiform_retiredStatus__Kt5l_","onHoldStatus":"roiform_onHoldStatus__XbEXV","in-ProgressStatus":"roiform_in-ProgressStatus__RD9_z","inProgressStatus":"roiform_inProgressStatus__vGhbA","uATStatus":"roiform_uATStatus__HqIVH","initialDemandStatus":"roiform_initialDemandStatus__r0fKw","designFeasibilityStatus":"roiform_designFeasibilityStatus__yv3lS","feasibilityStatus":"roiform_feasibilityStatus__kyNpW","designStatus":"roiform_designStatus__uj5M_","ideasStatus":"roiform_ideasStatus__Cql_H","buildStatus":"roiform_buildStatus__3R9mF","landingContainer":"roiform_landingContainer__Ckh4o","roiHeader":"roiform_roiHeader__GBODZ","roiFormContainer":"roiform_roiFormContainer__1OiMv","roiBannerHeader":"roiform_roiBannerHeader__E1uJI","bannerColumn":"roiform_bannerColumn__eHBr6","roiFormRow":"roiform_roiFormRow__YXUIf","roiFormImage":"roiform_roiFormImage__Qcf_C","roiFormColumn":"roiform_roiFormColumn__jbJgR","roiHeading":"roiform_roiHeading__NtnOj","roiHeaderText":"roiform_roiHeaderText__CCdXp","firstText":"roiform_firstText__kyoSE","roiBtns":"roiform_roiBtns__kxGa1","projectDetails":"roiform_projectDetails__gCgKs","currentProcess":"roiform_currentProcess__7Ul5l","activeBtn":"roiform_activeBtn__vuYpU","activeBtns":"roiform_activeBtns__XEJgq","btns":"roiform_btns__3PKLq","btnWrapper":"roiform_btnWrapper__GdPRH","actionBtn":"roiform_actionBtn__SPKYF","arrowIcon":"roiform_arrowIcon__itWz1","backArrowIcon":"roiform_backArrowIcon__SxiQj","leftArrow":"roiform_leftArrow__Lza6m","bounce":"roiform_bounce__Bi2bc","rightArrow":"roiform_rightArrow__y0fue","continueBtn":"roiform_continueBtn__kS3UW","FirstBackBtn":"roiform_FirstBackBtn__SiP27","secondBackBtn":"roiform_secondBackBtn__5oi5w","roiCalculationRow":"roiform_roiCalculationRow__g0fm_","roiFormulaContainer":"roiform_roiFormulaContainer__YOFre","topHeading":"roiform_topHeading__RoS4T","heading":"roiform_heading__hKQCL","headingAfter":"roiform_headingAfter__U57NK","roiCalculation":"roiform_roiCalculation__s8w4E","calculationWrapper":"roiform_calculationWrapper__KZEE2","allCalculation":"roiform_allCalculation__aLm17","formGroup":"roiform_formGroup__GJjfe","selectGroup":"roiform_selectGroup__iBtWC","RoiBreakdown":"roiform_RoiBreakdown__ZW9eI","yearlyTotal":"roiform_yearlyTotal__8UVdh","result":"roiform_result__SeB4f","forOne":"roiform_forOne__8WBZH","forThree":"roiform_forThree__UDsDg","topText":"roiform_topText__2__q3","bottomText":"roiform_bottomText__QPWQb","totalMonthBreak":"roiform_totalMonthBreak__bCTrP","calculation":"roiform_calculation__JoekU","upperText":"roiform_upperText__QvrrY","dividerText":"roiform_dividerText__R3Lti","multiplication":"roiform_multiplication__8XGE3","RoiWrapper":"roiform_RoiWrapper__eYdX3","information":"roiform_information__G0Qqo","overlayModalContainer":"roiform_overlayModalContainer__m7Xp2","overlayModal":"roiform_overlayModal__xIzMZ","modalOpen":"roiform_modalOpen__ExaD8","popup":"roiform_popup___DQqe","slide-bottom":"roiform_slide-bottom__sKCEQ","close":"roiform_close__yM9CV","tooltip":"roiform_tooltip__DU9vh","tooltipText":"roiform_tooltipText___z9dJ","resourceRoiWrapper":"roiform_resourceRoiWrapper__z4v6_","actionBtnWrapper":"roiform_actionBtnWrapper__ixQVJ","backBtn":"roiform_backBtn__aAfx3","extractDataBtn":"roiform_extractDataBtn__q4c9o","submitBtn":"roiform_submitBtn__cvl6X","resRoiRowWrapper":"roiform_resRoiRowWrapper__OcS7I","roiRowWrapper":"roiform_roiRowWrapper__XxmQG","tabContainer":"roiform_tabContainer___k3_J","roiTabRow":"roiform_roiTabRow__eYIsy","roiBothTabs":"roiform_roiBothTabs__XFN2O","btnTab":"roiform_btnTab__kgvuC","projectDetailsField":"roiform_projectDetailsField__v_V9H","projectClusterRow":"roiform_projectClusterRow__dSk7i","projectClusterLeft":"roiform_projectClusterLeft__xd1vL","projectClusterRight":"roiform_projectClusterRight__Ni6J6","projectFiledColumn":"roiform_projectFiledColumn__nXPMS","selectedOption":"roiform_selectedOption__Rx0nT","leftSelect":"roiform_leftSelect__KPxOY","leftSelectBlur":"roiform_leftSelectBlur__Fu0Dv","right":"roiform_right__ZJ3DG","optionsContainer":"roiform_optionsContainer__mU69H","option":"roiform_option__UB1VX","errorMessage":"roiform_errorMessage__ThuSn","dropDownFields":"roiform_dropDownFields__gurOf","inputContainer":"roiform_inputContainer__J_F5l","inputtext":"roiform_inputtext__4BvjE","inputLabel":"roiform_inputLabel__LnvIe","inputField":"roiform_inputField__L8Ln5","inputLabelChange":"roiform_inputLabelChange__2hUEb","formLabel":"roiform_formLabel__p3bCc","mainLabel":"roiform_mainLabel__MVS6H","mandatoryField":"roiform_mandatoryField__Y28RF","emptyField":"roiform_emptyField__fG7jW","currentProcessFields":"roiform_currentProcessFields__i_7nP","currentProcessField2":"roiform_currentProcessField2__YyEV7","projectDetailsColumn":"roiform_projectDetailsColumn__HLA6j","editModalContainer":"roiform_editModalContainer__CB1Wz"};

/***/ }),

/***/ 70355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"liveStatus":"userMapping_liveStatus__KH8sX","rejectedStatus":"userMapping_rejectedStatus__f_doV","retiredStatus":"userMapping_retiredStatus__g9kr7","onHoldStatus":"userMapping_onHoldStatus__zqEhO","in-ProgressStatus":"userMapping_in-ProgressStatus__z9GCX","inProgressStatus":"userMapping_inProgressStatus__x_e9n","uATStatus":"userMapping_uATStatus__BCBin","initialDemandStatus":"userMapping_initialDemandStatus__9wQhE","designFeasibilityStatus":"userMapping_designFeasibilityStatus__EYpzD","feasibilityStatus":"userMapping_feasibilityStatus__SvFUo","designStatus":"userMapping_designStatus__IHLpF","ideasStatus":"userMapping_ideasStatus__xvk3v","buildStatus":"userMapping_buildStatus__A6zqU","containerUser":"userMapping_containerUser__w3gYW","left":"userMapping_left__Oa_zr","userModal":"userMapping_userModal__Gys0t","colFirst":"userMapping_colFirst__a1bcn","userTypeerrorMessage":"userMapping_userTypeerrorMessage__F9Gzg","errorMessage":"userMapping_errorMessage__gltP6","formGroup":"userMapping_formGroup__GdV__","mainLabel":"userMapping_mainLabel__yQh_n","mandatoryField":"userMapping_mandatoryField__kk44v","inputGroupWrapper":"userMapping_inputGroupWrapper__Agrat","radioWrapper":"userMapping_radioWrapper__6Wfak","subLabel":"userMapping_subLabel__8kwcl","radioCheckmark":"userMapping_radioCheckmark__LAPTT","input":"userMapping_input__80X57","right":"userMapping_right__BqRUY","more":"userMapping_more__DyTPC","errorBorder":"userMapping_errorBorder__DYb_O","btn":"userMapping_btn__2Rqrv","head":"userMapping_head__lakSM","dropdownsearch":"userMapping_dropdownsearch__VAH8D","search":"userMapping_search__O4z3C","mobileBtn":"userMapping_mobileBtn__x0WNI","searchIcon":"userMapping_searchIcon__fDA13","listWrapper":"userMapping_listWrapper__jXLNY","inputGroup":"userMapping_inputGroup__BGFv8","first-of-type":"userMapping_first-of-type__UGgaG","dropdown":"userMapping_dropdown__5lPnn","scrollableTable":"userMapping_scrollableTable__BECsh","noresults":"userMapping_noresults__VumwJ","content":"userMapping_content__4R6ND","dividedHead":"userMapping_dividedHead__G9ojL","subHead":"userMapping_subHead__xfL7d","subDivision":"userMapping_subDivision__fnt_R","dividedBody":"userMapping_dividedBody__VvZbx","editInactive":"userMapping_editInactive__bFRt7","icon":"userMapping_icon__YSwL_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1057,2013,5445,9866,4617,1228,8487,5937,3662,6556,4885,8869,5443,7847,2655,9726,7851,6634,8764,4973,998,7747,5136,8553,6490,591,9497,1019,7455,9510,9774,2888,179], function() { return __webpack_exec__(63781); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);